/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(91);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file utils.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

/**
 * Utils
 *
 * @module utils
 */

/**
 * Utility functions
 *
 * @class [utils] utils
 * @constructor
 */


var BigNumber = __webpack_require__(26);
var sha3 = __webpack_require__(27);
var utf8 = __webpack_require__(218);

var unitMap = {
    'noether':      '0',
    'wei':          '1',
    'kwei':         '1000',
    'Kwei':         '1000',
    'babbage':      '1000',
    'femtoether':   '1000',
    'mwei':         '1000000',
    'Mwei':         '1000000',
    'lovelace':     '1000000',
    'picoether':    '1000000',
    'gwei':         '1000000000',
    'Gwei':         '1000000000',
    'shannon':      '1000000000',
    'nanoether':    '1000000000',
    'nano':         '1000000000',
    'szabo':        '1000000000000',
    'microether':   '1000000000000',
    'micro':        '1000000000000',
    'finney':       '1000000000000000',
    'milliether':   '1000000000000000',
    'milli':        '1000000000000000',
    'ether':        '1000000000000000000',
    'kether':       '1000000000000000000000',
    'grand':        '1000000000000000000000',
    'mether':       '1000000000000000000000000',
    'gether':       '1000000000000000000000000000',
    'tether':       '1000000000000000000000000000000'
};

/**
 * Should be called to pad string to expected length
 *
 * @method padLeft
 * @param {String} string to be padded
 * @param {Number} characters that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */
var padLeft = function (string, chars, sign) {
    return new Array(chars - string.length + 1).join(sign ? sign : "0") + string;
};

/**
 * Should be called to pad string to expected length
 *
 * @method padRight
 * @param {String} string to be padded
 * @param {Number} characters that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */
var padRight = function (string, chars, sign) {
    return string + (new Array(chars - string.length + 1).join(sign ? sign : "0"));
};

/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method toUtf8
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */
var toUtf8 = function(hex) {
// Find termination
    var str = "";
    var i = 0, l = hex.length;
    if (hex.substring(0, 2) === '0x') {
        i = 2;
    }
    for (; i < l; i+=2) {
        var code = parseInt(hex.substr(i, 2), 16);
        if (code === 0)
            break;
        str += String.fromCharCode(code);
    }

    return utf8.decode(str);
};

/**
 * Should be called to get ascii from it's hex representation
 *
 * @method toAscii
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */
var toAscii = function(hex) {
// Find termination
    var str = "";
    var i = 0, l = hex.length;
    if (hex.substring(0, 2) === '0x') {
        i = 2;
    }
    for (; i < l; i+=2) {
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }

    return str;
};

/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method fromUtf8
 * @param {String} string
 * @param {Boolean} allowZero to convert code point zero to 00 instead of end of string
 * @returns {String} hex representation of input string
 */
var fromUtf8 = function(str, allowZero) {
    str = utf8.encode(str);
    var hex = "";
    for(var i = 0; i < str.length; i++) {
        var code = str.charCodeAt(i);
        if (code === 0) {
            if (allowZero) {
                hex += '00';
            } else {
                break;
            }
        } else {
            var n = code.toString(16);
            hex += n.length < 2 ? '0' + n : n;
        }
    }

    return "0x" + hex;
};

/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method fromAscii
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */
var fromAscii = function(str) {
    var hex = "";
    for(var i = 0; i < str.length; i++) {
        var code = str.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? '0' + n : n;
    }

    return "0x" + hex;
};

/**
 * Should be used to create full function/event name from json abi
 *
 * @method transformToFullName
 * @param {Object} json-abi
 * @return {String} full fnction/event name
 */
var transformToFullName = function (json) {
    if (json.name.indexOf('(') !== -1) {
        return json.name;
    }

    var typeName = json.inputs.map(function(i){return i.type; }).join();
    return json.name + '(' + typeName + ')';
};

/**
 * Should be called to get display name of contract function
 *
 * @method extractDisplayName
 * @param {String} name of function/event
 * @returns {String} display name for function/event eg. multiply(uint256) -> multiply
 */
var extractDisplayName = function (name) {
    var stBracket = name.indexOf('(');
    var endBracket = name.indexOf(')');
    return (stBracket !== -1 && endBracket !== -1) ? name.substr(0, stBracket) : name;
};

/**
 * Should be called to get type name of contract function
 *
 * @method extractTypeName
 * @param {String} name of function/event
 * @returns {String} type name for function/event eg. multiply(uint256) -> uint256
 */
var extractTypeName = function (name) {
    var stBracket = name.indexOf('(');
    var endBracket = name.indexOf(')');
    return (stBracket !== -1 && endBracket !== -1) ? name.substr(stBracket + 1, endBracket - stBracket - 1).replace(' ', '') : "";
};

/**
 * Converts value to it's decimal representation in string
 *
 * @method toDecimal
 * @param {String|Number|BigNumber}
 * @return {String}
 */
var toDecimal = function (value) {
    return toBigNumber(value).toNumber();
};

/**
 * Converts value to it's hex representation
 *
 * @method fromDecimal
 * @param {String|Number|BigNumber}
 * @return {String}
 */
var fromDecimal = function (value) {
    var number = toBigNumber(value);
    var result = number.toString(16);

    return number.lessThan(0) ? '-0x' + result.substr(1) : '0x' + result;
};

/**
 * Auto converts any given value into it's hex representation.
 *
 * And even stringifys objects before.
 *
 * @method toHex
 * @param {String|Number|BigNumber|Object}
 * @return {String}
 */
var toHex = function (val) {
    /*jshint maxcomplexity: 8 */

    if (isBoolean(val))
        return fromDecimal(+val);

    if (isBigNumber(val))
        return fromDecimal(val);

    if (typeof val === 'object')
        return fromUtf8(JSON.stringify(val));

    // if its a negative number, pass it through fromDecimal
    if (isString(val)) {
        if (val.indexOf('-0x') === 0)
            return fromDecimal(val);
        else if(val.indexOf('0x') === 0)
            return val;
        else if (!isFinite(val))
            return fromUtf8(val,1);
    }

    return fromDecimal(val);
};

/**
 * Returns value of unit in Wei
 *
 * @method getValueOfUnit
 * @param {String} unit the unit to convert to, default ether
 * @returns {BigNumber} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */
var getValueOfUnit = function (unit) {
    unit = unit ? unit.toLowerCase() : 'ether';
    var unitValue = unitMap[unit];
    if (unitValue === undefined) {
        throw new Error('This unit doesn\'t exists, please use the one of the following units' + JSON.stringify(unitMap, null, 2));
    }
    return new BigNumber(unitValue, 10);
};

/**
 * Takes a number of wei and converts it to any other ether unit.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method fromWei
 * @param {Number|String} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert to, default ether
 * @return {String|Object} When given a BigNumber object it returns one as well, otherwise a number
*/
var fromWei = function(number, unit) {
    var returnValue = toBigNumber(number).dividedBy(getValueOfUnit(unit));

    return isBigNumber(number) ? returnValue : returnValue.toString(10);
};

/**
 * Takes a number of a unit and converts it to wei.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method toWei
 * @param {Number|String|BigNumber} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert from, default ether
 * @return {String|Object} When given a BigNumber object it returns one as well, otherwise a number
*/
var toWei = function(number, unit) {
    var returnValue = toBigNumber(number).times(getValueOfUnit(unit));

    return isBigNumber(number) ? returnValue : returnValue.toString(10);
};

/**
 * Takes an input and transforms it into an bignumber
 *
 * @method toBigNumber
 * @param {Number|String|BigNumber} a number, string, HEX string or BigNumber
 * @return {BigNumber} BigNumber
*/
var toBigNumber = function(number) {
    /*jshint maxcomplexity:5 */
    number = number || 0;
    if (isBigNumber(number))
        return number;

    if (isString(number) && (number.indexOf('0x') === 0 || number.indexOf('-0x') === 0)) {
        return new BigNumber(number.replace('0x',''), 16);
    }

    return new BigNumber(number.toString(10), 10);
};

/**
 * Takes and input transforms it into bignumber and if it is negative value, into two's complement
 *
 * @method toTwosComplement
 * @param {Number|String|BigNumber}
 * @return {BigNumber}
 */
var toTwosComplement = function (number) {
    var bigNumber = toBigNumber(number).round();
    if (bigNumber.lessThan(0)) {
        return new BigNumber("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16).plus(bigNumber).plus(1);
    }
    return bigNumber;
};

/**
 * Checks if the given string is strictly an address
 *
 * @method isStrictAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
var isStrictAddress = function (address) {
    return /^0x[0-9a-f]{40}$/i.test(address);
};

/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
var isAddress = function (address) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        // check if it has the basic requirements of an address
        return false;
    } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
        // If it's all small caps or all all caps, return true
        return true;
    } else {
        // Otherwise check each case
        return isChecksumAddress(address);
    }
};

/**
 * Checks if the given string is a checksummed address
 *
 * @method isChecksumAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
var isChecksumAddress = function (address) {
    // Check each case
    address = address.replace('0x','');
    var addressHash = sha3(address.toLowerCase());

    for (var i = 0; i < 40; i++ ) {
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
            return false;
        }
    }
    return true;
};



/**
 * Makes a checksum address
 *
 * @method toChecksumAddress
 * @param {String} address the given HEX adress
 * @return {String}
*/
var toChecksumAddress = function (address) {
    if (typeof address === 'undefined') return '';

    address = address.toLowerCase().replace('0x','');
    var addressHash = sha3(address);
    var checksumAddress = '0x';

    for (var i = 0; i < address.length; i++ ) {
        // If ith character is 9 to f then make it uppercase
        if (parseInt(addressHash[i], 16) > 7) {
          checksumAddress += address[i].toUpperCase();
        } else {
            checksumAddress += address[i];
        }
    }
    return checksumAddress;
};

/**
 * Transforms given string to valid 20 bytes-length addres with 0x prefix
 *
 * @method toAddress
 * @param {String} address
 * @return {String} formatted address
 */
var toAddress = function (address) {
    if (isStrictAddress(address)) {
        return address;
    }

    if (/^[0-9a-f]{40}$/.test(address)) {
        return '0x' + address;
    }

    return '0x' + padLeft(toHex(address).substr(2), 40);
};

/**
 * Returns true if object is BigNumber, otherwise false
 *
 * @method isBigNumber
 * @param {Object}
 * @return {Boolean}
 */
var isBigNumber = function (object) {
    return object instanceof BigNumber ||
        (object && object.constructor && object.constructor.name === 'BigNumber');
};

/**
 * Returns true if object is string, otherwise false
 *
 * @method isString
 * @param {Object}
 * @return {Boolean}
 */
var isString = function (object) {
    return typeof object === 'string' ||
        (object && object.constructor && object.constructor.name === 'String');
};

/**
 * Returns true if object is function, otherwise false
 *
 * @method isFunction
 * @param {Object}
 * @return {Boolean}
 */
var isFunction = function (object) {
    return typeof object === 'function';
};

/**
 * Returns true if object is Objet, otherwise false
 *
 * @method isObject
 * @param {Object}
 * @return {Boolean}
 */
var isObject = function (object) {
    return object !== null && !(Array.isArray(object)) && typeof object === 'object';
};

/**
 * Returns true if object is boolean, otherwise false
 *
 * @method isBoolean
 * @param {Object}
 * @return {Boolean}
 */
var isBoolean = function (object) {
    return typeof object === 'boolean';
};

/**
 * Returns true if object is array, otherwise false
 *
 * @method isArray
 * @param {Object}
 * @return {Boolean}
 */
var isArray = function (object) {
    return Array.isArray(object);
};

/**
 * Returns true if given string is valid json object
 *
 * @method isJson
 * @param {String}
 * @return {Boolean}
 */
var isJson = function (str) {
    try {
        return !!JSON.parse(str);
    } catch (e) {
        return false;
    }
};

/**
 * Returns true if given string is a valid Ethereum block header bloom.
 *
 * @method isBloom
 * @param {String} hex encoded bloom filter
 * @return {Boolean}
 */
var isBloom = function (bloom) {
    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) {
        return false;
    } else if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) {
        return true;
    }
    return false;
};

/**
 * Returns true if given string is a valid log topic.
 *
 * @method isTopic
 * @param {String} hex encoded topic
 * @return {Boolean}
 */
var isTopic = function (topic) {
    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) {
        return false;
    } else if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) {
        return true;
    }
    return false;
};

module.exports = {
    padLeft: padLeft,
    padRight: padRight,
    toHex: toHex,
    toDecimal: toDecimal,
    fromDecimal: fromDecimal,
    toUtf8: toUtf8,
    toAscii: toAscii,
    fromUtf8: fromUtf8,
    fromAscii: fromAscii,
    transformToFullName: transformToFullName,
    extractDisplayName: extractDisplayName,
    extractTypeName: extractTypeName,
    toWei: toWei,
    fromWei: fromWei,
    toBigNumber: toBigNumber,
    toTwosComplement: toTwosComplement,
    toAddress: toAddress,
    isBigNumber: isBigNumber,
    isStrictAddress: isStrictAddress,
    isAddress: isAddress,
    isChecksumAddress: isChecksumAddress,
    toChecksumAddress: toChecksumAddress,
    isFunction: isFunction,
    isString: isString,
    isObject: isObject,
    isBoolean: isBoolean,
    isArray: isArray,
    isJson: isJson,
    isBloom: isBloom,
    isTopic: isTopic,
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(17));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(97)();
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _react = __webpack_require__(0);

var _loadScript = _interopRequireDefault(__webpack_require__(123));

var _deepmerge = _interopRequireDefault(__webpack_require__(124));

var _props = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge["default"])(defaultProps.config, props.config);

  var _iterator = _createForOfIteratorHelper(_props.DEPRECATED_CONFIG_PROPS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge["default"])(config, _defineProperty({}, key, props[p]));

        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = "ReactPlayer: %c".concat(p, " %cis deprecated, please use the config prop instead \u2013 ").concat(link);
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isObject(val) {
  return val !== null && _typeof(val) === 'object';
} // Deep comparison of two objects, but ignoring functions
// and React elements, for use in shouldComponentUpdate


function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }

  if ((0, _react.isValidElement)(a) && (0, _react.isValidElement)(b)) {
    return true;
  }

  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }

    return true;
  }

  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (var _i3 = 0, _Object$keys = Object.keys(a); _i3 < _Object$keys.length; _i3++) {
      var key = _Object$keys[_i3];

      if (!isEqual(a[key], b[key])) {
        return false;
      }
    }

    return true;
  }

  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file formatters.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var BigNumber = __webpack_require__(26);
var utils = __webpack_require__(2);
var c = __webpack_require__(32);
var SolidityParam = __webpack_require__(81);


/**
 * Formats input value to byte representation of int
 * If value is negative, return it's two's complement
 * If the value is floating point, round it down
 *
 * @method formatInputInt
 * @param {String|Number|BigNumber} value that needs to be formatted
 * @returns {SolidityParam}
 */
var formatInputInt = function (value) {
    BigNumber.config(c.ETH_BIGNUMBER_ROUNDING_MODE);
    var result = utils.padLeft(utils.toTwosComplement(value).toString(16), 64);
    return new SolidityParam(result);
};

/**
 * Formats input bytes
 *
 * @method formatInputBytes
 * @param {String}
 * @returns {SolidityParam}
 */
var formatInputBytes = function (value) {
    var result = utils.toHex(value).substr(2);
    var l = Math.floor((result.length + 63) / 64);
    result = utils.padRight(result, l * 64);
    return new SolidityParam(result);
};

/**
 * Formats input bytes
 *
 * @method formatDynamicInputBytes
 * @param {String}
 * @returns {SolidityParam}
 */
var formatInputDynamicBytes = function (value) {
    var result = utils.toHex(value).substr(2);
    var length = result.length / 2;
    var l = Math.floor((result.length + 63) / 64);
    result = utils.padRight(result, l * 64);
    return new SolidityParam(formatInputInt(length).value + result);
};

/**
 * Formats input value to byte representation of string
 *
 * @method formatInputString
 * @param {String}
 * @returns {SolidityParam}
 */
var formatInputString = function (value) {
    var result = utils.fromUtf8(value).substr(2);
    var length = result.length / 2;
    var l = Math.floor((result.length + 63) / 64);
    result = utils.padRight(result, l * 64);
    return new SolidityParam(formatInputInt(length).value + result);
};

/**
 * Formats input value to byte representation of bool
 *
 * @method formatInputBool
 * @param {Boolean}
 * @returns {SolidityParam}
 */
var formatInputBool = function (value) {
    var result = '000000000000000000000000000000000000000000000000000000000000000' + (value ?  '1' : '0');
    return new SolidityParam(result);
};

/**
 * Formats input value to byte representation of real
 * Values are multiplied by 2^m and encoded as integers
 *
 * @method formatInputReal
 * @param {String|Number|BigNumber}
 * @returns {SolidityParam}
 */
var formatInputReal = function (value) {
    return formatInputInt(new BigNumber(value).times(new BigNumber(2).pow(128)));
};

/**
 * Check if input value is negative
 *
 * @method signedIsNegative
 * @param {String} value is hex format
 * @returns {Boolean} true if it is negative, otherwise false
 */
var signedIsNegative = function (value) {
    return (new BigNumber(value.substr(0, 1), 16).toString(2).substr(0, 1)) === '1';
};

/**
 * Formats right-aligned output bytes to int
 *
 * @method formatOutputInt
 * @param {SolidityParam} param
 * @returns {BigNumber} right-aligned output bytes formatted to big number
 */
var formatOutputInt = function (param) {
    var value = param.staticPart() || "0";

    // check if it's negative number
    // it it is, return two's complement
    if (signedIsNegative(value)) {
        return new BigNumber(value, 16).minus(new BigNumber('ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff', 16)).minus(1);
    }
    return new BigNumber(value, 16);
};

/**
 * Formats right-aligned output bytes to uint
 *
 * @method formatOutputUInt
 * @param {SolidityParam}
 * @returns {BigNumeber} right-aligned output bytes formatted to uint
 */
var formatOutputUInt = function (param) {
    var value = param.staticPart() || "0";
    return new BigNumber(value, 16);
};

/**
 * Formats right-aligned output bytes to real
 *
 * @method formatOutputReal
 * @param {SolidityParam}
 * @returns {BigNumber} input bytes formatted to real
 */
var formatOutputReal = function (param) {
    return formatOutputInt(param).dividedBy(new BigNumber(2).pow(128));
};

/**
 * Formats right-aligned output bytes to ureal
 *
 * @method formatOutputUReal
 * @param {SolidityParam}
 * @returns {BigNumber} input bytes formatted to ureal
 */
var formatOutputUReal = function (param) {
    return formatOutputUInt(param).dividedBy(new BigNumber(2).pow(128));
};

/**
 * Should be used to format output bool
 *
 * @method formatOutputBool
 * @param {SolidityParam}
 * @returns {Boolean} right-aligned input bytes formatted to bool
 */
var formatOutputBool = function (param) {
    return param.staticPart() === '0000000000000000000000000000000000000000000000000000000000000001' ? true : false;
};

/**
 * Should be used to format output bytes
 *
 * @method formatOutputBytes
 * @param {SolidityParam} left-aligned hex representation of string
 * @param {String} name type name
 * @returns {String} hex string
 */
var formatOutputBytes = function (param, name) {
    var matches = name.match(/^bytes([0-9]*)/);
    var size = parseInt(matches[1]);
    return '0x' + param.staticPart().slice(0, 2 * size);
};

/**
 * Should be used to format output bytes
 *
 * @method formatOutputDynamicBytes
 * @param {SolidityParam} left-aligned hex representation of string
 * @returns {String} hex string
 */
var formatOutputDynamicBytes = function (param) {
    var length = (new BigNumber(param.dynamicPart().slice(0, 64), 16)).toNumber() * 2;
    return '0x' + param.dynamicPart().substr(64, length);
};

/**
 * Should be used to format output string
 *
 * @method formatOutputString
 * @param {SolidityParam} left-aligned hex representation of string
 * @returns {String} ascii string
 */
var formatOutputString = function (param) {
    var length = (new BigNumber(param.dynamicPart().slice(0, 64), 16)).toNumber() * 2;
    return utils.toUtf8(param.dynamicPart().substr(64, length));
};

/**
 * Should be used to format output address
 *
 * @method formatOutputAddress
 * @param {SolidityParam} right-aligned input bytes
 * @returns {String} address
 */
var formatOutputAddress = function (param) {
    var value = param.staticPart();
    return "0x" + value.slice(value.length - 40, value.length);
};

module.exports = {
    formatInputInt: formatInputInt,
    formatInputBytes: formatInputBytes,
    formatInputDynamicBytes: formatInputDynamicBytes,
    formatInputString: formatInputString,
    formatInputBool: formatInputBool,
    formatInputReal: formatInputReal,
    formatOutputInt: formatOutputInt,
    formatOutputUInt: formatOutputUInt,
    formatOutputReal: formatOutputReal,
    formatOutputUReal: formatOutputUReal,
    formatOutputBool: formatOutputBool,
    formatOutputBytes: formatOutputBytes,
    formatOutputDynamicBytes: formatOutputDynamicBytes,
    formatOutputString: formatOutputString,
    formatOutputAddress: formatOutputAddress
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSinglePlayer;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(29);

var _utils = __webpack_require__(5);

var _Player = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SinglePlayer, _Component);

    var _super = _createSuper(SinglePlayer);

    function SinglePlayer() {
      var _this;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
        _this.player = player;
      });

      return _this;
    }

    _createClass(SinglePlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$config$file = this.config.file,
            forceVideo = _this$config$file.forceVideo,
            forceAudio = _this$config$file.forceAudio,
            forceHLS = _this$config$file.forceHLS,
            forceDASH = _this$config$file.forceDASH;
        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;

        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }

        var _this$props = this.props,
            style = _this$props.style,
            width = _this$props.width,
            height = _this$props.height,
            Wrapper = _this$props.wrapper;
        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          style: _objectSpread({}, style, {
            width: width,
            height: height
          })
        }, otherProps), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, this.props, {
          ref: this.ref,
          activePlayer: activePlayer,
          config: this.config
        })));
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _defineProperty(_class, "displayName", "".concat(activePlayer.displayName, "Player")), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "canPlay", activePlayer.canPlay), _temp;
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityParam = __webpack_require__(81);

/**
 * SolidityType prototype is used to encode/decode solidity params of certain type
 */
var SolidityType = function (config) {
    this._inputFormatter = config.inputFormatter;
    this._outputFormatter = config.outputFormatter;
};

/**
 * Should be used to determine if this SolidityType do match given name
 *
 * @method isType
 * @param {String} name
 * @return {Bool} true if type match this SolidityType, otherwise false
 */
SolidityType.prototype.isType = function (name) {
    throw "this method should be overrwritten for type " + name;
};

/**
 * Should be used to determine what is the length of static part in given type
 *
 * @method staticPartLength
 * @param {String} name
 * @return {Number} length of static part in bytes
 */
SolidityType.prototype.staticPartLength = function (name) {
    // If name isn't an array then treat it like a single element array.
    return (this.nestedTypes(name) || ['[1]'])
        .map(function (type) {
            // the length of the nested array
            return parseInt(type.slice(1, -1), 10) || 1;
        })
        .reduce(function (previous, current) {
            return previous * current;
        // all basic types are 32 bytes long
        }, 32);
};

/**
 * Should be used to determine if type is dynamic array
 * eg:
 * "type[]" => true
 * "type[4]" => false
 *
 * @method isDynamicArray
 * @param {String} name
 * @return {Bool} true if the type is dynamic array
 */
SolidityType.prototype.isDynamicArray = function (name) {
    var nestedTypes = this.nestedTypes(name);
    return !!nestedTypes && !nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g);
};

/**
 * Should be used to determine if type is static array
 * eg:
 * "type[]" => false
 * "type[4]" => true
 *
 * @method isStaticArray
 * @param {String} name
 * @return {Bool} true if the type is static array
 */
SolidityType.prototype.isStaticArray = function (name) {
    var nestedTypes = this.nestedTypes(name);
    return !!nestedTypes && !!nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g);
};

/**
 * Should return length of static array
 * eg.
 * "int[32]" => 32
 * "int256[14]" => 14
 * "int[2][3]" => 3
 * "int" => 1
 * "int[1]" => 1
 * "int[]" => 1
 *
 * @method staticArrayLength
 * @param {String} name
 * @return {Number} static array length
 */
SolidityType.prototype.staticArrayLength = function (name) {
    var nestedTypes = this.nestedTypes(name);
    if (nestedTypes) {
       return parseInt(nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g) || 1);
    }
    return 1;
};

/**
 * Should return nested type
 * eg.
 * "int[32]" => "int"
 * "int256[14]" => "int256"
 * "int[2][3]" => "int[2]"
 * "int" => "int"
 * "int[]" => "int"
 *
 * @method nestedName
 * @param {String} name
 * @return {String} nested name
 */
SolidityType.prototype.nestedName = function (name) {
    // remove last [] in name
    var nestedTypes = this.nestedTypes(name);
    if (!nestedTypes) {
        return name;
    }

    return name.substr(0, name.length - nestedTypes[nestedTypes.length - 1].length);
};

/**
 * Should return true if type has dynamic size by default
 * such types are "string", "bytes"
 *
 * @method isDynamicType
 * @param {String} name
 * @return {Bool} true if is dynamic, otherwise false
 */
SolidityType.prototype.isDynamicType = function () {
    return false;
};

/**
 * Should return array of nested types
 * eg.
 * "int[2][3][]" => ["[2]", "[3]", "[]"]
 * "int[] => ["[]"]
 * "int" => null
 *
 * @method nestedTypes
 * @param {String} name
 * @return {Array} array of nested types
 */
SolidityType.prototype.nestedTypes = function (name) {
    // return list of strings eg. "[]", "[3]", "[]", "[2]"
    return name.match(/(\[[0-9]*\])/g);
};

/**
 * Should be used to encode the value
 *
 * @method encode
 * @param {Object} value
 * @param {String} name
 * @return {String} encoded value
 */
SolidityType.prototype.encode = function (value, name) {
    var self = this;
    if (this.isDynamicArray(name)) {

        return (function () {
            var length = value.length;                          // in int
            var nestedName = self.nestedName(name);

            var result = [];
            result.push(f.formatInputInt(length).encode());

            value.forEach(function (v) {
                result.push(self.encode(v, nestedName));
            });

            return result;
        })();

    } else if (this.isStaticArray(name)) {

        return (function () {
            var length = self.staticArrayLength(name);          // in int
            var nestedName = self.nestedName(name);

            var result = [];
            for (var i = 0; i < length; i++) {
                result.push(self.encode(value[i], nestedName));
            }

            return result;
        })();

    }

    return this._inputFormatter(value, name).encode();
};

/**
 * Should be used to decode value from bytes
 *
 * @method decode
 * @param {String} bytes
 * @param {Number} offset in bytes
 * @param {String} name type name
 * @returns {Object} decoded value
 */
SolidityType.prototype.decode = function (bytes, offset, name) {
    var self = this;

    if (this.isDynamicArray(name)) {

        return (function () {
            var arrayOffset = parseInt('0x' + bytes.substr(offset * 2, 64)); // in bytes
            var length = parseInt('0x' + bytes.substr(arrayOffset * 2, 64)); // in int
            var arrayStart = arrayOffset + 32; // array starts after length; // in bytes

            var nestedName = self.nestedName(name);
            var nestedStaticPartLength = self.staticPartLength(nestedName);  // in bytes
            var roundedNestedStaticPartLength = Math.floor((nestedStaticPartLength + 31) / 32) * 32;
            var result = [];

            for (var i = 0; i < length * roundedNestedStaticPartLength; i += roundedNestedStaticPartLength) {
                result.push(self.decode(bytes, arrayStart + i, nestedName));
            }

            return result;
        })();

    } else if (this.isStaticArray(name)) {

        return (function () {
            var length = self.staticArrayLength(name);                      // in int
            var arrayStart = offset;                                        // in bytes

            var nestedName = self.nestedName(name);
            var nestedStaticPartLength = self.staticPartLength(nestedName); // in bytes
            var roundedNestedStaticPartLength = Math.floor((nestedStaticPartLength + 31) / 32) * 32;
            var result = [];

            for (var i = 0; i < length * roundedNestedStaticPartLength; i += roundedNestedStaticPartLength) {
                result.push(self.decode(bytes, arrayStart + i, nestedName));
            }

            return result;
        })();
    } else if (this.isDynamicType(name)) {

        return (function () {
            var dynamicOffset = parseInt('0x' + bytes.substr(offset * 2, 64));      // in bytes
            var length = parseInt('0x' + bytes.substr(dynamicOffset * 2, 64));      // in bytes
            var roundedLength = Math.floor((length + 31) / 32);                     // in int
            var param = new SolidityParam(bytes.substr(dynamicOffset * 2, ( 1 + roundedLength) * 64), 0);
            return self._outputFormatter(param, name);
        })();
    }

    var length = this.staticPartLength(name);
    var param = new SolidityParam(bytes.substr(offset * 2, length * 2));
    return this._outputFormatter(param, name);
};

module.exports = SolidityType;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hh; });
/* unused harmony export maskHeightFactor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return roundRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectPassiveEventSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojifyTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// import marked from 'marked'
/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 * @param {CanvasRenderingContext2D} ctx
 * @param {Number} x The top left x coordinate
 * @param {Number} y The top left y coordinate
 * @param {Number} width The width of the rectangle
 * @param {Number} height The height of the rectangle
 * @param {Number} [radius = 5] The corner radius; It can also be an object
 *                 to specify different radii for corners
 * @param {Number} [radius.tl = 0] Top left
 * @param {Number} [radius.tr = 0] Top right
 * @param {Number} [radius.br = 0] Bottom right
 * @param {Number} [radius.bl = 0] Bottom left
 * @param {Boolean} [fill = false] Whether to fill the rectangle.
 * @param {Boolean} [stroke = true] Whether to stroke the rectangle.
 */function roundRect(ctx,x,y,width,height,radius,fill,stroke){var defaultRadius={tl:0,tr:0,br:0,bl:0};stroke=typeof stroke==='undefined'?true:stroke;radius=typeof radius==='undefined'?5:radius;if(typeof radius==='number'){radius={tl:radius,tr:radius,br:radius,bl:radius};}else{for(var side in defaultRadius){radius[side]=radius[side]||defaultRadius[side];}}ctx.beginPath();ctx.moveTo(x+radius.tl,y);ctx.lineTo(x+width-radius.tr,y);ctx.quadraticCurveTo(x+width,y,x+width,y+radius.tr);ctx.lineTo(x+width,y+height-radius.br);ctx.quadraticCurveTo(x+width,y+height,x+width-radius.br,y+height);ctx.lineTo(x+radius.bl,y+height);ctx.quadraticCurveTo(x,y+height,x,y+height-radius.bl);ctx.lineTo(x,y+radius.tl);ctx.quadraticCurveTo(x,y,x+radius.tl,y);ctx.closePath();if(fill)ctx.fill();if(stroke)ctx.stroke();}// Checks if browser supports passive event listeners
function detectPassiveEventSupport(){var supportsPassive=false;try{var opts=Object.defineProperty({},'passive',{get:function get(){supportsPassive=true;}});window.addEventListener('testPassive',null,opts);window.removeEventListener('testPassive',null,opts);}catch(e){}return supportsPassive;}// /**
// * @param {.md file} path
// **/
// function md(path) {
//   fetch(path)
//     .then((response) => { return response.text() })
//     .then((text) => {
//       return marked(text)
//     })
// }
var hh=52;var maskHeightFactor=0.1;var noop=function noop(){};var emojifyTitle=function emojifyTitle(title){var matchWizard='<wizard/> / ';console.log('matchWizard is '+matchWizard);console.log('title.indexOf(matchWizard) is '+title.indexOf(matchWizard));if(title.indexOf(matchWizard)!==-1){var strippedTitle=title.replace(matchWizard,'');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{'class':'has_wizard_emoji'},' / ',strippedTitle);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,title);}};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(158)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
      return factory( window, matchesSelector );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file formatters.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @author Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */




var utils = __webpack_require__(2);
var config = __webpack_require__(32);
var Iban = __webpack_require__(33);

/**
 * Should the format output to a big number
 *
 * @method outputBigNumberFormatter
 * @param {String|Number|BigNumber}
 * @returns {BigNumber} object
 */
var outputBigNumberFormatter = function (number) {
    return utils.toBigNumber(number);
};

var isPredefinedBlockNumber = function (blockNumber) {
    return blockNumber === 'latest' || blockNumber === 'pending' || blockNumber === 'earliest';
};

var inputDefaultBlockNumberFormatter = function (blockNumber) {
    if (blockNumber === undefined) {
        return config.defaultBlock;
    }
    return inputBlockNumberFormatter(blockNumber);
};

var inputBlockNumberFormatter = function (blockNumber) {
    if (blockNumber === undefined) {
        return undefined;
    } else if (isPredefinedBlockNumber(blockNumber)) {
        return blockNumber;
    }
    return utils.toHex(blockNumber);
};

/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputCallFormatter
 * @param {Object} transaction options
 * @returns object
*/
var inputCallFormatter = function (options){

    options.from = options.from || config.defaultAccount;

    if (options.from) {
        options.from = inputAddressFormatter(options.from);
    }

    if (options.to) { // it might be contract creation
        options.to = inputAddressFormatter(options.to);
    }

    ['gasPrice', 'gas', 'value', 'nonce'].filter(function (key) {
        return options[key] !== undefined;
    }).forEach(function(key){
        options[key] = utils.fromDecimal(options[key]);
    });

    return options;
};

/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputTransactionFormatter
 * @param {Object} transaction options
 * @returns object
*/
var inputTransactionFormatter = function (options){

    options.from = options.from || config.defaultAccount;
    options.from = inputAddressFormatter(options.from);

    if (options.to) { // it might be contract creation
        options.to = inputAddressFormatter(options.to);
    }

    ['gasPrice', 'gas', 'value', 'nonce'].filter(function (key) {
        return options[key] !== undefined;
    }).forEach(function(key){
        options[key] = utils.fromDecimal(options[key]);
    });

    return options;
};

/**
 * Formats the output of a transaction to its proper values
 *
 * @method outputTransactionFormatter
 * @param {Object} tx
 * @returns {Object}
*/
var outputTransactionFormatter = function (tx){
    if(tx.blockNumber !== null)
        tx.blockNumber = utils.toDecimal(tx.blockNumber);
    if(tx.transactionIndex !== null)
        tx.transactionIndex = utils.toDecimal(tx.transactionIndex);
    tx.nonce = utils.toDecimal(tx.nonce);
    tx.gas = utils.toDecimal(tx.gas);
    tx.gasPrice = utils.toBigNumber(tx.gasPrice);
    tx.value = utils.toBigNumber(tx.value);
    return tx;
};

/**
 * Formats the output of a transaction receipt to its proper values
 *
 * @method outputTransactionReceiptFormatter
 * @param {Object} receipt
 * @returns {Object}
*/
var outputTransactionReceiptFormatter = function (receipt){
    if(receipt.blockNumber !== null)
        receipt.blockNumber = utils.toDecimal(receipt.blockNumber);
    if(receipt.transactionIndex !== null)
        receipt.transactionIndex = utils.toDecimal(receipt.transactionIndex);
    receipt.cumulativeGasUsed = utils.toDecimal(receipt.cumulativeGasUsed);
    receipt.gasUsed = utils.toDecimal(receipt.gasUsed);

    if(utils.isArray(receipt.logs)) {
        receipt.logs = receipt.logs.map(function(log){
            return outputLogFormatter(log);
        });
    }

    return receipt;
};

/**
 * Formats the output of a block to its proper values
 *
 * @method outputBlockFormatter
 * @param {Object} block
 * @returns {Object}
*/
var outputBlockFormatter = function(block) {

    // transform to number
    block.gasLimit = utils.toDecimal(block.gasLimit);
    block.gasUsed = utils.toDecimal(block.gasUsed);
    block.size = utils.toDecimal(block.size);
    block.timestamp = utils.toDecimal(block.timestamp);
    if(block.number !== null)
        block.number = utils.toDecimal(block.number);

    block.difficulty = utils.toBigNumber(block.difficulty);
    block.totalDifficulty = utils.toBigNumber(block.totalDifficulty);

    if (utils.isArray(block.transactions)) {
        block.transactions.forEach(function(item){
            if(!utils.isString(item))
                return outputTransactionFormatter(item);
        });
    }

    return block;
};

/**
 * Formats the output of a log
 *
 * @method outputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
*/
var outputLogFormatter = function(log) {
    if(log.blockNumber)
        log.blockNumber = utils.toDecimal(log.blockNumber);
    if(log.transactionIndex)
        log.transactionIndex = utils.toDecimal(log.transactionIndex);
    if(log.logIndex)
        log.logIndex = utils.toDecimal(log.logIndex);

    return log;
};

/**
 * Formats the input of a whisper post and converts all values to HEX
 *
 * @method inputPostFormatter
 * @param {Object} transaction object
 * @returns {Object}
*/
var inputPostFormatter = function(post) {

    // post.payload = utils.toHex(post.payload);
    post.ttl = utils.fromDecimal(post.ttl);
    post.workToProve = utils.fromDecimal(post.workToProve);
    post.priority = utils.fromDecimal(post.priority);

    // fallback
    if (!utils.isArray(post.topics)) {
        post.topics = post.topics ? [post.topics] : [];
    }

    // format the following options
    post.topics = post.topics.map(function(topic){
        // convert only if not hex
        return (topic.indexOf('0x') === 0) ? topic : utils.fromUtf8(topic);
    });

    return post;
};

/**
 * Formats the output of a received post message
 *
 * @method outputPostFormatter
 * @param {Object}
 * @returns {Object}
 */
var outputPostFormatter = function(post){

    post.expiry = utils.toDecimal(post.expiry);
    post.sent = utils.toDecimal(post.sent);
    post.ttl = utils.toDecimal(post.ttl);
    post.workProved = utils.toDecimal(post.workProved);
    // post.payloadRaw = post.payload;
    // post.payload = utils.toAscii(post.payload);

    // if (utils.isJson(post.payload)) {
    //     post.payload = JSON.parse(post.payload);
    // }

    // format the following options
    if (!post.topics) {
        post.topics = [];
    }
    post.topics = post.topics.map(function(topic){
        return utils.toAscii(topic);
    });

    return post;
};

var inputAddressFormatter = function (address) {
    var iban = new Iban(address);
    if (iban.isValid() && iban.isDirect()) {
        return '0x' + iban.address();
    } else if (utils.isStrictAddress(address)) {
        return address;
    } else if (utils.isAddress(address)) {
        return '0x' + address;
    }
    throw new Error('invalid address');
};


var outputSyncingFormatter = function(result) {
    if (!result) {
        return result;
    }

    result.startingBlock = utils.toDecimal(result.startingBlock);
    result.currentBlock = utils.toDecimal(result.currentBlock);
    result.highestBlock = utils.toDecimal(result.highestBlock);
    if (result.knownStates) {
        result.knownStates = utils.toDecimal(result.knownStates);
        result.pulledStates = utils.toDecimal(result.pulledStates);
    }

    return result;
};

module.exports = {
    inputDefaultBlockNumberFormatter: inputDefaultBlockNumberFormatter,
    inputBlockNumberFormatter: inputBlockNumberFormatter,
    inputCallFormatter: inputCallFormatter,
    inputTransactionFormatter: inputTransactionFormatter,
    inputAddressFormatter: inputAddressFormatter,
    inputPostFormatter: inputPostFormatter,
    outputBigNumberFormatter: outputBigNumberFormatter,
    outputTransactionFormatter: outputTransactionFormatter,
    outputTransactionReceiptFormatter: outputTransactionReceiptFormatter,
    outputBlockFormatter: outputBlockFormatter,
    outputLogFormatter: outputLogFormatter,
    outputPostFormatter: outputPostFormatter,
    outputSyncingFormatter: outputSyncingFormatter
};



/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(45),
      __webpack_require__(76),
      __webpack_require__(13),
      __webpack_require__(159),
      __webpack_require__(160),
      __webpack_require__(161),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('ev-emitter'),
        require('get-size'),
        require('fizzy-ui-utils'),
        require('./cell'),
        require('./slide'),
        require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
        window,
        window.EvEmitter,
        window.getSize,
        window.fizzyUIUtils,
        _Flickity.Cell,
        _Flickity.Slide,
        _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
    utils, Cell, Slide, animatePrototype ) {

/* eslint-enable max-params */
'use strict';

// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( var eventName in this.options.on ) {
    var listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i = index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  } );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match( /^(\d+)%$/ );
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    /* eslint-disable-next-line no-invalid-this */
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5,
  },
  left: {
    left: 0,
    right: 1,
  },
  right: {
    right: 0,
    left: 1,
  },
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  var prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index != prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

proto.selectInitialIndex = function() {
  var initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    var cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  var index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell = this.queryCell( value );
  if ( !cell ) {
    return;
  }

  var index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slides that has cell
  for ( var i = 0; i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      return i;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i = 0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  if ( typeof selector == 'string' ) {
    // do not select invalid selectors from hash: #123, #/. #791
    if ( selector.match( /^[#.]?[\d/]/ ) ) {
      return;
    }
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// keep focus on element when child UI elements are clicked
proto.childUIPointerDown = function( event ) {
  // HACK iOS does not allow touch events to bubble up?!
  if ( event.type != 'touchstart' ) {
    event.preventDefault();
  }
  this.focus();
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  // #1177 disable resize behavior when animating or dragging for iOS 15
  if ( !this.isActive || this.isAnimating || this.isDragging ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  var isNotFocused = document.activeElement && document.activeElement != this.element;
  if ( !this.options.accessibility || isNotFocused ) {
    return;
  }

  var handler = Flickity.keyboardHandlers[ event.keyCode ];
  if ( handler ) {
    handler.call( this );
  }
};

Flickity.keyboardHandlers = {
  // left arrow
  37: function() {
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  },
  // right arrow
  39: function() {
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  // TODO remove scrollTo once focus options gets more support
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
  //    #Browser_compatibility
  var prevScrollY = window.pageYOffset;
  this.element.focus({ preventScroll: true });
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  } );
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(47), __webpack_require__(48));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file method.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var utils = __webpack_require__(2);
var errors = __webpack_require__(22);

var Method = function (options) {
    this.name = options.name;
    this.call = options.call;
    this.params = options.params || 0;
    this.inputFormatter = options.inputFormatter;
    this.outputFormatter = options.outputFormatter;
    this.requestManager = null;
};

Method.prototype.setRequestManager = function (rm) {
    this.requestManager = rm;
};

/**
 * Should be used to determine name of the jsonrpc method based on arguments
 *
 * @method getCall
 * @param {Array} arguments
 * @return {String} name of jsonrpc method
 */
Method.prototype.getCall = function (args) {
    return utils.isFunction(this.call) ? this.call(args) : this.call;
};

/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */
Method.prototype.extractCallback = function (args) {
    if (utils.isFunction(args[args.length - 1])) {
        return args.pop(); // modify the args array!
    }
};

/**
 * Should be called to check if the number of arguments is correct
 * 
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */
Method.prototype.validateArgs = function (args) {
    if (args.length !== this.params) {
        throw errors.InvalidNumberOfRPCParams();
    }
};

/**
 * Should be called to format input args of method
 * 
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */
Method.prototype.formatInput = function (args) {
    if (!this.inputFormatter) {
        return args;
    }

    return this.inputFormatter.map(function (formatter, index) {
        return formatter ? formatter(args[index]) : args[index];
    });
};

/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param {Object}
 * @return {Object}
 */
Method.prototype.formatOutput = function (result) {
    return this.outputFormatter && result ? this.outputFormatter(result) : result;
};

/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */
Method.prototype.toPayload = function (args) {
    var call = this.getCall(args);
    var callback = this.extractCallback(args);
    var params = this.formatInput(args);
    this.validateArgs(params);

    return {
        method: call,
        params: params,
        callback: callback
    };
};

Method.prototype.attachToObject = function (obj) {
    var func = this.buildCall();
    func.call = this.call; // TODO!!! that's ugly. filter.js uses it
    var name = this.name.split('.');
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else {
        obj[name[0]] = func; 
    }
};

Method.prototype.buildCall = function() {
    var method = this;
    var send = function () {
        var payload = method.toPayload(Array.prototype.slice.call(arguments));
        if (payload.callback) {
            return method.requestManager.sendAsync(payload, function (err, result) {
                payload.callback(err, method.formatOutput(result));
            });
        }
        return method.formatOutput(method.requestManager.send(payload));
    };
    send.request = this.request.bind(this);
    return send;
};

/**
 * Should be called to create pure JSONRPC request which can be used in batch request
 *
 * @method request
 * @param {...} params
 * @return {Object} jsonrpc request
 */
Method.prototype.request = function () {
    var payload = this.toPayload(Array.prototype.slice.call(arguments));
    payload.format = this.formatOutput.bind(this);
    return payload;
};

module.exports = Method;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(103);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 22 */
/***/ (function(module, exports) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file errors.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

module.exports = {
    InvalidNumberOfSolidityArgs: function () {
        return new Error('Invalid number of arguments to Solidity function');
    },
    InvalidNumberOfRPCParams: function () {
        return new Error('Invalid number of input parameters to RPC method');
    },
    InvalidConnection: function (host){
        return new Error('CONNECTION ERROR: Couldn\'t connect to node '+ host +'.');
    },
    InvalidProvider: function () {
        return new Error('Provider not set or invalid');
    },
    InvalidResponse: function (result){
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : 'Invalid JSON RPC response: ' + JSON.stringify(result);
        return new Error(message);
    },
    ConnectionTimeout: function (ms){
        return new Error('CONNECTION TIMEOUT: timeout of ' + ms + ' ms achived');
    }
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file property.js
 * @author Fabian Vogelsteller <fabian@frozeman.de>
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var utils = __webpack_require__(2);

var Property = function (options) {
    this.name = options.name;
    this.getter = options.getter;
    this.setter = options.setter;
    this.outputFormatter = options.outputFormatter;
    this.inputFormatter = options.inputFormatter;
    this.requestManager = null;
};

Property.prototype.setRequestManager = function (rm) {
    this.requestManager = rm;
};

/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */
Property.prototype.formatInput = function (arg) {
    return this.inputFormatter ? this.inputFormatter(arg) : arg;
};

/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param {Object}
 * @return {Object}
 */
Property.prototype.formatOutput = function (result) {
    return this.outputFormatter && result !== null && result !== undefined ? this.outputFormatter(result) : result;
};

/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */
Property.prototype.extractCallback = function (args) {
    if (utils.isFunction(args[args.length - 1])) {
        return args.pop(); // modify the args array!
    }
};


/**
 * Should attach function to method
 *
 * @method attachToObject
 * @param {Object}
 * @param {Function}
 */
Property.prototype.attachToObject = function (obj) {
    var proto = {
        get: this.buildGet(),
        enumerable: true
    };

    var names = this.name.split('.');
    var name = names[0];
    if (names.length > 1) {
        obj[names[0]] = obj[names[0]] || {};
        obj = obj[names[0]];
        name = names[1];
    }

    Object.defineProperty(obj, name, proto);
    obj[asyncGetterName(name)] = this.buildAsyncGet();
};

var asyncGetterName = function (name) {
    return 'get' + name.charAt(0).toUpperCase() + name.slice(1);
};

Property.prototype.buildGet = function () {
    var property = this;
    return function get() {
        return property.formatOutput(property.requestManager.send({
            method: property.getter
        }));
    };
};

Property.prototype.buildAsyncGet = function () {
    var property = this;
    var get = function (callback) {
        property.requestManager.sendAsync({
            method: property.getter
        }, function (err, result) {
            callback(err, property.formatOutput(result));
        });
    };
    get.request = this.request.bind(this);
    return get;
};

/**
 * Should be called to create pure JSONRPC request which can be used in batch request
 *
 * @method request
 * @param {...} params
 * @return {Object} jsonrpc request
 */
Property.prototype.request = function () {
    var payload = {
        method: this.getter,
        params: [],
        callback: this.extractCallback(Array.prototype.slice.call(arguments))
    };
    payload.format = this.formatOutput.bind(this);
    return payload;
};

module.exports = Property;



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(134);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroAside; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MainAside; });
/* unused harmony export SubAside */
/* unused harmony export HeroAsideWithNewsletter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoToTokenPageCTA__ = __webpack_require__(150);
function evalConfig(config){return __WEBPACK_IMPORTED_MODULE_1_classnames___default()({'aside-left':config.justification==='LEFT','aside-center':config.justification==='CENTER','aside-right':config.justification==='RIGHT','aside-wide':config.width==='WIDE','aside-narrow':config.width==='NARROW'});}function HeroAside(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'aside-hero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aside-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.cta?Object(__WEBPACK_IMPORTED_MODULE_2__Links__["c" /* addCTAs */])(content.cta):null));}function HeroAsideWithNewsletter(_ref2){var content=_ref2.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'aside-hero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aside-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GoToTokenPageCTA__["a" /* default */],null)));}function MainAside(_ref3){var content=_ref3.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:evalConfig(content)+' aside-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aside-content'},content.hasOwnProperty('icn')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icn',src:content.icn.src,alt:content.icn.alt}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.cta?Object(__WEBPACK_IMPORTED_MODULE_2__Links__["c" /* addCTAs */])(content.cta):null));}function SubAside(_ref4){var content=_ref4.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:evalConfig(content)+' aside-sub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aside-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.cta?Object(__WEBPACK_IMPORTED_MODULE_2__Links__["c" /* addCTAs */])(content.cta):null));}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! bignumber.js v2.0.7 https://github.com/MikeMcl/bignumber.js/LICENCE */

;(function (global) {
    'use strict';

    /*
      bignumber.js v2.0.7
      A JavaScript library for arbitrary-precision arithmetic.
      https://github.com/MikeMcl/bignumber.js
      Copyright (c) 2015 Michael Mclaughlin <M8ch88l@gmail.com>
      MIT Expat Licence
    */


    var BigNumber, crypto, parseNumeric,
        isNumeric = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        mathceil = Math.ceil,
        mathfloor = Math.floor,
        notBool = ' not a boolean or binary digit',
        roundingMode = 'rounding mode',
        tooManyDigits = 'number type has more than 15 significant digits',
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_',
        BASE = 1e14,
        LOG_BASE = 14,
        MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
        // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
        POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
        SQRT_BASE = 1e7,

        /*
         * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
         * the arguments to toExponential, toFixed, toFormat, and toPrecision, beyond which an
         * exception is thrown (if ERRORS is true).
         */
        MAX = 1E9;                                   // 0 to MAX_INT32


    /*
     * Create and return a BigNumber constructor.
     */
    function another(configObj) {
        var div,

            // id tracks the caller function, so its name can be included in error messages.
            id = 0,
            P = BigNumber.prototype,
            ONE = new BigNumber(1),


            /********************************* EDITABLE DEFAULTS **********************************/


            /*
             * The default values below must be integers within the inclusive ranges stated.
             * The values can also be changed at run-time using BigNumber.config.
             */

            // The maximum number of decimal places for operations involving division.
            DECIMAL_PLACES = 20,                     // 0 to MAX

            /*
             * The rounding mode used when rounding to the above decimal places, and when using
             * toExponential, toFixed, toFormat and toPrecision, and round (default value).
             * UP         0 Away from zero.
             * DOWN       1 Towards zero.
             * CEIL       2 Towards +Infinity.
             * FLOOR      3 Towards -Infinity.
             * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
             * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
             * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
             * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
             * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
             */
            ROUNDING_MODE = 4,                       // 0 to 8

            // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

            // The exponent value at and beneath which toString returns exponential notation.
            // Number type: -7
            TO_EXP_NEG = -7,                         // 0 to -MAX

            // The exponent value at and above which toString returns exponential notation.
            // Number type: 21
            TO_EXP_POS = 21,                         // 0 to MAX

            // RANGE : [MIN_EXP, MAX_EXP]

            // The minimum exponent value, beneath which underflow to zero occurs.
            // Number type: -324  (5e-324)
            MIN_EXP = -1e7,                          // -1 to -MAX

            // The maximum exponent value, above which overflow to Infinity occurs.
            // Number type:  308  (1.7976931348623157e+308)
            // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
            MAX_EXP = 1e7,                           // 1 to MAX

            // Whether BigNumber Errors are ever thrown.
            ERRORS = true,                           // true or false

            // Change to intValidatorNoErrors if ERRORS is false.
            isValidInt = intValidatorWithErrors,     // intValidatorWithErrors/intValidatorNoErrors

            // Whether to use cryptographically-secure random number generation, if available.
            CRYPTO = false,                          // true or false

            /*
             * The modulo mode used when calculating the modulus: a mod n.
             * The quotient (q = a / n) is calculated according to the corresponding rounding mode.
             * The remainder (r) is calculated as: r = a - n * q.
             *
             * UP        0 The remainder is positive if the dividend is negative, else is negative.
             * DOWN      1 The remainder has the same sign as the dividend.
             *             This modulo mode is commonly known as 'truncated division' and is
             *             equivalent to (a % n) in JavaScript.
             * FLOOR     3 The remainder has the same sign as the divisor (Python %).
             * HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
             * EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
             *             The remainder is always positive.
             *
             * The truncated division, floored division, Euclidian division and IEEE 754 remainder
             * modes are commonly used for the modulus operation.
             * Although the other rounding modes can also be used, they may not give useful results.
             */
            MODULO_MODE = 1,                         // 0 to 9

            // The maximum number of significant digits of the result of the toPower operation.
            // If POW_PRECISION is 0, there will be unlimited significant digits.
            POW_PRECISION = 100,                     // 0 to MAX

            // The format specification used by the BigNumber.prototype.toFormat method.
            FORMAT = {
                decimalSeparator: '.',
                groupSeparator: ',',
                groupSize: 3,
                secondaryGroupSize: 0,
                fractionGroupSeparator: '\xA0',      // non-breaking space
                fractionGroupSize: 0
            };


        /******************************************************************************************/


        // CONSTRUCTOR


        /*
         * The BigNumber constructor and exported function.
         * Create and return a new instance of a BigNumber object.
         *
         * n {number|string|BigNumber} A numeric value.
         * [b] {number} The base of n. Integer, 2 to 64 inclusive.
         */
        function BigNumber( n, b ) {
            var c, e, i, num, len, str,
                x = this;

            // Enable constructor usage without new.
            if ( !( x instanceof BigNumber ) ) {

                // 'BigNumber() constructor call without new: {n}'
                if (ERRORS) raise( 26, 'constructor call without new', n );
                return new BigNumber( n, b );
            }

            // 'new BigNumber() base not an integer: {b}'
            // 'new BigNumber() base out of range: {b}'
            if ( b == null || !isValidInt( b, 2, 64, id, 'base' ) ) {

                // Duplicate.
                if ( n instanceof BigNumber ) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = ( n = n.c ) ? n.slice() : n;
                    id = 0;
                    return;
                }

                if ( ( num = typeof n == 'number' ) && n * 0 == 0 ) {
                    x.s = 1 / n < 0 ? ( n = -n, -1 ) : 1;

                    // Fast path for integers.
                    if ( n === ~~n ) {
                        for ( e = 0, i = n; i >= 10; i /= 10, e++ );
                        x.e = e;
                        x.c = [n];
                        id = 0;
                        return;
                    }

                    str = n + '';
                } else {
                    if ( !isNumeric.test( str = n + '' ) ) return parseNumeric( x, str, num );
                    x.s = str.charCodeAt(0) === 45 ? ( str = str.slice(1), -1 ) : 1;
                }
            } else {
                b = b | 0;
                str = n + '';

                // Ensure return value is rounded to DECIMAL_PLACES as with other bases.
                // Allow exponential notation to be used with base 10 argument.
                if ( b == 10 ) {
                    x = new BigNumber( n instanceof BigNumber ? n : str );
                    return round( x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE );
                }

                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                // Any number in exponential form will fail due to the [Ee][+-].
                if ( ( num = typeof n == 'number' ) && n * 0 != 0 ||
                  !( new RegExp( '^-?' + ( c = '[' + ALPHABET.slice( 0, b ) + ']+' ) +
                    '(?:\\.' + c + ')?$',b < 37 ? 'i' : '' ) ).test(str) ) {
                    return parseNumeric( x, str, num, b );
                }

                if (num) {
                    x.s = 1 / n < 0 ? ( str = str.slice(1), -1 ) : 1;

                    if ( ERRORS && str.replace( /^0\.0*|\./, '' ).length > 15 ) {

                        // 'new BigNumber() number type has more than 15 significant digits: {n}'
                        raise( id, tooManyDigits, n );
                    }

                    // Prevent later check for length on converted number.
                    num = false;
                } else {
                    x.s = str.charCodeAt(0) === 45 ? ( str = str.slice(1), -1 ) : 1;
                }

                str = convertBase( str, 10, b, x.s );
            }

            // Decimal point?
            if ( ( e = str.indexOf('.') ) > -1 ) str = str.replace( '.', '' );

            // Exponential form?
            if ( ( i = str.search( /e/i ) ) > 0 ) {

                // Determine exponent.
                if ( e < 0 ) e = i;
                e += +str.slice( i + 1 );
                str = str.substring( 0, i );
            } else if ( e < 0 ) {

                // Integer.
                e = str.length;
            }

            // Determine leading zeros.
            for ( i = 0; str.charCodeAt(i) === 48; i++ );

            // Determine trailing zeros.
            for ( len = str.length; str.charCodeAt(--len) === 48; );
            str = str.slice( i, len + 1 );

            if (str) {
                len = str.length;

                // Disallow numbers with over 15 significant digits if number type.
                // 'new BigNumber() number type has more than 15 significant digits: {n}'
                if ( num && ERRORS && len > 15 ) raise( id, tooManyDigits, x.s * n );

                e = e - i - 1;

                 // Overflow?
                if ( e > MAX_EXP ) {

                    // Infinity.
                    x.c = x.e = null;

                // Underflow?
                } else if ( e < MIN_EXP ) {

                    // Zero.
                    x.c = [ x.e = 0 ];
                } else {
                    x.e = e;
                    x.c = [];

                    // Transform base

                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = ( e + 1 ) % LOG_BASE;
                    if ( e < 0 ) i += LOG_BASE;

                    if ( i < len ) {
                        if (i) x.c.push( +str.slice( 0, i ) );

                        for ( len -= LOG_BASE; i < len; ) {
                            x.c.push( +str.slice( i, i += LOG_BASE ) );
                        }

                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else {
                        i -= len;
                    }

                    for ( ; i--; str += '0' );
                    x.c.push( +str );
                }
            } else {

                // Zero.
                x.c = [ x.e = 0 ];
            }

            id = 0;
        }


        // CONSTRUCTOR PROPERTIES


        BigNumber.another = another;

        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;


        /*
         * Configure infrequently-changing library-wide settings.
         *
         * Accept an object or an argument list, with one or many of the following properties or
         * parameters respectively:
         *
         *   DECIMAL_PLACES  {number}  Integer, 0 to MAX inclusive
         *   ROUNDING_MODE   {number}  Integer, 0 to 8 inclusive
         *   EXPONENTIAL_AT  {number|number[]}  Integer, -MAX to MAX inclusive or
         *                                      [integer -MAX to 0 incl., 0 to MAX incl.]
         *   RANGE           {number|number[]}  Non-zero integer, -MAX to MAX inclusive or
         *                                      [integer -MAX to -1 incl., integer 1 to MAX incl.]
         *   ERRORS          {boolean|number}   true, false, 1 or 0
         *   CRYPTO          {boolean|number}   true, false, 1 or 0
         *   MODULO_MODE     {number}           0 to 9 inclusive
         *   POW_PRECISION   {number}           0 to MAX inclusive
         *   FORMAT          {object}           See BigNumber.prototype.toFormat
         *      decimalSeparator       {string}
         *      groupSeparator         {string}
         *      groupSize              {number}
         *      secondaryGroupSize     {number}
         *      fractionGroupSeparator {string}
         *      fractionGroupSize      {number}
         *
         * (The values assigned to the above FORMAT object properties are not checked for validity.)
         *
         * E.g.
         * BigNumber.config(20, 4) is equivalent to
         * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
         *
         * Ignore properties/parameters set to null or undefined.
         * Return an object with the properties current values.
         */
        BigNumber.config = function () {
            var v, p,
                i = 0,
                r = {},
                a = arguments,
                o = a[0],
                has = o && typeof o == 'object'
                  ? function () { if ( o.hasOwnProperty(p) ) return ( v = o[p] ) != null; }
                  : function () { if ( a.length > i ) return ( v = a[i++] ) != null; };

            // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
            // 'config() DECIMAL_PLACES not an integer: {v}'
            // 'config() DECIMAL_PLACES out of range: {v}'
            if ( has( p = 'DECIMAL_PLACES' ) && isValidInt( v, 0, MAX, 2, p ) ) {
                DECIMAL_PLACES = v | 0;
            }
            r[p] = DECIMAL_PLACES;

            // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
            // 'config() ROUNDING_MODE not an integer: {v}'
            // 'config() ROUNDING_MODE out of range: {v}'
            if ( has( p = 'ROUNDING_MODE' ) && isValidInt( v, 0, 8, 2, p ) ) {
                ROUNDING_MODE = v | 0;
            }
            r[p] = ROUNDING_MODE;

            // EXPONENTIAL_AT {number|number[]}
            // Integer, -MAX to MAX inclusive or [integer -MAX to 0 inclusive, 0 to MAX inclusive].
            // 'config() EXPONENTIAL_AT not an integer: {v}'
            // 'config() EXPONENTIAL_AT out of range: {v}'
            if ( has( p = 'EXPONENTIAL_AT' ) ) {

                if ( isArray(v) ) {
                    if ( isValidInt( v[0], -MAX, 0, 2, p ) && isValidInt( v[1], 0, MAX, 2, p ) ) {
                        TO_EXP_NEG = v[0] | 0;
                        TO_EXP_POS = v[1] | 0;
                    }
                } else if ( isValidInt( v, -MAX, MAX, 2, p ) ) {
                    TO_EXP_NEG = -( TO_EXP_POS = ( v < 0 ? -v : v ) | 0 );
                }
            }
            r[p] = [ TO_EXP_NEG, TO_EXP_POS ];

            // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
            // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
            // 'config() RANGE not an integer: {v}'
            // 'config() RANGE cannot be zero: {v}'
            // 'config() RANGE out of range: {v}'
            if ( has( p = 'RANGE' ) ) {

                if ( isArray(v) ) {
                    if ( isValidInt( v[0], -MAX, -1, 2, p ) && isValidInt( v[1], 1, MAX, 2, p ) ) {
                        MIN_EXP = v[0] | 0;
                        MAX_EXP = v[1] | 0;
                    }
                } else if ( isValidInt( v, -MAX, MAX, 2, p ) ) {
                    if ( v | 0 ) MIN_EXP = -( MAX_EXP = ( v < 0 ? -v : v ) | 0 );
                    else if (ERRORS) raise( 2, p + ' cannot be zero', v );
                }
            }
            r[p] = [ MIN_EXP, MAX_EXP ];

            // ERRORS {boolean|number} true, false, 1 or 0.
            // 'config() ERRORS not a boolean or binary digit: {v}'
            if ( has( p = 'ERRORS' ) ) {

                if ( v === !!v || v === 1 || v === 0 ) {
                    id = 0;
                    isValidInt = ( ERRORS = !!v ) ? intValidatorWithErrors : intValidatorNoErrors;
                } else if (ERRORS) {
                    raise( 2, p + notBool, v );
                }
            }
            r[p] = ERRORS;

            // CRYPTO {boolean|number} true, false, 1 or 0.
            // 'config() CRYPTO not a boolean or binary digit: {v}'
            // 'config() crypto unavailable: {crypto}'
            if ( has( p = 'CRYPTO' ) ) {

                if ( v === !!v || v === 1 || v === 0 ) {
                    CRYPTO = !!( v && crypto && typeof crypto == 'object' );
                    if ( v && !CRYPTO && ERRORS ) raise( 2, 'crypto unavailable', crypto );
                } else if (ERRORS) {
                    raise( 2, p + notBool, v );
                }
            }
            r[p] = CRYPTO;

            // MODULO_MODE {number} Integer, 0 to 9 inclusive.
            // 'config() MODULO_MODE not an integer: {v}'
            // 'config() MODULO_MODE out of range: {v}'
            if ( has( p = 'MODULO_MODE' ) && isValidInt( v, 0, 9, 2, p ) ) {
                MODULO_MODE = v | 0;
            }
            r[p] = MODULO_MODE;

            // POW_PRECISION {number} Integer, 0 to MAX inclusive.
            // 'config() POW_PRECISION not an integer: {v}'
            // 'config() POW_PRECISION out of range: {v}'
            if ( has( p = 'POW_PRECISION' ) && isValidInt( v, 0, MAX, 2, p ) ) {
                POW_PRECISION = v | 0;
            }
            r[p] = POW_PRECISION;

            // FORMAT {object}
            // 'config() FORMAT not an object: {v}'
            if ( has( p = 'FORMAT' ) ) {

                if ( typeof v == 'object' ) {
                    FORMAT = v;
                } else if (ERRORS) {
                    raise( 2, p + ' not an object', v );
                }
            }
            r[p] = FORMAT;

            return r;
        };


        /*
         * Return a new BigNumber whose value is the maximum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */
        BigNumber.max = function () { return maxOrMin( arguments, P.lt ); };


        /*
         * Return a new BigNumber whose value is the minimum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */
        BigNumber.min = function () { return maxOrMin( arguments, P.gt ); };


        /*
         * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
         * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
         * zeros are produced).
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         *
         * 'random() decimal places not an integer: {dp}'
         * 'random() decimal places out of range: {dp}'
         * 'random() crypto unavailable: {crypto}'
         */
        BigNumber.random = (function () {
            var pow2_53 = 0x20000000000000;

            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
              ? function () { return mathfloor( Math.random() * pow2_53 ); }
              : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
                  (Math.random() * 0x800000 | 0); };

            return function (dp) {
                var a, b, e, k, v,
                    i = 0,
                    c = [],
                    rand = new BigNumber(ONE);

                dp = dp == null || !isValidInt( dp, 0, MAX, 14 ) ? DECIMAL_PLACES : dp | 0;
                k = mathceil( dp / LOG_BASE );

                if (CRYPTO) {

                    // Browsers supporting crypto.getRandomValues.
                    if ( crypto && crypto.getRandomValues ) {

                        a = crypto.getRandomValues( new Uint32Array( k *= 2 ) );

                        for ( ; i < k; ) {

                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);

                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if ( v >= 9e15 ) {
                                b = crypto.getRandomValues( new Uint32Array(2) );
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {

                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push( v % 1e14 );
                                i += 2;
                            }
                        }
                        i = k / 2;

                    // Node.js supporting crypto.randomBytes.
                    } else if ( crypto && crypto.randomBytes ) {

                        // buffer
                        a = crypto.randomBytes( k *= 7 );

                        for ( ; i < k; ) {

                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = ( ( a[i] & 31 ) * 0x1000000000000 ) + ( a[i + 1] * 0x10000000000 ) +
                                  ( a[i + 2] * 0x100000000 ) + ( a[i + 3] * 0x1000000 ) +
                                  ( a[i + 4] << 16 ) + ( a[i + 5] << 8 ) + a[i + 6];

                            if ( v >= 9e15 ) {
                                crypto.randomBytes(7).copy( a, i );
                            } else {

                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push( v % 1e14 );
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else if (ERRORS) {
                        raise( 14, 'crypto unavailable', crypto );
                    }
                }

                // Use Math.random: CRYPTO is false or crypto is unavailable and ERRORS is false.
                if (!i) {

                    for ( ; i < k; ) {
                        v = random53bitInt();
                        if ( v < 9e15 ) c[i++] = v % 1e14;
                    }
                }

                k = c[--i];
                dp %= LOG_BASE;

                // Convert trailing digits to zeros according to dp.
                if ( k && dp ) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor( k / v ) * v;
                }

                // Remove trailing elements which are zero.
                for ( ; c[i] === 0; c.pop(), i-- );

                // Zero?
                if ( i < 0 ) {
                    c = [ e = 0 ];
                } else {

                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for ( e = -1 ; c[0] === 0; c.shift(), e -= LOG_BASE);

                    // Count the digits of the first element of c to determine leading zeros, and...
                    for ( i = 1, v = c[0]; v >= 10; v /= 10, i++);

                    // adjust the exponent accordingly.
                    if ( i < LOG_BASE ) e -= LOG_BASE - i;
                }

                rand.e = e;
                rand.c = c;
                return rand;
            };
        })();


        // PRIVATE FUNCTIONS


        // Convert a numeric string of baseIn to a numeric string of baseOut.
        function convertBase( str, baseOut, baseIn, sign ) {
            var d, e, k, r, x, xc, y,
                i = str.indexOf( '.' ),
                dp = DECIMAL_PLACES,
                rm = ROUNDING_MODE;

            if ( baseIn < 37 ) str = str.toLowerCase();

            // Non-integer.
            if ( i >= 0 ) {
                k = POW_PRECISION;

                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace( '.', '' );
                y = new BigNumber(baseIn);
                x = y.pow( str.length - i );
                POW_PRECISION = k;

                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut( toFixedPoint( coeffToString( x.c ), x.e ), 10, baseOut );
                y.e = y.c.length;
            }

            // Convert the number as integer.
            xc = toBaseOut( str, baseIn, baseOut );
            e = k = xc.length;

            // Remove trailing zeros.
            for ( ; xc[--k] == 0; xc.pop() );
            if ( !xc[0] ) return '0';

            if ( i < 0 ) {
                --e;
            } else {
                x.c = xc;
                x.e = e;

                // sign is needed for correct rounding.
                x.s = sign;
                x = div( x, y, dp, rm, baseOut );
                xc = x.c;
                r = x.r;
                e = x.e;
            }

            d = e + dp + 1;

            // The rounding digit, i.e. the digit to the right of the digit that may be rounded up.
            i = xc[d];
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;

            r = rm < 4 ? ( i != null || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                       : i > k || i == k &&( rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
                         rm == ( x.s < 0 ? 8 : 7 ) );

            if ( d < 1 || !xc[0] ) {

                // 1^-dp or 0.
                str = r ? toFixedPoint( '1', -dp ) : '0';
            } else {
                xc.length = d;

                if (r) {

                    // Rounding up may mean the previous digit has to be rounded up and so on.
                    for ( --baseOut; ++xc[--d] > baseOut; ) {
                        xc[d] = 0;

                        if ( !d ) {
                            ++e;
                            xc.unshift(1);
                        }
                    }
                }

                // Determine trailing zeros.
                for ( k = xc.length; !xc[--k]; );

                // E.g. [4, 11, 15] becomes 4bf.
                for ( i = 0, str = ''; i <= k; str += ALPHABET.charAt( xc[i++] ) );
                str = toFixedPoint( str, e );
            }

            // The caller will add the sign.
            return str;
        }


        // Perform division in the specified base. Called by div and convertBase.
        div = (function () {

            // Assume non-zero x and k.
            function multiply( x, k, base ) {
                var m, temp, xlo, xhi,
                    carry = 0,
                    i = x.length,
                    klo = k % SQRT_BASE,
                    khi = k / SQRT_BASE | 0;

                for ( x = x.slice(); i--; ) {
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + ( ( m % SQRT_BASE ) * SQRT_BASE ) + carry;
                    carry = ( temp / base | 0 ) + ( m / SQRT_BASE | 0 ) + khi * xhi;
                    x[i] = temp % base;
                }

                if (carry) x.unshift(carry);

                return x;
            }

            function compare( a, b, aL, bL ) {
                var i, cmp;

                if ( aL != bL ) {
                    cmp = aL > bL ? 1 : -1;
                } else {

                    for ( i = cmp = 0; i < aL; i++ ) {

                        if ( a[i] != b[i] ) {
                            cmp = a[i] > b[i] ? 1 : -1;
                            break;
                        }
                    }
                }
                return cmp;
            }

            function subtract( a, b, aL, base ) {
                var i = 0;

                // Subtract b from a.
                for ( ; aL--; ) {
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }

                // Remove leading zeros.
                for ( ; !a[0] && a.length > 1; a.shift() );
            }

            // x: dividend, y: divisor.
            return function ( x, y, dp, rm, base ) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
                    yL, yz,
                    s = x.s == y.s ? 1 : -1,
                    xc = x.c,
                    yc = y.c;

                // Either NaN, Infinity or 0?
                if ( !xc || !xc[0] || !yc || !yc[0] ) {

                    return new BigNumber(

                      // Return NaN if either NaN, or both Infinity or 0.
                      !x.s || !y.s || ( xc ? yc && xc[0] == yc[0] : !yc ) ? NaN :

                        // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                        xc && xc[0] == 0 || !yc ? s * 0 : s / 0
                    );
                }

                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;

                if ( !base ) {
                    base = BASE;
                    e = bitFloor( x.e / LOG_BASE ) - bitFloor( y.e / LOG_BASE );
                    s = s / LOG_BASE | 0;
                }

                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for ( i = 0; yc[i] == ( xc[i] || 0 ); i++ );
                if ( yc[i] > ( xc[i] || 0 ) ) e--;

                if ( s < 0 ) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;

                    // Normalise xc and yc so highest order digit of yc is >= base / 2.

                    n = mathfloor( base / ( yc[0] + 1 ) );

                    // Not necessary, but to handle odd bases where yc[0] == ( base / 2 ) - 1.
                    // if ( n > 1 || n++ == 1 && yc[0] < base / 2 ) {
                    if ( n > 1 ) {
                        yc = multiply( yc, n, base );
                        xc = multiply( xc, n, base );
                        yL = yc.length;
                        xL = xc.length;
                    }

                    xi = yL;
                    rem = xc.slice( 0, yL );
                    remL = rem.length;

                    // Add zeros to make remainder as long as divisor.
                    for ( ; remL < yL; rem[remL++] = 0 );
                    yz = yc.slice();
                    yz.unshift(0);
                    yc0 = yc[0];
                    if ( yc[1] >= base / 2 ) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if ( base == 3 && yc0 == 1 ) yc0 = 1 + 1e-15;

                    do {
                        n = 0;

                        // Compare divisor and remainder.
                        cmp = compare( yc, rem, yL, remL );

                        // If divisor < remainder.
                        if ( cmp < 0 ) {

                            // Calculate trial digit, n.

                            rem0 = rem[0];
                            if ( yL != remL ) rem0 = rem0 * base + ( rem[1] || 0 );

                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor( rem0 / yc0 );

                            //  Algorithm:
                            //  1. product = divisor * trial digit (n)
                            //  2. if product > remainder: product -= divisor, n--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, n++

                            if ( n > 1 ) {

                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;

                                // product = divisor * trial digit.
                                prod = multiply( yc, n, base );
                                prodL = prod.length;
                                remL = rem.length;

                                // Compare product and remainder.
                                // If product > remainder.
                                // Trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while ( compare( prod, rem, prodL, remL ) == 1 ) {
                                    n--;

                                    // Subtract divisor from product.
                                    subtract( prod, yL < prodL ? yz : yc, prodL, base );
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {

                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if ( n == 0 ) {

                                    // divisor < remainder, so n must be at least 1.
                                    cmp = n = 1;
                                }

                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }

                            if ( prodL < remL ) prod.unshift(0);

                            // Subtract product from remainder.
                            subtract( rem, prod, remL, base );
                            remL = rem.length;

                             // If product was < remainder.
                            if ( cmp == -1 ) {

                                // Compare divisor and new remainder.
                                // If divisor < new remainder, subtract divisor from remainder.
                                // Trial digit n too low.
                                // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                while ( compare( yc, rem, yL, remL ) < 1 ) {
                                    n++;

                                    // Subtract divisor from remainder.
                                    subtract( rem, yL < remL ? yz : yc, remL, base );
                                    remL = rem.length;
                                }
                            }
                        } else if ( cmp === 0 ) {
                            n++;
                            rem = [0];
                        } // else cmp === 1 and n will be 0

                        // Add the next digit, n, to the result array.
                        qc[i++] = n;

                        // Update the remainder.
                        if ( rem[0] ) {
                            rem[remL++] = xc[xi] || 0;
                        } else {
                            rem = [ xc[xi] ];
                            remL = 1;
                        }
                    } while ( ( xi++ < xL || rem[0] != null ) && s-- );

                    more = rem[0] != null;

                    // Leading zero?
                    if ( !qc[0] ) qc.shift();
                }

                if ( base == BASE ) {

                    // To calculate q.e, first get the number of digits of qc[0].
                    for ( i = 1, s = qc[0]; s >= 10; s /= 10, i++ );
                    round( q, dp + ( q.e = i + e * LOG_BASE - 1 ) + 1, rm, more );

                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }

                return q;
            };
        })();


        /*
         * Return a string representing the value of BigNumber n in fixed-point or exponential
         * notation rounded to the specified decimal places or significant digits.
         *
         * n is a BigNumber.
         * i is the index of the last digit required (i.e. the digit that may be rounded up).
         * rm is the rounding mode.
         * caller is caller id: toExponential 19, toFixed 20, toFormat 21, toPrecision 24.
         */
        function format( n, i, rm, caller ) {
            var c0, e, ne, len, str;

            rm = rm != null && isValidInt( rm, 0, 8, caller, roundingMode )
              ? rm | 0 : ROUNDING_MODE;

            if ( !n.c ) return n.toString();
            c0 = n.c[0];
            ne = n.e;

            if ( i == null ) {
                str = coeffToString( n.c );
                str = caller == 19 || caller == 24 && ne <= TO_EXP_NEG
                  ? toExponential( str, ne )
                  : toFixedPoint( str, ne );
            } else {
                n = round( new BigNumber(n), i, rm );

                // n.e may have changed if the value was rounded up.
                e = n.e;

                str = coeffToString( n.c );
                len = str.length;

                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.

                // Exponential notation.
                if ( caller == 19 || caller == 24 && ( i <= e || e <= TO_EXP_NEG ) ) {

                    // Append zeros?
                    for ( ; len < i; str += '0', len++ );
                    str = toExponential( str, e );

                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint( str, e );

                    // Append zeros?
                    if ( e + 1 > len ) {
                        if ( --i > 0 ) for ( str += '.'; i--; str += '0' );
                    } else {
                        i += e - len;
                        if ( i > 0 ) {
                            if ( e + 1 == len ) str += '.';
                            for ( ; i--; str += '0' );
                        }
                    }
                }
            }

            return n.s < 0 && c0 ? '-' + str : str;
        }


        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin( args, method ) {
            var m, n,
                i = 0;

            if ( isArray( args[0] ) ) args = args[0];
            m = new BigNumber( args[0] );

            for ( ; ++i < args.length; ) {
                n = new BigNumber( args[i] );

                // If any number is NaN, return NaN.
                if ( !n.s ) {
                    m = n;
                    break;
                } else if ( method.call( m, n ) ) {
                    m = n;
                }
            }

            return m;
        }


        /*
         * Return true if n is an integer in range, otherwise throw.
         * Use for argument validation when ERRORS is true.
         */
        function intValidatorWithErrors( n, min, max, caller, name ) {
            if ( n < min || n > max || n != truncate(n) ) {
                raise( caller, ( name || 'decimal places' ) +
                  ( n < min || n > max ? ' out of range' : ' not an integer' ), n );
            }

            return true;
        }


        /*
         * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
         * Called by minus, plus and times.
         */
        function normalise( n, c, e ) {
            var i = 1,
                j = c.length;

             // Remove trailing zeros.
            for ( ; !c[--j]; c.pop() );

            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for ( j = c[0]; j >= 10; j /= 10, i++ );

            // Overflow?
            if ( ( e = i + e * LOG_BASE - 1 ) > MAX_EXP ) {

                // Infinity.
                n.c = n.e = null;

            // Underflow?
            } else if ( e < MIN_EXP ) {

                // Zero.
                n.c = [ n.e = 0 ];
            } else {
                n.e = e;
                n.c = c;
            }

            return n;
        }


        // Handle values that fail the validity test in BigNumber.
        parseNumeric = (function () {
            var basePrefix = /^(-?)0([xbo])/i,
                dotAfter = /^([^.]+)\.$/,
                dotBefore = /^\.([^.]+)$/,
                isInfinityOrNaN = /^-?(Infinity|NaN)$/,
                whitespaceOrPlus = /^\s*\+|^\s+|\s+$/g;

            return function ( x, str, num, b ) {
                var base,
                    s = num ? str : str.replace( whitespaceOrPlus, '' );

                // No exception on ±Infinity or NaN.
                if ( isInfinityOrNaN.test(s) ) {
                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                } else {
                    if ( !num ) {

                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace( basePrefix, function ( m, p1, p2 ) {
                            base = ( p2 = p2.toLowerCase() ) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });

                        if (b) {
                            base = b;

                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace( dotAfter, '$1' ).replace( dotBefore, '0.$1' );
                        }

                        if ( str != s ) return new BigNumber( s, base );
                    }

                    // 'new BigNumber() not a number: {n}'
                    // 'new BigNumber() not a base {b} number: {n}'
                    if (ERRORS) raise( id, 'not a' + ( b ? ' base ' + b : '' ) + ' number', str );
                    x.s = null;
                }

                x.c = x.e = null;
                id = 0;
            }
        })();


        // Throw a BigNumber Error.
        function raise( caller, msg, val ) {
            var error = new Error( [
                'new BigNumber',     // 0
                'cmp',               // 1
                'config',            // 2
                'div',               // 3
                'divToInt',          // 4
                'eq',                // 5
                'gt',                // 6
                'gte',               // 7
                'lt',                // 8
                'lte',               // 9
                'minus',             // 10
                'mod',               // 11
                'plus',              // 12
                'precision',         // 13
                'random',            // 14
                'round',             // 15
                'shift',             // 16
                'times',             // 17
                'toDigits',          // 18
                'toExponential',     // 19
                'toFixed',           // 20
                'toFormat',          // 21
                'toFraction',        // 22
                'pow',               // 23
                'toPrecision',       // 24
                'toString',          // 25
                'BigNumber'          // 26
            ][caller] + '() ' + msg + ': ' + val );

            error.name = 'BigNumber Error';
            id = 0;
            throw error;
        }


        /*
         * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
         * If r is truthy, it is known that there are more digits after the rounding digit.
         */
        function round( x, sd, rm, r ) {
            var d, i, j, k, n, ni, rd,
                xc = x.c,
                pows10 = POWS_TEN;

            // if x is not Infinity or NaN...
            if (xc) {

                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {

                    // Get the number of digits of the first element of xc.
                    for ( d = 1, k = xc[0]; k >= 10; k /= 10, d++ );
                    i = sd - d;

                    // If the rounding digit is in the first element of xc...
                    if ( i < 0 ) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ ni = 0 ];

                        // Get the rounding digit at index j of n.
                        rd = n / pows10[ d - j - 1 ] % 10 | 0;
                    } else {
                        ni = mathceil( ( i + 1 ) / LOG_BASE );

                        if ( ni >= xc.length ) {

                            if (r) {

                                // Needed by sqrt.
                                for ( ; xc.length <= ni; xc.push(0) );
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else {
                                break out;
                            }
                        } else {
                            n = k = xc[ni];

                            // Get the number of digits of n.
                            for ( d = 1; k >= 10; k /= 10, d++ );

                            // Get the index of rd within n.
                            i %= LOG_BASE;

                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;

                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[ d - j - 1 ] % 10 | 0;
                        }
                    }

                    r = r || sd < 0 ||

                    // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[ d - j - 1 ]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                      xc[ni + 1] != null || ( j < 0 ? n : n % pows10[ d - j - 1 ] );

                    r = rm < 4
                      ? ( rd || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                      : rd > 5 || rd == 5 && ( rm == 4 || r || rm == 6 &&

                        // Check whether the digit to the left of the rounding digit is odd.
                        ( ( i > 0 ? j > 0 ? n / pows10[ d - j ] : 0 : xc[ni - 1] ) % 10 ) & 1 ||
                          rm == ( x.s < 0 ? 8 : 7 ) );

                    if ( sd < 1 || !xc[0] ) {
                        xc.length = 0;

                        if (r) {

                            // Convert sd to decimal places.
                            sd -= x.e + 1;

                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[ sd % LOG_BASE ];
                            x.e = -sd || 0;
                        } else {

                            // Zero.
                            xc[0] = x.e = 0;
                        }

                        return x;
                    }

                    // Remove excess digits.
                    if ( i == 0 ) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[ LOG_BASE - i ];

                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor( n / pows10[ d - j ] % pows10[j] ) * k : 0;
                    }

                    // Round up?
                    if (r) {

                        for ( ; ; ) {

                            // If the digit to be rounded up is in the first element of xc...
                            if ( ni == 0 ) {

                                // i will be the length of xc[0] before k is added.
                                for ( i = 1, j = xc[0]; j >= 10; j /= 10, i++ );
                                j = xc[0] += k;
                                for ( k = 1; j >= 10; j /= 10, k++ );

                                // if i != k the length has increased.
                                if ( i != k ) {
                                    x.e++;
                                    if ( xc[0] == BASE ) xc[0] = 1;
                                }

                                break;
                            } else {
                                xc[ni] += k;
                                if ( xc[ni] != BASE ) break;
                                xc[ni--] = 0;
                                k = 1;
                            }
                        }
                    }

                    // Remove trailing zeros.
                    for ( i = xc.length; xc[--i] === 0; xc.pop() );
                }

                // Overflow? Infinity.
                if ( x.e > MAX_EXP ) {
                    x.c = x.e = null;

                // Underflow? Zero.
                } else if ( x.e < MIN_EXP ) {
                    x.c = [ x.e = 0 ];
                }
            }

            return x;
        }


        // PROTOTYPE/INSTANCE METHODS


        /*
         * Return a new BigNumber whose value is the absolute value of this BigNumber.
         */
        P.absoluteValue = P.abs = function () {
            var x = new BigNumber(this);
            if ( x.s < 0 ) x.s = 1;
            return x;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
         * number in the direction of Infinity.
         */
        P.ceil = function () {
            return round( new BigNumber(this), this.e + 1, 2 );
        };


        /*
         * Return
         * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
         * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
         * 0 if they have the same value,
         * or null if the value of either is NaN.
         */
        P.comparedTo = P.cmp = function ( y, b ) {
            id = 1;
            return compare( this, new BigNumber( y, b ) );
        };


        /*
         * Return the number of decimal places of the value of this BigNumber, or null if the value
         * of this BigNumber is ±Infinity or NaN.
         */
        P.decimalPlaces = P.dp = function () {
            var n, v,
                c = this.c;

            if ( !c ) return null;
            n = ( ( v = c.length - 1 ) - bitFloor( this.e / LOG_BASE ) ) * LOG_BASE;

            // Subtract the number of trailing zeros of the last number.
            if ( v = c[v] ) for ( ; v % 10 == 0; v /= 10, n-- );
            if ( n < 0 ) n = 0;

            return n;
        };


        /*
         *  n / 0 = I
         *  n / N = N
         *  n / I = 0
         *  0 / n = 0
         *  0 / 0 = N
         *  0 / N = N
         *  0 / I = 0
         *  N / n = N
         *  N / 0 = N
         *  N / N = N
         *  N / I = N
         *  I / n = I
         *  I / 0 = I
         *  I / N = N
         *  I / I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
         * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */
        P.dividedBy = P.div = function ( y, b ) {
            id = 3;
            return div( this, new BigNumber( y, b ), DECIMAL_PLACES, ROUNDING_MODE );
        };


        /*
         * Return a new BigNumber whose value is the integer part of dividing the value of this
         * BigNumber by the value of BigNumber(y, b).
         */
        P.dividedToIntegerBy = P.divToInt = function ( y, b ) {
            id = 4;
            return div( this, new BigNumber( y, b ), 0, 1 );
        };


        /*
         * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
         * otherwise returns false.
         */
        P.equals = P.eq = function ( y, b ) {
            id = 5;
            return compare( this, new BigNumber( y, b ) ) === 0;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
         * number in the direction of -Infinity.
         */
        P.floor = function () {
            return round( new BigNumber(this), this.e + 1, 3 );
        };


        /*
         * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
         * otherwise returns false.
         */
        P.greaterThan = P.gt = function ( y, b ) {
            id = 6;
            return compare( this, new BigNumber( y, b ) ) > 0;
        };


        /*
         * Return true if the value of this BigNumber is greater than or equal to the value of
         * BigNumber(y, b), otherwise returns false.
         */
        P.greaterThanOrEqualTo = P.gte = function ( y, b ) {
            id = 7;
            return ( b = compare( this, new BigNumber( y, b ) ) ) === 1 || b === 0;

        };


        /*
         * Return true if the value of this BigNumber is a finite number, otherwise returns false.
         */
        P.isFinite = function () {
            return !!this.c;
        };


        /*
         * Return true if the value of this BigNumber is an integer, otherwise return false.
         */
        P.isInteger = P.isInt = function () {
            return !!this.c && bitFloor( this.e / LOG_BASE ) > this.c.length - 2;
        };


        /*
         * Return true if the value of this BigNumber is NaN, otherwise returns false.
         */
        P.isNaN = function () {
            return !this.s;
        };


        /*
         * Return true if the value of this BigNumber is negative, otherwise returns false.
         */
        P.isNegative = P.isNeg = function () {
            return this.s < 0;
        };


        /*
         * Return true if the value of this BigNumber is 0 or -0, otherwise returns false.
         */
        P.isZero = function () {
            return !!this.c && this.c[0] == 0;
        };


        /*
         * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
         * otherwise returns false.
         */
        P.lessThan = P.lt = function ( y, b ) {
            id = 8;
            return compare( this, new BigNumber( y, b ) ) < 0;
        };


        /*
         * Return true if the value of this BigNumber is less than or equal to the value of
         * BigNumber(y, b), otherwise returns false.
         */
        P.lessThanOrEqualTo = P.lte = function ( y, b ) {
            id = 9;
            return ( b = compare( this, new BigNumber( y, b ) ) ) === -1 || b === 0;
        };


        /*
         *  n - 0 = n
         *  n - N = N
         *  n - I = -I
         *  0 - n = -n
         *  0 - 0 = 0
         *  0 - N = N
         *  0 - I = -I
         *  N - n = N
         *  N - 0 = N
         *  N - N = N
         *  N - I = N
         *  I - n = I
         *  I - 0 = I
         *  I - N = N
         *  I - I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber minus the value of
         * BigNumber(y, b).
         */
        P.minus = P.sub = function ( y, b ) {
            var i, j, t, xLTy,
                x = this,
                a = x.s;

            id = 10;
            y = new BigNumber( y, b );
            b = y.s;

            // Either NaN?
            if ( !a || !b ) return new BigNumber(NaN);

            // Signs differ?
            if ( a != b ) {
                y.s = -b;
                return x.plus(y);
            }

            var xe = x.e / LOG_BASE,
                ye = y.e / LOG_BASE,
                xc = x.c,
                yc = y.c;

            if ( !xe || !ye ) {

                // Either Infinity?
                if ( !xc || !yc ) return xc ? ( y.s = -b, y ) : new BigNumber( yc ? x : NaN );

                // Either zero?
                if ( !xc[0] || !yc[0] ) {

                    // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                    return yc[0] ? ( y.s = -b, y ) : new BigNumber( xc[0] ? x :

                      // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                      ROUNDING_MODE == 3 ? -0 : 0 );
                }
            }

            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();

            // Determine which is the bigger number.
            if ( a = xe - ye ) {

                if ( xLTy = a < 0 ) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }

                t.reverse();

                // Prepend zeros to equalise exponents.
                for ( b = a; b--; t.push(0) );
                t.reverse();
            } else {

                // Exponents equal. Check digit by digit.
                j = ( xLTy = ( a = xc.length ) < ( b = yc.length ) ) ? a : b;

                for ( a = b = 0; b < j; b++ ) {

                    if ( xc[b] != yc[b] ) {
                        xLTy = xc[b] < yc[b];
                        break;
                    }
                }
            }

            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;

            b = ( j = yc.length ) - ( i = xc.length );

            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if ( b > 0 ) for ( ; b--; xc[i++] = 0 );
            b = BASE - 1;

            // Subtract yc from xc.
            for ( ; j > a; ) {

                if ( xc[--j] < yc[j] ) {
                    for ( i = j; i && !xc[--i]; xc[i] = b );
                    --xc[i];
                    xc[j] += BASE;
                }

                xc[j] -= yc[j];
            }

            // Remove leading zeros and adjust exponent accordingly.
            for ( ; xc[0] == 0; xc.shift(), --ye );

            // Zero?
            if ( !xc[0] ) {

                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [ y.e = 0 ];
                return y;
            }

            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise( y, xc, ye );
        };


        /*
         *   n % 0 =  N
         *   n % N =  N
         *   n % I =  n
         *   0 % n =  0
         *  -0 % n = -0
         *   0 % 0 =  N
         *   0 % N =  N
         *   0 % I =  0
         *   N % n =  N
         *   N % 0 =  N
         *   N % N =  N
         *   N % I =  N
         *   I % n =  N
         *   I % 0 =  N
         *   I % N =  N
         *   I % I =  N
         *
         * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
         * BigNumber(y, b). The result depends on the value of MODULO_MODE.
         */
        P.modulo = P.mod = function ( y, b ) {
            var q, s,
                x = this;

            id = 11;
            y = new BigNumber( y, b );

            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if ( !x.c || !y.s || y.c && !y.c[0] ) {
                return new BigNumber(NaN);

            // Return x if y is Infinity or x is zero.
            } else if ( !y.c || x.c && !x.c[0] ) {
                return new BigNumber(x);
            }

            if ( MODULO_MODE == 9 ) {

                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div( x, y, 0, 3 );
                y.s = s;
                q.s *= s;
            } else {
                q = div( x, y, 0, MODULO_MODE );
            }

            return x.minus( q.times(y) );
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber negated,
         * i.e. multiplied by -1.
         */
        P.negated = P.neg = function () {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };


        /*
         *  n + 0 = n
         *  n + N = N
         *  n + I = I
         *  0 + n = n
         *  0 + 0 = 0
         *  0 + N = N
         *  0 + I = I
         *  N + n = N
         *  N + 0 = N
         *  N + N = N
         *  N + I = N
         *  I + n = I
         *  I + 0 = I
         *  I + N = N
         *  I + I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber plus the value of
         * BigNumber(y, b).
         */
        P.plus = P.add = function ( y, b ) {
            var t,
                x = this,
                a = x.s;

            id = 12;
            y = new BigNumber( y, b );
            b = y.s;

            // Either NaN?
            if ( !a || !b ) return new BigNumber(NaN);

            // Signs differ?
             if ( a != b ) {
                y.s = -b;
                return x.minus(y);
            }

            var xe = x.e / LOG_BASE,
                ye = y.e / LOG_BASE,
                xc = x.c,
                yc = y.c;

            if ( !xe || !ye ) {

                // Return ±Infinity if either ±Infinity.
                if ( !xc || !yc ) return new BigNumber( a / 0 );

                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if ( !xc[0] || !yc[0] ) return yc[0] ? y : new BigNumber( xc[0] ? x : a * 0 );
            }

            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();

            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if ( a = xe - ye ) {
                if ( a > 0 ) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }

                t.reverse();
                for ( ; a--; t.push(0) );
                t.reverse();
            }

            a = xc.length;
            b = yc.length;

            // Point xc to the longer array, and b to the shorter length.
            if ( a - b < 0 ) t = yc, yc = xc, xc = t, b = a;

            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for ( a = 0; b; ) {
                a = ( xc[--b] = xc[b] + yc[b] + a ) / BASE | 0;
                xc[b] %= BASE;
            }

            if (a) {
                xc.unshift(a);
                ++ye;
            }

            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise( y, xc, ye );
        };


        /*
         * Return the number of significant digits of the value of this BigNumber.
         *
         * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
         */
        P.precision = P.sd = function (z) {
            var n, v,
                x = this,
                c = x.c;

            // 'precision() argument not a boolean or binary digit: {z}'
            if ( z != null && z !== !!z && z !== 1 && z !== 0 ) {
                if (ERRORS) raise( 13, 'argument' + notBool, z );
                if ( z != !!z ) z = null;
            }

            if ( !c ) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;

            if ( v = c[v] ) {

                // Subtract the number of trailing zeros of the last element.
                for ( ; v % 10 == 0; v /= 10, n-- );

                // Add the number of digits of the first element.
                for ( v = c[0]; v >= 10; v /= 10, n++ );
            }

            if ( z && x.e + 1 > n ) n = x.e + 1;

            return n;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
         * dp decimal places using rounding mode rm, or to 0 and ROUNDING_MODE respectively if
         * omitted.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'round() decimal places out of range: {dp}'
         * 'round() decimal places not an integer: {dp}'
         * 'round() rounding mode not an integer: {rm}'
         * 'round() rounding mode out of range: {rm}'
         */
        P.round = function ( dp, rm ) {
            var n = new BigNumber(this);

            if ( dp == null || isValidInt( dp, 0, MAX, 15 ) ) {
                round( n, ~~dp + this.e + 1, rm == null ||
                  !isValidInt( rm, 0, 8, 15, roundingMode ) ? ROUNDING_MODE : rm | 0 );
            }

            return n;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
         * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
         *
         * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
         *
         * If k is out of range and ERRORS is false, the result will be ±0 if k < 0, or ±Infinity
         * otherwise.
         *
         * 'shift() argument not an integer: {k}'
         * 'shift() argument out of range: {k}'
         */
        P.shift = function (k) {
            var n = this;
            return isValidInt( k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 16, 'argument' )

              // k < 1e+21, or truncate(k) will produce exponential notation.
              ? n.times( '1e' + truncate(k) )
              : new BigNumber( n.c && n.c[0] && ( k < -MAX_SAFE_INTEGER || k > MAX_SAFE_INTEGER )
                ? n.s * ( k < 0 ? 0 : 1 / 0 )
                : n );
        };


        /*
         *  sqrt(-n) =  N
         *  sqrt( N) =  N
         *  sqrt(-I) =  N
         *  sqrt( I) =  I
         *  sqrt( 0) =  0
         *  sqrt(-0) = -0
         *
         * Return a new BigNumber whose value is the square root of the value of this BigNumber,
         * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */
        P.squareRoot = P.sqrt = function () {
            var m, n, r, rep, t,
                x = this,
                c = x.c,
                s = x.s,
                e = x.e,
                dp = DECIMAL_PLACES + 4,
                half = new BigNumber('0.5');

            // Negative/NaN/Infinity/zero?
            if ( s !== 1 || !c || !c[0] ) {
                return new BigNumber( !s || s < 0 && ( !c || c[0] ) ? NaN : c ? x : 1 / 0 );
            }

            // Initial estimate.
            s = Math.sqrt( +x );

            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if ( s == 0 || s == 1 / 0 ) {
                n = coeffToString(c);
                if ( ( n.length + e ) % 2 == 0 ) n += '0';
                s = Math.sqrt(n);
                e = bitFloor( ( e + 1 ) / 2 ) - ( e < 0 || e % 2 );

                if ( s == 1 / 0 ) {
                    n = '1e' + e;
                } else {
                    n = s.toExponential();
                    n = n.slice( 0, n.indexOf('e') + 1 ) + e;
                }

                r = new BigNumber(n);
            } else {
                r = new BigNumber( s + '' );
            }

            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if ( r.c[0] ) {
                e = r.e;
                s = e + dp;
                if ( s < 3 ) s = 0;

                // Newton-Raphson iteration.
                for ( ; ; ) {
                    t = r;
                    r = half.times( t.plus( div( x, t, dp, 1 ) ) );

                    if ( coeffToString( t.c   ).slice( 0, s ) === ( n =
                         coeffToString( r.c ) ).slice( 0, s ) ) {

                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if ( r.e < e ) --s;
                        n = n.slice( s - 3, s + 1 );

                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if ( n == '9999' || !rep && n == '4999' ) {

                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if ( !rep ) {
                                round( t, t.e + DECIMAL_PLACES + 2, 0 );

                                if ( t.times(t).eq(x) ) {
                                    r = t;
                                    break;
                                }
                            }

                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {

                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if ( !+n || !+n.slice(1) && n.charAt(0) == '5' ) {

                                // Truncate to the first rounding digit.
                                round( r, r.e + DECIMAL_PLACES + 2, 1 );
                                m = !r.times(r).eq(x);
                            }

                            break;
                        }
                    }
                }
            }

            return round( r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m );
        };


        /*
         *  n * 0 = 0
         *  n * N = N
         *  n * I = I
         *  0 * n = 0
         *  0 * 0 = 0
         *  0 * N = N
         *  0 * I = N
         *  N * n = N
         *  N * 0 = N
         *  N * N = N
         *  N * I = N
         *  I * n = I
         *  I * 0 = N
         *  I * N = N
         *  I * I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber times the value of
         * BigNumber(y, b).
         */
        P.times = P.mul = function ( y, b ) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
                base, sqrtBase,
                x = this,
                xc = x.c,
                yc = ( id = 17, y = new BigNumber( y, b ) ).c;

            // Either NaN, ±Infinity or ±0?
            if ( !xc || !yc || !xc[0] || !yc[0] ) {

                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if ( !x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc ) {
                    y.c = y.e = y.s = null;
                } else {
                    y.s *= x.s;

                    // Return ±Infinity if either is ±Infinity.
                    if ( !xc || !yc ) {
                        y.c = y.e = null;

                    // Return ±0 if either is ±0.
                    } else {
                        y.c = [0];
                        y.e = 0;
                    }
                }

                return y;
            }

            e = bitFloor( x.e / LOG_BASE ) + bitFloor( y.e / LOG_BASE );
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;

            // Ensure xc points to longer array and xcL to its length.
            if ( xcL < ycL ) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;

            // Initialise the result array with zeros.
            for ( i = xcL + ycL, zc = []; i--; zc.push(0) );

            base = BASE;
            sqrtBase = SQRT_BASE;

            for ( i = ycL; --i >= 0; ) {
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;

                for ( k = xcL, j = i + k; j > i; ) {
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + ( ( m % sqrtBase ) * sqrtBase ) + zc[j] + c;
                    c = ( xlo / base | 0 ) + ( m / sqrtBase | 0 ) + yhi * xhi;
                    zc[j--] = xlo % base;
                }

                zc[j] = c;
            }

            if (c) {
                ++e;
            } else {
                zc.shift();
            }

            return normalise( y, zc, e );
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
         * sd significant digits using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toDigits() precision out of range: {sd}'
         * 'toDigits() precision not an integer: {sd}'
         * 'toDigits() rounding mode not an integer: {rm}'
         * 'toDigits() rounding mode out of range: {rm}'
         */
        P.toDigits = function ( sd, rm ) {
            var n = new BigNumber(this);
            sd = sd == null || !isValidInt( sd, 1, MAX, 18, 'precision' ) ? null : sd | 0;
            rm = rm == null || !isValidInt( rm, 0, 8, 18, roundingMode ) ? ROUNDING_MODE : rm | 0;
            return sd ? round( n, sd, rm ) : n;
        };


        /*
         * Return a string representing the value of this BigNumber in exponential notation and
         * rounded using ROUNDING_MODE to dp fixed decimal places.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toExponential() decimal places not an integer: {dp}'
         * 'toExponential() decimal places out of range: {dp}'
         * 'toExponential() rounding mode not an integer: {rm}'
         * 'toExponential() rounding mode out of range: {rm}'
         */
        P.toExponential = function ( dp, rm ) {
            return format( this,
              dp != null && isValidInt( dp, 0, MAX, 19 ) ? ~~dp + 1 : null, rm, 19 );
        };


        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounding
         * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
         * but e.g. (-0.00001).toFixed(0) is '-0'.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toFixed() decimal places not an integer: {dp}'
         * 'toFixed() decimal places out of range: {dp}'
         * 'toFixed() rounding mode not an integer: {rm}'
         * 'toFixed() rounding mode out of range: {rm}'
         */
        P.toFixed = function ( dp, rm ) {
            return format( this, dp != null && isValidInt( dp, 0, MAX, 20 )
              ? ~~dp + this.e + 1 : null, rm, 20 );
        };


        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounded
         * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
         * of the FORMAT object (see BigNumber.config).
         *
         * FORMAT = {
         *      decimalSeparator : '.',
         *      groupSeparator : ',',
         *      groupSize : 3,
         *      secondaryGroupSize : 0,
         *      fractionGroupSeparator : '\xA0',    // non-breaking space
         *      fractionGroupSize : 0
         * };
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toFormat() decimal places not an integer: {dp}'
         * 'toFormat() decimal places out of range: {dp}'
         * 'toFormat() rounding mode not an integer: {rm}'
         * 'toFormat() rounding mode out of range: {rm}'
         */
        P.toFormat = function ( dp, rm ) {
            var str = format( this, dp != null && isValidInt( dp, 0, MAX, 21 )
              ? ~~dp + this.e + 1 : null, rm, 21 );

            if ( this.c ) {
                var i,
                    arr = str.split('.'),
                    g1 = +FORMAT.groupSize,
                    g2 = +FORMAT.secondaryGroupSize,
                    groupSeparator = FORMAT.groupSeparator,
                    intPart = arr[0],
                    fractionPart = arr[1],
                    isNeg = this.s < 0,
                    intDigits = isNeg ? intPart.slice(1) : intPart,
                    len = intDigits.length;

                if (g2) i = g1, g1 = g2, g2 = i, len -= i;

                if ( g1 > 0 && len > 0 ) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr( 0, i );

                    for ( ; i < len; i += g1 ) {
                        intPart += groupSeparator + intDigits.substr( i, g1 );
                    }

                    if ( g2 > 0 ) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }

                str = fractionPart
                  ? intPart + FORMAT.decimalSeparator + ( ( g2 = +FORMAT.fractionGroupSize )
                    ? fractionPart.replace( new RegExp( '\\d{' + g2 + '}\\B', 'g' ),
                      '$&' + FORMAT.fractionGroupSeparator )
                    : fractionPart )
                  : intPart;
            }

            return str;
        };


        /*
         * Return a string array representing the value of this BigNumber as a simple fraction with
         * an integer numerator and an integer denominator. The denominator will be a positive
         * non-zero value less than or equal to the specified maximum denominator. If a maximum
         * denominator is not specified, the denominator will be the lowest value necessary to
         * represent the number exactly.
         *
         * [md] {number|string|BigNumber} Integer >= 1 and < Infinity. The maximum denominator.
         *
         * 'toFraction() max denominator not an integer: {md}'
         * 'toFraction() max denominator out of range: {md}'
         */
        P.toFraction = function (md) {
            var arr, d0, d2, e, exp, n, n0, q, s,
                k = ERRORS,
                x = this,
                xc = x.c,
                d = new BigNumber(ONE),
                n1 = d0 = new BigNumber(ONE),
                d1 = n0 = new BigNumber(ONE);

            if ( md != null ) {
                ERRORS = false;
                n = new BigNumber(md);
                ERRORS = k;

                if ( !( k = n.isInt() ) || n.lt(ONE) ) {

                    if (ERRORS) {
                        raise( 22,
                          'max denominator ' + ( k ? 'out of range' : 'not an integer' ), md );
                    }

                    // ERRORS is false:
                    // If md is a finite non-integer >= 1, round it to an integer and use it.
                    md = !k && n.c && round( n, n.e + 1, 1 ).gte(ONE) ? n : null;
                }
            }

            if ( !xc ) return x.toString();
            s = coeffToString(xc);

            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[ ( exp = e % LOG_BASE ) < 0 ? LOG_BASE + exp : exp ];
            md = !md || n.cmp(d) > 0 ? ( e > 0 ? d : n1 ) : n;

            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);

            // n0 = d1 = 0
            n0.c[0] = 0;

            for ( ; ; )  {
                q = div( n, d, 0, 1 );
                d2 = d0.plus( q.times(d1) );
                if ( d2.cmp(md) == 1 ) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus( q.times( d2 = n1 ) );
                n0 = d2;
                d = n.minus( q.times( d2 = d ) );
                n = d2;
            }

            d2 = div( md.minus(d0), d1, 0, 1 );
            n0 = n0.plus( d2.times(n1) );
            d0 = d0.plus( d2.times(d1) );
            n0.s = n1.s = x.s;
            e *= 2;

            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div( n1, d1, e, ROUNDING_MODE ).minus(x).abs().cmp(
                  div( n0, d0, e, ROUNDING_MODE ).minus(x).abs() ) < 1
                    ? [ n1.toString(), d1.toString() ]
                    : [ n0.toString(), d0.toString() ];

            MAX_EXP = exp;
            return arr;
        };


        /*
         * Return the value of this BigNumber converted to a number primitive.
         */
        P.toNumber = function () {
            var x = this;

            // Ensure zero has correct sign.
            return +x || ( x.s ? x.s * 0 : NaN );
        };


        /*
         * Return a BigNumber whose value is the value of this BigNumber raised to the power n.
         * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
         * If POW_PRECISION is not 0, round to POW_PRECISION using ROUNDING_MODE.
         *
         * n {number} Integer, -9007199254740992 to 9007199254740992 inclusive.
         * (Performs 54 loop iterations for n of 9007199254740992.)
         *
         * 'pow() exponent not an integer: {n}'
         * 'pow() exponent out of range: {n}'
         */
        P.toPower = P.pow = function (n) {
            var k, y,
                i = mathfloor( n < 0 ? -n : +n ),
                x = this;

            // Pass ±Infinity to Math.pow if exponent is out of range.
            if ( !isValidInt( n, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 23, 'exponent' ) &&
              ( !isFinite(n) || i > MAX_SAFE_INTEGER && ( n /= 0 ) ||
                parseFloat(n) != n && !( n = NaN ) ) ) {
                return new BigNumber( Math.pow( +x, n ) );
            }

            // Truncating each coefficient array to a length of k after each multiplication equates
            // to truncating significant digits to POW_PRECISION + [28, 41], i.e. there will be a
            // minimum of 28 guard digits retained. (Using + 1.5 would give [9, 21] guard digits.)
            k = POW_PRECISION ? mathceil( POW_PRECISION / LOG_BASE + 2 ) : 0;
            y = new BigNumber(ONE);

            for ( ; ; ) {

                if ( i % 2 ) {
                    y = y.times(x);
                    if ( !y.c ) break;
                    if ( k && y.c.length > k ) y.c.length = k;
                }

                i = mathfloor( i / 2 );
                if ( !i ) break;

                x = x.times(x);
                if ( k && x.c && x.c.length > k ) x.c.length = k;
            }

            if ( n < 0 ) y = ONE.div(y);
            return k ? round( y, POW_PRECISION, ROUNDING_MODE ) : y;
        };


        /*
         * Return a string representing the value of this BigNumber rounded to sd significant digits
         * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
         * necessary to represent the integer part of the value in fixed-point notation, then use
         * exponential notation.
         *
         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * 'toPrecision() precision not an integer: {sd}'
         * 'toPrecision() precision out of range: {sd}'
         * 'toPrecision() rounding mode not an integer: {rm}'
         * 'toPrecision() rounding mode out of range: {rm}'
         */
        P.toPrecision = function ( sd, rm ) {
            return format( this, sd != null && isValidInt( sd, 1, MAX, 24, 'precision' )
              ? sd | 0 : null, rm, 24 );
        };


        /*
         * Return a string representing the value of this BigNumber in base b, or base 10 if b is
         * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
         * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
         * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
         * TO_EXP_NEG, return exponential notation.
         *
         * [b] {number} Integer, 2 to 64 inclusive.
         *
         * 'toString() base not an integer: {b}'
         * 'toString() base out of range: {b}'
         */
        P.toString = function (b) {
            var str,
                n = this,
                s = n.s,
                e = n.e;

            // Infinity or NaN?
            if ( e === null ) {

                if (s) {
                    str = 'Infinity';
                    if ( s < 0 ) str = '-' + str;
                } else {
                    str = 'NaN';
                }
            } else {
                str = coeffToString( n.c );

                if ( b == null || !isValidInt( b, 2, 64, 25, 'base' ) ) {
                    str = e <= TO_EXP_NEG || e >= TO_EXP_POS
                      ? toExponential( str, e )
                      : toFixedPoint( str, e );
                } else {
                    str = convertBase( toFixedPoint( str, e ), b | 0, 10, s );
                }

                if ( s < 0 && n.c[0] ) str = '-' + str;
            }

            return str;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber truncated to a whole
         * number.
         */
        P.truncated = P.trunc = function () {
            return round( new BigNumber(this), this.e + 1, 1 );
        };



        /*
         * Return as toString, but do not accept a base argument.
         */
        P.valueOf = P.toJSON = function () {
            return this.toString();
        };


        // Aliases for BigDecimal methods.
        //P.add = P.plus;         // P.add included above
        //P.subtract = P.minus;   // P.sub included above
        //P.multiply = P.times;   // P.mul included above
        //P.divide = P.div;
        //P.remainder = P.mod;
        //P.compareTo = P.cmp;
        //P.negate = P.neg;


        if ( configObj != null ) BigNumber.config(configObj);

        return BigNumber;
    }


    // PRIVATE HELPER FUNCTIONS


    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }


    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z,
            i = 1,
            j = a.length,
            r = a[0] + '';

        for ( ; i < j; ) {
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for ( ; z--; s = '0' + s );
            r += s;
        }

        // Determine trailing zeros.
        for ( j = r.length; r.charCodeAt(--j) === 48; );
        return r.slice( 0, j + 1 || 1 );
    }


    // Compare the value of BigNumbers x and y.
    function compare( x, y ) {
        var a, b,
            xc = x.c,
            yc = y.c,
            i = x.s,
            j = y.s,
            k = x.e,
            l = y.e;

        // Either NaN?
        if ( !i || !j ) return null;

        a = xc && !xc[0];
        b = yc && !yc[0];

        // Either zero?
        if ( a || b ) return a ? b ? 0 : -j : i;

        // Signs differ?
        if ( i != j ) return i;

        a = i < 0;
        b = k == l;

        // Either Infinity?
        if ( !xc || !yc ) return b ? 0 : !xc ^ a ? 1 : -1;

        // Compare exponents.
        if ( !b ) return k > l ^ a ? 1 : -1;

        j = ( k = xc.length ) < ( l = yc.length ) ? k : l;

        // Compare digit by digit.
        for ( i = 0; i < j; i++ ) if ( xc[i] != yc[i] ) return xc[i] > yc[i] ^ a ? 1 : -1;

        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }


    /*
     * Return true if n is a valid number in range, otherwise false.
     * Use for argument validation when ERRORS is false.
     * Note: parseInt('1e+1') == 1 but parseFloat('1e+1') == 10.
     */
    function intValidatorNoErrors( n, min, max ) {
        return ( n = truncate(n) ) >= min && n <= max;
    }


    function isArray(obj) {
        return Object.prototype.toString.call(obj) == '[object Array]';
    }


    /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. convertBase('255', 10, 16) returns [15, 15].
     * Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
     */
    function toBaseOut( str, baseIn, baseOut ) {
        var j,
            arr = [0],
            arrL,
            i = 0,
            len = str.length;

        for ( ; i < len; ) {
            for ( arrL = arr.length; arrL--; arr[arrL] *= baseIn );
            arr[ j = 0 ] += ALPHABET.indexOf( str.charAt( i++ ) );

            for ( ; j < arr.length; j++ ) {

                if ( arr[j] > baseOut - 1 ) {
                    if ( arr[j + 1] == null ) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
        }

        return arr.reverse();
    }


    function toExponential( str, e ) {
        return ( str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str ) +
          ( e < 0 ? 'e' : 'e+' ) + e;
    }


    function toFixedPoint( str, e ) {
        var len, z;

        // Negative exponent?
        if ( e < 0 ) {

            // Prepend zeros.
            for ( z = '0.'; ++e; z += '0' );
            str = z + str;

        // Positive exponent
        } else {
            len = str.length;

            // Append zeros.
            if ( ++e > len ) {
                for ( z = '0', e -= len; --e; z += '0' );
                str += z;
            } else if ( e < len ) {
                str = str.slice( 0, e ) + '.' + str.slice(e);
            }
        }

        return str;
    }


    function truncate(n) {
        n = parseFloat(n);
        return n < 0 ? mathceil(n) : mathfloor(n);
    }


    // EXPORT


    BigNumber = another();

    // AMD.
    if ( true ) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return BigNumber; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    // Node and other environments that support module.exports.
    } else if ( typeof module != 'undefined' && module.exports ) {
        module.exports = BigNumber;
        if ( !crypto ) try { crypto = require('crypto'); } catch (e) {}

    // Browser.
    } else {
        global.BigNumber = BigNumber;
    }
})(this);


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file sha3.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var CryptoJS = __webpack_require__(195);
var sha3 = __webpack_require__(80);

module.exports = function (value, options) {
    if (options && options.encoding === 'hex') {
        if (value.length > 2 && value.substr(0, 2) === '0x') {
            value = value.substr(2);
        }
        value = CryptoJS.enc.Hex.parse(value);
    }

    return sha3(value, {
        outputLength: 256
    }).toString();
};



/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object,
      preload: bool
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      preload: bool
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;
var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  light: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      preload: false
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.13.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onBufferEnd: function onBufferEnd() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};
exports.defaultProps = defaultProps;
var DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];
exports.DEPRECATED_CONFIG_PROPS = DEPRECATED_CONFIG_PROPS;

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Logo; });
/* unused harmony export InternalHeaderLink */
/* unused harmony export ExternalHeaderLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExternalFooterLink; });
/* unused harmony export InternalFooterLink */
/* unused harmony export ExternalCTA */
/* unused harmony export ExternalButtonCTA */
/* unused harmony export ExternalImageCTA */
/* unused harmony export InternalCTA */
/* unused harmony export PlaintextCTA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addCTAs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseLinksHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseLinksFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(12);
function Logo(_ref){var logo=_ref.logo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{id:'header-logo-link',to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'header-logo',src:logo,alt:'FOAM'}));}function ExternalHeaderLink(_ref2){var href=_ref2.href,text=_ref2.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'header-link',target:'_blank',href:href},text);}function HeaderText(_ref3){var text=_ref3.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header-link'},text);}function InternalHeaderLink(_ref4){var href=_ref4.href,text=_ref4.text,selected=_ref4.selected,selectedColor=_ref4.selectedColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'header-link',to:href},text,selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{style:{backgroundColor:selectedColor}}):null);}function ExternalFooterLink(_ref5){var href=_ref5.href,text=_ref5.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'footer-link',target:'_blank',href:href},text);}function InternalFooterLink(_ref6){var href=_ref6.href,text=_ref6.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'footer-link',to:href},text);}function ExternalCTA(_ref7){var href=_ref7.href,text=_ref7.text,isNew=_ref7.isNew;var newClassName=isNew?'isNew':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cta cta--external '+newClassName,target:'_blank',href:href},text);}function ExternalImageCTA(_ref8){var href=_ref8.href,text=_ref8.text,onClickHandler=_ref8.onClickHandler;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cta-image',target:'_blank',href:href,onClick:onClickHandler},text);}function InternalImageCTA(_ref9){var href=_ref9.href,text=_ref9.text,onClickHandler=_ref9.onClickHandler;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'cta-image',to:href,onClick:onClickHandler},text);}function ExternalButtonCTA(_ref10){var href=_ref10.href,text=_ref10.text,onClickHandler=_ref10.onClickHandler;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cta-button',target:'_blank',href:href,onClick:onClickHandler},text);}function InternalCTA(_ref11){var href=_ref11.href,text=_ref11.text,isNew=_ref11.isNew;var newClassName=isNew?'isNew':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'cta '+newClassName,to:href},text);}function PlaintextCTA(_ref12){var href=_ref12.href,text=_ref12.text,isNew=_ref12.isNew;var newClassName=isNew?'isNew':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cta-plaintext '+newClassName},text);}function addCTAs(list){list=Array.isArray(list)?list:[list];return list.map(function(li,idx){var isNew=li.new?true:false;switch(li.type){case'INTERNAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InternalCTA,{key:'cta-'+idx,href:li.path,text:li.text,isNew:isNew});case'EXTERNAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalCTA,{key:'cta-'+idx,href:li.path,text:li.text,isNew:isNew,onClickHandler:li.onClickHandler||__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* noop */]});case'EXTERNAL-BUTTON':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalButtonCTA,{key:'cta-'+idx,href:li.path,text:li.text,onClickHandler:li.onClickHandler||__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* noop */]});case'EXTERNAL-IMAGE':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalImageCTA,{key:'cta-'+idx,href:li.path,text:li.text,onClickHandler:li.onClickHandler||__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* noop */]});case'INTERNAL-IMAGE':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InternalImageCTA,{key:'cta-'+idx,href:li.path,text:li.text,onClickHandler:li.onClickHandler||__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* noop */]});case'PLAINTEXT':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlaintextCTA,{key:'cta-'+idx,text:li.text});default:return null;}});}function parseLinksFooter(routes,key){var filterer=function filterer(r){return r.category===key;};var filteredToCategory=routes.reduce(function(acc,r){var route=filterer(r)?[r]:[];var childRoutes=r.children==null?[]:r.children.filter(filterer);return acc.concat(route,childRoutes);},[]);var seen={};var deduped=filteredToCategory.reduce(function(acc,r){if(seen[r.name]){return acc;}else{seen[r.name]=true;return acc.concat(r);}},[]);return deduped.map(function(r){switch(r.type){case'INTERNAL-NORMAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InternalFooterLink,{key:'f-'+r.path,href:r.path,text:r.name});case'EXTERNAL-NORMAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalFooterLink,{key:'f-'+r.path,href:r.path,text:r.name});case'EXTERNAL-BUTTON':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalFooterLink,{key:'f-'+r.path,href:r.path,text:r.name});default:return null;}});}function parseLinksHeader(routes,currentRoute){var routeMapper=function routeMapper(r,idx){switch(r.type){case'INTERNAL-NORMAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InternalHeaderLink,{key:idx,href:r.path,text:r.name,selected:currentRoute!=null&&r.path===currentRoute.path,selectedColor:r.selectedColor});case'EXTERNAL-NORMAL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExternalHeaderLink,{key:idx,href:r.path,text:r.name});case'TEXT':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderText,{key:idx,text:r.name});default:return null;}};return routes.map(function(r,idx){var res=routeMapper(r,idx);if(res==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HeaderLinkWrapper',key:'HeaderLinkWrapper-Root-'+idx},res,r.children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HeaderLinkWrapper-dropDown'},r.children.map(function(r_,idx_){return routeMapper(r_,idx_);})));});}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file config.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

/**
 * Utils
 * 
 * @module utils
 */

/**
 * Utility functions
 * 
 * @class [utils] config
 * @constructor
 */


/// required to define ETH_BIGNUMBER_ROUNDING_MODE
var BigNumber = __webpack_require__(26);

var ETH_UNITS = [
    'wei',
    'kwei',
    'Mwei',
    'Gwei',
    'szabo',
    'finney',
    'femtoether',
    'picoether',
    'nanoether',
    'microether',
    'milliether',
    'nano',
    'micro',
    'milli',
    'ether',
    'grand',
    'Mether',
    'Gether',
    'Tether',
    'Pether',
    'Eether',
    'Zether',
    'Yether',
    'Nether',
    'Dether',
    'Vether',
    'Uether'
];

module.exports = {
    ETH_PADDING: 32,
    ETH_SIGNATURE_LENGTH: 4,
    ETH_UNITS: ETH_UNITS,
    ETH_BIGNUMBER_ROUNDING_MODE: { ROUNDING_MODE: BigNumber.ROUND_DOWN },
    ETH_POLLING_TIMEOUT: 1000/2,
    defaultBlock: 'latest',
    defaultAccount: undefined
};



/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file iban.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var BigNumber = __webpack_require__(26);

var padLeft = function (string, bytes) {
    var result = string;
    while (result.length < bytes * 2) {
        result = '0' + result;
    }
    return result;
};

/**
 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
 *
 * @method iso13616Prepare
 * @param {String} iban the IBAN
 * @returns {String} the prepared IBAN
 */
var iso13616Prepare = function (iban) {
    var A = 'A'.charCodeAt(0);
    var Z = 'Z'.charCodeAt(0);

    iban = iban.toUpperCase();
    iban = iban.substr(4) + iban.substr(0,4);

    return iban.split('').map(function(n){
        var code = n.charCodeAt(0);
        if (code >= A && code <= Z){
            // A = 10, B = 11, ... Z = 35
            return code - A + 10;
        } else {
            return n;
        }
    }).join('');
};

/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 *
 * @method mod9710
 * @param {String} iban
 * @returns {Number}
 */
var mod9710 = function (iban) {
    var remainder = iban,
        block;

    while (remainder.length > 2){
        block = remainder.slice(0, 9);
        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
};

/**
 * This prototype should be used to create iban object from iban correct string
 *
 * @param {String} iban
 */
var Iban = function (iban) {
    this._iban = iban;
};

/**
 * This method should be used to create iban object from ethereum address
 *
 * @method fromAddress
 * @param {String} address
 * @return {Iban} the IBAN object
 */
Iban.fromAddress = function (address) {
    var asBn = new BigNumber(address, 16);
    var base36 = asBn.toString(36);
    var padded = padLeft(base36, 15);
    return Iban.fromBban(padded.toUpperCase());
};

/**
 * Convert the passed BBAN to an IBAN for this country specification.
 * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
 * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
 *
 * @method fromBban
 * @param {String} bban the BBAN to convert to IBAN
 * @returns {Iban} the IBAN object
 */
Iban.fromBban = function (bban) {
    var countryCode = 'XE';

    var remainder = mod9710(iso13616Prepare(countryCode + '00' + bban));
    var checkDigit = ('0' + (98 - remainder)).slice(-2);

    return new Iban(countryCode + checkDigit + bban);
};

/**
 * Should be used to create IBAN object for given institution and identifier
 *
 * @method createIndirect
 * @param {Object} options, required options are "institution" and "identifier"
 * @return {Iban} the IBAN object
 */
Iban.createIndirect = function (options) {
    return Iban.fromBban('ETH' + options.institution + options.identifier);
};

/**
 * Thos method should be used to check if given string is valid iban object
 *
 * @method isValid
 * @param {String} iban string
 * @return {Boolean} true if it is valid IBAN
 */
Iban.isValid = function (iban) {
    var i = new Iban(iban);
    return i.isValid();
};

/**
 * Should be called to check if iban is correct
 *
 * @method isValid
 * @returns {Boolean} true if it is, otherwise false
 */
Iban.prototype.isValid = function () {
    return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) &&
        mod9710(iso13616Prepare(this._iban)) === 1;
};

/**
 * Should be called to check if iban number is direct
 *
 * @method isDirect
 * @returns {Boolean} true if it is, otherwise false
 */
Iban.prototype.isDirect = function () {
    return this._iban.length === 34 || this._iban.length === 35;
};

/**
 * Should be called to check if iban number if indirect
 *
 * @method isIndirect
 * @returns {Boolean} true if it is, otherwise false
 */
Iban.prototype.isIndirect = function () {
    return this._iban.length === 20;
};

/**
 * Should be called to get iban checksum
 * Uses the mod-97-10 checksumming protocol (ISO/IEC 7064:2003)
 *
 * @method checksum
 * @returns {String} checksum
 */
Iban.prototype.checksum = function () {
    return this._iban.substr(2, 2);
};

/**
 * Should be called to get institution identifier
 * eg. XREG
 *
 * @method institution
 * @returns {String} institution identifier
 */
Iban.prototype.institution = function () {
    return this.isIndirect() ? this._iban.substr(7, 4) : '';
};

/**
 * Should be called to get client identifier within institution
 * eg. GAVOFYORK
 *
 * @method client
 * @returns {String} client identifier
 */
Iban.prototype.client = function () {
    return this.isIndirect() ? this._iban.substr(11) : '';
};

/**
 * Should be called to get client direct address
 *
 * @method address
 * @returns {String} client direct address
 */
Iban.prototype.address = function () {
    if (this.isDirect()) {
        var base36 = this._iban.substr(4);
        var asBn = new BigNumber(base36, 36);
        return padLeft(asBn.toString(16), 20);
    } 

    return '';
};

Iban.prototype.toString = function () {
    return this._iban;
};

module.exports = Iban;



/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file filter.js
 * @authors:
 *   Jeffrey Wilcke <jeff@ethdev.com>
 *   Marek Kotewicz <marek@ethdev.com>
 *   Marian Oancea <marian@ethdev.com>
 *   Fabian Vogelsteller <fabian@ethdev.com>
 *   Gav Wood <g@ethdev.com>
 * @date 2014
 */

var formatters = __webpack_require__(14);
var utils = __webpack_require__(2);

/**
* Converts a given topic to a hex string, but also allows null values.
*
* @param {Mixed} value
* @return {String}
*/
var toTopic = function(value){

    if(value === null || typeof value === 'undefined')
        return null;

    value = String(value);

    if(value.indexOf('0x') === 0)
        return value;
    else
        return utils.fromUtf8(value);
};

/// This method should be called on options object, to verify deprecated properties && lazy load dynamic ones
/// @param should be string or object
/// @returns options string or object
var getOptions = function (options, type) {
    /*jshint maxcomplexity: 6 */

    if (utils.isString(options)) {
        return options;
    }

    options = options || {};


    switch(type) {
        case 'eth':

            // make sure topics, get converted to hex
            options.topics = options.topics || [];
            options.topics = options.topics.map(function(topic){
                return (utils.isArray(topic)) ? topic.map(toTopic) : toTopic(topic);
            });

            return {
                topics: options.topics,
                from: options.from,
                to: options.to,
                address: options.address,
                fromBlock: formatters.inputBlockNumberFormatter(options.fromBlock),
                toBlock: formatters.inputBlockNumberFormatter(options.toBlock)
            };
        case 'shh':
            return options;
    }
};

/**
Adds the callback and sets up the methods, to iterate over the results.

@method getLogsAtStart
@param {Object} self
@param {function} callback
*/
var getLogsAtStart = function(self, callback){
    // call getFilterLogs for the first watch callback start
    if (!utils.isString(self.options)) {
        self.get(function (err, messages) {
            // don't send all the responses to all the watches again... just to self one
            if (err) {
                callback(err);
            }

            if(utils.isArray(messages)) {
                messages.forEach(function (message) {
                    callback(null, message);
                });
            }
        });
    }
};

/**
Adds the callback and sets up the methods, to iterate over the results.

@method pollFilter
@param {Object} self
*/
var pollFilter = function(self) {

    var onMessage = function (error, messages) {
        if (error) {
            return self.callbacks.forEach(function (callback) {
                callback(error);
            });
        }

        if(utils.isArray(messages)) {
            messages.forEach(function (message) {
                message = self.formatter ? self.formatter(message) : message;
                self.callbacks.forEach(function (callback) {
                    callback(null, message);
                });
            });
        }
    };

    self.requestManager.startPolling({
        method: self.implementation.poll.call,
        params: [self.filterId],
    }, self.filterId, onMessage, self.stopWatching.bind(self));

};

var Filter = function (options, type, requestManager, methods, formatter, callback, filterCreationErrorCallback) {
    var self = this;
    var implementation = {};
    methods.forEach(function (method) {
        method.setRequestManager(requestManager);
        method.attachToObject(implementation);
    });
    this.requestManager = requestManager;
    this.options = getOptions(options, type);
    this.implementation = implementation;
    this.filterId = null;
    this.callbacks = [];
    this.getLogsCallbacks = [];
    this.pollFilters = [];
    this.formatter = formatter;
    this.implementation.newFilter(this.options, function(error, id){
        if(error) {
            self.callbacks.forEach(function(cb){
                cb(error);
            });
            if (typeof filterCreationErrorCallback === 'function') {
              filterCreationErrorCallback(error);
            }
        } else {
            self.filterId = id;

            // check if there are get pending callbacks as a consequence
            // of calling get() with filterId unassigned.
            self.getLogsCallbacks.forEach(function (cb){
                self.get(cb);
            });
            self.getLogsCallbacks = [];

            // get filter logs for the already existing watch calls
            self.callbacks.forEach(function(cb){
                getLogsAtStart(self, cb);
            });
            if(self.callbacks.length > 0)
                pollFilter(self);

            // start to watch immediately
            if(typeof callback === 'function') {
                return self.watch(callback);
            }
        }
    });

    return this;
};

Filter.prototype.watch = function (callback) {
    this.callbacks.push(callback);

    if(this.filterId) {
        getLogsAtStart(this, callback);
        pollFilter(this);
    }

    return this;
};

Filter.prototype.stopWatching = function (callback) {
    this.requestManager.stopPolling(this.filterId);
    this.callbacks = [];
    // remove filter async
    if (callback) {
        this.implementation.uninstallFilter(this.filterId, callback);
    } else {
        return this.implementation.uninstallFilter(this.filterId);
    }
};

Filter.prototype.get = function (callback) {
    var self = this;
    if (utils.isFunction(callback)) {
        if (this.filterId === null) {
            // If filterId is not set yet, call it back
            // when newFilter() assigns it.
            this.getLogsCallbacks.push(callback);
        } else {
            this.implementation.getLogs(this.filterId, function(err, res){
                if (err) {
                    callback(err);
                } else {
                    callback(null, res.map(function (log) {
                        return self.formatter ? self.formatter(log) : log;
                    }));
                }
            });
        }
    } else {
        if (this.filterId === null) {
            throw new Error('Filter ID Error: filter().get() can\'t be chained synchronous, please provide a callback for the get() method.');
        }
        var logs = this.implementation.getLogs(this.filterId);
        return logs.map(function (log) {
            return self.formatter ? self.formatter(log) : log;
        });
    }

    return this;
};

module.exports = Filter;



/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file watches.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var Method = __webpack_require__(18);

/// @returns an array of objects describing web3.eth.filter api methods
var eth = function () {
    var newFilterCall = function (args) {
        var type = args[0];

        switch(type) {
            case 'latest':
                args.shift();
                this.params = 0;
                return 'eth_newBlockFilter';
            case 'pending':
                args.shift();
                this.params = 0;
                return 'eth_newPendingTransactionFilter';
            default:
                return 'eth_newFilter';
        }
    };

    var newFilter = new Method({
        name: 'newFilter',
        call: newFilterCall,
        params: 1
    });

    var uninstallFilter = new Method({
        name: 'uninstallFilter',
        call: 'eth_uninstallFilter',
        params: 1
    });

    var getLogs = new Method({
        name: 'getLogs',
        call: 'eth_getFilterLogs',
        params: 1
    });

    var poll = new Method({
        name: 'poll',
        call: 'eth_getFilterChanges',
        params: 1
    });

    return [
        newFilter,
        uninstallFilter,
        getLogs,
        poll
    ];
};

/// @returns an array of objects describing web3.shh.watch api methods
var shh = function () {

    return [
        new Method({
            name: 'newFilter',
            call: 'shh_newMessageFilter',
            params: 1
        }),
        new Method({
            name: 'uninstallFilter',
            call: 'shh_deleteMessageFilter',
            params: 1
        }),
        new Method({
            name: 'getLogs',
            call: 'shh_getFilterMessages',
            params: 1
        }),
        new Method({
            name: 'poll',
            call: 'shh_getFilterMessages',
            params: 1
        })
    ];
};

module.exports = {
    eth: eth,
    shh: shh
};



/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(37);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.YouTube = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    return {
      listType: 'playlist',
      list: playlistId
    };
  }

  return {};
}

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (_ref) {
      var data = _ref.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');

        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist

        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var _config$youtube = config.youtube,
          playerVars = _config$youtube.playerVars,
          embedOptions = _config$youtube.embedOptions;
      var id = url && url.match(MATCH_URL)[1];

      if (isReady) {
        if (MATCH_PLAYLIST.test(url)) {
          this.player.loadPlaylist(parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), {}, playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        }, embedOptions));
      }, _onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports.YouTube = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(YouTube);

exports["default"] = _default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(29);

var _utils = __webpack_require__(5);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (player) {
        _this.player = player;
      }
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady) {
        this.player.stop();
      }

      if (this.player.disablePIP) {
        this.player.disablePIP();
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // Invoke player methods based on changed props
      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer;

      if (!(0, _utils.isEqual)(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", _props.propTypes);

_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SoundCloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, _this2.props.onPause);

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports.SoundCloud = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(SoundCloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(SoundCloud);

exports["default"] = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Vimeo = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, _this2.props.config.vimeo.playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports.Vimeo = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "forceLoad", true);

_defineProperty(Vimeo, "canPlay", function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }

  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Vimeo);

exports["default"] = _default;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DailyMotion = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports.DailyMotion = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(DailyMotion, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(DailyMotion);

exports["default"] = _default;

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(45)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
      return factory( window, EvEmitter );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {

'use strict';

function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( 'ontouchstart' in window ) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
  } else if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file coder.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var f = __webpack_require__(6);

var SolidityTypeAddress = __webpack_require__(221);
var SolidityTypeBool = __webpack_require__(222);
var SolidityTypeInt = __webpack_require__(223);
var SolidityTypeUInt = __webpack_require__(224);
var SolidityTypeDynamicBytes = __webpack_require__(225);
var SolidityTypeString = __webpack_require__(226);
var SolidityTypeReal = __webpack_require__(227);
var SolidityTypeUReal = __webpack_require__(228);
var SolidityTypeBytes = __webpack_require__(229);

var isDynamic = function (solidityType, type) {
   return solidityType.isDynamicType(type) ||
          solidityType.isDynamicArray(type);
};

/**
 * SolidityCoder prototype should be used to encode/decode solidity params of any type
 */
var SolidityCoder = function (types) {
    this._types = types;
};

/**
 * This method should be used to transform type to SolidityType
 *
 * @method _requireType
 * @param {String} type
 * @returns {SolidityType}
 * @throws {Error} throws if no matching type is found
 */
SolidityCoder.prototype._requireType = function (type) {
    var solidityType = this._types.filter(function (t) {
        return t.isType(type);
    })[0];

    if (!solidityType) {
        throw Error('invalid solidity type!: ' + type);
    }

    return solidityType;
};

/**
 * Should be used to encode plain param
 *
 * @method encodeParam
 * @param {String} type
 * @param {Object} plain param
 * @return {String} encoded plain param
 */
SolidityCoder.prototype.encodeParam = function (type, param) {
    return this.encodeParams([type], [param]);
};

/**
 * Should be used to encode list of params
 *
 * @method encodeParams
 * @param {Array} types
 * @param {Array} params
 * @return {String} encoded list of params
 */
SolidityCoder.prototype.encodeParams = function (types, params) {
    var solidityTypes = this.getSolidityTypes(types);

    var encodeds = solidityTypes.map(function (solidityType, index) {
        return solidityType.encode(params[index], types[index]);
    });

    var dynamicOffset = solidityTypes.reduce(function (acc, solidityType, index) {
        var staticPartLength = solidityType.staticPartLength(types[index]);
        var roundedStaticPartLength = Math.floor((staticPartLength + 31) / 32) * 32;

        return acc + (isDynamic(solidityTypes[index], types[index]) ?
            32 :
            roundedStaticPartLength);
    }, 0);

    var result = this.encodeMultiWithOffset(types, solidityTypes, encodeds, dynamicOffset);

    return result;
};

SolidityCoder.prototype.encodeMultiWithOffset = function (types, solidityTypes, encodeds, dynamicOffset) {
    var result = "";
    var self = this;

    types.forEach(function (type, i) {
        if (isDynamic(solidityTypes[i], types[i])) {
            result += f.formatInputInt(dynamicOffset).encode();
            var e = self.encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
            dynamicOffset += e.length / 2;
        } else {
            // don't add length to dynamicOffset. it's already counted
            result += self.encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
        }

        // TODO: figure out nested arrays
    });

    types.forEach(function (type, i) {
        if (isDynamic(solidityTypes[i], types[i])) {
            var e = self.encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
            dynamicOffset += e.length / 2;
            result += e;
        }
    });
    return result;
};

SolidityCoder.prototype.encodeWithOffset = function (type, solidityType, encoded, offset) {
    /* jshint maxcomplexity: 17 */
    /* jshint maxdepth: 5 */

    var self = this;
    var encodingMode={dynamic:1,static:2,other:3};

    var mode=(solidityType.isDynamicArray(type)?encodingMode.dynamic:(solidityType.isStaticArray(type)?encodingMode.static:encodingMode.other));

    if(mode !== encodingMode.other){
        var nestedName = solidityType.nestedName(type);
        var nestedStaticPartLength = solidityType.staticPartLength(nestedName);
        var result = (mode === encodingMode.dynamic ? encoded[0] : '');

        if (solidityType.isDynamicArray(nestedName)) {
            var previousLength = (mode === encodingMode.dynamic ? 2 : 0);

            for (var i = 0; i < encoded.length; i++) {
                // calculate length of previous item
                if(mode === encodingMode.dynamic){
                    previousLength += +(encoded[i - 1])[0] || 0;
                }
                else if(mode === encodingMode.static){
                    previousLength += +(encoded[i - 1] || [])[0] || 0;
                }
                result += f.formatInputInt(offset + i * nestedStaticPartLength + previousLength * 32).encode();
            }
        }

        var len= (mode === encodingMode.dynamic ? encoded.length-1 : encoded.length);
        for (var c = 0; c < len; c++) {
            var additionalOffset = result / 2;
            if(mode === encodingMode.dynamic){
                result += self.encodeWithOffset(nestedName, solidityType, encoded[c + 1], offset +  additionalOffset);
            }
            else if(mode === encodingMode.static){
                result += self.encodeWithOffset(nestedName, solidityType, encoded[c], offset + additionalOffset);
            }
        }

        return result;
    }

    return encoded;
};


/**
 * Should be used to decode bytes to plain param
 *
 * @method decodeParam
 * @param {String} type
 * @param {String} bytes
 * @return {Object} plain param
 */
SolidityCoder.prototype.decodeParam = function (type, bytes) {
    return this.decodeParams([type], bytes)[0];
};

/**
 * Should be used to decode list of params
 *
 * @method decodeParam
 * @param {Array} types
 * @param {String} bytes
 * @return {Array} array of plain params
 */
SolidityCoder.prototype.decodeParams = function (types, bytes) {
    var solidityTypes = this.getSolidityTypes(types);
    var offsets = this.getOffsets(types, solidityTypes);

    return solidityTypes.map(function (solidityType, index) {
        return solidityType.decode(bytes, offsets[index],  types[index], index);
    });
};

SolidityCoder.prototype.getOffsets = function (types, solidityTypes) {
    var lengths =  solidityTypes.map(function (solidityType, index) {
        return solidityType.staticPartLength(types[index]);
    });

    for (var i = 1; i < lengths.length; i++) {
         // sum with length of previous element
        lengths[i] += lengths[i - 1];
    }

    return lengths.map(function (length, index) {
        // remove the current length, so the length is sum of previous elements
        var staticPartLength = solidityTypes[index].staticPartLength(types[index]);
        return length - staticPartLength;
    });
};

SolidityCoder.prototype.getSolidityTypes = function (types) {
    var self = this;
    return types.map(function (type) {
        return self._requireType(type);
    });
};

var coder = new SolidityCoder([
    new SolidityTypeAddress(),
    new SolidityTypeBool(),
    new SolidityTypeInt(),
    new SolidityTypeUInt(),
    new SolidityTypeDynamicBytes(),
    new SolidityTypeBytes(),
    new SolidityTypeString(),
    new SolidityTypeReal(),
    new SolidityTypeUReal()
]);

module.exports = coder;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(87);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(92);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(104);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(105);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(107);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(109);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(111);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(36);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(113);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(117);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(118);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(119);
/* unused harmony reexport withRouter */





























/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(55);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(108)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Facebook = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.facebook.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: _this2.props.config.facebook.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

exports.Facebook = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Facebook, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Facebook);

exports["default"] = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Streamable = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports.Streamable = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Streamable);

exports["default"] = _default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Wistia = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "getID",
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props5 = this.props,
          playing = _this$props5.playing,
          muted = _this$props5.muted,
          controls = _this$props5.controls,
          _onReady = _this$props5.onReady,
          config = _this$props5.config,
          onError = _this$props5.onError;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.getID(url),
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.getID(this.props.url);
      var className = "wistia_embed wistia_async_".concat(id);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports.Wistia = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Wistia, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Wistia);

exports["default"] = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Twitch = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.twitch.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;
      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports.Twitch = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
});

_defineProperty(Twitch, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Twitch);

exports["default"] = _default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Mixcloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_objectSpread({}, config.mixcloud.options, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports.Mixcloud = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Mixcloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Mixcloud);

exports["default"] = _default;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FilePlayer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(5);

var _singlePlayer = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }

        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function supportsWebKitPresentationMode(video) {
  if (!video) video = document.createElement('video'); // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function

  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && !/iPhone|iPod/.test(navigator.userAgent);
}

function canEnablePIP(url) {
  return canPlay(url) && (!!document.pictureInPictureEnabled || supportsWebKitPresentationMode()) && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && supportsWebKitPresentationMode(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners(this.player);

      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer);
        this.addListeners(this.player);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var playsinline = this.props.playsinline;
      player.addEventListener('canplay', this.onReady);
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }

      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config$fi = this.props.config.file,
          hlsVersion = _this$props$config$fi.hlsVersion,
          dashVersion = _this$props$config$fi.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          _this2.hls.loadSource(url);

          _this2.hls.attachMedia(_this2.player);
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);

      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playing = _this$props10.playing,
          loop = _this$props10.loop,
          controls = _this$props10.controls,
          muted = _this$props10.muted,
          config = _this$props10.config,
          width = _this$props10.width,
          height = _this$props10.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.file.attributes), url instanceof Array && url.map(this.renderSourceElement), config.file.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports.FilePlayer = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", canPlay);

_defineProperty(FilePlayer, "canEnablePIP", canEnablePIP);

var _default = (0, _singlePlayer["default"])(FilePlayer);

exports["default"] = _default;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lesserRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Views_Home_HomeZones__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__homePage__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homePageZones__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapPage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locationPage__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companyPage__ = __webpack_require__(188);
// import Page Components
// import Company from '../Views/Company/Company'
// import Page Content
var routes=[{name:'Trust Zone',path:'/',viewComponent:__WEBPACK_IMPORTED_MODULE_2__Views_Home_HomeZones__["a" /* default */],type:'INTERNAL-LOGO',description:'',content:__WEBPACK_IMPORTED_MODULE_5__homePageZones__["a" /* zones */],category:'HOME'},{name:'About',path:'/about',viewComponent:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__["a" /* default */],type:'INTERNAL-NORMAL',description:'',content:__WEBPACK_IMPORTED_MODULE_4__homePage__["a" /* home */],category:'HOME'},{name:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/publicAssets/linkLocation.svg',alt:''}),title:'Location',path:'/location',viewComponent:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__["a" /* default */],selectedColor:'#27AE60',type:'INTERNAL-NORMAL',description:'',content:__WEBPACK_IMPORTED_MODULE_7__locationPage__["a" /* location */],category:'HOME'},{name:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#3083E9'}},'FOAM Map'),title:'Map',path:'/map',viewComponent:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__["a" /* default */],selectedColor:'#3083E9',type:'INTERNAL-NORMAL',description:'',content:__WEBPACK_IMPORTED_MODULE_6__mapPage__["a" /* map */],category:'HOME'},{name:'Company',path:'/company',viewComponent:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__["a" /* default */],selectedColor:'currentColor',type:'INTERNAL-NORMAL',description:'',content:__WEBPACK_IMPORTED_MODULE_8__companyPage__["a" /* company */],category:''},{name:'Community',path:null,children:[{name:'Blog',path:'https://mirror.xyz/foamspace.eth',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'COMMUNITY'},{name:'Farcaster',path:'https://warpcast.com/~/channel/foam',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'COMMUNITY'},{name:'Twitter',path:'https://twitter.com/foamspace',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'COMMUNITY'}],viewComponent:null,type:'TEXT',description:'',content:null,category:''},{name:'Learn',path:null,children:[{name:'Whitepaper',path:'/publicAssets/FOAM_Whitepaper.pdf',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'LOCATION',isWhitepaper:true},{name:'Trust Zone FAQ',path:'https://mirror.xyz/foamspace.eth/9QRjUNdAuw80x9CLvMs76hEp-LVpV92CXVyGmC0H4fU',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'LOCATION',isWhitepaper:false},{name:'Developer',path:'https://developer.foam.space',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'MAP'},{name:'Blog',path:'https://mirror.xyz/foamspace.eth',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'COMMUNITY'},{name:'Farcaster',path:'https://warpcast.com/~/channel/foam',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'COMMUNITY'}],viewComponent:null,type:'TEXT',description:'',content:null,category:'HOME'},{name:'404',path:'*',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'NOMATCH',description:'',content:null,category:'UTIL'}];var lesserRoutes=[{name:'Team',path:'/company',viewComponent:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Home__["a" /* default */],type:'INTERNAL-NORMAL',description:'',content:__WEBPACK_IMPORTED_MODULE_8__companyPage__["a" /* company */],category:'COMPANY'},{name:'Dapp',path:'https://map.foam.space',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'MAP'},{name:'Tools',path:'https://foam.tools/#/',viewComponent:__WEBPACK_IMPORTED_MODULE_3__Views_NoMatch_NoMatch__["a" /* default */],type:'EXTERNAL-NORMAL',description:'',content:null,category:'MAP'},{name:'Technical Paper',path:'https://github.com/f-o-a-m/public-research/blob/master/FOAM%20Techincal%20Whitepaper%20Draft.pdf',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'LOCATION',isWhitepaper:true},{name:'Github',path:'https://github.com/f-o-a-m/',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',content:null,category:'LOCATION'},// {
//   name: 'Blog',
//   path: 'https://blog.foam.space/',
//   viewComponent: NoMatch,
//   type: 'EXTERNAL-NORMAL',
//   description: '',
//   content: null,
//   category: 'COMMUNITY'
// },
{name:'Careers',path:'https://jobs.lever.co/foam',viewComponent:null,type:'EXTERNAL-NORMAL',description:'',contenct:null,category:'COMPANY'// {
//   name: 'LinkedIn',
//   path: 'https://www.linkedin.com/company/10965775/',
//   viewComponent: null,
//   type: 'EXTERNAL-NORMAL',
//   description: '',
//   content: null,
//   category: 'COMPANY'
// },
// {
//   name: 'AngelList',
//   path: 'https://angel.co/foam_protocol/',
//   viewComponent: null,
//   type: 'EXTERNAL-NORMAL',
//   description: '',
//   content: null,
//   category: 'COMPANY'
// },
}];

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SectionWrapper=function(_Component){_inherits(SectionWrapper,_Component);function SectionWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SectionWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SectionWrapper.__proto__||Object.getPrototypeOf(SectionWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.componentDidMount=function(){var options={passive:false// force application to get exact heights at event
};var _this$props=_this.props,index=_this$props.index,referenceKey=_this$props.referenceKey,announceHeight=_this$props.announceHeight;if(_this.node){var _node=_this.node;var callback=function callback(){return announceHeight(referenceKey,index,_node.clientHeight,_node.offsetTop);};window.addEventListener('resize',callback,options);callback();setTimeout(callback,100);}},_this.componentWillUnmount=function(){var announceHeight=_this.props.announceHeight;window.removeEventListener('resize',announceHeight);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SectionWrapper,[{key:'render',value:function render(){var _this2=this;var referenceKey=this.props.referenceKey;var colorStyle=__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'section-shadow':this.props.shadow===true,'section-light':this.props.color==='LIGHT'||this.props.color==='TRANSPARENT','section-dark':this.props.color==='DARK'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'heightWrapper-'+referenceKey,className:'heightWrapper '+colorStyle,ref:function ref(node){return _this2.node=node;}},this.props.child);}}]);return SectionWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SectionWrapper);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(69)(module)))

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/foam-arrow.ec5f8288.svg";

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_HeroMask__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Aside__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Hero=function(_Component){_inherits(Hero,_Component);function Hero(){_classCallCheck(this,Hero);return _possibleConstructorReturn(this,(Hero.__proto__||Object.getPrototypeOf(Hero)).apply(this,arguments));}_createClass(Hero,[{key:'render',value:function render(){var _props=this.props,content=_props.content,openModal=_props.openModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'hero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeroVideo,{video:content.video,openModal:openModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Aside__["a" /* HeroAside */],{content:content.main}));}}]);return Hero;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function HeroVideo(_ref){var video=_ref.video,openModal=_ref.openModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hero-video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,loop:true,playsInline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:video.src,type:'video/mp4',width:window.innerWidth*0.5,height:window.innerHeight}),video.alt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_HeroMask__["a" /* default */],null),video.hidePlayBtn===true?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'playVideo',onClick:function onClick(){return openModal();}}));}/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Options
var deg=45*Math.PI/180;var smoosh=0.66;var br=12;var numTiles=3;var offset=160;var HeroMask=function(_Component){_inherits(HeroMask,_Component);function HeroMask(props){_classCallCheck(this,HeroMask);var _this=_possibleConstructorReturn(this,(HeroMask.__proto__||Object.getPrototypeOf(HeroMask)).call(this,props));_this.resize=function(){var canvas=_this.canvas;// Lookup the size the browser is displaying the canvas.
var displayWidth=canvas.clientWidth;var displayHeight=canvas.clientHeight;// Check if the canvas is not the same size.
if(canvas.width!==displayWidth||canvas.height!==displayHeight){// Make the canvas the same size
canvas.width=displayWidth*_this.scaleFactor;canvas.height=displayHeight*_this.scaleFactor;}};_this.resizeHandler=function(){_this.resize();_this.drawHandler();};_this.backingScale=function(w){if('devicePixelRatio'in w){if(w.devicePixelRatio>1){return w.devicePixelRatio;}}return 1;};_this.easeInOutCubic=function(t){return--t*t*t+1;};_this.drawHandler=function(){requestAnimationFrame(_this.draw);if(_this.iteration<_this.iterationLimit){_this.iteration++;requestAnimationFrame(_this.drawHandler);}};_this.draw=function(){var ctx=_this.ctx;var canvas=_this.canvas;var cw=canvas.width;var ch=canvas.height;var t=_this.iteration/_this.iterationLimit;var size=4000;var i=0;var xFrameRatio=0.5;var yFrameRatio=0.5;var xFrameRatioTablet=0.1;var yFrameRatioTablet=0.75;if(window.innerWidth<1024){xFrameRatio=xFrameRatioTablet;yFrameRatio=yFrameRatioTablet;}var yMidpoint=Math.hypot(size,size)*smoosh*0.5;var windowYMidpoint=ch*yFrameRatio;var xEdgeLeft=-Math.hypot(size,size)*0.5;var windowXMidpoint=cw*xFrameRatio;var x=windowXMidpoint-xEdgeLeft;var y=windowYMidpoint-yMidpoint;// Reset the canvas to defaults for new frames, even from resize events
ctx.clearRect(0,0,cw,ch);ctx.globalCompositeOperation='source-over';// Set up isometric transforms on squares
ctx.translate(x,y);ctx.scale(1,smoosh);ctx.rotate(deg);// Draw tiles
for(i=0;i<numTiles;i++){_this.tileOpacity[i]=1/(i+1)*t;_this.tilePos[i]=Math.floor(_this.easeInOutCubic(t)*i*offset);ctx.fillStyle='rgba(255, 255, 255, '+_this.tileOpacity[i]+')';Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* roundRect */])(ctx,_this.tilePos[i],_this.tilePos[i],size,size,br,true,false);}// Set a globalCompositeOperation that makes a mask
ctx.globalCompositeOperation='source-out';// Reset canvas transform to defaults
ctx.setTransform(1,0,0,1,0,0);ctx.fillStyle='rgba(255, 255, 255, 1)';ctx.fillRect(0,0,cw,ch);};_this.ctx=null;_this.canvas=null;_this.scaleFactor=1;_this.iteration=0;_this.animate=true;_this.iterationLimit=100;_this.tilePos=[];_this.tileOpacity=[];return _this;}_createClass(HeroMask,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// Set up canvas
this.canvas=this.heroMask;var canvas=this.canvas;this.ctx=canvas.getContext('2d');// Rescale canvas for high resolution displays
this.scaleFactor=this.backingScale(window);if(this.scaleFactor>1){canvas.width=canvas.width*this.scaleFactor;canvas.height=canvas.height*this.scaleFactor;this.ctx=canvas.getContext('2d');}// set listener, this produces re-draws
this.resizeHandler();window.addEventListener('resize',function(){return _this2.resizeHandler();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.drawHandler);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'hero-mask',ref:function ref(heroMask){return _this3.heroMask=heroMask;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hero-mask-fallback'}));}}]);return HeroMask;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HeroMask);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Partners(_ref){var content=_ref.content;var partners=content.partnerTiles.filter(function(org){return org.type==='PARTNER';});var support=content.partnerTiles.filter(function(org){return org.type==='SUPPORT';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'partners'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quasi-iso-mask-top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'midHeading midHeading--partners'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Supported By')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileGrid,{partners:support}),partners.length===0?null:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'midHeading midHeading--partners'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileGrid,{partners:partners})]);}function TileGrid(_ref2){var partners=_ref2.partners;var tiles=partners.map(function(partner,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tile,{key:'partner-'+i,partner:partner});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-list'},tiles);}function Tile(_ref3){var partner=_ref3.partner;if(partner.filler){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-column-container--wrap'});}else{var img=partner.img;if(partner.href){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-column-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:partner.href,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:img.src,alt:img.alt,width:img.width,height:img.height,style:img.style})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'level-column-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:img.src,alt:img.alt}));}}}/* harmony default export */ __webpack_exports__["a"] = (Partners);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return partnerTiles; });
var partnerTiles=[{h:'New Lab',href:'https://newlab.com/',img:{src:'/publicAssets/partners/newlab.svg',width:'200px',alt:'New Lab'},type:'SUPPORT'},//  {
//    h: 'Perkins Coie',
//    href: 'https://perkinscoie.com/',
//    img: {
//      src: '/publicAssets/partners/perkinscoie.png',
//      width: '200px',
//      alt: 'Perkins Coie'
//      // style: { paddingTop: '25px' }
//    },
//    type: 'SUPPORT'
//  },
{h:'Tendermint',href:'https://tendermint.com',img:{src:'/publicAssets/partners/tendermint.png',width:'200px',alt:'Navel'},type:'SUPPORT'},{h:'Navel',href:'http://navel.la',img:{src:'/publicAssets/partners/navel_scribble.png',width:'200px',alt:'Navel'},type:'SUPPORT'}];

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function FeatureArtwork(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'featureArtwork',className:'FeatureArtwork'},content.main.map(function(content,_idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureArtworkItem,{key:'FeatureArtworkItem-'+_idx,content:content});}));}function FeatureArtworkItem(_ref2){var content=_ref2.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContent'},content.img,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p)));}/* harmony default export */ __webpack_exports__["a"] = (FeatureArtwork);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file jsonrpc.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 *   Aaron Kumavis <aaron@kumavis.me>
 * @date 2015
 */

// Initialize Jsonrpc as a simple object with utility functions.
var Jsonrpc = {
    messageId: 0
};

/**
 * Should be called to valid json create payload object
 *
 * @method toPayload
 * @param {Function} method of jsonrpc call, required
 * @param {Array} params, an array of method params, optional
 * @returns {Object} valid jsonrpc payload object
 */
Jsonrpc.toPayload = function (method, params) {
    if (!method)
        console.error('jsonrpc method should be specified!');

    // advance message ID
    Jsonrpc.messageId++;

    return {
        jsonrpc: '2.0',
        id: Jsonrpc.messageId,
        method: method,
        params: params || []
    };
};

/**
 * Should be called to check if jsonrpc response is valid
 *
 * @method isValidResponse
 * @param {Object}
 * @returns {Boolean} true if response is valid, otherwise false
 */
Jsonrpc.isValidResponse = function (response) {
    return Array.isArray(response) ? response.every(validateSingleMessage) : validateSingleMessage(response);

    function validateSingleMessage(message){
      return !!message &&
        !message.error &&
        message.jsonrpc === '2.0' &&
        typeof message.id === 'number' &&
        message.result !== undefined; // only undefined is not valid json object
    }
};

/**
 * Should be called to create batch payload object
 *
 * @method toBatchPayload
 * @param {Array} messages, an array of objects with method (required) and params (optional) fields
 * @returns {Array} batch payload
 */
Jsonrpc.toBatchPayload = function (messages) {
    return messages.map(function (message) {
        return Jsonrpc.toPayload(message.method, message.params);
    });
};

module.exports = Jsonrpc;



/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(31));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(31));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file param.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var utils = __webpack_require__(2);

/**
 * SolidityParam object prototype.
 * Should be used when encoding, decoding solidity bytes
 */
var SolidityParam = function (value, offset) {
    this.value = value || '';
    this.offset = offset; // offset in bytes
};

/**
 * This method should be used to get length of params's dynamic part
 * 
 * @method dynamicPartLength
 * @returns {Number} length of dynamic part (in bytes)
 */
SolidityParam.prototype.dynamicPartLength = function () {
    return this.dynamicPart().length / 2;
};

/**
 * This method should be used to create copy of solidity param with different offset
 *
 * @method withOffset
 * @param {Number} offset length in bytes
 * @returns {SolidityParam} new solidity param with applied offset
 */
SolidityParam.prototype.withOffset = function (offset) {
    return new SolidityParam(this.value, offset);
};

/**
 * This method should be used to combine solidity params together
 * eg. when appending an array
 *
 * @method combine
 * @param {SolidityParam} param with which we should combine
 * @param {SolidityParam} result of combination
 */
SolidityParam.prototype.combine = function (param) {
    return new SolidityParam(this.value + param.value); 
};

/**
 * This method should be called to check if param has dynamic size.
 * If it has, it returns true, otherwise false
 *
 * @method isDynamic
 * @returns {Boolean}
 */
SolidityParam.prototype.isDynamic = function () {
    return this.offset !== undefined;
};

/**
 * This method should be called to transform offset to bytes
 *
 * @method offsetAsBytes
 * @returns {String} bytes representation of offset
 */
SolidityParam.prototype.offsetAsBytes = function () {
    return !this.isDynamic() ? '' : utils.padLeft(utils.toTwosComplement(this.offset).toString(16), 64);
};

/**
 * This method should be called to get static part of param
 *
 * @method staticPart
 * @returns {String} offset if it is a dynamic param, otherwise value
 */
SolidityParam.prototype.staticPart = function () {
    if (!this.isDynamic()) {
        return this.value; 
    } 
    return this.offsetAsBytes();
};

/**
 * This method should be called to get dynamic part of param
 *
 * @method dynamicPart
 * @returns {String} returns a value if it is a dynamic param, otherwise empty string
 */
SolidityParam.prototype.dynamicPart = function () {
    return this.isDynamic() ? this.value : '';
};

/**
 * This method should be called to encode param
 *
 * @method encode
 * @returns {String}
 */
SolidityParam.prototype.encode = function () {
    return this.staticPart() + this.dynamicPart();
};

/**
 * This method should be called to encode array of params
 *
 * @method encodeList
 * @param {Array[SolidityParam]} params
 * @returns {String}
 */
SolidityParam.encodeList = function (params) {
    
    // updating offsets
    var totalOffset = params.length * 32;
    var offsetParams = params.map(function (param) {
        if (!param.isDynamic()) {
            return param;
        }
        var offset = totalOffset;
        totalOffset += param.dynamicPartLength();
        return param.withOffset(offset);
    });

    // encode everything!
    return offsetParams.reduce(function (result, param) {
        return result + param.dynamicPart();
    }, offsetParams.reduce(function (result, param) {
        return result + param.staticPart();
    }, ''));
};



module.exports = SolidityParam;



/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file event.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2014
 */

var utils = __webpack_require__(2);
var coder = __webpack_require__(49);
var formatters = __webpack_require__(14);
var sha3 = __webpack_require__(27);
var Filter = __webpack_require__(34);
var watches = __webpack_require__(35);

/**
 * This prototype should be used to create event filters
 */
var SolidityEvent = function (requestManager, json, address) {
    this._requestManager = requestManager;
    this._params = json.inputs;
    this._name = utils.transformToFullName(json);
    this._address = address;
    this._anonymous = json.anonymous;
};

/**
 * Should be used to get filtered param types
 *
 * @method types
 * @param {Bool} decide if returned typed should be indexed
 * @return {Array} array of types
 */
SolidityEvent.prototype.types = function (indexed) {
    return this._params.filter(function (i) {
        return i.indexed === indexed;
    }).map(function (i) {
        return i.type;
    });
};

/**
 * Should be used to get event display name
 *
 * @method displayName
 * @return {String} event display name
 */
SolidityEvent.prototype.displayName = function () {
    return utils.extractDisplayName(this._name);
};

/**
 * Should be used to get event type name
 *
 * @method typeName
 * @return {String} event type name
 */
SolidityEvent.prototype.typeName = function () {
    return utils.extractTypeName(this._name);
};

/**
 * Should be used to get event signature
 *
 * @method signature
 * @return {String} event signature
 */
SolidityEvent.prototype.signature = function () {
    return sha3(this._name);
};

/**
 * Should be used to encode indexed params and options to one final object
 *
 * @method encode
 * @param {Object} indexed
 * @param {Object} options
 * @return {Object} everything combined together and encoded
 */
SolidityEvent.prototype.encode = function (indexed, options) {
    indexed = indexed || {};
    options = options || {};
    var result = {};

    ['fromBlock', 'toBlock'].filter(function (f) {
        return options[f] !== undefined;
    }).forEach(function (f) {
        result[f] = formatters.inputBlockNumberFormatter(options[f]);
    });

    result.topics = [];

    result.address = this._address;
    if (!this._anonymous) {
        result.topics.push('0x' + this.signature());
    }

    var indexedTopics = this._params.filter(function (i) {
        return i.indexed === true;
    }).map(function (i) {
        var value = indexed[i.name];
        if (value === undefined || value === null) {
            return null;
        }

        if (utils.isArray(value)) {
            return value.map(function (v) {
                return '0x' + coder.encodeParam(i.type, v);
            });
        }
        return '0x' + coder.encodeParam(i.type, value);
    });

    result.topics = result.topics.concat(indexedTopics);

    return result;
};

/**
 * Should be used to decode indexed params and options
 *
 * @method decode
 * @param {Object} data
 * @return {Object} result object with decoded indexed && not indexed params
 */
SolidityEvent.prototype.decode = function (data) {

    data.data = data.data || '';
    data.topics = data.topics || [];


    var argTopics = this._anonymous ? data.topics : data.topics.slice(1);
    var indexedData = argTopics.map(function (topics) { return topics.slice(2); }).join("");
    var indexedParams = coder.decodeParams(this.types(true), indexedData);

    var notIndexedData = data.data.slice(2);
    var notIndexedParams = coder.decodeParams(this.types(false), notIndexedData);

    var result = formatters.outputLogFormatter(data);
    result.event = this.displayName();
    result.address = data.address;

    result.args = this._params.reduce(function (acc, current) {
        acc[current.name] = current.indexed ? indexedParams.shift() : notIndexedParams.shift();
        return acc;
    }, {});

    delete result.data;
    delete result.topics;

    return result;
};

/**
 * Should be used to create new filter object from event
 *
 * @method execute
 * @param {Object} indexed
 * @param {Object} options
 * @return {Object} filter object
 */
SolidityEvent.prototype.execute = function (indexed, options, callback) {

    if (utils.isFunction(arguments[arguments.length - 1])) {
        callback = arguments[arguments.length - 1];
        if(arguments.length === 2)
            options = null;
        if(arguments.length === 1) {
            options = null;
            indexed = {};
        }
    }

    var o = this.encode(indexed, options);
    var formatter = this.decode.bind(this);
    return new Filter(o, 'eth', this._requestManager, watches.eth(), formatter, callback);
};

/**
 * Should be used to attach event to contract object
 *
 * @method attachToContract
 * @param {Contract}
 */
SolidityEvent.prototype.attachToContract = function (contract) {
    var execute = this.execute.bind(this);
    var displayName = this.displayName();
    if (!contract[displayName]) {
        contract[displayName] = execute;
    }
    contract[displayName][this.typeName()] = this.execute.bind(this, contract);
};

module.exports = SolidityEvent;



/***/ }),
/* 83 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85);
module.exports = __webpack_require__(90);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(86).enable();
  window.Promise = __webpack_require__(88);
}

// fetch() polyfill for making API calls.
__webpack_require__(89);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(28);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(50);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(50);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_web3__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_web3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_web3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_index_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_index_css__);
var web3=new __WEBPACK_IMPORTED_MODULE_3_web3___default.a(new __WEBPACK_IMPORTED_MODULE_3_web3___default.a.providers.HttpProvider('https://mainnet.infura.io/'));web3.eth=__WEBPACK_IMPORTED_MODULE_4_bluebird___default.a.promisifyAll(web3.eth);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Main__["a" /* default */],{web3:web3}),document.getElementById('root'));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(28),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(28),r=__webpack_require__(93);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(94);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_player__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Header__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__content_routes__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var routeWrapper=function routeWrapper(r,globalProps){var View=r.viewComponent;var path=r.path;var content=r.content;var WrappedRoute=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:path,key:path,render:function render(props){var extraRouteProps=r.props||{};var routeProps=Object.assign({},Object.assign({},props),Object.assign({},globalProps),Object.assign({},extraRouteProps));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RouteWrapper,Object.assign({key:path,content:content,View:View},routeProps));}});var WrappedRouteHome=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:'/',key:path,render:function render(props){var routeProps=Object.assign({},Object.assign({},props),Object.assign({},globalProps));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RouteWrapper,Object.assign({key:path,content:content,View:View},routeProps));}});var ret=r.path==='/'?WrappedRouteHome:WrappedRoute;// console.log(ret);
return ret;};var Main=function(_Component){_inherits(Main,_Component);function Main(props){_classCallCheck(this,Main);var _this=_possibleConstructorReturn(this,(Main.__proto__||Object.getPrototypeOf(Main)).call(this,props));_this.setCurrentRoute=function(path){var currentRoute=__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */].find(function(r){return r.path===path;});// if no match, currentRoute = 404 page, which is the last route in the routes array
currentRoute=!currentRoute?__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */][__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */].length-1]:currentRoute;_this.setState({currentRoute:currentRoute});};_this.closeMobileTray=function(){_this.setState({mobileTrayOpen:false});};_this.componentWillMount=function(){var GAKey=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_GA_ANALYTICS_KEY":"UA-111781922-1","REACT_APP_MAPBOX_TOKEN":"pk.eyJ1Ijoia2VqYWNlIiwiYSI6ImNqZ2NlZ3ZrdzNmMGIzMnFkdXh2dGIzY3QifQ.1Ytkor_lU5hORL0jK9KpOw"}).node_env==='development'?'deadbeef':"UA-111781922-1";__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].initialize(GAKey);window.addEventListener('keydown',function(e){return _this.handleKeyDown(e);});};_this.wrapRoutes=function(routes,globalProps){return routes.reduce(function(acc,r){var res=[];if(r.path!=null){res=res.concat([routeWrapper(r,globalProps)]);}if(r.children!=null){res=res.concat(r.children.map(function(r_){return routeWrapper(r_,globalProps);}));}return acc.concat(res);},[]);};_this.updateHeaderStyle=function(y,sections){var hh=__WEBPACK_IMPORTED_MODULE_9__helpers__["c" /* hh */]+12;// header height
var currentSection=sections.filter(function(section){return section.fromTop<=y+hh&&section.fromTop+section.height>y+hh;});if(currentSection[0]){var headerColor=currentSection[0].color;if(_this.state.headerColor!==headerColor){_this.setState({headerColor:headerColor});}}};_this.toggleMobileTray=function(){_this.setState({mobileTrayOpen:!_this.state.mobileTrayOpen});};_this.handleToggleModal=function(){_this.state.isModalOpen?_this.closeModal():_this.openModal();};_this.handleToggleTokenModal=function(){_this.state.isTokenModalOpen?_this.closeTokenModal():_this.openTokenModal();};_this.openModal=function(){_this.setState({isModalOpen:true});};_this.closeModal=function(){_this.setState({isModalOpen:false});};_this.openTokenModal=function(){_this.setState({isTokenModalOpen:true});};_this.closeTokenModal=function(){_this.setState({isTokenModalOpen:false});};_this.handleKeyDown=function(e){if(e.keyCode===27){_this.closeModal();_this.closeTokenModal();}};_this.state={currentRoute:__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */][0],headerColor:'LIGHT',mobileTrayOpen:false,isModalOpen:false,isTokenModalOpen:false};return _this;}_createClass(Main,[{key:'render',value:function render(){var _this2=this;var _state=this.state,currentRoute=_state.currentRoute,isModalOpen=_state.isModalOpen,isTokenModalOpen=_state.isTokenModalOpen;var globalProps={closeMobileTray:this.closeMobileTray,setCurrentRoute:this.setCurrentRoute,currentRoute:currentRoute,updateHeaderStyle:this.updateHeaderStyle,handleToggleModal:this.handleToggleModal,openModal:this.openModal,closeModal:this.closeModal,isModalOpen:isModalOpen,openTokenModal:this.openTokenModal,closeTokenModal:this.closeTokenModal,isTokenModalOpen:isTokenModalOpen,web3:this.props.web3};var pageTitle=currentRoute.name==='Home'?'FOAM • The Future of Proof of Location':'FOAM \u2022\xA0'+(currentRoute.title||currentRoute.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main-root'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Header__["a" /* default */],{headerColor:this.state.headerColor,routes:__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */],lesserRoutes:__WEBPACK_IMPORTED_MODULE_8__content_routes__["a" /* lesserRoutes */],currentRoute:currentRoute,mobileTrayOpen:this.state.mobileTrayOpen,toggleMobileTray:function toggleMobileTray(){return _this2.toggleMobileTray();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,pageTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:currentRoute.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,this.wrapRoutes(__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */],globalProps)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer__["a" /* default */],{lesserRoutes:__WEBPACK_IMPORTED_MODULE_8__content_routes__["a" /* lesserRoutes */],routes:__WEBPACK_IMPORTED_MODULE_8__content_routes__["b" /* routes */],currentRoute:currentRoute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal,{heroVideo:'https://youtu.be/EJeMVh4tm1w',isShowing:isModalOpen,closeModal:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal,{heroVideo:'https://youtu.be/LKb0y8z9TJg',isShowing:isTokenModalOpen,closeModal:this.closeTokenModal})));}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RouteWrapper=function(_Component2){_inherits(RouteWrapper,_Component2);function RouteWrapper(){_classCallCheck(this,RouteWrapper);return _possibleConstructorReturn(this,(RouteWrapper.__proto__||Object.getPrototypeOf(RouteWrapper)).apply(this,arguments));}_createClass(RouteWrapper,[{key:'componentWillMount',value:function componentWillMount(){__WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].pageview(window.location.pathname+window.location.search);this.props.setCurrentRoute(this.props.location.pathname);this.props.closeMobileTray();}},{key:'render',value:function render(){var View=this.props.View;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,this.props);}}]);return RouteWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function Modal(_ref){var heroVideo=_ref.heroVideo,isShowing=_ref.isShowing,closeModal=_ref.closeModal;var isShowingClasses=__WEBPACK_IMPORTED_MODULE_3_classnames___default()({hideModal:!isShowing,showModal:isShowing,videoModal:true});var config={youtube:{playerVars:{playsinline:0}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:isShowingClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return closeModal();}},'×'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_player___default.a,{playing:isShowing,controls:false,url:heroVideo,style:{width:'100vw',height:'100vh'},config:config}));}/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(36);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(98);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(36);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(106);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(37);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(110);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(112);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(57);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(114);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(37);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(116);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(38);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(57);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(38);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(120);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FilePlayer", {
  enumerable: true,
  get: function get() {
    return _FilePlayer["default"];
  }
});
Object.defineProperty(exports, "YouTube", {
  enumerable: true,
  get: function get() {
    return _YouTube["default"];
  }
});
Object.defineProperty(exports, "SoundCloud", {
  enumerable: true,
  get: function get() {
    return _SoundCloud["default"];
  }
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _Vimeo["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "Streamable", {
  enumerable: true,
  get: function get() {
    return _Streamable["default"];
  }
});
Object.defineProperty(exports, "Wistia", {
  enumerable: true,
  get: function get() {
    return _Wistia["default"];
  }
});
Object.defineProperty(exports, "Twitch", {
  enumerable: true,
  get: function get() {
    return _Twitch["default"];
  }
});
Object.defineProperty(exports, "DailyMotion", {
  enumerable: true,
  get: function get() {
    return _DailyMotion["default"];
  }
});
Object.defineProperty(exports, "Mixcloud", {
  enumerable: true,
  get: function get() {
    return _Mixcloud["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(29);

var _utils = __webpack_require__(5);

var _players = _interopRequireDefault(__webpack_require__(125));

var _Player4 = _interopRequireDefault(__webpack_require__(40));

var _Preview = _interopRequireDefault(__webpack_require__(126));

var _FilePlayer = _interopRequireWildcard(__webpack_require__(63));

var _preload = _interopRequireDefault(__webpack_require__(127));

var _YouTube = _interopRequireDefault(__webpack_require__(39));

var _SoundCloud = _interopRequireDefault(__webpack_require__(41));

var _Vimeo = _interopRequireDefault(__webpack_require__(42));

var _Facebook = _interopRequireDefault(__webpack_require__(58));

var _Streamable = _interopRequireDefault(__webpack_require__(59));

var _Wistia = _interopRequireDefault(__webpack_require__(60));

var _Twitch = _interopRequireDefault(__webpack_require__(61));

var _DailyMotion = _interopRequireDefault(__webpack_require__(43));

var _Mixcloud = _interopRequireDefault(__webpack_require__(62));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);
var customPlayers = [];

var ReactPlayer = /*#__PURE__*/function (_Component) {
  _inherits(ReactPlayer, _Component);

  var _super = _createSuper(ReactPlayer);

  function ReactPlayer() {
    var _this;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPreview: !!_this.props.light
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function () {
      _this.setState({
        showPreview: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
      _this.setState({
        showPreview: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    });

    _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    });

    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
      if (!_this.player) return null;

      _this.player.seekTo(fraction, type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      _this.props.onReady(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
      _this.wrapper = wrapper;
    });

    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
      _this.player = player;
    });

    return _this;
  }

  _createClass(ReactPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var light = this.props.light;
      this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);

      if (!prevProps.light && light) {
        this.setState({
          showPreview: true
        });
      }

      if (prevProps.light && !light) {
        this.setState({
          showPreview: false
        });
      }
    }
  }, {
    key: "getActivePlayer",
    value: function getActivePlayer(url) {
      for (var _i = 0, _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i < _arr.length; _i++) {
        var _Player = _arr[_i];

        if (_Player.canPlay(url)) {
          return _Player;
        }
      } // Fall back to FilePlayer if nothing else can play the URL


      return _FilePlayer.FilePlayer;
    }
  }, {
    key: "renderActivePlayer",
    value: function renderActivePlayer(url, activePlayer) {
      if (!url) return null;
      return /*#__PURE__*/_react["default"].createElement(_Player4["default"], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.handleReady
      }));
    }
  }, {
    key: "sortPlayers",
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          controls = _this$props.controls,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height,
          light = _this$props.light,
          playIcon = _this$props.playIcon,
          Wrapper = _this$props.wrapper;
      var showPreview = this.state.showPreview && url;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.getActivePlayer(url);
      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
      var preloadPlayers = (0, _preload["default"])(url, controls, this.config);
      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);

      var preview = /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
        url: url,
        light: light,
        playIcon: playIcon,
        onClick: this.handleClickPreview
      });

      return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
        ref: this.wrapperRef,
        style: _objectSpread({}, style, {
          width: width,
          height: height
        })
      }, otherProps), showPreview ? preview : players);
    }
  }]);

  return ReactPlayer;
}(_react.Component);

exports["default"] = ReactPlayer;

_defineProperty(ReactPlayer, "addCustomPlayer", function (player) {
  customPlayers.push(player);
});

_defineProperty(ReactPlayer, "removeCustomPlayers", function () {
  customPlayers = [];
});

_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');

_defineProperty(ReactPlayer, "propTypes", _props.propTypes);

_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);

_defineProperty(ReactPlayer, "canPlay", function (url) {
  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];

    if (_Player2.canPlay(url)) {
      return true;
    }
  }

  return false;
});

_defineProperty(ReactPlayer, "canEnablePIP", function (url) {
  for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];

    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }

  return false;
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _YouTube = __webpack_require__(39);

var _SoundCloud = __webpack_require__(41);

var _Vimeo = __webpack_require__(42);

var _Facebook = __webpack_require__(58);

var _Streamable = __webpack_require__(59);

var _Wistia = __webpack_require__(60);

var _Twitch = __webpack_require__(61);

var _DailyMotion = __webpack_require__(43);

var _Mixcloud = __webpack_require__(62);

var _FilePlayer = __webpack_require__(63);

var _default = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];
exports["default"] = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderPreloadPlayers;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Player = _interopRequireDefault(__webpack_require__(40));

var _YouTube = __webpack_require__(39);

var _SoundCloud = __webpack_require__(41);

var _Vimeo = __webpack_require__(42);

var _DailyMotion = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, controls, config) {
  var players = [];

  var _iterator = _createForOfIteratorHelper(PRELOAD_PLAYERS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push( /*#__PURE__*/_react["default"].createElement(_Player["default"], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          controls: controls,
          playing: true,
          muted: true,
          display: "none"
        }));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return players;
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(129);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(131);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(132);

var _HelmetConstants = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(130));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(28);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(44);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(141);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(44);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(65);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_light_png__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logo_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_logo_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_logo_dark_png__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_logo_dark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_logo_dark_png__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.componentWillMount=function(){window.addEventListener('resize',_this.onResize);};_this.componentWillUnmount=function(){window.removeEventListener('resize',_this.onResize);};_this.onResize=function(){_this.setState({windowWidth:window.innerWidth});};_this.render=function(){var _this$props=_this.props,routes=_this$props.routes,lesserRoutes=_this$props.lesserRoutes,headerColor=_this$props.headerColor,toggleMobileTray=_this$props.toggleMobileTray,currentRoute=_this$props.currentRoute,mobileTrayOpen=_this$props.mobileTrayOpen;var headerClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'header-dark':headerColor==='DARK','header-light':headerColor==='LIGHT','header-transparent':headerColor==='TRANSPARENT'});var logoPath=headerColor==='DARK'?__WEBPACK_IMPORTED_MODULE_4__assets_logo_dark_png___default.a:__WEBPACK_IMPORTED_MODULE_3__assets_logo_light_png___default.a;var hamburgerPath=__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'/publicAssets/hamburger-light.svg':headerColor==='LIGHT'||headerColor==='TRANSPARENT','/publicAssets/hamburger-dark.svg':headerColor==='DARK'});if(_this.state.windowWidth<960){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileHeader,{headerClasses:headerClasses,logoPath:logoPath,hamburgerPath:hamburgerPath,routes:routes,handleBannerClose:function handleBannerClose(){return _this.setState({bannerIsOpen:false});},bannerIsOpen:_this.state.bannerIsOpen,lesserRoutes:lesserRoutes,toggleMobileTray:toggleMobileTray,mobileTrayOpen:mobileTrayOpen});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullHeader,{headerClasses:headerClasses,logoPath:logoPath,hamburgerPath:hamburgerPath,handleBannerClose:function handleBannerClose(){return _this.setState({bannerIsOpen:false});},bannerIsOpen:_this.state.bannerIsOpen,currentRoute:currentRoute,routes:routes});};_this.state={bannerIsOpen:false,windowWidth:window.innerWidth};return _this;}return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function MobileHeader(_ref){var headerClasses=_ref.headerClasses,lesserRoutes=_ref.lesserRoutes,logoPath=_ref.logoPath,routes=_ref.routes,hamburgerPath=_ref.hamburgerPath,handleBannerClose=_ref.handleBannerClose,bannerIsOpen=_ref.bannerIsOpen,toggleMobileTray=_ref.toggleMobileTray,mobileTrayOpen=_ref.mobileTrayOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:headerClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Links__["b" /* Logo */],{logo:logoPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Hamburger,{hamburgerPath:hamburgerPath,toggleMobileTray:toggleMobileTray}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileTray,{routes:routes,lesserRoutes:lesserRoutes,open:mobileTrayOpen})),bannerIsOpen&&!mobileTrayOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Banner,{handleClose:handleBannerClose})));}function FullHeader(_ref2){var headerClasses=_ref2.headerClasses,bannerIsOpen=_ref2.bannerIsOpen,handleBannerClose=_ref2.handleBannerClose,currentRoute=_ref2.currentRoute,logoPath=_ref2.logoPath,routes=_ref2.routes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:headerClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Links__["b" /* Logo */],{logo:logoPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header-aside'},Object(__WEBPACK_IMPORTED_MODULE_2__Links__["e" /* parseLinksHeader */])(routes,currentRoute))),bannerIsOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Banner,{handleClose:handleBannerClose})));}function Hamburger(_ref3){var hamburgerPath=_ref3.hamburgerPath,toggleMobileTray=_ref3.toggleMobileTray;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'hamburger',onClick:toggleMobileTray},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'hamburger-svg',src:hamburgerPath,alt:'Menu'}));}function MobileTray(_ref4){var open=_ref4.open,routes=_ref4.routes,lesserRoutes=_ref4.lesserRoutes;var transform=open?'mobileTray-open':'mobileTray-closed';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mobileTray',className:transform},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mobileTray-mainLinks'},Object(__WEBPACK_IMPORTED_MODULE_2__Links__["e" /* parseLinksHeader */])(routes)));}function Banner(_ref5){var handleClose=_ref5.handleClose;return;// return (
//   <section id={'banner'}>
//     Meet FOAM team at{' '}
//     <a href="https://blog.foam.space/foam-at-ethnewyork-7e8a5db85605">
//       ETH New York
//     </a>{' '}
//     @New Lab
//     <button onClick={handleClose}>{'×'}</button>
//   </section>
// )
}/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARoAAABYCAYAAAAqVDhpAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAACHWSURBVHgB7V0JmFTVlT73VVV30w3dRbOJCBQNGlGZoHGJOiowxvkIOKMxycxkXNAhBh2jMY7JJHFpotH4aRTiGtQRktHPCYoQ9TP5TLTdwiR+GTVqNJGlQKOsva9V770759zlLVWvmga6qrf7a1FVr+ot/areX//5zzn3AhgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYDBhuv+CCKjAwMBgRYFBi3HLZ0tNcsJbjrs/AnT9kgXXbd+6/fwsYGBgMW5SMaG5Z9m+nOmDVM8bO5GLHtGtO91nO4FHbZcvrH3ggDQYGBsMORSeam7/2tdNdcG5AglkA+I+/Y49o8F+kHnyJc74GmHvb9fc99B4YGBgMGxSNaG657LLTHHCuQ/aYj7tJgCITuhM7VnuW6kYdivy/Bxh/Mpvhy+sffPAvYGBgMOQRgyLgO0sv+Z+YBXdYjM0U+yBWYVLDiH+YUjS0TL2mgQ/jqHPmYDj19aPqZna9/u67r4GBgcGQRhyKgJae7Jz27gxUJWJQVV6e97omHBk86ScyjHK5C7ubW2FnUzN0d2dmg4GBwZBHUYiG4Lgu7G1uh0bbhrHV1TC6erRHKjpc4iqMIpKhJ0Quu/DWk82K10qeEjMwMCgKikY00ugFcJFo9uzcCW2NjVAzrhZGjRnt28D4wHU5NLe0wa5GVDDZDBnCSuZw8AwdAwODIY2iEI02dy3KJCkPxnFsaN69G1qbmqAqmYQx1WNgT0srqp5WyAoFo4hJkww3JGNgMFzQV6JhN1xyyTwrxr7juPC7WLlzb/19q3f0vookCkt5vZZYxCGTyUDrJztgyyc7kYQsiDH5HkEsglxcFVbxfeoZfA+7ZdmyBS5ltlz34esfemgrGBgYDDrs0wa5funS0zCDdBNe1GfINUipwB7kgVW7mlpuvW/t2vbcda688II/ObYzm/d0g9vdBS4qFmI05BWwXYDOrA0dnBjGgrgiIo5ShsjFoaoa1yOZ1etfeuniqOO6+bJLv4REdS2ueoIitW7c4KO27Xy/ftWq7WBgYDBoUIho2HdRwcRi1nUY/CwQC5j/dotJfwWv7z2YJbo9MYqt+d7Kh3bqla9AomGOM9tBknG6u4HZWbAoNMKVbCSRDvRt2h18IzJYQqe9cWOuIBi851yGUJyv3vDKKx7R/HjhwvKWGdMW4cPv4+3o3IOXqwg8xHvsH9Y/8ohpbTAwGATII5obly79rAvuTcgK8/DFuFAbqtZOpouYCHfIe2Hecv6hw+GB7vbO+3/42GNNRDRoyswmNWN3EdFkRMEOrU5EQ4qmHZUNi8UgYYEfKqmbo8MmDoJo6uvrLWvnx/+MRHUlvvck7eUwFq4u5qA9HhGqteHGHmMx59br7n14GxgYGAwYPKKpv/zyua7dc7Pr8EWWJS9cWVvHQm8XfotXYCdVipelZqyVQ+zGXR1t13LbOdRVigZQ0aBcEVvKIhN02Q4SDRdEQ0ym/RuqoZFkgY+ByIKt/swxszfi69cgsR3BVF48THzK2lF1OQ7noWMWfweHe9yKzPX1K1Y3g4GBQcnhmcGfTk2+pKOze9GHu/dCV0/GL6ZjXHUPqCXeRc38LLQKd1o6Oqs/2tt8V21tEhWMDH+IPMB1gLngVehp5YJmDL6uu57898sQCCi0uvDjPU1LJtSMgbJEHDSFsJAOU2FcwDrm/q5QWLnQ2dl1hd3sPIlPG6CEmDk9VZLUmWux1NatWw9YtaVSqWTMgXPwo/g0nks66Ll4/lLB9+CyNC5L4+fyJn4l3nJi0JBGwAADz/GLeDdPP8fjW75le7oeioTc/ZVin4WAn1sqxiEvAbJ5W3rQlaB5RBND/TAeL+hDktWwu7kNtu/ZC+3dPaGwxK/k9UtdiBYaW9tgL946kKDouSASBl5NDHkvMnRSDZRqOXEQZ9IAZsKjAT8EkvuzMqh+Wto7IFlZAeWJBHDLAgBfcQVTU5qgiHiyuF43KqqenqzqgHDBIIyZU1NL8GO/CE/cPLB8eRv1LVXEk8JzOY+e4Bcc6qan3sTTuhJJZz1yTsnVIl5n88SxB4+TwVW4fEUpj2cg9kmIuXDjUKlqtbwHlm5CYjC5tgZO+VQdfKZuKlSWl0U0QBJ5uNCMBLD5o4/hk72NQgXlXfVMhjLcF0LC34nhvmKWJ2+EseKorJOr/Bm5mPvqBV9POA6MymbAcmzVxhA4yzp0IqO5rR1aW1sxlS5JxpTkhFGXSl2Fv8xN+Ok/Ajm/zvsDPLVzaRtIOm/UTUvdCCUGXmgXRSxOWi58A0qLku+T1Ax+AEtgiMAKPVO1LDJkYnDI2Br43N8cCcfXTYPRSDiaCJpa22HbJzthFxJMFi9sUMV2TLmxOrzRRXhCUeBW0XOBOCqSqrIElFvSm5H1MtyTSDKiklXB2iRmSuNwlEAUkpV1d0KmsREynZ3yuInQMG/eisTX1tYBWSKY4N9FT2wY8Tg8lZpL0h8/pxX4NAn9B1I69bjtrbMOQ5VRAvR2oZHCgBJDqZr+PKe9QqiZIQQvdHIVI/CAuUshj43aeMaEcTBz0gR4K/0hPPP6W8DR95AMRUYrFwV3IkwCX4FwlaESoYzyeBg+iKMBHIsnIFZZBXtQeRApcLUt15UNTronSisgWfCHxGRZgnRiZCC7NrQ17oU9TiNUJmvQi3FUfxSXf4uGSqsXs9miz8AsGt5egn4Ghp8t+3oPqRhXEkxvaMbjW4+ncRt+VOnwPgSZfDrKvwkgxWPwIqqbevQslkMRsY+wIUlh4eYP06uhdNCqph6KDEGyfOioGYJ/+XEIZI/kP3okPBvDpAQuI58kgwomERzWAZSS0eoFAoNaESEgsXBbGraJeByqkmOhvLoaQycLxmWz0NTUAp/s3i08ldAXh/vbt7xWb5mZcoSykel1GzNaWQzbrHjMW83LiXGliziZwjDwQJIp8ZdfAC/8u/BcFZL2zfjZrMT7hk3pdAP0AfRFxy/OEiSui6JIR6mbuQ6Di4vhW/TpQrNEWLUaSohSeTVDyZvR8EMnZvlKxgtfmPRM1AuO69W3KCNWvaC8FEtsUC4jIhHKBbNFcQy7KseOheopUyFeXQM2viVD6W4rBrXjauHIww+H8ePGiXXEoYCvqiymeqa4SlWrjJcbsKVd8BWVjzAZDgZBMxCYOS31CJ6zKJIhglmOZDADCaa+ryRDoGwTrbNlW3oGntyLKSMV8bZzLA4vFiOcwG9JlDfTkPN8XqnCuACK7tXg+Zw7lLwZDSv4gBSIq8hDXLz6P7xSbW3OihoXbdpyvycpYOKKcEcQTQxGo3oZP3kKjE7WipYDV6SWNHkxmV2KWXDo5ElIOLNg0oTxKkRCBYTLvT4oFVrZjlQ0tB26zzo+wYTUjBeAAYQJaOQAw6Ubo76UeDbeRII5lsjiYH99N6fTqzFUnY8P1+e+RmYx/vreBf2NfDXTgH/PuUChX/BtsdL7GErVpKBIQOO9/89nCRDIOik1ES5SEerGcVWaWjwG3zDW/yhy4opEajGKqUKSqBlVCZUVFWLbIrks/BzfxNHpb6Z4oAzT11MmTYJjjjgcph0yESbQGDauJDUK32y8z+I9hVlUYey6qsiP+6TCAyFXcITikQbyKPC81ue9wGENKpFj+7MGhra1eVv6XFJIeS8i0fVnRkr8XbnhGoM1RJj42a/JeXspVE0uUSeLZdSKdH5uDU+0mhx08IjGpa5p5qe4/ZoU5lXr6vBEFNa5rljmKCJwXb+F4JRjjoRx1WP8ofQ8MmKBwa6Yl5L2LBi1zxj6OuPG1kJV1RhhThNJkXDJotEiFI1SNvTcdQMkox8EtkUsNtL0DP2iciv/y46nYvnm7eklUCSQQooiG/Js+uuCj/i70qSq6IFr5ZvdRVc10jxPh5YhuRZD1aCayf9MXSiq6d5fCIROVqjeRNepcFeHJZooVKVdIHwK3lNYddTUQ+CKhX8L55w4B5JVFeAHMFx5KywohELGLy3MdndDd0enqImh9ws1g8eRJbIRj+VNhF6u620iX7dwf6S+EWTS0C9qhEm7flMJqleJbPC0r8xd7sYOXvIXUDPehaZUWkPOavOKGcqIQ4gg1/5WNVFqhrKYTmyIKRryTywWUAKgHqub107AtaJR73Gl2nG4NmVlCEW3OYdNgis+fzoSzjEwvma0n6FStGX5aSqRMs9090BPZwfYmI3SWStZQSML/0i9ZB1JMroyOIYhmlBiOV6wJkovFBwhdTTiC5nvy6TRw7gaSgRUTWSINgSXkV8jKpEPBlaeCeypGW8/ERd9sQ1aOoZiq5ooNeNYQ0PNEDyiEaEH06lt8AwO16uRUaqBsUD6mPstB4pAZDgl2McziedMPxQuPetUWHzCHBg7usrbtuAGCoFQwWS6usDRYwUH0+cq4yTDM9cjFCr8K0PXeTRmtSwdhgUkTbgamI8YRRP1haRf/VL3JVFqO2+hdeC/8lRsCPk9RnkGtMqeNQSX4ffiolSRi+kiVQ0XldcHjUJqZjD0mvUVHtFwNbKdlhjyelYmMKiME8hxIyxV6RvMNqmH3taIbFwkES58FFf0Oh03cypcseh0OPv4o9EoLkeCQQWDBEPjCgezRPqR9Gf8IkJSNbaKhaiFoRJJpqaiTB0P5HgxMkPmHdQIUDTqF3ReaCF+IXN/9UsBcRHkh1CpA/Vq8CuUV+2LnszKqPdGXPTJUqgaKFKKfairGUK4BUGV2oUrUMC7grmqAlYN3WokPO69pt/qOtz3Tui9SDaiYpfuccHcumlw+MSxQsEw5aNoL0X6t4pqaDkLmNNM+TzK9S1H05jaGWLKMPaPU76eYwENe0RdTGgWroEBAl4M9bnL0Mzd7ws+st2gl1/0AqrmqoFQNQdrRg8HNUMIhU6BpJMHdc162R1RkWtBILXtvSvg57gy3EFiodYAUZ9DPVHUJuA6YtgIb6/KxfXVFCj3RRILBBSNsH+ZbMiUrQlMkIy3JoNo8BFi0TA4I2dJetNHfS/E62+oGp2G0ML8Y9wnoozVff6iszyCLbqqiSI4OEhVMxzUDMEKPmLqv2DZm59dAr+fiYNXoetf4fKGF38P54y73PVS4lxniLhSQaovCSBQj8NYiCiYTEv1aBWjwynLion3Ugqc7rN6WzpKCj4JZLOGu0VDv9ZkuAaX4SnYAAONfEWV3J8Lr4Ca2bCvX3RHFhCGalzIq4Eioz9VzXBRMwSfaOzEnZy7PwEpHAQ8rwQ05TCfPMSYM4p0QPEEh3VuNnvyuDGV/ycUjasqeEXti1YyvrcTQqiFwMtKPWvbzheQXjYylFGiqJC6vqm1AW8OEY02olm+oFFiZy++/IPO2trfw/DG3NwF+Au+HgYYNFZN7jL0VuZCHxF34ZzcZRgO7qs5VKgpzvrPI+or+lPVWBFm8lBUMwSPaBZefXX6rCuvXZawIIVqZBVSSDsLXL0yJOKinsXvTxQvui5jv+SWdcLTr7583nMbN76RtV0RMjm6eldli0SVLykQNbSE56OEBZT/GPHTdeue+snjj5+CpHYms9hGGv6TxeNgI+lk8PA7XTn4Vp4Rw6AZ/4abWSY768dr1163atWqThjGsCKIxo7DmzDAEBd8TuoXP+5P93V9N3/Ihz6Hg/jVIEIqeVtCf6iayJqhIapmCHkRxRn/fs2HePe15++88zarjP8Hks1XMRySg5SrbBINkqXqYZ53LOuWDQ0NDcFtcNFhbcliGyQE7nDP6NV9TNoslkV6aj29gCvHOYB7H338N3j3m+9ddP55+CJ9kEcToXXjCpTR0sNWuDTZE/DbnJ7s3ff84hcfw2AC+hP4BYL+ABVqpYONkC6kciRd80CMelcAuccxFvoAVXeTCi1kff9Fp7+/LpVaycI+h1AXxfSuSNXMnJ5qgHDYs1/7pQroXIU+VNUMoaB1cedjj01GMphaXVUZO/24v4Fj6lJChDjiHxcSeFGXj6r4VDweO/LSxYt/v+qZZzzFQI2OCabHppFp8wynsWgssFHNyNH8CD6Z8NCDQBoqgHlz5yY3vvn2bDyGKYfUJmHS+PGobOKCaMgTamtthY6OdhaLx4+NJ8oPxcWDjWiWQD913qJBuhoCEh3PVjLndA2agdiZVDRzAwtq+rJexMWW3t9UPaka/H6E1IRSFw1QRJCq4TnDjPZ1v5EES2pm29BUMwQrd8F5J510+NknnvA0vvA83ha3tnewZ176Lax68ml4d9MWMSEc7+oEp6cbetrapmW6uu+37ew7X1208JJ6tT1R6OvIamHyZ/Q8Tei3eH1ROosVhM45ySf+V2zhrFnlC48/7htIbm9j/HUTc93kzj174Z2/fAC7du2CxsZG+vWCvXv3gp21qbL47+1Mz+sXnDn/8UvPOutIMBho7HdaeV/tBn2FUHUD0Gx5MF5NVJ/aUFYzBI9oli1adMyXTj75UYyJ/2wxthjDpVE6EUTG796WVvjDu+9jmjrrVQKLOZh6eiDT0T4jm8k8/OGiz2+5ZPHCC7tsu1x4OmosYDkesCtbCXQTJvUuhLJMvkUTzHudfeKJX0+MTb6HAukuPK7DxJg3upYHSay5uQl27N4tCIYFtiVaJWz3n7pd+73zz/rcz5bMm1eyYRYHAiyiixgGCfiBHEtEu4FzgCoE8wirc5dxa3BmoIabN6PhEc0XFy5YtmjBaV+ZWFvLLC/JrZ0P2T1NtSjU2Ghzv2hOtwu4eKF3dnVP393asaalo2uOrXqSdIuCzDy5gXQ3hL0ZD36BHpLSudUTJ/54VNXoGWIgLXWjDBTV1lAZoM3VDVSQJvqbZP8T+UGxWBzGVFaeP3r8+D5nOoYkrLzmuuSMGTOmwyBA7oWDX4G3ent/VLsBfiEaDvRii1QXshepqGR8IKpmOKoZgufRUOa47rApUDd1CvxlyzZ49Y0/ws69TSLDRBcw9TypSd1A1MSArOCN44XsYiaok8aJyWRk82OgLUGW0KiKYjWHisxgyddlb5N/QPqxvqMBtKrH1UKydiy0NDVCY3OLIC9Kbbu6YpjIx1L0qIr4KsrKoLKqChKJhDwODgMPFy4u1lCezEGiyQmELZvPhxIPZ5kLIg0897kXdLq3dUS7QY45c7AXW5RnUooxfvfHqyngzawcyt6MRqAy2FLl/wBH1k2HpeedDV848wyYUFsrLmRxUeO9g2ohgzcbCQbKK8RjmnnSCVzJstPbH6tGjB+jfBlSNZ6ykTsOZbV1qOY9V6+XIXEcOmkSzE5Nh9qaakFuLmW06Djw5lgxNIZjkMBjSo4dCzXJpCIZBiMBNKFb7jIUegOu4pyI6VzwAi+Ydt/fdoO+YqDaEgqpGiSVvPqgqLF2HGvfNUNDAaGsE8vxTI5GwjlqxjT44+Y0vEAKp7lNDAJeSWqBhmdQ49DIfLUu6QPYsrsRasdUCYXBFVFYKmMV03YxiLd7RKLhDSWKZNTWgYmseNwziSlbNaqiHI6aPBGmJ2tgc3Mr7OnqFnJsdEUFTEYCqsLXfcdnZJAMQaRyaUK3QHZHdS3XD2iam+fVwTT3luKNGnibCFPNEHmwSOU8Tw6UqsHfdRqfxytmjFIz+KO/ZjioGUKAaCw53IIOZThXU6QAHHv4DDgOb6+++2d4+a0/gdYJTA2MxUKZaA6/3bId3t+xC46dOhmOnnIIlMVjSr0woWy86VlYTn0el6YxzXy5q7lZeCwTJ04UoRANCxFncvBzuq9MWDCrZjTUErFUjILqigp/OwL5KfRhDwYb8M8Nqhi6kJYADMyvIpXQ43cjFVrIC1crCzUTMbsBg+IpM1aCmQtEXc201BoIt0CkglPCRKXybWtgw97+RCiqF51OLEAiXM52ra3hKeiTaBUTPinBMYTlK61dPfAbJKVHftkA76a3CzPZm1GBSwEUJCcyiJtaWmDThx+hN7TXM4zjalZLIqcEkk3CkscTFwN1IengutTB3TudsBExHE0saoDwEk9sFoQVMZA2hgIF+6+i2g1KADHvOBQZUZ3senyeqEyTUDNDPNMURGBwcnnPAt3QuopXeawCcsoTPaSn764w0PM6yWVcvb+5owM2vPI7uOPnG+B/398EGWpNCAwpQdvAbBXsQnLZ1dgoCvpE5ghk1oiOoAzjrTKRbZLTr8TULJcxTYJc7jfQ1ABB54eOdSR0b3+QTpP30ZCzODUAU8TqiydXidC1U1DRuAMww6RACVLdanyeNTmLhaqJ8maGk5oh+Fkn/UCpGO23+KPd+bloMZCVIptQ6KN6jnRbARFKa3cPtCDZZG1UK6hunt34BzjnlONFL1QrKhiq5qWtlKOJOwmN5/aeHmjv6hLbLkPDl6qJqfKXhoUgFRNzQZGYHASLc99GFpEfD/gzelwbJielHwmI8gNw2Y2Y/VmviKjooBAIjyGvhL63grvIjAspNF6ECmcm9jMvsKTobQkEUjX4PQyTGno1LKfOaDh5Mxoe0YhmRd0GzcPKRj5gStVok5WHugXEQ/VSuZ1FJdMFTU3NSDBZMdKemMwWz+Ae9F8e/uWLYs4m2rmYuwmzRdlMj2i4rCovh2pMS9Oc3pUYEjEensXAEYMUu/4UMMFXQ2QSZpaRMvV2gT4bClWfwut/frHlOIVpNHEcyyeNXtsHojwKMdPltqLMdJnEC34rBC7wUrQl0LmP8GryUv+lGES+1MibQM5ShKKJhst4yIOuCOYuDysaPVsC3h912GSI2Y7wWSwmi+wsFQ6JuaGAZjPgkBXPmQrN5PyUdjYjxg8uw2xTDLNbOqFF+kq3M9hKLYmCQG+Uv4C2CubKGYwoP5igxuvNvUBTMTlzZAqKhF5Iho5pfqH1ClTDNhTLoFVtCbleUUlmtnTkCIOF/y429IvzohCY1wnyDF49uJVHQGJxTi9SoEDPVbcjpx0G3/zy2fCvf3caTEhWS09HFdjRTdTi4NaIaHpwM1nt8ODyRAIVzZhqGF1ZieGSpaZwkdOsIHWBHIJCVR3jaxlHDUHhHT0bkQmnIIRqiZ71oGhkQ9tUJJOXIaL5pHpVUhEeSbGrYSPbEkowhESBcXK8lwdifOdSIKRodFCkZzrQ+SYNxphX+MK5N2EueMaMSonLNwMcUzcNrv3yP8AFZ54u/BcqsHMxTHLoPiYL7HqYvLGychhTk4RksgYSqGQ0sqp9gVoaiFSyrj8lri0UkzajIUfZAGh1MxL5hr6wLPrXkcjmjbppqX4ziKn4jLYZmYbmsLK3UKBAu0HRe3sKFdIVU/FpRI2TIzBM1QwhJ70dMHUVxXikowgkBoE2Ae6vx8Cvv/E2zuQrc2el4NtfWgwXLjgVJtQmhR8EVNmLt/KKCjh0fK0gogqqiZEbUW0K3Buawnb9CmNbze9E20+Qt8S8ORlywNS/I1PaFJo5EmhICQZ3oZezNXUQ4QKtKwrpLHgKIhon8ay/qeZ4Koio2Q1K1dvDBmAOKEIBVTNs1QwhQDT+QFTBeZX8pDH3QigvjJJvCNyzwNzaiq4kb4js0clHzoIf/Ms/wiXzT4Wp48fBDCSYIyZNgDFINsxi3jC/XB0YrWqrkEnMWAlcPCY1RRPHkZFMU67IXbL8v847lIjXRgh6IRtCCnn6RSIc8kn68mtOPgypISIYWhciWgwEMHPi9uLLqG2l4ADGA+4vDNQcUIQ8VTOM1QzByzphwodEBghS0dOqqNe0V0MXPxGGmIkSwJ+lQDVJKU4BHWFB4LkPDicfkRIZpre354xLpTZAd65aV3g7qtiPmjItVexHWSwq4IvjMWcKaRa/ihBghJPNrFSqmfOC09Km8IQ+QiUASCBpoKZHDml8uo1exDM3Hf9J4vO5otJ3H6eSPJm+ZE6i2g36Mh5wfyKiHKAkbQmkamamUlfjF/0Mer552/BVMwSPaKhORSoJ/5IlArFUOKQL8IhsKGukp6FlwH1F4Zfa+PCjMODBOpuIb6ucL6pAmENzvDA9ELlUTgnBhhZkWWA9Ht70yAya8oFkswJ/qdcXygoFkBI3lv8J9YGq0/ixXLxp277rUQq0G5R8ehhSNXVIrsFzUoq2BIIKlVbDCEBe1smLhLySGpkxCl6xFgsrCM80lpZME6am28Kvy+0xHvz28tAc37n3cnusW4djnGuSkjMxgMpkWSyCVVT8ZUgmDApJtmxLz8BTeDGHfp0cvpmUAaawj92U7htRRLYbDFT4kO+XJAeimno4wyOabKdzh+M4D3DqamTBcEdV5CkmCY41w7x3CNLYi4Lj9j2OO6WqvGJ3MOxy1b2aejKomWQ/VSiL5e2VWgx+ZVnWF8hU1I6z7fpGMc3pRC0NITDIJbMtuIcr73niiQYwEKBfUk04cHBFag34cV6NBDODwrP9UQBRsxsMlBnqSlVR8jmgRhI8opl/9dXpU5ZddZkVt1K27axyudvhEwkIghBjy4TK/kUI1Wy5/EcskZi14bXXvrVx48YuvU6wHcrVTm8gr6UZIY+6AlLkv9ate+rBJ548Fr8Ni3ETv9dhGqW6e2wOXVnHH9RKSzK583c4s5butKzZSDJ3g0Ee6MJGb2A+EQWeu3O5nCu7IUrt0DJB+Jh6pgG8cJ2xtO4WDMn2N8Tor/GA+wuF5oBKRYwZY3BgKBh2v3LfnXWJWPxb6LdebIFVRnbI5o93wOPPvwxqEoMMhi5rkHRuf/Lllz8IrvvOQ/dsRkKokzsI907pnb72/mZ4e9tf/QXcT1F7NYEAG1asXRv6sK/58nnnuNnst92s/dlsNivqa8qrazBlbmmC2oPHtBw6O39693PPtYKBgcGAo+DoCadd/s0teLfs6Ttvvmni6Opb8OL/Ij6vVKP9rsLM023rXn11S9S6OiEuoVLjAN6wnTxHFeUqndw+ziB+9PMnqft3/dcXLToT5fct3S4/gQaJwIzJdtzora1jxqxGdIOBgcGgwT6HaTn7m9eR7Ljodw/eXs8d5wK0cJ598pVX/9DrSio7FEpG5brMXtiUsyro7BSD3grt7n722V/j3a8vWLBgAXf5nFExtvq2J55oAQMDg0GHPo8HddJXr92Kd9/vy3t5MH/FeSj1TI9l6BVOZHvzZ6vCv77iZy+88ALevQAGBgaDFkUZeI46qmPgdx6RMnG5XyXs5ti/wXCJ6xjLwMBg2MCCYsB1ZAralWmn3PFq5ONg9glyYij5pkExRYqBgcFBoyiKxtG5bepNUkV2uuFSdStAXngU8nIkw1h9j6AMDAwGMYqiaBzXeQ4NWtcvvnP9gry8gar0e3zzWKEZn/wKDAwMhjyKQjQnXn7NFY2ZzBE2d/87aztdsinS9QfI4jlhEffbFPBxE97fmrCdT61Yu/Z+MDAwGPIoenDy23tvnRXj8Rtisdj5sjtJ2r+vf5CG9z7a4dXWIPG0WpyvZIytuGvt2kYwMDAYNiiZC/LiXfWpykTlzRazvmgxVk5E8/5fd5CYyaIXcyvPOg+sWLfuEzAwMBh2KLnd+lT9d+eOT1bf8e62v57xp492/Lw7m71h1fr1m8HAwMCgv/GfX/nKWDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwGCL4f4+aVakVlu0IAAAAAElFTkSuQmCC"

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Links__ = __webpack_require__(30);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function Footer(_ref){var routes=_ref.routes,lesserRoutes=_ref.lesserRoutes;var footerRoutes=[].concat(_toConsumableArray(routes),_toConsumableArray(lesserRoutes));var companyLinks=Object(__WEBPACK_IMPORTED_MODULE_1__Links__["d" /* parseLinksFooter */])(footerRoutes,'COMPANY');var mapLinks=Object(__WEBPACK_IMPORTED_MODULE_1__Links__["d" /* parseLinksFooter */])(footerRoutes,'MAP');var locationLinks=Object(__WEBPACK_IMPORTED_MODULE_1__Links__["d" /* parseLinksFooter */])(footerRoutes,'LOCATION');var communityLinks=Object(__WEBPACK_IMPORTED_MODULE_1__Links__["d" /* parseLinksFooter */])(footerRoutes,'COMMUNITY');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'footer-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'footer-columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Foamspace Corp'),companyLinks,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-terms-of-service',href:'/tos',text:'Terms of Service'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-privacy-policy',href:'/privacy',text:'Privacy Policy'})),mapLinks.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Map'),mapLinks):null,locationLinks.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Location'),locationLinks):null,communityLinks.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Community'),communityLinks):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contact'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-contact',href:'mailto:info@foam.space',text:'info@foam.space'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-column',style:{'flex-grow':1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Token Addresses'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-token-mainnet',href:'https://etherscan.io/token/0x4946fcea7c692606e8908002e55a582af44ac121',text:'Mainnet: 0x4946Fcea7C692606e8908002e55A582af44AC121'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-token-optimism',href:'https://optimistic.etherscan.io/token/0x79e6c6b6aaba4432fabacb30cc0c879d8f3e598e',text:'Optimism: 0x79E6c6b6aABA4432FAbacB30cC0C879D8f3E598e'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Links__["a" /* ExternalFooterLink */],{key:'f-token-base',href:'https://basescan.org/token/0x6059d0ed9368c36941514d2864fd114a84853d5a',text:'Base: 0x6059d0ed9368c36941514d2864fD114a84853d5a'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'footer-copyright'},'©2022 Foamspace Corp'));}/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.componentWillMount=function(){_this.mounted=true;window.scrollTo(0,0);var options={passive:Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* detectPassiveEventSupport */])()};window.addEventListener('scroll',_this.onScroll,options);};_this.componentWillUnmount=function(){_this.mounted=false;window.removeEventListener('scroll',Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["throttle"])(_this.onScroll,30));};_this.componentDidMount=function(){_this.mounted=true;setTimeout(function(){_this.setState({alertIsOpen:true});},5000);_this.setState({vidPlay:true});_this.update();};_this.updateMapStickiness=function(y,startY,stopY){y=y+__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* hh */];// add header height
var mapLock='pinTop';// if above map section
mapLock=y<startY?'pinTop':mapLock;// if in map section
mapLock=y>startY&&y<=stopY?'sticky':mapLock;// if below map section
mapLock=y>=stopY?'pinBottom':mapLock;if(mapLock!==_this.state.mapLock){_this.setState({mapLock:mapLock});}};_this.updateMapStoryIndex=function(y,mapStorySection,startY,stopY){if(y>startY&&y<=stopY){var offset=__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* hh */]+300;var userY=y-startY+offset;var trackLength=mapStorySection.height;var currentMapIndex=Math.floor(userY/trackLength*_this.numSlides);if(currentMapIndex!==_this.state.currentMapIndex){_this.setState({currentMapIndex:currentMapIndex});}}};_this.announceHeight=function(referenceKey,index,height,fromTop){var newSectionList=[].concat(_toConsumableArray(_this.sectionList));newSectionList[index].height=height;newSectionList[index].fromTop=fromTop;_this.sectionList=newSectionList;};_this.announceCurrentSection=function(y,sections){var currentSection=sections.filter(function(s,i){return y>s.fromTop&&y<s.fromTop+s.height;});if(currentSection[0]){var currentSectionKey=currentSection[0].key;if(currentSectionKey!==_this.state.currentSectionKey){_this.setState({currentSectionKey:currentSectionKey});}}};_this.update=function(){if(!_this.mounted){return;}var sections=_this.sectionList;var lastScrollY=_this.lastScrollY;// const iw = window.innerWidth
var ih=window.innerHeight;sections.forEach(function(s){if(s.key==='mapStory'){// this is tricky and has to match the css
var startY=s.fromTop;var stopY=startY+(_this.numSlides-1)*ih;_this.updateMapStickiness(lastScrollY,startY,stopY);_this.updateMapStoryIndex(lastScrollY,s,startY,stopY);}});_this.props.updateHeaderStyle(lastScrollY,sections);_this.announceCurrentSection(lastScrollY,sections);_this.ticking=false;};_this.requestTick=function(){if(!_this.ticking){window.requestAnimationFrame(_this.update);_this.ticking=true;}};_this.onScroll=function(){_this.lastScrollY=window.scrollY;_this.requestTick();};_this.handleMailinglistClicked=function(){__WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].event({category:'cta_click',action:'alert_mailing_list'});};_this.state={mapLock:'relative',currentMapIndex:0,currentSectionKey:_this.props.content[0].key,alertIsOpen:false,isModalOpen:false,vidPlay:false};_this.mounted=false;_this.ticking=false;_this.lastScrollY=0;_this.numSlides=0;_this.props.content.forEach(function(s){if(s.key==='mapStory'){_this.numSlides=s.steps.length;}});_this.sectionList=_this.props.content;return _this;}// don't try to do stuff when stuff is already happening
_createClass(Home,[{key:'render',value:function render(){var _this2=this;var _state=this.state,mapLock=_state.mapLock,currentMapIndex=_state.currentMapIndex,currentSectionKey=_state.currentSectionKey,vidPlay=_state.vidPlay;var sections=this.props.content.map(function(section,index){var Child=section.component;switch(section.key){case'mapStory':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__["a" /* default */],{index:index,key:section.key,announceHeight:_this2.announceHeight,color:section.color,shadow:section.shadow,referenceKey:section.key,child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child,{vidPlay:vidPlay,content:section,mapLock:mapLock,currentMapIndex:currentMapIndex,currentSectionKey:currentSectionKey})});case'hero':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__["a" /* default */],{index:index,key:section.key,announceHeight:_this2.announceHeight,color:section.color,shadow:section.shadow,referenceKey:section.key,child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child,{content:section,isModalOpen:_this2.props.isModalOpen,openModal:_this2.props.openModal,closeModal:_this2.props.closeModal,vidPlay:vidPlay,currentSectionKey:currentSectionKey})});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__["a" /* default */],{index:index,key:section.key,announceHeight:_this2.announceHeight,color:section.color,shadow:section.shadow,referenceKey:section.key,child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child,{content:section,currentSectionKey:currentSectionKey,vidPlay:vidPlay})});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,sections,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert,{isOpen:this.state.alertIsOpen,handleClose:function handleClose(){return _this2.setState({alertIsOpen:false});},handleMailinglistClicked:this.handleMailinglistClicked}));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Alert=function Alert(_ref){var isOpen=_ref.isOpen,handleClose=_ref.handleClose,handleMailinglistClicked=_ref.handleMailinglistClicked;var alertClasses=__WEBPACK_IMPORTED_MODULE_5_classnames___default()({alertIsOpen:isOpen,alertIsClosed:!isOpen,alert:true});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:alertClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:handleClose},'×'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Join the Community'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:'https://upscri.be/b845ab/',onClick:handleMailinglistClicked},'Join Our Mailing List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:'https://map.foam.space/',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].event({category:'cta_click',action:'alert_start_mapping'});}},'Start Mapping'));};/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_foam_arrow_svg__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_foam_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_foam_arrow_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeZones=function(_Component){_inherits(HomeZones,_Component);function HomeZones(props){_classCallCheck(this,HomeZones);var _this=_possibleConstructorReturn(this,(HomeZones.__proto__||Object.getPrototypeOf(HomeZones)).call(this,props));_this.componentWillMount=function(){_this.mounted=true;window.scrollTo(0,0);var options={passive:Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* detectPassiveEventSupport */])()};window.addEventListener('scroll',_this.onScroll,options);};_this.componentWillUnmount=function(){_this.mounted=false;window.removeEventListener('scroll',Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["throttle"])(_this.onScroll,30));};_this.componentDidMount=function(){_this.mounted=true;setTimeout(function(){_this.setState({alertIsOpen:true});},5000);_this.setState({vidPlay:true});_this.update();};_this.announceHeight=function(referenceKey,index,height,fromTop){var newSectionList=[].concat(_toConsumableArray(_this.sectionList));newSectionList[index].height=height;newSectionList[index].fromTop=fromTop;_this.sectionList=newSectionList;};_this.announceCurrentSection=function(y,sections){var currentSection=sections.filter(function(s,i){return y>s.fromTop&&y<s.fromTop+s.height;});if(currentSection[0]){var currentSectionKey=currentSection[0].key;if(currentSectionKey!==_this.state.currentSectionKey){_this.setState({currentSectionKey:currentSectionKey});}}};_this.update=function(){if(!_this.mounted){return;}var sections=_this.sectionList;var lastScrollY=_this.lastScrollY;// const iw = window.innerWidth
var ih=window.innerHeight;sections.forEach(function(s){if(s.key==='mapStory'){// this is tricky and has to match the css
var startY=s.fromTop;var stopY=startY+(_this.numSlides-1)*ih;_this.updateMapStickiness(lastScrollY,startY,stopY);_this.updateMapStoryIndex(lastScrollY,s,startY,stopY);}});_this.props.updateHeaderStyle(lastScrollY,sections);_this.announceCurrentSection(lastScrollY,sections);_this.ticking=false;};_this.requestTick=function(){if(!_this.ticking){window.requestAnimationFrame(_this.update);_this.ticking=true;}};_this.onScroll=function(){_this.lastScrollY=window.scrollY;_this.requestTick();};_this.handleMailinglistClicked=function(){__WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].event({category:'cta_click',action:'alert_mailing_list'});};_this.state={currentSectionKey:_this.props.content[0].key,alertIsOpen:false,isModalOpen:false,vidPlay:false};_this.mounted=false;_this.ticking=false;_this.autoPlay=false;_this.lastScrollY=0;_this.numSlides=0;_this.props.content.forEach(function(s){if(s.key==='mapStory'){_this.numSlides=s.steps.length;}});_this.sectionList=_this.props.content;return _this;}// don't try to do stuff when stuff is already happening
_createClass(HomeZones,[{key:'render',value:function render(){var _this2=this;var _state=this.state,currentSectionKey=_state.currentSectionKey,vidPlay=_state.vidPlay;var sections=this.props.content.map(function(section,index){var Child=section.component;switch(section.key){case'hero':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__["a" /* default */],{index:index,key:section.key,announceHeight:_this2.announceHeight,color:section.color,shadow:section.shadow,referenceKey:section.key,child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child,{content:section,isModalOpen:_this2.props.isModalOpen,openModal:_this2.props.openModal,closeModal:_this2.props.closeModal,vidPlay:vidPlay,currentSectionKey:currentSectionKey})});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_SectionWrapper__["a" /* default */],{index:index,key:section.key,announceHeight:_this2.announceHeight,color:section.color,shadow:section.shadow,referenceKey:section.key,child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child,{content:section,currentSectionKey:currentSectionKey,vidPlay:vidPlay})});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zones'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot-right black'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'persistent-sign-up',href:'https://cqnllvd8gl2.typeform.com/to/EKlKIoEe',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'sign-up-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sign up'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_foam_arrow_svg___default.a,alt:'arrow'}))),sections,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert,{isOpen:this.state.alertIsOpen,handleClose:function handleClose(){return _this2.setState({alertIsOpen:false});},handleMailinglistClicked:this.handleMailinglistClicked}));}}]);return HomeZones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Alert=function Alert(_ref){var isOpen=_ref.isOpen,handleClose=_ref.handleClose,handleMailinglistClicked=_ref.handleMailinglistClicked;var alertClasses=__WEBPACK_IMPORTED_MODULE_5_classnames___default()({alertIsOpen:isOpen,alertIsClosed:!isOpen,alert:true});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:alertClasses});};/* harmony default export */ __webpack_exports__["a"] = (HomeZones);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function NoMatch(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'noMatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Coordinate Not Found'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Error 404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bg,null));}function Bg(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bgWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'skew-layers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noMatch-l1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noMatch-l2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noMatch-l3'})));}/* harmony default export */ __webpack_exports__["a"] = (NoMatch);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return home; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Views_Home_Hero__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Views_Home_Verticals__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Views_Home_Partners__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partnerTiles__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Views_Home_FeatureArtwork__ = __webpack_require__(75);
// Import Sections
// Import Content
var verticalsTiles=[{h:'Internet of Things',p:'Secure location verification and localization for networks of IoT devices.',img:{src:'',alt:''},video:{src:'/bigAssets/IoT.mp4',alt:''}},{h:'Geospatial Data',p:'Data provenance and attribution to support the development of decentralized data-markets.',img:{src:'',alt:''},video:{src:'/bigAssets/Geodata.mp4',alt:''}},{h:'Supply Chain',p:'Verifiable and precise product tracking from supplier to customer, with all the steps in-between.',img:{src:'',alt:''},video:{src:'/bigAssets/Supply.mp4',alt:''}},{h:'Mobility',p:'Location tracking and fraud prevention to support the growth of mobility services and autonomous vehicles.',img:{src:'',alt:''},video:{src:'bigAssets/Mobility.mp4',alt:''}},{h:'Insurance',p:'Automated conflict resolution and contract enforcement through the trusted reporting of spatial information.',img:{src:'',alt:''},video:{src:'/bigAssets/InsuranceLight.mp4',alt:''}},{h:'Location Intelligence',p:'Spatial attribution added to the toolkit of blockchain-enabled analytics.',img:{src:'',alt:''},video:{src:'/bigAssets/Presence.mp4',alt:''}}];var home=[{key:'hero',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_Hero__["a" /* default */],color:'LIGHT',shadow:true,main:{h:['Secure and',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-hero-main-h-br1'}),'Transparent',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-hero-main-h-br2'}),'Location Data'],p:['FOAM provides the tools to enable a crowdsourced map and decentralized location services.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-hero-main-h-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-hero-main-h-br4'}),'Learn more:'],cta:[// {
//   path: '/token',
//   text: 'FOAM Map is live on Ethereum mainnet!',
//   type: 'PLAINTEXT',
//   new: false
// },
// {
//   path: 'https://map.foam.space',
//   text: 'Start Mapping',
//   type: 'EXTERNAL-BUTTON',
//   new: false,
//   onClickHandler: () =>
//     ReactGA.event({
//       category: 'cta_click',
//       action: 'home_start_mapping'
//     })
// },
{path:'/map',text:'FOAM Map',type:'INTERNAL'},{path:'/location',text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/publicAssets/foam-location.svg',alt:''}),type:'INTERNAL-IMAGE',new:false}],justification:'LEFT',width:'NARROW'},video:{hidePlayBtn:true,src:'/bigAssets/FOAM_short_harder.mp4',alt:'Your browser does not support the video tag.'}},{key:'featureArtwork',component:__WEBPACK_IMPORTED_MODULE_5__Views_Home_FeatureArtwork__["a" /* default */],color:'LIGHT',main:[{h:['Location data without',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main1-h-br1'}),'Satellites.'],p:['The stock market, supply chains, the airline industry, the electrical grid, communication networks and more rely on GPS.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main1-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main1-p-br2'}),'But GPS is vulnerable to hacking and spoofing, leaving our critical infrastructure unprotected. Secure location verification is urgently needed across an array of industries.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main1-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main1-p-br4'}),'FOAM solves the problem of location verification with an alternative, fault-tolerant system provided through an open network of terrestrial radios that anyone can operate.'],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RatioBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'RatioBox-item',autoPlay:true,muted:true,loop:true,playsInline:true},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:'/bigAssets/GPS.mp4',type:'video/mp4'}),' ')))},{h:['Open Source.'],p:['FOAM invites individuals, businesses, and organizations to join together in a community-owned and operated location network. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main2-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main2-p-br2'}),'FOAM Map and FOAM Location provide more resilient alternatives to centralized maps and location services but without a single point of failure.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main2-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main2-p-br4'}),'By putting a verification layer at the core, others can build on top of FOAM data and know that it can be trusted. '],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RatioBox RatioBox--ratio2X1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'RatioBox-item',autoPlay:true,muted:true,loop:true,playsInline:true},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:'/bigAssets/PoL.mp4',type:'video/mp4'}),' ')))},{h:['Built on blockchain.'],p:['FOAM is built on the Ethereum blockchain, a decentralized database that is secure without a third party or gatekeeper.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main3-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main3-p-br2'}),'Blockchains mean that FOAM is transparent and censorship-resistant, and can provide secure location data for other applications. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main3-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-featureArtwork-main3-p-br4'}),'The FOAM token gives participants control over their location network and requires them to make decisions that impact its future.'],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RatioBox RatioBox--ratio4X3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'RatioBox-item',autoPlay:true,muted:true,loop:true,playsInline:true},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:'/bigAssets/rp.mp4',type:'video/mp4'}),' ')))}]},{key:'verticals',component:__WEBPACK_IMPORTED_MODULE_2__Views_Home_Verticals__["a" /* default */],color:'LIGHT',main:{h:'A Field of Applications.',p:['Verified location data benefits a wide',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'home-verticals-main-p-br1'}),'range of use-cases.'],cta:{path:'https://blog.foam.space',text:'Check Out Our Blog',type:'EXTERNAL'},justification:'LEFT',width:'WIDE'},verticalsTiles:verticalsTiles},{key:'partners',component:__WEBPACK_IMPORTED_MODULE_3__Views_Home_Partners__["a" /* default */],color:'DARK',partnerTiles:__WEBPACK_IMPORTED_MODULE_4__partnerTiles__["a" /* partnerTiles */]}];

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_routes__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoToTokenPageCTA=function(_Component){_inherits(GoToTokenPageCTA,_Component);function GoToTokenPageCTA(props){_classCallCheck(this,GoToTokenPageCTA);var _this=_possibleConstructorReturn(this,(GoToTokenPageCTA.__proto__||Object.getPrototypeOf(GoToTokenPageCTA)).call(this,props));var tokenPage=__WEBPACK_IMPORTED_MODULE_1__content_routes__["b" /* routes */].filter(function(r){return r.isTokenPage;})[0];_this.state={tokenPage:tokenPage};return _this;}_createClass(GoToTokenPageCTA,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-signup-container',style:{paddingTop:'.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'header-button',href:'https://tokenfoundry.com/projects/foam',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PURCHASE FOAM TOKENS'),' \u2794'));}}]);return GoToTokenPageCTA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GoToTokenPageCTA);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Aside__ = __webpack_require__(25);
function Verticals(_ref){var content=_ref.content,vidPlay=_ref.vidPlay;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'verticals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_Aside__["b" /* MainAside */],{content:content.main}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileGrid,{content:content.verticalsTiles,vidPlay:vidPlay}));}function TileGrid(_ref2){var content=_ref2.content,vidPlay=_ref2.vidPlay;var tiles=content.map(function(vertical){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tile,{key:vertical.h,content:vertical,vidPlay:vidPlay});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-list'},tiles);}function Tile(_ref3){var content=_ref3.content,vidPlay=_ref3.vidPlay;var h=content.h,p=content.p,video=content.video;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vertical-tile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,loop:true,playsInline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:video.src,type:'video/mp4'}),video.alt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,p)));}/* harmony default export */ __webpack_exports__["a"] = (Verticals);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return zones; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__ = __webpack_require__(153);
var zones=[{key:'hero-1',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{src:'/bigAssets/foam_1.png',smallSrc:'/bigAssets/foam_1_small.png',justification:'CENTER',width:'NARROW'}},{key:'hero-2',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{h:['Foam is excited to announce the launch of Trust Zone, the Foam Location incentivized testnet.'],justification:'LARGE',width:'WIDE'}},{key:'hero-3',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{h4:['FOAM Location Testnet'],p:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),'Trust Zone is the program where Location Service Providers can operate Zones, complete tasks, and provide feedback to improve FOAM Location.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br3'}),'FOAM Location is a permissionless and autonomous network of radios that offer secure location services through time synchronization, independent of centralized sources like GPS.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br5'}),'The goal of Trust Zone is to run FOAM Location in different geographical environments, test various zone configurations and the current prototype of the FOAM radio. The participants will have to run localization experiments and submit the results for evaluation.'],justification:'CENTER',width:'NARROW'}},{key:'hero-7-B',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,size:'wide',image:{src:'/bigAssets/foam-full-1.jpg',smallSrc:'/bigAssets/foam-full-1-s.jpg'}},{key:'hero-4',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{h4:['Why participate?'],p:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'outline',key:'span1'},'Refine Localization in real world'),'You will have a key role in the development of the protocol and features while helping to refine localization results.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'outline',key:'span2'},'Earn Rewards'),'As a partner participant in the Trust Zone program you will be eligible for earning FOAM tokens.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'outline',key:'span3'},'Be the First Zone Operator'),'You will be the first Zone Operator when the network further opens to stake, earn mining rewards and offer location services to customers. '],justification:'CENTER',width:'NARROW'}},{key:'hero-5',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{button:['Sign up'],justification:'CENTER',width:'WIDE'}},{key:'hero-6',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{h4:['Zone Anchors'],p:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),'The decentralized FOAM Location network consists of Zone Anchors (ZA). These remotely-controlled radio nodes are coordinated to transceive LoRa packets to and from one another and configured to log those packets to a remote data store such as blockchain.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br3'}),'The Zone Anchor consists of the PCB stack, battery, LTE Modem, and two antennas. To perform localization, the ZA needs to be placed outdoors. For the early stage of the program, a radio node assembled from off-the-shelf components will be used.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br5'}),'The Zone Anchor with custom-designed hardware and enclosure is under development.'],justification:'CENTER',width:'NARROW'}},{key:'hero-7',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,size:'wide',image:{src:'/bigAssets/foam_3.png',smallSrc:'/bigAssets/foam_3_small.png'}},{key:'hero-8',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{h4:['Trust Zone'],p:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),'The FOAM Location protocol requires at least four Zone Anchor radios to form a zone. Program participants would need to scope and test locations for all four radios.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br3'}),'After the radio nodes are set up, a visibility test would need to be performed to assess the viability of the location. Material and support will be provided on how to approach building owners to allow permission to use their building. Once permanently installed, your Zone will be up and running and eligible for participating in multiple kinds of location tracking use cases and stress testing of the protocol. '],justification:'CENTER',width:'NARROW'}},{key:'hero-9',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,slider:{width:'narrow',images:['/bigAssets/foam-g-1.jpg','/bigAssets/foam-g-2.jpg','/bigAssets/foam-g-3.jpg','/bigAssets/foam-g-4.jpg'],smallImages:['/bigAssets/foam-g-1-s.jpg','/bigAssets/foam-g-2-s.jpg','/bigAssets/foam-g-3-s.jpg','/bigAssets/foam-g-4-s.jpg'],captions:['Zone Anchor product under development']}},{key:'hero-10',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'DARK',shadow:false,main:{h4:['Brooklyn Navy Yard Zone &',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),'Current Zone Anchor prototype'],justification:'CENTER',width:'NARROW-MINIMAL'}},{key:'hero-11',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,slider:{width:'full',images:['/bigAssets/foam-bk-1.png','/bigAssets/foam-bk-2.png','/bigAssets/foam-bk-3.png','/bigAssets/foam-bk-4.png','/bigAssets/foam-bk-5.png','/bigAssets/foam-bk-6.png'],smallImages:['/bigAssets/foam-bk-1-s.png','/bigAssets/foam-bk-2-s.png','/bigAssets/foam-bk-3-s.png','/bigAssets/foam-bk-4-s.png','/bigAssets/foam-bk-5-s.png','/bigAssets/foam-bk-6-s.png'],captions:['localization algorithm data','network simulation on Raspberry Pis']}},{key:'hero-12',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'DARK',shadow:false,main:{h4:[],p:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br1'}),'The first operational Zone is deployed at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://brooklynnavyyard.org/',key:'a1'},'Brooklyn Navy Yard(BNY)'),' to test in a dense, urban setting and serves as an ongoing sandbox environment since June 2020. The installation hosts four radio nodes (Zone Anchors) across three rooftops with good visibility between them. Unlike tests done in an ideal environment such as an open field, the BNY installation has radio nodes at different altitudes that range from 10m to 60m, and the largest distance between them is 1000m.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br3'}),'The radio nodes currently tested are the latest developer prototypes assembled from off-the-shelf components provisioned through a remote management system developed at FOAM. The daily experiments include localization of the static nodes on the rooftops one by one as well as a dynamic moving node, which we do with a person walking with a radio node as well as on bicycles and vehicles.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'br5'})],a:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://blog.foam.space/foam-2020-summer-updates-7c78cbd5fdca',key:'a2'},'Read More')],justification:'CENTER',width:'NARROW'}},{key:'hero-13',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,main:{button:['Sign up'],justification:'CENTER',width:'WIDE'}},{key:'hero-14',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_HeroZones__["a" /* default */],color:'LIGHT',shadow:false,video:{hidePlayBtn:false,hidePauseBtn:true,src:'/bigAssets/foam_final_vid.mp4',alt:''}}];

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_MainSection__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Slider__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_video_still_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_video_still_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_video_still_png__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeroZones=function(_Component){_inherits(HeroZones,_Component);function HeroZones(){_classCallCheck(this,HeroZones);return _possibleConstructorReturn(this,(HeroZones.__proto__||Object.getPrototypeOf(HeroZones)).apply(this,arguments));}_createClass(HeroZones,[{key:'render',value:function render(){var _props=this.props,content=_props.content,openModal=_props.openModal;var windowWidth=window.innerWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content.video&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeroVideo,{video:content.video,openModal:openModal}),content.image&&windowWidth>=600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeroImage,{image:content.image,openModal:openModal,size:content.size}),content.image&&windowWidth<600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeroImageSmall,{image:content.image,openModal:openModal,size:content.size}),content.main&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_MainSection__["a" /* MainSection */],{content:content.main}),content.slider&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slideshow '+content.slider.width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Slider__["a" /* default */],{options:{autoPlay:false,pauseAutoPlayOnHover:true,wrapAround:false,contain:true,prevNextButtons:false,imagesLoaded:true,cellAlign:'left'}},content.slider.images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'auto',height:'400px',margin:'0 0.5em'},key:index},windowWidth<600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:content.slider.smallImages[index],alt:''}),windowWidth>=600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'caption'},content.slider.captions[index]));}))));}}]);return HeroZones;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function HeroVideo(_ref){var video=_ref.video,openModal=_ref.openModal;var vidRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isActive=_useState2[0],setActive=_useState2[1];var handlePlayVideo=function handlePlayVideo(){vidRef.current.muted=false;setActive(!isActive);isActive?vidRef.current.pause():vidRef.current.play();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zone-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hero-video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{muted:true,loop:true,playsInline:true,ref:vidRef,poster:__WEBPACK_IMPORTED_MODULE_3__assets_video_still_png___default.a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:video.src,type:'video/mp4',width:window.innerWidth*0.5,height:window.innerHeight}),video.alt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:isActive?'show':'hide',id:'playVideo',onClick:function onClick(){return handlePlayVideo();}})));}function HeroImage(_ref2){var image=_ref2.image,openModal=_ref2.openModal,size=_ref2.size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zone-outer '+size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-center zonewrapper zonewrapper-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square bl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square br'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image.src,alt:''}))));}function HeroImageSmall(_ref3){var image=_ref3.image,openModal=_ref3.openModal,size=_ref3.size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zone-outer '+size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-center zonewrapper zonewrapper-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square bl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square br'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image.smallSrc,alt:''}))));}/* harmony default export */ __webpack_exports__["a"] = (HeroZones);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intersection_observer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_foam_arrow_svg__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_foam_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_foam_arrow_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function evalConfig(config){return __WEBPACK_IMPORTED_MODULE_1_classnames___default()({'zonewrapper-left':config.justification==='LEFT','zonewrapper-center':config.justification==='CENTER','zonewrapper-right':config.justification==='RIGHT','zonewrapper-wide':config.width==='WIDE','zonewrapper-narrow':config.width==='NARROW','zonewrapper-narrow zonewrapper-minimal':config.width==='NARROW-MINIMAL','zonewrapper-large':config.justification==='LARGE'});}var MainSection=function(_Component){_inherits(MainSection,_Component);function MainSection(props){_classCallCheck(this,MainSection);var _this=_possibleConstructorReturn(this,(MainSection.__proto__||Object.getPrototypeOf(MainSection)).call(this,props));_this.componentWillMount=function(){window.scrollTo(0,0);var options={passive:Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* detectPassiveEventSupport */])()};window.addEventListener('scroll',_this.onScroll,options);window.addEventListener('resize',_this.onResize);};_this.componentDidMount=function(){_this.onResize();};_this.componentWillUnmount=function(){window.removeEventListener('scroll',_this.onScroll);window.removeEventListener('resize',_this.onResize);};_this.update=function(){var lastScrollY=_this.lastScrollY;if(lastScrollY<0||_this.noAnim){_this.ticking=false;return false;}_this.coords.tl.x2=_this.sq_tl.getBoundingClientRect().left;_this.coords.tl.y2=_this.sq_tl.getBoundingClientRect().top;_this.coords.tr.x2=_this.sq_tr.getBoundingClientRect().left;_this.coords.tr.y2=_this.sq_tr.getBoundingClientRect().top;_this.coords.bl.x2=_this.sq_bl.getBoundingClientRect().left;_this.coords.bl.y2=_this.sq_bl.getBoundingClientRect().top;_this.coords.br.x2=_this.sq_br.getBoundingClientRect().left;_this.coords.br.y2=_this.sq_br.getBoundingClientRect().top;var canvas=_this.canvas;if(canvas.getContext){var ctx=canvas.getContext('2d');var w=ctx.canvas.clientWidth;var h=ctx.canvas.clientHeight;ctx.clearRect(0,0,w,h);ctx.strokeStyle='rgba(201,201,201,.65)';ctx.lineWidth=0.6;// Top left
ctx.beginPath();ctx.moveTo(25,77);ctx.lineTo(_this.coords.tl.x2+5,_this.coords.tl.y2+5);ctx.closePath();ctx.stroke();// Top right
ctx.beginPath();ctx.moveTo(w-25,77);ctx.lineTo(_this.coords.tr.x2+5,_this.coords.tr.y2+5);ctx.closePath();ctx.stroke();// Bottom left
ctx.beginPath();ctx.moveTo(25,h-25);ctx.lineTo(_this.coords.bl.x2+5,_this.coords.bl.y2+5);ctx.closePath();ctx.stroke();// Bottom right
ctx.beginPath();ctx.moveTo(w-25,h-25);ctx.lineTo(_this.coords.br.x2+5,_this.coords.br.y2+5);ctx.closePath();ctx.stroke();}_this.ticking=false;};_this.requestTick=function(){if(!_this.ticking){window.requestAnimationFrame(_this.update);_this.ticking=true;}};_this.onScroll=function(){_this.lastScrollY=window.scrollY;_this.requestTick();};_this.onResize=function(){var canvas=_this.canvas;if(canvas.getContext){var ctx=canvas.getContext('2d');ctx.canvas.width=canvas.offsetWidth;ctx.canvas.height=canvas.offsetHeight;_this.requestTick();}};_this.onCanvasOut=function(){_this.noAnim=true;};_this.isInView=function(bool,entry){if(bool){_this.noAnim=false;_this.canvas.classList.add('active');_this.canvas.removeEventListener('transitionend',_this.onCanvasOut);}else{_this.canvas.addEventListener('transitionend',_this.onCanvasOut);_this.canvas.classList.remove('active');}};_this.coords={tl:{x1:0,y1:0,x2:0,y2:0},tr:{x1:0,y1:0,x2:0,y2:0},bl:{x1:0,y1:0,x2:0,y2:0},br:{x1:0,y1:0,x2:0,y2:0}};_this.canvas=null;_this.sq_tl=null;_this.sq_tr=null;_this.sq_bl=null;_this.sq_br=null;_this.ticking=false;_this.inView=false;_this.noAnim=false;_this.content=_this.props.content;return _this;}// don't try to do stuff when stuff is already happening
_createClass(MainSection,[{key:'render',value:function render(){var _this2=this;var content=this.content;var windowWidth=window.innerWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intersection_observer__["a" /* InView */],{threshold:'0.6',rootMargin:'-10% 0% -10% 0%',onChange:function onChange(inView,entry){return _this2.isInView(inView,entry);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zone-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zonewrapper-content '+evalConfig(content)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{ref:function ref(el){return _this2.canvas=el;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tl',ref:function ref(el){return _this2.sq_tl=el;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square tr',ref:function ref(el){return _this2.sq_tr=el;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square bl',ref:function ref(el){return _this2.sq_bl=el;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'square br',ref:function ref(el){return _this2.sq_br=el;}}),content.h&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Trust Zone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'FOAM Incentivized Location Testnet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'top-arrow',src:__WEBPACK_IMPORTED_MODULE_4__assets_foam_arrow_svg___default.a,alt:'arrow'})),content.h&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h)),content.h4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,content.h4),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.a&&content.a),content.src&&windowWidth>=600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:content.src,alt:''})),content.src&&windowWidth<600&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:content.smallSrc,alt:''})),content.button&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://cqnllvd8gl2.typeform.com/to/EKlKIoEe',target:'_blank',rel:'noopener noreferrer',className:'sign-up-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'sign-up-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,content.button),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_foam_arrow_svg___default.a,alt:'arrow'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'button-disclaimer'},'Trust Zone Program applications have closed. Sign up to be notified for the next batch.'))))));}}]);return MainSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InView; });
/* unused harmony export default */
/* unused harmony export defaultFallbackInView */
/* unused harmony export observe */
/* unused harmony export useInView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"]({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity_dist_flickity_min_css__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity_dist_flickity_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flickity_dist_flickity_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slider=function(_React$Component){_inherits(Slider,_React$Component);function Slider(props){_classCallCheck(this,Slider);var _this=_possibleConstructorReturn(this,(Slider.__proto__||Object.getPrototypeOf(Slider)).call(this,props));_this.state={flickityReady:false};_this.refreshFlickity=_this.refreshFlickity.bind(_this);return _this;}_createClass(Slider,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.flickity=new __WEBPACK_IMPORTED_MODULE_2_flickity___default.a(this.flickityNode,this.props.options||{});this.setState({flickityReady:true});setTimeout(function(){//If images loading
_this2.flickity.element.querySelectorAll('img').forEach(function(element){element.addEventListener('load',function(){_this2.refreshFlickity();});});//If images already loaded (cached)
_this2.refreshFlickity();},500);}},{key:'refreshFlickity',value:function refreshFlickity(){this.flickity.reloadCells();this.flickity.resize();this.flickity.updateDraggable();}},{key:'componentWillUnmount',value:function componentWillUnmount(){// TODO: this causes React Router to basically implode if uncommented
// TODO: not sure why, but this ends up causing React DOM to try to remove a child twice,
// TODO: which of course, breaks the whole site...
// this.flickity.destroy()
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var flickityDidBecomeActive=!prevState.flickityReady&&this.state.flickityReady;var childrenDidChange=prevProps.children.length!==this.props.children.length;if(flickityDidBecomeActive||childrenDidChange){this.refreshFlickity();}}},{key:'renderPortal',value:function renderPortal(){if(!this.flickityNode){return null;}var mountNode=this.flickityNode.querySelector('.flickity-slider');if(mountNode){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children,mountNode);}}},{key:'render',value:function render(){var _this3=this;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test',key:'flickityBase',ref:function ref(node){return _this3.flickityNode=node;}}),this.renderPortal()].filter(Boolean);}}]);return Slider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(162),
      __webpack_require__(164),
      __webpack_require__(165),
      __webpack_require__(166),
      __webpack_require__(167),
      __webpack_require__(168),
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('./flickity'),
        require('./drag'),
        require('./prev-next-button'),
        require('./page-dots'),
        require('./player'),
        require('./add-remove-cell'),
        require('./lazyload')
    );
  }

} )( window, function factory( Flickity ) {
  return Flickity;
} );


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(76),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( getSize ) {
      return factory( window, getSize );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
        window,
        window.getSize
    );
  }

}( window, function factory( window, getSize ) {

'use strict';

function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.element.setAttribute( 'aria-hidden', 'true' );
  this.x = 0;
  this.shift = 0;
  this.element.style[ this.parent.originSide ] = 0;
};

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
  this.element.style.transform = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var sideOffset = this.parent.originSide === 'left' ? 1 : -1;

  var adjustedX = this.parent.options.percentPosition ?
    x * sideOffset * ( this.parent.size.innerWidth / this.size.width ) :
    x * sideOffset;

  this.element.style.transform = 'translateX(' +
    this.parent.getPositionValue( adjustedX ) + ')';
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

/**
 * @param {Integer} shift - 0, 1, or -1
 */
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

} ) );


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( function( cell ) {
    cell.select();
  } );
};

proto.unselect = function() {
  this.cells.forEach( function( cell ) {
    cell.unselect();
  } );
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

return Slide;

} ) );


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( utils ) {
      return factory( window, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
        window,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {

'use strict';

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    } );
  }
};

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x -= this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft ? -x : x;
  var translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
};

proto.dispatchScrollEvent = function() {
  var firstSlide = this.slides[0];
  if ( !firstSlide ) {
    return;
  }
  var positionX = -this.x - firstSlide.target;
  var progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  var isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
  if ( isResting ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i = 0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i = 0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  var dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(163),
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unidragger'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
        window,
        window.Flickity,
        window.Unidragger,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {

'use strict';

// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );
proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

proto._createDrag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  // TODO updateDraggable on resize? if groupCells & slides change
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable == '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  if ( this.isDraggable ) {
    this.element.classList.add('is-draggable');
  } else {
    this.element.classList.remove('is-draggable');
  }
};

// backwards compatibility
proto.bindDrag = function() {
  this.options.draggable = true;
  this.updateDraggable();
};

proto.unbindDrag = function() {
  this.options.draggable = false;
  this.updateDraggable();
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.pointerDown = function( event, pointer ) {
  if ( !this.isDraggable ) {
    this._pointerDownDefault( event, pointer );
    return;
  }
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }

  this._pointerDownPreventDefault( event );
  this.pointerDownFocus( event );
  // blur
  if ( document.activeElement != this.element ) {
    // do not blur if already focused
    this.pointerDownBlur();
  }

  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this._pointerDownDefault( event, pointer );
};

// default pointerDown logic, used for staticClick
proto._pointerDownDefault = function( event, pointer ) {
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };
  // bind move and end events
  this._bindPostStartEvents( event );
  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var focusNodes = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true,
};

proto.pointerDownFocus = function( event ) {
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isFocusNode ) {
    this.focus();
  }
};

proto._pointerDownPreventDefault = function( event ) {
  var isTouchStart = event.type == 'touchstart';
  var isTouchPointer = event.pointerType == 'touch';
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
    event.preventDefault();
  }
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) {
    return;
  }
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  if ( this.options.wrapAround ) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( dist, minDist ) {
      return dist <= minDist;
    } : function( dist, minDist ) {
      return dist < minDist;
    };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(46)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Unipointer ) {
      return factory( window, Unipointer );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {

'use strict';

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(46),
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = Object.create( Unipointer.prototype );

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-button flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindStartEvent( this.element );
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // click events
  this.unbindStartEvent( this.element );
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path' );
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(46),
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //

'use strict';

function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = Object.create( Unipointer.prototype );

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.handleClick = this.onClick.bind( this );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.holder.addEventListener( 'click', this.handleClick );
  this.bindStartEvent( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  this.holder.removeEventListener( 'click', this.handleClick );
  this.unbindStartEvent( this.holder );
  // remove from DOM
  this.parent.element.removeChild( this.holder );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  var length = this.dots.length;
  var max = length + count;

  for ( var i = length; i < max; i++ ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
    fragment.appendChild( dot );
    newDots.push( dot );
  }

  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

PageDots.prototype.onTap = // old method name, backwards-compatible
PageDots.prototype.onClick = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true,
} );

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(45),
      __webpack_require__(13),
      __webpack_require__(16),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('ev-emitter'),
        require('fizzy-ui-utils'),
        require('./flickity')
    );
  } else {
    // browser global
    factory(
        window.EvEmitter,
        window.fizzyUIUtils,
        window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {

'use strict';

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {

'use strict';

// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  } );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index, true );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }

  var minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( function( cell ) {
    cell.remove();
    var index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  }, this );

  this.cellChange( minCellIndex, true );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex
  // try to maintain position & select previous selected element
  var cell = this.getCell( prevSelectedElem );
  if ( cell ) {
    this.selectedIndex = this.getCellSlideIndex( cell );
  }
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
  // do not position slider after lazy load
  if ( isPositioningSlider ) {
    this.positionSliderAtSelected();
  }
};

// -----  ----- //

return Flickity;

} ) );


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
( function( window, factory ) {
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(16),
      __webpack_require__(13),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  } );
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' ) {
    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
      return [ cellElem ];
    }
  }
  // select lazy images in cell
  var lazySelector = 'img[data-flickity-lazyload], ' +
    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
  var imgs = cellElem.querySelectorAll( lazySelector );
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  var src = this.img.getAttribute('data-flickity-lazyload') ||
    this.img.getAttribute('data-flickity-lazyload-src');
  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
  // set src & serset
  this.img.src = src;
  if ( srcset ) {
    this.img.setAttribute( 'srcset', srcset );
  }
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
  this.img.removeAttribute('data-flickity-lazyload-src');
  this.img.removeAttribute('data-flickity-lazyload-srcset');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video-still.eb058814.png";

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Views_Home_SpatialIndex__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Views_Home_FeatureArtwork__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Views_Home_FeatureSteps__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Links__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga__ = __webpack_require__(24);
var map=[{key:'spatialIndex',component:__WEBPACK_IMPORTED_MODULE_1__Views_Home_SpatialIndex__["b" /* default */],color:'DARK',main:{h:['FOAM ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'map-spatialIndex-main-h-span1',style:{color:'#2F80ED'}},'Map')],p:['A community-verified registry of',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-spatialIndex-main-p-br1'}),' crowdsourced places.'],cta:[{path:'https://map.foam.space',text:'Start Mapping',type:'EXTERNAL',onClickHandler:function onClickHandler(){return __WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].event({category:'cta_click',action:'start_mapping'});}}],justification:'LEFT',width:'WIDE'},indexStats:{}},{key:'featureArtwork',component:__WEBPACK_IMPORTED_MODULE_2__Views_Home_FeatureArtwork__["a" /* default */],color:'DARK',main:[{h:['Open to cartographers',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main1-h-br1'}),'everywhere.'],p:['Anyone can add places to the FOAM Map and share their knowledge of the world.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main1-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main1-p-br2'}),'Because maps get better when they’re shaped by cartographers like you.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main1-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main1-p-br4'}),'Collect locations – called points of interest or POIs – and contribute to an open source registry.'],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:'/publicAssets/map-page-artwork1.png',alt:''}))},{h:['Community verification for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main2-h-br1'}),'crowdsourced places.'],p:['A new place must go through multiple stages before it is verified. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main2-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main2-p-br2'}),'Cartographers challenge when they find something that seems false or incorrect, starting a process in which the community votes to decide if a location should be included or removed.  '],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:'/publicAssets/map-page-artwork2.png',alt:''}))},{h:['Building a map that',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main3-h-br1'}),'can be trusted.'],p:['Cartographers use FOAM tokens to sort places and ensure location data is correct and up to date. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main3-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main3-p-br2'}),'Since the tokens have value, spamming has a cost and participants share the value they create. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main3-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureArtwork-main3-p-br4'}),'Tokens enable people to agree on which locations should be included in the FOAM Map without the need for a central authority.'],img:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureArtwork-itemContentArtworkWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:'/publicAssets/map-page-artwork3.png',alt:''}))}]},{key:'featureSteps',component:__WEBPACK_IMPORTED_MODULE_3__Views_Home_FeatureSteps__["a" /* default */],color:'DARK',shadow:true,h:'How do I become a cartographer?',p:'This short guide will tell you everything you need to know to start mapping.',main:[{h:'Browser + Wallet',hSub:'Step 1',color:'#2F80ED',itemColor:'#196BD9',p:['To use the FOAM Map, you need a desktop computer with a compatible browser installed, such as Chrome, Opera or Brave.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main1-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main1-p-br2'}),'Then you need to install a digital wallet like MetaMask. This is a free browser extension that allows you to access digital currencies and tokens.'],items:[{href:'https://chrome.com',name:'Chrome',img:'publicAssets/icons/logo-Chrome.svg'},{href:'https://brave.com',name:'Brave',img:'publicAssets/icons/logo-Brave.svg'},{href:'https://opera.com',name:'Opera',img:'publicAssets/icons/logo-Opera.svg'},{href:'https://metamask.com',name:'MetaMask',img:'publicAssets/icons/logo-Metamask.svg'}]},{h:'FOAM Token',hSub:'Step 2',color:'#27AE60',itemColor:'#0B8E42',p:['You need FOAM tokens to add and verify locations.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main2-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main2-p-br2'}),'Exchange USD, Bitcoin, Ether or other currencies for FOAM Tokens on the RadarRelay, Poloniex, and Uniswap exchanges.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main2-p-br3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main2-p-br4'}),'Once you have FOAM Tokens, make sure they’re in your MetaMask wallet.'],items:[{href:'https://radarrelay.com',name:'RadarRelay',img:'publicAssets/icons/logo-RadarRelay.svg'},{href:'https://uniswap.io',name:'Uniswap',img:'publicAssets/icons/logo-Uniswap.svg'},{href:'https://poloniex.com',name:'Poloniex',img:'publicAssets/icons/logo-Poloniex.svg'}]},{h:'Gas (Ethereum)',hSub:'Step 3',color:'#F48068',itemColor:'#DB654D',p:['The final thing you need is a small amount of Ether (ETH) in your MetaMask wallet to carry out a cartographer’s tasks.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main3-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main3-p-br2'}),'The FOAM Map runs on the Ethereum blockchain to enable a decentralized map. Gas is needed to pay for transactions on the blockchain. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://mapguide.foam.space/gas',target:'_blank',key:'map-featureSteps-main3-p-a1',rel:'noopener noreferrer'},'Read more')],items:[{href:'https://coinbase.com',name:'Coinbase',img:'publicAssets/icons/logo-Coinbase.svg'},{href:'https://gemini.com',name:'Gemini',img:'publicAssets/icons/logo-Gemini.svg'},{href:'https://kraken.com',name:'Kraken',img:'publicAssets/icons/logo-Kraken.svg'}]},{h:'Start Mapping!',hSub:'Step 4',color:'transparent',itemColor:'',p:['That’s everything! Now you’re ready to get started.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main4-p-br1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{key:'map-featureSteps-main4-p-br2'}),Object(__WEBPACK_IMPORTED_MODULE_4__Components_Links__["c" /* addCTAs */])({path:'https://map.foam.space',text:'Go to FOAM Map',type:'EXTERNAL',onClickHandler:function onClickHandler(){return __WEBPACK_IMPORTED_MODULE_5_react_ga__["a" /* default */].event({category:'cta_click',action:'go_to_foam_map'});}})],splash:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Views_Home_SpatialIndex__["a" /* SpatialIndexShowcase */],{currentSectionKey:'spatialIndex'})}]}];

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SpatialIndexShowcase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Aside__ = __webpack_require__(25);
function SpatialIndex(_ref){var content=_ref.content,currentSectionKey=_ref.currentSectionKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'spatialIndex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quasi-iso-mask-top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quasi-iso-mask-bottom'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_Aside__["b" /* MainAside */],{content:content.main}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpatialIndexShowcase,{currentSectionKey:currentSectionKey}));}function SpatialIndexShowcase(_ref2){var currentSectionKey=_ref2.currentSectionKey;var expandClass=currentSectionKey==='spatialIndex'?'spatialIndex-expand':'';var expandBubble_1=currentSectionKey==='spatialIndex'?'expand-1':'no-expand-1';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spatialIndexShowcase-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'spatialIndexBubble '+expandBubble_1,src:'/publicAssets/newlab-poi.png',alt:'bubble'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spatialIndexShowcase-ground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spatialIndexShowcase-layer-1',className:expandClass}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spatialIndexShowcase-layer-2',className:expandClass}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spatialIndexShowcase-layer-3',className:expandClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'spatialIndexScreencap',src:'/bigAssets/spatialIndex.png',alt:'Spatial Index'}))));}/* harmony default export */ __webpack_exports__["b"] = (SpatialIndex);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function FeatureSteps(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'FeatureSteps',className:'FeatureSteps'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.main.map(function(content,_idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureStepsItem,{key:'FeatureStepsItem-'+_idx,content:content});}));}function FeatureStepsItem(_ref2){var content=_ref2.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureSteps-item',style:{backgroundColor:content.color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.hSub),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureSteps-itemContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),content.items&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureSteps-itemContentItems'},content.items.map(function(_ref3,_idx){var href=_ref3.href,name=_ref3.name,img=_ref3.img;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:href,key:'FeatureSteps-itemContentItem-'+_idx,target:'_blank',className:'FeatureSteps-itemContentItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureSteps-itemContentItemImg',style:{backgroundColor:content.itemColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:img,alt:name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,name));}))),content.splash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeatureSteps-splash'},content.splash));}/* harmony default export */ __webpack_exports__["a"] = (FeatureSteps);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return location; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_ga__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Views_Home_Hero__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Views_Home_MapStory__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Views_Home_FeaturesTwo__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Views_Home_FeaturesBordered__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps__ = __webpack_require__(187);
// Import Sections
var location=[{key:'hero',component:__WEBPACK_IMPORTED_MODULE_2__Views_Home_Hero__["a" /* default */],color:'LIGHT',shadow:true,main:{h:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/foam-location-2-line.svg',alt:''}),p:'A permissionless and autonomous network of radios that offer secure location services through time synchronization, independent of centralized sources like GPS.',cta:[{path:'https://foam.space/publicAssets/FOAM_Whitepaper.pdf',text:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/btnLocation.svg',alt:''}),type:'EXTERNAL-IMAGE',new:false,onClickHandler:function onClickHandler(){return __WEBPACK_IMPORTED_MODULE_0_react_ga__["a" /* default */].event({category:'cta_click',action:'home_start_mapping'});}}],justification:'LEFT',width:'NARROW'},video:{src:'/bigAssets/Foam_15sec.mp4',alt:'Your browser does not support the video tag.'}},{key:'featuresTwo',component:__WEBPACK_IMPORTED_MODULE_4__Views_Home_FeaturesTwo__["a" /* default */],color:'LIGHT',main:[{h:'Host the future of location data.',p:'A community owned and operated network. Service providers are rewarded for setting up and maintaining radio beacons.',img:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/icons/location_1.svg',alt:''})},{h:'Own your location network.',p:'The FOAM token grants the right to offer location services and safety deposits ensure service providers can be trusted.',img:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/icons/location_2.svg',alt:''})},{h:'A fault-tolerant system.',p:'Location customers receive accurate and secure location data even when part of the network is down.',img:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/icons/location_3.svg',alt:''})},{h:'Low power. Long range.',p:'FOAM Location is optimized for Low-Power Wide-Area Network technology that cover large distances with minimal power consumption.',img:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/publicAssets/icons/location_4.svg',alt:''})}]},{key:'mapStory',component:__WEBPACK_IMPORTED_MODULE_3__Views_Home_MapStory__["a" /* default */],color:'DARK',main:{h:'Foam is Cartography, Cryptographically.',p:'We are designing a shared spatial language for open decentralized systems and smart contracts. FOAM is working on geospatial protocol and the resulting market implications on global infrastructures.',cta:{path:'https://blog.foam.space/',text:'Learn More on Our Blog',type:'EXTERNAL'},icn:{src:'/publicAssets/icons/intro.png',alt:''},justification:'LEFT',width:'NARROW'},sub:{h:'',p:'',cta:{path:'',text:'',type:''},justification:'LEFT',width:'WIDE'},steps:__WEBPACK_IMPORTED_MODULE_6__steps__["a" /* steps */]},{key:'featuresBordered',component:__WEBPACK_IMPORTED_MODULE_5__Views_Home_FeaturesBordered__["a" /* default */],color:'DARK',shadow:true,h:'How do I participate in FOAM Location?',main:[{h:'Signal.',color:'#FFC700',p:'Create a signal on the FOAM Map to show where you need decentralized location services most. Signals hold FOAM Tokens in smart contracts linked to a particular area. This indicates the demand for location services and incentivizes participants to expand the coverage of FOAM Location.',cta:{href:'https://map.foam.space',text:['map.foam.space']}},{h:'Offer location services.',color:'#27AE60',p:'To become a location service provider you need to host radio hardware (LPWAN) and stake a safety deposit of FOAM tokens. A safety deposit of FOAM tokens ensures that everyone follows the rules of offering location services. You will receive FOAM tokens and fees for verifying the locations of customers and for providing work for the network.',cta:{href:'https://cqnllvd8gl2.typeform.com/to/EKlKIoEe',text:['Sign up to be notified for the next batch']}}]}];

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mapbox_gl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_nodes_json__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_nodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_nodes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_networkLines_json__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_networkLines_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_networkLines_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_triangles_json__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_triangles_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__data_triangles_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_pingMapLines_json__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_pingMapLines_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_pingMapLines_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_pingMapNodes_json__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_pingMapNodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__data_pingMapNodes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_pingMapPolygons_json__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_pingMapPolygons_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__data_pingMapPolygons_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_map_car_png__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_map_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_map_car_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var STYLE='mapbox://styles/mapbox/dark-v9';var pink='rgb(244, 128, 103)';// const darkPink = 'rgb(164, 96, 81)'
var blue='rgb(47, 128, 237)';// const darkBlue = 'rgb(25, 73, 138)'
var green='#27AE60';// const darkGreen = '#17703d'
var viewport={altitude:1,longitude:-73.974423,latitude:40.699154,zoom:12,minZoom:1,maxZoom:17,pitch:40.5,bearing:-27.396674584323023};var MapStory=function(_Component){_inherits(MapStory,_Component);function MapStory(props){_classCallCheck(this,MapStory);var _this=_possibleConstructorReturn(this,(MapStory.__proto__||Object.getPrototypeOf(MapStory)).call(this,props));_this.componentWillMount=function(){var options={passive:Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* detectPassiveEventSupport */])()};window.addEventListener('resize',function(){return _this.resizeMapToViewport();},options);};_this.componentDidMount=function(){var mapboxSupport=__WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.supported();if(window.innerWidth>760&&mapboxSupport){__WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.accessToken="pk.eyJ1Ijoia2VqYWNlIiwiYSI6ImNqZ2NlZ3ZrdzNmMGIzMnFkdXh2dGIzY3QifQ.1Ytkor_lU5hORL0jK9KpOw";_this.map=new __WEBPACK_IMPORTED_MODULE_1_mapbox_gl___default.a.Map({container:'mapbox-map',// container id
style:STYLE,center:[-73.98,40.741],zoom:12,bearing:0,pitch:0,interactive:false,transition:{duration:1500,delay:0}});_this.map.on('load',_this.addLayers);}else if(window.innerWidth>760&&!mapboxSupport){_this.setState({showFallback:true});}};_this.componentWillUnmount=function(){window.removeEventListener('resize',_this.resizeMapToViewport);};_this.resizeMapToViewport=function(){var width=window.innerWidth*0.5;var height=window.innerHeight;_this.setState({width:width,height:height});};_this.mergeViewport=function(newViewport){return Object.assign({},Object.assign({},viewport),Object.assign({},newViewport));};_this.addMapSteps=function(steps){return steps.map(function(step){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MapTile,{key:step.key,step:step});});};_this.addLayers=function(){_this.map.addSource('nodeData',{data:__WEBPACK_IMPORTED_MODULE_4__data_nodes_json___default.a,type:'geojson'});_this.map.addSource('networkLines',{data:__WEBPACK_IMPORTED_MODULE_5__data_networkLines_json___default.a,type:'geojson'});_this.map.addSource('polygons',{data:__WEBPACK_IMPORTED_MODULE_7__data_triangles_json___default.a,type:'geojson'});_this.map.addSource('routeLines',{data:__WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json___default.a,type:'geojson'});_this.map.addSource('carOne',{type:'geojson',data:_this.movePoint(0,0)});_this.map.addSource('pingLinesPerFrame',{type:'geojson',data:_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_8__data_pingMapLines_json___default.a,_this.frameCount)});_this.map.addSource('pingNodesPerFrame',{type:'geojson',data:_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_9__data_pingMapNodes_json___default.a,_this.frameCount)});_this.map.addSource('pingPolygonsPerFrame',{type:'geojson',data:_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_10__data_pingMapPolygons_json___default.a,_this.frameCount)});_this.map.addLayer({id:'polygons',type:'fill',source:'polygons',paint:{'fill-color':blue,'fill-opacity':0}});_this.map.addLayer({id:'ping-polygons',type:'fill',source:'pingPolygonsPerFrame',paint:{'fill-color':blue,'fill-opacity':0}});_this.map.addLayer({id:'nodes-heatmap',type:'circle',source:'nodeData',layout:{visibility:'visible'},paint:{'circle-blur':5,'circle-color':['match',['get','color'],'blue',blue,'pink','rgba(0,0,0,0)','green','rgba(0,0,0,0)',blue],'circle-radius':60,'circle-opacity':1,'circle-radius-transition':{duration:1000,delay:0}}});_this.map.addLayer({id:'routeLines',type:'line',source:'routeLines',layout:{visibility:'visible','line-cap':'round'},paint:{'line-color':pink,'line-width':8,'line-opacity':0}});_this.map.addLayer({id:'network',type:'line',source:'networkLines',layout:{visibility:'visible','line-cap':'round'},paint:{'line-color':blue,'line-width':1,'line-opacity':0,'line-dasharray':[1,2],'line-opacity-transition':{duration:1000,delay:500},'line-dasharray-transition':{duration:1000,delay:2000}}});_this.map.addLayer({id:'ping-lines',type:'line',source:'pingLinesPerFrame',layout:{visibility:'visible','line-cap':'round'},paint:{'line-color':green,'line-width':4,'line-opacity':0,'line-dasharray':[1,2]}});_this.map.addLayer({id:'ping-nodes',type:'circle',source:'pingNodesPerFrame',layout:{visibility:'visible'},paint:{'circle-blur':1,'circle-color':['match',['get','color'],'blue',blue,'pink',pink,'green',green,blue],'circle-radius':45,'circle-opacity':0,'circle-radius-transition':{duration:400,delay:0}}});_this.map.addLayer({id:'nodes',type:'circle',source:'nodeData',layout:{visibility:'visible'},paint:{'circle-pitch-alignment':'map','circle-color':['match',['get','color'],'blue',blue,'pink',pink,'green',green,blue],'circle-radius':0,'circle-opacity':1}});_this.map.loadImage(__WEBPACK_IMPORTED_MODULE_11__assets_map_car_png___default.a,function(err,img){_this.map.addImage('sprite',img);_this.map.addLayer({id:'car',type:'symbol',source:'carOne',layout:{'icon-image':'sprite','icon-rotation-alignment':'map','icon-size':0.8}});_this.setState({mapLoaded:true});});};_this.componentWillReceiveProps=function(nextProps){if(nextProps.currentMapIndex!==_this.props.currentMapIndex){var content=_this.props.content;var currentStep=content.steps[nextProps.currentMapIndex];viewport=_this.mergeViewport(currentStep.viewport);if(_this.map){_this.map.easeTo({center:[viewport.longitude,viewport.latitude],pitch:viewport.pitch,bearing:viewport.bearing,zoom:viewport.zoom,duration:2000,easing:function easing(t){return t<0.5?2*t*t:-1+(4-2*t)*t;}});}}};_this.animateMarker=function(){if(_this.frameCount<__WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json___default.a.coordinates.length&&_this.props.currentSectionKey==='mapStory'){var segments=__WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json___default.a.coordinates;var currentCarCoord=segments[_this.frameCount];_this.map.getSource('carOne').setData(_this.movePoint(currentCarCoord));_this.map.getSource('routeLines').setData(_this.dropLines());_this.map.getSource('pingLinesPerFrame').setData(_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_8__data_pingMapLines_json___default.a,_this.frameCount));_this.map.getSource('pingNodesPerFrame').setData(_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_9__data_pingMapNodes_json___default.a,_this.frameCount));_this.map.getSource('pingPolygonsPerFrame').setData(_this.incrementFromArray(__WEBPACK_IMPORTED_MODULE_10__data_pingMapPolygons_json___default.a,_this.frameCount));_this.currentAnimationFrameID=requestAnimationFrame(_this.animateMarker);_this.frameCount++;}else{window.cancelAnimationFrame(_this.currentAnimationFrameID);}};_this.movePoint=function(coord){return{type:'Point',coordinates:coord};};_this.dropLines=function(){return{type:'LineString',coordinates:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__data_segmentFrames_json___default.a.coordinates)).slice(_this.frameCount)};};_this.incrementFromArray=function(arr,frame){return arr[frame];};_this.state={mapLoaded:false,width:window.innerWidth*0.5,height:window.innerHeight,showFallback:false};_this.map=null;_this.frameCount=0;_this.currentAnimationFrameID=null;return _this;}_createClass(MapStory,[{key:'render',value:function render(){var _props=this.props,mapLock=_props.mapLock,currentMapIndex=_props.currentMapIndex,content=_props.content;// choose which layers to show
if(this.state.mapLoaded&&this.map){if(currentMapIndex>=0){this.map.setPaintProperty('nodes','circle-radius',3);// this.map.setPaintProperty('nodes-blur', 'circle-radius', 3)
}else{this.map.setPaintProperty('nodes','circle-radius',0);}if(currentMapIndex>0){this.map.setPaintProperty('nodes-heatmap','circle-radius',0);this.map.setPaintProperty('nodes','circle-radius',5);this.map.setPaintProperty('network','line-opacity',1);this.map.setPaintProperty('network','line-dasharray',[1]);}else{this.map.setPaintProperty('nodes-heatmap','circle-radius',60);this.map.setPaintProperty('network','line-opacity',0);this.map.setPaintProperty('network','line-dasharray',[1,2]);}if(currentMapIndex>1){this.map.setPaintProperty('polygons','fill-opacity',0.1);}else{this.map.setPaintProperty('polygons','fill-opacity',0);}if(currentMapIndex>2){this.map.setPaintProperty('ping-polygons','fill-opacity',0.5);this.map.setPaintProperty('polygons','fill-opacity',0.1);this.map.setPaintProperty('routeLines','line-opacity',1);this.map.setPaintProperty('ping-lines','line-opacity',1);this.map.setPaintProperty('ping-nodes','circle-opacity',0.5);this.map.setLayoutProperty('car','icon-size',0.5);this.map.setPaintProperty('nodes','circle-radius',5);this.animateMarker(0);}else{this.map.setPaintProperty('ping-polygons','fill-opacity',0);this.map.setPaintProperty('ping-lines','line-opacity',0);this.map.setPaintProperty('ping-nodes','circle-opacity',0);this.map.setPaintProperty('polygons','fill-color','rgb(47, 128, 237)');this.map.setPaintProperty('routeLines','line-opacity',0);this.map.setLayoutProperty('car','icon-size',0);if(this.currentAnimationFrameID){window.cancelAnimationFrame(this.currentAnimationFrameID);}}}if(currentMapIndex<3){this.frameCount=0;}var showFallbackClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()({showFallback:this.state.showFallback});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'mapStory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mapbox-image-fallback '+showFallbackClasses,src:'/publicAssets/mapStory/fallback-1.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mapbox-image-fallback '+showFallbackClasses,src:'/publicAssets/mapStory/fallback-2.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mapbox-image-fallback '+showFallbackClasses,src:'/publicAssets/mapStory/fallback-3.png',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mapbox-image-fallback '+showFallbackClasses,src:'/publicAssets/mapStory/fallback-4.png',alt:''}),window.innerWidth<760?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mapbox',className:mapLock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mapbox-map'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mapStory-steps-container'},this.addMapSteps(content.steps)));}}]);return MapStory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function MapTile(_ref){var step=_ref.step;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mapTile-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mapTile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mapTile-heading'},step.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Card Icon',className:'smallIcon',src:step.icon.src}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,step.h)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mapTile-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,step.p),step.img?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mapTile-diagram',alt:'diagram',src:step.img.src}):null)));}/* harmony default export */ __webpack_exports__["a"] = (MapStory);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.mapboxgl = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
function geometry(e){var r,t=0;switch(e.type){case"Polygon":return polygonArea(e.coordinates);case"MultiPolygon":for(r=0;r<e.coordinates.length;r++)t+=polygonArea(e.coordinates[r]);return t;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(r=0;r<e.geometries.length;r++)t+=geometry(e.geometries[r]);return t}}function polygonArea(e){var r=0;if(e&&e.length>0){r+=Math.abs(ringArea(e[0]));for(var t=1;t<e.length;t++)r-=Math.abs(ringArea(e[t]))}return r}function ringArea(e){var r,t,n,o,a,i,g,s=0,l=e.length;if(l>2){for(g=0;g<l;g++)g===l-2?(o=l-2,a=l-1,i=0):g===l-1?(o=l-1,a=0,i=1):(o=g,a=g+1,i=g+2),r=e[o],t=e[a],n=e[i],s+=(rad(n[0])-rad(r[0]))*Math.sin(rad(t[1]));s=s*wgs84.RADIUS*wgs84.RADIUS/2}return s}function rad(e){return e*Math.PI/180}var wgs84=_dereq_("wgs84");module.exports.geometry=geometry,module.exports.ring=ringArea;
},{"wgs84":40}],2:[function(_dereq_,module,exports){
!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):t.glMatrix=n()}(this,function(){"use strict";function t(t,n,r){var e=n[0],a=n[1],o=n[2];return t[0]=e*r[0]+a*r[3]+o*r[6],t[1]=e*r[1]+a*r[4]+o*r[7],t[2]=e*r[2]+a*r[5]+o*r[8],t}function n(t,n,r){var e=n[0],a=n[1],o=n[2],u=n[3];return t[0]=r[0]*e+r[4]*a+r[8]*o+r[12]*u,t[1]=r[1]*e+r[5]*a+r[9]*o+r[13]*u,t[2]=r[2]*e+r[6]*a+r[10]*o+r[14]*u,t[3]=r[3]*e+r[7]*a+r[11]*o+r[15]*u,t}function r(){var t=new Float32Array(4);return t[0]=1,t[1]=0,t[2]=0,t[3]=1,t}function e(t,n,r){var e=n[0],a=n[1],o=n[2],u=n[3],i=Math.sin(r),c=Math.cos(r);return t[0]=e*c+o*i,t[1]=a*c+u*i,t[2]=e*-i+o*c,t[3]=a*-i+u*c,t}function a(t,n,r){var e=n[0],a=n[1],o=n[2],u=n[3],i=r[0],c=r[1];return t[0]=e*i,t[1]=a*i,t[2]=o*c,t[3]=u*c,t}function o(){var t=new Float32Array(9);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=1,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t}function u(t,n){var r=Math.sin(n),e=Math.cos(n);return t[0]=e,t[1]=r,t[2]=0,t[3]=-r,t[4]=e,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t}function i(){var t=new Float32Array(16);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function c(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function f(t,n){var r=n[0],e=n[1],a=n[2],o=n[3],u=n[4],i=n[5],c=n[6],f=n[7],v=n[8],s=n[9],l=n[10],M=n[11],h=n[12],m=n[13],y=n[14],d=n[15],p=r*i-e*u,w=r*c-a*u,A=r*f-o*u,F=e*c-a*i,x=e*f-o*i,b=a*f-o*c,g=v*m-s*h,j=v*y-l*h,R=v*d-M*h,X=s*y-l*m,Z=s*d-M*m,k=l*d-M*y,q=p*k-w*Z+A*X+F*R-x*j+b*g;return q?(q=1/q,t[0]=(i*k-c*Z+f*X)*q,t[1]=(a*Z-e*k-o*X)*q,t[2]=(m*b-y*x+d*F)*q,t[3]=(l*x-s*b-M*F)*q,t[4]=(c*R-u*k-f*j)*q,t[5]=(r*k-a*R+o*j)*q,t[6]=(y*A-h*b-d*w)*q,t[7]=(v*b-l*A+M*w)*q,t[8]=(u*Z-i*R+f*g)*q,t[9]=(e*R-r*Z-o*g)*q,t[10]=(h*x-m*A+d*p)*q,t[11]=(s*A-v*x-M*p)*q,t[12]=(i*j-u*X-c*g)*q,t[13]=(r*X-e*j+a*g)*q,t[14]=(m*w-h*F-y*p)*q,t[15]=(v*F-s*w+l*p)*q,t):null}function v(t,n,r){var e=n[0],a=n[1],o=n[2],u=n[3],i=n[4],c=n[5],f=n[6],v=n[7],s=n[8],l=n[9],M=n[10],h=n[11],m=n[12],y=n[13],d=n[14],p=n[15],w=r[0],A=r[1],F=r[2],x=r[3];return t[0]=w*e+A*i+F*s+x*m,t[1]=w*a+A*c+F*l+x*y,t[2]=w*o+A*f+F*M+x*d,t[3]=w*u+A*v+F*h+x*p,w=r[4],A=r[5],F=r[6],x=r[7],t[4]=w*e+A*i+F*s+x*m,t[5]=w*a+A*c+F*l+x*y,t[6]=w*o+A*f+F*M+x*d,t[7]=w*u+A*v+F*h+x*p,w=r[8],A=r[9],F=r[10],x=r[11],t[8]=w*e+A*i+F*s+x*m,t[9]=w*a+A*c+F*l+x*y,t[10]=w*o+A*f+F*M+x*d,t[11]=w*u+A*v+F*h+x*p,w=r[12],A=r[13],F=r[14],x=r[15],t[12]=w*e+A*i+F*s+x*m,t[13]=w*a+A*c+F*l+x*y,t[14]=w*o+A*f+F*M+x*d,t[15]=w*u+A*v+F*h+x*p,t}function s(t,n,r){var e,a,o,u,i,c,f,v,s,l,M,h,m=r[0],y=r[1],d=r[2];return n===t?(t[12]=n[0]*m+n[4]*y+n[8]*d+n[12],t[13]=n[1]*m+n[5]*y+n[9]*d+n[13],t[14]=n[2]*m+n[6]*y+n[10]*d+n[14],t[15]=n[3]*m+n[7]*y+n[11]*d+n[15]):(e=n[0],a=n[1],o=n[2],u=n[3],i=n[4],c=n[5],f=n[6],v=n[7],s=n[8],l=n[9],M=n[10],h=n[11],t[0]=e,t[1]=a,t[2]=o,t[3]=u,t[4]=i,t[5]=c,t[6]=f,t[7]=v,t[8]=s,t[9]=l,t[10]=M,t[11]=h,t[12]=e*m+i*y+s*d+n[12],t[13]=a*m+c*y+l*d+n[13],t[14]=o*m+f*y+M*d+n[14],t[15]=u*m+v*y+h*d+n[15]),t}function l(t,n,r){var e=r[0],a=r[1],o=r[2];return t[0]=n[0]*e,t[1]=n[1]*e,t[2]=n[2]*e,t[3]=n[3]*e,t[4]=n[4]*a,t[5]=n[5]*a,t[6]=n[6]*a,t[7]=n[7]*a,t[8]=n[8]*o,t[9]=n[9]*o,t[10]=n[10]*o,t[11]=n[11]*o,t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],t}function M(t,n,r){var e=Math.sin(r),a=Math.cos(r),o=n[4],u=n[5],i=n[6],c=n[7],f=n[8],v=n[9],s=n[10],l=n[11];return n!==t&&(t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15]),t[4]=o*a+f*e,t[5]=u*a+v*e,t[6]=i*a+s*e,t[7]=c*a+l*e,t[8]=f*a-o*e,t[9]=v*a-u*e,t[10]=s*a-i*e,t[11]=l*a-c*e,t}function h(t,n,r){var e=Math.sin(r),a=Math.cos(r),o=n[0],u=n[1],i=n[2],c=n[3],f=n[4],v=n[5],s=n[6],l=n[7];return n!==t&&(t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15]),t[0]=o*a+f*e,t[1]=u*a+v*e,t[2]=i*a+s*e,t[3]=c*a+l*e,t[4]=f*a-o*e,t[5]=v*a-u*e,t[6]=s*a-i*e,t[7]=l*a-c*e,t}function m(t,n,r,e,a){var o=1/Math.tan(n/2),u=1/(e-a);return t[0]=o/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=(a+e)*u,t[11]=-1,t[12]=0,t[13]=0,t[14]=2*a*e*u,t[15]=0,t}function y(t,n,r,e,a,o,u){var i=1/(n-r),c=1/(e-a),f=1/(o-u);return t[0]=-2*i,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*c,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*f,t[11]=0,t[12]=(n+r)*i,t[13]=(a+e)*c,t[14]=(u+o)*f,t[15]=1,t}(function(){var t=new Float32Array(3);t[0]=0,t[1]=0,t[2]=0})(),function(){var t=new Float32Array(4);t[0]=0,t[1]=0,t[2]=0,t[3]=0}();return{vec3:{transformMat3:t},vec4:{transformMat4:n},mat2:{create:r,rotate:e,scale:a},mat3:{create:o,fromRotation:u},mat4:{create:i,identity:c,translate:s,scale:l,multiply:v,perspective:m,rotateX:M,rotateZ:h,invert:f,ortho:y}}});
},{}],3:[function(_dereq_,module,exports){
"use strict";function isSupported(e){return!!(isBrowser()&&isArraySupported()&&isFunctionSupported()&&isObjectSupported()&&isJSONSupported()&&isWorkerSupported()&&isUint8ClampedArraySupported()&&isWebGLSupportedCached(e&&e.failIfMajorPerformanceCaveat))}function isBrowser(){return"undefined"!=typeof window&&"undefined"!=typeof document}function isArraySupported(){return Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray}function isFunctionSupported(){return Function.prototype&&Function.prototype.bind}function isObjectSupported(){return Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions}function isJSONSupported(){return"JSON"in window&&"parse"in JSON&&"stringify"in JSON}function isWorkerSupported(){if(!("Worker"in window&&"Blob"in window))return!1;var e,t,r=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(r);try{t=new Worker(o),e=!0}catch(t){e=!1}return t&&t.terminate(),URL.revokeObjectURL(o),e}function isUint8ClampedArraySupported(){return"Uint8ClampedArray"in window}function isWebGLSupportedCached(e){return void 0===isWebGLSupportedCache[e]&&(isWebGLSupportedCache[e]=isWebGLSupported(e)),isWebGLSupportedCache[e]}function isWebGLSupported(e){var t=document.createElement("canvas"),r=Object.create(isSupported.webGLContextAttributes);return r.failIfMajorPerformanceCaveat=e,t.probablySupportsContext?t.probablySupportsContext("webgl",r)||t.probablySupportsContext("experimental-webgl",r):t.supportsContext?t.supportsContext("webgl",r)||t.supportsContext("experimental-webgl",r):t.getContext("webgl",r)||t.getContext("experimental-webgl",r)}"undefined"!=typeof module&&module.exports?module.exports=isSupported:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=isSupported);var isWebGLSupportedCache={};isSupported.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};
},{}],4:[function(_dereq_,module,exports){
"use strict";function Point(t,n){this.x=t,this.y=n}module.exports=Point,Point.prototype={clone:function(){return new Point(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,n){return this.clone()._rotateAround(t,n)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var n=t.x-this.x,i=t.y-this.y;return n*n+i*i},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,n){return Math.atan2(this.x*n-this.y*t,this.x*t+this.y*n)},_matMult:function(t){var n=t[0]*this.x+t[1]*this.y,i=t[2]*this.x+t[3]*this.y;return this.x=n,this.y=i,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var n=Math.cos(t),i=Math.sin(t),s=n*this.x-i*this.y,r=i*this.x+n*this.y;return this.x=s,this.y=r,this},_rotateAround:function(t,n){var i=Math.cos(t),s=Math.sin(t),r=n.x+i*(this.x-n.x)-s*(this.y-n.y),h=n.y+s*(this.x-n.x)+i*(this.y-n.y);return this.x=r,this.y=h,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},Point.convert=function(t){return t instanceof Point?t:Array.isArray(t)?new Point(t[0],t[1]):t};
},{}],5:[function(_dereq_,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ShelfPack=e()}(this,function(){function t(t,e,i){i=i||{},this.w=t||64,this.h=e||64,this.autoResize=!!i.autoResize,this.shelves=[],this.freebins=[],this.stats={},this.bins={},this.maxId=0}function e(t,e,i){this.x=0,this.y=t,this.w=this.free=e,this.h=i}function i(t,e,i,s,h,n,r){this.id=t,this.x=e,this.y=i,this.w=s,this.h=h,this.maxw=n||s,this.maxh=r||h,this.refcount=0}return t.prototype.pack=function(t,e){t=[].concat(t),e=e||{};for(var i,s,h,n,r=[],f=0;f<t.length;f++)if(i=t[f].w||t[f].width,s=t[f].h||t[f].height,h=t[f].id,i&&s){if(!(n=this.packOne(i,s,h)))continue;e.inPlace&&(t[f].x=n.x,t[f].y=n.y,t[f].id=n.id),r.push(n)}return this.shrink(),r},t.prototype.packOne=function(t,i,s){var h,n,r,f,o={freebin:-1,shelf:-1,waste:1/0},a=0;if("string"==typeof s||"number"==typeof s){if(h=this.getBin(s))return this.ref(h),h;"number"==typeof s&&(this.maxId=Math.max(s,this.maxId))}else s=++this.maxId;for(f=0;f<this.freebins.length;f++){if(h=this.freebins[f],i===h.maxh&&t===h.maxw)return this.allocFreebin(f,t,i,s);i>h.maxh||t>h.maxw||i<=h.maxh&&t<=h.maxw&&(r=h.maxw*h.maxh-t*i)<o.waste&&(o.waste=r,o.freebin=f)}for(f=0;f<this.shelves.length;f++)if(n=this.shelves[f],a+=n.h,!(t>n.free)){if(i===n.h)return this.allocShelf(f,t,i,s);i>n.h||i<n.h&&(r=(n.h-i)*t)<o.waste&&(o.freebin=-1,o.waste=r,o.shelf=f)}if(-1!==o.freebin)return this.allocFreebin(o.freebin,t,i,s);if(-1!==o.shelf)return this.allocShelf(o.shelf,t,i,s);if(i<=this.h-a&&t<=this.w)return n=new e(a,this.w,i),this.allocShelf(this.shelves.push(n)-1,t,i,s);if(this.autoResize){var u,l,c,p;return u=l=this.h,c=p=this.w,(c<=u||t>c)&&(p=2*Math.max(t,c)),(u<c||i>u)&&(l=2*Math.max(i,u)),this.resize(p,l),this.packOne(t,i,s)}return null},t.prototype.allocFreebin=function(t,e,i,s){var h=this.freebins.splice(t,1)[0];return h.id=s,h.w=e,h.h=i,h.refcount=0,this.bins[s]=h,this.ref(h),h},t.prototype.allocShelf=function(t,e,i,s){var h=this.shelves[t],n=h.alloc(e,i,s);return this.bins[s]=n,this.ref(n),n},t.prototype.shrink=function(){if(this.shelves.length>0){for(var t=0,e=0,i=0;i<this.shelves.length;i++){var s=this.shelves[i];e+=s.h,t=Math.max(s.w-s.free,t)}this.resize(t,e)}},t.prototype.getBin=function(t){return this.bins[t]},t.prototype.ref=function(t){if(1==++t.refcount){var e=t.h;this.stats[e]=1+(0|this.stats[e])}return t.refcount},t.prototype.unref=function(t){return 0===t.refcount?0:(0==--t.refcount&&(this.stats[t.h]--,delete this.bins[t.id],this.freebins.push(t)),t.refcount)},t.prototype.clear=function(){this.shelves=[],this.freebins=[],this.stats={},this.bins={},this.maxId=0},t.prototype.resize=function(t,e){this.w=t,this.h=e;for(var i=0;i<this.shelves.length;i++)this.shelves[i].resize(t);return!0},e.prototype.alloc=function(t,e,s){if(t>this.free||e>this.h)return null;var h=this.x;return this.x+=t,this.free-=t,new i(s,h,this.y,t,e,t,this.h)},e.prototype.resize=function(t){return this.free+=t-this.w,this.w=t,!0},t});
},{}],6:[function(_dereq_,module,exports){
"use strict";function TinySDF(t,i,s,e,h,r){this.fontSize=t||24,this.buffer=void 0===i?3:i,this.cutoff=e||.25,this.fontFamily=h||"sans-serif",this.fontWeight=r||"normal",this.radius=s||8;var a=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=a,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(a*a),this.gridInner=new Float64Array(a*a),this.f=new Float64Array(a),this.d=new Float64Array(a),this.z=new Float64Array(a+1),this.v=new Int16Array(a),this.middle=Math.round(a/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1))}function edt(t,i,s,e,h,r,a){for(var n=0;n<i;n++){for(var o=0;o<s;o++)e[o]=t[o*i+n];for(edt1d(e,h,r,a,s),o=0;o<s;o++)t[o*i+n]=h[o]}for(o=0;o<s;o++){for(n=0;n<i;n++)e[n]=t[o*i+n];for(edt1d(e,h,r,a,i),n=0;n<i;n++)t[o*i+n]=Math.sqrt(h[n])}}function edt1d(t,i,s,e,h){s[0]=0,e[0]=-INF,e[1]=+INF;for(var r=1,a=0;r<h;r++){for(var n=(t[r]+r*r-(t[s[a]]+s[a]*s[a]))/(2*r-2*s[a]);n<=e[a];)a--,n=(t[r]+r*r-(t[s[a]]+s[a]*s[a]))/(2*r-2*s[a]);a++,s[a]=r,e[a]=n,e[a+1]=+INF}for(r=0,a=0;r<h;r++){for(;e[a+1]<r;)a++;i[r]=(r-s[a])*(r-s[a])+t[s[a]]}}module.exports=TinySDF;var INF=1e20;TinySDF.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var i=this.ctx.getImageData(0,0,this.size,this.size),s=new Uint8ClampedArray(this.size*this.size),e=0;e<this.size*this.size;e++){var h=i.data[4*e+3]/255;this.gridOuter[e]=1===h?0:0===h?INF:Math.pow(Math.max(0,.5-h),2),this.gridInner[e]=1===h?INF:0===h?0:Math.pow(Math.max(0,h-.5),2)}for(edt(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),edt(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),e=0;e<this.size*this.size;e++){var r=this.gridOuter[e]-this.gridInner[e];s[e]=Math.max(0,Math.min(255,Math.round(255-255*(r/this.radius+this.cutoff))))}return s};
},{}],7:[function(_dereq_,module,exports){
function UnitBezier(t,i,e,r){this.cx=3*t,this.bx=3*(e-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*i,this.by=3*(r-i)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=r,this.p2x=e,this.p2y=r}module.exports=UnitBezier,UnitBezier.prototype.sampleCurveX=function(t){return((this.ax*t+this.bx)*t+this.cx)*t},UnitBezier.prototype.sampleCurveY=function(t){return((this.ay*t+this.by)*t+this.cy)*t},UnitBezier.prototype.sampleCurveDerivativeX=function(t){return(3*this.ax*t+2*this.bx)*t+this.cx},UnitBezier.prototype.solveCurveX=function(t,i){void 0===i&&(i=1e-6);var e,r,s,h,n;for(s=t,n=0;n<8;n++){if(h=this.sampleCurveX(s)-t,Math.abs(h)<i)return s;var u=this.sampleCurveDerivativeX(s);if(Math.abs(u)<1e-6)break;s-=h/u}if(e=0,r=1,(s=t)<e)return e;if(s>r)return r;for(;e<r;){if(h=this.sampleCurveX(s),Math.abs(h-t)<i)return s;t>h?e=s:r=s,s=.5*(r-e)+e}return s},UnitBezier.prototype.solve=function(t,i){return this.sampleCurveY(this.solveCurveX(t,i))};
},{}],8:[function(_dereq_,module,exports){
module.exports.VectorTile=_dereq_("./lib/vectortile.js"),module.exports.VectorTileFeature=_dereq_("./lib/vectortilefeature.js"),module.exports.VectorTileLayer=_dereq_("./lib/vectortilelayer.js");
},{"./lib/vectortile.js":9,"./lib/vectortilefeature.js":10,"./lib/vectortilelayer.js":11}],9:[function(_dereq_,module,exports){
"use strict";function VectorTile(e,r){this.layers=e.readFields(readTile,{},r)}function readTile(e,r,i){if(3===e){var t=new VectorTileLayer(i,i.readVarint()+i.pos);t.length&&(r[t.name]=t)}}var VectorTileLayer=_dereq_("./vectortilelayer");module.exports=VectorTile;
},{"./vectortilelayer":11}],10:[function(_dereq_,module,exports){
"use strict";function VectorTileFeature(e,t,r,a,i){this.properties={},this.extent=r,this.type=0,this._pbf=e,this._geometry=-1,this._keys=a,this._values=i,e.readFields(readFeature,this,t)}function readFeature(e,t,r){1==e?t.id=r.readVarint():2==e?readTag(r,t):3==e?t.type=r.readVarint():4==e&&(t._geometry=r.pos)}function readTag(e,t){for(var r=e.readVarint()+e.pos;e.pos<r;){var a=t._keys[e.readVarint()],i=t._values[e.readVarint()];t.properties[a]=i}}function classifyRings(e){var t=e.length;if(t<=1)return[e];for(var r,a,i=[],o=0;o<t;o++){var n=signedArea(e[o]);0!==n&&(void 0===a&&(a=n<0),a===n<0?(r&&i.push(r),r=[e[o]]):r.push(e[o]))}return r&&i.push(r),i}function signedArea(e){for(var t,r,a=0,i=0,o=e.length,n=o-1;i<o;n=i++)t=e[i],r=e[n],a+=(r.x-t.x)*(t.y+r.y);return a}var Point=_dereq_("@mapbox/point-geometry");module.exports=VectorTileFeature,VectorTileFeature.types=["Unknown","Point","LineString","Polygon"],VectorTileFeature.prototype.loadGeometry=function(){var e=this._pbf;e.pos=this._geometry;for(var t,r=e.readVarint()+e.pos,a=1,i=0,o=0,n=0,s=[];e.pos<r;){if(!i){var p=e.readVarint();a=7&p,i=p>>3}if(i--,1===a||2===a)o+=e.readSVarint(),n+=e.readSVarint(),1===a&&(t&&s.push(t),t=[]),t.push(new Point(o,n));else{if(7!==a)throw new Error("unknown command "+a);t&&t.push(t[0].clone())}}return t&&s.push(t),s},VectorTileFeature.prototype.bbox=function(){var e=this._pbf;e.pos=this._geometry;for(var t=e.readVarint()+e.pos,r=1,a=0,i=0,o=0,n=1/0,s=-1/0,p=1/0,h=-1/0;e.pos<t;){if(!a){var u=e.readVarint();r=7&u,a=u>>3}if(a--,1===r||2===r)i+=e.readSVarint(),o+=e.readSVarint(),i<n&&(n=i),i>s&&(s=i),o<p&&(p=o),o>h&&(h=o);else if(7!==r)throw new Error("unknown command "+r)}return[n,p,s,h]},VectorTileFeature.prototype.toGeoJSON=function(e,t,r){function a(e){for(var t=0;t<e.length;t++){var r=e[t],a=180-360*(r.y+p)/n;e[t]=[360*(r.x+s)/n-180,360/Math.PI*Math.atan(Math.exp(a*Math.PI/180))-90]}}var i,o,n=this.extent*Math.pow(2,r),s=this.extent*e,p=this.extent*t,h=this.loadGeometry(),u=VectorTileFeature.types[this.type];switch(this.type){case 1:var d=[];for(i=0;i<h.length;i++)d[i]=h[i][0];h=d,a(h);break;case 2:for(i=0;i<h.length;i++)a(h[i]);break;case 3:for(h=classifyRings(h),i=0;i<h.length;i++)for(o=0;o<h[i].length;o++)a(h[i][o])}1===h.length?h=h[0]:u="Multi"+u;var f={type:"Feature",geometry:{type:u,coordinates:h},properties:this.properties};return"id"in this&&(f.id=this.id),f};
},{"@mapbox/point-geometry":4}],11:[function(_dereq_,module,exports){
"use strict";function VectorTileLayer(e,t){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=e,this._keys=[],this._values=[],this._features=[],e.readFields(readLayer,this,t),this.length=this._features.length}function readLayer(e,t,r){15===e?t.version=r.readVarint():1===e?t.name=r.readString():5===e?t.extent=r.readVarint():2===e?t._features.push(r.pos):3===e?t._keys.push(r.readString()):4===e&&t._values.push(readValueMessage(r))}function readValueMessage(e){for(var t=null,r=e.readVarint()+e.pos;e.pos<r;){var a=e.readVarint()>>3;t=1===a?e.readString():2===a?e.readFloat():3===a?e.readDouble():4===a?e.readVarint64():5===a?e.readVarint():6===a?e.readSVarint():7===a?e.readBoolean():null}return t}var VectorTileFeature=_dereq_("./vectortilefeature.js");module.exports=VectorTileLayer,VectorTileLayer.prototype.feature=function(e){if(e<0||e>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[e];var t=this._pbf.readVarint()+this._pbf.pos;return new VectorTileFeature(this._pbf,t,this.extent,this._keys,this._values)};
},{"./vectortilefeature.js":10}],12:[function(_dereq_,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.WhooTS=e.WhooTS||{})}(this,function(e){function t(e,t,r,n,i,s){return s=s||{},e+"?"+["bbox="+o(r,n,i),"format="+(s.format||"image/png"),"service="+(s.service||"WMS"),"version="+(s.version||"1.1.1"),"request="+(s.request||"GetMap"),"srs="+(s.srs||"EPSG:3857"),"width="+(s.width||256),"height="+(s.height||256),"layers="+t].join("&")}function o(e,t,o){t=Math.pow(2,o)-t-1;var n=r(256*e,256*t,o),i=r(256*(e+1),256*(t+1),o);return n[0]+","+n[1]+","+i[0]+","+i[1]}function r(e,t,o){var r=2*Math.PI*6378137/256/Math.pow(2,o);return[e*r-2*Math.PI*6378137/2,t*r-2*Math.PI*6378137/2]}e.getURL=t,e.getTileBBox=o,e.getMercCoords=r,Object.defineProperty(e,"__esModule",{value:!0})});
},{}],13:[function(_dereq_,module,exports){
"use strict";function earcut(e,n,r){r=r||2;var t=n&&n.length,i=t?n[0]*r:e.length,x=linkedList(e,0,i,r,!0),a=[];if(!x)return a;var o,l,u,s,v,f,y;if(t&&(x=eliminateHoles(e,n,x,r)),e.length>80*r){o=u=e[0],l=s=e[1];for(var d=r;d<i;d+=r)v=e[d],f=e[d+1],v<o&&(o=v),f<l&&(l=f),v>u&&(u=v),f>s&&(s=f);y=Math.max(u-o,s-l)}return earcutLinked(x,a,r,o,l,y),a}function linkedList(e,n,r,t,i){var x,a;if(i===signedArea(e,n,r,t)>0)for(x=n;x<r;x+=t)a=insertNode(x,e[x],e[x+1],a);else for(x=r-t;x>=n;x-=t)a=insertNode(x,e[x],e[x+1],a);return a&&equals(a,a.next)&&(removeNode(a),a=a.next),a}function filterPoints(e,n){if(!e)return e;n||(n=e);var r,t=e;do{if(r=!1,t.steiner||!equals(t,t.next)&&0!==area(t.prev,t,t.next))t=t.next;else{if(removeNode(t),(t=n=t.prev)===t.next)return null;r=!0}}while(r||t!==n);return n}function earcutLinked(e,n,r,t,i,x,a){if(e){!a&&x&&indexCurve(e,t,i,x);for(var o,l,u=e;e.prev!==e.next;)if(o=e.prev,l=e.next,x?isEarHashed(e,t,i,x):isEar(e))n.push(o.i/r),n.push(e.i/r),n.push(l.i/r),removeNode(e),e=l.next,u=l.next;else if((e=l)===u){a?1===a?(e=cureLocalIntersections(e,n,r),earcutLinked(e,n,r,t,i,x,2)):2===a&&splitEarcut(e,n,r,t,i,x):earcutLinked(filterPoints(e),n,r,t,i,x,1);break}}}function isEar(e){var n=e.prev,r=e,t=e.next;if(area(n,r,t)>=0)return!1;for(var i=e.next.next;i!==e.prev;){if(pointInTriangle(n.x,n.y,r.x,r.y,t.x,t.y,i.x,i.y)&&area(i.prev,i,i.next)>=0)return!1;i=i.next}return!0}function isEarHashed(e,n,r,t){var i=e.prev,x=e,a=e.next;if(area(i,x,a)>=0)return!1;for(var o=i.x<x.x?i.x<a.x?i.x:a.x:x.x<a.x?x.x:a.x,l=i.y<x.y?i.y<a.y?i.y:a.y:x.y<a.y?x.y:a.y,u=i.x>x.x?i.x>a.x?i.x:a.x:x.x>a.x?x.x:a.x,s=i.y>x.y?i.y>a.y?i.y:a.y:x.y>a.y?x.y:a.y,v=zOrder(o,l,n,r,t),f=zOrder(u,s,n,r,t),y=e.nextZ;y&&y.z<=f;){if(y!==e.prev&&y!==e.next&&pointInTriangle(i.x,i.y,x.x,x.y,a.x,a.y,y.x,y.y)&&area(y.prev,y,y.next)>=0)return!1;y=y.nextZ}for(y=e.prevZ;y&&y.z>=v;){if(y!==e.prev&&y!==e.next&&pointInTriangle(i.x,i.y,x.x,x.y,a.x,a.y,y.x,y.y)&&area(y.prev,y,y.next)>=0)return!1;y=y.prevZ}return!0}function cureLocalIntersections(e,n,r){var t=e;do{var i=t.prev,x=t.next.next;!equals(i,x)&&intersects(i,t,t.next,x)&&locallyInside(i,x)&&locallyInside(x,i)&&(n.push(i.i/r),n.push(t.i/r),n.push(x.i/r),removeNode(t),removeNode(t.next),t=e=x),t=t.next}while(t!==e);return t}function splitEarcut(e,n,r,t,i,x){var a=e;do{for(var o=a.next.next;o!==a.prev;){if(a.i!==o.i&&isValidDiagonal(a,o)){var l=splitPolygon(a,o);return a=filterPoints(a,a.next),l=filterPoints(l,l.next),earcutLinked(a,n,r,t,i,x),void earcutLinked(l,n,r,t,i,x)}o=o.next}a=a.next}while(a!==e)}function eliminateHoles(e,n,r,t){var i,x,a,o,l,u=[];for(i=0,x=n.length;i<x;i++)a=n[i]*t,o=i<x-1?n[i+1]*t:e.length,l=linkedList(e,a,o,t,!1),l===l.next&&(l.steiner=!0),u.push(getLeftmost(l));for(u.sort(compareX),i=0;i<u.length;i++)eliminateHole(u[i],r),r=filterPoints(r,r.next);return r}function compareX(e,n){return e.x-n.x}function eliminateHole(e,n){if(n=findHoleBridge(e,n)){var r=splitPolygon(n,e);filterPoints(r,r.next)}}function findHoleBridge(e,n){var r,t=n,i=e.x,x=e.y,a=-1/0;do{if(x<=t.y&&x>=t.next.y){var o=t.x+(x-t.y)*(t.next.x-t.x)/(t.next.y-t.y);if(o<=i&&o>a){if(a=o,o===i){if(x===t.y)return t;if(x===t.next.y)return t.next}r=t.x<t.next.x?t:t.next}}t=t.next}while(t!==n);if(!r)return null;if(i===a)return r.prev;var l,u=r,s=r.x,v=r.y,f=1/0;for(t=r.next;t!==u;)i>=t.x&&t.x>=s&&pointInTriangle(x<v?i:a,x,s,v,x<v?a:i,x,t.x,t.y)&&((l=Math.abs(x-t.y)/(i-t.x))<f||l===f&&t.x>r.x)&&locallyInside(t,e)&&(r=t,f=l),t=t.next;return r}function indexCurve(e,n,r,t){var i=e;do{null===i.z&&(i.z=zOrder(i.x,i.y,n,r,t)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next}while(i!==e);i.prevZ.nextZ=null,i.prevZ=null,sortLinked(i)}function sortLinked(e){var n,r,t,i,x,a,o,l,u=1;do{for(r=e,e=null,x=null,a=0;r;){for(a++,t=r,o=0,n=0;n<u&&(o++,t=t.nextZ);n++);for(l=u;o>0||l>0&&t;)0===o?(i=t,t=t.nextZ,l--):0!==l&&t?r.z<=t.z?(i=r,r=r.nextZ,o--):(i=t,t=t.nextZ,l--):(i=r,r=r.nextZ,o--),x?x.nextZ=i:e=i,i.prevZ=x,x=i;r=t}x.nextZ=null,u*=2}while(a>1);return e}function zOrder(e,n,r,t,i){return e=32767*(e-r)/i,n=32767*(n-t)/i,e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),n=16711935&(n|n<<8),n=252645135&(n|n<<4),n=858993459&(n|n<<2),n=1431655765&(n|n<<1),e|n<<1}function getLeftmost(e){var n=e,r=e;do{n.x<r.x&&(r=n),n=n.next}while(n!==e);return r}function pointInTriangle(e,n,r,t,i,x,a,o){return(i-a)*(n-o)-(e-a)*(x-o)>=0&&(e-a)*(t-o)-(r-a)*(n-o)>=0&&(r-a)*(x-o)-(i-a)*(t-o)>=0}function isValidDiagonal(e,n){return e.next.i!==n.i&&e.prev.i!==n.i&&!intersectsPolygon(e,n)&&locallyInside(e,n)&&locallyInside(n,e)&&middleInside(e,n)}function area(e,n,r){return(n.y-e.y)*(r.x-n.x)-(n.x-e.x)*(r.y-n.y)}function equals(e,n){return e.x===n.x&&e.y===n.y}function intersects(e,n,r,t){return!!(equals(e,n)&&equals(r,t)||equals(e,t)&&equals(r,n))||area(e,n,r)>0!=area(e,n,t)>0&&area(r,t,e)>0!=area(r,t,n)>0}function intersectsPolygon(e,n){var r=e;do{if(r.i!==e.i&&r.next.i!==e.i&&r.i!==n.i&&r.next.i!==n.i&&intersects(r,r.next,e,n))return!0;r=r.next}while(r!==e);return!1}function locallyInside(e,n){return area(e.prev,e,e.next)<0?area(e,n,e.next)>=0&&area(e,e.prev,n)>=0:area(e,n,e.prev)<0||area(e,e.next,n)<0}function middleInside(e,n){var r=e,t=!1,i=(e.x+n.x)/2,x=(e.y+n.y)/2;do{r.y>x!=r.next.y>x&&i<(r.next.x-r.x)*(x-r.y)/(r.next.y-r.y)+r.x&&(t=!t),r=r.next}while(r!==e);return t}function splitPolygon(e,n){var r=new Node(e.i,e.x,e.y),t=new Node(n.i,n.x,n.y),i=e.next,x=n.prev;return e.next=n,n.prev=e,r.next=i,i.prev=r,t.next=r,r.prev=t,x.next=t,t.prev=x,t}function insertNode(e,n,r,t){var i=new Node(e,n,r);return t?(i.next=t.next,i.prev=t,t.next.prev=i,t.next=i):(i.prev=i,i.next=i),i}function removeNode(e){e.next.prev=e.prev,e.prev.next=e.next,e.prevZ&&(e.prevZ.nextZ=e.nextZ),e.nextZ&&(e.nextZ.prevZ=e.prevZ)}function Node(e,n,r){this.i=e,this.x=n,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1}function signedArea(e,n,r,t){for(var i=0,x=n,a=r-t;x<r;x+=t)i+=(e[a]-e[x])*(e[x+1]+e[a+1]),a=x;return i}module.exports=earcut,earcut.deviation=function(e,n,r,t){var i=n&&n.length,x=i?n[0]*r:e.length,a=Math.abs(signedArea(e,0,x,r));if(i)for(var o=0,l=n.length;o<l;o++){var u=n[o]*r,s=o<l-1?n[o+1]*r:e.length;a-=Math.abs(signedArea(e,u,s,r))}var v=0;for(o=0;o<t.length;o+=3){var f=t[o]*r,y=t[o+1]*r,d=t[o+2]*r;v+=Math.abs((e[f]-e[d])*(e[y+1]-e[f+1])-(e[f]-e[y])*(e[d+1]-e[f+1]))}return 0===a&&0===v?0:Math.abs((v-a)/a)},earcut.flatten=function(e){for(var n=e[0][0].length,r={vertices:[],holes:[],dimensions:n},t=0,i=0;i<e.length;i++){for(var x=0;x<e[i].length;x++)for(var a=0;a<n;a++)r.vertices.push(e[i][x][a]);i>0&&(t+=e[i-1].length,r.holes.push(t))}return r};
},{}],14:[function(_dereq_,module,exports){
function rewind(r,e){switch(r&&r.type||null){case"FeatureCollection":return r.features=r.features.map(curryOuter(rewind,e)),r;case"Feature":return r.geometry=rewind(r.geometry,e),r;case"Polygon":case"MultiPolygon":return correct(r,e);default:return r}}function curryOuter(r,e){return function(n){return r(n,e)}}function correct(r,e){return"Polygon"===r.type?r.coordinates=correctRings(r.coordinates,e):"MultiPolygon"===r.type&&(r.coordinates=r.coordinates.map(curryOuter(correctRings,e))),r}function correctRings(r,e){e=!!e,r[0]=wind(r[0],e);for(var n=1;n<r.length;n++)r[n]=wind(r[n],!e);return r}function wind(r,e){return cw(r)===e?r:r.reverse()}function cw(r){return geojsonArea.ring(r)>=0}var geojsonArea=_dereq_("@mapbox/geojson-area");module.exports=rewind;
},{"@mapbox/geojson-area":1}],15:[function(_dereq_,module,exports){
"use strict";function clip(i,n,e,t,l,r,u){if(e/=n,t/=n,r>=e&&u<=t)return i;if(r>t||u<e)return null;for(var s=[],o=0;o<i.length;o++){var h=i[o],p=h.geometry,c=h.type,a=0===l?h.minX:h.minY,g=0===l?h.maxX:h.maxY;if(a>=e&&g<=t)s.push(h);else if(!(a>t||g<e)){var f=[];if("Point"===c||"MultiPoint"===c)clipPoints(p,f,e,t,l);else if("LineString"===c)clipLine(p,f,e,t,l,!1);else if("MultiLineString"===c)clipLines(p,f,e,t,l,!1);else if("Polygon"===c)clipLines(p,f,e,t,l,!0);else if("MultiPolygon"===c)for(var P=0;P<p.length;P++){var L=[];clipLines(p[P],L,e,t,l,!0),L.length&&f.push(L)}f.length&&("LineString"!==c&&"MultiLineString"!==c||(1===f.length?(c="LineString",f=f[0]):c="MultiLineString"),"Point"!==c&&"MultiPoint"!==c||(c=3===f.length?"Point":"MultiPoint"),s.push(createFeature(h.id,c,f,h.tags)))}}return s.length?s:null}function clipPoints(i,n,e,t,l){for(var r=0;r<i.length;r+=3){var u=i[r+l];u>=e&&u<=t&&(n.push(i[r]),n.push(i[r+1]),n.push(i[r+2]))}}function clipLine(i,n,e,t,l,r){for(var u=[],s=0===l?intersectX:intersectY,o=0;o<i.length-3;o+=3){var h=i[o],p=i[o+1],c=i[o+2],a=i[o+3],g=i[o+4],f=0===l?h:p,P=0===l?a:g,L=!1;f<e?P>=e&&s(u,h,p,a,g,e):f>t?P<=t&&s(u,h,p,a,g,t):addPoint(u,h,p,c),P<e&&f>=e&&(s(u,h,p,a,g,e),L=!0),P>t&&f<=t&&(s(u,h,p,a,g,t),L=!0),!r&&L&&(u.size=i.size,n.push(u),u=[])}var v=i.length-3;h=i[v],p=i[v+1],c=i[v+2],f=0===l?h:p,f>=e&&f<=t&&addPoint(u,h,p,c),v=u.length-3,r&&v>=3&&(u[v]!==u[0]||u[v+1]!==u[1])&&addPoint(u,u[0],u[1],u[2]),u.length&&(u.size=i.size,n.push(u))}function clipLines(i,n,e,t,l,r){for(var u=0;u<i.length;u++)clipLine(i[u],n,e,t,l,r)}function addPoint(i,n,e,t){i.push(n),i.push(e),i.push(t)}function intersectX(i,n,e,t,l,r){i.push(r),i.push(e+(r-n)*(l-e)/(t-n)),i.push(1)}function intersectY(i,n,e,t,l,r){i.push(n+(r-e)*(t-n)/(l-e)),i.push(r),i.push(1)}module.exports=clip;var createFeature=_dereq_("./feature");
},{"./feature":17}],16:[function(_dereq_,module,exports){
"use strict";function convert(e,t){var r=[];if("FeatureCollection"===e.type)for(var o=0;o<e.features.length;o++)convertFeature(r,e.features[o],t);else"Feature"===e.type?convertFeature(r,e,t):convertFeature(r,{geometry:e},t);return r}function convertFeature(e,t,r){if(t.geometry){var o=t.geometry.coordinates,n=t.geometry.type,i=r*r,a=[];if("Point"===n)convertPoint(o,a);else if("MultiPoint"===n)for(var u=0;u<o.length;u++)convertPoint(o[u],a);else if("LineString"===n)convertLine(o,a,i,!1);else if("MultiLineString"===n)convertLines(o,a,i,!1);else if("Polygon"===n)convertLines(o,a,i,!0);else{if("MultiPolygon"!==n){if("GeometryCollection"===n){for(u=0;u<t.geometry.geometries.length;u++)convertFeature(e,{geometry:t.geometry.geometries[u],properties:t.properties},r);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<o.length;u++){var s=[];convertLines(o[u],s,i,!0),a.push(s)}}e.push(createFeature(t.id,n,a,t.properties))}}function convertPoint(e,t){t.push(projectX(e[0])),t.push(projectY(e[1])),t.push(0)}function convertLine(e,t,r,o){for(var n,i,a=0,u=0;u<e.length;u++){var s=projectX(e[u][0]),c=projectY(e[u][1]);t.push(s),t.push(c),t.push(0),u>0&&(a+=o?(n*c-s*i)/2:Math.sqrt(Math.pow(s-n,2)+Math.pow(c-i,2))),n=s,i=c}var p=t.length-3;t[2]=1,simplify(t,0,p,r),t[p+2]=1,t.size=Math.abs(a)}function convertLines(e,t,r,o){for(var n=0;n<e.length;n++){var i=[];convertLine(e[n],i,r,o),t.push(i)}}function projectX(e){return e/360+.5}function projectY(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}module.exports=convert;var simplify=_dereq_("./simplify"),createFeature=_dereq_("./feature");
},{"./feature":17,"./simplify":19}],17:[function(_dereq_,module,exports){
"use strict";function createFeature(e,n,t,i){var a={id:e||null,type:n,geometry:t,tags:i,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return calcBBox(a),a}function calcBBox(e){var n=e.geometry,t=e.type;if("Point"===t||"MultiPoint"===t||"LineString"===t)calcLineBBox(e,n);else if("Polygon"===t||"MultiLineString"===t)for(var i=0;i<n.length;i++)calcLineBBox(e,n[i]);else if("MultiPolygon"===t)for(i=0;i<n.length;i++)for(var a=0;a<n[i].length;a++)calcLineBBox(e,n[i][a])}function calcLineBBox(e,n){for(var t=0;t<n.length;t+=3)e.minX=Math.min(e.minX,n[t]),e.minY=Math.min(e.minY,n[t+1]),e.maxX=Math.max(e.maxX,n[t]),e.maxY=Math.max(e.maxY,n[t+1])}module.exports=createFeature;
},{}],18:[function(_dereq_,module,exports){
"use strict";function geojsonvt(e,t){return new GeoJSONVT(e,t)}function GeoJSONVT(e,t){t=this.options=extend(Object.create(this.options),t);var o=t.debug;if(o&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");var i=1<<t.maxZoom,n=convert(e,t.tolerance/(i*t.extent));this.tiles={},this.tileCoords=[],o&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),n=wrap(n,t.buffer/t.extent),n.length&&this.splitTile(n,0,0,0),o&&(n.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)))}function toID(e,t,o){return 32*((1<<e)*o+t)+e}function extend(e,t){for(var o in t)e[o]=t[o];return e}module.exports=geojsonvt;var convert=_dereq_("./convert"),transform=_dereq_("./transform"),clip=_dereq_("./clip"),wrap=_dereq_("./wrap"),createTile=_dereq_("./tile");GeoJSONVT.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,debug:0},GeoJSONVT.prototype.splitTile=function(e,t,o,i,n,s,l){for(var r=[e,t,o,i],a=this.options,u=a.debug;r.length;){i=r.pop(),o=r.pop(),t=r.pop(),e=r.pop();var m=1<<t,c=toID(t,o,i),p=this.tiles[c],d=t===a.maxZoom?0:a.tolerance/(m*a.extent);if(!p&&(u>1&&console.time("creation"),p=this.tiles[c]=createTile(e,m,o,i,d,t===a.maxZoom),this.tileCoords.push({z:t,x:o,y:i}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,o,i,p.numFeatures,p.numPoints,p.numSimplified),console.timeEnd("creation"));var h="z"+t;this.stats[h]=(this.stats[h]||0)+1,this.total++}if(p.source=e,n){if(t===a.maxZoom||t===n)continue;var x=1<<n-t;if(o!==Math.floor(s/x)||i!==Math.floor(l/x))continue}else if(t===a.indexMaxZoom||p.numPoints<=a.indexMaxPoints)continue;if(p.source=null,0!==e.length){u>1&&console.time("clipping");var f,g,v,Z,T,M,b=.5*a.buffer/a.extent,w=.5-b,Y=.5+b,O=1+b;f=g=v=Z=null,T=clip(e,m,o-b,o+Y,0,p.minX,p.maxX),M=clip(e,m,o+w,o+O,0,p.minX,p.maxX),e=null,T&&(f=clip(T,m,i-b,i+Y,1,p.minY,p.maxY),g=clip(T,m,i+w,i+O,1,p.minY,p.maxY),T=null),M&&(v=clip(M,m,i-b,i+Y,1,p.minY,p.maxY),Z=clip(M,m,i+w,i+O,1,p.minY,p.maxY),M=null),u>1&&console.timeEnd("clipping"),r.push(f||[],t+1,2*o,2*i),r.push(g||[],t+1,2*o,2*i+1),r.push(v||[],t+1,2*o+1,2*i),r.push(Z||[],t+1,2*o+1,2*i+1)}}},GeoJSONVT.prototype.getTile=function(e,t,o){var i=this.options,n=i.extent,s=i.debug;if(e<0||e>24)return null;var l=1<<e;t=(t%l+l)%l;var r=toID(e,t,o);if(this.tiles[r])return transform.tile(this.tiles[r],n);s>1&&console.log("drilling down to z%d-%d-%d",e,t,o);for(var a,u=e,m=t,c=o;!a&&u>0;)u--,m=Math.floor(m/2),c=Math.floor(c/2),a=this.tiles[toID(u,m,c)];return a&&a.source?(s>1&&console.log("found parent tile z%d-%d-%d",u,m,c),s>1&&console.time("drilling down"),this.splitTile(a.source,u,m,c,e,t,o),s>1&&console.timeEnd("drilling down"),this.tiles[r]?transform.tile(this.tiles[r],n):null):null};
},{"./clip":15,"./convert":16,"./tile":20,"./transform":21,"./wrap":22}],19:[function(_dereq_,module,exports){
"use strict";function simplify(i,t,r,s){for(var e,f=s,l=i[t],m=i[t+1],n=i[r],o=i[r+1],p=t+3;p<r;p+=3){var u=getSqSegDist(i[p],i[p+1],l,m,n,o);u>f&&(e=p,f=u)}f>s&&(e-t>3&&simplify(i,t,e,s),i[e+2]=f,r-e>3&&simplify(i,e,r,s))}function getSqSegDist(i,t,r,s,e,f){var l=e-r,m=f-s;if(0!==l||0!==m){var n=((i-r)*l+(t-s)*m)/(l*l+m*m);n>1?(r=e,s=f):n>0&&(r+=l*n,s+=m*n)}return l=i-r,m=t-s,l*l+m*m}module.exports=simplify;
},{}],20:[function(_dereq_,module,exports){
"use strict";function createTile(n,e,i,t,r,u){for(var a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:i,y:t,z2:e,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},l=0;l<n.length;l++){a.numFeatures++,addFeature(a,n[l],r,u);var o=n[l].minX,m=n[l].minY,f=n[l].maxX,s=n[l].maxY;o<a.minX&&(a.minX=o),m<a.minY&&(a.minY=m),f>a.maxX&&(a.maxX=f),s>a.maxY&&(a.maxY=s)}return a}function addFeature(n,e,i,t){var r=e.geometry,u=e.type,a=[];if("Point"===u||"MultiPoint"===u)for(var l=0;l<r.length;l+=3)a.push(r[l]),a.push(r[l+1]),n.numPoints++,n.numSimplified++;else if("LineString"===u)addLine(a,r,n,i,t,!1,!1);else if("MultiLineString"===u||"Polygon"===u)for(l=0;l<r.length;l++)addLine(a,r[l],n,i,t,"Polygon"===u,0===l);else if("MultiPolygon"===u)for(var o=0;o<r.length;o++){var m=r[o];for(l=0;l<m.length;l++)addLine(a,m[l],n,i,t,!0,0===l)}if(a.length){var f={geometry:a,type:"Polygon"===u||"MultiPolygon"===u?3:"LineString"===u||"MultiLineString"===u?2:1,tags:e.tags||null};null!==e.id&&(f.id=e.id),n.features.push(f)}}function addLine(n,e,i,t,r,u,a){var l=t*t;if(!r&&e.size<(u?l:t))return void(i.numPoints+=e.length/3);for(var o=[],m=0;m<e.length;m+=3)(r||e[m+2]>l)&&(i.numSimplified++,o.push(e[m]),o.push(e[m+1])),i.numPoints++;u&&rewind(o,a),n.push(o)}function rewind(n,e){for(var i=0,t=0,r=n.length,u=r-2;t<r;u=t,t+=2)i+=(n[t]-n[u])*(n[t+1]+n[u+1]);if(i>0===e)for(t=0,r=n.length;t<r/2;t+=2){var a=n[t],l=n[t+1];n[t]=n[r-2-t],n[t+1]=n[r-1-t],n[r-2-t]=a,n[r-1-t]=l}}module.exports=createTile;
},{}],21:[function(_dereq_,module,exports){
"use strict";function transformTile(r,t){if(r.transformed)return r;var e,o,n,f=r.z2,s=r.x,a=r.y;for(e=0;e<r.features.length;e++){var i=r.features[e],u=i.geometry,m=i.type;if(i.geometry=[],1===m)for(o=0;o<u.length;o+=2)i.geometry.push(transformPoint(u[o],u[o+1],t,f,s,a));else for(o=0;o<u.length;o++){var h=[];for(n=0;n<u[o].length;n+=2)h.push(transformPoint(u[o][n],u[o][n+1],t,f,s,a));i.geometry.push(h)}}return r.transformed=!0,r}function transformPoint(r,t,e,o,n,f){return[Math.round(e*(r*o-n)),Math.round(e*(t*o-f))]}exports.tile=transformTile,exports.point=transformPoint;
},{}],22:[function(_dereq_,module,exports){
"use strict";function wrap(e,r){var t=e,o=clip(e,1,-1-r,r,0,-1,2),i=clip(e,1,1-r,2+r,0,-1,2);return(o||i)&&(t=clip(e,1,-r,1+r,0,-1,2)||[],o&&(t=shiftFeatureCoords(o,1).concat(t)),i&&(t=t.concat(shiftFeatureCoords(i,-1)))),t}function shiftFeatureCoords(e,r){for(var t=[],o=0;o<e.length;o++){var i,s=e[o],n=s.type;if("Point"===n||"MultiPoint"===n||"LineString"===n)i=shiftCoords(s.geometry,r);else if("MultiLineString"===n||"Polygon"===n){i=[];for(var u=0;u<s.geometry.length;u++)i.push(shiftCoords(s.geometry[u],r))}else if("MultiPolygon"===n)for(i=[],u=0;u<s.geometry.length;u++){for(var a=[],f=0;f<s.geometry[u].length;f++)a.push(shiftCoords(s.geometry[u][f],r));i.push(a)}t.push(createFeature(s.id,n,i,s.tags))}return t}function shiftCoords(e,r){var t=[];t.size=e.size;for(var o=0;o<e.length;o+=3)t.push(e[o]+r,e[o+1],e[o+2]);return t}var clip=_dereq_("./clip"),createFeature=_dereq_("./feature");module.exports=wrap;
},{"./clip":15,"./feature":17}],23:[function(_dereq_,module,exports){
"use strict";function GridIndex(t,r,e){var s=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],r=i[1],e=i[2],this.d=r+2*e;for(var h=0;h<this.d*this.d;h++){var n=i[NUM_PARAMS+h],o=i[NUM_PARAMS+h+1];s.push(n===o?null:i.subarray(n,o))}var l=i[NUM_PARAMS+s.length],a=i[NUM_PARAMS+s.length+1];this.keys=i.subarray(l,a),this.bboxes=i.subarray(a),this.insert=this._insertReadonly}else{this.d=r+2*e;for(var d=0;d<this.d*this.d;d++)s.push([]);this.keys=[],this.bboxes=[]}this.n=r,this.extent=t,this.padding=e,this.scale=r/t,this.uid=0;var f=e/r*t;this.min=-f,this.max=t+f}module.exports=GridIndex;var NUM_PARAMS=3;GridIndex.prototype.insert=function(t,r,e,s,i){this._forEachCell(r,e,s,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(r),this.bboxes.push(e),this.bboxes.push(s),this.bboxes.push(i)},GridIndex.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},GridIndex.prototype._insertCell=function(t,r,e,s,i,h){this.cells[i].push(h)},GridIndex.prototype.query=function(t,r,e,s){var i=this.min,h=this.max;if(t<=i&&r<=i&&h<=e&&h<=s)return Array.prototype.slice.call(this.keys);var n=[],o={};return this._forEachCell(t,r,e,s,this._queryCell,n,o),n},GridIndex.prototype._queryCell=function(t,r,e,s,i,h,n){var o=this.cells[i];if(null!==o)for(var l=this.keys,a=this.bboxes,d=0;d<o.length;d++){var f=o[d];if(void 0===n[f]){var u=4*f;t<=a[u+2]&&r<=a[u+3]&&e>=a[u+0]&&s>=a[u+1]?(n[f]=!0,h.push(l[f])):n[f]=!1}}},GridIndex.prototype._forEachCell=function(t,r,e,s,i,h,n){for(var o=this._convertToCellCoord(t),l=this._convertToCellCoord(r),a=this._convertToCellCoord(e),d=this._convertToCellCoord(s),f=o;f<=a;f++)for(var u=l;u<=d;u++){var y=this.d*u+f;if(i.call(this,t,r,e,s,y,h,n))return}},GridIndex.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},GridIndex.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,r=NUM_PARAMS+this.cells.length+1+1,e=0,s=0;s<this.cells.length;s++)e+=this.cells[s].length;var i=new Int32Array(r+e+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var h=r,n=0;n<t.length;n++){var o=t[n];i[NUM_PARAMS+n]=h,i.set(o,h),h+=o.length}return i[NUM_PARAMS+t.length]=h,i.set(this.keys,h),h+=this.keys.length,i[NUM_PARAMS+t.length+1]=h,i.set(this.bboxes,h),h+=this.bboxes.length,i.buffer};
},{}],24:[function(_dereq_,module,exports){
exports.read=function(a,o,t,r,h){var M,p,w=8*h-r-1,f=(1<<w)-1,e=f>>1,i=-7,N=t?h-1:0,n=t?-1:1,s=a[o+N];for(N+=n,M=s&(1<<-i)-1,s>>=-i,i+=w;i>0;M=256*M+a[o+N],N+=n,i-=8);for(p=M&(1<<-i)-1,M>>=-i,i+=r;i>0;p=256*p+a[o+N],N+=n,i-=8);if(0===M)M=1-e;else{if(M===f)return p?NaN:1/0*(s?-1:1);p+=Math.pow(2,r),M-=e}return(s?-1:1)*p*Math.pow(2,M-r)},exports.write=function(a,o,t,r,h,M){var p,w,f,e=8*M-h-1,i=(1<<e)-1,N=i>>1,n=23===h?Math.pow(2,-24)-Math.pow(2,-77):0,s=r?0:M-1,u=r?1:-1,l=o<0||0===o&&1/o<0?1:0;for(o=Math.abs(o),isNaN(o)||o===1/0?(w=isNaN(o)?1:0,p=i):(p=Math.floor(Math.log(o)/Math.LN2),o*(f=Math.pow(2,-p))<1&&(p--,f*=2),o+=p+N>=1?n/f:n*Math.pow(2,1-N),o*f>=2&&(p++,f/=2),p+N>=i?(w=0,p=i):p+N>=1?(w=(o*f-1)*Math.pow(2,h),p+=N):(w=o*Math.pow(2,N-1)*Math.pow(2,h),p=0));h>=8;a[t+s]=255&w,s+=u,w/=256,h-=8);for(p=p<<h|w,e+=h;e>0;a[t+s]=255&p,s+=u,p/=256,e-=8);a[t+s-u]|=128*l};
},{}],25:[function(_dereq_,module,exports){
"use strict";function kdbush(t,i,e,s,n){return new KDBush(t,i,e,s,n)}function KDBush(t,i,e,s,n){i=i||defaultGetX,e=e||defaultGetY,n=n||Array,this.nodeSize=s||64,this.points=t,this.ids=new n(t.length),this.coords=new n(2*t.length);for(var r=0;r<t.length;r++)this.ids[r]=r,this.coords[2*r]=i(t[r]),this.coords[2*r+1]=e(t[r]);sort(this.ids,this.coords,this.nodeSize,0,this.ids.length-1,0)}function defaultGetX(t){return t[0]}function defaultGetY(t){return t[1]}var sort=_dereq_("./sort"),range=_dereq_("./range"),within=_dereq_("./within");module.exports=kdbush,KDBush.prototype={range:function(t,i,e,s){return range(this.ids,this.coords,t,i,e,s,this.nodeSize)},within:function(t,i,e){return within(this.ids,this.coords,t,i,e,this.nodeSize)}};
},{"./range":26,"./sort":27,"./within":28}],26:[function(_dereq_,module,exports){
"use strict";function range(p,r,s,u,h,e,o){for(var a,t,n=[0,p.length-1,0],f=[];n.length;){var l=n.pop(),v=n.pop(),g=n.pop();if(v-g<=o)for(var i=g;i<=v;i++)a=r[2*i],t=r[2*i+1],a>=s&&a<=h&&t>=u&&t<=e&&f.push(p[i]);else{var c=Math.floor((g+v)/2);a=r[2*c],t=r[2*c+1],a>=s&&a<=h&&t>=u&&t<=e&&f.push(p[c]);var d=(l+1)%2;(0===l?s<=a:u<=t)&&(n.push(g),n.push(c-1),n.push(d)),(0===l?h>=a:e>=t)&&(n.push(c+1),n.push(v),n.push(d))}}return f}module.exports=range;
},{}],27:[function(_dereq_,module,exports){
"use strict";function sortKD(t,a,o,s,r,e){if(!(r-s<=o)){var f=Math.floor((s+r)/2);select(t,a,f,s,r,e%2),sortKD(t,a,o,s,f-1,e+1),sortKD(t,a,o,f+1,r,e+1)}}function select(t,a,o,s,r,e){for(;r>s;){if(r-s>600){var f=r-s+1,p=o-s+1,w=Math.log(f),m=.5*Math.exp(2*w/3),n=.5*Math.sqrt(w*m*(f-m)/f)*(p-f/2<0?-1:1);select(t,a,o,Math.max(s,Math.floor(o-p*m/f+n)),Math.min(r,Math.floor(o+(f-p)*m/f+n)),e)}var c=a[2*o+e],h=s,i=r;for(swapItem(t,a,s,o),a[2*r+e]>c&&swapItem(t,a,s,r);h<i;){for(swapItem(t,a,h,i),h++,i--;a[2*h+e]<c;)h++;for(;a[2*i+e]>c;)i--}a[2*s+e]===c?swapItem(t,a,s,i):(i++,swapItem(t,a,i,r)),i<=o&&(s=i+1),o<=i&&(r=i-1)}}function swapItem(t,a,o,s){swap(t,o,s),swap(a,2*o,2*s),swap(a,2*o+1,2*s+1)}function swap(t,a,o){var s=t[a];t[a]=t[o],t[o]=s}module.exports=sortKD;
},{}],28:[function(_dereq_,module,exports){
"use strict";function within(s,p,r,t,u,h){for(var i=[0,s.length-1,0],o=[],n=u*u;i.length;){var e=i.pop(),a=i.pop(),f=i.pop();if(a-f<=h)for(var v=f;v<=a;v++)sqDist(p[2*v],p[2*v+1],r,t)<=n&&o.push(s[v]);else{var l=Math.floor((f+a)/2),c=p[2*l],q=p[2*l+1];sqDist(c,q,r,t)<=n&&o.push(s[l]);var D=(e+1)%2;(0===e?r-u<=c:t-u<=q)&&(i.push(f),i.push(l-1),i.push(D)),(0===e?r+u>=c:t+u>=q)&&(i.push(l+1),i.push(a),i.push(D))}}return o}function sqDist(s,p,r,t){var u=s-r,h=p-t;return u*u+h*h}module.exports=within;
},{}],29:[function(_dereq_,module,exports){
"use strict";function Pbf(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length}function readVarintRemainder(t,i,e){var r,s,n=e.buf;if(s=n[e.pos++],r=(112&s)>>4,s<128)return toNum(t,r,i);if(s=n[e.pos++],r|=(127&s)<<3,s<128)return toNum(t,r,i);if(s=n[e.pos++],r|=(127&s)<<10,s<128)return toNum(t,r,i);if(s=n[e.pos++],r|=(127&s)<<17,s<128)return toNum(t,r,i);if(s=n[e.pos++],r|=(127&s)<<24,s<128)return toNum(t,r,i);if(s=n[e.pos++],r|=(1&s)<<31,s<128)return toNum(t,r,i);throw new Error("Expected varint not more than 10 bytes")}function readPackedEnd(t){return t.type===Pbf.Bytes?t.readVarint()+t.pos:t.pos+1}function toNum(t,i,e){return e?4294967296*i+(t>>>0):4294967296*(i>>>0)+(t>>>0)}function writeBigVarint(t,i){var e,r;if(t>=0?(e=t%4294967296|0,r=t/4294967296|0):(e=~(-t%4294967296),r=~(-t/4294967296),4294967295^e?e=e+1|0:(e=0,r=r+1|0)),t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");i.realloc(10),writeBigVarintLow(e,r,i),writeBigVarintHigh(r,i)}function writeBigVarintLow(t,i,e){e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos]=127&t}function writeBigVarintHigh(t,i){var e=(7&t)<<4;i.buf[i.pos++]|=e|((t>>>=3)?128:0),t&&(i.buf[i.pos++]=127&t|((t>>>=7)?128:0),t&&(i.buf[i.pos++]=127&t|((t>>>=7)?128:0),t&&(i.buf[i.pos++]=127&t|((t>>>=7)?128:0),t&&(i.buf[i.pos++]=127&t|((t>>>=7)?128:0),t&&(i.buf[i.pos++]=127&t)))))}function makeRoomForExtraLength(t,i,e){var r=i<=16383?1:i<=2097151?2:i<=268435455?3:Math.ceil(Math.log(i)/(7*Math.LN2));e.realloc(r);for(var s=e.pos-1;s>=t;s--)e.buf[s+r]=e.buf[s]}function writePackedVarint(t,i){for(var e=0;e<t.length;e++)i.writeVarint(t[e])}function writePackedSVarint(t,i){for(var e=0;e<t.length;e++)i.writeSVarint(t[e])}function writePackedFloat(t,i){for(var e=0;e<t.length;e++)i.writeFloat(t[e])}function writePackedDouble(t,i){for(var e=0;e<t.length;e++)i.writeDouble(t[e])}function writePackedBoolean(t,i){for(var e=0;e<t.length;e++)i.writeBoolean(t[e])}function writePackedFixed32(t,i){for(var e=0;e<t.length;e++)i.writeFixed32(t[e])}function writePackedSFixed32(t,i){for(var e=0;e<t.length;e++)i.writeSFixed32(t[e])}function writePackedFixed64(t,i){for(var e=0;e<t.length;e++)i.writeFixed64(t[e])}function writePackedSFixed64(t,i){for(var e=0;e<t.length;e++)i.writeSFixed64(t[e])}function readUInt32(t,i){return(t[i]|t[i+1]<<8|t[i+2]<<16)+16777216*t[i+3]}function writeInt32(t,i,e){t[e]=i,t[e+1]=i>>>8,t[e+2]=i>>>16,t[e+3]=i>>>24}function readInt32(t,i){return(t[i]|t[i+1]<<8|t[i+2]<<16)+(t[i+3]<<24)}function readUtf8(t,i,e){for(var r="",s=i;s<e;){var n=t[s],o=null,a=n>239?4:n>223?3:n>191?2:1;if(s+a>e)break;var h,u,f;1===a?n<128&&(o=n):2===a?128==(192&(h=t[s+1]))&&(o=(31&n)<<6|63&h)<=127&&(o=null):3===a?(h=t[s+1],u=t[s+2],128==(192&h)&&128==(192&u)&&((o=(15&n)<<12|(63&h)<<6|63&u)<=2047||o>=55296&&o<=57343)&&(o=null)):4===a&&(h=t[s+1],u=t[s+2],f=t[s+3],128==(192&h)&&128==(192&u)&&128==(192&f)&&((o=(15&n)<<18|(63&h)<<12|(63&u)<<6|63&f)<=65535||o>=1114112)&&(o=null)),null===o?(o=65533,a=1):o>65535&&(o-=65536,r+=String.fromCharCode(o>>>10&1023|55296),o=56320|1023&o),r+=String.fromCharCode(o),s+=a}return r}function writeUtf8(t,i,e){for(var r,s,n=0;n<i.length;n++){if((r=i.charCodeAt(n))>55295&&r<57344){if(!s){r>56319||n+1===i.length?(t[e++]=239,t[e++]=191,t[e++]=189):s=r;continue}if(r<56320){t[e++]=239,t[e++]=191,t[e++]=189,s=r;continue}r=s-55296<<10|r-56320|65536,s=null}else s&&(t[e++]=239,t[e++]=191,t[e++]=189,s=null);r<128?t[e++]=r:(r<2048?t[e++]=r>>6|192:(r<65536?t[e++]=r>>12|224:(t[e++]=r>>18|240,t[e++]=r>>12&63|128),t[e++]=r>>6&63|128),t[e++]=63&r|128)}return e}module.exports=Pbf;var ieee754=_dereq_("ieee754");Pbf.Varint=0,Pbf.Fixed64=1,Pbf.Bytes=2,Pbf.Fixed32=5;var SHIFT_LEFT_32=4294967296,SHIFT_RIGHT_32=1/SHIFT_LEFT_32;Pbf.prototype={destroy:function(){this.buf=null},readFields:function(t,i,e){for(e=e||this.length;this.pos<e;){var r=this.readVarint(),s=r>>3,n=this.pos;this.type=7&r,t(s,i,this),this.pos===n&&this.skip(r)}return i},readMessage:function(t,i){return this.readFields(t,i,this.readVarint()+this.pos)},readFixed32:function(){var t=readUInt32(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=readInt32(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=readUInt32(this.buf,this.pos)+readUInt32(this.buf,this.pos+4)*SHIFT_LEFT_32;return this.pos+=8,t},readSFixed64:function(){var t=readUInt32(this.buf,this.pos)+readInt32(this.buf,this.pos+4)*SHIFT_LEFT_32;return this.pos+=8,t},readFloat:function(){var t=ieee754.read(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=ieee754.read(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var i,e,r=this.buf;return e=r[this.pos++],i=127&e,e<128?i:(e=r[this.pos++],i|=(127&e)<<7,e<128?i:(e=r[this.pos++],i|=(127&e)<<14,e<128?i:(e=r[this.pos++],i|=(127&e)<<21,e<128?i:(e=r[this.pos],i|=(15&e)<<28,readVarintRemainder(i,t,this)))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,i=readUtf8(this.buf,this.pos,t);return this.pos=t,i},readBytes:function(){var t=this.readVarint()+this.pos,i=this.buf.subarray(this.pos,t);return this.pos=t,i},readPackedVarint:function(t,i){var e=readPackedEnd(this);for(t=t||[];this.pos<e;)t.push(this.readVarint(i));return t},readPackedSVarint:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readBoolean());return t},readPackedFloat:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readFloat());return t},readPackedDouble:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readDouble());return t},readPackedFixed32:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){var i=readPackedEnd(this);for(t=t||[];this.pos<i;)t.push(this.readSFixed64());return t},skip:function(t){var i=7&t;if(i===Pbf.Varint)for(;this.buf[this.pos++]>127;);else if(i===Pbf.Bytes)this.pos=this.readVarint()+this.pos;else if(i===Pbf.Fixed32)this.pos+=4;else{if(i!==Pbf.Fixed64)throw new Error("Unimplemented type: "+i);this.pos+=8}},writeTag:function(t,i){this.writeVarint(t<<3|i)},realloc:function(t){for(var i=this.length||16;i<this.pos+t;)i*=2;if(i!==this.length){var e=new Uint8Array(i);e.set(this.buf),this.buf=e,this.length=i}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),writeInt32(this.buf,t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),writeInt32(this.buf,t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),writeInt32(this.buf,-1&t,this.pos),writeInt32(this.buf,Math.floor(t*SHIFT_RIGHT_32),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),writeInt32(this.buf,-1&t,this.pos),writeInt32(this.buf,Math.floor(t*SHIFT_RIGHT_32),this.pos+4),this.pos+=8},writeVarint:function(t){if((t=+t||0)>268435455||t<0)return void writeBigVarint(t,this);this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127)))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var i=this.pos;this.pos=writeUtf8(this.buf,t,this.pos);var e=this.pos-i;e>=128&&makeRoomForExtraLength(i,e,this),this.pos=i-1,this.writeVarint(e),this.pos+=e},writeFloat:function(t){this.realloc(4),ieee754.write(this.buf,t,this.pos,!0,23,4),this.pos+=4},writeDouble:function(t){this.realloc(8),ieee754.write(this.buf,t,this.pos,!0,52,8),this.pos+=8},writeBytes:function(t){var i=t.length;this.writeVarint(i),this.realloc(i);for(var e=0;e<i;e++)this.buf[this.pos++]=t[e]},writeRawMessage:function(t,i){this.pos++;var e=this.pos;t(i,this);var r=this.pos-e;r>=128&&makeRoomForExtraLength(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r},writeMessage:function(t,i,e){this.writeTag(t,Pbf.Bytes),this.writeRawMessage(i,e)},writePackedVarint:function(t,i){this.writeMessage(t,writePackedVarint,i)},writePackedSVarint:function(t,i){this.writeMessage(t,writePackedSVarint,i)},writePackedBoolean:function(t,i){this.writeMessage(t,writePackedBoolean,i)},writePackedFloat:function(t,i){this.writeMessage(t,writePackedFloat,i)},writePackedDouble:function(t,i){this.writeMessage(t,writePackedDouble,i)},writePackedFixed32:function(t,i){this.writeMessage(t,writePackedFixed32,i)},writePackedSFixed32:function(t,i){this.writeMessage(t,writePackedSFixed32,i)},writePackedFixed64:function(t,i){this.writeMessage(t,writePackedFixed64,i)},writePackedSFixed64:function(t,i){this.writeMessage(t,writePackedSFixed64,i)},writeBytesField:function(t,i){this.writeTag(t,Pbf.Bytes),this.writeBytes(i)},writeFixed32Field:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeFixed32(i)},writeSFixed32Field:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeSFixed32(i)},writeFixed64Field:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeFixed64(i)},writeSFixed64Field:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeSFixed64(i)},writeVarintField:function(t,i){this.writeTag(t,Pbf.Varint),this.writeVarint(i)},writeSVarintField:function(t,i){this.writeTag(t,Pbf.Varint),this.writeSVarint(i)},writeStringField:function(t,i){this.writeTag(t,Pbf.Bytes),this.writeString(i)},writeFloatField:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeFloat(i)},writeDoubleField:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeDouble(i)},writeBooleanField:function(t,i){this.writeVarintField(t,Boolean(i))}};
},{"ieee754":24}],30:[function(_dereq_,module,exports){
function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(e){if(cachedSetTimeout===setTimeout)return setTimeout(e,0);if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout)return cachedSetTimeout=setTimeout,setTimeout(e,0);try{return cachedSetTimeout(e,0)}catch(t){try{return cachedSetTimeout.call(null,e,0)}catch(t){return cachedSetTimeout.call(this,e,0)}}}function runClearTimeout(e){if(cachedClearTimeout===clearTimeout)return clearTimeout(e);if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout)return cachedClearTimeout=clearTimeout,clearTimeout(e);try{return cachedClearTimeout(e)}catch(t){try{return cachedClearTimeout.call(null,e)}catch(t){return cachedClearTimeout.call(this,e)}}}function cleanUpNextTick(){draining&&currentQueue&&(draining=!1,currentQueue.length?queue=currentQueue.concat(queue):queueIndex=-1,queue.length&&drainQueue())}function drainQueue(){if(!draining){var e=runTimeout(cleanUpNextTick);draining=!0;for(var t=queue.length;t;){for(currentQueue=queue,queue=[];++queueIndex<t;)currentQueue&&currentQueue[queueIndex].run();queueIndex=-1,t=queue.length}currentQueue=null,draining=!1,runClearTimeout(e)}}function Item(e,t){this.fun=e,this.array=t}function noop(){}var process=module.exports={},cachedSetTimeout,cachedClearTimeout;!function(){try{cachedSetTimeout="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(e){cachedSetTimeout=defaultSetTimout}try{cachedClearTimeout="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(e){cachedClearTimeout=defaultClearTimeout}}();var queue=[],draining=!1,currentQueue,queueIndex=-1;process.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)t[r-1]=arguments[r];queue.push(new Item(e,t)),1!==queue.length||draining||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},process.title="browser",process.browser=!0,process.env={},process.argv=[],process.version="",process.versions={},process.on=noop,process.addListener=noop,process.once=noop,process.off=noop,process.removeListener=noop,process.removeAllListeners=noop,process.emit=noop,process.prependListener=noop,process.prependOnceListener=noop,process.listeners=function(e){return[]},process.binding=function(e){throw new Error("process.binding is not supported")},process.cwd=function(){return"/"},process.chdir=function(e){throw new Error("process.chdir is not supported")},process.umask=function(){return 0};
},{}],31:[function(_dereq_,module,exports){
"use strict";function partialSort(a,t,r,o,p){for(r=r||0,o=o||a.length-1,p=p||defaultCompare;o>r;){if(o-r>600){var f=o-r+1,e=t-r+1,l=Math.log(f),s=.5*Math.exp(2*l/3),i=.5*Math.sqrt(l*s*(f-s)/f)*(e-f/2<0?-1:1);partialSort(a,t,Math.max(r,Math.floor(t-e*s/f+i)),Math.min(o,Math.floor(t+(f-e)*s/f+i)),p)}var n=a[t],h=r,u=o;for(swap(a,r,t),p(a[o],n)>0&&swap(a,r,o);h<u;){for(swap(a,h,u),h++,u--;p(a[h],n)<0;)h++;for(;p(a[u],n)>0;)u--}0===p(a[r],n)?swap(a,r,u):(u++,swap(a,u,o)),u<=t&&(r=u+1),t<=u&&(o=u-1)}}function swap(a,t,r){var o=a[t];a[t]=a[r],a[r]=o}function defaultCompare(a,t){return a<t?-1:a>t?1:0}module.exports=partialSort;
},{}],32:[function(_dereq_,module,exports){
"use strict";function supercluster(t){return new SuperCluster(t)}function SuperCluster(t){this.options=extend(Object.create(this.options),t),this.trees=new Array(this.options.maxZoom+1)}function createCluster(t,e,n,o,i){return{x:t,y:e,zoom:1/0,id:o,properties:i,parentId:-1,numPoints:n}}function createPointCluster(t,e){var n=t.geometry.coordinates;return{x:lngX(n[0]),y:latY(n[1]),zoom:1/0,id:e,parentId:-1}}function getClusterJSON(t){return{type:"Feature",properties:getClusterProperties(t),geometry:{type:"Point",coordinates:[xLng(t.x),yLat(t.y)]}}}function getClusterProperties(t){var e=t.numPoints,n=e>=1e4?Math.round(e/1e3)+"k":e>=1e3?Math.round(e/100)/10+"k":e;return extend(extend({},t.properties),{cluster:!0,cluster_id:t.id,point_count:e,point_count_abbreviated:n})}function lngX(t){return t/360+.5}function latY(t){var e=Math.sin(t*Math.PI/180),n=.5-.25*Math.log((1+e)/(1-e))/Math.PI;return n<0?0:n>1?1:n}function xLng(t){return 360*(t-.5)}function yLat(t){var e=(180-360*t)*Math.PI/180;return 360*Math.atan(Math.exp(e))/Math.PI-90}function extend(t,e){for(var n in e)t[n]=e[n];return t}function getX(t){return t.x}function getY(t){return t.y}var kdbush=_dereq_("kdbush");module.exports=supercluster,SuperCluster.prototype={options:{minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,reduce:null,initial:function(){return{}},map:function(t){return t}},load:function(t){var e=this.options.log;e&&console.time("total time");var n="prepare "+t.length+" points";e&&console.time(n),this.points=t;var o=t.map(createPointCluster);e&&console.timeEnd(n);for(var i=this.options.maxZoom;i>=this.options.minZoom;i--){var r=+Date.now();this.trees[i+1]=kdbush(o,getX,getY,this.options.nodeSize,Float32Array),o=this._cluster(o,i),e&&console.log("z%d: %d clusters in %dms",i,o.length,+Date.now()-r)}return this.trees[this.options.minZoom]=kdbush(o,getX,getY,this.options.nodeSize,Float32Array),e&&console.timeEnd("total time"),this},getClusters:function(t,e){for(var n=this.trees[this._limitZoom(e)],o=n.range(lngX(t[0]),latY(t[3]),lngX(t[2]),latY(t[1])),i=[],r=0;r<o.length;r++){var s=n.points[o[r]];i.push(s.numPoints?getClusterJSON(s):this.points[s.id])}return i},getChildren:function(t,e){for(var n=this.trees[e+1].points[t],o=this.options.radius/(this.options.extent*Math.pow(2,e)),i=this.trees[e+1].within(n.x,n.y,o),r=[],s=0;s<i.length;s++){var u=this.trees[e+1].points[i[s]];u.parentId===t&&r.push(u.numPoints?getClusterJSON(u):this.points[u.id])}return r},getLeaves:function(t,e,n,o){n=n||10,o=o||0;var i=[];return this._appendLeaves(i,t,e,n,o,0),i},getTile:function(t,e,n){var o=this.trees[this._limitZoom(t)],i=Math.pow(2,t),r=this.options.extent,s=this.options.radius,u=s/r,a=(n-u)/i,p=(n+1+u)/i,h={features:[]};return this._addTileFeatures(o.range((e-u)/i,a,(e+1+u)/i,p),o.points,e,n,i,h),0===e&&this._addTileFeatures(o.range(1-u/i,a,1,p),o.points,i,n,i,h),e===i-1&&this._addTileFeatures(o.range(0,a,u/i,p),o.points,-1,n,i,h),h.features.length?h:null},getClusterExpansionZoom:function(t,e){for(;e<this.options.maxZoom;){var n=this.getChildren(t,e);if(e++,1!==n.length)break;t=n[0].properties.cluster_id}return e},_appendLeaves:function(t,e,n,o,i,r){for(var s=this.getChildren(e,n),u=0;u<s.length;u++){var a=s[u].properties;if(a.cluster?r+a.point_count<=i?r+=a.point_count:r=this._appendLeaves(t,a.cluster_id,n+1,o,i,r):r<i?r++:t.push(s[u]),t.length===o)break}return r},_addTileFeatures:function(t,e,n,o,i,r){for(var s=0;s<t.length;s++){var u=e[t[s]];r.features.push({type:1,geometry:[[Math.round(this.options.extent*(u.x*i-n)),Math.round(this.options.extent*(u.y*i-o))]],tags:u.numPoints?getClusterProperties(u):this.points[u.id].properties})}},_limitZoom:function(t){return Math.max(this.options.minZoom,Math.min(t,this.options.maxZoom+1))},_cluster:function(t,e){for(var n=[],o=this.options.radius/(this.options.extent*Math.pow(2,e)),i=0;i<t.length;i++){var r=t[i];if(!(r.zoom<=e)){r.zoom=e;var s=this.trees[e+1],u=s.within(r.x,r.y,o),a=r.numPoints||1,p=r.x*a,h=r.y*a,l=null;this.options.reduce&&(l=this.options.initial(),this._accumulate(l,r));for(var c=0;c<u.length;c++){var d=s.points[u[c]];if(e<d.zoom){var m=d.numPoints||1;d.zoom=e,p+=d.x*m,h+=d.y*m,a+=m,d.parentId=i,this.options.reduce&&this._accumulate(l,d)}}1===a?n.push(r):(r.parentId=i,n.push(createCluster(p/a,h/a,a,i,l)))}}return n},_accumulate:function(t,e){var n=e.numPoints?e.properties:this.options.map(this.points[e.id].properties);this.options.reduce(t,n)}};
},{"kdbush":25}],33:[function(_dereq_,module,exports){
"use strict";function TinyQueue(t,i){if(!(this instanceof TinyQueue))return new TinyQueue(t,i);if(this.data=t||[],this.length=this.data.length,this.compare=i||defaultCompare,this.length>0)for(var e=this.length>>1;e>=0;e--)this._down(e)}function defaultCompare(t,i){return t<i?-1:t>i?1:0}module.exports=TinyQueue,TinyQueue.prototype={push:function(t){this.data.push(t),this.length++,this._up(this.length-1)},pop:function(){if(0!==this.length){var t=this.data[0];return this.length--,this.length>0&&(this.data[0]=this.data[this.length],this._down(0)),this.data.pop(),t}},peek:function(){return this.data[0]},_up:function(t){for(var i=this.data,e=this.compare,h=i[t];t>0;){var n=t-1>>1,a=i[n];if(e(h,a)>=0)break;i[t]=a,t=n}i[t]=h},_down:function(t){for(var i=this.data,e=this.compare,h=this.length,n=h>>1,a=i[t];t<n;){var s=1+(t<<1),u=s+1,r=i[s];if(u<h&&e(i[u],r)<0&&(s=u,r=i[u]),e(r,a)>=0)break;i[t]=r,t=s}i[t]=a}};
},{}],34:[function(_dereq_,module,exports){
"function"==typeof Object.create?module.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:module.exports=function(t,e){t.super_=e;var o=function(){};o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t};
},{}],35:[function(_dereq_,module,exports){
module.exports=function(o){return o&&"object"==typeof o&&"function"==typeof o.copy&&"function"==typeof o.fill&&"function"==typeof o.readUInt8};
},{}],36:[function(_dereq_,module,exports){
(function (process,global){
function inspect(e,r){var t={seen:[],stylize:stylizeNoColor};return arguments.length>=3&&(t.depth=arguments[2]),arguments.length>=4&&(t.colors=arguments[3]),isBoolean(r)?t.showHidden=r:r&&exports._extend(t,r),isUndefined(t.showHidden)&&(t.showHidden=!1),isUndefined(t.depth)&&(t.depth=2),isUndefined(t.colors)&&(t.colors=!1),isUndefined(t.customInspect)&&(t.customInspect=!0),t.colors&&(t.stylize=stylizeWithColor),formatValue(t,e,t.depth)}function stylizeWithColor(e,r){var t=inspect.styles[r];return t?"["+inspect.colors[t][0]+"m"+e+"["+inspect.colors[t][1]+"m":e}function stylizeNoColor(e,r){return e}function arrayToHash(e){var r={};return e.forEach(function(e,t){r[e]=!0}),r}function formatValue(e,r,t){if(e.customInspect&&r&&isFunction(r.inspect)&&r.inspect!==exports.inspect&&(!r.constructor||r.constructor.prototype!==r)){var n=r.inspect(t,e);return isString(n)||(n=formatValue(e,n,t)),n}var i=formatPrimitive(e,r);if(i)return i;var o=Object.keys(r),s=arrayToHash(o);if(e.showHidden&&(o=Object.getOwnPropertyNames(r)),isError(r)&&(o.indexOf("message")>=0||o.indexOf("description")>=0))return formatError(r);if(0===o.length){if(isFunction(r)){var u=r.name?": "+r.name:"";return e.stylize("[Function"+u+"]","special")}if(isRegExp(r))return e.stylize(RegExp.prototype.toString.call(r),"regexp");if(isDate(r))return e.stylize(Date.prototype.toString.call(r),"date");if(isError(r))return formatError(r)}var c="",a=!1,l=["{","}"];if(isArray(r)&&(a=!0,l=["[","]"]),isFunction(r)){c=" [Function"+(r.name?": "+r.name:"")+"]"}if(isRegExp(r)&&(c=" "+RegExp.prototype.toString.call(r)),isDate(r)&&(c=" "+Date.prototype.toUTCString.call(r)),isError(r)&&(c=" "+formatError(r)),0===o.length&&(!a||0==r.length))return l[0]+c+l[1];if(t<0)return isRegExp(r)?e.stylize(RegExp.prototype.toString.call(r),"regexp"):e.stylize("[Object]","special");e.seen.push(r);var p;return p=a?formatArray(e,r,t,s,o):o.map(function(n){return formatProperty(e,r,t,s,n,a)}),e.seen.pop(),reduceToSingleString(p,c,l)}function formatPrimitive(e,r){if(isUndefined(r))return e.stylize("undefined","undefined");if(isString(r)){var t="'"+JSON.stringify(r).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(t,"string")}return isNumber(r)?e.stylize(""+r,"number"):isBoolean(r)?e.stylize(""+r,"boolean"):isNull(r)?e.stylize("null","null"):void 0}function formatError(e){return"["+Error.prototype.toString.call(e)+"]"}function formatArray(e,r,t,n,i){for(var o=[],s=0,u=r.length;s<u;++s)hasOwnProperty(r,String(s))?o.push(formatProperty(e,r,t,n,String(s),!0)):o.push("");return i.forEach(function(i){i.match(/^\d+$/)||o.push(formatProperty(e,r,t,n,i,!0))}),o}function formatProperty(e,r,t,n,i,o){var s,u,c;if(c=Object.getOwnPropertyDescriptor(r,i)||{value:r[i]},c.get?u=c.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):c.set&&(u=e.stylize("[Setter]","special")),hasOwnProperty(n,i)||(s="["+i+"]"),u||(e.seen.indexOf(c.value)<0?(u=isNull(t)?formatValue(e,c.value,null):formatValue(e,c.value,t-1),u.indexOf("\n")>-1&&(u=o?u.split("\n").map(function(e){return"  "+e}).join("\n").substr(2):"\n"+u.split("\n").map(function(e){return"   "+e}).join("\n"))):u=e.stylize("[Circular]","special")),isUndefined(s)){if(o&&i.match(/^\d+$/))return u;s=JSON.stringify(""+i),s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=e.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=e.stylize(s,"string"))}return s+": "+u}function reduceToSingleString(e,r,t){var n=0;return e.reduce(function(e,r){return n++,r.indexOf("\n")>=0&&n++,e+r.replace(/\u001b\[\d\d?m/g,"").length+1},0)>60?t[0]+(""===r?"":r+"\n ")+" "+e.join(",\n  ")+" "+t[1]:t[0]+r+" "+e.join(", ")+" "+t[1]}function isArray(e){return Array.isArray(e)}function isBoolean(e){return"boolean"==typeof e}function isNull(e){return null===e}function isNullOrUndefined(e){return null==e}function isNumber(e){return"number"==typeof e}function isString(e){return"string"==typeof e}function isSymbol(e){return"symbol"==typeof e}function isUndefined(e){return void 0===e}function isRegExp(e){return isObject(e)&&"[object RegExp]"===objectToString(e)}function isObject(e){return"object"==typeof e&&null!==e}function isDate(e){return isObject(e)&&"[object Date]"===objectToString(e)}function isError(e){return isObject(e)&&("[object Error]"===objectToString(e)||e instanceof Error)}function isFunction(e){return"function"==typeof e}function isPrimitive(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e}function objectToString(e){return Object.prototype.toString.call(e)}function pad(e){return e<10?"0"+e.toString(10):e.toString(10)}function timestamp(){var e=new Date,r=[pad(e.getHours()),pad(e.getMinutes()),pad(e.getSeconds())].join(":");return[e.getDate(),months[e.getMonth()],r].join(" ")}function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}var formatRegExp=/%[sdj%]/g;exports.format=function(e){if(!isString(e)){for(var r=[],t=0;t<arguments.length;t++)r.push(inspect(arguments[t]));return r.join(" ")}for(var t=1,n=arguments,i=n.length,o=String(e).replace(formatRegExp,function(e){if("%%"===e)return"%";if(t>=i)return e;switch(e){case"%s":return String(n[t++]);case"%d":return Number(n[t++]);case"%j":try{return JSON.stringify(n[t++])}catch(e){return"[Circular]"}default:return e}}),s=n[t];t<i;s=n[++t])isNull(s)||!isObject(s)?o+=" "+s:o+=" "+inspect(s);return o},exports.deprecate=function(e,r){function t(){if(!n){if(process.throwDeprecation)throw new Error(r);process.traceDeprecation?console.trace(r):console.error(r),n=!0}return e.apply(this,arguments)}if(isUndefined(global.process))return function(){return exports.deprecate(e,r).apply(this,arguments)};if(!0===process.noDeprecation)return e;var n=!1;return t};var debugs={},debugEnviron;exports.debuglog=function(e){if(isUndefined(debugEnviron)&&(debugEnviron=process.env.NODE_DEBUG||""),e=e.toUpperCase(),!debugs[e])if(new RegExp("\\b"+e+"\\b","i").test(debugEnviron)){var r=process.pid;debugs[e]=function(){var t=exports.format.apply(exports,arguments);console.error("%s %d: %s",e,r,t)}}else debugs[e]=function(){};return debugs[e]},exports.inspect=inspect,inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"},exports.isArray=isArray,exports.isBoolean=isBoolean,exports.isNull=isNull,exports.isNullOrUndefined=isNullOrUndefined,exports.isNumber=isNumber,exports.isString=isString,exports.isSymbol=isSymbol,exports.isUndefined=isUndefined,exports.isRegExp=isRegExp,exports.isObject=isObject,exports.isDate=isDate,exports.isError=isError,exports.isFunction=isFunction,exports.isPrimitive=isPrimitive,exports.isBuffer=_dereq_("./support/isBuffer");var months=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];exports.log=function(){console.log("%s - %s",timestamp(),exports.format.apply(exports,arguments))},exports.inherits=_dereq_("inherits"),exports._extend=function(e,r){if(!r||!isObject(r))return e;for(var t=Object.keys(r),n=t.length;n--;)e[t[n]]=r[t[n]];return e};
}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./support/isBuffer":35,"_process":30,"inherits":34}],37:[function(_dereq_,module,exports){
function fromVectorTileJs(e){var r=new Pbf;return writeTile(e,r),r.finish()}function fromGeojsonVt(e){var r={};for(var t in e)r[t]=new GeoJSONWrapper(e[t].features),r[t].name=t;return fromVectorTileJs({layers:r})}function writeTile(e,r){for(var t in e.layers)r.writeMessage(3,writeLayer,e.layers[t])}function writeLayer(e,r){r.writeVarintField(15,e.version||1),r.writeStringField(1,e.name||""),r.writeVarintField(5,e.extent||4096);var t,i={keys:[],values:[],keycache:{},valuecache:{}};for(t=0;t<e.length;t++)i.feature=e.feature(t),r.writeMessage(2,writeFeature,i);var a=i.keys;for(t=0;t<a.length;t++)r.writeStringField(3,a[t]);var o=i.values;for(t=0;t<o.length;t++)r.writeMessage(4,writeValue,o[t])}function writeFeature(e,r){var t=e.feature;void 0!==t.id&&r.writeVarintField(1,t.id),r.writeMessage(2,writeProperties,e),r.writeVarintField(3,t.type),r.writeMessage(4,writeGeometry,t)}function writeProperties(e,r){var t=e.feature,i=e.keys,a=e.values,o=e.keycache,n=e.valuecache;for(var l in t.properties){var s=o[l];void 0===s&&(i.push(l),s=i.length-1,o[l]=s),r.writeVarint(s);var u=t.properties[l],f=typeof u;"string"!==f&&"boolean"!==f&&"number"!==f&&(u=JSON.stringify(u));var w=f+":"+u,v=n[w];void 0===v&&(a.push(u),v=a.length-1,n[w]=v),r.writeVarint(v)}}function command(e,r){return(r<<3)+(7&e)}function zigzag(e){return e<<1^e>>31}function writeGeometry(e,r){for(var t=e.loadGeometry(),i=e.type,a=0,o=0,n=t.length,l=0;l<n;l++){var s=t[l],u=1;1===i&&(u=s.length),r.writeVarint(command(1,u));for(var f=0;f<s.length;f++){1===f&&1!==i&&r.writeVarint(command(2,s.length-1));var w=s[f].x-a,v=s[f].y-o;r.writeVarint(zigzag(w)),r.writeVarint(zigzag(v)),a+=w,o+=v}}}function writeValue(e,r){var t=typeof e;"string"===t?r.writeStringField(1,e):"boolean"===t?r.writeBooleanField(7,e):"number"===t&&(e%1!=0?r.writeDoubleField(3,e):e<0?r.writeSVarintField(6,e):r.writeVarintField(5,e))}var Pbf=_dereq_("pbf"),GeoJSONWrapper=_dereq_("./lib/geojson_wrapper");module.exports=fromVectorTileJs,module.exports.fromVectorTileJs=fromVectorTileJs,module.exports.fromGeojsonVt=fromGeojsonVt,module.exports.GeoJSONWrapper=GeoJSONWrapper;
},{"./lib/geojson_wrapper":38,"pbf":29}],38:[function(_dereq_,module,exports){
"use strict";function GeoJSONWrapper(e){this.features=e,this.length=e.length}function FeatureWrapper(e){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=4096}var Point=_dereq_("@mapbox/point-geometry"),VectorTileFeature=_dereq_("@mapbox/vector-tile").VectorTileFeature;module.exports=GeoJSONWrapper,GeoJSONWrapper.prototype.feature=function(e){return new FeatureWrapper(this.features[e])},FeatureWrapper.prototype.loadGeometry=function(){var e=this.rawGeometry;this.geometry=[];for(var t=0;t<e.length;t++){for(var r=e[t],o=[],a=0;a<r.length;a++)o.push(new Point(r[a][0],r[a][1]));this.geometry.push(o)}return this.geometry},FeatureWrapper.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,o=1/0,a=-1/0,p=0;p<e.length;p++)for(var i=e[p],n=0;n<i.length;n++){var h=i[n];t=Math.min(t,h.x),r=Math.max(r,h.x),o=Math.min(o,h.y),a=Math.max(a,h.y)}return[t,o,r,a]},FeatureWrapper.prototype.toGeoJSON=VectorTileFeature.prototype.toGeoJSON;
},{"@mapbox/point-geometry":4,"@mapbox/vector-tile":8}],39:[function(_dereq_,module,exports){
var bundleFn=arguments[3],sources=arguments[4],cache=arguments[5],stringify=JSON.stringify;module.exports=function(r,e){function t(r){d[r]=!0;for(var e in sources[r][1]){var n=sources[r][1][e];d[n]||t(n)}}for(var n,o=Object.keys(cache),a=0,i=o.length;a<i;a++){var s=o[a],u=cache[s].exports;if(u===r||u&&u.default===r){n=s;break}}if(!n){n=Math.floor(Math.pow(16,8)*Math.random()).toString(16);for(var f={},a=0,i=o.length;a<i;a++){var s=o[a];f[s]=s}sources[n]=[Function(["require","module","exports"],"("+r+")(self)"),f]}var c=Math.floor(Math.pow(16,8)*Math.random()).toString(16),l={};l[n]=n,sources[c]=[Function(["require"],"var f = require("+stringify(n)+");(f.default ? f.default : f)(self);"),l];var d={};t(c);var g="("+bundleFn+")({"+Object.keys(d).map(function(r){return stringify(r)+":["+sources[r][0]+","+stringify(sources[r][1])+"]"}).join(",")+"},{},["+stringify(c)+"])",v=window.URL||window.webkitURL||window.mozURL||window.msURL,w=new Blob([g],{type:"text/javascript"});if(e&&e.bare)return w;var h=v.createObjectURL(w),b=new Worker(h);return b.objectURL=h,b};
},{}],40:[function(_dereq_,module,exports){
module.exports.RADIUS=6378137,module.exports.FLATTENING=1/298.257223563,module.exports.POLAR_RADIUS=6356752.3142;
},{}],41:[function(_dereq_,module,exports){
module.exports={"version":"0.43.0"}
},{}],42:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/struct_array"),StructArray=ref.StructArray,ref$1=_dereq_("../util/struct_array"),Struct=ref$1.Struct,ref$2=_dereq_("../util/web_worker_transfer"),register=ref$2.register,Point=_dereq_("@mapbox/point-geometry"),StructArrayLayout2i4=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r){var i=this.length;this.resize(i+1);var e=2*i;return this.int16[e+0]=t,this.int16[e+1]=r,i},r}(StructArray);StructArrayLayout2i4.prototype.bytesPerElement=4,register("StructArrayLayout2i4",StructArrayLayout2i4);var StructArrayLayout4i8=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e){var o=this.length;this.resize(o+1);var u=4*o;return this.int16[u+0]=t,this.int16[u+1]=r,this.int16[u+2]=i,this.int16[u+3]=e,o},r}(StructArray);StructArrayLayout4i8.prototype.bytesPerElement=8,register("StructArrayLayout4i8",StructArrayLayout4i8);var StructArrayLayout2i4i12=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u){var n=this.length;this.resize(n+1);var a=6*n;return this.int16[a+0]=t,this.int16[a+1]=r,this.int16[a+2]=i,this.int16[a+3]=e,this.int16[a+4]=o,this.int16[a+5]=u,n},r}(StructArray);StructArrayLayout2i4i12.prototype.bytesPerElement=12,register("StructArrayLayout2i4i12",StructArrayLayout2i4i12);var StructArrayLayout4i4ub12=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u,n,a){var y=this.length;this.resize(y+1);var s=6*y,c=12*y;return this.int16[s+0]=t,this.int16[s+1]=r,this.int16[s+2]=i,this.int16[s+3]=e,this.uint8[c+8]=o,this.uint8[c+9]=u,this.uint8[c+10]=n,this.uint8[c+11]=a,y},r}(StructArray);StructArrayLayout4i4ub12.prototype.bytesPerElement=12,register("StructArrayLayout4i4ub12",StructArrayLayout4i4ub12);var StructArrayLayout4i4ui16=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u,n,a){var y=this.length;this.resize(y+1);var s=8*y;return this.int16[s+0]=t,this.int16[s+1]=r,this.int16[s+2]=i,this.int16[s+3]=e,this.uint16[s+4]=o,this.uint16[s+5]=u,this.uint16[s+6]=n,this.uint16[s+7]=a,y},r}(StructArray);StructArrayLayout4i4ui16.prototype.bytesPerElement=16,register("StructArrayLayout4i4ui16",StructArrayLayout4i4ui16);var StructArrayLayout3f12=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i){var e=this.length;this.resize(e+1);var o=3*e;return this.float32[o+0]=t,this.float32[o+1]=r,this.float32[o+2]=i,e},r}(StructArray);StructArrayLayout3f12.prototype.bytesPerElement=12,register("StructArrayLayout3f12",StructArrayLayout3f12);var StructArrayLayout1ul4=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t){var r=this.length;this.resize(r+1);var i=1*r;return this.uint32[i+0]=t,r},r}(StructArray);StructArrayLayout1ul4.prototype.bytesPerElement=4,register("StructArrayLayout1ul4",StructArrayLayout1ul4);var StructArrayLayout6i1ul2ui2i24=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u,n,a,y,s,c){var p=this.length;this.resize(p+1);var h=12*p,f=6*p;return this.int16[h+0]=t,this.int16[h+1]=r,this.int16[h+2]=i,this.int16[h+3]=e,this.int16[h+4]=o,this.int16[h+5]=u,this.uint32[f+3]=n,this.uint16[h+8]=a,this.uint16[h+9]=y,this.int16[h+10]=s,this.int16[h+11]=c,p},r}(StructArray);StructArrayLayout6i1ul2ui2i24.prototype.bytesPerElement=24,register("StructArrayLayout6i1ul2ui2i24",StructArrayLayout6i1ul2ui2i24);var StructArrayLayout2i2i2i12=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u){var n=this.length;this.resize(n+1);var a=6*n;return this.int16[a+0]=t,this.int16[a+1]=r,this.int16[a+2]=i,this.int16[a+3]=e,this.int16[a+4]=o,this.int16[a+5]=u,n},r}(StructArray);StructArrayLayout2i2i2i12.prototype.bytesPerElement=12,register("StructArrayLayout2i2i2i12",StructArrayLayout2i2i2i12);var StructArrayLayout2ub4=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r){var i=this.length;this.resize(i+1);var e=4*i;return this.uint8[e+0]=t,this.uint8[e+1]=r,i},r}(StructArray);StructArrayLayout2ub4.prototype.bytesPerElement=4,register("StructArrayLayout2ub4",StructArrayLayout2ub4);var StructArrayLayout2i2ui3ul3ui2f2ub40=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e,o,u,n,a,y,s,c,p,h,f){var A=this.length;this.resize(A+1);var _=20*A,l=10*A,S=40*A;return this.int16[_+0]=t,this.int16[_+1]=r,this.uint16[_+2]=i,this.uint16[_+3]=e,this.uint32[l+2]=o,this.uint32[l+3]=u,this.uint32[l+4]=n,this.uint16[_+10]=a,this.uint16[_+11]=y,this.uint16[_+12]=s,this.float32[l+7]=c,this.float32[l+8]=p,this.uint8[S+36]=h,this.uint8[S+37]=f,A},r}(StructArray);StructArrayLayout2i2ui3ul3ui2f2ub40.prototype.bytesPerElement=40,register("StructArrayLayout2i2ui3ul3ui2f2ub40",StructArrayLayout2i2ui3ul3ui2f2ub40);var StructArrayLayout1f4=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t){var r=this.length;this.resize(r+1);var i=1*r;return this.float32[i+0]=t,r},r}(StructArray);StructArrayLayout1f4.prototype.bytesPerElement=4,register("StructArrayLayout1f4",StructArrayLayout1f4);var StructArrayLayout3i6=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i){var e=this.length;this.resize(e+1);var o=3*e;return this.int16[o+0]=t,this.int16[o+1]=r,this.int16[o+2]=i,e},r}(StructArray);StructArrayLayout3i6.prototype.bytesPerElement=6,register("StructArrayLayout3i6",StructArrayLayout3i6);var StructArrayLayout1ul2ui8=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i){var e=this.length;this.resize(e+1);var o=2*e,u=4*e;return this.uint32[o+0]=t,this.uint16[u+2]=r,this.uint16[u+3]=i,e},r}(StructArray);StructArrayLayout1ul2ui8.prototype.bytesPerElement=8,register("StructArrayLayout1ul2ui8",StructArrayLayout1ul2ui8);var StructArrayLayout3ui6=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i){var e=this.length;this.resize(e+1);var o=3*e;return this.uint16[o+0]=t,this.uint16[o+1]=r,this.uint16[o+2]=i,e},r}(StructArray);StructArrayLayout3ui6.prototype.bytesPerElement=6,register("StructArrayLayout3ui6",StructArrayLayout3ui6);var StructArrayLayout2ui4=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r){var i=this.length;this.resize(i+1);var e=2*i;return this.uint16[e+0]=t,this.uint16[e+1]=r,i},r}(StructArray);StructArrayLayout2ui4.prototype.bytesPerElement=4,register("StructArrayLayout2ui4",StructArrayLayout2ui4);var StructArrayLayout2f8=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r){var i=this.length;this.resize(i+1);var e=2*i;return this.float32[e+0]=t,this.float32[e+1]=r,i},r}(StructArray);StructArrayLayout2f8.prototype.bytesPerElement=8,register("StructArrayLayout2f8",StructArrayLayout2f8);var StructArrayLayout4f16=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},r.prototype.emplaceBack=function(t,r,i,e){var o=this.length;this.resize(o+1);var u=4*o;return this.float32[u+0]=t,this.float32[u+1]=r,this.float32[u+2]=i,this.float32[u+3]=e,o},r}(StructArray);StructArrayLayout4f16.prototype.bytesPerElement=16,register("StructArrayLayout4f16",StructArrayLayout4f16);var CollisionBoxStruct=function(t){function r(){t.apply(this,arguments)}t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r;var i={anchorPointX:{},anchorPointY:{},x1:{},y1:{},x2:{},y2:{},featureIndex:{},sourceLayerIndex:{},bucketIndex:{},radius:{},signedDistanceFromAnchor:{},anchorPoint:{}};return i.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},i.anchorPointX.set=function(t){this._structArray.int16[this._pos2+0]=t},i.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},i.anchorPointY.set=function(t){this._structArray.int16[this._pos2+1]=t},i.x1.get=function(){return this._structArray.int16[this._pos2+2]},i.x1.set=function(t){this._structArray.int16[this._pos2+2]=t},i.y1.get=function(){return this._structArray.int16[this._pos2+3]},i.y1.set=function(t){this._structArray.int16[this._pos2+3]=t},i.x2.get=function(){return this._structArray.int16[this._pos2+4]},i.x2.set=function(t){this._structArray.int16[this._pos2+4]=t},i.y2.get=function(){return this._structArray.int16[this._pos2+5]},i.y2.set=function(t){this._structArray.int16[this._pos2+5]=t},i.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},i.featureIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t},i.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},i.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t},i.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},i.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t},i.radius.get=function(){return this._structArray.int16[this._pos2+10]},i.radius.set=function(t){this._structArray.int16[this._pos2+10]=t},i.signedDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+11]},i.signedDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+11]=t},i.anchorPoint.get=function(){return new Point(this.anchorPointX,this.anchorPointY)},Object.defineProperties(r.prototype,i),r}(Struct);CollisionBoxStruct.prototype.size=24;var CollisionBoxArray=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.get=function(t){return new CollisionBoxStruct(this,t)},r}(StructArrayLayout6i1ul2ui2i24);register("CollisionBoxArray",CollisionBoxArray);var PlacedSymbolStruct=function(t){function r(){t.apply(this,arguments)}t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r;var i={anchorX:{},anchorY:{},glyphStartIndex:{},numGlyphs:{},vertexStartIndex:{},lineStartIndex:{},lineLength:{},segment:{},lowerSize:{},upperSize:{},lineOffsetX:{},lineOffsetY:{},writingMode:{},hidden:{}};return i.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},i.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t},i.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},i.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t},i.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},i.glyphStartIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t},i.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},i.numGlyphs.set=function(t){this._structArray.uint16[this._pos2+3]=t},i.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},i.vertexStartIndex.set=function(t){this._structArray.uint32[this._pos4+2]=t},i.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},i.lineStartIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t},i.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},i.lineLength.set=function(t){this._structArray.uint32[this._pos4+4]=t},i.segment.get=function(){return this._structArray.uint16[this._pos2+10]},i.segment.set=function(t){this._structArray.uint16[this._pos2+10]=t},i.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},i.lowerSize.set=function(t){this._structArray.uint16[this._pos2+11]=t},i.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},i.upperSize.set=function(t){this._structArray.uint16[this._pos2+12]=t},i.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},i.lineOffsetX.set=function(t){this._structArray.float32[this._pos4+7]=t},i.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},i.lineOffsetY.set=function(t){this._structArray.float32[this._pos4+8]=t},i.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},i.writingMode.set=function(t){this._structArray.uint8[this._pos1+36]=t},i.hidden.get=function(){return this._structArray.uint8[this._pos1+37]},i.hidden.set=function(t){this._structArray.uint8[this._pos1+37]=t},Object.defineProperties(r.prototype,i),r}(Struct);PlacedSymbolStruct.prototype.size=40;var PlacedSymbolArray=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.get=function(t){return new PlacedSymbolStruct(this,t)},r}(StructArrayLayout2i2ui3ul3ui2f2ub40);register("PlacedSymbolArray",PlacedSymbolArray);var GlyphOffsetStruct=function(t){function r(){t.apply(this,arguments)}t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r;var i={offsetX:{}};return i.offsetX.get=function(){return this._structArray.float32[this._pos4+0]},i.offsetX.set=function(t){this._structArray.float32[this._pos4+0]=t},Object.defineProperties(r.prototype,i),r}(Struct);GlyphOffsetStruct.prototype.size=4;var GlyphOffsetArray=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.getoffsetX=function(t){return this.float32[1*t+0]},r.prototype.get=function(t){return new GlyphOffsetStruct(this,t)},r}(StructArrayLayout1f4);register("GlyphOffsetArray",GlyphOffsetArray);var SymbolLineVertexStruct=function(t){function r(){t.apply(this,arguments)}t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r;var i={x:{},y:{},tileUnitDistanceFromAnchor:{}};return i.x.get=function(){return this._structArray.int16[this._pos2+0]},i.x.set=function(t){this._structArray.int16[this._pos2+0]=t},i.y.get=function(){return this._structArray.int16[this._pos2+1]},i.y.set=function(t){this._structArray.int16[this._pos2+1]=t},i.tileUnitDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+2]},i.tileUnitDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+2]=t},Object.defineProperties(r.prototype,i),r}(Struct);SymbolLineVertexStruct.prototype.size=6;var SymbolLineVertexArray=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.getx=function(t){return this.int16[3*t+0]},r.prototype.gety=function(t){return this.int16[3*t+1]},r.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},r.prototype.get=function(t){return new SymbolLineVertexStruct(this,t)},r}(StructArrayLayout3i6);register("SymbolLineVertexArray",SymbolLineVertexArray);var FeatureIndexStruct=function(t){function r(){t.apply(this,arguments)}t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r;var i={featureIndex:{},sourceLayerIndex:{},bucketIndex:{}};return i.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},i.featureIndex.set=function(t){this._structArray.uint32[this._pos4+0]=t},i.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},i.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t},i.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},i.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+3]=t},Object.defineProperties(r.prototype,i),r}(Struct);FeatureIndexStruct.prototype.size=8;var FeatureIndexArray=function(t){function r(){t.apply(this,arguments)}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.get=function(t){return new FeatureIndexStruct(this,t)},r}(StructArrayLayout1ul2ui8);register("FeatureIndexArray",FeatureIndexArray),module.exports={StructArrayLayout2i4:StructArrayLayout2i4,StructArrayLayout4i8:StructArrayLayout4i8,StructArrayLayout2i4i12:StructArrayLayout2i4i12,StructArrayLayout4i4ub12:StructArrayLayout4i4ub12,StructArrayLayout4i4ui16:StructArrayLayout4i4ui16,StructArrayLayout3f12:StructArrayLayout3f12,StructArrayLayout1ul4:StructArrayLayout1ul4,StructArrayLayout6i1ul2ui2i24:StructArrayLayout6i1ul2ui2i24,StructArrayLayout2i2i2i12:StructArrayLayout2i2i2i12,StructArrayLayout2ub4:StructArrayLayout2ub4,StructArrayLayout2i2ui3ul3ui2f2ub40:StructArrayLayout2i2ui3ul3ui2f2ub40,StructArrayLayout1f4:StructArrayLayout1f4,StructArrayLayout3i6:StructArrayLayout3i6,StructArrayLayout1ul2ui8:StructArrayLayout1ul2ui8,StructArrayLayout3ui6:StructArrayLayout3ui6,StructArrayLayout2ui4:StructArrayLayout2ui4,StructArrayLayout2f8:StructArrayLayout2f8,StructArrayLayout4f16:StructArrayLayout4f16,PosArray:StructArrayLayout2i4,RasterBoundsArray:StructArrayLayout4i8,CircleLayoutArray:StructArrayLayout2i4,FillLayoutArray:StructArrayLayout2i4,FillExtrusionLayoutArray:StructArrayLayout2i4i12,HeatmapLayoutArray:StructArrayLayout2i4,LineLayoutArray:StructArrayLayout4i4ub12,SymbolLayoutArray:StructArrayLayout4i4ui16,SymbolDynamicLayoutArray:StructArrayLayout3f12,SymbolOpacityArray:StructArrayLayout1ul4,CollisionBoxLayoutArray:StructArrayLayout2i2i2i12,CollisionCircleLayoutArray:StructArrayLayout2i2i2i12,CollisionVertexArray:StructArrayLayout2ub4,TriangleIndexArray:StructArrayLayout3ui6,LineIndexArray:StructArrayLayout2ui4,CollisionBoxArray:CollisionBoxArray,PlacedSymbolArray:PlacedSymbolArray,GlyphOffsetArray:GlyphOffsetArray,SymbolLineVertexArray:SymbolLineVertexArray,FeatureIndexArray:FeatureIndexArray};
},{"../util/struct_array":281,"../util/web_worker_transfer":288,"@mapbox/point-geometry":4}],43:[function(_dereq_,module,exports){
"use strict";module.exports={deserialize:function(r,e){var t={};if(!e)return t;for(var n=0,a=r;n<a.length;n+=1){var i=a[n],l=i.layerIds.map(function(r){return e.getLayer(r)}).filter(Boolean);if(0!==l.length){i.layers=l;for(var o=0,f=l;o<f.length;o+=1){t[f[o].id]=i}}}return t}};
},{}],44:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../../util/struct_array"),createLayout=ref.createLayout;module.exports=createLayout([{name:"a_pos",components:2,type:"Int16"}],4);
},{"../../util/struct_array":281}],45:[function(_dereq_,module,exports){
"use strict";function addCircleVertex(e,r,t,a,i){e.emplaceBack(2*r+(a+1)/2,2*t+(i+1)/2)}var ref=_dereq_("../array_types"),CircleLayoutArray=ref.CircleLayoutArray,layoutAttributes=_dereq_("./circle_attributes").members,ref$1=_dereq_("../segment"),SegmentVector=ref$1.SegmentVector,ref$2=_dereq_("../program_configuration"),ProgramConfigurationSet=ref$2.ProgramConfigurationSet,ref$3=_dereq_("../index_array_type"),TriangleIndexArray=ref$3.TriangleIndexArray,loadGeometry=_dereq_("../load_geometry"),EXTENT=_dereq_("../extent"),ref$4=_dereq_("../../util/web_worker_transfer"),register=ref$4.register,CircleBucket=function(e){this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.layerIds=this.layers.map(function(e){return e.id}),this.index=e.index,this.layoutVertexArray=new CircleLayoutArray,this.indexArray=new TriangleIndexArray,this.segments=new SegmentVector,this.programConfigurations=new ProgramConfigurationSet(layoutAttributes,e.layers,e.zoom)};CircleBucket.prototype.populate=function(e,r){for(var t=this,a=0,i=e;a<i.length;a+=1){var o=i[a],n=o.feature,u=o.index,s=o.sourceLayerIndex;if(t.layers[0]._featureFilter({zoom:t.zoom},n)){var y=loadGeometry(n);t.addFeature(n,y),r.featureIndex.insert(n,y,u,s,t.index)}}},CircleBucket.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},CircleBucket.prototype.upload=function(e){this.layoutVertexBuffer=e.createVertexBuffer(this.layoutVertexArray,layoutAttributes),this.indexBuffer=e.createIndexBuffer(this.indexArray),this.programConfigurations.upload(e)},CircleBucket.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},CircleBucket.prototype.addFeature=function(e,r){for(var t=this,a=0,i=r;a<i.length;a+=1)for(var o=i[a],n=0,u=o;n<u.length;n+=1){var s=u[n],y=s.x,l=s.y;if(!(y<0||y>=EXTENT||l<0||l>=EXTENT)){var c=t.segments.prepareSegment(4,t.layoutVertexArray,t.indexArray),f=c.vertexLength;addCircleVertex(t.layoutVertexArray,y,l,-1,-1),addCircleVertex(t.layoutVertexArray,y,l,1,-1),addCircleVertex(t.layoutVertexArray,y,l,1,1),addCircleVertex(t.layoutVertexArray,y,l,-1,1),t.indexArray.emplaceBack(f,f+1,f+2),t.indexArray.emplaceBack(f,f+3,f+2),c.vertexLength+=4,c.primitiveLength+=2}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e)},register("CircleBucket",CircleBucket,{omit:["layers"]}),module.exports=CircleBucket;
},{"../../util/web_worker_transfer":288,"../array_types":42,"../extent":56,"../index_array_type":58,"../load_geometry":59,"../program_configuration":61,"../segment":63,"./circle_attributes":44}],46:[function(_dereq_,module,exports){
arguments[4][44][0].apply(exports,arguments)
},{"../../util/struct_array":281,"dup":44}],47:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../array_types"),FillLayoutArray=ref.FillLayoutArray,layoutAttributes=_dereq_("./fill_attributes").members,ref$1=_dereq_("../segment"),SegmentVector=ref$1.SegmentVector,ref$2=_dereq_("../program_configuration"),ProgramConfigurationSet=ref$2.ProgramConfigurationSet,ref$3=_dereq_("../index_array_type"),LineIndexArray=ref$3.LineIndexArray,TriangleIndexArray=ref$3.TriangleIndexArray,loadGeometry=_dereq_("../load_geometry"),earcut=_dereq_("earcut"),classifyRings=_dereq_("../../util/classify_rings"),EARCUT_MAX_RINGS=500,ref$4=_dereq_("../../util/web_worker_transfer"),register=ref$4.register,FillBucket=function(e){this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.layerIds=this.layers.map(function(e){return e.id}),this.index=e.index,this.layoutVertexArray=new FillLayoutArray,this.indexArray=new TriangleIndexArray,this.indexArray2=new LineIndexArray,this.programConfigurations=new ProgramConfigurationSet(layoutAttributes,e.layers,e.zoom),this.segments=new SegmentVector,this.segments2=new SegmentVector};FillBucket.prototype.populate=function(e,r){for(var t=this,i=0,a=e;i<a.length;i+=1){var n=a[i],o=n.feature,s=n.index,u=n.sourceLayerIndex;if(t.layers[0]._featureFilter({zoom:t.zoom},o)){var l=loadGeometry(o);t.addFeature(o,l),r.featureIndex.insert(o,l,s,u,t.index)}}},FillBucket.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},FillBucket.prototype.upload=function(e){this.layoutVertexBuffer=e.createVertexBuffer(this.layoutVertexArray,layoutAttributes),this.indexBuffer=e.createIndexBuffer(this.indexArray),this.indexBuffer2=e.createIndexBuffer(this.indexArray2),this.programConfigurations.upload(e)},FillBucket.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy())},FillBucket.prototype.addFeature=function(e,r){for(var t=this,i=0,a=classifyRings(r,EARCUT_MAX_RINGS);i<a.length;i+=1){for(var n=a[i],o=0,s=0,u=n;s<u.length;s+=1){o+=u[s].length}for(var l=t.segments.prepareSegment(o,t.layoutVertexArray,t.indexArray),y=l.vertexLength,g=[],f=[],h=0,x=n;h<x.length;h+=1){var d=x[h];if(0!==d.length){d!==n[0]&&f.push(g.length/2);var c=t.segments2.prepareSegment(d.length,t.layoutVertexArray,t.indexArray2),m=c.vertexLength;t.layoutVertexArray.emplaceBack(d[0].x,d[0].y),t.indexArray2.emplaceBack(m+d.length-1,m),g.push(d[0].x),g.push(d[0].y);for(var p=1;p<d.length;p++)t.layoutVertexArray.emplaceBack(d[p].x,d[p].y),t.indexArray2.emplaceBack(m+p-1,m+p),g.push(d[p].x),g.push(d[p].y);c.vertexLength+=d.length,c.primitiveLength+=d.length}}for(var A=earcut(g,f),B=0;B<A.length;B+=3)t.indexArray.emplaceBack(y+A[B],y+A[B+1],y+A[B+2]);l.vertexLength+=o,l.primitiveLength+=A.length/3}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e)},register("FillBucket",FillBucket,{omit:["layers"]}),module.exports=FillBucket;
},{"../../util/classify_rings":266,"../../util/web_worker_transfer":288,"../array_types":42,"../index_array_type":58,"../load_geometry":59,"../program_configuration":61,"../segment":63,"./fill_attributes":46,"earcut":13}],48:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../../util/struct_array"),createLayout=ref.createLayout;module.exports=createLayout([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4);
},{"../../util/struct_array":281}],49:[function(_dereq_,module,exports){
"use strict";function addVertex(e,r,t,i,a,n,o,u){e.emplaceBack(r,t,2*Math.floor(i*FACTOR)+o,a*FACTOR*2,n*FACTOR*2,Math.round(u))}function isBoundaryEdge(e,r){return e.x===r.x&&(e.x<0||e.x>EXTENT)||e.y===r.y&&(e.y<0||e.y>EXTENT)}function isEntirelyOutside(e){return e.every(function(e){return e.x<0})||e.every(function(e){return e.x>EXTENT})||e.every(function(e){return e.y<0})||e.every(function(e){return e.y>EXTENT})}var ref=_dereq_("../array_types"),FillExtrusionLayoutArray=ref.FillExtrusionLayoutArray,layoutAttributes=_dereq_("./fill_extrusion_attributes").members,ref$1=_dereq_("../segment"),SegmentVector=ref$1.SegmentVector,MAX_VERTEX_ARRAY_LENGTH=ref$1.MAX_VERTEX_ARRAY_LENGTH,ref$2=_dereq_("../program_configuration"),ProgramConfigurationSet=ref$2.ProgramConfigurationSet,ref$3=_dereq_("../index_array_type"),TriangleIndexArray=ref$3.TriangleIndexArray,loadGeometry=_dereq_("../load_geometry"),EXTENT=_dereq_("../extent"),earcut=_dereq_("earcut"),classifyRings=_dereq_("../../util/classify_rings"),EARCUT_MAX_RINGS=500,ref$4=_dereq_("../../util/web_worker_transfer"),register=ref$4.register,FACTOR=Math.pow(2,13),FillExtrusionBucket=function(e){this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.layerIds=this.layers.map(function(e){return e.id}),this.index=e.index,this.layoutVertexArray=new FillExtrusionLayoutArray,this.indexArray=new TriangleIndexArray,this.programConfigurations=new ProgramConfigurationSet(layoutAttributes,e.layers,e.zoom),this.segments=new SegmentVector};FillExtrusionBucket.prototype.populate=function(e,r){for(var t=this,i=0,a=e;i<a.length;i+=1){var n=a[i],o=n.feature,u=n.index,s=n.sourceLayerIndex;if(t.layers[0]._featureFilter({zoom:t.zoom},o)){var y=loadGeometry(o);t.addFeature(o,y),r.featureIndex.insert(o,y,u,s,t.index)}}},FillExtrusionBucket.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},FillExtrusionBucket.prototype.upload=function(e){this.layoutVertexBuffer=e.createVertexBuffer(this.layoutVertexArray,layoutAttributes),this.indexBuffer=e.createIndexBuffer(this.indexArray),this.programConfigurations.upload(e)},FillExtrusionBucket.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},FillExtrusionBucket.prototype.addFeature=function(e,r){for(var t=this,i=0,a=classifyRings(r,EARCUT_MAX_RINGS);i<a.length;i+=1){for(var n=a[i],o=0,u=0,s=n;u<s.length;u+=1){o+=s[u].length}for(var y=t.segments.prepareSegment(4,t.layoutVertexArray,t.indexArray),l=0,x=n;l<x.length;l+=1){var f=x[l];if(0!==f.length&&!isEntirelyOutside(f))for(var g=0,d=0;d<f.length;d++){var h=f[d];if(d>=1){var A=f[d-1];if(!isBoundaryEdge(h,A)){y.vertexLength+4>MAX_VERTEX_ARRAY_LENGTH&&(y=t.segments.prepareSegment(4,t.layoutVertexArray,t.indexArray));var c=h.sub(A)._perp()._unit(),p=A.dist(h);g+p>32768&&(g=0),addVertex(t.layoutVertexArray,h.x,h.y,c.x,c.y,0,0,g),addVertex(t.layoutVertexArray,h.x,h.y,c.x,c.y,0,1,g),g+=p,addVertex(t.layoutVertexArray,A.x,A.y,c.x,c.y,0,0,g),addVertex(t.layoutVertexArray,A.x,A.y,c.x,c.y,0,1,g);var E=y.vertexLength;t.indexArray.emplaceBack(E,E+1,E+2),t.indexArray.emplaceBack(E+1,E+2,E+3),y.vertexLength+=4,y.primitiveLength+=2}}}}y.vertexLength+o>MAX_VERTEX_ARRAY_LENGTH&&(y=t.segments.prepareSegment(o,t.layoutVertexArray,t.indexArray));for(var m=[],v=[],V=y.vertexLength,_=0,T=n;_<T.length;_+=1){var B=T[_];if(0!==B.length){B!==n[0]&&v.push(m.length/2);for(var R=0;R<B.length;R++){var F=B[R];addVertex(t.layoutVertexArray,F.x,F.y,0,0,1,1,0),m.push(F.x),m.push(F.y)}}}for(var L=earcut(m,v),X=0;X<L.length;X+=3)t.indexArray.emplaceBack(V+L[X],V+L[X+1],V+L[X+2]);y.primitiveLength+=L.length/3,y.vertexLength+=o}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e)},register("FillExtrusionBucket",FillExtrusionBucket,{omit:["layers"]}),module.exports=FillExtrusionBucket;
},{"../../util/classify_rings":266,"../../util/web_worker_transfer":288,"../array_types":42,"../extent":56,"../index_array_type":58,"../load_geometry":59,"../program_configuration":61,"../segment":63,"./fill_extrusion_attributes":48,"earcut":13}],50:[function(_dereq_,module,exports){
"use strict";var CircleBucket=_dereq_("./circle_bucket"),ref=_dereq_("../../util/web_worker_transfer"),register=ref.register,HeatmapBucket=function(e){function t(){e.apply(this,arguments)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t}(CircleBucket);register("HeatmapBucket",HeatmapBucket,{omit:["layers"]}),module.exports=HeatmapBucket;
},{"../../util/web_worker_transfer":288,"./circle_bucket":45}],51:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../../util/struct_array"),createLayout=ref.createLayout;module.exports=createLayout([{name:"a_pos_normal",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4);
},{"../../util/struct_array":281}],52:[function(_dereq_,module,exports){
"use strict";function addLineVertex(e,t,r,i,a,n,s){e.emplaceBack(t.x,t.y,i?1:0,a?1:-1,Math.round(EXTRUDE_SCALE*r.x)+128,Math.round(EXTRUDE_SCALE*r.y)+128,1+(0===n?0:n<0?-1:1)|(s*LINE_DISTANCE_SCALE&63)<<2,s*LINE_DISTANCE_SCALE>>6)}var ref=_dereq_("../array_types"),LineLayoutArray=ref.LineLayoutArray,layoutAttributes=_dereq_("./line_attributes").members,ref$1=_dereq_("../segment"),SegmentVector=ref$1.SegmentVector,ref$2=_dereq_("../program_configuration"),ProgramConfigurationSet=ref$2.ProgramConfigurationSet,ref$3=_dereq_("../index_array_type"),TriangleIndexArray=ref$3.TriangleIndexArray,loadGeometry=_dereq_("../load_geometry"),EXTENT=_dereq_("../extent"),vectorTileFeatureTypes=_dereq_("@mapbox/vector-tile").VectorTileFeature.types,ref$4=_dereq_("../../util/web_worker_transfer"),register=ref$4.register,EXTRUDE_SCALE=63,COS_HALF_SHARP_CORNER=Math.cos(Math.PI/180*37.5),SHARP_CORNER_OFFSET=15,LINE_DISTANCE_BUFFER_BITS=15,LINE_DISTANCE_SCALE=.5,MAX_LINE_DISTANCE=Math.pow(2,LINE_DISTANCE_BUFFER_BITS-1)/LINE_DISTANCE_SCALE,LineBucket=function(e){this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.layerIds=this.layers.map(function(e){return e.id}),this.index=e.index,this.layoutVertexArray=new LineLayoutArray,this.indexArray=new TriangleIndexArray,this.programConfigurations=new ProgramConfigurationSet(layoutAttributes,e.layers,e.zoom),this.segments=new SegmentVector};LineBucket.prototype.populate=function(e,t){for(var r=this,i=0,a=e;i<a.length;i+=1){var n=a[i],s=n.feature,u=n.index,d=n.sourceLayerIndex;if(r.layers[0]._featureFilter({zoom:r.zoom},s)){var o=loadGeometry(s);r.addFeature(s,o),t.featureIndex.insert(s,o,u,d,r.index)}}},LineBucket.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},LineBucket.prototype.upload=function(e){this.layoutVertexBuffer=e.createVertexBuffer(this.layoutVertexArray,layoutAttributes),this.indexBuffer=e.createIndexBuffer(this.indexArray),this.programConfigurations.upload(e)},LineBucket.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},LineBucket.prototype.addFeature=function(e,t){for(var r=this,i=this.layers[0].layout,a=i.get("line-join").evaluate(e),n=i.get("line-cap"),s=i.get("line-miter-limit"),u=i.get("line-round-limit"),d=0,o=t;d<o.length;d+=1){var l=o[d];r.addLine(l,e,a,n,s,u)}},LineBucket.prototype.addLine=function(e,t,r,i,a,n){for(var s=this,u="Polygon"===vectorTileFeatureTypes[t.type],d=e.length;d>=2&&e[d-1].equals(e[d-2]);)d--;for(var o=0;o<d-1&&e[o].equals(e[o+1]);)o++;if(!(d<(u?3:2))){"bevel"===r&&(a=1.05);var l=SHARP_CORNER_OFFSET*(EXTENT/(512*this.overscaling)),h=e[o],y=this.segments.prepareSegment(10*d,this.layoutVertexArray,this.indexArray);this.distance=0;var c,f,x,m=i,p=u?"butt":i,_=!0,g=void 0,v=void 0,L=void 0,A=void 0;this.e1=this.e2=this.e3=-1,u&&(c=e[d-2],A=h.sub(c)._unit()._perp());for(var C=o;C<d;C++)if(!(v=u&&C===d-1?e[o+1]:e[C+1])||!e[C].equals(v)){A&&(L=A),c&&(g=c),c=e[C],A=v?v.sub(c)._unit()._perp():L,L=L||A;var E=L.add(A);0===E.x&&0===E.y||E._unit();var V=E.x*A.x+E.y*A.y,S=0!==V?1/V:1/0,B=V<COS_HALF_SHARP_CORNER&&g&&v;if(B&&C>o){var T=c.dist(g);if(T>2*l){var I=c.sub(c.sub(g)._mult(l/T)._round());s.distance+=I.dist(g),s.addCurrentVertex(I,s.distance,L.mult(1),0,0,!1,y),g=I}}var b=g&&v,N=b?r:v?m:p;if(b&&"round"===N&&(S<n?N="miter":S<=2&&(N="fakeround")),"miter"===N&&S>a&&(N="bevel"),"bevel"===N&&(S>2&&(N="flipbevel"),S<a&&(N="miter")),g&&(s.distance+=c.dist(g)),"miter"===N)E._mult(S),s.addCurrentVertex(c,s.distance,E,0,0,!1,y);else if("flipbevel"===N){if(S>100)E=A.clone().mult(-1);else{var k=L.x*A.y-L.y*A.x>0?-1:1,R=S*L.add(A).mag()/L.sub(A).mag();E._perp()._mult(R*k)}s.addCurrentVertex(c,s.distance,E,0,0,!1,y),s.addCurrentVertex(c,s.distance,E.mult(-1),0,0,!1,y)}else if("bevel"===N||"fakeround"===N){var F=L.x*A.y-L.y*A.x>0,q=-Math.sqrt(S*S-1);if(F?(x=0,f=q):(f=0,x=q),_||s.addCurrentVertex(c,s.distance,L,f,x,!1,y),"fakeround"===N){for(var P=Math.floor(8*(.5-(V-.5))),D=void 0,M=0;M<P;M++)D=A.mult((M+1)/(P+1))._add(L)._unit(),s.addPieSliceVertex(c,s.distance,D,F,y);s.addPieSliceVertex(c,s.distance,E,F,y);for(var O=P-1;O>=0;O--)D=L.mult((O+1)/(P+1))._add(A)._unit(),s.addPieSliceVertex(c,s.distance,D,F,y)}v&&s.addCurrentVertex(c,s.distance,A,-f,-x,!1,y)}else"butt"===N?(_||s.addCurrentVertex(c,s.distance,L,0,0,!1,y),v&&s.addCurrentVertex(c,s.distance,A,0,0,!1,y)):"square"===N?(_||(s.addCurrentVertex(c,s.distance,L,1,1,!1,y),s.e1=s.e2=-1),v&&s.addCurrentVertex(c,s.distance,A,-1,-1,!1,y)):"round"===N&&(_||(s.addCurrentVertex(c,s.distance,L,0,0,!1,y),s.addCurrentVertex(c,s.distance,L,1,1,!0,y),s.e1=s.e2=-1),v&&(s.addCurrentVertex(c,s.distance,A,-1,-1,!0,y),s.addCurrentVertex(c,s.distance,A,0,0,!1,y)));if(B&&C<d-1){var $=c.dist(v);if($>2*l){var w=c.add(v.sub(c)._mult(l/$)._round());s.distance+=w.dist(c),s.addCurrentVertex(w,s.distance,A.mult(1),0,0,!1,y),c=w}}_=!1}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t)}},LineBucket.prototype.addCurrentVertex=function(e,t,r,i,a,n,s){var u,d=this.layoutVertexArray,o=this.indexArray;u=r.clone(),i&&u._sub(r.perp()._mult(i)),addLineVertex(d,e,u,n,!1,i,t),this.e3=s.vertexLength++,this.e1>=0&&this.e2>=0&&(o.emplaceBack(this.e1,this.e2,this.e3),s.primitiveLength++),this.e1=this.e2,this.e2=this.e3,u=r.mult(-1),a&&u._sub(r.perp()._mult(a)),addLineVertex(d,e,u,n,!0,-a,t),this.e3=s.vertexLength++,this.e1>=0&&this.e2>=0&&(o.emplaceBack(this.e1,this.e2,this.e3),s.primitiveLength++),this.e1=this.e2,this.e2=this.e3,t>MAX_LINE_DISTANCE/2&&(this.distance=0,this.addCurrentVertex(e,this.distance,r,i,a,n,s))},LineBucket.prototype.addPieSliceVertex=function(e,t,r,i,a){r=r.mult(i?-1:1);var n=this.layoutVertexArray,s=this.indexArray;addLineVertex(n,e,r,!1,i,0,t),this.e3=a.vertexLength++,this.e1>=0&&this.e2>=0&&(s.emplaceBack(this.e1,this.e2,this.e3),a.primitiveLength++),i?this.e2=this.e3:this.e1=this.e3},register("LineBucket",LineBucket,{omit:["layers"]}),module.exports=LineBucket;
},{"../../util/web_worker_transfer":288,"../array_types":42,"../extent":56,"../index_array_type":58,"../load_geometry":59,"../program_configuration":61,"../segment":63,"./line_attributes":51,"@mapbox/vector-tile":8}],53:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../../util/struct_array"),createLayout=ref.createLayout,symbolLayoutAttributes=createLayout([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"}]),dynamicLayoutAttributes=createLayout([{name:"a_projected_pos",components:3,type:"Float32"}],4),placementOpacityAttributes=createLayout([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),collisionVertexAttributes=createLayout([{name:"a_placed",components:2,type:"Uint8"}],4),symbolAttributes={symbolLayoutAttributes:symbolLayoutAttributes,dynamicLayoutAttributes:dynamicLayoutAttributes,placementOpacityAttributes:placementOpacityAttributes,collisionVertexAttributes:collisionVertexAttributes,collisionBox:createLayout([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"radius"},{type:"Int16",name:"signedDistanceFromAnchor"}]),collisionBoxLayout:createLayout([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4),collisionCircleLayout:createLayout([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4),placement:createLayout([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"hidden"}]),glyphOffset:createLayout([{type:"Float32",name:"offsetX"}]),lineVertex:createLayout([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}])};module.exports=symbolAttributes;
},{"../../util/struct_array":281}],54:[function(_dereq_,module,exports){
"use strict";function addVertex(e,t,r,o,i,a,n,s){e.emplaceBack(t,r,Math.round(64*o),Math.round(64*i),a,n,s?s[0]:void 0,s?s[1]:void 0)}function addDynamicAttributes(e,t,r){e.emplaceBack(t.x,t.y,r),e.emplaceBack(t.x,t.y,r),e.emplaceBack(t.x,t.y,r),e.emplaceBack(t.x,t.y,r)}var ref=_dereq_("./symbol_attributes"),symbolLayoutAttributes=ref.symbolLayoutAttributes,collisionVertexAttributes=ref.collisionVertexAttributes,collisionBoxLayout=ref.collisionBoxLayout,collisionCircleLayout=ref.collisionCircleLayout,dynamicLayoutAttributes=ref.dynamicLayoutAttributes,ref$1=_dereq_("../array_types"),SymbolLayoutArray=ref$1.SymbolLayoutArray,SymbolDynamicLayoutArray=ref$1.SymbolDynamicLayoutArray,SymbolOpacityArray=ref$1.SymbolOpacityArray,CollisionBoxLayoutArray=ref$1.CollisionBoxLayoutArray,CollisionCircleLayoutArray=ref$1.CollisionCircleLayoutArray,CollisionVertexArray=ref$1.CollisionVertexArray,PlacedSymbolArray=ref$1.PlacedSymbolArray,GlyphOffsetArray=ref$1.GlyphOffsetArray,SymbolLineVertexArray=ref$1.SymbolLineVertexArray,Point=_dereq_("@mapbox/point-geometry"),ref$2=_dereq_("../segment"),SegmentVector=ref$2.SegmentVector,ref$3=_dereq_("../program_configuration"),ProgramConfigurationSet=ref$3.ProgramConfigurationSet,ref$4=_dereq_("../index_array_type"),TriangleIndexArray=ref$4.TriangleIndexArray,LineIndexArray=ref$4.LineIndexArray,transformText=_dereq_("../../symbol/transform_text"),mergeLines=_dereq_("../../symbol/mergelines"),scriptDetection=_dereq_("../../util/script_detection"),loadGeometry=_dereq_("../load_geometry"),vectorTileFeatureTypes=_dereq_("@mapbox/vector-tile").VectorTileFeature.types,verticalizePunctuation=_dereq_("../../util/verticalize_punctuation"),Anchor=_dereq_("../../symbol/anchor"),OpacityState=_dereq_("../../symbol/opacity_state"),ref$5=_dereq_("../../symbol/symbol_size"),getSizeData=ref$5.getSizeData,ref$6=_dereq_("../../util/web_worker_transfer"),register=ref$6.register,shaderOpacityAttributes=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}],symbolBufferConfigurations={text:{LayoutArray:SymbolLayoutArray,layoutAttributes:symbolLayoutAttributes.members,IndexArray:TriangleIndexArray,dynamicLayout:!0,opacity:!0,collision:!1},icon:{LayoutArray:SymbolLayoutArray,layoutAttributes:symbolLayoutAttributes.members,IndexArray:TriangleIndexArray,dynamicLayout:!0,opacity:!0,collision:!1},collisionBox:{LayoutArray:CollisionBoxLayoutArray,layoutAttributes:collisionBoxLayout.members,IndexArray:LineIndexArray,dynamicLayout:!1,opacity:!1,collision:!0},collisionCircle:{LayoutArray:CollisionCircleLayoutArray,layoutAttributes:collisionCircleLayout.members,IndexArray:TriangleIndexArray,dynamicLayout:!1,opacity:!1,collision:!0}},SymbolBuffers=function(e,t){this.layoutVertexArray=new e.LayoutArray,this.layoutAttributes=e.layoutAttributes,this.indexArray=new e.IndexArray,this.programConfigurations=t,this.segments=new SegmentVector,e.dynamicLayout&&(this.dynamicLayoutVertexArray=new SymbolDynamicLayoutArray),e.opacity&&(this.opacityVertexArray=new SymbolOpacityArray),e.collision&&(this.collisionVertexArray=new CollisionVertexArray)};SymbolBuffers.prototype.upload=function(e,t){void 0===t&&(t=!1),this.layoutVertexBuffer=e.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=e.createIndexBuffer(this.indexArray,t),this.programConfigurations.upload(e),this.dynamicLayoutVertexArray&&(this.dynamicLayoutVertexBuffer=e.createVertexBuffer(this.dynamicLayoutVertexArray,dynamicLayoutAttributes.members,!0)),this.opacityVertexArray&&(this.opacityVertexBuffer=e.createVertexBuffer(this.opacityVertexArray,shaderOpacityAttributes,!0),this.opacityVertexBuffer.itemSize=1),this.collisionVertexArray&&(this.collisionVertexBuffer=e.createVertexBuffer(this.collisionVertexArray,collisionVertexAttributes.members,!0))},SymbolBuffers.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer&&this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer&&this.opacityVertexBuffer.destroy(),this.collisionVertexBuffer&&this.collisionVertexBuffer.destroy())},register("SymbolBuffers",SymbolBuffers);var SymbolBucket=function(e){this.collisionBoxArray=e.collisionBoxArray,this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.layerIds=this.layers.map(function(e){return e.id}),this.index=e.index,this.pixelRatio=e.pixelRatio;var t=this.layers[0],r=t._unevaluatedLayout._values;this.textSizeData=getSizeData(this.zoom,r["text-size"]),this.iconSizeData=getSizeData(this.zoom,r["icon-size"]);var o=this.layers[0].layout;this.sortFeaturesByY=o.get("text-allow-overlap")||o.get("icon-allow-overlap")||o.get("text-ignore-placement")||o.get("icon-ignore-placement")};SymbolBucket.prototype.createArrays=function(){this.text=new SymbolBuffers(symbolBufferConfigurations.text,new ProgramConfigurationSet(symbolLayoutAttributes.members,this.layers,this.zoom,function(e){return/^text/.test(e)})),this.icon=new SymbolBuffers(symbolBufferConfigurations.icon,new ProgramConfigurationSet(symbolLayoutAttributes.members,this.layers,this.zoom,function(e){return/^icon/.test(e)})),this.collisionBox=new SymbolBuffers(symbolBufferConfigurations.collisionBox,new ProgramConfigurationSet(collisionBoxLayout.members,this.layers,this.zoom,function(){return!1})),this.collisionCircle=new SymbolBuffers(symbolBufferConfigurations.collisionCircle,new ProgramConfigurationSet(collisionCircleLayout.members,this.layers,this.zoom,function(){return!1})),this.placedGlyphArray=new PlacedSymbolArray,this.placedIconArray=new PlacedSymbolArray,this.glyphOffsetArray=new GlyphOffsetArray,this.lineVertexArray=new SymbolLineVertexArray},SymbolBucket.prototype.populate=function(e,t){var r=this,o=this.layers[0],i=o.layout,a=i.get("text-font"),n=i.get("text-field"),s=i.get("icon-image"),l=("constant"!==n.value.kind||n.value.value.length>0)&&("constant"!==a.value.kind||a.value.value.length>0),y="constant"!==s.value.kind||s.value.value&&s.value.value.length>0;if(this.features=[],l||y){for(var c=t.iconDependencies,u=t.glyphDependencies,x={zoom:this.zoom},m=0,f=e;m<f.length;m+=1){var h=f[m],d=h.feature,p=h.index,g=h.sourceLayerIndex;if(o._featureFilter(x,d)){var A=void 0;l&&(A=o.getValueAndResolveTokens("text-field",d),A=transformText(A,o,d));var b=void 0;if(y&&(b=o.getValueAndResolveTokens("icon-image",d)),A||b){var B={text:A,icon:b,index:p,sourceLayerIndex:g,geometry:loadGeometry(d),properties:d.properties,type:vectorTileFeatureTypes[d.type]};if(void 0!==d.id&&(B.id=d.id),r.features.push(B),b&&(c[b]=!0),A)for(var v=a.evaluate(d).join(","),S=u[v]=u[v]||{},L="map"===i.get("text-rotation-alignment")&&"line"===i.get("symbol-placement"),V=scriptDetection.allowsVerticalWritingMode(A),C=0;C<A.length;C++)if(S[A.charCodeAt(C)]=!0,L&&V){var k=verticalizePunctuation.lookup[A.charAt(C)];k&&(S[k.charCodeAt(0)]=!0)}}}}"line"===i.get("symbol-placement")&&(this.features=mergeLines(this.features))}},SymbolBucket.prototype.isEmpty=function(){return 0===this.symbolInstances.length},SymbolBucket.prototype.upload=function(e){this.text.upload(e,this.sortFeaturesByY),this.icon.upload(e,this.sortFeaturesByY),this.collisionBox.upload(e),this.collisionCircle.upload(e)},SymbolBucket.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.collisionBox.destroy(),this.collisionCircle.destroy()},SymbolBucket.prototype.addToLineVertexArray=function(e,t){var r=this,o=this.lineVertexArray.length;if(void 0!==e.segment){for(var i=e.dist(t[e.segment+1]),a=e.dist(t[e.segment]),n={},s=e.segment+1;s<t.length;s++)n[s]={x:t[s].x,y:t[s].y,tileUnitDistanceFromAnchor:i},s<t.length-1&&(i+=t[s+1].dist(t[s]));for(var l=e.segment||0;l>=0;l--)n[l]={x:t[l].x,y:t[l].y,tileUnitDistanceFromAnchor:a},l>0&&(a+=t[l-1].dist(t[l]));for(var y=0;y<t.length;y++){var c=n[y];r.lineVertexArray.emplaceBack(c.x,c.y,c.tileUnitDistanceFromAnchor)}}return{lineStartIndex:o,lineLength:this.lineVertexArray.length-o}},SymbolBucket.prototype.addSymbols=function(e,t,r,o,i,a,n,s,l,y,c){for(var u=this,x=e.indexArray,m=e.layoutVertexArray,f=e.dynamicLayoutVertexArray,h=e.segments.prepareSegment(4*t.length,e.layoutVertexArray,e.indexArray),d=this.glyphOffsetArray.length,p=h.vertexLength,g=0,A=t;g<A.length;g+=1){var b=A[g],B=b.tl,v=b.tr,S=b.bl,L=b.br,V=b.tex,C=h.vertexLength,k=b.glyphOffset[1];addVertex(m,s.x,s.y,B.x,k+B.y,V.x,V.y,r),addVertex(m,s.x,s.y,v.x,k+v.y,V.x+V.w,V.y,r),addVertex(m,s.x,s.y,S.x,k+S.y,V.x,V.y+V.h,r),addVertex(m,s.x,s.y,L.x,k+L.y,V.x+V.w,V.y+V.h,r),addDynamicAttributes(f,s,0),x.emplaceBack(C,C+1,C+2),x.emplaceBack(C+1,C+2,C+3),h.vertexLength+=4,h.primitiveLength+=2,u.glyphOffsetArray.emplaceBack(b.glyphOffset[0])}c.emplaceBack(s.x,s.y,d,this.glyphOffsetArray.length-d,p,l,y,s.segment,r?r[0]:0,r?r[1]:0,o[0],o[1],n,!1),e.programConfigurations.populatePaintArrays(e.layoutVertexArray.length,a)},SymbolBucket.prototype._addCollisionDebugVertex=function(e,t,r,o,i){return t.emplaceBack(0,0),e.emplaceBack(r.x,r.y,o.x,o.y,Math.round(i.x),Math.round(i.y))},SymbolBucket.prototype.addCollisionDebugVertices=function(e,t,r,o,i,a,n,s){var l=i.segments.prepareSegment(4,i.layoutVertexArray,i.indexArray),y=l.vertexLength,c=i.layoutVertexArray,u=i.collisionVertexArray;if(this._addCollisionDebugVertex(c,u,a,n.anchor,new Point(e,t)),this._addCollisionDebugVertex(c,u,a,n.anchor,new Point(r,t)),this._addCollisionDebugVertex(c,u,a,n.anchor,new Point(r,o)),this._addCollisionDebugVertex(c,u,a,n.anchor,new Point(e,o)),l.vertexLength+=4,s){var x=i.indexArray;x.emplaceBack(y,y+1,y+2),x.emplaceBack(y,y+2,y+3),l.primitiveLength+=2}else{var m=i.indexArray;m.emplaceBack(y,y+1),m.emplaceBack(y+1,y+2),m.emplaceBack(y+2,y+3),m.emplaceBack(y+3,y),l.primitiveLength+=4}},SymbolBucket.prototype.generateCollisionDebugBuffers=function(){for(var e=this,t=0,r=e.symbolInstances;t<r.length;t+=1){var o=r[t];o.textCollisionFeature={boxStartIndex:o.textBoxStartIndex,boxEndIndex:o.textBoxEndIndex},o.iconCollisionFeature={boxStartIndex:o.iconBoxStartIndex,boxEndIndex:o.iconBoxEndIndex};for(var i=0;i<2;i++){var a=o[0===i?"textCollisionFeature":"iconCollisionFeature"];if(a)for(var n=a.boxStartIndex;n<a.boxEndIndex;n++){var s=e.collisionBoxArray.get(n),l=s.x1,y=s.y1,c=s.x2,u=s.y2,x=s.radius>0;e.addCollisionDebugVertices(l,y,c,u,x?e.collisionCircle:e.collisionBox,s.anchorPoint,o,x)}}}},SymbolBucket.prototype.deserializeCollisionBoxes=function(e,t,r,o,i){for(var a={},n=t;n<r;n++){var s=e.get(n);if(0===s.radius){a.textBox={x1:s.x1,y1:s.y1,x2:s.x2,y2:s.y2,anchorPointX:s.anchorPointX,anchorPointY:s.anchorPointY};break}a.textCircles||(a.textCircles=[]);a.textCircles.push(s.anchorPointX,s.anchorPointY,s.radius,s.signedDistanceFromAnchor,1)}for(var l=o;l<i;l++){var y=e.get(l);if(0===y.radius){a.iconBox={x1:y.x1,y1:y.y1,x2:y.x2,y2:y.y2,anchorPointX:y.anchorPointX,anchorPointY:y.anchorPointY};break}}return a},SymbolBucket.prototype.sortFeatures=function(e){var t=this;if(this.sortFeaturesByY&&this.sortedAngle!==e&&(this.sortedAngle=e,!(this.text.segments.get().length>1||this.icon.segments.get().length>1))){for(var r=[],o=0;o<this.symbolInstances.length;o++)r.push(o);var i=Math.sin(e),a=Math.cos(e);r.sort(function(e,r){var o=t.symbolInstances[e],n=t.symbolInstances[r];return(i*o.anchor.x+a*o.anchor.y|0)-(i*n.anchor.x+a*n.anchor.y|0)||n.featureIndex-o.featureIndex}),this.text.indexArray.clear(),this.icon.indexArray.clear();for(var n=0,s=r;n<s.length;n+=1){for(var l=s[n],y=t.symbolInstances[l],c=0,u=y.placedTextSymbolIndices;c<u.length;c+=1)for(var x=u[c],m=t.placedGlyphArray.get(x),f=m.vertexStartIndex+4*m.numGlyphs,h=m.vertexStartIndex;h<f;h+=4)t.text.indexArray.emplaceBack(h,h+1,h+2),t.text.indexArray.emplaceBack(h+1,h+2,h+3);var d=t.placedIconArray.get(l);if(d.numGlyphs){var p=d.vertexStartIndex;t.icon.indexArray.emplaceBack(p,p+1,p+2),t.icon.indexArray.emplaceBack(p+1,p+2,p+3)}}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray)}},register("SymbolBucket",SymbolBucket,{omit:["layers","collisionBoxArray","features","compareText"],shallow:["symbolInstances"]}),SymbolBucket.MAX_GLYPHS=65535,SymbolBucket.addDynamicAttributes=addDynamicAttributes,module.exports=SymbolBucket;
},{"../../symbol/anchor":224,"../../symbol/mergelines":232,"../../symbol/opacity_state":233,"../../symbol/symbol_size":239,"../../symbol/transform_text":240,"../../util/script_detection":279,"../../util/verticalize_punctuation":287,"../../util/web_worker_transfer":288,"../array_types":42,"../index_array_type":58,"../load_geometry":59,"../program_configuration":61,"../segment":63,"./symbol_attributes":53,"@mapbox/point-geometry":4,"@mapbox/vector-tile":8}],55:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/image"),RGBAImage=ref.RGBAImage,util=_dereq_("../util/util"),ref$1=_dereq_("../util/web_worker_transfer"),register=ref$1.register,Level=function(e,t,i){if(e<=0)throw new RangeError("Level must have positive dimension");this.dim=e,this.border=t,this.stride=this.dim+2*this.border,this.data=i||new Int32Array((this.dim+2*this.border)*(this.dim+2*this.border))};Level.prototype.set=function(e,t,i){this.data[this._idx(e,t)]=i+65536},Level.prototype.get=function(e,t){return this.data[this._idx(e,t)]-65536},Level.prototype._idx=function(e,t){if(e<-this.border||e>=this.dim+this.border||t<-this.border||t>=this.dim+this.border)throw new RangeError("out of range source coordinates for DEM data");return(t+this.border)*this.stride+(e+this.border)},register("Level",Level);var DEMData=function(e,t,i){this.uid=e,this.scale=t||1,this.level=i||new Level(256,512),this.loaded=!!i};DEMData.prototype.loadFromImage=function(e){var t=this;if(e.height!==e.width)throw new RangeError("DEM tiles must be square");for(var i=this.level=new Level(e.width,e.width/2),r=e.data,d=0;d<i.dim;d++)for(var s=0;s<i.dim;s++){var a=d*i.dim+s,o=4*a;i.set(s,d,t.scale*((256*r[o]*256+256*r[o+1]+r[o+2])/10-1e4))}for(var m=0;m<i.dim;m++)i.set(-1,m,i.get(0,m)),i.set(i.dim,m,i.get(i.dim-1,m)),i.set(m,-1,i.get(m,0)),i.set(m,i.dim,i.get(m,i.dim-1));i.set(-1,-1,i.get(0,0)),i.set(i.dim,-1,i.get(i.dim-1,0)),i.set(-1,i.dim,i.get(0,i.dim-1)),i.set(i.dim,i.dim,i.get(i.dim-1,i.dim-1)),this.loaded=!0},DEMData.prototype.getPixels=function(){return new RGBAImage({width:this.level.dim+2*this.level.border,height:this.level.dim+2*this.level.border},new Uint8Array(this.level.data.buffer))},DEMData.prototype.backfillBorder=function(e,t,i){var r=this.level,d=e.level;if(r.dim!==d.dim)throw new Error("level mismatch (dem dimension)");var s=t*r.dim,a=t*r.dim+r.dim,o=i*r.dim,m=i*r.dim+r.dim;switch(t){case-1:s=a-1;break;case 1:a=s+1}switch(i){case-1:o=m-1;break;case 1:m=o+1}for(var l=util.clamp(s,-r.border,r.dim+r.border),h=util.clamp(a,-r.border,r.dim+r.border),n=util.clamp(o,-r.border,r.dim+r.border),v=util.clamp(m,-r.border,r.dim+r.border),u=-t*r.dim,f=-i*r.dim,b=n;b<v;b++)for(var g=l;g<h;g++)r.set(g,b,d.get(g+u,b+f))},register("DEMData",DEMData),module.exports={DEMData:DEMData,Level:Level};
},{"../util/image":274,"../util/util":285,"../util/web_worker_transfer":288}],56:[function(_dereq_,module,exports){
"use strict";module.exports=8192;
},{}],57:[function(_dereq_,module,exports){
"use strict";function topDownFeatureComparator(e,r){return r-e}var Point=_dereq_("@mapbox/point-geometry"),loadGeometry=_dereq_("./load_geometry"),EXTENT=_dereq_("./extent"),featureFilter=_dereq_("../style-spec/feature_filter"),Grid=_dereq_("grid-index"),DictionaryCoder=_dereq_("../util/dictionary_coder"),vt=_dereq_("@mapbox/vector-tile"),Protobuf=_dereq_("pbf"),GeoJSONFeature=_dereq_("../util/vectortile_to_geojson"),arraysIntersect=_dereq_("../util/util").arraysIntersect,ref=_dereq_("../source/tile_id"),OverscaledTileID=ref.OverscaledTileID,ref$1=_dereq_("../util/web_worker_transfer"),register=ref$1.register,ref$2=_dereq_("./array_types"),FeatureIndexArray=ref$2.FeatureIndexArray,FeatureIndex=function(e,r,t,a){this.tileID=e,this.overscaling=r,this.x=e.canonical.x,this.y=e.canonical.y,this.z=e.canonical.z,this.grid=t||new Grid(EXTENT,16,0),this.featureIndexArray=a||new FeatureIndexArray};FeatureIndex.prototype.insert=function(e,r,t,a,i){var o=this,n=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(t,a,i);for(var s=0;s<r.length;s++){for(var u=r[s],l=[1/0,1/0,-1/0,-1/0],y=0;y<u.length;y++){var d=u[y];l[0]=Math.min(l[0],d.x),l[1]=Math.min(l[1],d.y),l[2]=Math.max(l[2],d.x),l[3]=Math.max(l[3],d.y)}o.grid.insert(n,l[0],l[1],l[2],l[3])}},FeatureIndex.prototype.setCollisionIndex=function(e){this.collisionIndex=e},FeatureIndex.prototype.query=function(e,r){this.vtLayers||(this.vtLayers=new vt.VectorTile(new Protobuf(this.rawTileData)).layers,this.sourceLayerCoder=new DictionaryCoder(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"]));for(var t={},a=e.params||{},i=EXTENT/e.tileSize/e.scale,o=featureFilter(a.filter),n=e.queryGeometry,s=e.additionalRadius*i,u=1/0,l=1/0,y=-1/0,d=-1/0,c=0;c<n.length;c++)for(var f=n[c],h=0;h<f.length;h++){var x=f[h];u=Math.min(u,x.x),l=Math.min(l,x.y),y=Math.max(y,x.x),d=Math.max(d,x.y)}var I=this.grid.query(u-s,l-s,y+s,d+s);I.sort(topDownFeatureComparator),this.filterMatching(t,I,this.featureIndexArray,n,o,a.layers,r,e.bearing,i);var v=this.collisionIndex?this.collisionIndex.queryRenderedSymbols(n,this.tileID,EXTENT/e.tileSize,e.collisionBoxArray,e.sourceID):[];return v.sort(),this.filterMatching(t,v,e.collisionBoxArray,n,o,a.layers,r,e.bearing,i),t},FeatureIndex.prototype.filterMatching=function(e,r,t,a,i,o,n,s,u){for(var l,y=this,d=0;d<r.length;d++){var c=r[d];if(c!==l){l=c;var f=t.get(c),h=y.bucketLayerIDs[f.bucketIndex];if(!o||arraysIntersect(o,h)){var x=y.sourceLayerCoder.decode(f.sourceLayerIndex),I=y.vtLayers[x],v=I.feature(f.featureIndex);if(i({zoom:y.tileID.overscaledZ},v))for(var g=null,p=0;p<h.length;p++){var m=h[p];if(!(o&&o.indexOf(m)<0)){var F=n[m];if(F&&("symbol"===F.type||(g||(g=loadGeometry(v)),F.queryIntersectsFeature(a,v,g,y.z,s,u)))){var q=new GeoJSONFeature(v,y.z,y.x,y.y);q.layer=F.serialize();var b=e[m];void 0===b&&(b=e[m]=[]),b.push({featureIndex:c,feature:q})}}}}}}},FeatureIndex.prototype.hasLayer=function(e){for(var r=this,t=0,a=r.bucketLayerIDs;t<a.length;t+=1)for(var i=a[t],o=0,n=i;o<n.length;o+=1){var s=n[o];if(e===s)return!0}return!1},register("FeatureIndex",FeatureIndex,{omit:["rawTileData","sourceLayerCoder","collisionIndex"]}),module.exports=FeatureIndex;
},{"../source/tile_id":117,"../style-spec/feature_filter":151,"../util/dictionary_coder":268,"../util/util":285,"../util/vectortile_to_geojson":286,"../util/web_worker_transfer":288,"./array_types":42,"./extent":56,"./load_geometry":59,"@mapbox/point-geometry":4,"@mapbox/vector-tile":8,"grid-index":23,"pbf":29}],58:[function(_dereq_,module,exports){
"use strict";module.exports={LineIndexArray:_dereq_("./array_types").LineIndexArray,TriangleIndexArray:_dereq_("./array_types").TriangleIndexArray};
},{"./array_types":42}],59:[function(_dereq_,module,exports){
"use strict";function createBounds(e){return{min:-1*Math.pow(2,e-1),max:Math.pow(2,e-1)-1}}var util=_dereq_("../util/util"),EXTENT=_dereq_("./extent"),bounds=createBounds(16);module.exports=function(e){for(var t=EXTENT/e.extent,r=e.loadGeometry(),n=0;n<r.length;n++)for(var u=r[n],o=0;o<u.length;o++){var a=u[o];a.x=Math.round(a.x*t),a.y=Math.round(a.y*t),(a.x<bounds.min||a.x>bounds.max||a.y<bounds.min||a.y>bounds.max)&&util.warnOnce("Geometry exceeds allowed extent, reduce your vector tile buffer size")}return r};
},{"../util/util":285,"./extent":56}],60:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/struct_array"),createLayout=ref.createLayout;module.exports=createLayout([{name:"a_pos",type:"Int16",components:2}]);
},{"../util/struct_array":281}],61:[function(_dereq_,module,exports){
"use strict";function packColor(r){return[packUint8ToFloat(255*r.r,255*r.g),packUint8ToFloat(255*r.b,255*r.a)]}function paintAttributeName(r,t){return{"text-opacity":"opacity","icon-opacity":"opacity","text-color":"fill_color","icon-color":"fill_color","text-halo-color":"halo_color","icon-halo-color":"halo_color","text-halo-blur":"halo_blur","icon-halo-blur":"halo_blur","text-halo-width":"halo_width","icon-halo-width":"halo_width","line-gap-width":"gapwidth"}[r]||r.replace(t+"-","").replace(/-/g,"_")}var packUint8ToFloat=_dereq_("../shaders/encode_attribute").packUint8ToFloat,Color=_dereq_("../style-spec/util/color"),ref=_dereq_("../util/web_worker_transfer"),register=ref.register,ref$1=_dereq_("../style/properties"),PossiblyEvaluatedPropertyValue=ref$1.PossiblyEvaluatedPropertyValue,ref$2=_dereq_("./array_types"),StructArrayLayout1f4=ref$2.StructArrayLayout1f4,StructArrayLayout2f8=ref$2.StructArrayLayout2f8,StructArrayLayout4f16=ref$2.StructArrayLayout4f16,ConstantBinder=function(r,t,o){this.value=r,this.name=t,this.type=o,this.statistics={max:-1/0}};ConstantBinder.prototype.defines=function(){return["#define HAS_UNIFORM_u_"+this.name]},ConstantBinder.prototype.populatePaintArray=function(){},ConstantBinder.prototype.upload=function(){},ConstantBinder.prototype.destroy=function(){},ConstantBinder.prototype.setUniforms=function(r,t,o,e){var i=e.constantOr(this.value),n=r.gl;"color"===this.type?n.uniform4f(t.uniforms["u_"+this.name],i.r,i.g,i.b,i.a):n.uniform1f(t.uniforms["u_"+this.name],i)};var SourceExpressionBinder=function(r,t,o){this.expression=r,this.name=t,this.type=o,this.statistics={max:-1/0};var e="color"===o?StructArrayLayout2f8:StructArrayLayout1f4;this.paintVertexAttributes=[{name:"a_"+t,type:"Float32",components:"color"===o?2:1,offset:0}],this.paintVertexArray=new e};SourceExpressionBinder.prototype.defines=function(){return[]},SourceExpressionBinder.prototype.populatePaintArray=function(r,t){var o=this.paintVertexArray,e=o.length;o.reserve(r);var i=this.expression.evaluate({zoom:0},t);if("color"===this.type)for(var n=packColor(i),a=e;a<r;a++)o.emplaceBack(n[0],n[1]);else{for(var s=e;s<r;s++)o.emplaceBack(i);this.statistics.max=Math.max(this.statistics.max,i)}},SourceExpressionBinder.prototype.upload=function(r){this.paintVertexArray&&(this.paintVertexBuffer=r.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes))},SourceExpressionBinder.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy()},SourceExpressionBinder.prototype.setUniforms=function(r,t){r.gl.uniform1f(t.uniforms["a_"+this.name+"_t"],0)};var CompositeExpressionBinder=function(r,t,o,e,i){this.expression=r,this.name=t,this.type=o,this.useIntegerZoom=e,this.zoom=i,this.statistics={max:-1/0};var n="color"===o?StructArrayLayout4f16:StructArrayLayout2f8;this.paintVertexAttributes=[{name:"a_"+t,type:"Float32",components:"color"===o?4:2,offset:0}],this.paintVertexArray=new n};CompositeExpressionBinder.prototype.defines=function(){return[]},CompositeExpressionBinder.prototype.populatePaintArray=function(r,t){var o=this.paintVertexArray,e=o.length;o.reserve(r);var i=this.expression.evaluate({zoom:this.zoom},t),n=this.expression.evaluate({zoom:this.zoom+1},t);if("color"===this.type)for(var a=packColor(i),s=packColor(n),u=e;u<r;u++)o.emplaceBack(a[0],a[1],s[0],s[1]);else{for(var p=e;p<r;p++)o.emplaceBack(i,n);this.statistics.max=Math.max(this.statistics.max,i,n)}},CompositeExpressionBinder.prototype.upload=function(r){this.paintVertexArray&&(this.paintVertexBuffer=r.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes))},CompositeExpressionBinder.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy()},CompositeExpressionBinder.prototype.interpolationFactor=function(r){return this.useIntegerZoom?this.expression.interpolationFactor(Math.floor(r),this.zoom,this.zoom+1):this.expression.interpolationFactor(r,this.zoom,this.zoom+1)},CompositeExpressionBinder.prototype.setUniforms=function(r,t,o){r.gl.uniform1f(t.uniforms["a_"+this.name+"_t"],this.interpolationFactor(o.zoom))};var ProgramConfiguration=function(){this.binders={},this.cacheKey="",this._buffers=[]};ProgramConfiguration.createDynamic=function(r,t,o){var e=new ProgramConfiguration,i=[];for(var n in r.paint._values)if(o(n)){var a=r.paint.get(n);if(a instanceof PossiblyEvaluatedPropertyValue&&a.property.specification["property-function"]){var s=paintAttributeName(n,r.type),u=a.property.specification.type,p=a.property.useIntegerZoom;"constant"===a.value.kind?(e.binders[n]=new ConstantBinder(a.value,s,u),i.push("/u_"+s)):"source"===a.value.kind?(e.binders[n]=new SourceExpressionBinder(a.value,s,u),i.push("/a_"+s)):(e.binders[n]=new CompositeExpressionBinder(a.value,s,u,p,t),i.push("/z_"+s))}}return e.cacheKey=i.sort().join(""),e},ProgramConfiguration.forBackgroundColor=function(r,t){var o=new ProgramConfiguration;return o.binders["background-color"]=new ConstantBinder(r,"color","color"),o.cacheKey+="/u_color",o.binders["background-opacity"]=new ConstantBinder(t,"opacity","number"),o.cacheKey+="/u_opacity",o},ProgramConfiguration.forBackgroundPattern=function(r){var t=new ProgramConfiguration;return t.binders["background-opacity"]=new ConstantBinder(r,"opacity","number"),t.cacheKey+="/u_opacity",t},ProgramConfiguration.forTileClippingMask=function(){return ProgramConfiguration.forBackgroundColor(Color.black,1)},ProgramConfiguration.prototype.populatePaintArrays=function(r,t){var o=this;for(var e in o.binders)o.binders[e].populatePaintArray(r,t)},ProgramConfiguration.prototype.defines=function(){var r=this,t=[];for(var o in r.binders)t.push.apply(t,r.binders[o].defines());return t},ProgramConfiguration.prototype.setUniforms=function(r,t,o,e){var i=this;for(var n in i.binders){i.binders[n].setUniforms(r,t,e,o.get(n))}},ProgramConfiguration.prototype.getPaintVertexBuffers=function(){return this._buffers},ProgramConfiguration.prototype.upload=function(r){var t=this;for(var o in t.binders)t.binders[o].upload(r);var e=[];for(var i in t.binders){var n=t.binders[i];(n instanceof SourceExpressionBinder||n instanceof CompositeExpressionBinder)&&n.paintVertexBuffer&&e.push(n.paintVertexBuffer)}this._buffers=e},ProgramConfiguration.prototype.destroy=function(){var r=this;for(var t in r.binders)r.binders[t].destroy()};var ProgramConfigurationSet=function(r,t,o,e){var i=this;void 0===e&&(e=function(){return!0}),this.programConfigurations={};for(var n=0,a=t;n<a.length;n+=1){var s=a[n];i.programConfigurations[s.id]=ProgramConfiguration.createDynamic(s,o,e),i.programConfigurations[s.id].layoutAttributes=r}};ProgramConfigurationSet.prototype.populatePaintArrays=function(r,t){var o=this;for(var e in o.programConfigurations)o.programConfigurations[e].populatePaintArrays(r,t)},ProgramConfigurationSet.prototype.get=function(r){return this.programConfigurations[r]},ProgramConfigurationSet.prototype.upload=function(r){var t=this;for(var o in t.programConfigurations)t.programConfigurations[o].upload(r)},ProgramConfigurationSet.prototype.destroy=function(){var r=this;for(var t in r.programConfigurations)r.programConfigurations[t].destroy()},register("ConstantBinder",ConstantBinder),register("SourceExpressionBinder",SourceExpressionBinder),register("CompositeExpressionBinder",CompositeExpressionBinder),register("ProgramConfiguration",ProgramConfiguration,{omit:["_buffers"]}),register("ProgramConfigurationSet",ProgramConfigurationSet),module.exports={ProgramConfiguration:ProgramConfiguration,ProgramConfigurationSet:ProgramConfigurationSet};
},{"../shaders/encode_attribute":99,"../style-spec/util/color":165,"../style/properties":199,"../util/web_worker_transfer":288,"./array_types":42}],62:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/struct_array"),createLayout=ref.createLayout;module.exports=createLayout([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);
},{"../util/struct_array":281}],63:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/util"),warnOnce=ref.warnOnce,ref$1=_dereq_("../util/web_worker_transfer"),register=ref$1.register,MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,SegmentVector=function(e){void 0===e&&(e=[]),this.segments=e};SegmentVector.prototype.prepareSegment=function(e,t,r){var n=this.segments[this.segments.length-1];return e>MAX_VERTEX_ARRAY_LENGTH&&warnOnce("Max vertices per segment is "+MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+e),(!n||n.vertexLength+e>module.exports.MAX_VERTEX_ARRAY_LENGTH)&&(n={vertexOffset:t.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},this.segments.push(n)),n},SegmentVector.prototype.get=function(){return this.segments},SegmentVector.prototype.destroy=function(){for(var e=this,t=0,r=e.segments;t<r.length;t+=1){var n=r[t];for(var s in n.vaos)n.vaos[s].destroy()}},register("SegmentVector",SegmentVector),module.exports={SegmentVector:SegmentVector,MAX_VERTEX_ARRAY_LENGTH:MAX_VERTEX_ARRAY_LENGTH};
},{"../util/util":285,"../util/web_worker_transfer":288}],64:[function(_dereq_,module,exports){
"use strict";var Coordinate=function(o,t,n){this.column=o,this.row=t,this.zoom=n};Coordinate.prototype.clone=function(){return new Coordinate(this.column,this.row,this.zoom)},Coordinate.prototype.zoomTo=function(o){return this.clone()._zoomTo(o)},Coordinate.prototype.sub=function(o){return this.clone()._sub(o)},Coordinate.prototype._zoomTo=function(o){var t=Math.pow(2,o-this.zoom);return this.column*=t,this.row*=t,this.zoom=o,this},Coordinate.prototype._sub=function(o){return o=o.zoomTo(this.zoom),this.column-=o.column,this.row-=o.row,this},module.exports=Coordinate;
},{}],65:[function(_dereq_,module,exports){
"use strict";var wrap=_dereq_("../util/util").wrap,LngLat=function(t,n){if(isNaN(t)||isNaN(n))throw new Error("Invalid LngLat object: ("+t+", "+n+")");if(this.lng=+t,this.lat=+n,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};LngLat.prototype.wrap=function(){return new LngLat(wrap(this.lng,-180,180),this.lat)},LngLat.prototype.toArray=function(){return[this.lng,this.lat]},LngLat.prototype.toString=function(){return"LngLat("+this.lng+", "+this.lat+")"},LngLat.prototype.toBounds=function(t){var n=360*t/40075017,r=n/Math.cos(Math.PI/180*this.lat);return new(_dereq_("./lng_lat_bounds"))(new LngLat(this.lng-r,this.lat-n),new LngLat(this.lng+r,this.lat+n))},LngLat.convert=function(t){if(t instanceof LngLat)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new LngLat(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new LngLat(Number(t.lng),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")},module.exports=LngLat;
},{"../util/util":285,"./lng_lat_bounds":66}],66:[function(_dereq_,module,exports){
"use strict";var LngLat=_dereq_("./lng_lat"),LngLatBounds=function(t,n){t&&(n?this.setSouthWest(t).setNorthEast(n):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]))};LngLatBounds.prototype.setNorthEast=function(t){return this._ne=t instanceof LngLat?new LngLat(t.lng,t.lat):LngLat.convert(t),this},LngLatBounds.prototype.setSouthWest=function(t){return this._sw=t instanceof LngLat?new LngLat(t.lng,t.lat):LngLat.convert(t),this},LngLatBounds.prototype.extend=function(t){var n,e,s=this._sw,o=this._ne;if(t instanceof LngLat)n=t,e=t;else{if(!(t instanceof LngLatBounds))return Array.isArray(t)?t.every(Array.isArray)?this.extend(LngLatBounds.convert(t)):this.extend(LngLat.convert(t)):this;if(n=t._sw,e=t._ne,!n||!e)return this}return s||o?(s.lng=Math.min(n.lng,s.lng),s.lat=Math.min(n.lat,s.lat),o.lng=Math.max(e.lng,o.lng),o.lat=Math.max(e.lat,o.lat)):(this._sw=new LngLat(n.lng,n.lat),this._ne=new LngLat(e.lng,e.lat)),this},LngLatBounds.prototype.getCenter=function(){return new LngLat((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},LngLatBounds.prototype.getSouthWest=function(){return this._sw},LngLatBounds.prototype.getNorthEast=function(){return this._ne},LngLatBounds.prototype.getNorthWest=function(){return new LngLat(this.getWest(),this.getNorth())},LngLatBounds.prototype.getSouthEast=function(){return new LngLat(this.getEast(),this.getSouth())},LngLatBounds.prototype.getWest=function(){return this._sw.lng},LngLatBounds.prototype.getSouth=function(){return this._sw.lat},LngLatBounds.prototype.getEast=function(){return this._ne.lng},LngLatBounds.prototype.getNorth=function(){return this._ne.lat},LngLatBounds.prototype.toArray=function(){return[this._sw.toArray(),this._ne.toArray()]},LngLatBounds.prototype.toString=function(){return"LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},LngLatBounds.convert=function(t){return!t||t instanceof LngLatBounds?t:new LngLatBounds(t)},module.exports=LngLatBounds;
},{"./lng_lat":65}],67:[function(_dereq_,module,exports){
"use strict";var LngLat=_dereq_("./lng_lat"),Point=_dereq_("@mapbox/point-geometry"),Coordinate=_dereq_("./coordinate"),util=_dereq_("../util/util"),interp=_dereq_("../style-spec/util/interpolate").number,tileCover=_dereq_("../util/tile_cover"),ref=_dereq_("../source/tile_id"),CanonicalTileID=ref.CanonicalTileID,UnwrappedTileID=ref.UnwrappedTileID,EXTENT=_dereq_("../data/extent"),glmatrix=_dereq_("@mapbox/gl-matrix"),vec4=glmatrix.vec4,mat4=glmatrix.mat4,mat2=glmatrix.mat2,Transform=function(t,i,o){this.tileSize=512,this._renderWorldCopies=void 0===o||o,this._minZoom=t||0,this._maxZoom=i||22,this.latRange=[-85.05113,85.05113],this.width=0,this.height=0,this._center=new LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._posMatrixCache={}},prototypeAccessors={minZoom:{},maxZoom:{},renderWorldCopies:{},worldSize:{},centerPoint:{},size:{},bearing:{},pitch:{},fov:{},zoom:{},center:{},unmodified:{},x:{},y:{},point:{}};Transform.prototype.clone=function(){var t=new Transform(this._minZoom,this._maxZoom,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._calcMatrices(),t},prototypeAccessors.minZoom.get=function(){return this._minZoom},prototypeAccessors.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t))},prototypeAccessors.maxZoom.get=function(){return this._maxZoom},prototypeAccessors.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t))},prototypeAccessors.renderWorldCopies.get=function(){return this._renderWorldCopies},prototypeAccessors.worldSize.get=function(){return this.tileSize*this.scale},prototypeAccessors.centerPoint.get=function(){return this.size._div(2)},prototypeAccessors.size.get=function(){return new Point(this.width,this.height)},prototypeAccessors.bearing.get=function(){return-this.angle/Math.PI*180},prototypeAccessors.bearing.set=function(t){var i=-util.wrap(t,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=mat2.create(),mat2.rotate(this.rotationMatrix,this.rotationMatrix,this.angle))},prototypeAccessors.pitch.get=function(){return this._pitch/Math.PI*180},prototypeAccessors.pitch.set=function(t){var i=util.clamp(t,0,60)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices())},prototypeAccessors.fov.get=function(){return this._fov/Math.PI*180},prototypeAccessors.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices())},prototypeAccessors.zoom.get=function(){return this._zoom},prototypeAccessors.zoom.set=function(t){var i=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==i&&(this._unmodified=!1,this._zoom=i,this.scale=this.zoomScale(i),this.tileZoom=Math.floor(i),this.zoomFraction=i-this.tileZoom,this._constrain(),this._calcMatrices())},prototypeAccessors.center.get=function(){return this._center},prototypeAccessors.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices())},Transform.prototype.coveringZoomLevel=function(t){return(t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize))},Transform.prototype.getVisibleUnwrappedCoordinates=function(t){for(var i=this.pointCoordinate(new Point(0,0),0),o=this.pointCoordinate(new Point(this.width,0),0),e=Math.floor(i.column),r=Math.floor(o.column),n=[new UnwrappedTileID(0,t)],s=e;s<=r;s++)0!==s&&n.push(new UnwrappedTileID(s,t));return n},Transform.prototype.coveringTiles=function(t){var i=this.coveringZoomLevel(t),o=i;if(void 0!==t.minzoom&&i<t.minzoom)return[];void 0!==t.maxzoom&&i>t.maxzoom&&(i=t.maxzoom);var e=this.pointCoordinate(this.centerPoint,i),r=new Point(e.column-.5,e.row-.5),n=[this.pointCoordinate(new Point(0,0),i),this.pointCoordinate(new Point(this.width,0),i),this.pointCoordinate(new Point(this.width,this.height),i),this.pointCoordinate(new Point(0,this.height),i)];return tileCover(i,n,t.reparseOverscaled?o:i,this._renderWorldCopies).sort(function(t,i){return r.dist(t.canonical)-r.dist(i.canonical)})},Transform.prototype.resize=function(t,i){this.width=t,this.height=i,this.pixelsToGLUnits=[2/t,-2/i],this._constrain(),this._calcMatrices()},prototypeAccessors.unmodified.get=function(){return this._unmodified},Transform.prototype.zoomScale=function(t){return Math.pow(2,t)},Transform.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},Transform.prototype.project=function(t){return new Point(this.lngX(t.lng),this.latY(t.lat))},Transform.prototype.unproject=function(t){return new LngLat(this.xLng(t.x),this.yLat(t.y))},prototypeAccessors.x.get=function(){return this.lngX(this.center.lng)},prototypeAccessors.y.get=function(){return this.latY(this.center.lat)},prototypeAccessors.point.get=function(){return new Point(this.x,this.y)},Transform.prototype.lngX=function(t){return(180+t)*this.worldSize/360},Transform.prototype.latY=function(t){return(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))*this.worldSize/360},Transform.prototype.xLng=function(t){return 360*t/this.worldSize-180},Transform.prototype.yLat=function(t){var i=180-360*t/this.worldSize;return 360/Math.PI*Math.atan(Math.exp(i*Math.PI/180))-90},Transform.prototype.setLocationAtPoint=function(t,i){var o=this.pointCoordinate(i)._sub(this.pointCoordinate(this.centerPoint));this.center=this.coordinateLocation(this.locationCoordinate(t)._sub(o)),this._renderWorldCopies&&(this.center=this.center.wrap())},Transform.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},Transform.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},Transform.prototype.locationCoordinate=function(t){return new Coordinate(this.lngX(t.lng)/this.tileSize,this.latY(t.lat)/this.tileSize,this.zoom).zoomTo(this.tileZoom)},Transform.prototype.coordinateLocation=function(t){var i=t.zoomTo(this.zoom);return new LngLat(this.xLng(i.column*this.tileSize),this.yLat(i.row*this.tileSize))},Transform.prototype.pointCoordinate=function(t,i){void 0===i&&(i=this.tileZoom);var o=[t.x,t.y,0,1],e=[t.x,t.y,1,1];vec4.transformMat4(o,o,this.pixelMatrixInverse),vec4.transformMat4(e,e,this.pixelMatrixInverse);var r=o[3],n=e[3],s=o[0]/r,a=e[0]/n,h=o[1]/r,c=e[1]/n,p=o[2]/r,m=e[2]/n,l=p===m?0:(0-p)/(m-p);return new Coordinate(interp(s,a,l)/this.tileSize,interp(h,c,l)/this.tileSize,this.zoom)._zoomTo(i)},Transform.prototype.coordinatePoint=function(t){var i=t.zoomTo(this.zoom),o=[i.column*this.tileSize,i.row*this.tileSize,0,1];return vec4.transformMat4(o,o,this.pixelMatrix),new Point(o[0]/o[3],o[1]/o[3])},Transform.prototype.calculatePosMatrix=function(t){var i=t.key;if(this._posMatrixCache[i])return this._posMatrixCache[i];var o=t.canonical,e=this.worldSize/this.zoomScale(o.z),r=o.x+Math.pow(2,o.z)*t.wrap,n=mat4.identity(new Float64Array(16));return mat4.translate(n,n,[r*e,o.y*e,0]),mat4.scale(n,n,[e/EXTENT,e/EXTENT,1]),mat4.multiply(n,this.projMatrix,n),this._posMatrixCache[i]=new Float32Array(n),this._posMatrixCache[i]},Transform.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var t,i,o,e,r=-90,n=90,s=-180,a=180,h=this.size,c=this._unmodified;if(this.latRange){var p=this.latRange;r=this.latY(p[1]),n=this.latY(p[0]),t=n-r<h.y?h.y/(n-r):0}if(this.lngRange){var m=this.lngRange;s=this.lngX(m[0]),a=this.lngX(m[1]),i=a-s<h.x?h.x/(a-s):0}var l=Math.max(i||0,t||0);if(l)return this.center=this.unproject(new Point(i?(a+s)/2:this.x,t?(n+r)/2:this.y)),this.zoom+=this.scaleZoom(l),this._unmodified=c,void(this._constraining=!1);if(this.latRange){var u=this.y,f=h.y/2;u-f<r&&(e=r+f),u+f>n&&(e=n-f)}if(this.lngRange){var d=this.x,g=h.x/2;d-g<s&&(o=s+g),d+g>a&&(o=a-g)}void 0===o&&void 0===e||(this.center=this.unproject(new Point(void 0!==o?o:this.x,void 0!==e?e:this.y))),this._unmodified=c,this._constraining=!1}},Transform.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var t=this._fov/2,i=Math.PI/2+this._pitch,o=Math.sin(t)*this.cameraToCenterDistance/Math.sin(Math.PI-i-t),e=Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance,r=1.01*e,n=new Float64Array(16);mat4.perspective(n,this._fov,this.width/this.height,1,r),mat4.scale(n,n,[1,-1,1]),mat4.translate(n,n,[0,0,-this.cameraToCenterDistance]),mat4.rotateX(n,n,this._pitch),mat4.rotateZ(n,n,this.angle),mat4.translate(n,n,[-this.x,-this.y,0]);var s=this.worldSize/(2*Math.PI*6378137*Math.abs(Math.cos(this.center.lat*(Math.PI/180))));if(mat4.scale(n,n,[1,1,s,1]),this.projMatrix=n,n=mat4.create(),mat4.scale(n,n,[this.width/2,-this.height/2,1]),mat4.translate(n,n,[1,-1,0]),this.pixelMatrix=mat4.multiply(new Float64Array(16),n,this.projMatrix),!(n=mat4.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=n,this._posMatrixCache={}}},Object.defineProperties(Transform.prototype,prototypeAccessors),module.exports=Transform;
},{"../data/extent":56,"../source/tile_id":117,"../style-spec/util/interpolate":169,"../util/tile_cover":283,"../util/util":285,"./coordinate":64,"./lng_lat":65,"@mapbox/gl-matrix":2,"@mapbox/point-geometry":4}],68:[function(_dereq_,module,exports){
"use strict";var Color=_dereq_("../style-spec/util/color"),ZERO=0,ONE=1,ONE_MINUS_SRC_ALPHA=771,ColorMode=function(o,e,l){this.blendFunction=o,this.blendColor=e,this.mask=l};ColorMode.Replace=[ONE,ZERO],ColorMode.disabled=new ColorMode(ColorMode.Replace,Color.transparent,[!1,!1,!1,!1]),ColorMode.unblended=new ColorMode(ColorMode.Replace,Color.transparent,[!0,!0,!0,!0]),ColorMode.alphaBlended=new ColorMode([ONE,ONE_MINUS_SRC_ALPHA],Color.transparent,[!0,!0,!0,!0]),module.exports=ColorMode;
},{"../style-spec/util/color":165}],69:[function(_dereq_,module,exports){
"use strict";var IndexBuffer=_dereq_("./index_buffer"),VertexBuffer=_dereq_("./vertex_buffer"),Framebuffer=_dereq_("./framebuffer"),DepthMode=_dereq_("./depth_mode"),StencilMode=_dereq_("./stencil_mode"),ColorMode=_dereq_("./color_mode"),util=_dereq_("../util/util"),ref=_dereq_("./value"),ClearColor=ref.ClearColor,ClearDepth=ref.ClearDepth,ClearStencil=ref.ClearStencil,ColorMask=ref.ColorMask,DepthMask=ref.DepthMask,StencilMask=ref.StencilMask,StencilFunc=ref.StencilFunc,StencilOp=ref.StencilOp,StencilTest=ref.StencilTest,DepthRange=ref.DepthRange,DepthTest=ref.DepthTest,DepthFunc=ref.DepthFunc,Blend=ref.Blend,BlendFunc=ref.BlendFunc,BlendColor=ref.BlendColor,Program=ref.Program,LineWidth=ref.LineWidth,ActiveTextureUnit=ref.ActiveTextureUnit,Viewport=ref.Viewport,BindFramebuffer=ref.BindFramebuffer,BindRenderbuffer=ref.BindRenderbuffer,BindTexture=ref.BindTexture,BindVertexBuffer=ref.BindVertexBuffer,BindElementBuffer=ref.BindElementBuffer,BindVertexArrayOES=ref.BindVertexArrayOES,PixelStoreUnpack=ref.PixelStoreUnpack,PixelStoreUnpackPremultiplyAlpha=ref.PixelStoreUnpackPremultiplyAlpha,Context=function(e){this.gl=e,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.lineWidthRange=e.getParameter(e.ALIASED_LINE_WIDTH_RANGE),this.clearColor=new ClearColor(this),this.clearDepth=new ClearDepth(this),this.clearStencil=new ClearStencil(this),this.colorMask=new ColorMask(this),this.depthMask=new DepthMask(this),this.stencilMask=new StencilMask(this),this.stencilFunc=new StencilFunc(this),this.stencilOp=new StencilOp(this),this.stencilTest=new StencilTest(this),this.depthRange=new DepthRange(this),this.depthTest=new DepthTest(this),this.depthFunc=new DepthFunc(this),this.blend=new Blend(this),this.blendFunc=new BlendFunc(this),this.blendColor=new BlendColor(this),this.program=new Program(this),this.lineWidth=new LineWidth(this),this.activeTexture=new ActiveTextureUnit(this),this.viewport=new Viewport(this),this.bindFramebuffer=new BindFramebuffer(this),this.bindRenderbuffer=new BindRenderbuffer(this),this.bindTexture=new BindTexture(this),this.bindVertexBuffer=new BindVertexBuffer(this),this.bindElementBuffer=new BindElementBuffer(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new BindVertexArrayOES(this),this.pixelStoreUnpack=new PixelStoreUnpack(this),this.pixelStoreUnpackPremultiplyAlpha=new PixelStoreUnpackPremultiplyAlpha(this),this.extTextureFilterAnisotropic=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=e.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&e.getExtension("OES_texture_half_float_linear")};Context.prototype.createIndexBuffer=function(e,t){return new IndexBuffer(this,e,t)},Context.prototype.createVertexBuffer=function(e,t,r){return new VertexBuffer(this,e,t,r)},Context.prototype.createRenderbuffer=function(e,t,r){var i=this.gl,n=i.createRenderbuffer();return this.bindRenderbuffer.set(n),i.renderbufferStorage(i.RENDERBUFFER,e,t,r),this.bindRenderbuffer.set(null),n},Context.prototype.createFramebuffer=function(e,t){return new Framebuffer(this,e,t)},Context.prototype.clear=function(e){var t=e.color,r=e.depth,i=this.gl,n=0;t&&(n|=i.COLOR_BUFFER_BIT,this.clearColor.set(t),this.colorMask.set([!0,!0,!0,!0])),void 0!==r&&(n|=i.DEPTH_BUFFER_BIT,this.clearDepth.set(r),this.depthMask.set(!0)),i.clear(n)},Context.prototype.setDepthMode=function(e){e.func!==this.gl.ALWAYS||e.mask?(this.depthTest.set(!0),this.depthFunc.set(e.func),this.depthMask.set(e.mask),this.depthRange.set(e.range)):this.depthTest.set(!1)},Context.prototype.setStencilMode=function(e){e.func!==this.gl.ALWAYS||e.mask?(this.stencilTest.set(!0),this.stencilMask.set(e.mask),this.stencilOp.set([e.fail,e.depthFail,e.pass]),this.stencilFunc.set({func:e.test.func,ref:e.ref,mask:e.test.mask})):this.stencilTest.set(!1)},Context.prototype.setColorMode=function(e){util.deepEqual(e.blendFunction,ColorMode.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask)},module.exports=Context;
},{"../util/util":285,"./color_mode":68,"./depth_mode":70,"./framebuffer":71,"./index_buffer":72,"./stencil_mode":73,"./value":74,"./vertex_buffer":75}],70:[function(_dereq_,module,exports){
"use strict";var ALWAYS=519,DepthMode=function(e,t,d){this.func=e,this.mask=t,this.range=d};DepthMode.ReadOnly=!1,DepthMode.ReadWrite=!0,DepthMode.disabled=new DepthMode(ALWAYS,DepthMode.ReadOnly,[0,1]),module.exports=DepthMode;
},{}],71:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("./value"),ColorAttachment=ref.ColorAttachment,DepthAttachment=ref.DepthAttachment,Framebuffer=function(t,e,r){this.context=t,this.width=e,this.height=r;var h=t.gl,a=this.framebuffer=h.createFramebuffer();this.colorAttachment=new ColorAttachment(t,a),this.depthAttachment=new DepthAttachment(t,a)};Framebuffer.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e);var r=this.depthAttachment.get();r&&t.deleteRenderbuffer(r),t.deleteFramebuffer(this.framebuffer)},module.exports=Framebuffer;
},{"./value":74}],72:[function(_dereq_,module,exports){
"use strict";var IndexBuffer=function(e,t,r){this.context=e;var f=e.gl;this.buffer=f.createBuffer(),this.dynamicDraw=Boolean(r),this.unbindVAO(),e.bindElementBuffer.set(this.buffer),f.bufferData(f.ELEMENT_ARRAY_BUFFER,t.arrayBuffer,this.dynamicDraw?f.DYNAMIC_DRAW:f.STATIC_DRAW),this.dynamicDraw||delete t.arrayBuffer};IndexBuffer.prototype.unbindVAO=function(){this.context.extVertexArrayObject&&this.context.bindVertexArrayOES.set(null)},IndexBuffer.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer)},IndexBuffer.prototype.updateData=function(e){var t=this.context.gl;this.unbindVAO(),this.bind(),t.bufferSubData(t.ELEMENT_ARRAY_BUFFER,0,e.arrayBuffer)},IndexBuffer.prototype.destroy=function(){var e=this.context.gl;this.buffer&&(e.deleteBuffer(this.buffer),delete this.buffer)},module.exports=IndexBuffer;
},{}],73:[function(_dereq_,module,exports){
"use strict";var ALWAYS=519,KEEP=7680,StencilMode=function(t,e,i,s,d,l){this.test=t,this.ref=e,this.mask=i,this.fail=s,this.depthFail=d,this.pass=l};StencilMode.disabled=new StencilMode({func:ALWAYS,mask:0},0,0,KEEP,KEEP,KEEP),module.exports=StencilMode;
},{}],74:[function(_dereq_,module,exports){
"use strict";var Color=_dereq_("../style-spec/util/color"),util=_dereq_("../util/util"),ClearColor=function(t){this.context=t,this.current=Color.transparent};ClearColor.prototype.get=function(){return this.current},ClearColor.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a||(this.context.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t)};var ClearDepth=function(t){this.context=t,this.current=1};ClearDepth.prototype.get=function(){return this.current},ClearDepth.prototype.set=function(t){this.current!==t&&(this.context.gl.clearDepth(t),this.current=t)};var ClearStencil=function(t){this.context=t,this.current=0};ClearStencil.prototype.get=function(){return this.current},ClearStencil.prototype.set=function(t){this.current!==t&&(this.context.gl.clearStencil(t),this.current=t)};var ColorMask=function(t){this.context=t,this.current=[!0,!0,!0,!0]};ColorMask.prototype.get=function(){return this.current},ColorMask.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]||(this.context.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t)};var DepthMask=function(t){this.context=t,this.current=!0};DepthMask.prototype.get=function(){return this.current},DepthMask.prototype.set=function(t){this.current!==t&&(this.context.gl.depthMask(t),this.current=t)};var StencilMask=function(t){this.context=t,this.current=255};StencilMask.prototype.get=function(){return this.current},StencilMask.prototype.set=function(t){this.current!==t&&(this.context.gl.stencilMask(t),this.current=t)};var StencilFunc=function(t){this.context=t,this.current={func:t.gl.ALWAYS,ref:0,mask:255}};StencilFunc.prototype.get=function(){return this.current},StencilFunc.prototype.set=function(t){var e=this.current;t.func===e.func&&t.ref===e.ref&&t.mask===e.mask||(this.context.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t)};var StencilOp=function(t){this.context=t;var e=this.context.gl;this.current=[e.KEEP,e.KEEP,e.KEEP]};StencilOp.prototype.get=function(){return this.current},StencilOp.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]||(this.context.gl.stencilOp(t[0],t[1],t[2]),this.current=t)};var StencilTest=function(t){this.context=t,this.current=!1};StencilTest.prototype.get=function(){return this.current},StencilTest.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t}};var DepthRange=function(t){this.context=t,this.current=[0,1]};DepthRange.prototype.get=function(){return this.current},DepthRange.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]||(this.context.gl.depthRange(t[0],t[1]),this.current=t)};var DepthTest=function(t){this.context=t,this.current=!1};DepthTest.prototype.get=function(){return this.current},DepthTest.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t}};var DepthFunc=function(t){this.context=t,this.current=t.gl.LESS};DepthFunc.prototype.get=function(){return this.current},DepthFunc.prototype.set=function(t){this.current!==t&&(this.context.gl.depthFunc(t),this.current=t)};var Blend=function(t){this.context=t,this.current=!1};Blend.prototype.get=function(){return this.current},Blend.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t}};var BlendFunc=function(t){this.context=t;var e=this.context.gl;this.current=[e.ONE,e.ZERO]};BlendFunc.prototype.get=function(){return this.current},BlendFunc.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]||(this.context.gl.blendFunc(t[0],t[1]),this.current=t)};var BlendColor=function(t){this.context=t,this.current=Color.transparent};BlendColor.prototype.get=function(){return this.current},BlendColor.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a||(this.context.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t)};var Program=function(t){this.context=t,this.current=null};Program.prototype.get=function(){return this.current},Program.prototype.set=function(t){this.current!==t&&(this.context.gl.useProgram(t),this.current=t)};var LineWidth=function(t){this.context=t,this.current=1};LineWidth.prototype.get=function(){return this.current},LineWidth.prototype.set=function(t){var e=this.context.lineWidthRange,r=util.clamp(t,e[0],e[1]);this.current!==r&&(this.context.gl.lineWidth(r),this.current=t)};var ActiveTextureUnit=function(t){this.context=t,this.current=t.gl.TEXTURE0};ActiveTextureUnit.prototype.get=function(){return this.current},ActiveTextureUnit.prototype.set=function(t){this.current!==t&&(this.context.gl.activeTexture(t),this.current=t)};var Viewport=function(t){this.context=t;var e=this.context.gl;this.current=[0,0,e.drawingBufferWidth,e.drawingBufferHeight]};Viewport.prototype.get=function(){return this.current},Viewport.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]||(this.context.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t)};var BindFramebuffer=function(t){this.context=t,this.current=null};BindFramebuffer.prototype.get=function(){return this.current},BindFramebuffer.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t}};var BindRenderbuffer=function(t){this.context=t,this.current=null};BindRenderbuffer.prototype.get=function(){return this.current},BindRenderbuffer.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t}};var BindTexture=function(t){this.context=t,this.current=null};BindTexture.prototype.get=function(){return this.current},BindTexture.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t}};var BindVertexBuffer=function(t){this.context=t,this.current=null};BindVertexBuffer.prototype.get=function(){return this.current},BindVertexBuffer.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t}};var BindElementBuffer=function(t){this.context=t,this.current=null};BindElementBuffer.prototype.get=function(){return this.current},BindElementBuffer.prototype.set=function(t){var e=this.context.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t};var BindVertexArrayOES=function(t){this.context=t,this.current=null};BindVertexArrayOES.prototype.get=function(){return this.current},BindVertexArrayOES.prototype.set=function(t){this.current!==t&&this.context.extVertexArrayObject&&(this.context.extVertexArrayObject.bindVertexArrayOES(t),this.current=t)};var PixelStoreUnpack=function(t){this.context=t,this.current=4};PixelStoreUnpack.prototype.get=function(){return this.current},PixelStoreUnpack.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t}};var PixelStoreUnpackPremultiplyAlpha=function(t){this.context=t,this.current=!1};PixelStoreUnpackPremultiplyAlpha.prototype.get=function(){return this.current},PixelStoreUnpackPremultiplyAlpha.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t}};var FramebufferValue=function(t,e){this.context=t,this.current=null,this.parent=e};FramebufferValue.prototype.get=function(){return this.current};var ColorAttachment=function(t){function e(e,r){t.call(this,e,r),this.dirty=!1}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(this.dirty||this.current!==t){var e=this.context.gl;this.context.bindFramebuffer.set(this.parent),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1}},e.prototype.setDirty=function(){this.dirty=!0},e}(FramebufferValue),DepthAttachment=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(this.current!==t){var e=this.context.gl;this.context.bindFramebuffer.set(this.parent),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t}},e}(FramebufferValue);module.exports={ClearColor:ClearColor,ClearDepth:ClearDepth,ClearStencil:ClearStencil,ColorMask:ColorMask,DepthMask:DepthMask,StencilMask:StencilMask,StencilFunc:StencilFunc,StencilOp:StencilOp,StencilTest:StencilTest,DepthRange:DepthRange,DepthTest:DepthTest,DepthFunc:DepthFunc,Blend:Blend,BlendFunc:BlendFunc,BlendColor:BlendColor,Program:Program,LineWidth:LineWidth,ActiveTextureUnit:ActiveTextureUnit,Viewport:Viewport,BindFramebuffer:BindFramebuffer,BindRenderbuffer:BindRenderbuffer,BindTexture:BindTexture,BindVertexBuffer:BindVertexBuffer,BindElementBuffer:BindElementBuffer,BindVertexArrayOES:BindVertexArrayOES,PixelStoreUnpack:PixelStoreUnpack,PixelStoreUnpackPremultiplyAlpha:PixelStoreUnpackPremultiplyAlpha,ColorAttachment:ColorAttachment,DepthAttachment:DepthAttachment};
},{"../style-spec/util/color":165,"../util/util":285}],75:[function(_dereq_,module,exports){
"use strict";var AttributeType={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},VertexBuffer=function(t,e,r,i){this.length=e.length,this.attributes=r,this.itemSize=e.bytesPerElement,this.dynamicDraw=i,this.context=t;var f=t.gl;this.buffer=f.createBuffer(),t.bindVertexBuffer.set(this.buffer),f.bufferData(f.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?f.DYNAMIC_DRAW:f.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer};VertexBuffer.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer)},VertexBuffer.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer)},VertexBuffer.prototype.enableAttributes=function(t,e){for(var r=this,i=0;i<this.attributes.length;i++){var f=r.attributes[i],n=e.attributes[f.name];void 0!==n&&t.enableVertexAttribArray(n)}},VertexBuffer.prototype.setVertexAttribPointers=function(t,e,r){for(var i=this,f=0;f<this.attributes.length;f++){var n=i.attributes[f],u=e.attributes[n.name];void 0!==u&&t.vertexAttribPointer(u,n.components,t[AttributeType[n.type]],!1,i.itemSize,n.offset+i.itemSize*(r||0))}},VertexBuffer.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer)},module.exports=VertexBuffer;
},{}],76:[function(_dereq_,module,exports){
"use strict";var supported=_dereq_("@mapbox/mapbox-gl-supported"),browser=_dereq_("./util/browser"),version=_dereq_("../package.json").version,Map=_dereq_("./ui/map"),NavigationControl=_dereq_("./ui/control/navigation_control"),GeolocateControl=_dereq_("./ui/control/geolocate_control"),AttributionControl=_dereq_("./ui/control/attribution_control"),ScaleControl=_dereq_("./ui/control/scale_control"),FullscreenControl=_dereq_("./ui/control/fullscreen_control"),Popup=_dereq_("./ui/popup"),Marker=_dereq_("./ui/marker"),Style=_dereq_("./style/style"),LngLat=_dereq_("./geo/lng_lat"),LngLatBounds=_dereq_("./geo/lng_lat_bounds"),Point=_dereq_("@mapbox/point-geometry"),Evented=_dereq_("./util/evented"),config=_dereq_("./util/config"),rtlTextPlugin=_dereq_("./source/rtl_text_plugin");module.exports={version:version,supported:supported,workerCount:Math.max(Math.floor(browser.hardwareConcurrency/2),1),setRTLTextPlugin:rtlTextPlugin.setRTLTextPlugin,Map:Map,NavigationControl:NavigationControl,GeolocateControl:GeolocateControl,AttributionControl:AttributionControl,ScaleControl:ScaleControl,FullscreenControl:FullscreenControl,Popup:Popup,Marker:Marker,Style:Style,LngLat:LngLat,LngLatBounds:LngLatBounds,Point:Point,Evented:Evented,config:config,get accessToken(){return config.ACCESS_TOKEN},set accessToken(o){config.ACCESS_TOKEN=o}};
},{"../package.json":41,"./geo/lng_lat":65,"./geo/lng_lat_bounds":66,"./source/rtl_text_plugin":112,"./style/style":201,"./ui/control/attribution_control":243,"./ui/control/fullscreen_control":244,"./ui/control/geolocate_control":245,"./ui/control/navigation_control":247,"./ui/control/scale_control":248,"./ui/map":258,"./ui/marker":259,"./ui/popup":260,"./util/browser":263,"./util/config":267,"./util/evented":271,"@mapbox/mapbox-gl-supported":3,"@mapbox/point-geometry":4}],77:[function(_dereq_,module,exports){
"use strict";function drawBackground(e,r,t){var a=t.paint.get("background-color"),o=t.paint.get("background-opacity");if(0!==o){var i=e.context,l=i.gl,n=e.transform,s=n.tileSize,u=t.paint.get("background-pattern"),d={zoom:n.zoom},p=u||1!==a.a||1!==o?"translucent":"opaque";if(e.renderPass===p){i.setStencilMode(StencilMode.disabled),i.setDepthMode(e.depthModeForSublayer(0,"opaque"===p?DepthMode.ReadWrite:DepthMode.ReadOnly)),i.setColorMode(e.colorModeForRenderPass());var f=new PossiblyEvaluated(fillLayerPaintProperties);f._values["background-color"]=new PossiblyEvaluatedPropertyValue(fillLayerPaintProperties.properties["fill-color"],{kind:"constant",value:a},d),f._values["background-opacity"]=new PossiblyEvaluatedPropertyValue(fillLayerPaintProperties.properties["fill-opacity"],{kind:"constant",value:o},d);var P;if(u){if(pattern.isPatternMissing(u,e))return;var g=ProgramConfiguration.forBackgroundPattern(o);P=e.useProgram("fillPattern",g),g.setUniforms(i,P,f,d),pattern.prepare(u,e,P),e.tileExtentPatternVAO.bind(i,P,e.tileExtentBuffer,[])}else{var c=ProgramConfiguration.forBackgroundColor(a,o);P=e.useProgram("fill",c),c.setUniforms(i,P,f,d),e.tileExtentVAO.bind(i,P,e.tileExtentBuffer,[])}for(var y=n.coveringTiles({tileSize:s}),v=0,m=y;v<m.length;v+=1){var b=m[v];u&&pattern.setTile({tileID:b,tileSize:s},e,P),l.uniformMatrix4fv(P.uniforms.u_matrix,!1,e.transform.calculatePosMatrix(b.toUnwrapped())),l.drawArrays(l.TRIANGLE_STRIP,0,e.tileExtentBuffer.length)}}}}var pattern=_dereq_("./pattern"),ref=_dereq_("../data/program_configuration"),ProgramConfiguration=ref.ProgramConfiguration,ref$1=_dereq_("../style/properties"),PossiblyEvaluated=ref$1.PossiblyEvaluated,PossiblyEvaluatedPropertyValue=ref$1.PossiblyEvaluatedPropertyValue,fillLayerPaintProperties=_dereq_("../style/style_layer/fill_style_layer_properties").paint,StencilMode=_dereq_("../gl/stencil_mode"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawBackground;
},{"../data/program_configuration":61,"../gl/depth_mode":70,"../gl/stencil_mode":73,"../style/properties":199,"../style/style_layer/fill_style_layer_properties":210,"./pattern":94}],78:[function(_dereq_,module,exports){
"use strict";function drawCircles(e,t,r,i){if("translucent"===e.renderPass){var o=r.paint.get("circle-opacity"),a=r.paint.get("circle-stroke-width"),n=r.paint.get("circle-stroke-opacity");if(0!==o.constantOr(1)||0!==a.constantOr(1)&&0!==n.constantOr(1)){var s=e.context,c=s.gl;s.setDepthMode(e.depthModeForSublayer(0,DepthMode.ReadOnly)),s.setStencilMode(StencilMode.disabled),s.setColorMode(e.colorModeForRenderPass());for(var l=!0,m=0;m<i.length;m++){var u=i[m],f=t.getTile(u),p=f.getBucket(r);if(p){var d=e.context.program.get(),_=p.programConfigurations.get(r.id),g=e.useProgram("circle",_);if((l||g.program!==d)&&(_.setUniforms(s,g,r.paint,{zoom:e.transform.zoom}),l=!1),c.uniform1f(g.uniforms.u_camera_to_center_distance,e.transform.cameraToCenterDistance),c.uniform1i(g.uniforms.u_scale_with_map,"map"===r.paint.get("circle-pitch-scale")?1:0),"map"===r.paint.get("circle-pitch-alignment")){c.uniform1i(g.uniforms.u_pitch_with_map,1);var h=pixelsToTileUnits(f,1,e.transform.zoom);c.uniform2f(g.uniforms.u_extrude_scale,h,h)}else c.uniform1i(g.uniforms.u_pitch_with_map,0),c.uniform2fv(g.uniforms.u_extrude_scale,e.transform.pixelsToGLUnits);c.uniformMatrix4fv(g.uniforms.u_matrix,!1,e.translatePosMatrix(u.posMatrix,f,r.paint.get("circle-translate"),r.paint.get("circle-translate-anchor"))),g.draw(s,c.TRIANGLES,r.id,p.layoutVertexBuffer,p.indexBuffer,p.segments,_)}}}}}var pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),StencilMode=_dereq_("../gl/stencil_mode"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawCircles;
},{"../gl/depth_mode":70,"../gl/stencil_mode":73,"../source/pixels_to_tile_units":107}],79:[function(_dereq_,module,exports){
"use strict";function drawCollisionDebugGeometry(e,o,i,r,t){var l=e.context,s=l.gl,n=t?e.useProgram("collisionCircle"):e.useProgram("collisionBox");l.setDepthMode(DepthMode.disabled),l.setStencilMode(StencilMode.disabled),l.setColorMode(e.colorModeForRenderPass());for(var u=0;u<r.length;u++){var a=r[u],d=o.getTile(a),f=d.getBucket(i);if(f){var m=t?f.collisionCircle:f.collisionBox;if(m){s.uniformMatrix4fv(n.uniforms.u_matrix,!1,a.posMatrix),t||l.lineWidth.set(1),s.uniform1f(n.uniforms.u_camera_to_center_distance,e.transform.cameraToCenterDistance);var c=pixelsToTileUnits(d,1,e.transform.zoom),x=Math.pow(2,e.transform.zoom-d.tileID.overscaledZ);s.uniform1f(n.uniforms.u_pixels_to_tile_units,c),s.uniform2f(n.uniforms.u_extrude_scale,e.transform.pixelsToGLUnits[0]/(c*x),e.transform.pixelsToGLUnits[1]/(c*x)),n.draw(l,t?s.TRIANGLES:s.LINES,i.id,m.layoutVertexBuffer,m.indexBuffer,m.segments,null,m.collisionVertexBuffer,null)}}}}function drawCollisionDebug(e,o,i,r){drawCollisionDebugGeometry(e,o,i,r,!1),drawCollisionDebugGeometry(e,o,i,r,!0)}var pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),DepthMode=_dereq_("../gl/depth_mode"),StencilMode=_dereq_("../gl/stencil_mode");module.exports=drawCollisionDebug;
},{"../gl/depth_mode":70,"../gl/stencil_mode":73,"../source/pixels_to_tile_units":107}],80:[function(_dereq_,module,exports){
"use strict";function drawDebug(e,r,t){for(var o=0;o<t.length;o++)drawDebugTile(e,r,t[o])}function drawDebugTile(e,r,t){var o=e.context,a=o.gl;o.lineWidth.set(1*browser.devicePixelRatio);var i=t.posMatrix,u=e.useProgram("debug");o.setDepthMode(DepthMode.disabled),o.setStencilMode(StencilMode.disabled),o.setColorMode(e.colorModeForRenderPass()),a.uniformMatrix4fv(u.uniforms.u_matrix,!1,i),a.uniform4f(u.uniforms.u_color,1,0,0,1),e.debugVAO.bind(o,u,e.debugBuffer,[]),a.drawArrays(a.LINE_STRIP,0,e.debugBuffer.length);for(var n=createTextVerticies(t.toString(),50,200,5),s=new PosArray,l=0;l<n.length;l+=2)s.emplaceBack(n[l],n[l+1]);var d=o.createVertexBuffer(s,posAttributes.members);(new VertexArrayObject).bind(o,u,d,[]),a.uniform4f(u.uniforms.u_color,1,1,1,1);for(var f=r.getTile(t).tileSize,m=EXTENT/(Math.pow(2,e.transform.zoom-t.overscaledZ)*f),c=[[-1,-1],[-1,1],[1,-1],[1,1]],b=0;b<c.length;b++){var g=c[b];a.uniformMatrix4fv(u.uniforms.u_matrix,!1,mat4.translate([],i,[m*g[0],m*g[1],0])),a.drawArrays(a.LINES,0,d.length)}a.uniform4f(u.uniforms.u_color,0,0,0,1),a.uniformMatrix4fv(u.uniforms.u_matrix,!1,i),a.drawArrays(a.LINES,0,d.length)}function createTextVerticies(e,r,t,o){o=o||1;var a,i,u,n,s,l,d,f,m=[];for(a=0,i=e.length;a<i;a++)if(s=simplexFont[e[a]]){for(f=null,u=0,n=s[1].length;u<n;u+=2)-1===s[1][u]&&-1===s[1][u+1]?f=null:(l=r+s[1][u]*o,d=t-s[1][u+1]*o,f&&m.push(f.x,f.y,l,d),f={x:l,y:d});r+=s[0]*o}return m}var browser=_dereq_("../util/browser"),mat4=_dereq_("@mapbox/gl-matrix").mat4,EXTENT=_dereq_("../data/extent"),VertexArrayObject=_dereq_("./vertex_array_object"),ref=_dereq_("../data/array_types"),PosArray=ref.PosArray,posAttributes=_dereq_("../data/pos_attributes"),DepthMode=_dereq_("../gl/depth_mode"),StencilMode=_dereq_("../gl/stencil_mode");module.exports=drawDebug;var simplexFont={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};
},{"../data/array_types":42,"../data/extent":56,"../data/pos_attributes":60,"../gl/depth_mode":70,"../gl/stencil_mode":73,"../util/browser":263,"./vertex_array_object":98,"@mapbox/gl-matrix":2}],81:[function(_dereq_,module,exports){
"use strict";function drawFill(t,e,r,o){var a=r.paint.get("fill-color"),i=r.paint.get("fill-opacity");if(0!==i.constantOr(1)){var n=t.context;n.setColorMode(t.colorModeForRenderPass());var l=r.paint.get("fill-pattern")||1!==a.constantOr(Color.transparent).a||1!==i.constantOr(0)?"translucent":"opaque";t.renderPass===l&&(n.setDepthMode(t.depthModeForSublayer(1,"opaque"===t.renderPass?DepthMode.ReadWrite:DepthMode.ReadOnly)),drawFillTiles(t,e,r,o,drawFillTile)),"translucent"===t.renderPass&&r.paint.get("fill-antialias")&&(n.lineWidth.set(2),n.setDepthMode(t.depthModeForSublayer(r.getPaintProperty("fill-outline-color")?2:0,DepthMode.ReadOnly)),drawFillTiles(t,e,r,o,drawStrokeTile))}}function drawFillTiles(t,e,r,o,a){if(!pattern.isPatternMissing(r.paint.get("fill-pattern"),t))for(var i=!0,n=0,l=o;n<l.length;n+=1){var s=l[n],p=e.getTile(s),d=p.getBucket(r);d&&(t.context.setStencilMode(t.stencilModeForClipping(s)),a(t,e,r,p,s,d,i),i=!1)}}function drawFillTile(t,e,r,o,a,i,n){var l=t.context.gl,s=i.programConfigurations.get(r.id);setFillProgram("fill",r.paint.get("fill-pattern"),t,s,r,o,a,n).draw(t.context,l.TRIANGLES,r.id,i.layoutVertexBuffer,i.indexBuffer,i.segments,s)}function drawStrokeTile(t,e,r,o,a,i,n){var l=t.context.gl,s=i.programConfigurations.get(r.id),p=r.getPaintProperty("fill-outline-color")?null:r.paint.get("fill-pattern"),d=setFillProgram("fillOutline",p,t,s,r,o,a,n);l.uniform2f(d.uniforms.u_world,l.drawingBufferWidth,l.drawingBufferHeight),d.draw(t.context,l.LINES,r.id,i.layoutVertexBuffer,i.indexBuffer2,i.segments2,s)}function setFillProgram(t,e,r,o,a,i,n,l){var s,p=r.context.program.get();return e?(s=r.useProgram(t+"Pattern",o),(l||s.program!==p)&&(o.setUniforms(r.context,s,a.paint,{zoom:r.transform.zoom}),pattern.prepare(e,r,s)),pattern.setTile(i,r,s)):(s=r.useProgram(t,o),(l||s.program!==p)&&o.setUniforms(r.context,s,a.paint,{zoom:r.transform.zoom})),r.context.gl.uniformMatrix4fv(s.uniforms.u_matrix,!1,r.translatePosMatrix(n.posMatrix,i,a.paint.get("fill-translate"),a.paint.get("fill-translate-anchor"))),s}var pattern=_dereq_("./pattern"),Color=_dereq_("../style-spec/util/color"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawFill;
},{"../gl/depth_mode":70,"../style-spec/util/color":165,"./pattern":94}],82:[function(_dereq_,module,exports){
"use strict";function draw(e,t,r,i){if(0!==r.paint.get("fill-extrusion-opacity"))if("offscreen"===e.renderPass){drawToExtrusionFramebuffer(e,r);for(var o=!0,a=0,n=i;a<n.length;a+=1){var s=n[a],u=t.getTile(s),f=u.getBucket(r);f&&(drawExtrusion(e,t,r,u,s,f,o),o=!1)}}else"translucent"===e.renderPass&&drawExtrusionTexture(e,r)}function drawToExtrusionFramebuffer(e,t){var r=e.context,i=r.gl,o=t.viewportFrame;if(e.depthRboNeedsClear&&e.setupOffscreenDepthRenderbuffer(),!o){var a=new Texture(r,{width:e.width,height:e.height,data:null},i.RGBA);a.bind(i.LINEAR,i.CLAMP_TO_EDGE),o=t.viewportFrame=r.createFramebuffer(e.width,e.height),o.colorAttachment.set(a.texture)}r.bindFramebuffer.set(o.framebuffer),o.depthAttachment.set(e.depthRbo),e.depthRboNeedsClear&&(r.clear({depth:1}),e.depthRboNeedsClear=!1),r.clear({color:Color.transparent}),r.setStencilMode(StencilMode.disabled),r.setDepthMode(new DepthMode(i.LEQUAL,DepthMode.ReadWrite,[0,1])),r.setColorMode(e.colorModeForRenderPass())}function drawExtrusionTexture(e,t){var r=t.viewportFrame;if(r){var i=e.context,o=i.gl,a=e.useProgram("extrusionTexture");i.setStencilMode(StencilMode.disabled),i.setDepthMode(DepthMode.disabled),i.setColorMode(e.colorModeForRenderPass()),i.activeTexture.set(o.TEXTURE0),o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),o.uniform1f(a.uniforms.u_opacity,t.paint.get("fill-extrusion-opacity")),o.uniform1i(a.uniforms.u_image,0);var n=mat4.create();mat4.ortho(n,0,e.width,e.height,0,0,1),o.uniformMatrix4fv(a.uniforms.u_matrix,!1,n),o.uniform2f(a.uniforms.u_world,o.drawingBufferWidth,o.drawingBufferHeight),e.viewportVAO.bind(i,a,e.viewportBuffer,[]),o.drawArrays(o.TRIANGLE_STRIP,0,4)}}function drawExtrusion(e,t,r,i,o,a,n){var s=e.context,u=s.gl,f=r.paint.get("fill-extrusion-pattern"),l=e.context.program.get(),d=a.programConfigurations.get(r.id),m=e.useProgram(f?"fillExtrusionPattern":"fillExtrusion",d);if((n||m.program!==l)&&d.setUniforms(s,m,r.paint,{zoom:e.transform.zoom}),f){if(pattern.isPatternMissing(f,e))return;pattern.prepare(f,e,m),pattern.setTile(i,e,m),u.uniform1f(m.uniforms.u_height_factor,-Math.pow(2,o.overscaledZ)/i.tileSize/8)}e.context.gl.uniformMatrix4fv(m.uniforms.u_matrix,!1,e.translatePosMatrix(o.posMatrix,i,r.paint.get("fill-extrusion-translate"),r.paint.get("fill-extrusion-translate-anchor"))),setLight(m,e),m.draw(s,u.TRIANGLES,r.id,a.layoutVertexBuffer,a.indexBuffer,a.segments,d)}function setLight(e,t){var r=t.context.gl,i=t.style.light,o=i.properties.get("position"),a=[o.x,o.y,o.z],n=mat3.create();"viewport"===i.properties.get("anchor")&&mat3.fromRotation(n,-t.transform.angle),vec3.transformMat3(a,a,n);var s=i.properties.get("color");r.uniform3fv(e.uniforms.u_lightpos,a),r.uniform1f(e.uniforms.u_lightintensity,i.properties.get("intensity")),r.uniform3f(e.uniforms.u_lightcolor,s.r,s.g,s.b)}var glMatrix=_dereq_("@mapbox/gl-matrix"),pattern=_dereq_("./pattern"),Texture=_dereq_("./texture"),Color=_dereq_("../style-spec/util/color"),DepthMode=_dereq_("../gl/depth_mode"),mat3=glMatrix.mat3,mat4=glMatrix.mat4,vec3=glMatrix.vec3,StencilMode=_dereq_("../gl/stencil_mode");module.exports=draw;
},{"../gl/depth_mode":70,"../gl/stencil_mode":73,"../style-spec/util/color":165,"./pattern":94,"./texture":96,"@mapbox/gl-matrix":2}],83:[function(_dereq_,module,exports){
"use strict";function drawHeatmap(e,t,r,o){if(0!==r.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var a=e.context,i=a.gl;a.setDepthMode(e.depthModeForSublayer(0,DepthMode.ReadOnly)),a.setStencilMode(StencilMode.disabled),bindFramebuffer(a,e,r),a.clear({color:Color.transparent}),a.setColorMode(new ColorMode([i.ONE,i.ONE],Color.transparent,[!0,!0,!0,!0]));for(var n=!0,u=0;u<o.length;u++){var T=o[u];if(!t.hasRenderableParent(T)){var f=t.getTile(T),m=f.getBucket(r);if(m){var l=e.context.program.get(),s=m.programConfigurations.get(r.id),d=e.useProgram("heatmap",s),E=e.transform,x=E.zoom;(n||d.program!==l)&&(s.setUniforms(e.context,d,r.paint,{zoom:x}),n=!1),i.uniform1f(d.uniforms.u_extrude_scale,pixelsToTileUnits(f,1,x)),i.uniform1f(d.uniforms.u_intensity,r.paint.get("heatmap-intensity")),i.uniformMatrix4fv(d.uniforms.u_matrix,!1,T.posMatrix),d.draw(a,i.TRIANGLES,r.id,m.layoutVertexBuffer,m.indexBuffer,m.segments,s)}}}a.viewport.set([0,0,e.width,e.height])}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),renderTextureToMap(e,r))}function bindFramebuffer(e,t,r){var o=e.gl;e.activeTexture.set(o.TEXTURE1),e.viewport.set([0,0,t.width/4,t.height/4]);var a=r.heatmapFbo;if(a)o.bindTexture(o.TEXTURE_2D,a.colorAttachment.get()),e.bindFramebuffer.set(a.framebuffer);else{var i=o.createTexture();o.bindTexture(o.TEXTURE_2D,i),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_S,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_T,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MIN_FILTER,o.LINEAR),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MAG_FILTER,o.LINEAR),a=r.heatmapFbo=e.createFramebuffer(t.width/4,t.height/4),bindTextureToFramebuffer(e,t,i,a)}}function bindTextureToFramebuffer(e,t,r,o){var a=e.gl;a.texImage2D(a.TEXTURE_2D,0,a.RGBA,t.width/4,t.height/4,0,a.RGBA,e.extTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:a.UNSIGNED_BYTE,null),o.colorAttachment.set(r),e.extTextureHalfFloat&&a.checkFramebufferStatus(a.FRAMEBUFFER)!==a.FRAMEBUFFER_COMPLETE&&(e.extTextureHalfFloat=null,o.colorAttachment.setDirty(),bindTextureToFramebuffer(e,t,r,o))}function renderTextureToMap(e,t){var r=e.context,o=r.gl,a=t.heatmapFbo;if(a){r.activeTexture.set(o.TEXTURE0),o.bindTexture(o.TEXTURE_2D,a.colorAttachment.get()),r.activeTexture.set(o.TEXTURE1);var i=t.colorRampTexture;i||(i=t.colorRampTexture=new Texture(r,t.colorRamp,o.RGBA)),i.bind(o.LINEAR,o.CLAMP_TO_EDGE),r.setDepthMode(DepthMode.disabled);var n=e.useProgram("heatmapTexture"),u=t.paint.get("heatmap-opacity");o.uniform1f(n.uniforms.u_opacity,u),o.uniform1i(n.uniforms.u_image,0),o.uniform1i(n.uniforms.u_color_ramp,1);var T=mat4.create();mat4.ortho(T,0,e.width,e.height,0,0,1),o.uniformMatrix4fv(n.uniforms.u_matrix,!1,T),o.uniform2f(n.uniforms.u_world,o.drawingBufferWidth,o.drawingBufferHeight),e.viewportVAO.bind(e.context,n,e.viewportBuffer,[]),o.drawArrays(o.TRIANGLE_STRIP,0,4)}}var mat4=_dereq_("@mapbox/gl-matrix").mat4,Texture=_dereq_("./texture"),pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),Color=_dereq_("../style-spec/util/color"),DepthMode=_dereq_("../gl/depth_mode"),StencilMode=_dereq_("../gl/stencil_mode"),ColorMode=_dereq_("../gl/color_mode");module.exports=drawHeatmap;
},{"../gl/color_mode":68,"../gl/depth_mode":70,"../gl/stencil_mode":73,"../source/pixels_to_tile_units":107,"../style-spec/util/color":165,"./texture":96,"@mapbox/gl-matrix":2}],84:[function(_dereq_,module,exports){
"use strict";function drawHillshade(e,r,t,a){if("offscreen"===e.renderPass||"translucent"===e.renderPass){var i=e.context;i.setDepthMode(e.depthModeForSublayer(0,DepthMode.ReadOnly)),i.setStencilMode(StencilMode.disabled),i.setColorMode(e.colorModeForRenderPass());for(var n=0,o=a;n<o.length;n+=1){var s=o[n],d=r.getTile(s);d.needsHillshadePrepare&&"offscreen"===e.renderPass?prepareHillshade(e,d):"translucent"===e.renderPass&&renderHillshade(e,d,t)}i.viewport.set([0,0,e.width,e.height])}}function setLight(e,r,t){var a=t.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===t.paint.get("hillshade-illumination-anchor")&&(a-=r.transform.angle),r.context.gl.uniform2f(e.uniforms.u_light,t.paint.get("hillshade-exaggeration"),a)}function getTileLatRange(e,r){var t=r.toCoordinate(),a=new Coordinate(t.column,t.row+1,t.zoom);return[e.transform.coordinateLocation(t).lat,e.transform.coordinateLocation(a).lat]}function renderHillshade(e,r,t){var a=e.context,i=a.gl,n=r.fbo;if(n){var o=e.useProgram("hillshade"),s=e.transform.calculatePosMatrix(r.tileID.toUnwrapped());setLight(o,e,t);var d=getTileLatRange(e,r.tileID);a.activeTexture.set(i.TEXTURE0),i.bindTexture(i.TEXTURE_2D,n.colorAttachment.get()),i.uniformMatrix4fv(o.uniforms.u_matrix,!1,s),i.uniform2fv(o.uniforms.u_latrange,d),i.uniform1i(o.uniforms.u_image,0);var l=t.paint.get("hillshade-shadow-color");i.uniform4f(o.uniforms.u_shadow,l.r,l.g,l.b,l.a);var u=t.paint.get("hillshade-highlight-color");i.uniform4f(o.uniforms.u_highlight,u.r,u.g,u.b,u.a);var f=t.paint.get("hillshade-accent-color");if(i.uniform4f(o.uniforms.u_accent,f.r,f.g,f.b,f.a),r.maskedBoundsBuffer&&r.maskedIndexBuffer&&r.segments)o.draw(a,i.TRIANGLES,t.id,r.maskedBoundsBuffer,r.maskedIndexBuffer,r.segments);else{var m=e.rasterBoundsBuffer;e.rasterBoundsVAO.bind(a,o,m,[]),i.drawArrays(i.TRIANGLE_STRIP,0,m.length)}}}function prepareHillshade(e,r){var t=e.context,a=t.gl;if(r.dem&&r.dem.level){var i=r.dem.level.dim,n=r.dem.getPixels();if(t.activeTexture.set(a.TEXTURE1),t.pixelStoreUnpackPremultiplyAlpha.set(!1),r.demTexture=r.demTexture||e.getTileTexture(r.tileSize),r.demTexture){var o=r.demTexture;o.update(n,!1),o.bind(a.NEAREST,a.CLAMP_TO_EDGE)}else r.demTexture=new Texture(t,n,a.RGBA,!1),r.demTexture.bind(a.NEAREST,a.CLAMP_TO_EDGE);t.activeTexture.set(a.TEXTURE0);var s=r.fbo;if(!s){var d=new Texture(t,{width:i,height:i,data:null},a.RGBA);d.bind(a.LINEAR,a.CLAMP_TO_EDGE),s=r.fbo=t.createFramebuffer(i,i),s.colorAttachment.set(d.texture)}t.bindFramebuffer.set(s.framebuffer),t.viewport.set([0,0,i,i]);var l=mat4.create();mat4.ortho(l,0,EXTENT,-EXTENT,0,0,1),mat4.translate(l,l,[0,-EXTENT,0]);var u=e.useProgram("hillshadePrepare");a.uniformMatrix4fv(u.uniforms.u_matrix,!1,l),a.uniform1f(u.uniforms.u_zoom,r.tileID.overscaledZ),a.uniform2fv(u.uniforms.u_dimension,[2*i,2*i]),a.uniform1i(u.uniforms.u_image,1);var f=e.rasterBoundsBuffer;e.rasterBoundsVAO.bind(t,u,f,[]),a.drawArrays(a.TRIANGLE_STRIP,0,f.length),r.needsHillshadePrepare=!1}}var Coordinate=_dereq_("../geo/coordinate"),Texture=_dereq_("./texture"),EXTENT=_dereq_("../data/extent"),mat4=_dereq_("@mapbox/gl-matrix").mat4,StencilMode=_dereq_("../gl/stencil_mode"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawHillshade;
},{"../data/extent":56,"../geo/coordinate":64,"../gl/depth_mode":70,"../gl/stencil_mode":73,"./texture":96,"@mapbox/gl-matrix":2}],85:[function(_dereq_,module,exports){
"use strict";function drawLineTile(e,i,t,r,n,a,o,s,u){var f,l,m,p,_=i.context,g=_.gl,d=n.paint.get("line-dasharray"),c=n.paint.get("line-pattern");if(s||u){var x=1/pixelsToTileUnits(t,1,i.transform.tileZoom);if(d){f=i.lineAtlas.getDash(d.from,"round"===n.layout.get("line-cap")),l=i.lineAtlas.getDash(d.to,"round"===n.layout.get("line-cap"));var h=f.width*d.fromScale,v=l.width*d.toScale;g.uniform2f(e.uniforms.u_patternscale_a,x/h,-f.height/2),g.uniform2f(e.uniforms.u_patternscale_b,x/v,-l.height/2),g.uniform1f(e.uniforms.u_sdfgamma,i.lineAtlas.width/(256*Math.min(h,v)*browser.devicePixelRatio)/2)}else if(c){if(m=i.imageManager.getPattern(c.from),p=i.imageManager.getPattern(c.to),!m||!p)return;g.uniform2f(e.uniforms.u_pattern_size_a,m.displaySize[0]*c.fromScale/x,p.displaySize[1]),g.uniform2f(e.uniforms.u_pattern_size_b,p.displaySize[0]*c.toScale/x,p.displaySize[1]);var T=i.imageManager.getPixelSize(),y=T.width,M=T.height;g.uniform2fv(e.uniforms.u_texsize,[y,M])}g.uniform2f(e.uniforms.u_gl_units_to_pixels,1/i.transform.pixelsToGLUnits[0],1/i.transform.pixelsToGLUnits[1])}s&&(d?(g.uniform1i(e.uniforms.u_image,0),_.activeTexture.set(g.TEXTURE0),i.lineAtlas.bind(_),g.uniform1f(e.uniforms.u_tex_y_a,f.y),g.uniform1f(e.uniforms.u_tex_y_b,l.y),g.uniform1f(e.uniforms.u_mix,d.t)):c&&(g.uniform1i(e.uniforms.u_image,0),_.activeTexture.set(g.TEXTURE0),i.imageManager.bind(_),g.uniform2fv(e.uniforms.u_pattern_tl_a,m.tl),g.uniform2fv(e.uniforms.u_pattern_br_a,m.br),g.uniform2fv(e.uniforms.u_pattern_tl_b,p.tl),g.uniform2fv(e.uniforms.u_pattern_br_b,p.br),g.uniform1f(e.uniforms.u_fade,c.t))),_.setStencilMode(i.stencilModeForClipping(a));var b=i.translatePosMatrix(a.posMatrix,t,n.paint.get("line-translate"),n.paint.get("line-translate-anchor"));g.uniformMatrix4fv(e.uniforms.u_matrix,!1,b),g.uniform1f(e.uniforms.u_ratio,1/pixelsToTileUnits(t,1,i.transform.zoom)),e.draw(_,g.TRIANGLES,n.id,r.layoutVertexBuffer,r.indexBuffer,r.segments,o)}var browser=_dereq_("../util/browser"),pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),DepthMode=_dereq_("../gl/depth_mode");module.exports=function(e,i,t,r){if("translucent"===e.renderPass){if(0!==t.paint.get("line-opacity").constantOr(1)){var n=e.context;n.setDepthMode(e.depthModeForSublayer(0,DepthMode.ReadOnly)),n.setColorMode(e.colorModeForRenderPass());for(var a,o=t.paint.get("line-dasharray")?"lineSDF":t.paint.get("line-pattern")?"linePattern":"line",s=!0,u=0,f=r;u<f.length;u+=1){var l=f[u],m=i.getTile(l),p=m.getBucket(t);if(p){var _=p.programConfigurations.get(t.id),g=e.context.program.get(),d=e.useProgram(o,_),c=s||d.program!==g,x=a!==m.tileID.overscaledZ;c&&_.setUniforms(e.context,d,t.paint,{zoom:e.transform.zoom}),drawLineTile(d,e,m,p,t,l,_,c,x),a=m.tileID.overscaledZ,s=!1}}}}};
},{"../gl/depth_mode":70,"../source/pixels_to_tile_units":107,"../util/browser":263}],86:[function(_dereq_,module,exports){
"use strict";function drawRaster(e,r,t,a){if("translucent"===e.renderPass&&0!==t.paint.get("raster-opacity")){var i=e.context,o=i.gl,n=r.getSource(),s=e.useProgram("raster");i.setStencilMode(StencilMode.disabled),i.setColorMode(e.colorModeForRenderPass()),o.uniform1f(s.uniforms.u_brightness_low,t.paint.get("raster-brightness-min")),o.uniform1f(s.uniforms.u_brightness_high,t.paint.get("raster-brightness-max")),o.uniform1f(s.uniforms.u_saturation_factor,saturationFactor(t.paint.get("raster-saturation"))),o.uniform1f(s.uniforms.u_contrast_factor,contrastFactor(t.paint.get("raster-contrast"))),o.uniform3fv(s.uniforms.u_spin_weights,spinWeights(t.paint.get("raster-hue-rotate"))),o.uniform1f(s.uniforms.u_buffer_scale,1),o.uniform1i(s.uniforms.u_image0,0),o.uniform1i(s.uniforms.u_image1,1);for(var u=a.length&&a[0].overscaledZ,d=0,f=a;d<f.length;d+=1){var c=f[d];i.setDepthMode(e.depthModeForSublayer(c.overscaledZ-u,1===t.paint.get("raster-opacity")?DepthMode.ReadWrite:DepthMode.ReadOnly,o.LESS));var m=r.getTile(c),l=e.transform.calculatePosMatrix(c.toUnwrapped());m.registerFadeDuration(t.paint.get("raster-fade-duration")),o.uniformMatrix4fv(s.uniforms.u_matrix,!1,l);var g=r.findLoadedParent(c,0,{}),p=getFadeValues(m,g,r,t,e.transform),_=void 0,h=void 0;if(i.activeTexture.set(o.TEXTURE0),m.texture.bind(o.LINEAR,o.CLAMP_TO_EDGE,o.LINEAR_MIPMAP_NEAREST),i.activeTexture.set(o.TEXTURE1),g?(g.texture.bind(o.LINEAR,o.CLAMP_TO_EDGE,o.LINEAR_MIPMAP_NEAREST),_=Math.pow(2,g.tileID.overscaledZ-m.tileID.overscaledZ),h=[m.tileID.canonical.x*_%1,m.tileID.canonical.y*_%1]):m.texture.bind(o.LINEAR,o.CLAMP_TO_EDGE,o.LINEAR_MIPMAP_NEAREST),o.uniform2fv(s.uniforms.u_tl_parent,h||[0,0]),o.uniform1f(s.uniforms.u_scale_parent,_||1),o.uniform1f(s.uniforms.u_fade_t,p.mix),o.uniform1f(s.uniforms.u_opacity,p.opacity*t.paint.get("raster-opacity")),n instanceof ImageSource){var E=n.boundsBuffer;n.boundsVAO.bind(i,s,E,[]),o.drawArrays(o.TRIANGLE_STRIP,0,E.length)}else if(m.maskedBoundsBuffer&&m.maskedIndexBuffer&&m.segments)s.draw(i,o.TRIANGLES,t.id,m.maskedBoundsBuffer,m.maskedIndexBuffer,m.segments);else{var M=e.rasterBoundsBuffer,v=e.rasterBoundsVAO;v.bind(i,s,M,[]),o.drawArrays(o.TRIANGLE_STRIP,0,M.length)}}}}function spinWeights(e){e*=Math.PI/180;var r=Math.sin(e),t=Math.cos(e);return[(2*t+1)/3,(-Math.sqrt(3)*r-t+1)/3,(Math.sqrt(3)*r-t+1)/3]}function contrastFactor(e){return e>0?1/(1-e):1+e}function saturationFactor(e){return e>0?1-1/(1.001-e):-e}function getFadeValues(e,r,t,a,i){var o=a.paint.get("raster-fade-duration");if(o>0){var n=browser.now(),s=(n-e.timeAdded)/o,u=r?(n-r.timeAdded)/o:-1,d=t.getSource(),f=i.coveringZoomLevel({tileSize:d.tileSize,roundZoom:d.roundZoom}),c=!r||Math.abs(r.tileID.overscaledZ-f)>Math.abs(e.tileID.overscaledZ-f),m=c&&e.refreshedUponExpiration?1:util.clamp(c?s:1-u,0,1);return e.refreshedUponExpiration&&s>=1&&(e.refreshedUponExpiration=!1),r?{opacity:1,mix:1-m}:{opacity:m,mix:0}}return{opacity:1,mix:0}}var util=_dereq_("../util/util"),ImageSource=_dereq_("../source/image_source"),browser=_dereq_("../util/browser"),StencilMode=_dereq_("../gl/stencil_mode"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawRaster;
},{"../gl/depth_mode":70,"../gl/stencil_mode":73,"../source/image_source":105,"../util/browser":263,"../util/util":285}],87:[function(_dereq_,module,exports){
"use strict";function drawSymbols(t,e,o,i){if("translucent"===t.renderPass){var r=t.context;r.setStencilMode(StencilMode.disabled),r.setColorMode(t.colorModeForRenderPass()),0!==o.paint.get("icon-opacity").constantOr(1)&&drawLayerSymbols(t,e,o,i,!1,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),o.layout.get("icon-rotation-alignment"),o.layout.get("icon-pitch-alignment"),o.layout.get("icon-keep-upright")),0!==o.paint.get("text-opacity").constantOr(1)&&drawLayerSymbols(t,e,o,i,!0,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),o.layout.get("text-keep-upright")),e.map.showCollisionBoxes&&drawCollisionDebug(t,e,o,i)}}function drawLayerSymbols(t,e,o,i,r,n,a,s,u,l){var m=t.context,f=m.gl,c=t.transform,p="map"===s,y="map"===u,_=p&&"line"===o.layout.get("symbol-placement"),d=p&&!y&&!_,g=y;m.setDepthMode(g?t.depthModeForSublayer(0,DepthMode.ReadOnly):DepthMode.disabled);for(var x,b=0,h=i;b<h.length;b+=1){var S=h[b],M=e.getTile(S),z=M.getBucket(o);if(z){var T=r?z.text:z.icon;if(T&&T.segments.get().length){var w=T.programConfigurations.get(o.id),v=r||z.sdfIcons,D=r?z.textSizeData:z.iconSizeData;if(x||(x=t.useProgram(v?"symbolSDF":"symbolIcon",w),w.setUniforms(t.context,x,o.paint,{zoom:t.transform.zoom}),setSymbolDrawState(x,t,o,r,d,y,D)),m.activeTexture.set(f.TEXTURE0),f.uniform1i(x.uniforms.u_texture,0),r)M.glyphAtlasTexture.bind(f.LINEAR,f.CLAMP_TO_EDGE),f.uniform2fv(x.uniforms.u_texsize,M.glyphAtlasTexture.size);else{var L=1!==o.layout.get("icon-size").constantOr(0)||z.iconsNeedLinear,P=y||0!==c.pitch;M.iconAtlasTexture.bind(v||t.options.rotating||t.options.zooming||L||P?f.LINEAR:f.NEAREST,f.CLAMP_TO_EDGE),f.uniform2fv(x.uniforms.u_texsize,M.iconAtlasTexture.size)}f.uniformMatrix4fv(x.uniforms.u_matrix,!1,t.translatePosMatrix(S.posMatrix,M,n,a));var E=pixelsToTileUnits(M,1,t.transform.zoom),A=symbolProjection.getLabelPlaneMatrix(S.posMatrix,y,p,t.transform,E),C=symbolProjection.getGlCoordMatrix(S.posMatrix,y,p,t.transform,E);f.uniformMatrix4fv(x.uniforms.u_gl_coord_matrix,!1,t.translatePosMatrix(C,M,n,a,!0)),_?(f.uniformMatrix4fv(x.uniforms.u_label_plane_matrix,!1,identityMat4),symbolProjection.updateLineLabels(z,S.posMatrix,t,r,A,C,y,l)):f.uniformMatrix4fv(x.uniforms.u_label_plane_matrix,!1,A),f.uniform1f(x.uniforms.u_fade_change,t.options.fadeDuration?(browser.now()-z.fadeStartTime)/t.options.fadeDuration:1),drawTileSymbols(x,w,t,o,M,T,r,v,y)}}}}function setSymbolDrawState(t,e,o,i,r,n,a){var s=e.context.gl,u=e.transform;s.uniform1i(t.uniforms.u_pitch_with_map,n?1:0),s.uniform1f(t.uniforms.u_is_text,i?1:0),s.uniform1f(t.uniforms.u_pitch,u.pitch/360*2*Math.PI);var l="constant"===a.functionType||"source"===a.functionType,m="constant"===a.functionType||"camera"===a.functionType;s.uniform1i(t.uniforms.u_is_size_zoom_constant,l?1:0),s.uniform1i(t.uniforms.u_is_size_feature_constant,m?1:0),s.uniform1f(t.uniforms.u_camera_to_center_distance,u.cameraToCenterDistance);var f=symbolSize.evaluateSizeForZoom(a,u.zoom,symbolLayoutProperties.properties[i?"text-size":"icon-size"]);void 0!==f.uSizeT&&s.uniform1f(t.uniforms.u_size_t,f.uSizeT),void 0!==f.uSize&&s.uniform1f(t.uniforms.u_size,f.uSize),s.uniform1f(t.uniforms.u_aspect_ratio,u.width/u.height),s.uniform1i(t.uniforms.u_rotate_symbol,r?1:0)}function drawTileSymbols(t,e,o,i,r,n,a,s,u){var l=o.context,m=l.gl,f=o.transform;if(s){var c=0!==i.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),p=u?Math.cos(f._pitch)*f.cameraToCenterDistance:1;m.uniform1f(t.uniforms.u_gamma_scale,p),c&&(m.uniform1f(t.uniforms.u_is_halo,1),drawSymbolElements(n,i,l,t)),m.uniform1f(t.uniforms.u_is_halo,0)}drawSymbolElements(n,i,l,t)}function drawSymbolElements(t,e,o,i){i.draw(o,o.gl.TRIANGLES,e.id,t.layoutVertexBuffer,t.indexBuffer,t.segments,t.programConfigurations.get(e.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer)}var drawCollisionDebug=_dereq_("./draw_collision_debug"),pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),symbolProjection=_dereq_("../symbol/projection"),symbolSize=_dereq_("../symbol/symbol_size"),mat4=_dereq_("@mapbox/gl-matrix").mat4,identityMat4=mat4.identity(new Float32Array(16)),symbolLayoutProperties=_dereq_("../style/style_layer/symbol_style_layer_properties").layout,browser=_dereq_("../util/browser"),StencilMode=_dereq_("../gl/stencil_mode"),DepthMode=_dereq_("../gl/depth_mode");module.exports=drawSymbols;
},{"../gl/depth_mode":70,"../gl/stencil_mode":73,"../source/pixels_to_tile_units":107,"../style/style_layer/symbol_style_layer_properties":220,"../symbol/projection":234,"../symbol/symbol_size":239,"../util/browser":263,"./draw_collision_debug":79,"@mapbox/gl-matrix":2}],88:[function(_dereq_,module,exports){
"use strict";function makeGlyphAtlas(a){var e=new AlphaImage({width:0,height:0}),i={},t=new ShelfPack(0,0,{autoResize:!0});for(var h in a){var r=a[h],p=i[h]={};for(var m in r){var d=r[+m];if(d&&0!==d.bitmap.width&&0!==d.bitmap.height){var g=t.packOne(d.bitmap.width+2*padding,d.bitmap.height+2*padding);e.resize({width:t.w,height:t.h}),AlphaImage.copy(d.bitmap,e,{x:0,y:0},{x:g.x+padding,y:g.y+padding},d.bitmap),p[m]={rect:g,metrics:d.metrics}}}}return t.shrink(),e.resize({width:t.w,height:t.h}),{image:e,positions:i}}var ShelfPack=_dereq_("@mapbox/shelf-pack"),ref=_dereq_("../util/image"),AlphaImage=ref.AlphaImage,padding=1;module.exports={makeGlyphAtlas:makeGlyphAtlas};
},{"../util/image":274,"@mapbox/shelf-pack":5}],89:[function(_dereq_,module,exports){
"use strict";var loadGlyphRange=_dereq_("../style/load_glyph_range"),TinySDF=_dereq_("@mapbox/tiny-sdf"),isChar=_dereq_("../util/is_char_in_unicode_block"),ref=_dereq_("../util/util"),asyncAll=ref.asyncAll,ref$1=_dereq_("../util/image"),AlphaImage=ref$1.AlphaImage,GlyphManager=function(e,r){this.requestTransform=e,this.localIdeographFontFamily=r,this.entries={}};GlyphManager.prototype.setURL=function(e){this.url=e},GlyphManager.prototype.getGlyphs=function(e,r){var i=this,t=[];for(var a in e)for(var l=0,n=e[a];l<n.length;l+=1){var s=n[l];t.push({stack:a,id:s})}asyncAll(t,function(e,r){var t=e.stack,a=e.id,l=i.entries[t];l||(l=i.entries[t]={glyphs:{},requests:{}});var n=l.glyphs[a];if(void 0!==n)return void r(null,{stack:t,id:a,glyph:n});if(n=i._tinySDF(l,t,a))return void r(null,{stack:t,id:a,glyph:n});var s=Math.floor(a/256);if(256*s>65535)return void r(new Error("glyphs > 65535 not supported"));var o=l.requests[s];o||(o=l.requests[s]=[],loadGlyphRange(t,s,i.url,i.requestTransform,function(e,r){if(r)for(var i in r)l.glyphs[+i]=r[+i];for(var t=0,a=o;t<a.length;t+=1){(0,a[t])(e,r)}delete l.requests[s]})),o.push(function(e,i){e?r(e):i&&r(null,{stack:t,id:a,glyph:i[a]||null})})},function(e,i){if(e)r(e);else if(i){for(var t={},a=0,l=i;a<l.length;a+=1){var n=l[a],s=n.stack,o=n.id,h=n.glyph;(t[s]||(t[s]={}))[o]=h&&{id:h.id,bitmap:h.bitmap.clone(),metrics:h.metrics}}r(null,t)}})},GlyphManager.prototype._tinySDF=function(e,r,i){var t=this.localIdeographFontFamily;if(t&&(isChar["CJK Unified Ideographs"](i)||isChar["Hangul Syllables"](i))){var a=e.tinySDF;if(!a){var l="400";/bold/i.test(r)?l="900":/medium/i.test(r)?l="500":/light/i.test(r)&&(l="200"),a=e.tinySDF=new TinySDF(24,3,8,.25,t,l)}return{id:i,bitmap:new AlphaImage({width:30,height:30},a.draw(String.fromCharCode(i))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},module.exports=GlyphManager;
},{"../style/load_glyph_range":195,"../util/image":274,"../util/is_char_in_unicode_block":276,"../util/util":285,"@mapbox/tiny-sdf":6}],90:[function(_dereq_,module,exports){
"use strict";function imagePosition(a,i){var e=i.pixelRatio,t={x:a.x+padding,y:a.y+padding,w:a.w-2*padding,h:a.h-2*padding};return{pixelRatio:e,textureRect:t,tl:[t.x,t.y],br:[t.x+t.w,t.y+t.h],displaySize:[t.w/e,t.h/e]}}function makeImageAtlas(a){var i=new RGBAImage({width:0,height:0}),e={},t=new ShelfPack(0,0,{autoResize:!0});for(var d in a){var g=a[d],n=t.packOne(g.data.width+2*padding,g.data.height+2*padding);i.resize({width:t.w,height:t.h}),RGBAImage.copy(g.data,i,{x:0,y:0},{x:n.x+padding,y:n.y+padding},g.data),e[d]=imagePosition(n,g)}return t.shrink(),i.resize({width:t.w,height:t.h}),{image:i,positions:e}}var ShelfPack=_dereq_("@mapbox/shelf-pack"),ref=_dereq_("../util/image"),RGBAImage=ref.RGBAImage,padding=1;module.exports={imagePosition:imagePosition,makeImageAtlas:makeImageAtlas};
},{"../util/image":274,"@mapbox/shelf-pack":5}],91:[function(_dereq_,module,exports){
"use strict";var ShelfPack=_dereq_("@mapbox/shelf-pack"),ref=_dereq_("../util/image"),RGBAImage=ref.RGBAImage,ref$1=_dereq_("./image_atlas"),imagePosition=ref$1.imagePosition,Texture=_dereq_("./texture"),padding=1,ImageManager=function(){this.images={},this.loaded=!1,this.requestors=[],this.shelfPack=new ShelfPack(64,64,{autoResize:!0}),this.patterns={},this.atlasImage=new RGBAImage({width:64,height:64}),this.dirty=!0};ImageManager.prototype.isLoaded=function(){return this.loaded},ImageManager.prototype.setLoaded=function(e){var t=this;if(this.loaded!==e&&(this.loaded=e,e)){for(var a=0,i=t.requestors;a<i.length;a+=1){var r=i[a],s=r.ids,h=r.callback;t._notify(s,h)}this.requestors=[]}},ImageManager.prototype.getImage=function(e){return this.images[e]},ImageManager.prototype.addImage=function(e,t){this.images[e]=t},ImageManager.prototype.removeImage=function(e){delete this.images[e];var t=this.patterns[e];t&&(this.shelfPack.unref(t.bin),delete this.patterns[e])},ImageManager.prototype.getImages=function(e,t){var a=this,i=!0;if(!this.isLoaded())for(var r=0,s=e;r<s.length;r+=1){var h=s[r];a.images[h]||(i=!1)}this.isLoaded()||i?this._notify(e,t):this.requestors.push({ids:e,callback:t})},ImageManager.prototype._notify=function(e,t){for(var a=this,i={},r=0,s=e;r<s.length;r+=1){var h=s[r],g=a.images[h];g&&(i[h]={data:g.data.clone(),pixelRatio:g.pixelRatio,sdf:g.sdf})}t(null,i)},ImageManager.prototype.getPixelSize=function(){return{width:this.shelfPack.w,height:this.shelfPack.h}},ImageManager.prototype.getPattern=function(e){var t=this.patterns[e];if(t)return t.position;var a=this.getImage(e);if(!a)return null;var i=a.data.width+2*padding,r=a.data.height+2*padding,s=this.shelfPack.packOne(i,r);if(!s)return null;this.atlasImage.resize(this.getPixelSize());var h=a.data,g=this.atlasImage,n=s.x+padding,o=s.y+padding,d=h.width,l=h.height;RGBAImage.copy(h,g,{x:0,y:0},{x:n,y:o},{width:d,height:l}),RGBAImage.copy(h,g,{x:0,y:l-1},{x:n,y:o-1},{width:d,height:1}),RGBAImage.copy(h,g,{x:0,y:0},{x:n,y:o+l},{width:d,height:1}),RGBAImage.copy(h,g,{x:d-1,y:0},{x:n-1,y:o},{width:1,height:l}),RGBAImage.copy(h,g,{x:0,y:0},{x:n+d,y:o},{width:1,height:l}),this.dirty=!0;var p=imagePosition(s,a);return this.patterns[e]={bin:s,position:p},p},ImageManager.prototype.bind=function(e){var t=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new Texture(e,this.atlasImage,t.RGBA),this.atlasTexture.bind(t.LINEAR,t.CLAMP_TO_EDGE)},module.exports=ImageManager;
},{"../util/image":274,"./image_atlas":90,"./texture":96,"@mapbox/shelf-pack":5}],92:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),LineAtlas=function(t,i){this.width=t,this.height=i,this.nextRow=0,this.bytes=4,this.data=new Uint8Array(this.width*this.height*this.bytes),this.positions={}};LineAtlas.prototype.getDash=function(t,i){var e=t.join(",")+String(i);return this.positions[e]||(this.positions[e]=this.addDash(t,i)),this.positions[e]},LineAtlas.prototype.addDash=function(t,i){var e=this,h=i?7:0,s=2*h+1;if(this.nextRow+s>this.height)return util.warnOnce("LineAtlas out of space"),null;for(var a=0,r=0;r<t.length;r++)a+=t[r];for(var n=this.width/a,E=n/2,T=t.length%2==1,o=-h;o<=h;o++)for(var R=e.nextRow+h+o,d=e.width*R,u=T?-t[t.length-1]:0,l=t[0],x=1,_=0;_<this.width;_++){for(;l<_/n;)u=l,l+=t[x],T&&x===t.length-1&&(l+=t[0]),x++;var g=Math.abs(_-u*n),A=Math.abs(_-l*n),w=Math.min(g,A),D=x%2==1,U=void 0;if(i){var f=h?o/h*(E+1):0;if(D){var p=E-Math.abs(f);U=Math.sqrt(w*w+p*p)}else U=E-Math.sqrt(w*w+f*f)}else U=(D?1:-1)*w;e.data[3+4*(d+_)]=Math.max(0,Math.min(255,U+128))}var v={y:(this.nextRow+h+.5)/this.height,height:2*h/this.height,width:a};return this.nextRow+=s,this.dirty=!0,v},LineAtlas.prototype.bind=function(t){var i=t.gl;this.texture?(i.bindTexture(i.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,i.texSubImage2D(i.TEXTURE_2D,0,0,0,this.width,this.height,i.RGBA,i.UNSIGNED_BYTE,this.data))):(this.texture=i.createTexture(),i.bindTexture(i.TEXTURE_2D,this.texture),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_WRAP_S,i.REPEAT),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_WRAP_T,i.REPEAT),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_MIN_FILTER,i.LINEAR),i.texParameteri(i.TEXTURE_2D,i.TEXTURE_MAG_FILTER,i.LINEAR),i.texImage2D(i.TEXTURE_2D,0,i.RGBA,this.width,this.height,0,i.RGBA,i.UNSIGNED_BYTE,this.data))},module.exports=LineAtlas;
},{"../util/util":285}],93:[function(_dereq_,module,exports){
"use strict";var browser=_dereq_("../util/browser"),mat4=_dereq_("@mapbox/gl-matrix").mat4,SourceCache=_dereq_("../source/source_cache"),EXTENT=_dereq_("../data/extent"),pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),util=_dereq_("../util/util"),VertexArrayObject=_dereq_("./vertex_array_object"),ref=_dereq_("../data/array_types"),RasterBoundsArray=ref.RasterBoundsArray,PosArray=ref.PosArray,rasterBoundsAttributes=_dereq_("../data/raster_bounds_attributes"),posAttributes=_dereq_("../data/pos_attributes"),ref$1=_dereq_("../data/program_configuration"),ProgramConfiguration=ref$1.ProgramConfiguration,CrossTileSymbolIndex=_dereq_("../symbol/cross_tile_symbol_index"),shaders=_dereq_("../shaders"),Program=_dereq_("./program"),Context=_dereq_("../gl/context"),DepthMode=_dereq_("../gl/depth_mode"),StencilMode=_dereq_("../gl/stencil_mode"),ColorMode=_dereq_("../gl/color_mode"),Texture=_dereq_("./texture"),updateTileMasks=_dereq_("./tile_mask"),Color=_dereq_("../style-spec/util/color"),draw={symbol:_dereq_("./draw_symbol"),circle:_dereq_("./draw_circle"),heatmap:_dereq_("./draw_heatmap"),line:_dereq_("./draw_line"),fill:_dereq_("./draw_fill"),"fill-extrusion":_dereq_("./draw_fill_extrusion"),hillshade:_dereq_("./draw_hillshade"),raster:_dereq_("./draw_raster"),background:_dereq_("./draw_background"),debug:_dereq_("./draw_debug")},Painter=function(e,r){this.context=new Context(e),this.transform=r,this._tileTextures={},this.setup(),this.numSublayers=SourceCache.maxUnderzooming+SourceCache.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.depthRboNeedsClear=!0,this.emptyProgramConfiguration=new ProgramConfiguration,this.crossTileSymbolIndex=new CrossTileSymbolIndex};Painter.prototype.resize=function(e,r){var t=this,i=this.context.gl;if(this.width=e*browser.devicePixelRatio,this.height=r*browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var s=0,a=t.style._order;s<a.length;s+=1){var o=a[s];t.style._layers[o].resize()}this.depthRbo&&(i.deleteRenderbuffer(this.depthRbo),this.depthRbo=null)},Painter.prototype.setup=function(){var e=this.context,r=new PosArray;r.emplaceBack(0,0),r.emplaceBack(EXTENT,0),r.emplaceBack(0,EXTENT),r.emplaceBack(EXTENT,EXTENT),this.tileExtentBuffer=e.createVertexBuffer(r,posAttributes.members),this.tileExtentVAO=new VertexArrayObject,this.tileExtentPatternVAO=new VertexArrayObject;var t=new PosArray;t.emplaceBack(0,0),t.emplaceBack(EXTENT,0),t.emplaceBack(EXTENT,EXTENT),t.emplaceBack(0,EXTENT),t.emplaceBack(0,0),this.debugBuffer=e.createVertexBuffer(t,posAttributes.members),this.debugVAO=new VertexArrayObject;var i=new RasterBoundsArray;i.emplaceBack(0,0,0,0),i.emplaceBack(EXTENT,0,EXTENT,0),i.emplaceBack(0,EXTENT,0,EXTENT),i.emplaceBack(EXTENT,EXTENT,EXTENT,EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(i,rasterBoundsAttributes.members),this.rasterBoundsVAO=new VertexArrayObject;var s=new PosArray;s.emplaceBack(0,0),s.emplaceBack(1,0),s.emplaceBack(0,1),s.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(s,posAttributes.members),this.viewportVAO=new VertexArrayObject},Painter.prototype.clearStencil=function(){var e=this.context,r=e.gl;e.setColorMode(ColorMode.disabled),e.setDepthMode(DepthMode.disabled),e.setStencilMode(new StencilMode({func:r.ALWAYS,mask:0},0,255,r.ZERO,r.ZERO,r.ZERO));var t=mat4.create();mat4.ortho(t,0,this.width,this.height,0,0,1),mat4.scale(t,t,[r.drawingBufferWidth,r.drawingBufferHeight,0]);var i=this.useProgram("fill",ProgramConfiguration.forTileClippingMask());r.uniformMatrix4fv(i.uniforms.u_matrix,!1,t),this.viewportVAO.bind(e,i,this.viewportBuffer,[]),r.drawArrays(r.TRIANGLE_STRIP,0,4)},Painter.prototype._renderTileClippingMasks=function(e){var r=this,t=this.context,i=t.gl;t.setColorMode(ColorMode.disabled),t.setDepthMode(DepthMode.disabled);var s=1;this._tileClippingMaskIDs={};for(var a=ProgramConfiguration.forTileClippingMask(),o=0,n=e;o<n.length;o+=1){var l=n[o],c=r._tileClippingMaskIDs[l.key]=s++;t.setStencilMode(new StencilMode({func:i.ALWAYS,mask:0},c,255,i.KEEP,i.KEEP,i.REPLACE));var u=r.useProgram("fill",a);i.uniformMatrix4fv(u.uniforms.u_matrix,!1,l.posMatrix),r.tileExtentVAO.bind(r.context,u,r.tileExtentBuffer,[]),i.drawArrays(i.TRIANGLE_STRIP,0,r.tileExtentBuffer.length)}},Painter.prototype.stencilModeForClipping=function(e){var r=this.context.gl;return new StencilMode({func:r.EQUAL,mask:255},this._tileClippingMaskIDs[e.key],0,r.KEEP,r.KEEP,r.REPLACE)},Painter.prototype.colorModeForRenderPass=function(){var e=this.context.gl;if(this._showOverdrawInspector){return new ColorMode([e.CONSTANT_COLOR,e.ONE],new Color(1/8,1/8,1/8,0),[!0,!0,!0,!0])}return"opaque"===this.renderPass?ColorMode.unblended:ColorMode.alphaBlended},Painter.prototype.depthModeForSublayer=function(e,r,t){var i=1-((1+this.currentLayer)*this.numSublayers+e)*this.depthEpsilon,s=i-1+this.depthRange;return new DepthMode(t||this.context.gl.LEQUAL,r,[s,i])},Painter.prototype.render=function(e,r){var t=this;this.style=e,this.options=r,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager;for(var i in e.sourceCaches){var s=t.style.sourceCaches[i];s.used&&s.prepare(t.context)}var a=this.style._order,o=util.filterObject(this.style.sourceCaches,function(e){return"raster"===e.getSource().type||"raster-dem"===e.getSource().type});for(var n in o)!function(e){var r=o[e],i=r.getVisibleCoordinates(),s=i.map(function(e){return r.getTile(e)});updateTileMasks(s,t.context)}(n);this.renderPass="offscreen";var l,c=[];this.depthRboNeedsClear=!0;for(var u=0;u<a.length;u++){var h=t.style._layers[a[u]];h.hasOffscreenPass()&&!h.isHidden(t.transform.zoom)&&(h.source!==(l&&l.id)&&(l=t.style.sourceCaches[h.source],c=[],l&&(c=l.getVisibleCoordinates(),c.reverse())),c.length&&t.renderLayer(t,l,h,c))}this.context.bindFramebuffer.set(null),this.context.clear({color:r.showOverdrawInspector?Color.black:Color.transparent,depth:1}),this._showOverdrawInspector=r.showOverdrawInspector,this.depthRange=(e._order.length+2)*this.numSublayers*this.depthEpsilon,this.renderPass="opaque";var d,p=[];for(this.currentLayer=a.length-1,this.currentLayer;this.currentLayer>=0;this.currentLayer--){var f=t.style._layers[a[t.currentLayer]];f.source!==(d&&d.id)&&(d=t.style.sourceCaches[f.source],p=[],d&&(t.clearStencil(),p=d.getVisibleCoordinates(),d.getSource().isTileClipped&&t._renderTileClippingMasks(p))),t.renderLayer(t,d,f,p)}this.renderPass="translucent";var m,g=[];for(this.currentLayer=0,this.currentLayer;this.currentLayer<a.length;this.currentLayer++){var y=t.style._layers[a[t.currentLayer]];y.source!==(m&&m.id)&&(m=t.style.sourceCaches[y.source],g=[],m&&(t.clearStencil(),g=m.getVisibleCoordinates(),m.getSource().isTileClipped&&t._renderTileClippingMasks(g)),g.reverse()),t.renderLayer(t,m,y,g)}if(this.options.showTileBoundaries){var b=this.style.sourceCaches[Object.keys(this.style.sourceCaches)[0]];b&&draw.debug(this,b,b.getVisibleCoordinates())}},Painter.prototype.setupOffscreenDepthRenderbuffer=function(){var e=this.context;this.depthRbo||(this.depthRbo=e.createRenderbuffer(e.gl.DEPTH_COMPONENT16,this.width,this.height))},Painter.prototype.renderLayer=function(e,r,t,i){t.isHidden(this.transform.zoom)||("background"===t.type||i.length)&&(this.id=t.id,draw[t.type](e,r,t,i))},Painter.prototype.translatePosMatrix=function(e,r,t,i,s){if(!t[0]&&!t[1])return e;var a=s?"map"===i?this.transform.angle:0:"viewport"===i?-this.transform.angle:0;if(a){var o=Math.sin(a),n=Math.cos(a);t=[t[0]*n-t[1]*o,t[0]*o+t[1]*n]}var l=[s?t[0]:pixelsToTileUnits(r,t[0],this.transform.zoom),s?t[1]:pixelsToTileUnits(r,t[1],this.transform.zoom),0],c=new Float32Array(16);return mat4.translate(c,e,l),c},Painter.prototype.saveTileTexture=function(e){var r=this._tileTextures[e.size[0]];r?r.push(e):this._tileTextures[e.size[0]]=[e]},Painter.prototype.getTileTexture=function(e){var r=this._tileTextures[e];return r&&r.length>0?r.pop():null},Painter.prototype._createProgramCached=function(e,r){this.cache=this.cache||{};var t=""+e+(r.cacheKey||"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[t]||(this.cache[t]=new Program(this.context,shaders[e],r,this._showOverdrawInspector)),this.cache[t]},Painter.prototype.useProgram=function(e,r){var t=this._createProgramCached(e,r||this.emptyProgramConfiguration);return this.context.program.set(t.program),t},module.exports=Painter;
},{"../data/array_types":42,"../data/extent":56,"../data/pos_attributes":60,"../data/program_configuration":61,"../data/raster_bounds_attributes":62,"../gl/color_mode":68,"../gl/context":69,"../gl/depth_mode":70,"../gl/stencil_mode":73,"../shaders":100,"../source/pixels_to_tile_units":107,"../source/source_cache":114,"../style-spec/util/color":165,"../symbol/cross_tile_symbol_index":229,"../util/browser":263,"../util/util":285,"./draw_background":77,"./draw_circle":78,"./draw_debug":80,"./draw_fill":81,"./draw_fill_extrusion":82,"./draw_heatmap":83,"./draw_hillshade":84,"./draw_line":85,"./draw_raster":86,"./draw_symbol":87,"./program":95,"./texture":96,"./tile_mask":97,"./vertex_array_object":98,"@mapbox/gl-matrix":2}],94:[function(_dereq_,module,exports){
"use strict";var pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units");exports.isPatternMissing=function(e,i){if(!e)return!1;var r=i.imageManager.getPattern(e.from),t=i.imageManager.getPattern(e.to);return!r||!t},exports.prepare=function(e,i,r){var t=i.context,n=t.gl,o=i.imageManager.getPattern(e.from),a=i.imageManager.getPattern(e.to);n.uniform1i(r.uniforms.u_image,0),n.uniform2fv(r.uniforms.u_pattern_tl_a,o.tl),n.uniform2fv(r.uniforms.u_pattern_br_a,o.br),n.uniform2fv(r.uniforms.u_pattern_tl_b,a.tl),n.uniform2fv(r.uniforms.u_pattern_br_b,a.br);var u=i.imageManager.getPixelSize(),f=u.width,m=u.height;n.uniform2fv(r.uniforms.u_texsize,[f,m]),n.uniform1f(r.uniforms.u_mix,e.t),n.uniform2fv(r.uniforms.u_pattern_size_a,o.displaySize),n.uniform2fv(r.uniforms.u_pattern_size_b,a.displaySize),n.uniform1f(r.uniforms.u_scale_a,e.fromScale),n.uniform1f(r.uniforms.u_scale_b,e.toScale),t.activeTexture.set(n.TEXTURE0),i.imageManager.bind(i.context)},exports.setTile=function(e,i,r){var t=i.context.gl;t.uniform1f(r.uniforms.u_tile_units_to_pixels,1/pixelsToTileUnits(e,1,i.transform.tileZoom));var n=Math.pow(2,e.tileID.overscaledZ),o=e.tileSize*Math.pow(2,i.transform.tileZoom)/n,a=o*(e.tileID.canonical.x+e.tileID.wrap*n),u=o*e.tileID.canonical.y;t.uniform2f(r.uniforms.u_pixel_coord_upper,a>>16,u>>16),t.uniform2f(r.uniforms.u_pixel_coord_lower,65535&a,65535&u)};
},{"../source/pixels_to_tile_units":107}],95:[function(_dereq_,module,exports){
"use strict";var browser=_dereq_("../util/browser"),shaders=_dereq_("../shaders"),ref=_dereq_("../data/program_configuration"),ProgramConfiguration=ref.ProgramConfiguration,VertexArrayObject=_dereq_("./vertex_array_object"),Context=_dereq_("../gl/context"),Program=function(r,e,t,a){var o=this,i=r.gl;this.program=i.createProgram();var n=t.defines().concat("#define DEVICE_PIXEL_RATIO "+browser.devicePixelRatio.toFixed(1));a&&n.push("#define OVERDRAW_INSPECTOR;");var s=n.concat(shaders.prelude.fragmentSource,e.fragmentSource).join("\n"),m=n.concat(shaders.prelude.vertexSource,e.vertexSource).join("\n"),g=i.createShader(i.FRAGMENT_SHADER);i.shaderSource(g,s),i.compileShader(g),i.attachShader(this.program,g);var c=i.createShader(i.VERTEX_SHADER);i.shaderSource(c,m),i.compileShader(c),i.attachShader(this.program,c);for(var u=t.layoutAttributes||[],h=0;h<u.length;h++)i.bindAttribLocation(o.program,h,u[h].name);i.linkProgram(this.program),this.numAttributes=i.getProgramParameter(this.program,i.ACTIVE_ATTRIBUTES),this.attributes={},this.uniforms={};for(var f=0;f<this.numAttributes;f++){var d=i.getActiveAttrib(o.program,f);d&&(o.attributes[d.name]=i.getAttribLocation(o.program,d.name))}for(var v=i.getProgramParameter(this.program,i.ACTIVE_UNIFORMS),p=0;p<v;p++){var S=i.getActiveUniform(o.program,p);S&&(o.uniforms[S.name]=i.getUniformLocation(o.program,S.name))}};Program.prototype.draw=function(r,e,t,a,o,i,n,s,m){for(var g,c=this,u=r.gl,h=(g={},g[u.LINES]=2,g[u.TRIANGLES]=3,g)[e],f=0,d=i.get();f<d.length;f+=1){var v=d[f],p=v.vaos||(v.vaos={});(p[t]||(p[t]=new VertexArrayObject)).bind(r,c,a,n?n.getPaintVertexBuffers():[],o,v.vertexOffset,s,m),u.drawElements(e,v.primitiveLength*h,u.UNSIGNED_SHORT,v.primitiveOffset*h*2)}},module.exports=Program;
},{"../data/program_configuration":61,"../gl/context":69,"../shaders":100,"../util/browser":263,"./vertex_array_object":98}],96:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/window"),HTMLImageElement=ref.HTMLImageElement,HTMLCanvasElement=ref.HTMLCanvasElement,HTMLVideoElement=ref.HTMLVideoElement,ImageData=ref.ImageData,Texture=function(e,t,i,r){this.context=e;var a=t.width,T=t.height;this.size=[a,T],this.format=i,this.texture=e.gl.createTexture(),this.update(t,r)};Texture.prototype.update=function(e,t){var i=e.width,r=e.height;this.size=[i,r];var a=this,T=a.context,n=T.gl;n.bindTexture(n.TEXTURE_2D,this.texture),T.pixelStoreUnpack.set(1),this.format===n.RGBA&&!1!==t&&T.pixelStoreUnpackPremultiplyAlpha.set(!0),e instanceof HTMLImageElement||e instanceof HTMLCanvasElement||e instanceof HTMLVideoElement||e instanceof ImageData?n.texImage2D(n.TEXTURE_2D,0,this.format,this.format,n.UNSIGNED_BYTE,e):n.texImage2D(n.TEXTURE_2D,0,this.format,i,r,0,this.format,n.UNSIGNED_BYTE,e.data)},Texture.prototype.bind=function(e,t,i){var r=this,a=r.context,T=a.gl;T.bindTexture(T.TEXTURE_2D,this.texture),e!==this.filter&&(T.texParameteri(T.TEXTURE_2D,T.TEXTURE_MAG_FILTER,e),T.texParameteri(T.TEXTURE_2D,T.TEXTURE_MIN_FILTER,i||e),this.filter=e),t!==this.wrap&&(T.texParameteri(T.TEXTURE_2D,T.TEXTURE_WRAP_S,t),T.texParameteri(T.TEXTURE_2D,T.TEXTURE_WRAP_T,t),this.wrap=t)},Texture.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null},module.exports=Texture;
},{"../util/window":265}],97:[function(_dereq_,module,exports){
"use strict";function computeTileMasks(e,i,l,a,r){for(var n=0;n<l.length;n++){var s=l[n];if(a.isLessThan(s.tileID))break;if(i.key===s.tileID.key)return;if(s.tileID.isChildOf(i)){for(var t=i.children(1/0),c=0;c<t.length;c++){computeTileMasks(e,t[c],l.slice(n),a,r)}return}}var o=i.overscaledZ-e.overscaledZ,D=new CanonicalTileID(o,i.canonical.x-(e.canonical.x<<o),i.canonical.y-(e.canonical.y<<o));r[D.key]=r[D.key]||D}var ref=_dereq_("../source/tile_id"),OverscaledTileID=ref.OverscaledTileID,CanonicalTileID=ref.CanonicalTileID;module.exports=function(e,i){for(var l=e.sort(function(e,i){return e.tileID.isLessThan(i.tileID)?-1:i.tileID.isLessThan(e.tileID)?1:0}),a=0;a<l.length;a++){var r={},n=l[a],s=l.slice(a+1);computeTileMasks(n.tileID.wrapped(),n.tileID,s,new OverscaledTileID(0,n.tileID.wrap+1,0,0,0),r),n.setMask(r,i)}};
},{"../source/tile_id":117}],98:[function(_dereq_,module,exports){
"use strict";var VertexArrayObject=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null};VertexArrayObject.prototype.bind=function(t,e,r,i,n,s,u,o){var b=this;this.context=t;for(var a=this.boundPaintVertexBuffers.length!==i.length,f=0;!a&&f<i.length;f++)b.boundPaintVertexBuffers[f]!==i[f]&&(a=!0);var x=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==r||a||this.boundIndexBuffer!==n||this.boundVertexOffset!==s||this.boundDynamicVertexBuffer!==u||this.boundDynamicVertexBuffer2!==o;!t.extVertexArrayObject||x?this.freshBind(e,r,i,n,s,u,o):(t.bindVertexArrayOES.set(this.vao),u&&u.bind(),n&&n.dynamicDraw&&n.bind(),o&&o.bind())},VertexArrayObject.prototype.freshBind=function(t,e,r,i,n,s,u){var o,b=t.numAttributes,a=this.context,f=a.gl;if(a.extVertexArrayObject)this.vao&&this.destroy(),this.vao=a.extVertexArrayObject.createVertexArrayOES(),a.bindVertexArrayOES.set(this.vao),o=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=r,this.boundIndexBuffer=i,this.boundVertexOffset=n,this.boundDynamicVertexBuffer=s,this.boundDynamicVertexBuffer2=u;else{o=a.currentNumAttributes||0;for(var x=b;x<o;x++)f.disableVertexAttribArray(x)}e.enableAttributes(f,t);for(var d=0,h=r;d<h.length;d+=1){h[d].enableAttributes(f,t)}s&&s.enableAttributes(f,t),u&&u.enableAttributes(f,t),e.bind(),e.setVertexAttribPointers(f,t,n);for(var V=0,l=r;V<l.length;V+=1){var y=l[V];y.bind(),y.setVertexAttribPointers(f,t,n)}s&&(s.bind(),s.setVertexAttribPointers(f,t,n)),i&&i.bind(),u&&(u.bind(),u.setVertexAttribPointers(f,t,n)),a.currentNumAttributes=b},VertexArrayObject.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null)},module.exports=VertexArrayObject;
},{}],99:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util");exports.packUint8ToFloat=function(t,l){return t=util.clamp(Math.floor(t),0,255),l=util.clamp(Math.floor(l),0,255),256*t+l};
},{"../util/util":285}],100:[function(_dereq_,module,exports){
"use strict";var shaders={prelude:{fragmentSource:"#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n",vertexSource:"#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n\n// Unpack a pair of values that have been packed into a single float.\n// The packed values are assumed to be 8-bit unsigned integers, and are\n// packed like so:\n// packedValue = floor(input[0]) * 256 + input[1],\nvec2 unpack_float(const float packedValue) {\n    int packedIntValue = int(packedValue);\n    int v0 = packedIntValue / 256;\n    return vec2(v0, packedIntValue - v0 * 256);\n}\n\nvec2 unpack_opacity(const float packedOpacity) {\n    int intOpacity = int(packedOpacity) / 2;\n    return vec2(float(intOpacity) / 127.0, mod(packedOpacity, 2.0));\n}\n\n// To minimize the number of attributes needed, we encode a 4-component\n// color into a pair of floats (i.e. a vec2) as follows:\n// [ floor(color.r * 255) * 256 + color.g * 255,\n//   floor(color.b * 255) * 256 + color.g * 255 ]\nvec4 decode_color(const vec2 encodedColor) {\n    return vec4(\n        unpack_float(encodedColor[0]) / 255.0,\n        unpack_float(encodedColor[1]) / 255.0\n    );\n}\n\n// Unpack a pair of paint values and interpolate between them.\nfloat unpack_mix_vec2(const vec2 packedValue, const float t) {\n    return mix(packedValue[0], packedValue[1], t);\n}\n\n// Unpack a pair of paint values and interpolate between them.\nvec4 unpack_mix_vec4(const vec4 packedColors, const float t) {\n    vec4 minColor = decode_color(vec2(packedColors[0], packedColors[1]));\n    vec4 maxColor = decode_color(vec2(packedColors[2], packedColors[3]));\n    return mix(minColor, maxColor, t);\n}\n\n// The offset depends on how many pixels are between the world origin and the edge of the tile:\n// vec2 offset = mod(pixel_coord, size)\n//\n// At high zoom levels there are a ton of pixels between the world origin and the edge of the tile.\n// The glsl spec only guarantees 16 bits of precision for highp floats. We need more than that.\n//\n// The pixel_coord is passed in as two 16 bit values:\n// pixel_coord_upper = floor(pixel_coord / 2^16)\n// pixel_coord_lower = mod(pixel_coord, 2^16)\n//\n// The offset is calculated in a series of steps that should preserve this precision:\nvec2 get_pattern_pos(const vec2 pixel_coord_upper, const vec2 pixel_coord_lower,\n    const vec2 pattern_size, const float tile_units_to_pixels, const vec2 pos) {\n\n    vec2 offset = mod(mod(mod(pixel_coord_upper, pattern_size) * 256.0, pattern_size) * 256.0 + pixel_coord_lower, pattern_size);\n    return (tile_units_to_pixels * pos + offset) / pattern_size;\n}\n"},circle:{fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec3 v_data;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize highp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    vec2 extrude = v_data.xy;\n    float extrude_length = length(extrude);\n\n    lowp float antialiasblur = v_data.z;\n    float antialiased_blur = -max(blur, antialiasblur);\n\n    float opacity_t = smoothstep(0.0, antialiased_blur, extrude_length - 1.0);\n\n    float color_t = stroke_width < 0.01 ? 0.0 : smoothstep(\n        antialiased_blur,\n        0.0,\n        extrude_length - radius / (radius + stroke_width)\n    );\n\n    gl_FragColor = opacity_t * mix(color * opacity, stroke_color * stroke_opacity, color_t);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform bool u_scale_with_map;\nuniform bool u_pitch_with_map;\nuniform vec2 u_extrude_scale;\nuniform highp float u_camera_to_center_distance;\n\nattribute vec2 a_pos;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec3 v_data;\n\nvoid main(void) {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize highp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    // unencode the extrusion vector that we snuck into the a_pos vector\n    vec2 extrude = vec2(mod(a_pos, 2.0) * 2.0 - 1.0);\n\n    // multiply a_pos by 0.5, since we had it * 2 in order to sneak\n    // in extrusion data\n    vec2 circle_center = floor(a_pos * 0.5);\n    if (u_pitch_with_map) {\n        vec2 corner_position = circle_center;\n        if (u_scale_with_map) {\n            corner_position += extrude * (radius + stroke_width) * u_extrude_scale;\n        } else {\n            // Pitching the circle with the map effectively scales it with the map\n            // To counteract the effect for pitch-scale: viewport, we rescale the\n            // whole circle based on the pitch scaling effect at its central point\n            vec4 projected_center = u_matrix * vec4(circle_center, 0, 1);\n            corner_position += extrude * (radius + stroke_width) * u_extrude_scale * (projected_center.w / u_camera_to_center_distance);\n        }\n\n        gl_Position = u_matrix * vec4(corner_position, 0, 1);\n    } else {\n        gl_Position = u_matrix * vec4(circle_center, 0, 1);\n\n        if (u_scale_with_map) {\n            gl_Position.xy += extrude * (radius + stroke_width) * u_extrude_scale * u_camera_to_center_distance;\n        } else {\n            gl_Position.xy += extrude * (radius + stroke_width) * u_extrude_scale * gl_Position.w;\n        }\n    }\n\n    // This is a minimum blur distance that serves as a faux-antialiasing for\n    // the circle. since blur is a ratio of the circle's size and the intent is\n    // to keep the blur at roughly 1px, the two are inversely related.\n    lowp float antialiasblur = 1.0 / DEVICE_PIXEL_RATIO / (radius + stroke_width);\n\n    v_data = vec3(extrude.x, extrude.y, antialiasblur);\n}\n"},heatmap:{fragmentSource:"#pragma mapbox: define highp float weight\n\nuniform highp float u_intensity;\nvarying vec2 v_extrude;\n\n// Gaussian kernel coefficient: 1 / sqrt(2 * PI)\n#define GAUSS_COEF 0.3989422804014327\n\nvoid main() {\n    #pragma mapbox: initialize highp float weight\n\n    // Kernel density estimation with a Gaussian kernel of size 5x5\n    float d = -0.5 * 3.0 * 3.0 * dot(v_extrude, v_extrude);\n    float val = weight * u_intensity * GAUSS_COEF * exp(d);\n\n    gl_FragColor = vec4(val, 1.0, 1.0, 1.0);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\n\nuniform mat4 u_matrix;\nuniform float u_extrude_scale;\nuniform float u_opacity;\nuniform float u_intensity;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_extrude;\n\n// Effective \"0\" in the kernel density texture to adjust the kernel size to;\n// this empirically chosen number minimizes artifacts on overlapping kernels\n// for typical heatmap cases (assuming clustered source)\nconst highp float ZERO = 1.0 / 255.0 / 16.0;\n\n// Gaussian kernel coefficient: 1 / sqrt(2 * PI)\n#define GAUSS_COEF 0.3989422804014327\n\nvoid main(void) {\n    #pragma mapbox: initialize highp float weight\n    #pragma mapbox: initialize mediump float radius\n\n    // unencode the extrusion vector that we snuck into the a_pos vector\n    vec2 unscaled_extrude = vec2(mod(a_pos, 2.0) * 2.0 - 1.0);\n\n    // This 'extrude' comes in ranging from [-1, -1], to [1, 1].  We'll use\n    // it to produce the vertices of a square mesh framing the point feature\n    // we're adding to the kernel density texture.  We'll also pass it as\n    // a varying, so that the fragment shader can determine the distance of\n    // each fragment from the point feature.\n    // Before we do so, we need to scale it up sufficiently so that the\n    // kernel falls effectively to zero at the edge of the mesh.\n    // That is, we want to know S such that\n    // weight * u_intensity * GAUSS_COEF * exp(-0.5 * 3.0^2 * S^2) == ZERO\n    // Which solves to:\n    // S = sqrt(-2.0 * log(ZERO / (weight * u_intensity * GAUSS_COEF))) / 3.0\n    float S = sqrt(-2.0 * log(ZERO / weight / u_intensity / GAUSS_COEF)) / 3.0;\n\n    // Pass the varying in units of radius\n    v_extrude = S * unscaled_extrude;\n\n    // Scale by radius and the zoom-based scale factor to produce actual\n    // mesh position\n    vec2 extrude = v_extrude * radius * u_extrude_scale;\n\n    // multiply a_pos by 0.5, since we had it * 2 in order to sneak\n    // in extrusion data\n    vec4 pos = vec4(floor(a_pos * 0.5) + extrude, 0, 1);\n\n    gl_Position = u_matrix * pos;\n}\n"},heatmapTexture:{fragmentSource:"uniform sampler2D u_image;\nuniform sampler2D u_color_ramp;\nuniform float u_opacity;\nvarying vec2 v_pos;\n\nvoid main() {\n    float t = texture2D(u_image, v_pos).r;\n    vec4 color = texture2D(u_color_ramp, vec2(t, 0.5));\n    gl_FragColor = color * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(0.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nattribute vec2 a_pos;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos * u_world, 0, 1);\n\n    v_pos.x = a_pos.x;\n    v_pos.y = 1.0 - a_pos.y;\n}\n"},collisionBox:{fragmentSource:"\nvarying float v_placed;\nvarying float v_notUsed;\n\nvoid main() {\n\n    float alpha = 0.5;\n\n    // Red = collision, hide label\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0) * alpha;\n\n    // Blue = no collision, label is showing\n    if (v_placed > 0.5) {\n        gl_FragColor = vec4(0.0, 0.0, 1.0, 0.5) * alpha;\n    }\n\n    if (v_notUsed > 0.5) {\n        // This box not used, fade it out\n        gl_FragColor *= .1;\n    }\n}",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_anchor_pos;\nattribute vec2 a_extrude;\nattribute vec2 a_placed;\n\nuniform mat4 u_matrix;\nuniform vec2 u_extrude_scale;\nuniform float u_camera_to_center_distance;\n\nvarying float v_placed;\nvarying float v_notUsed;\n\nvoid main() {\n    vec4 projectedPoint = u_matrix * vec4(a_anchor_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    highp float collision_perspective_ratio = 0.5 + 0.5 * (u_camera_to_center_distance / camera_to_anchor_distance);\n\n    gl_Position = u_matrix * vec4(a_pos, 0.0, 1.0);\n    gl_Position.xy += a_extrude * u_extrude_scale * gl_Position.w * collision_perspective_ratio;\n\n    v_placed = a_placed.x;\n    v_notUsed = a_placed.y;\n}\n"},collisionCircle:{fragmentSource:"\nvarying float v_placed;\nvarying float v_notUsed;\nvarying float v_radius;\nvarying vec2 v_extrude;\nvarying vec2 v_extrude_scale;\n\nvoid main() {\n    float alpha = 0.5;\n\n    // Red = collision, hide label\n    vec4 color = vec4(1.0, 0.0, 0.0, 1.0) * alpha;\n\n    // Blue = no collision, label is showing\n    if (v_placed > 0.5) {\n        color = vec4(0.0, 0.0, 1.0, 0.5) * alpha;\n    }\n\n    if (v_notUsed > 0.5) {\n        // This box not used, fade it out\n        color *= .2;\n    }\n\n    float extrude_scale_length = length(v_extrude_scale);\n    float extrude_length = length(v_extrude) * extrude_scale_length;\n    float stroke_width = 3.0;\n    float radius = v_radius * extrude_scale_length;\n\n    float distance_to_edge = abs(extrude_length - radius);\n    float opacity_t = smoothstep(-stroke_width, 0.0, -distance_to_edge);\n\n    gl_FragColor = opacity_t * color;\n}\n",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_anchor_pos;\nattribute vec2 a_extrude;\nattribute vec2 a_placed;\n\nuniform mat4 u_matrix;\nuniform vec2 u_extrude_scale;\nuniform float u_camera_to_center_distance;\n\nvarying float v_placed;\nvarying float v_notUsed;\nvarying float v_radius;\n\nvarying vec2 v_extrude;\nvarying vec2 v_extrude_scale;\n\nvoid main() {\n    vec4 projectedPoint = u_matrix * vec4(a_anchor_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    highp float collision_perspective_ratio = 0.5 + 0.5 * (camera_to_anchor_distance / u_camera_to_center_distance);\n\n    gl_Position = u_matrix * vec4(a_pos, 0.0, 1.0);\n\n    highp float padding_factor = 1.2; // Pad the vertices slightly to make room for anti-alias blur\n    gl_Position.xy += a_extrude * u_extrude_scale * padding_factor * gl_Position.w / collision_perspective_ratio;\n\n    v_placed = a_placed.x;\n    v_notUsed = a_placed.y;\n    v_radius = abs(a_extrude.y); // We don't pitch the circles, so both units of the extrusion vector are equal in magnitude to the radius\n\n    v_extrude = a_extrude * padding_factor;\n    v_extrude_scale = u_extrude_scale * u_camera_to_center_distance / collision_perspective_ratio;\n}\n"},debug:{fragmentSource:"uniform highp vec4 u_color;\n\nvoid main() {\n    gl_FragColor = u_color;\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},fill:{fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_FragColor = color * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},fillOutline:{fragmentSource:"#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_pos;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);\n    gl_FragColor = outline_color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\nuniform vec2 u_world;\n\nvarying vec2 v_pos;\n\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillOutlinePattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    // find distance to outline for alpha interpolation\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);\n\n\n    gl_FragColor = mix(color1, color2, u_mix) * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    gl_FragColor = mix(color1, color2, u_mix) * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n}\n"},fillExtrusion:{fragmentSource:"varying vec4 v_color;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define highp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize highp vec4 color\n\n    gl_FragColor = v_color;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\n\nattribute vec2 a_pos;\nattribute vec4 a_normal_ed;\n\nvarying vec4 v_color;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\n#pragma mapbox: define highp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize highp vec4 color\n\n    vec3 normal = a_normal_ed.xyz;\n\n    base = max(0.0, base);\n    height = max(0.0, height);\n\n    float t = mod(normal.x, 2.0);\n\n    gl_Position = u_matrix * vec4(a_pos, t > 0.0 ? height : base, 1);\n\n    // Relative luminance (how dark/bright is the surface color?)\n    float colorvalue = color.r * 0.2126 + color.g * 0.7152 + color.b * 0.0722;\n\n    v_color = vec4(0.0, 0.0, 0.0, 1.0);\n\n    // Add slight ambient lighting so no extrusions are totally black\n    vec4 ambientlight = vec4(0.03, 0.03, 0.03, 1.0);\n    color += ambientlight;\n\n    // Calculate cos(theta), where theta is the angle between surface normal and diffuse light ray\n    float directional = clamp(dot(normal / 16384.0, u_lightpos), 0.0, 1.0);\n\n    // Adjust directional so that\n    // the range of values for highlight/shading is narrower\n    // with lower light intensity\n    // and with lighter/brighter surface colors\n    directional = mix((1.0 - u_lightintensity), max((1.0 - colorvalue + u_lightintensity), 1.0), directional);\n\n    // Add gradient along z axis of side surfaces\n    if (normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    // Assign final color based on surface + ambient light color, diffuse light directional, and light color\n    // with lower bounds adjusted to hue of light\n    // so that shading is tinted with the complementary (opposite) color to the light color\n    v_color.r += clamp(color.r * directional * u_lightcolor.r, mix(0.0, 0.3, 1.0 - u_lightcolor.r), 1.0);\n    v_color.g += clamp(color.g * directional * u_lightcolor.g, mix(0.0, 0.3, 1.0 - u_lightcolor.g), 1.0);\n    v_color.b += clamp(color.b * directional * u_lightcolor.b, mix(0.0, 0.3, 1.0 - u_lightcolor.b), 1.0);\n}\n"},fillExtrusionPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    vec4 mixedColor = mix(color1, color2, u_mix);\n\n    gl_FragColor = mixedColor * v_lighting;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\nuniform float u_height_factor;\n\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\n\nattribute vec2 a_pos;\nattribute vec4 a_normal_ed;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\nvarying float v_directional;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    vec3 normal = a_normal_ed.xyz;\n    float edgedistance = a_normal_ed.w;\n\n    base = max(0.0, base);\n    height = max(0.0, height);\n\n    float t = mod(normal.x, 2.0);\n    float z = t > 0.0 ? height : base;\n\n    gl_Position = u_matrix * vec4(a_pos, z, 1);\n\n    vec2 pos = normal.x == 1.0 && normal.y == 0.0 && normal.z == 16384.0\n        ? a_pos // extrusion top\n        : vec2(edgedistance, z * u_height_factor); // extrusion side\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, pos);\n\n    v_lighting = vec4(0.0, 0.0, 0.0, 1.0);\n    float directional = clamp(dot(normal / 16383.0, u_lightpos), 0.0, 1.0);\n    directional = mix((1.0 - u_lightintensity), max((0.5 + u_lightintensity), 1.0), directional);\n\n    if (normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    v_lighting.rgb += clamp(directional * u_lightcolor, mix(vec3(0.0), vec3(0.3), 1.0 - u_lightcolor), vec3(1.0));\n}\n"},extrusionTexture:{fragmentSource:"uniform sampler2D u_image;\nuniform float u_opacity;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_FragColor = texture2D(u_image, v_pos) * u_opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(0.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nattribute vec2 a_pos;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos * u_world, 0, 1);\n\n    v_pos.x = a_pos.x;\n    v_pos.y = 1.0 - a_pos.y;\n}\n"},hillshadePrepare:{fragmentSource:"#ifdef GL_ES\nprecision highp float;\n#endif\n\nuniform sampler2D u_image;\nvarying vec2 v_pos;\nuniform vec2 u_dimension;\nuniform float u_zoom;\n\nfloat getElevation(vec2 coord, float bias) {\n    // Convert encoded elevation value to meters\n    vec4 data = texture2D(u_image, coord) * 255.0;\n    return (data.r + data.g * 256.0 + data.b * 256.0 * 256.0) / 4.0;\n}\n\nvoid main() {\n    vec2 epsilon = 1.0 / u_dimension;\n\n    // queried pixels:\n    // +-----------+\n    // |   |   |   |\n    // | a | b | c |\n    // |   |   |   |\n    // +-----------+\n    // |   |   |   |\n    // | d | e | f |\n    // |   |   |   |\n    // +-----------+\n    // |   |   |   |\n    // | g | h | i |\n    // |   |   |   |\n    // +-----------+\n\n    float a = getElevation(v_pos + vec2(-epsilon.x, -epsilon.y), 0.0);\n    float b = getElevation(v_pos + vec2(0, -epsilon.y), 0.0);\n    float c = getElevation(v_pos + vec2(epsilon.x, -epsilon.y), 0.0);\n    float d = getElevation(v_pos + vec2(-epsilon.x, 0), 0.0);\n    float e = getElevation(v_pos, 0.0);\n    float f = getElevation(v_pos + vec2(epsilon.x, 0), 0.0);\n    float g = getElevation(v_pos + vec2(-epsilon.x, epsilon.y), 0.0);\n    float h = getElevation(v_pos + vec2(0, epsilon.y), 0.0);\n    float i = getElevation(v_pos + vec2(epsilon.x, epsilon.y), 0.0);\n\n    // here we divide the x and y slopes by 8 * pixel size\n    // where pixel size (aka meters/pixel) is:\n    // circumference of the world / (pixels per tile * number of tiles)\n    // which is equivalent to: 8 * 40075016.6855785 / (512 * pow(2, u_zoom))\n    // which can be reduced to: pow(2, 19.25619978527 - u_zoom)\n    // we want to vertically exaggerate the hillshading though, because otherwise\n    // it is barely noticeable at low zooms. to do this, we multiply this by some\n    // scale factor pow(2, (u_zoom - 14) * a) where a is an arbitrary value and 14 is the\n    // maxzoom of the tile source. here we use a=0.3 which works out to the\n    // expression below. see nickidlugash's awesome breakdown for more info\n    // https://github.com/mapbox/mapbox-gl-js/pull/5286#discussion_r148419556\n    float exaggeration = u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;\n\n    vec2 deriv = vec2(\n        (c + f + f + i) - (a + d + d + g),\n        (g + h + h + i) - (a + b + b + c)\n    ) /  pow(2.0, (u_zoom - 14.0) * exaggeration + 19.2562 - u_zoom);\n\n    gl_FragColor = clamp(vec4(\n        deriv.x / 2.0 + 0.5,\n        deriv.y / 2.0 + 0.5,\n        1.0,\n        1.0), 0.0, 1.0);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = (a_texture_pos / 8192.0) / 2.0 + 0.25;\n}\n"},hillshade:{fragmentSource:"uniform sampler2D u_image;\nvarying vec2 v_pos;\n\nuniform vec2 u_latrange;\nuniform vec2 u_light;\nuniform vec4 u_shadow;\nuniform vec4 u_highlight;\nuniform vec4 u_accent;\n\n#define PI 3.141592653589793\n\nvoid main() {\n    vec4 pixel = texture2D(u_image, v_pos);\n\n    vec2 deriv = ((pixel.rg * 2.0) - 1.0);\n\n    // We divide the slope by a scale factor based on the cosin of the pixel's approximate latitude\n    // to account for mercator projection distortion. see #4807 for details\n    float scaleFactor = cos(radians((u_latrange[0] - u_latrange[1]) * (1.0 - v_pos.y) + u_latrange[1]));\n    // We also multiply the slope by an arbitrary z-factor of 1.25\n    float slope = atan(1.25 * length(deriv) / scaleFactor);\n    float aspect = deriv.x != 0.0 ? atan(deriv.y, -deriv.x) : PI / 2.0 * (deriv.y > 0.0 ? 1.0 : -1.0);\n\n    float intensity = u_light.x;\n    // We add PI to make this property match the global light object, which adds PI/2 to the light's azimuthal\n    // position property to account for 0deg corresponding to north/the top of the viewport in the style spec\n    // and the original shader was written to accept (-illuminationDirection - 90) as the azimuthal.\n    float azimuth = u_light.y + PI;\n\n    // We scale the slope exponentially based on intensity, using a calculation similar to\n    // the exponential interpolation function in the style spec:\n    // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/expression/definitions/interpolate.js#L217-L228\n    // so that higher intensity values create more opaque hillshading.\n    float base = 1.875 - intensity * 1.75;\n    float maxValue = 0.5 * PI;\n    float scaledSlope = intensity != 0.5 ? ((pow(base, slope) - 1.0) / (pow(base, maxValue) - 1.0)) * maxValue : slope;\n\n    // The accent color is calculated with the cosine of the slope while the shade color is calculated with the sine\n    // so that the accent color's rate of change eases in while the shade color's eases out.\n    float accent = cos(scaledSlope);\n    // We multiply both the accent and shade color by a clamped intensity value\n    // so that intensities >= 0.5 do not additionally affect the color values\n    // while intensity values < 0.5 make the overall color more transparent.\n    vec4 accent_color = (1.0 - accent) * u_accent * clamp(intensity * 2.0, 0.0, 1.0);\n    float shade = abs(mod((aspect + azimuth) / PI + 0.5, 2.0) - 1.0);\n    vec4 shade_color = mix(u_shadow, u_highlight, shade) * sin(scaledSlope) * clamp(intensity * 2.0, 0.0, 1.0);\n    gl_FragColor = accent_color * (1.0 - shade_color.a) + shade_color;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = a_texture_pos / 8192.0;\n}\n"},line:{
fragmentSource:"#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_width2;\nvarying vec2 v_normal;\nvarying float v_gamma_scale;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\n// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float width\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_width2 = vec2(outset, inset);\n}\n"},linePattern:{fragmentSource:"uniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform vec2 u_texsize;\nuniform float u_fade;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float x_a = mod(v_linesofar / u_pattern_size_a.x, 1.0);\n    float x_b = mod(v_linesofar / u_pattern_size_b.x, 1.0);\n    float y_a = 0.5 + (v_normal.y * v_width2.s / u_pattern_size_a.y);\n    float y_b = 0.5 + (v_normal.y * v_width2.s / u_pattern_size_b.y);\n    vec2 pos_a = mix(u_pattern_tl_a / u_texsize, u_pattern_br_a / u_texsize, vec2(x_a, y_a));\n    vec2 pos_b = mix(u_pattern_tl_b / u_texsize, u_pattern_br_b / u_texsize, vec2(x_b, y_b));\n\n    vec4 color = mix(texture2D(u_image, pos_a), texture2D(u_image, pos_b), u_fade);\n\n    gl_FragColor = color * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize mediump float width\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_linesofar = a_linesofar;\n    v_width2 = vec2(outset, inset);\n}\n"},lineSDF:{fragmentSource:"\nuniform sampler2D u_image;\nuniform float u_sdfgamma;\nuniform float u_mix;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float width\n    #pragma mapbox: initialize lowp float floorwidth\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float sdfdist_a = texture2D(u_image, v_tex_a).a;\n    float sdfdist_b = texture2D(u_image, v_tex_b).a;\n    float sdfdist = mix(sdfdist_a, sdfdist_b, u_mix);\n    alpha *= smoothstep(0.5 - u_sdfgamma / floorwidth, 0.5 + u_sdfgamma / floorwidth, sdfdist);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec4 a_pos_normal;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_patternscale_a;\nuniform float u_tex_y_a;\nuniform vec2 u_patternscale_b;\nuniform float u_tex_y_b;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float width\n    #pragma mapbox: initialize lowp float floorwidth\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    vec2 pos = a_pos_normal.xy;\n\n    // x is 1 if it's a round cap, 0 otherwise\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = a_pos_normal.zw;\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases.\n    // moved them into the shader for clarity and simplicity.\n    gapwidth = gapwidth / 2.0;\n    float halfwidth = width / 2.0;\n    offset = -1.0 * offset;\n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + halfwidth * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist =outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_tex_a = vec2(a_linesofar * u_patternscale_a.x / floorwidth, normal.y * u_patternscale_a.y + u_tex_y_a);\n    v_tex_b = vec2(a_linesofar * u_patternscale_b.x / floorwidth, normal.y * u_patternscale_b.y + u_tex_y_b);\n\n    v_width2 = vec2(outset, inset);\n}\n"},raster:{fragmentSource:"uniform float u_fade_t;\nuniform float u_opacity;\nuniform sampler2D u_image0;\nuniform sampler2D u_image1;\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nuniform float u_brightness_low;\nuniform float u_brightness_high;\n\nuniform float u_saturation_factor;\nuniform float u_contrast_factor;\nuniform vec3 u_spin_weights;\n\nvoid main() {\n\n    // read and cross-fade colors from the main and parent tiles\n    vec4 color0 = texture2D(u_image0, v_pos0);\n    vec4 color1 = texture2D(u_image1, v_pos1);\n    if (color0.a > 0.0) {\n        color0.rgb = color0.rgb / color0.a;\n    }\n    if (color1.a > 0.0) {\n        color1.rgb = color1.rgb / color1.a;\n    }\n    vec4 color = mix(color0, color1, u_fade_t);\n    color.a *= u_opacity;\n    vec3 rgb = color.rgb;\n\n    // spin\n    rgb = vec3(\n        dot(rgb, u_spin_weights.xyz),\n        dot(rgb, u_spin_weights.zxy),\n        dot(rgb, u_spin_weights.yzx));\n\n    // saturation\n    float average = (color.r + color.g + color.b) / 3.0;\n    rgb += (average - rgb) * u_saturation_factor;\n\n    // contrast\n    rgb = (rgb - 0.5) * u_contrast_factor + 0.5;\n\n    // brightness\n    vec3 u_high_vec = vec3(u_brightness_low, u_brightness_low, u_brightness_low);\n    vec3 u_low_vec = vec3(u_brightness_high, u_brightness_high, u_brightness_high);\n\n    gl_FragColor = vec4(mix(u_high_vec, u_low_vec, rgb) * color.a, color.a);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_tl_parent;\nuniform float u_scale_parent;\nuniform float u_buffer_scale;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    // We are using Int16 for texture position coordinates to give us enough precision for\n    // fractional coordinates. We use 8192 to scale the texture coordinates in the buffer\n    // as an arbitrarily high number to preserve adequate precision when rendering.\n    // This is also the same value as the EXTENT we are using for our tile buffer pos coordinates,\n    // so math for modifying either is consistent.\n    v_pos0 = (((a_texture_pos / 8192.0) - 0.5) / u_buffer_scale ) + 0.5;\n    v_pos1 = (v_pos0 * u_scale_parent) + u_tl_parent;\n}\n"},symbolIcon:{fragmentSource:"uniform sampler2D u_texture;\n\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_tex;\nvarying float v_fade_opacity;\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    lowp float alpha = opacity * v_fade_opacity;\n    gl_FragColor = texture2D(u_texture, v_tex) * alpha;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"const float PI = 3.141592653589793;\n\nattribute vec4 a_pos_offset;\nattribute vec4 a_data;\nattribute vec3 a_projected_pos;\nattribute float a_fade_opacity;\n\nuniform bool u_is_size_zoom_constant;\nuniform bool u_is_size_feature_constant;\nuniform highp float u_size_t; // used to interpolate between zoom stops when size is a composite function\nuniform highp float u_size; // used when size is both zoom and feature constant\nuniform highp float u_camera_to_center_distance;\nuniform highp float u_pitch;\nuniform bool u_rotate_symbol;\nuniform highp float u_aspect_ratio;\nuniform float u_fade_change;\n\n#pragma mapbox: define lowp float opacity\n\nuniform mat4 u_matrix;\nuniform mat4 u_label_plane_matrix;\nuniform mat4 u_gl_coord_matrix;\n\nuniform bool u_is_text;\nuniform bool u_pitch_with_map;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_tex;\nvarying float v_fade_opacity;\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 a_pos = a_pos_offset.xy;\n    vec2 a_offset = a_pos_offset.zw;\n\n    vec2 a_tex = a_data.xy;\n    vec2 a_size = a_data.zw;\n\n    highp float segment_angle = -a_projected_pos[2];\n\n    float size;\n    if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = mix(a_size[0], a_size[1], u_size_t) / 10.0;\n    } else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = a_size[0] / 10.0;\n    } else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {\n        size = u_size;\n    } else {\n        size = u_size;\n    }\n\n    vec4 projectedPoint = u_matrix * vec4(a_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    // See comments in symbol_sdf.vertex\n    highp float distance_ratio = u_pitch_with_map ?\n        camera_to_anchor_distance / u_camera_to_center_distance :\n        u_camera_to_center_distance / camera_to_anchor_distance;\n    highp float perspective_ratio = 0.5 + 0.5 * distance_ratio;\n\n    size *= perspective_ratio;\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    highp float symbol_rotation = 0.0;\n    if (u_rotate_symbol) {\n        // See comments in symbol_sdf.vertex\n        vec4 offsetProjectedPoint = u_matrix * vec4(a_pos + vec2(1, 0), 0, 1);\n\n        vec2 a = projectedPoint.xy / projectedPoint.w;\n        vec2 b = offsetProjectedPoint.xy / offsetProjectedPoint.w;\n\n        symbol_rotation = atan((b.y - a.y) / u_aspect_ratio, b.x - a.x);\n    }\n\n    highp float angle_sin = sin(segment_angle + symbol_rotation);\n    highp float angle_cos = cos(segment_angle + symbol_rotation);\n    mat2 rotation_matrix = mat2(angle_cos, -1.0 * angle_sin, angle_sin, angle_cos);\n\n    vec4 projected_pos = u_label_plane_matrix * vec4(a_projected_pos.xy, 0.0, 1.0);\n    gl_Position = u_gl_coord_matrix * vec4(projected_pos.xy / projected_pos.w + rotation_matrix * (a_offset / 64.0 * fontScale), 0.0, 1.0);\n\n    v_tex = a_tex / u_texsize;\n    vec2 fade_opacity = unpack_opacity(a_fade_opacity);\n    float fade_change = fade_opacity[1] > 0.5 ? u_fade_change : -u_fade_change;\n    v_fade_opacity = max(0.0, min(1.0, fade_opacity[0] + fade_change));\n}\n"},symbolSDF:{fragmentSource:"#define SDF_PX 8.0\n#define EDGE_GAMMA 0.105/DEVICE_PIXEL_RATIO\n\nuniform bool u_is_halo;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n\nuniform sampler2D u_texture;\nuniform highp float u_gamma_scale;\nuniform bool u_is_text;\n\nvarying vec2 v_data0;\nvarying vec3 v_data1;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 fill_color\n    #pragma mapbox: initialize highp vec4 halo_color\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float halo_width\n    #pragma mapbox: initialize lowp float halo_blur\n\n    vec2 tex = v_data0.xy;\n    float gamma_scale = v_data1.x;\n    float size = v_data1.y;\n    float fade_opacity = v_data1[2];\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    lowp vec4 color = fill_color;\n    highp float gamma = EDGE_GAMMA / (fontScale * u_gamma_scale);\n    lowp float buff = (256.0 - 64.0) / 256.0;\n    if (u_is_halo) {\n        color = halo_color;\n        gamma = (halo_blur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * u_gamma_scale);\n        buff = (6.0 - halo_width / fontScale) / SDF_PX;\n    }\n\n    lowp float dist = texture2D(u_texture, tex).a;\n    highp float gamma_scaled = gamma * gamma_scale;\n    highp float alpha = smoothstep(buff - gamma_scaled, buff + gamma_scaled, dist);\n\n    gl_FragColor = color * (alpha * opacity * fade_opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"const float PI = 3.141592653589793;\n\nattribute vec4 a_pos_offset;\nattribute vec4 a_data;\nattribute vec3 a_projected_pos;\nattribute float a_fade_opacity;\n\n// contents of a_size vary based on the type of property value\n// used for {text,icon}-size.\n// For constants, a_size is disabled.\n// For source functions, we bind only one value per vertex: the value of {text,icon}-size evaluated for the current feature.\n// For composite functions:\n// [ text-size(lowerZoomStop, feature),\n//   text-size(upperZoomStop, feature) ]\nuniform bool u_is_size_zoom_constant;\nuniform bool u_is_size_feature_constant;\nuniform highp float u_size_t; // used to interpolate between zoom stops when size is a composite function\nuniform highp float u_size; // used when size is both zoom and feature constant\n\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n\nuniform mat4 u_matrix;\nuniform mat4 u_label_plane_matrix;\nuniform mat4 u_gl_coord_matrix;\n\nuniform bool u_is_text;\nuniform bool u_pitch_with_map;\nuniform highp float u_pitch;\nuniform bool u_rotate_symbol;\nuniform highp float u_aspect_ratio;\nuniform highp float u_camera_to_center_distance;\nuniform float u_fade_change;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_data0;\nvarying vec3 v_data1;\n\nvoid main() {\n    #pragma mapbox: initialize highp vec4 fill_color\n    #pragma mapbox: initialize highp vec4 halo_color\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float halo_width\n    #pragma mapbox: initialize lowp float halo_blur\n\n    vec2 a_pos = a_pos_offset.xy;\n    vec2 a_offset = a_pos_offset.zw;\n\n    vec2 a_tex = a_data.xy;\n    vec2 a_size = a_data.zw;\n\n    highp float segment_angle = -a_projected_pos[2];\n    float size;\n\n    if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = mix(a_size[0], a_size[1], u_size_t) / 10.0;\n    } else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {\n        size = a_size[0] / 10.0;\n    } else if (!u_is_size_zoom_constant && u_is_size_feature_constant) {\n        size = u_size;\n    } else {\n        size = u_size;\n    }\n\n    vec4 projectedPoint = u_matrix * vec4(a_pos, 0, 1);\n    highp float camera_to_anchor_distance = projectedPoint.w;\n    // If the label is pitched with the map, layout is done in pitched space,\n    // which makes labels in the distance smaller relative to viewport space.\n    // We counteract part of that effect by multiplying by the perspective ratio.\n    // If the label isn't pitched with the map, we do layout in viewport space,\n    // which makes labels in the distance larger relative to the features around\n    // them. We counteract part of that effect by dividing by the perspective ratio.\n    highp float distance_ratio = u_pitch_with_map ?\n        camera_to_anchor_distance / u_camera_to_center_distance :\n        u_camera_to_center_distance / camera_to_anchor_distance;\n    highp float perspective_ratio = 0.5 + 0.5 * distance_ratio;\n\n    size *= perspective_ratio;\n\n    float fontScale = u_is_text ? size / 24.0 : size;\n\n    highp float symbol_rotation = 0.0;\n    if (u_rotate_symbol) {\n        // Point labels with 'rotation-alignment: map' are horizontal with respect to tile units\n        // To figure out that angle in projected space, we draw a short horizontal line in tile\n        // space, project it, and measure its angle in projected space.\n        vec4 offsetProjectedPoint = u_matrix * vec4(a_pos + vec2(1, 0), 0, 1);\n\n        vec2 a = projectedPoint.xy / projectedPoint.w;\n        vec2 b = offsetProjectedPoint.xy / offsetProjectedPoint.w;\n\n        symbol_rotation = atan((b.y - a.y) / u_aspect_ratio, b.x - a.x);\n    }\n\n    highp float angle_sin = sin(segment_angle + symbol_rotation);\n    highp float angle_cos = cos(segment_angle + symbol_rotation);\n    mat2 rotation_matrix = mat2(angle_cos, -1.0 * angle_sin, angle_sin, angle_cos);\n\n    vec4 projected_pos = u_label_plane_matrix * vec4(a_projected_pos.xy, 0.0, 1.0);\n    gl_Position = u_gl_coord_matrix * vec4(projected_pos.xy / projected_pos.w + rotation_matrix * (a_offset / 64.0 * fontScale), 0.0, 1.0);\n    float gamma_scale = gl_Position.w;\n\n    vec2 tex = a_tex / u_texsize;\n    vec2 fade_opacity = unpack_opacity(a_fade_opacity);\n    float fade_change = fade_opacity[1] > 0.5 ? u_fade_change : -u_fade_change;\n    float interpolated_fade_opacity = max(0.0, min(1.0, fade_opacity[0] + fade_change));\n\n    v_data0 = vec2(tex.x, tex.y);\n    v_data1 = vec3(gamma_scale, size, interpolated_fade_opacity);\n}\n"}},re=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,loop=function(e){var n=shaders[e],a={};n.fragmentSource=n.fragmentSource.replace(re,function(e,n,t,o,i){return a[i]=!0,"define"===n?"\n#ifndef HAS_UNIFORM_u_"+i+"\nvarying "+t+" "+o+" "+i+";\n#else\nuniform "+t+" "+o+" u_"+i+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+i+"\n    "+t+" "+o+" "+i+" = u_"+i+";\n#endif\n"}),n.vertexSource=n.vertexSource.replace(re,function(e,n,t,o,i){var r="float"===o?"vec2":"vec4";return a[i]?"define"===n?"\n#ifndef HAS_UNIFORM_u_"+i+"\nuniform lowp float a_"+i+"_t;\nattribute "+t+" "+r+" a_"+i+";\nvarying "+t+" "+o+" "+i+";\n#else\nuniform "+t+" "+o+" u_"+i+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+i+"\n    "+i+" = unpack_mix_"+r+"(a_"+i+", a_"+i+"_t);\n#else\n    "+t+" "+o+" "+i+" = u_"+i+";\n#endif\n":"define"===n?"\n#ifndef HAS_UNIFORM_u_"+i+"\nuniform lowp float a_"+i+"_t;\nattribute "+t+" "+r+" a_"+i+";\n#else\nuniform "+t+" "+o+" u_"+i+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+i+"\n    "+t+" "+o+" "+i+" = unpack_mix_"+r+"(a_"+i+", a_"+i+"_t);\n#else\n    "+t+" "+o+" "+i+" = u_"+i+";\n#endif\n"})};for(var programName in shaders)loop(programName);module.exports=shaders;
},{}],101:[function(_dereq_,module,exports){
"use strict";var ImageSource=_dereq_("./image_source"),window=_dereq_("../util/window"),rasterBoundsAttributes=_dereq_("../data/raster_bounds_attributes"),VertexArrayObject=_dereq_("../render/vertex_array_object"),Texture=_dereq_("../render/texture"),CanvasSource=function(t){function e(e,i,s,a){t.call(this,e,i,s,a),this.options=i,this.animate=void 0===i.animate||i.animate}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.load=function(){if(this.canvas=this.canvas||window.document.getElementById(this.options.canvas),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions())return this.fire("error",new Error("Canvas dimensions cannot be less than or equal to zero."));this.play=function(){this._playing=!0,this.map._rerender()},this.pause=function(){this._playing=!1},this._finishLoading()},e.prototype.getCanvas=function(){return this.canvas},e.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play()},e.prototype.onRemove=function(){this.pause()},e.prototype.prepare=function(){var t=this,e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,s=i.gl;this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new VertexArrayObject),this.texture?e?this.texture.update(this.canvas):this._playing&&(this.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE),s.texSubImage2D(s.TEXTURE_2D,0,0,0,s.RGBA,s.UNSIGNED_BYTE,this.canvas)):(this.texture=new Texture(i,this.canvas,s.RGBA),this.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE));for(var a in t.tiles){var r=t.tiles[a];"loaded"!==r.state&&(r.state="loaded",r.texture=t.texture)}}},e.prototype.serialize=function(){return{type:"canvas",canvas:this.canvas,coordinates:this.coordinates}},e.prototype.hasTransition=function(){return this._playing},e.prototype._hasInvalidDimensions=function(){for(var t=this,e=0,i=[t.canvas.width,t.canvas.height];e<i.length;e+=1){var s=i[e];if(isNaN(s)||s<=0)return!0}return!1},e}(ImageSource);module.exports=CanvasSource;
},{"../data/raster_bounds_attributes":62,"../render/texture":96,"../render/vertex_array_object":98,"../util/window":265,"./image_source":105}],102:[function(_dereq_,module,exports){
"use strict";function resolveURL(t){var e=window.document.createElement("a");return e.href=t,e.href}var Evented=_dereq_("../util/evented"),util=_dereq_("../util/util"),window=_dereq_("../util/window"),EXTENT=_dereq_("../data/extent"),ResourceType=_dereq_("../util/ajax").ResourceType,browser=_dereq_("../util/browser"),GeoJSONSource=function(t){function e(e,o,i,r){t.call(this),this.id=e,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this.dispatcher=i,this.setEventedParent(r),this._data=o.data,this._options=util.extend({},o),void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type);var a=EXTENT/this.tileSize;this.workerOptions=util.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*a,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*a,extent:EXTENT,maxZoom:this.maxzoom},superclusterOptions:{maxZoom:void 0!==o.clusterMaxZoom?Math.min(o.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:EXTENT,radius:(o.clusterRadius||50)*a,log:!1}},o.workerOptions)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.load=function(){var t=this;this.fire("dataloading",{dataType:"source"}),this._updateWorkerData(function(e){if(e)return void t.fire("error",{error:e});t.fire("data",{dataType:"source",sourceDataType:"metadata"})})},e.prototype.onAdd=function(t){this.map=t,this.load()},e.prototype.setData=function(t){var e=this;return this._data=t,this.fire("dataloading",{dataType:"source"}),this._updateWorkerData(function(t){if(t)return e.fire("error",{error:t});e.fire("data",{dataType:"source",sourceDataType:"content"})}),this},e.prototype._updateWorkerData=function(t){var e=this,o=util.extend({},this.workerOptions),i=this._data;"string"==typeof i?o.request=this.map._transformRequest(resolveURL(i),ResourceType.Source):o.data=JSON.stringify(i),this.workerID=this.dispatcher.send(this.type+".loadData",o,function(o){e._loaded=!0,t(o)},this.workerID)},e.prototype.loadTile=function(t,e){var o=this,i=void 0===t.workerID||"expired"===t.state?"loadTile":"reloadTile",r={type:this.type,uid:t.uid,tileID:t.tileID,zoom:t.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:browser.devicePixelRatio,overscaling:t.tileID.overscaleFactor(),showCollisionBoxes:this.map.showCollisionBoxes};t.workerID=this.dispatcher.send(i,r,function(i,r){return t.unloadVectorData(),t.aborted?e(null):i?e(i):(t.loadVectorData(r,o.map.painter),e(null))},this.workerID)},e.prototype.abortTile=function(t){t.aborted=!0},e.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},null,t.workerID)},e.prototype.onRemove=function(){this.dispatcher.broadcast("removeSource",{type:this.type,source:this.id})},e.prototype.serialize=function(){return util.extend({},this._options,{type:this.type,data:this._data})},e.prototype.hasTransition=function(){return!1},e}(Evented);module.exports=GeoJSONSource;
},{"../data/extent":56,"../util/ajax":262,"../util/browser":263,"../util/evented":271,"../util/util":285,"../util/window":265}],103:[function(_dereq_,module,exports){
"use strict";function loadGeoJSONTile(e,r){var t=e.source,o=e.tileID.canonical;if(!this._geoJSONIndexes[t])return r(null,null);var n=this._geoJSONIndexes[t].getTile(o.z,o.x,o.y);if(!n)return r(null,null);var u=new GeoJSONWrapper(n.features),i=vtpbf(u);0===i.byteOffset&&i.byteLength===i.buffer.byteLength||(i=new Uint8Array(i)),r(null,{vectorTile:u,rawData:i.buffer})}var ajax=_dereq_("../util/ajax"),rewind=_dereq_("geojson-rewind"),GeoJSONWrapper=_dereq_("./geojson_wrapper"),vtpbf=_dereq_("vt-pbf"),supercluster=_dereq_("supercluster"),geojsonvt=_dereq_("geojson-vt"),VectorTileWorkerSource=_dereq_("./vector_tile_worker_source"),GeoJSONWorkerSource=function(e){function r(r,t,o){e.call(this,r,t,loadGeoJSONTile),o&&(this.loadGeoJSON=o),this._geoJSONIndexes={}}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.loadData=function(e,r){var t=this;this.loadGeoJSON(e,function(o,n){if(o||!n)return r(o);if("object"!=typeof n)return r(new Error("Input data is not a valid GeoJSON object."));rewind(n,!0);try{t._geoJSONIndexes[e.source]=e.cluster?supercluster(e.superclusterOptions).load(n.features):geojsonvt(n,e.geojsonVtOptions)}catch(o){return r(o)}t.loaded[e.source]={},r(null)})},r.prototype.reloadTile=function(r,t){var o=this.loaded[r.source],n=r.uid;return o&&o[n]?e.prototype.reloadTile.call(this,r,t):this.loadTile(r,t)},r.prototype.loadGeoJSON=function(e,r){if(e.request)ajax.getJSON(e.request,r);else{if("string"!=typeof e.data)return r(new Error("Input data is not a valid GeoJSON object."));try{return r(null,JSON.parse(e.data))}catch(e){return r(new Error("Input data is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,r){this._geoJSONIndexes[e.source]&&delete this._geoJSONIndexes[e.source],r()},r}(VectorTileWorkerSource);module.exports=GeoJSONWorkerSource;
},{"../util/ajax":262,"./geojson_wrapper":104,"./vector_tile_worker_source":119,"geojson-rewind":14,"geojson-vt":18,"supercluster":32,"vt-pbf":37}],104:[function(_dereq_,module,exports){
"use strict";var Point=_dereq_("@mapbox/point-geometry"),toGeoJSON=_dereq_("@mapbox/vector-tile").VectorTileFeature.prototype.toGeoJSON,EXTENT=_dereq_("../data/extent"),FeatureWrapper=function(e){this._feature=e,this.extent=EXTENT,this.type=e.type,this.properties=e.tags,"id"in e&&!isNaN(e.id)&&(this.id=parseInt(e.id,10))};FeatureWrapper.prototype.loadGeometry=function(){var e=this;if(1===this._feature.type){for(var t=[],r=0,o=e._feature.geometry;r<o.length;r+=1){var a=o[r];t.push([new Point(a[0],a[1])])}return t}for(var i=[],p=0,n=e._feature.geometry;p<n.length;p+=1){for(var s=n[p],u=[],h=0,f=s;h<f.length;h+=1){var l=f[h];u.push(new Point(l[0],l[1]))}i.push(u)}return i},FeatureWrapper.prototype.toGeoJSON=function(e,t,r){return toGeoJSON.call(this,e,t,r)};var GeoJSONWrapper=function(e){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=EXTENT,this.length=e.length,this._features=e};GeoJSONWrapper.prototype.feature=function(e){return new FeatureWrapper(this._features[e])},module.exports=GeoJSONWrapper;
},{"../data/extent":56,"@mapbox/point-geometry":4,"@mapbox/vector-tile":8}],105:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),ref=_dereq_("./tile_id"),CanonicalTileID=ref.CanonicalTileID,LngLat=_dereq_("../geo/lng_lat"),Point=_dereq_("@mapbox/point-geometry"),Evented=_dereq_("../util/evented"),ajax=_dereq_("../util/ajax"),browser=_dereq_("../util/browser"),EXTENT=_dereq_("../data/extent"),ref$1=_dereq_("../data/array_types"),RasterBoundsArray=ref$1.RasterBoundsArray,rasterBoundsAttributes=_dereq_("../data/raster_bounds_attributes"),VertexArrayObject=_dereq_("../render/vertex_array_object"),Texture=_dereq_("../render/texture"),ImageSource=function(t){function e(e,r,o,i){t.call(this),this.id=e,this.dispatcher=o,this.coordinates=r.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this.setEventedParent(i),this.options=r}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.load=function(){var t=this;this.fire("dataloading",{dataType:"source"}),this.url=this.options.url,ajax.getImage(this.map._transformRequest(this.url,ajax.ResourceType.Image),function(e,r){e?t.fire("error",{error:e}):r&&(t.image=browser.getImageData(r),t._finishLoading())})},e.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire("data",{dataType:"source",sourceDataType:"metadata"}))},e.prototype.onAdd=function(t){this.map=t,this.load()},e.prototype.setCoordinates=function(t){this.coordinates=t;var e=this.map,r=t.map(function(t){return e.transform.locationCoordinate(LngLat.convert(t)).zoomTo(0)}),o=this.centerCoord=util.getCoordinatesCenter(r);o.column=Math.floor(o.column),o.row=Math.floor(o.row),this.tileID=new CanonicalTileID(o.zoom,o.column,o.row),this.minzoom=this.maxzoom=o.zoom;var i=r.map(function(t){var e=t.zoomTo(o.zoom);return new Point(Math.round((e.column-o.column)*EXTENT),Math.round((e.row-o.row)*EXTENT))});return this._boundsArray=new RasterBoundsArray,this._boundsArray.emplaceBack(i[0].x,i[0].y,0,0),this._boundsArray.emplaceBack(i[1].x,i[1].y,EXTENT,0),this._boundsArray.emplaceBack(i[3].x,i[3].y,0,EXTENT),this._boundsArray.emplaceBack(i[2].x,i[2].y,EXTENT,EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire("data",{dataType:"source",sourceDataType:"content"}),this},e.prototype.prepare=function(){var t=this;if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,r=e.gl;this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new VertexArrayObject),this.texture||(this.texture=new Texture(e,this.image,r.RGBA),this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE));for(var o in t.tiles){var i=t.tiles[o];"loaded"!==i.state&&(i.state="loaded",i.texture=t.texture)}}},e.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null))},e.prototype.serialize=function(){return{type:"image",url:this.options.url,coordinates:this.coordinates}},e.prototype.hasTransition=function(){return!1},e}(Evented);module.exports=ImageSource;
},{"../data/array_types":42,"../data/extent":56,"../data/raster_bounds_attributes":62,"../geo/lng_lat":65,"../render/texture":96,"../render/vertex_array_object":98,"../util/ajax":262,"../util/browser":263,"../util/evented":271,"../util/util":285,"./tile_id":117,"@mapbox/point-geometry":4}],106:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),ajax=_dereq_("../util/ajax"),browser=_dereq_("../util/browser"),normalizeURL=_dereq_("../util/mapbox").normalizeSourceURL;module.exports=function(r,e,o){var u=function(r,e){if(r)return o(r);if(e){var u=util.pick(e,["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds"]);e.vector_layers&&(u.vectorLayers=e.vector_layers,u.vectorLayerIds=u.vectorLayers.map(function(r){return r.id})),o(null,u)}};r.url?ajax.getJSON(e(normalizeURL(r.url),ajax.ResourceType.Source),u):browser.frame(function(){return u(null,r)})};
},{"../util/ajax":262,"../util/browser":263,"../util/mapbox":278,"../util/util":285}],107:[function(_dereq_,module,exports){
"use strict";var EXTENT=_dereq_("../data/extent");module.exports=function(e,t,r){return t*(EXTENT/(e.tileSize*Math.pow(2,r-e.tileID.overscaledZ)))};
},{"../data/extent":56}],108:[function(_dereq_,module,exports){
"use strict";function sortTilesIn(e,r){var a=e.tileID,n=r.tileID;return a.overscaledZ-n.overscaledZ||a.canonical.y-n.canonical.y||a.wrap-n.wrap||a.canonical.x-n.canonical.x}function mergeRenderedFeatureLayers(e){for(var r={},a={},n=0,t=e;n<t.length;n+=1){var u=t[n],l=u.queryResults,o=u.wrappedTileID,s=a[o]=a[o]||{};for(var i in l)for(var c=l[i],d=s[i]=s[i]||{},f=r[i]=r[i]||[],p=0,v=c;p<v.length;p+=1){var y=v[p];d[y.featureIndex]||(d[y.featureIndex]=!0,f.push(y.feature))}}return r}exports.rendered=function(e,r,a,n,t,u){var l=e.tilesIn(a);l.sort(sortTilesIn);for(var o=[],s=0,i=l;s<i.length;s+=1){var c=i[s];o.push({wrappedTileID:c.tileID.wrapped().key,queryResults:c.tile.queryRenderedFeatures(r,c.queryGeometry,c.scale,n,u,e.id)})}return mergeRenderedFeatureLayers(o)},exports.source=function(e,r){for(var a=e.getRenderableIds().map(function(r){return e.getTileByID(r)}),n=[],t={},u=0;u<a.length;u++){var l=a[u],o=l.tileID.canonical.key;t[o]||(t[o]=!0,l.querySourceFeatures(n,r))}return n};
},{}],109:[function(_dereq_,module,exports){
"use strict";var ajax=_dereq_("../util/ajax"),util=_dereq_("../util/util"),Evented=_dereq_("../util/evented"),normalizeURL=_dereq_("../util/mapbox").normalizeTileURL,browser=_dereq_("../util/browser"),ref=_dereq_("./tile_id"),OverscaledTileID=ref.OverscaledTileID,RasterTileSource=_dereq_("./raster_tile_source"),RasterDEMTileSource=function(e){function r(r,i,t,l){e.call(this,r,i,t,l),this.type="raster-dem",this.maxzoom=22,this._options=util.extend({},i)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.serialize=function(){return{type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds}},r.prototype.loadTile=function(e,r){function i(i,l){if(delete e.request,e.aborted)e.state="unloaded",r(null);else if(i)e.state="errored",r(i);else if(l){this.map._refreshExpiredTiles&&e.setExpiryData(l),delete l.cacheControl,delete l.expires;var a=browser.getImageData(l),s={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:a};e.workerID&&"expired"!==e.state||(e.workerID=this.dispatcher.send("loadDEMTile",s,t.bind(this)))}}function t(i,t){i&&(e.state="errored",r(i)),t&&(e.dem=t,e.needsHillshadePrepare=!0,e.state="loaded",r(null))}var l=normalizeURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=ajax.getImage(this.map._transformRequest(l,ajax.ResourceType.Tile),i.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID)},r.prototype._getNeighboringTiles=function(e){var r=e.canonical,i=Math.pow(2,r.z),t=(r.x-1+i)%i,l=0===r.x?e.wrap-1:e.wrap,a=(r.x+1+i)%i,s=r.x+1===i?e.wrap+1:e.wrap,o={};return o[new OverscaledTileID(e.overscaledZ,l,r.z,t,r.y).key]={backfilled:!1},o[new OverscaledTileID(e.overscaledZ,s,r.z,a,r.y).key]={backfilled:!1},r.y>0&&(o[new OverscaledTileID(e.overscaledZ,l,r.z,t,r.y-1).key]={backfilled:!1},o[new OverscaledTileID(e.overscaledZ,e.wrap,r.z,r.x,r.y-1).key]={backfilled:!1},o[new OverscaledTileID(e.overscaledZ,s,r.z,a,r.y-1).key]={backfilled:!1}),r.y+1<i&&(o[new OverscaledTileID(e.overscaledZ,l,r.z,t,r.y+1).key]={backfilled:!1},o[new OverscaledTileID(e.overscaledZ,e.wrap,r.z,r.x,r.y+1).key]={backfilled:!1},o[new OverscaledTileID(e.overscaledZ,s,r.z,a,r.y+1).key]={backfilled:!1}),o},r.prototype.unloadTile=function(e){e.demTexture&&this.map.painter.saveTileTexture(e.demTexture),e.fbo&&(e.fbo.destroy(),delete e.fbo),e.dem&&delete e.dem,delete e.neighboringTiles,e.state="unloaded",this.dispatcher.send("removeDEMTile",{uid:e.uid,source:this.id},void 0,e.workerID)},r}(RasterTileSource);module.exports=RasterDEMTileSource;
},{"../util/ajax":262,"../util/browser":263,"../util/evented":271,"../util/mapbox":278,"../util/util":285,"./raster_tile_source":111,"./tile_id":117}],110:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../data/dem_data"),DEMData=ref.DEMData,RasterDEMTileWorkerSource=function(){this.loading={},this.loaded={}};RasterDEMTileWorkerSource.prototype.loadTile=function(e,a){var o=e.source,r=e.uid;this.loading[o]||(this.loading[o]={});var t=new DEMData(r);this.loading[o][r]=t,t.loadFromImage(e.rawImageData),delete this.loading[o][r],this.loaded[o]=this.loaded[o]||{},this.loaded[o][r]=t,a(null,t)},RasterDEMTileWorkerSource.prototype.removeTile=function(e){var a=this.loaded[e.source],o=e.uid;a&&a[o]&&delete a[o]},module.exports=RasterDEMTileWorkerSource;
},{"../data/dem_data":55}],111:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),ajax=_dereq_("../util/ajax"),Evented=_dereq_("../util/evented"),loadTileJSON=_dereq_("./load_tilejson"),normalizeURL=_dereq_("../util/mapbox").normalizeTileURL,TileBounds=_dereq_("./tile_bounds"),Texture=_dereq_("../render/texture"),RasterTileSource=function(e){function t(t,i,r,o){e.call(this),this.id=t,this.dispatcher=r,this.setEventedParent(o),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=util.extend({},i),util.extend(this,util.pick(i,["url","scheme","tileSize"]))}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.load=function(){var e=this;this.fire("dataloading",{dataType:"source"}),loadTileJSON(this._options,this.map._transformRequest,function(t,i){t?e.fire("error",t):i&&(util.extend(e,i),i.bounds&&(e.tileBounds=new TileBounds(i.bounds,e.minzoom,e.maxzoom)),e.fire("data",{dataType:"source",sourceDataType:"metadata"}),e.fire("data",{dataType:"source",sourceDataType:"content"}))})},t.prototype.onAdd=function(e){this.map=e,this.load()},t.prototype.serialize=function(){return util.extend({},this._options)},t.prototype.hasTile=function(e){return!this.tileBounds||this.tileBounds.contains(e.canonical)},t.prototype.loadTile=function(e,t){var i=this,r=normalizeURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url,this.tileSize);e.request=ajax.getImage(this.map._transformRequest(r,ajax.ResourceType.Tile),function(r,o){if(delete e.request,e.aborted)e.state="unloaded",t(null);else if(r)e.state="errored",t(r);else if(o){i.map._refreshExpiredTiles&&e.setExpiryData(o),delete o.cacheControl,delete o.expires;var a=i.map.painter.context,n=a.gl;e.texture=i.map.painter.getTileTexture(o.width),e.texture?(e.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE,n.LINEAR_MIPMAP_NEAREST),n.texSubImage2D(n.TEXTURE_2D,0,0,0,n.RGBA,n.UNSIGNED_BYTE,o)):(e.texture=new Texture(a,o,n.RGBA),e.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE,n.LINEAR_MIPMAP_NEAREST),a.extTextureFilterAnisotropic&&n.texParameterf(n.TEXTURE_2D,a.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,a.extTextureFilterAnisotropicMax)),n.generateMipmap(n.TEXTURE_2D),e.state="loaded",t(null)}})},t.prototype.abortTile=function(e,t){e.request&&(e.request.abort(),delete e.request),t()},t.prototype.unloadTile=function(e,t){e.texture&&this.map.painter.saveTileTexture(e.texture),t()},t.prototype.hasTransition=function(){return!1},t}(Evented);module.exports=RasterTileSource;
},{"../render/texture":96,"../util/ajax":262,"../util/evented":271,"../util/mapbox":278,"../util/util":285,"./load_tilejson":106,"./tile_bounds":116}],112:[function(_dereq_,module,exports){
"use strict";var ajax=_dereq_("../util/ajax"),Evented=_dereq_("../util/evented"),window=_dereq_("../util/window"),pluginRequested=!1,pluginBlobURL=null;module.exports.evented=new Evented,module.exports.registerForPluginAvailability=function(e){return pluginBlobURL?e({pluginBlobURL:pluginBlobURL,errorCallback:module.exports.errorCallback}):module.exports.evented.once("pluginAvailable",e),e},module.exports.createBlobURL=function(e){return window.URL.createObjectURL(new window.Blob([e.data],{type:"text/javascript"}))},module.exports.clearRTLTextPlugin=function(){pluginRequested=!1,pluginBlobURL=null},module.exports.setRTLTextPlugin=function(e,l){if(pluginRequested)throw new Error("setRTLTextPlugin cannot be called multiple times.");pluginRequested=!0,module.exports.errorCallback=l,ajax.getArrayBuffer({url:e},function(e,t){e?l(e):t&&(pluginBlobURL=module.exports.createBlobURL(t),module.exports.evented.fire("pluginAvailable",{pluginBlobURL:pluginBlobURL,errorCallback:l}))})},module.exports.applyArabicShaping=null,module.exports.processBidirectionalText=null;
},{"../util/ajax":262,"../util/evented":271,"../util/window":265}],113:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),sourceTypes={vector:_dereq_("../source/vector_tile_source"),raster:_dereq_("../source/raster_tile_source"),"raster-dem":_dereq_("../source/raster_dem_tile_source"),geojson:_dereq_("../source/geojson_source"),video:_dereq_("../source/video_source"),image:_dereq_("../source/image_source"),canvas:_dereq_("../source/canvas_source")};exports.create=function(e,r,o,s){var u=new sourceTypes[r.type](e,r,o,s);if(u.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+u.id);return util.bindAll(["load","abort","unload","serialize","prepare"],u),u},exports.getType=function(e){return sourceTypes[e]},exports.setType=function(e,r){sourceTypes[e]=r};
},{"../source/canvas_source":101,"../source/geojson_source":102,"../source/image_source":105,"../source/raster_dem_tile_source":109,"../source/raster_tile_source":111,"../source/vector_tile_source":118,"../source/video_source":120,"../util/util":285}],114:[function(_dereq_,module,exports){
"use strict";function coordinateToTilePoint(e,t){var i=t.zoomTo(e.canonical.z);return new Point((i.column-(e.canonical.x+e.wrap*Math.pow(2,e.canonical.z)))*EXTENT,(i.row-e.canonical.y)*EXTENT)}function isRasterType(e){return"raster"===e||"image"===e||"video"===e}var createSource=_dereq_("./source").create,Tile=_dereq_("./tile"),Evented=_dereq_("../util/evented"),Cache=_dereq_("../util/lru_cache"),Coordinate=_dereq_("../geo/coordinate"),util=_dereq_("../util/util"),EXTENT=_dereq_("../data/extent"),Context=_dereq_("../gl/context"),Point=_dereq_("@mapbox/point-geometry"),browser=_dereq_("../util/browser"),ref=_dereq_("./tile_id"),OverscaledTileID=ref.OverscaledTileID,SourceCache=function(e){function t(t,i,r){var o=this;e.call(this),this.id=t,this.dispatcher=r,this.on("data",function(e){"source"===e.dataType&&"metadata"===e.sourceDataType&&(o._sourceLoaded=!0),o._sourceLoaded&&!o._paused&&"source"===e.dataType&&"content"===e.sourceDataType&&(o.reload(),o.transform&&o.update(o.transform))}),this.on("error",function(){o._sourceErrored=!0}),this._source=createSource(t,i,r,this),this._tiles={},this._cache=new Cache(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._isIdRenderable=this._isIdRenderable.bind(this),this._coveredTiles={}}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.onAdd=function(e){this.map=e,this._maxTileCacheSize=e?e._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(e)},t.prototype.onRemove=function(e){this._source&&this._source.onRemove&&this._source.onRemove(e)},t.prototype.loaded=function(){var e=this;if(this._sourceErrored)return!0;if(!this._sourceLoaded)return!1;for(var t in e._tiles){var i=e._tiles[t];if("loaded"!==i.state&&"errored"!==i.state)return!1}return!0},t.prototype.getSource=function(){return this._source},t.prototype.pause=function(){this._paused=!0},t.prototype.getNeedsFullPlacement=function(){return this._needsFullPlacement},t.prototype.resume=function(){if(this._paused){var e=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,e&&this.reload(),this.transform&&this.update(this.transform)}},t.prototype._loadTile=function(e,t){return this._source.loadTile(e,t)},t.prototype._unloadTile=function(e){if(this._source.unloadTile)return this._source.unloadTile(e,function(){})},t.prototype._abortTile=function(e){if(this._source.abortTile)return this._source.abortTile(e,function(){})},t.prototype.serialize=function(){return this._source.serialize()},t.prototype.prepare=function(e){var t=this;this._source.prepare&&this._source.prepare();for(var i in t._tiles)t._tiles[i].upload(e)},t.prototype.getIds=function(){var e=this,t=function(t,i){var r=e._tiles[t].tileID,o=e._tiles[i].tileID,a=new Point(r.canonical.x,r.canonical.y).rotate(e.transform.angle),s=new Point(o.canonical.x,o.canonical.y).rotate(e.transform.angle);return r.overscaledZ-o.overscaledZ||s.y-a.y||s.x-a.x};return Object.keys(this._tiles).map(Number).sort(t)},t.prototype.getRenderableIds=function(){return this.getIds().filter(this._isIdRenderable)},t.prototype.hasRenderableParent=function(e){var t=this.findLoadedParent(e,0,{});return!!t&&this._isIdRenderable(t.tileID.key)},t.prototype._isIdRenderable=function(e){return this._tiles[e]&&this._tiles[e].hasData()&&!this._coveredTiles[e]},t.prototype.reload=function(){var e=this;if(this._paused)return void(this._shouldReloadOnResume=!0);this._cache.reset();for(var t in e._tiles)e._reloadTile(t,"reloading")},t.prototype._reloadTile=function(e,t){var i=this._tiles[e];i&&("loading"!==i.state&&(i.state=t),this._loadTile(i,this._tileLoaded.bind(this,i,e,t)))},t.prototype._tileLoaded=function(e,t,i,r){if(r)return e.state="errored",void(404!==r.status?this._source.fire("error",{tile:e,error:r}):this.update(this.transform));e.timeAdded=browser.now(),"expired"===i&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(t,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._source.fire("data",{dataType:"source",tile:e,coord:e.tileID}),this.map&&(this.map.painter.tileExtentVAO.vao=null),this._updatePlacement(),this.map&&this.getTileByID(t)&&e.added(this.map.painter.crossTileSymbolIndex)},t.prototype._backfillDEM=function(e){function t(e,t){e.needsHillshadePrepare=!0;var i=t.tileID.canonical.x-e.tileID.canonical.x,r=t.tileID.canonical.y-e.tileID.canonical.y,o=Math.pow(2,e.tileID.canonical.z),a=t.tileID.key;0===i&&0===r||Math.abs(r)>1||(Math.abs(i)>1&&(1===Math.abs(i+o)?i+=o:1===Math.abs(i-o)&&(i-=o)),t.dem&&e.dem&&(e.dem.backfillBorder(t.dem,i,r),e.neighboringTiles&&e.neighboringTiles[a]&&(e.neighboringTiles[a].backfilled=!0)))}for(var i=this,r=this.getRenderableIds(),o=0;o<r.length;o++){var a=r[o];if(e.neighboringTiles&&e.neighboringTiles[a]){var s=i.getTileByID(a);t(e,s),t(s,e)}}},t.prototype.getTile=function(e){return this.getTileByID(e.key)},t.prototype.getTileByID=function(e){return this._tiles[e]},t.prototype.getZoom=function(e){return e.zoom+e.scaleZoom(e.tileSize/this._source.tileSize)},t.prototype._findLoadedChildren=function(e,t,i){var r=this,o=!1;for(var a in r._tiles){var s=r._tiles[a];if(!(i[a]||!s.hasData()||s.tileID.overscaledZ<=e.overscaledZ||s.tileID.overscaledZ>t)){var n=Math.pow(2,s.tileID.canonical.z-e.canonical.z);if(Math.floor(s.tileID.canonical.x/n)===e.canonical.x&&Math.floor(s.tileID.canonical.y/n)===e.canonical.y)for(i[a]=s.tileID,o=!0;s&&s.tileID.overscaledZ-1>e.overscaledZ;){var l=s.tileID.scaledTo(s.tileID.overscaledZ-1);if(!l)break;s=r._tiles[l.key],s&&s.hasData()&&(delete i[a],i[l.key]=l)}}}return o},t.prototype.findLoadedParent=function(e,t,i){for(var r=this,o=e.overscaledZ-1;o>=t;o--){var a=e.scaledTo(o);if(!a)return;var s=String(a.key),n=r._tiles[s];if(n&&n.hasData())return i[s]=a,n;if(r._cache.has(s))return i[s]=a,r._cache.get(s)}},t.prototype.updateCacheSize=function(e){var t=Math.ceil(e.width/this._source.tileSize)+1,i=Math.ceil(e.height/this._source.tileSize)+1,r=t*i,o=Math.floor(5*r),a="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,o):o;this._cache.setMaxSize(a)},t.prototype.update=function(e){var i=this;if(this.transform=e,this._sourceLoaded&&!this._paused){this.updateCacheSize(e),this._coveredTiles={};var r;this.used?this._source.tileID?r=e.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e){return new OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)}):(r=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(r=r.filter(function(e){return i._source.hasTile(e)}))):r=[];var o=(this._source.roundZoom?Math.round:Math.floor)(this.getZoom(e)),a=Math.max(o-t.maxOverzooming,this._source.minzoom),s=Math.max(o+t.maxUnderzooming,this._source.minzoom),n=this._updateRetainedTiles(r,o),l={};if(isRasterType(this._source.type))for(var c=Object.keys(n),h=0;h<c.length;h++){var d=c[h],u=n[d],_=i._tiles[d];if(_&&(void 0===_.fadeEndTime||_.fadeEndTime>=browser.now())){i._findLoadedChildren(u,s,n)&&(n[d]=u);var p=i.findLoadedParent(u,a,l);p&&i._addTile(p.tileID)}}var m;for(m in l)n[m]||(i._coveredTiles[m]=!0);for(m in l)n[m]=l[m];for(var f=util.keysDifference(this._tiles,n),T=0;T<f.length;T++)i._removeTile(f[T])}},t.prototype._updateRetainedTiles=function(e,i){for(var r=this,o={},a={},s=Math.max(i-t.maxOverzooming,this._source.minzoom),n=Math.max(i+t.maxUnderzooming,this._source.minzoom),l=0;l<e.length;l++){var c=e[l],h=r._addTile(c),d=!1;if(h.hasData())o[c.key]=c;else{d=h.wasRequested(),o[c.key]=c;var u=!0;if(i+1>r._source.maxzoom){var _=c.children(r._source.maxzoom)[0],p=r.getTile(_);p&&p.hasData()?o[_.key]=_:u=!1}else{r._findLoadedChildren(c,n,o);for(var m=c.children(r._source.maxzoom),f=0;f<m.length;f++)if(!o[m[f].key]){u=!1;break}}if(!u)for(var T=c.overscaledZ-1;T>=s;--T){var v=c.scaledTo(T);if(a[v.key])break;if(a[v.key]=!0,h=r.getTile(v),!h&&d&&(h=r._addTile(v)),h&&(o[v.key]=v,d=h.wasRequested(),h.hasData()))break}}}return o},t.prototype._addTile=function(e){var t=this._tiles[e.key];if(t)return t;(t=this._cache.getAndRemove(e.key))&&(this._updatePlacement(),this.map&&t.added(this.map.painter.crossTileSymbolIndex),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,t)));var i=Boolean(t);return i||(t=new Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(t,this._tileLoaded.bind(this,t,e.key,t.state))),t?(t.uses++,this._tiles[e.key]=t,i||this._source.fire("dataloading",{tile:t,coord:t.tileID,dataType:"source"}),t):null},t.prototype._setTileReloadTimer=function(e,t){var i=this,r=t.getExpiryTimeout();r&&(this._timers[e]=setTimeout(function(){i._reloadTile(e,"expired"),delete i._timers[e]},r))},t.prototype._setCacheInvalidationTimer=function(e,t){var i=this,r=t.getExpiryTimeout();r&&(this._cacheTimers[e]=setTimeout(function(){i._cache.remove(e),delete i._cacheTimers[e]},r))},t.prototype._removeTile=function(e){var t=this._tiles[e];if(t&&(t.uses--,delete this._tiles[e],this._timers[e]&&(clearTimeout(this._timers[e]),delete this._timers[e]),!(t.uses>0)))if(this._updatePlacement(),this.map&&t.removed(this.map.painter.crossTileSymbolIndex),t.hasData()){t.tileID=t.tileID.wrapped();var i=t.tileID.key;this._cache.add(i,t),this._setCacheInvalidationTimer(i,t)}else t.aborted=!0,this._abortTile(t),this._unloadTile(t)},t.prototype._updatePlacement=function(){this._needsFullPlacement=!0},t.prototype.clearTiles=function(){var e=this;this._shouldReloadOnResume=!1,this._paused=!1;for(var t in e._tiles)e._removeTile(t);this._cache.reset()},t.prototype.tilesIn=function(e){for(var t=this,i=[],r=this.getIds(),o=1/0,a=1/0,s=-1/0,n=-1/0,l=e[0].zoom,c=0;c<e.length;c++){var h=e[c];o=Math.min(o,h.column),a=Math.min(a,h.row),s=Math.max(s,h.column),n=Math.max(n,h.row)}for(var d=0;d<r.length;d++){var u=t._tiles[r[d]],_=u.tileID,p=[coordinateToTilePoint(_,new Coordinate(o,a,l)),coordinateToTilePoint(_,new Coordinate(s,n,l))];if(p[0].x<EXTENT&&p[0].y<EXTENT&&p[1].x>=0&&p[1].y>=0){for(var m=[],f=0;f<e.length;f++)m.push(coordinateToTilePoint(_,e[f]));i.push({tile:u,tileID:_,queryGeometry:[m],scale:Math.pow(2,t.transform.zoom-u.tileID.overscaledZ)})}}return i},t.prototype.commitPlacement=function(e,t){var i=this;this._needsFullPlacement=!1;for(var r=this.getIds(),o=0;o<r.length;o++){i.getTileByID(r[o]).commitPlacement(e,t,i.transform.angle)}},t.prototype.getVisibleCoordinates=function(){for(var e=this,t=this.getRenderableIds().map(function(t){return e._tiles[t].tileID}),i=0,r=t;i<r.length;i+=1){var o=r[i];o.posMatrix=e.transform.calculatePosMatrix(o.toUnwrapped())}return t},t.prototype.hasTransition=function(){var e=this;if(this._source.hasTransition())return!0;if(isRasterType(this._source.type))for(var t in e._tiles){var i=e._tiles[t];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=browser.now())return!0}return!1},t}(Evented);SourceCache.maxOverzooming=10,SourceCache.maxUnderzooming=3,module.exports=SourceCache;
},{"../data/extent":56,"../geo/coordinate":64,"../gl/context":69,"../util/browser":263,"../util/evented":271,"../util/lru_cache":277,"../util/util":285,"./source":113,"./tile":115,"./tile_id":117,"@mapbox/point-geometry":4}],115:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),deserializeBucket=_dereq_("../data/bucket").deserialize,SymbolBucket=_dereq_("../data/bucket/symbol_bucket"),FeatureIndex=_dereq_("../data/feature_index"),vt=_dereq_("@mapbox/vector-tile"),Protobuf=_dereq_("pbf"),GeoJSONFeature=_dereq_("../util/vectortile_to_geojson"),featureFilter=_dereq_("../style-spec/feature_filter"),CollisionIndex=_dereq_("../symbol/collision_index"),ref=_dereq_("../data/array_types"),RasterBoundsArray=ref.RasterBoundsArray,CollisionBoxArray=ref.CollisionBoxArray,rasterBoundsAttributes=_dereq_("../data/raster_bounds_attributes"),EXTENT=_dereq_("../data/extent"),Point=_dereq_("@mapbox/point-geometry"),Texture=_dereq_("../render/texture"),ref$1=_dereq_("../data/segment"),SegmentVector=ref$1.SegmentVector,ref$2=_dereq_("../data/index_array_type"),TriangleIndexArray=ref$2.TriangleIndexArray,projection=_dereq_("../symbol/projection"),ref$3=_dereq_("../symbol/symbol_placement"),performSymbolPlacement=ref$3.performSymbolPlacement,updateOpacities=ref$3.updateOpacities,pixelsToTileUnits=_dereq_("../source/pixels_to_tile_units"),browser=_dereq_("../util/browser"),CLOCK_SKEW_RETRY_TIMEOUT=3e4,Tile=function(e,t){this.tileID=e,this.uid=util.uniqueId(),this.uses=0,this.tileSize=t,this.buckets={},this.expirationTime=null,this.expiredRequestCount=0,this.state="loading"};Tile.prototype.registerFadeDuration=function(e){var t=e+this.timeAdded;t<browser.now()||this.fadeEndTime&&t<this.fadeEndTime||(this.fadeEndTime=t)},Tile.prototype.wasRequested=function(){return"errored"===this.state||"loaded"===this.state||"reloading"===this.state},Tile.prototype.loadVectorData=function(e,t){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",!e)return void(this.collisionBoxArray=new CollisionBoxArray);e.rawTileData&&(this.rawTileData=e.rawTileData),this.collisionBoxArray=e.collisionBoxArray,this.featureIndex=e.featureIndex,this.featureIndex.rawTileData=this.rawTileData,this.buckets=deserializeBucket(e.buckets,t.style),e.iconAtlasImage&&(this.iconAtlasImage=e.iconAtlasImage),e.glyphAtlasImage&&(this.glyphAtlasImage=e.glyphAtlasImage)},Tile.prototype.unloadVectorData=function(){var e=this;"reloading"===this.state&&(this.justReloaded=!0);for(var t in e.buckets)e.buckets[t].destroy();this.buckets={},this.iconAtlasTexture&&this.iconAtlasTexture.destroy(),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.collisionBoxArray=null,this.featureIndex=null,this.state="unloaded"},Tile.prototype.unloadDEMData=function(){this.dem=null,this.neighboringTiles=null,this.state="unloaded"},Tile.prototype.added=function(e){var t=this;for(var i in t.buckets){var r=t.buckets[i];r instanceof SymbolBucket&&e.addTileLayer(i,t.tileID,r.symbolInstances)}},Tile.prototype.removed=function(e){var t=this;for(var i in t.buckets){t.buckets[i]instanceof SymbolBucket&&e.removeTileLayer(i,t.tileID)}},Tile.prototype.placeLayer=function(e,t,i,r){var a=this.getBucket(i),s=this.collisionBoxArray;if(a&&a instanceof SymbolBucket&&s){var o=t.transform.calculatePosMatrix(this.tileID.toUnwrapped()),n="map"===a.layers[0].layout.get("text-pitch-alignment"),l=EXTENT/this.tileSize,u=pixelsToTileUnits(this,1,t.transform.zoom),h=projection.getLabelPlaneMatrix(o,n,!0,t.transform,u);performSymbolPlacement(a,t,e,t.transform.zoom,l,o,h,this.tileID.key,r,s)}},Tile.prototype.commitPlacement=function(e,t,i){var r=this;for(var a in r.buckets){var s=r.buckets[a];s instanceof SymbolBucket&&(updateOpacities(s,t,r.justReloaded),s.sortFeatures(i))}this.featureIndex&&this.featureIndex.setCollisionIndex(e),this.justReloaded=!1},Tile.prototype.getBucket=function(e){return this.buckets[e.id]},Tile.prototype.upload=function(e){var t=this;for(var i in t.buckets){var r=t.buckets[i];r.uploaded||(r.upload(e),r.uploaded=!0)}var a=e.gl;this.iconAtlasImage&&(this.iconAtlasTexture=new Texture(e,this.iconAtlasImage,a.RGBA),this.iconAtlasImage=null),this.glyphAtlasImage&&(this.glyphAtlasTexture=new Texture(e,this.glyphAtlasImage,a.ALPHA),this.glyphAtlasImage=null)},Tile.prototype.queryRenderedFeatures=function(e,t,i,r,a,s){var o=this;if(!this.featureIndex||!this.collisionBoxArray)return{};var n=0;for(var l in e){var u=o.getBucket(e[l]);u&&(n=Math.max(n,e[l].queryRadius(u)))}return this.featureIndex.query({queryGeometry:t,scale:i,tileSize:this.tileSize,bearing:a,params:r,additionalRadius:n,collisionBoxArray:this.collisionBoxArray,sourceID:s},e)},Tile.prototype.querySourceFeatures=function(e,t){var i=this;if(this.rawTileData){this.vtLayers||(this.vtLayers=new vt.VectorTile(new Protobuf(this.rawTileData)).layers);var r=t?t.sourceLayer:"",a=this.vtLayers._geojsonTileLayer||this.vtLayers[r];if(a)for(var s=featureFilter(t&&t.filter),o={z:this.tileID.overscaledZ,x:this.tileID.canonical.x,y:this.tileID.canonical.y},n=0;n<a.length;n++){var l=a.feature(n);if(s({zoom:i.tileID.overscaledZ},l)){var u=new GeoJSONFeature(l,o.z,o.x,o.y);u.tile=o,e.push(u)}}}},Tile.prototype.clearMask=function(){this.segments&&(this.segments.destroy(),delete this.segments),this.maskedBoundsBuffer&&(this.maskedBoundsBuffer.destroy(),delete this.maskedBoundsBuffer),this.maskedIndexBuffer&&(this.maskedIndexBuffer.destroy(),delete this.maskedIndexBuffer)},Tile.prototype.setMask=function(e,t){var i=this;if(!util.deepEqual(this.mask,e)&&(this.mask=e,this.clearMask(),!util.deepEqual(e,{0:!0}))){var r=new RasterBoundsArray,a=new TriangleIndexArray;this.segments=new SegmentVector,this.segments.prepareSegment(0,r,a);for(var s=Object.keys(e),o=0;o<s.length;o++){var n=e[s[o]],l=EXTENT>>n.z,u=new Point(n.x*l,n.y*l),h=new Point(u.x+l,u.y+l),d=i.segments.prepareSegment(4,r,a);r.emplaceBack(u.x,u.y,u.x,u.y),r.emplaceBack(h.x,u.y,h.x,u.y),r.emplaceBack(u.x,h.y,u.x,h.y),r.emplaceBack(h.x,h.y,h.x,h.y);var c=d.vertexLength;a.emplaceBack(c,c+1,c+2),a.emplaceBack(c+1,c+2,c+3),d.vertexLength+=4,d.primitiveLength+=2}this.maskedBoundsBuffer=t.createVertexBuffer(r,rasterBoundsAttributes.members),this.maskedIndexBuffer=t.createIndexBuffer(a)}},Tile.prototype.hasData=function(){return"loaded"===this.state||"reloading"===this.state||"expired"===this.state},Tile.prototype.setExpiryData=function(e){var t=this.expirationTime;if(e.cacheControl){var i=util.parseCacheControl(e.cacheControl);i["max-age"]&&(this.expirationTime=Date.now()+1e3*i["max-age"])}else e.expires&&(this.expirationTime=new Date(e.expires).getTime());if(this.expirationTime){var r=Date.now(),a=!1;if(this.expirationTime>r)a=!1;else if(t)if(this.expirationTime<t)a=!0;else{var s=this.expirationTime-t;s?this.expirationTime=r+Math.max(s,CLOCK_SKEW_RETRY_TIMEOUT):a=!0}else a=!0;a?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0}},Tile.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},module.exports=Tile;
},{"../data/array_types":42,"../data/bucket":43,"../data/bucket/symbol_bucket":54,"../data/extent":56,"../data/feature_index":57,"../data/index_array_type":58,"../data/raster_bounds_attributes":62,"../data/segment":63,"../render/texture":96,"../source/pixels_to_tile_units":107,"../style-spec/feature_filter":151,"../symbol/collision_index":228,"../symbol/projection":234,"../symbol/symbol_placement":238,"../util/browser":263,"../util/util":285,"../util/vectortile_to_geojson":286,"@mapbox/point-geometry":4,"@mapbox/vector-tile":8,"pbf":29}],116:[function(_dereq_,module,exports){
"use strict";var LngLatBounds=_dereq_("../geo/lng_lat_bounds"),clamp=_dereq_("../util/util").clamp,TileBounds=function(t,n,o){this.bounds=LngLatBounds.convert(this.validateBounds(t)),this.minzoom=n||0,this.maxzoom=o||24};TileBounds.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},TileBounds.prototype.contains=function(t){var n={minX:Math.floor(this.lngX(this.bounds.getWest(),t.z)),minY:Math.floor(this.latY(this.bounds.getNorth(),t.z)),maxX:Math.ceil(this.lngX(this.bounds.getEast(),t.z)),maxY:Math.ceil(this.latY(this.bounds.getSouth(),t.z))};return t.x>=n.minX&&t.x<n.maxX&&t.y>=n.minY&&t.y<n.maxY},TileBounds.prototype.lngX=function(t,n){return(t+180)*(Math.pow(2,n)/360)},TileBounds.prototype.latY=function(t,n){var o=clamp(Math.sin(Math.PI/180*t),-.9999,.9999),a=Math.pow(2,n)/(2*Math.PI);return Math.pow(2,n-1)+.5*Math.log((1+o)/(1-o))*-a},module.exports=TileBounds;
},{"../geo/lng_lat_bounds":66,"../util/util":285}],117:[function(_dereq_,module,exports){
"use strict";function calculateKey(e,i,a,t){(e*=2)<0&&(e=-1*e-1);var n=1<<i;return 32*(n*n*e+n*t+a)+i}function getQuadkey(e,i,a){for(var t,n="",c=e;c>0;c--)t=1<<c-1,n+=(i&t?1:0)+(a&t?2:0);return n}var WhooTS=_dereq_("@mapbox/whoots-js"),ref=_dereq_("../util/web_worker_transfer"),register=ref.register,Coordinate=_dereq_("../geo/coordinate"),CanonicalTileID=function(e,i,a){this.z=e,this.x=i,this.y=a,this.key=calculateKey(0,e,i,a)};CanonicalTileID.prototype.equals=function(e){return this.z===e.z&&this.x===e.x&&this.y===e.y},CanonicalTileID.prototype.url=function(e,i){var a=WhooTS.getTileBBox(this.x,this.y,this.z),t=getQuadkey(this.z,this.x,this.y);return e[(this.x+this.y)%e.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===i?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",t).replace("{bbox-epsg-3857}",a)};var UnwrappedTileID=function(e,i){this.wrap=e,this.canonical=i,this.key=calculateKey(e,i.z,i.x,i.y)},OverscaledTileID=function(e,i,a,t,n){this.overscaledZ=e,this.wrap=i,this.canonical=new CanonicalTileID(a,+t,+n),this.key=calculateKey(i,e,t,n)};OverscaledTileID.prototype.scaledTo=function(e){var i=this.canonical.z-e;return e>this.canonical.z?new OverscaledTileID(e,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new OverscaledTileID(e,this.wrap,e,this.canonical.x>>i,this.canonical.y>>i)},OverscaledTileID.prototype.isChildOf=function(e){var i=this.canonical.z-e.canonical.z;return 0===e.overscaledZ||e.overscaledZ<this.overscaledZ&&e.canonical.x===this.canonical.x>>i&&e.canonical.y===this.canonical.y>>i},OverscaledTileID.prototype.children=function(e){if(this.overscaledZ>=e)return[new OverscaledTileID(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var i=this.canonical.z+1,a=2*this.canonical.x,t=2*this.canonical.y;return[new OverscaledTileID(i,this.wrap,i,a,t),new OverscaledTileID(i,this.wrap,i,a+1,t),new OverscaledTileID(i,this.wrap,i,a,t+1),new OverscaledTileID(i,this.wrap,i,a+1,t+1)]},OverscaledTileID.prototype.isLessThan=function(e){return this.wrap<e.wrap||!(this.wrap>e.wrap)&&(this.overscaledZ<e.overscaledZ||!(this.overscaledZ>e.overscaledZ)&&(this.canonical.x<e.canonical.x||!(this.canonical.x>e.canonical.x)&&this.canonical.y<e.canonical.y))},OverscaledTileID.prototype.wrapped=function(){return new OverscaledTileID(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},OverscaledTileID.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},OverscaledTileID.prototype.toUnwrapped=function(){return new UnwrappedTileID(this.wrap,this.canonical)},OverscaledTileID.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},OverscaledTileID.prototype.toCoordinate=function(){return new Coordinate(this.canonical.x+Math.pow(2,this.wrap),this.canonical.y,this.canonical.z)},register("CanonicalTileID",CanonicalTileID),register("OverscaledTileID",OverscaledTileID,{omit:["posMatrix"]}),module.exports={CanonicalTileID:CanonicalTileID,OverscaledTileID:OverscaledTileID,UnwrappedTileID:UnwrappedTileID};
},{"../geo/coordinate":64,"../util/web_worker_transfer":288,"@mapbox/whoots-js":12}],118:[function(_dereq_,module,exports){
"use strict";var Evented=_dereq_("../util/evented"),util=_dereq_("../util/util"),loadTileJSON=_dereq_("./load_tilejson"),normalizeURL=_dereq_("../util/mapbox").normalizeTileURL,TileBounds=_dereq_("./tile_bounds"),ResourceType=_dereq_("../util/ajax").ResourceType,browser=_dereq_("../util/browser"),VectorTileSource=function(e){function t(t,i,o,r){if(e.call(this),this.id=t,this.dispatcher=o,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,util.extend(this,util.pick(i,["url","scheme","tileSize"])),this._options=util.extend({type:"vector"},i),512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(r)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.load=function(){var e=this;this.fire("dataloading",{dataType:"source"}),loadTileJSON(this._options,this.map._transformRequest,function(t,i){t?e.fire("error",t):i&&(util.extend(e,i),i.bounds&&(e.tileBounds=new TileBounds(i.bounds,e.minzoom,e.maxzoom)),e.fire("data",{dataType:"source",sourceDataType:"metadata"}),e.fire("data",{dataType:"source",sourceDataType:"content"}))})},t.prototype.hasTile=function(e){return!this.tileBounds||this.tileBounds.contains(e.canonical)},t.prototype.onAdd=function(e){this.map=e,this.load()},t.prototype.serialize=function(){return util.extend({},this._options)},t.prototype.loadTile=function(e,t){function i(i,o){return e.aborted?t(null):i?t(i):(this.map._refreshExpiredTiles&&e.setExpiryData(o),e.loadVectorData(o,this.map.painter),t(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}var o=e.tileID.overscaleFactor(),r=normalizeURL(e.tileID.canonical.url(this.tiles,this.scheme),this.url),s={request:this.map._transformRequest(r,ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*o,type:this.type,source:this.id,pixelRatio:browser.devicePixelRatio,overscaling:o,showCollisionBoxes:this.map.showCollisionBoxes};void 0===e.workerID||"expired"===e.state?e.workerID=this.dispatcher.send("loadTile",s,i.bind(this)):"loading"===e.state?e.reloadCallback=t:this.dispatcher.send("reloadTile",s,i.bind(this),e.workerID)},t.prototype.abortTile=function(e){this.dispatcher.send("abortTile",{uid:e.uid,type:this.type,source:this.id},void 0,e.workerID)},t.prototype.unloadTile=function(e){e.unloadVectorData(),this.dispatcher.send("removeTile",{uid:e.uid,type:this.type,source:this.id},void 0,e.workerID)},t.prototype.hasTransition=function(){return!1},t}(Evented);module.exports=VectorTileSource;
},{"../util/ajax":262,"../util/browser":263,"../util/evented":271,"../util/mapbox":278,"../util/util":285,"./load_tilejson":106,"./tile_bounds":116}],119:[function(_dereq_,module,exports){
"use strict";function loadVectorTile(e,r){var o=ajax.getArrayBuffer(e.request,function(e,o){e?r(e):o&&r(null,{vectorTile:new vt.VectorTile(new Protobuf(o.data)),rawData:o.data,cacheControl:o.cacheControl,expires:o.expires})});return function(){o.abort(),r()}}var ajax=_dereq_("../util/ajax"),vt=_dereq_("@mapbox/vector-tile"),Protobuf=_dereq_("pbf"),WorkerTile=_dereq_("./worker_tile"),util=_dereq_("../util/util"),VectorTileWorkerSource=function(e,r,o){this.actor=e,this.layerIndex=r,this.loadVectorData=o||loadVectorTile,this.loading={},this.loaded={}};VectorTileWorkerSource.prototype.loadTile=function(e,r){var o=this,t=e.source,i=e.uid;this.loading[t]||(this.loading[t]={});var a=this.loading[t][i]=new WorkerTile(e);a.abort=this.loadVectorData(e,function(e,l){if(delete o.loading[t][i],e||!l)return r(e);var c=l.rawData,n={};l.expires&&(n.expires=l.expires),l.cacheControl&&(n.cacheControl=l.cacheControl),a.vectorTile=l.vectorTile,a.parse(l.vectorTile,o.layerIndex,o.actor,function(e,o){if(e||!o)return r(e);r(null,util.extend({rawTileData:c.slice(0)},o,n))}),o.loaded[t]=o.loaded[t]||{},o.loaded[t][i]=a})},VectorTileWorkerSource.prototype.reloadTile=function(e,r){function o(e,o){if(this.reloadCallback){var t=this.reloadCallback;delete this.reloadCallback,this.parse(this.vectorTile,a.layerIndex,a.actor,t)}r(e,o)}var t=this.loaded[e.source],i=e.uid,a=this;if(t&&t[i]){var l=t[i];l.showCollisionBoxes=e.showCollisionBoxes,"parsing"===l.status?l.reloadCallback=r:"done"===l.status&&l.parse(l.vectorTile,this.layerIndex,this.actor,o.bind(l))}},VectorTileWorkerSource.prototype.abortTile=function(e,r){var o=this.loading[e.source],t=e.uid;o&&o[t]&&o[t].abort&&(o[t].abort(),delete o[t]),r()},VectorTileWorkerSource.prototype.removeTile=function(e,r){var o=this.loaded[e.source],t=e.uid;o&&o[t]&&delete o[t],r()},module.exports=VectorTileWorkerSource;
},{"../util/ajax":262,"../util/util":285,"./worker_tile":122,"@mapbox/vector-tile":8,"pbf":29}],120:[function(_dereq_,module,exports){
"use strict";var ajax=_dereq_("../util/ajax"),ImageSource=_dereq_("./image_source"),rasterBoundsAttributes=_dereq_("../data/raster_bounds_attributes"),VertexArrayObject=_dereq_("../render/vertex_array_object"),Texture=_dereq_("../render/texture"),VideoSource=function(e){function t(t,r,i,o){e.call(this,t,r,i,o),this.roundZoom=!0,this.type="video",this.options=r}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.load=function(){var e=this,t=this.options;this.urls=t.urls,ajax.getVideo(t.urls,function(t,r){t?e.fire("error",{error:t}):r&&(e.video=r,e.video.loop=!0,e.video.addEventListener("playing",function(){e.map._rerender()}),e.map&&e.video.play(),e._finishLoading())})},t.prototype.getVideo=function(){return this.video},t.prototype.onAdd=function(e){this.map||(this.map=e,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)))},t.prototype.prepare=function(){var e=this;if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var t=this.map.painter.context,r=t.gl;this.boundsBuffer||(this.boundsBuffer=t.createVertexBuffer(this._boundsArray,rasterBoundsAttributes.members)),this.boundsVAO||(this.boundsVAO=new VertexArrayObject),this.texture?this.video.paused||(this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE),r.texSubImage2D(r.TEXTURE_2D,0,0,0,r.RGBA,r.UNSIGNED_BYTE,this.video)):(this.texture=new Texture(t,this.video,r.RGBA),this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE));for(var i in e.tiles){var o=e.tiles[i];"loaded"!==o.state&&(o.state="loaded",o.texture=e.texture)}}},t.prototype.serialize=function(){return{type:"video",urls:this.urls,coordinates:this.coordinates}},t.prototype.hasTransition=function(){return this.video&&!this.video.paused},t}(ImageSource);module.exports=VideoSource;
},{"../data/raster_bounds_attributes":62,"../render/texture":96,"../render/vertex_array_object":98,"../util/ajax":262,"./image_source":105}],121:[function(_dereq_,module,exports){
"use strict";var Actor=_dereq_("../util/actor"),StyleLayerIndex=_dereq_("../style/style_layer_index"),VectorTileWorkerSource=_dereq_("./vector_tile_worker_source"),RasterDEMTileWorkerSource=_dereq_("./raster_dem_tile_worker_source"),GeoJSONWorkerSource=_dereq_("./geojson_worker_source"),globalRTLTextPlugin=_dereq_("./rtl_text_plugin"),Worker=function(e){var r=this;this.self=e,this.actor=new Actor(e,this),this.layerIndexes={},this.workerSourceTypes={vector:VectorTileWorkerSource,geojson:GeoJSONWorkerSource},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,o){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=o},this.self.registerRTLTextPlugin=function(e){if(globalRTLTextPlugin.applyArabicShaping||globalRTLTextPlugin.processBidirectionalText)throw new Error("RTL text plugin already registered.");globalRTLTextPlugin.applyArabicShaping=e.applyArabicShaping,globalRTLTextPlugin.processBidirectionalText=e.processBidirectionalText}};Worker.prototype.setLayers=function(e,r,o){this.getLayerIndex(e).replace(r),o()},Worker.prototype.updateLayers=function(e,r,o){this.getLayerIndex(e).update(r.layers,r.removedIds),o()},Worker.prototype.loadTile=function(e,r,o){this.getWorkerSource(e,r.type).loadTile(r,o)},Worker.prototype.loadDEMTile=function(e,r,o){this.getDEMWorkerSource(e).loadTile(r,o)},Worker.prototype.reloadTile=function(e,r,o){this.getWorkerSource(e,r.type).reloadTile(r,o)},Worker.prototype.abortTile=function(e,r,o){this.getWorkerSource(e,r.type).abortTile(r,o)},Worker.prototype.removeTile=function(e,r,o){this.getWorkerSource(e,r.type).removeTile(r,o)},Worker.prototype.removeDEMTile=function(e,r){this.getDEMWorkerSource(e).removeTile(r)},Worker.prototype.removeSource=function(e,r,o){var t=this.getWorkerSource(e,r.type);void 0!==t.removeSource?t.removeSource(r,o):o()},Worker.prototype.loadWorkerSource=function(e,r,o){try{this.self.importScripts(r.url),o()}catch(e){o(e)}},Worker.prototype.loadRTLTextPlugin=function(e,r,o){try{globalRTLTextPlugin.applyArabicShaping||globalRTLTextPlugin.processBidirectionalText||(this.self.importScripts(r),globalRTLTextPlugin.applyArabicShaping&&globalRTLTextPlugin.processBidirectionalText||o(new Error("RTL Text Plugin failed to import scripts from "+r)))}catch(e){o(e)}},Worker.prototype.getLayerIndex=function(e){var r=this.layerIndexes[e];return r||(r=this.layerIndexes[e]=new StyleLayerIndex),r},Worker.prototype.getWorkerSource=function(e,r){var o=this;if(this.workerSources[e]||(this.workerSources[e]={}),!this.workerSources[e][r]){var t={send:function(r,t,i){o.actor.send(r,t,i,e)}};this.workerSources[e][r]=new this.workerSourceTypes[r](t,this.getLayerIndex(e))}return this.workerSources[e][r]},Worker.prototype.getDEMWorkerSource=function(e){return this.demWorkerSources[e]||(this.demWorkerSources[e]=new RasterDEMTileWorkerSource),this.demWorkerSources[e]},module.exports=function(e){return new Worker(e)};
},{"../style/style_layer_index":221,"../util/actor":261,"./geojson_worker_source":103,"./raster_dem_tile_worker_source":110,"./rtl_text_plugin":112,"./vector_tile_worker_source":119}],122:[function(_dereq_,module,exports){
"use strict";function recalculateLayers(e,r){for(var i=new EvaluationParameters(r),a=0,o=e;a<o.length;a+=1){o[a].recalculate(i)}}var FeatureIndex=_dereq_("../data/feature_index"),ref=_dereq_("../symbol/symbol_layout"),performSymbolLayout=ref.performSymbolLayout,ref$1=_dereq_("../data/array_types"),CollisionBoxArray=ref$1.CollisionBoxArray,DictionaryCoder=_dereq_("../util/dictionary_coder"),SymbolBucket=_dereq_("../data/bucket/symbol_bucket"),util=_dereq_("../util/util"),ref$2=_dereq_("../render/image_atlas"),makeImageAtlas=ref$2.makeImageAtlas,ref$3=_dereq_("../render/glyph_atlas"),makeGlyphAtlas=ref$3.makeGlyphAtlas,EvaluationParameters=_dereq_("../style/evaluation_parameters"),ref$4=_dereq_("./tile_id"),OverscaledTileID=ref$4.OverscaledTileID,WorkerTile=function(e){this.tileID=new OverscaledTileID(e.tileID.overscaledZ,e.tileID.wrap,e.tileID.canonical.z,e.tileID.canonical.x,e.tileID.canonical.y),this.uid=e.uid,this.zoom=e.zoom,this.pixelRatio=e.pixelRatio,this.tileSize=e.tileSize,this.source=e.source,this.overscaling=e.overscaling,this.showCollisionBoxes=e.showCollisionBoxes};WorkerTile.prototype.parse=function(e,r,i,a){function o(){var e=this;if(k)return a(k);if(b&&D){var r=makeGlyphAtlas(b),i=makeImageAtlas(D);for(var o in n){var t=n[o];t instanceof SymbolBucket&&(recalculateLayers(t.layers,e.zoom),performSymbolLayout(t,b,r.positions,D,i.positions,e.showCollisionBoxes))}this.status="done",a(null,{buckets:util.values(n).filter(function(e){return!e.isEmpty()}),featureIndex:s,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:r.image,iconAtlasImage:i.image})}}var t=this;this.status="parsing",this.data=e,this.collisionBoxArray=new CollisionBoxArray;var l=new DictionaryCoder(Object.keys(e.layers).sort()),s=new FeatureIndex(this.tileID,this.overscaling);s.bucketLayerIDs=[];var n={},c={featureIndex:s,iconDependencies:{},glyphDependencies:{}},u=r.familiesBySource[this.source];for(var y in u){var m=e.layers[y];if(m){1===m.version&&util.warnOnce('Vector tile source "'+t.source+'" layer "'+y+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var h=l.encode(y),d=[],f=0;f<m.length;f++){var p=m.feature(f);d.push({feature:p,index:f,sourceLayerIndex:h})}for(var v=0,g=u[y];v<g.length;v+=1){var x=g[v],I=x[0];if(!(I.minzoom&&t.zoom<Math.floor(I.minzoom))&&(!(I.maxzoom&&t.zoom>=I.maxzoom)&&"none"!==I.visibility)){recalculateLayers(x,t.zoom);(n[I.id]=I.createBucket({index:s.bucketLayerIDs.length,layers:x,zoom:t.zoom,pixelRatio:t.pixelRatio,overscaling:t.overscaling,collisionBoxArray:t.collisionBoxArray})).populate(d,c),s.bucketLayerIDs.push(x.map(function(e){return e.id}))}}}}var k,b,D,A=util.mapObject(c.glyphDependencies,function(e){return Object.keys(e).map(Number)});Object.keys(A).length?i.send("getGlyphs",{uid:this.uid,stacks:A},function(e,r){k||(k=e,b=r,o.call(t))}):b={};var z=Object.keys(c.iconDependencies);z.length?i.send("getImages",{icons:z},function(e,r){k||(k=e,D=r,o.call(t))}):D={},o.call(this)},module.exports=WorkerTile;
},{"../data/array_types":42,"../data/bucket/symbol_bucket":54,"../data/feature_index":57,"../render/glyph_atlas":88,"../render/image_atlas":90,"../style/evaluation_parameters":193,"../symbol/symbol_layout":237,"../util/dictionary_coder":268,"../util/util":285,"./tile_id":117}],123:[function(_dereq_,module,exports){
"use strict";function deref(r,e){var f={};for(var t in r)"ref"!==t&&(f[t]=r[t]);return refProperties.forEach(function(r){r in e&&(f[r]=e[r])}),f}function derefLayers(r){r=r.slice();for(var e=Object.create(null),f=0;f<r.length;f++)e[r[f].id]=r[f];for(var t=0;t<r.length;t++)"ref"in r[t]&&(r[t]=deref(r[t],e[r[t].ref]));return r}var refProperties=_dereq_("./util/ref_properties");module.exports=derefLayers;
},{"./util/ref_properties":170}],124:[function(_dereq_,module,exports){
"use strict";function addSource(e,r,o){o.push({command:operations.addSource,args:[e,r[e]]})}function removeSource(e,r,o){r.push({command:operations.removeSource,args:[e]}),o[e]=!0}function updateSource(e,r,o,a){removeSource(e,o,a),addSource(e,r,o)}function canUpdateGeoJSON(e,r,o){var a;for(a in e[o])if(e[o].hasOwnProperty(a)&&"data"!==a&&!isEqual(e[o][a],r[o][a]))return!1;for(a in r[o])if(r[o].hasOwnProperty(a)&&"data"!==a&&!isEqual(e[o][a],r[o][a]))return!1;return!0}function diffSources(e,r,o,a){e=e||{},r=r||{};var t;for(t in e)e.hasOwnProperty(t)&&(r.hasOwnProperty(t)||removeSource(t,o,a));for(t in r)r.hasOwnProperty(t)&&(e.hasOwnProperty(t)?isEqual(e[t],r[t])||("geojson"===e[t].type&&"geojson"===r[t].type&&canUpdateGeoJSON(e,r,t)?o.push({command:operations.setGeoJSONSourceData,args:[t,r[t].data]}):updateSource(t,r,o,a)):addSource(t,r,o))}function diffLayerPropertyChanges(e,r,o,a,t,s){e=e||{},r=r||{};var n;for(n in e)e.hasOwnProperty(n)&&(isEqual(e[n],r[n])||o.push({command:s,args:[a,n,r[n],t]}));for(n in r)r.hasOwnProperty(n)&&!e.hasOwnProperty(n)&&(isEqual(e[n],r[n])||o.push({command:s,args:[a,n,r[n],t]}))}function pluckId(e){return e.id}function indexById(e,r){return e[r.id]=r,e}function diffLayers(e,r,o){e=e||[],r=r||[];var a,t,s,n,i,p,u,m=e.map(pluckId),c=r.map(pluckId),l=e.reduce(indexById,{}),d=r.reduce(indexById,{}),y=m.slice(),h=Object.create(null);for(a=0,t=0;a<m.length;a++)s=m[a],d.hasOwnProperty(s)?t++:(o.push({command:operations.removeLayer,args:[s]}),y.splice(y.indexOf(s,t),1));for(a=0,t=0;a<c.length;a++)s=c[c.length-1-a],y[y.length-1-a]!==s&&(l.hasOwnProperty(s)?(o.push({command:operations.removeLayer,args:[s]}),y.splice(y.lastIndexOf(s,y.length-t),1)):t++,p=y[y.length-a],o.push({command:operations.addLayer,args:[d[s],p]}),y.splice(y.length-a,0,s),h[s]=!0);for(a=0;a<c.length;a++)if(s=c[a],n=l[s],i=d[s],!h[s]&&!isEqual(n,i))if(isEqual(n.source,i.source)&&isEqual(n["source-layer"],i["source-layer"])&&isEqual(n.type,i.type)){diffLayerPropertyChanges(n.layout,i.layout,o,s,null,operations.setLayoutProperty),diffLayerPropertyChanges(n.paint,i.paint,o,s,null,operations.setPaintProperty),isEqual(n.filter,i.filter)||o.push({command:operations.setFilter,args:[s,i.filter]}),isEqual(n.minzoom,i.minzoom)&&isEqual(n.maxzoom,i.maxzoom)||o.push({command:operations.setLayerZoomRange,args:[s,i.minzoom,i.maxzoom]});for(u in n)n.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?diffLayerPropertyChanges(n[u],i[u],o,s,u.slice(6),operations.setPaintProperty):isEqual(n[u],i[u])||o.push({command:operations.setLayerProperty,args:[s,u,i[u]]}));for(u in i)i.hasOwnProperty(u)&&!n.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?diffLayerPropertyChanges(n[u],i[u],o,s,u.slice(6),operations.setPaintProperty):isEqual(n[u],i[u])||o.push({command:operations.setLayerProperty,args:[s,u,i[u]]}))}else o.push({command:operations.removeLayer,args:[s]}),p=y[y.lastIndexOf(s)+1],o.push({command:operations.addLayer,args:[i,p]})}function diffStyles(e,r){if(!e)return[{command:operations.setStyle,args:[r]}];var o=[];try{if(!isEqual(e.version,r.version))return[{command:operations.setStyle,args:[r]}];isEqual(e.center,r.center)||o.push({command:operations.setCenter,args:[r.center]}),isEqual(e.zoom,r.zoom)||o.push({command:operations.setZoom,args:[r.zoom]}),isEqual(e.bearing,r.bearing)||o.push({command:operations.setBearing,args:[r.bearing]}),isEqual(e.pitch,r.pitch)||o.push({command:operations.setPitch,args:[r.pitch]}),isEqual(e.sprite,r.sprite)||o.push({command:operations.setSprite,args:[r.sprite]}),isEqual(e.glyphs,r.glyphs)||o.push({command:operations.setGlyphs,args:[r.glyphs]}),isEqual(e.transition,r.transition)||o.push({command:operations.setTransition,args:[r.transition]}),isEqual(e.light,r.light)||o.push({command:operations.setLight,args:[r.light]});var a={},t=[];diffSources(e.sources,r.sources,t,a);var s=[];e.layers&&e.layers.forEach(function(e){a[e.source]?o.push({command:operations.removeLayer,args:[e.id]}):s.push(e)}),o=o.concat(t),diffLayers(s,r.layers,o)}catch(e){console.warn("Unable to compute style diff:",e),o=[{command:operations.setStyle,args:[r]}]}return o}var isEqual=_dereq_("lodash.isequal"),operations={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};module.exports=diffStyles,module.exports.operations=operations;
},{"lodash.isequal":160}],125:[function(_dereq_,module,exports){
"use strict";function ValidationError(r,i){for(var t=[],o=arguments.length-2;o-- >0;)t[o]=arguments[o+2];this.message=(r?r+": ":"")+format.apply(format,t),null!==i&&void 0!==i&&i.__line__&&(this.line=i.__line__)}var format=_dereq_("util").format;module.exports=ValidationError;
},{"util":36}],126:[function(_dereq_,module,exports){
"use strict";function varargs(r){return{type:r}}function stringifySignature(r){return Array.isArray(r)?"("+r.map(toString).join(", ")+")":"("+toString(r.type)+"...)"}var ref=_dereq_("./types"),toString=ref.toString,ParsingContext=_dereq_("./parsing_context"),EvaluationContext=_dereq_("./evaluation_context"),CompoundExpression=function(r,n,e,t){this.name=r,this.type=n,this._evaluate=e,this.args=t};CompoundExpression.prototype.evaluate=function(r){return this._evaluate(r,this.args)},CompoundExpression.prototype.eachChild=function(r){this.args.forEach(r)},CompoundExpression.prototype.possibleOutputs=function(){return[void 0]},CompoundExpression.parse=function(r,n){var e=r[0],t=CompoundExpression.definitions[e];if(!t)return n.error('Unknown expression "'+e+'". If you wanted a literal array, use ["literal", [...]].',0);for(var o=Array.isArray(t)?t[0]:t.type,i=Array.isArray(t)?[[t[1],t[2]]]:t.overloads,s=i.filter(function(n){var e=n[0];return!Array.isArray(e)||e.length===r.length-1}),a=[],u=1;u<r.length;u++){var p=r[u],l=void 0;if(1===s.length){var g=s[0][0];l=Array.isArray(g)?g[u-1]:g.type}var f=n.parse(p,1+a.length,l);if(!f)return null;a.push(f)}for(var y=null,h=0,d=s;h<d.length;h+=1){var v=d[h],c=v[0],x=v[1];if(y=new ParsingContext(n.definitions,n.path,null,n.scope),Array.isArray(c)&&c.length!==a.length)y.error("Expected "+c.length+" arguments, but found "+a.length+" instead.");else{for(var m=0;m<a.length;m++){var C=Array.isArray(c)?c[m]:c.type,E=a[m];y.concat(m+1).checkSubtype(C,E.type)}if(0===y.errors.length)return new CompoundExpression(e,o,x,a)}}if(1===s.length)n.errors.push.apply(n.errors,y.errors);else{var A=s.length?s:i,S=A.map(function(r){return stringifySignature(r[0])}).join(" | "),b=a.map(function(r){return toString(r.type)}).join(", ");n.error("Expected arguments of type "+S+", but found ("+b+") instead.")}return null},CompoundExpression.register=function(r,n){CompoundExpression.definitions=n;for(var e in n)r[e]=CompoundExpression},module.exports={CompoundExpression:CompoundExpression,varargs:varargs};
},{"./evaluation_context":141,"./parsing_context":144,"./types":149}],127:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),toString=ref.toString,array=ref.array,ValueType=ref.ValueType,StringType=ref.StringType,NumberType=ref.NumberType,BooleanType=ref.BooleanType,checkSubtype=ref.checkSubtype,ref$1=_dereq_("../values"),typeOf=ref$1.typeOf,RuntimeError=_dereq_("../runtime_error"),types={string:StringType,number:NumberType,boolean:BooleanType},ArrayAssertion=function(e,r){this.type=e,this.input=r};ArrayAssertion.parse=function(e,r){if(e.length<2||e.length>4)return r.error("Expected 1, 2, or 3 arguments, but found "+(e.length-1)+" instead.");var t,n;if(e.length>2){var i=e[1];if("string"!=typeof i||!(i in types))return r.error('The item type argument of "array" must be one of string, number, boolean',1);t=types[i]}else t=ValueType;if(e.length>3){if("number"!=typeof e[2]||e[2]<0||e[2]!==Math.floor(e[2]))return r.error('The length argument to "array" must be a positive integer literal',2);n=e[2]}var o=array(t,n),u=r.parse(e[e.length-1],e.length-1,ValueType);return u?new ArrayAssertion(o,u):null},ArrayAssertion.prototype.evaluate=function(e){var r=this.input.evaluate(e);if(checkSubtype(this.type,typeOf(r)))throw new RuntimeError("Expected value to be of type "+toString(this.type)+", but found "+toString(typeOf(r))+" instead.");return r},ArrayAssertion.prototype.eachChild=function(e){e(this.input)},ArrayAssertion.prototype.possibleOutputs=function(){return this.input.possibleOutputs()},module.exports=ArrayAssertion;
},{"../runtime_error":146,"../types":149,"../values":150}],128:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),ObjectType=ref.ObjectType,ValueType=ref.ValueType,StringType=ref.StringType,NumberType=ref.NumberType,BooleanType=ref.BooleanType,RuntimeError=_dereq_("../runtime_error"),ref$1=_dereq_("../types"),checkSubtype=ref$1.checkSubtype,toString=ref$1.toString,ref$2=_dereq_("../values"),typeOf=ref$2.typeOf,types={string:StringType,number:NumberType,boolean:BooleanType,object:ObjectType},Assertion=function(e,r){this.type=e,this.args=r};Assertion.parse=function(e,r){if(e.length<2)return r.error("Expected at least one argument.");for(var t=e[0],n=types[t],o=[],p=1;p<e.length;p++){var s=r.parse(e[p],p,ValueType);if(!s)return null;o.push(s)}return new Assertion(n,o)},Assertion.prototype.evaluate=function(e){for(var r=this,t=0;t<this.args.length;t++){var n=r.args[t].evaluate(e);if(!checkSubtype(r.type,typeOf(n)))return n;if(t===r.args.length-1)throw new RuntimeError("Expected value to be of type "+toString(r.type)+", but found "+toString(typeOf(n))+" instead.")}return null},Assertion.prototype.eachChild=function(e){this.args.forEach(e)},Assertion.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.args.map(function(e){return e.possibleOutputs()}));var e},module.exports=Assertion;
},{"../runtime_error":146,"../types":149,"../values":150}],129:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),array=ref.array,ValueType=ref.ValueType,NumberType=ref.NumberType,RuntimeError=_dereq_("../runtime_error"),At=function(e,t,r){this.type=e,this.index=t,this.input=r};At.parse=function(e,t){if(3!==e.length)return t.error("Expected 2 arguments, but found "+(e.length-1)+" instead.");var r=t.parse(e[1],1,NumberType),n=t.parse(e[2],2,array(t.expectedType||ValueType));if(!r||!n)return null;var u=n.type;return new At(u.itemType,r,n)},At.prototype.evaluate=function(e){var t=this.index.evaluate(e),r=this.input.evaluate(e);if(t<0||t>=r.length)throw new RuntimeError("Array index out of bounds: "+t+" > "+r.length+".");if(t!==Math.floor(t))throw new RuntimeError("Array index must be an integer, but found "+t+" instead.");return r[t]},At.prototype.eachChild=function(e){e(this.index),e(this.input)},At.prototype.possibleOutputs=function(){return[void 0]},module.exports=At;
},{"../runtime_error":146,"../types":149}],130:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),BooleanType=ref.BooleanType,Case=function(e,t,r){this.type=e,this.branches=t,this.otherwise=r};Case.parse=function(e,t){if(e.length<4)return t.error("Expected at least 3 arguments, but found only "+(e.length-1)+".");if(e.length%2!=0)return t.error("Expected an odd number of arguments.");var r;t.expectedType&&"value"!==t.expectedType.kind&&(r=t.expectedType);for(var n=[],a=1;a<e.length-1;a+=2){var s=t.parse(e[a],a,BooleanType);if(!s)return null;var o=t.parse(e[a+1],a+1,r);if(!o)return null;n.push([s,o]),r=r||o.type}var u=t.parse(e[e.length-1],e.length-1,r);return u?new Case(r,n,u):null},Case.prototype.evaluate=function(e){for(var t=this,r=0,n=t.branches;r<n.length;r+=1){var a=n[r],s=a[0],o=a[1];if(s.evaluate(e))return o.evaluate(e)}return this.otherwise.evaluate(e)},Case.prototype.eachChild=function(e){for(var t=this,r=0,n=t.branches;r<n.length;r+=1){var a=n[r],s=a[0],o=a[1];e(s),e(o)}e(this.otherwise)},Case.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.branches.map(function(e){e[0];return e[1].possibleOutputs()})).concat(this.otherwise.possibleOutputs());var e},module.exports=Case;
},{"../types":149}],131:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),checkSubtype=ref.checkSubtype,ValueType=ref.ValueType,Coalesce=function(e,t){this.type=e,this.args=t};Coalesce.parse=function(e,t){if(e.length<2)return t.error("Expectected at least one argument.");var r=null,a=t.expectedType;a&&"value"!==a.kind&&(r=a);for(var n=[],o=0,u=e.slice(1);o<u.length;o+=1){var s=u[o],l=t.parse(s,1+n.length,r,void 0,{omitTypeAnnotations:!0});if(!l)return null;r=r||l.type,n.push(l)}return a&&n.some(function(e){return checkSubtype(a,e.type)})?new Coalesce(ValueType,n):new Coalesce(r,n)},Coalesce.prototype.evaluate=function(e){for(var t=this,r=null,a=0,n=t.args;a<n.length;a+=1){if(null!==(r=n[a].evaluate(e)))break}return r},Coalesce.prototype.eachChild=function(e){this.args.forEach(e)},Coalesce.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.args.map(function(e){return e.possibleOutputs()}));var e},module.exports=Coalesce;
},{"../types":149}],132:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),ColorType=ref.ColorType,ValueType=ref.ValueType,NumberType=ref.NumberType,ref$1=_dereq_("../values"),Color=ref$1.Color,validateRGBA=ref$1.validateRGBA,RuntimeError=_dereq_("../runtime_error"),types={"to-number":NumberType,"to-color":ColorType},Coercion=function(r,e){this.type=r,this.args=e};Coercion.parse=function(r,e){if(r.length<2)return e.error("Expected at least one argument.");for(var t=r[0],o=types[t],n=[],i=1;i<r.length;i++){var a=e.parse(r[i],i,ValueType);if(!a)return null;n.push(a)}return new Coercion(o,n)},Coercion.prototype.evaluate=function(r){var e=this;if("color"===this.type.kind){for(var t,o,n=0,i=e.args;n<i.length;n+=1){if(t=i[n].evaluate(r),o=null,"string"==typeof t){var a=r.parseColor(t);if(a)return a}else if(Array.isArray(t)&&!(o=t.length<3||t.length>4?"Invalid rbga value "+JSON.stringify(t)+": expected an array containing either three or four numeric values.":validateRGBA(t[0],t[1],t[2],t[3])))return new Color(t[0]/255,t[1]/255,t[2]/255,t[3])}throw new RuntimeError(o||"Could not parse color from value '"+("string"==typeof t?t:JSON.stringify(t))+"'")}for(var u=null,l=0,s=e.args;l<s.length;l+=1){if(null!==(u=s[l].evaluate(r))){var p=Number(u);if(!isNaN(p))return p}}throw new RuntimeError("Could not convert "+JSON.stringify(u)+" to number.")},Coercion.prototype.eachChild=function(r){this.args.forEach(r)},Coercion.prototype.possibleOutputs=function(){return(r=[]).concat.apply(r,this.args.map(function(r){return r.possibleOutputs()}));var r},module.exports=Coercion;
},{"../runtime_error":146,"../types":149,"../values":150}],133:[function(_dereq_,module,exports){
"use strict";function eq(e){return this.lhs.evaluate(e)===this.rhs.evaluate(e)}function ne(e){return this.lhs.evaluate(e)!==this.rhs.evaluate(e)}function isComparableType(e){return"string"===e.kind||"number"===e.kind||"boolean"===e.kind||"null"===e.kind}var ref=_dereq_("../types"),ValueType=ref.ValueType,BooleanType=ref.BooleanType,ref$1=_dereq_("../types"),toString=ref$1.toString,Equals=function(e,t,r){this.type=BooleanType,this.lhs=t,this.rhs=r,this.evaluate="=="===e?eq:ne};Equals.parse=function(e,t){if(3!==e.length)return t.error("Expected two arguments.");var r=e[0],n=t.parse(e[1],1,ValueType);if(!n)return null;var a=t.parse(e[2],2,ValueType);return a?isComparableType(n.type)||isComparableType(a.type)?n.type.kind!==a.type.kind&&"value"!==n.type.kind&&"value"!==a.type.kind?t.error("Cannot compare "+toString(n.type)+" and "+toString(a.type)+"."):new Equals(r,n,a):t.error("Expected at least one argument to be a string, number, boolean, or null, but found ("+toString(n.type)+", "+toString(a.type)+") instead."):null},Equals.prototype.eachChild=function(e){e(this.lhs),e(this.rhs)},Equals.prototype.possibleOutputs=function(){return[!0,!1]},module.exports=Equals;
},{"../types":149}],134:[function(_dereq_,module,exports){
"use strict";function rgba(e,r){var t=r[0],a=r[1],n=r[2],u=r[3];t=t.evaluate(e),a=a.evaluate(e),n=n.evaluate(e);var o=u?u.evaluate(e):1,p=validateRGBA(t,a,n,o);if(p)throw new RuntimeError(p);return new Color(t/255*o,a/255*o,n/255*o,o)}function has(e,r){return e in r}function get(e,r){var t=r[e];return void 0===t?null:t}function length(e,r){return r[0].evaluate(e).length}function lt(e,r){var t=r[0],a=r[1];return t.evaluate(e)<a.evaluate(e)}function gt(e,r){var t=r[0],a=r[1];return t.evaluate(e)>a.evaluate(e)}function lteq(e,r){var t=r[0],a=r[1];return t.evaluate(e)<=a.evaluate(e)}function gteq(e,r){var t=r[0],a=r[1];return t.evaluate(e)>=a.evaluate(e)}var ref=_dereq_("../types"),NumberType=ref.NumberType,StringType=ref.StringType,BooleanType=ref.BooleanType,ColorType=ref.ColorType,ObjectType=ref.ObjectType,ValueType=ref.ValueType,ErrorType=ref.ErrorType,array=ref.array,toString=ref.toString,ref$1=_dereq_("../values"),typeOf=ref$1.typeOf,Color=ref$1.Color,validateRGBA=ref$1.validateRGBA,ref$2=_dereq_("../compound_expression"),CompoundExpression=ref$2.CompoundExpression,varargs=ref$2.varargs,RuntimeError=_dereq_("../runtime_error"),Let=_dereq_("./let"),Var=_dereq_("./var"),Literal=_dereq_("./literal"),Assertion=_dereq_("./assertion"),ArrayAssertion=_dereq_("./array"),Coercion=_dereq_("./coercion"),At=_dereq_("./at"),Match=_dereq_("./match"),Case=_dereq_("./case"),Step=_dereq_("./step"),Interpolate=_dereq_("./interpolate"),Coalesce=_dereq_("./coalesce"),Equals=_dereq_("./equals"),expressions={"!=":Equals,"==":Equals,array:ArrayAssertion,at:At,boolean:Assertion,case:Case,coalesce:Coalesce,interpolate:Interpolate,let:Let,literal:Literal,match:Match,number:Assertion,object:Assertion,step:Step,string:Assertion,"to-color":Coercion,"to-number":Coercion,var:Var};CompoundExpression.register(expressions,{error:[ErrorType,[StringType],function(e,r){var t=r[0];throw new RuntimeError(t.evaluate(e))}],typeof:[StringType,[ValueType],function(e,r){var t=r[0];return toString(typeOf(t.evaluate(e)))}],"to-string":[StringType,[ValueType],function(e,r){var t=r[0];t=t.evaluate(e);var a=typeof t;return null===t||"string"===a||"number"===a||"boolean"===a?String(t):t instanceof Color?t.toString():JSON.stringify(t)}],"to-boolean":[BooleanType,[ValueType],function(e,r){var t=r[0];return Boolean(t.evaluate(e))}],"to-rgba":[array(NumberType,4),[ColorType],function(e,r){var t=r[0],a=t.evaluate(e),n=a.r,u=a.g,o=a.b,p=a.a;return[255*n/p,255*u/p,255*o/p,p]}],rgb:[ColorType,[NumberType,NumberType,NumberType],rgba],rgba:[ColorType,[NumberType,NumberType,NumberType,NumberType],rgba],length:{type:NumberType,overloads:[[[StringType],length],[[array(ValueType)],length]]},has:{type:BooleanType,overloads:[[[StringType],function(e,r){return has(r[0].evaluate(e),e.properties())}],[[StringType,ObjectType],function(e,r){var t=r[0],a=r[1];return has(t.evaluate(e),a.evaluate(e))}]]},get:{type:ValueType,overloads:[[[StringType],function(e,r){return get(r[0].evaluate(e),e.properties())}],[[StringType,ObjectType],function(e,r){var t=r[0],a=r[1];return get(t.evaluate(e),a.evaluate(e))}]]},properties:[ObjectType,[],function(e){return e.properties()}],"geometry-type":[StringType,[],function(e){return e.geometryType()}],id:[ValueType,[],function(e){return e.id()}],zoom:[NumberType,[],function(e){return e.globals.zoom}],"heatmap-density":[NumberType,[],function(e){return e.globals.heatmapDensity||0}],"+":[NumberType,varargs(NumberType),function(e,r){for(var t=0,a=0,n=r;a<n.length;a+=1){t+=n[a].evaluate(e)}return t}],"*":[NumberType,varargs(NumberType),function(e,r){for(var t=1,a=0,n=r;a<n.length;a+=1){t*=n[a].evaluate(e)}return t}],"-":{type:NumberType,overloads:[[[NumberType,NumberType],function(e,r){var t=r[0],a=r[1];return t.evaluate(e)-a.evaluate(e)}],[[NumberType],function(e,r){return-r[0].evaluate(e)}]]},"/":[NumberType,[NumberType,NumberType],function(e,r){var t=r[0],a=r[1];return t.evaluate(e)/a.evaluate(e)}],"%":[NumberType,[NumberType,NumberType],function(e,r){var t=r[0],a=r[1];return t.evaluate(e)%a.evaluate(e)}],ln2:[NumberType,[],function(){return Math.LN2}],pi:[NumberType,[],function(){return Math.PI}],e:[NumberType,[],function(){return Math.E}],"^":[NumberType,[NumberType,NumberType],function(e,r){var t=r[0],a=r[1];return Math.pow(t.evaluate(e),a.evaluate(e))}],sqrt:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.sqrt(t.evaluate(e))}],log10:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.log10(t.evaluate(e))}],ln:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.log(t.evaluate(e))}],log2:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.log2(t.evaluate(e))}],sin:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.sin(t.evaluate(e))}],cos:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.cos(t.evaluate(e))}],tan:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.tan(t.evaluate(e))}],asin:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.asin(t.evaluate(e))}],acos:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.acos(t.evaluate(e))}],atan:[NumberType,[NumberType],function(e,r){var t=r[0];return Math.atan(t.evaluate(e))}],min:[NumberType,varargs(NumberType),function(e,r){return Math.min.apply(Math,r.map(function(r){return r.evaluate(e)}))}],max:[NumberType,varargs(NumberType),function(e,r){return Math.max.apply(Math,r.map(function(r){return r.evaluate(e)}))}],">":{type:BooleanType,overloads:[[[NumberType,NumberType],gt],[[StringType,StringType],gt]]},"<":{type:BooleanType,overloads:[[[NumberType,NumberType],lt],[[StringType,StringType],lt]]},">=":{type:BooleanType,overloads:[[[NumberType,NumberType],gteq],[[StringType,StringType],gteq]]},"<=":{type:BooleanType,overloads:[[[NumberType,NumberType],lteq],[[StringType,StringType],lteq]]},all:{type:BooleanType,overloads:[[[BooleanType,BooleanType],function(e,r){var t=r[0],a=r[1];return t.evaluate(e)&&a.evaluate(e)}],[varargs(BooleanType),function(e,r){for(var t=0,a=r;t<a.length;t+=1){if(!a[t].evaluate(e))return!1}return!0}]]},any:{type:BooleanType,overloads:[[[BooleanType,BooleanType],function(e,r){var t=r[0],a=r[1];return t.evaluate(e)||a.evaluate(e)}],[varargs(BooleanType),function(e,r){for(var t=0,a=r;t<a.length;t+=1){if(a[t].evaluate(e))return!0}return!1}]]},"!":[BooleanType,[BooleanType],function(e,r){return!r[0].evaluate(e)}],upcase:[StringType,[StringType],function(e,r){return r[0].evaluate(e).toUpperCase()}],downcase:[StringType,[StringType],function(e,r){return r[0].evaluate(e).toLowerCase()}],concat:[StringType,varargs(StringType),function(e,r){return r.map(function(r){return r.evaluate(e)}).join("")}]}),module.exports=expressions;
},{"../compound_expression":126,"../runtime_error":146,"../types":149,"../values":150,"./array":127,"./assertion":128,"./at":129,"./case":130,"./coalesce":131,"./coercion":132,"./equals":133,"./interpolate":135,"./let":136,"./literal":137,"./match":138,"./step":139,"./var":140}],135:[function(_dereq_,module,exports){
"use strict";function exponentialInterpolation(e,t,r,n){var i=n-r,o=e-r;return 0===i?0:1===t?o/i:(Math.pow(t,o)-1)/(Math.pow(t,i)-1)}var UnitBezier=_dereq_("@mapbox/unitbezier"),interpolate=_dereq_("../../util/interpolate"),ref=_dereq_("../types"),toString=ref.toString,NumberType=ref.NumberType,ref$1=_dereq_("../stops"),findStopLessThanOrEqualTo=ref$1.findStopLessThanOrEqualTo,Interpolate=function(e,t,r,n){var i=this;this.type=e,this.interpolation=t,this.input=r,this.labels=[],this.outputs=[];for(var o=0,a=n;o<a.length;o+=1){var u=a[o],p=u[0],l=u[1];i.labels.push(p),i.outputs.push(l)}};Interpolate.interpolationFactor=function(e,t,r,n){var i=0;if("exponential"===e.name)i=exponentialInterpolation(t,e.base,r,n);else if("linear"===e.name)i=exponentialInterpolation(t,1,r,n);else if("cubic-bezier"===e.name){var o=e.controlPoints,a=new UnitBezier(o[0],o[1],o[2],o[3]);i=a.solve(exponentialInterpolation(t,1,r,n))}return i},Interpolate.parse=function(e,t){var r=e[1],n=e[2],i=e.slice(3);if(!Array.isArray(r)||0===r.length)return t.error("Expected an interpolation type expression.",1);if("linear"===r[0])r={name:"linear"};else if("exponential"===r[0]){var o=r[1];if("number"!=typeof o)return t.error("Exponential interpolation requires a numeric base.",1,1);r={name:"exponential",base:o}}else{if("cubic-bezier"!==r[0])return t.error("Unknown interpolation type "+String(r[0]),1,0);var a=r.slice(1);if(4!==a.length||a.some(function(e){return"number"!=typeof e||e<0||e>1}))return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);r={name:"cubic-bezier",controlPoints:a}}if(e.length-1<4)return t.error("Expected at least 4 arguments, but found only "+(e.length-1)+".");if((e.length-1)%2!=0)return t.error("Expected an even number of arguments.");if(!(n=t.parse(n,2,NumberType)))return null;var u=[],p=null;t.expectedType&&"value"!==t.expectedType.kind&&(p=t.expectedType);for(var l=0;l<i.length;l+=2){var s=i[l],f=i[l+1],c=l+3,h=l+4;if("number"!=typeof s)return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',c);if(u.length&&u[u.length-1][0]>=s)return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',c);var v=t.parse(f,h,p);if(!v)return null;p=p||v.type,u.push([s,v])}return"number"===p.kind||"color"===p.kind||"array"===p.kind&&"number"===p.itemType.kind&&"number"==typeof p.N?new Interpolate(p,r,n,u):t.error("Type "+toString(p)+" is not interpolatable.")},Interpolate.prototype.evaluate=function(e){var t=this.labels,r=this.outputs;if(1===t.length)return r[0].evaluate(e);var n=this.input.evaluate(e);if(n<=t[0])return r[0].evaluate(e);var i=t.length;if(n>=t[i-1])return r[i-1].evaluate(e);var o=findStopLessThanOrEqualTo(t,n),a=t[o],u=t[o+1],p=Interpolate.interpolationFactor(this.interpolation,n,a,u),l=r[o].evaluate(e),s=r[o+1].evaluate(e);return interpolate[this.type.kind.toLowerCase()](l,s,p)},Interpolate.prototype.eachChild=function(e){var t=this;e(this.input);for(var r=0,n=t.outputs;r<n.length;r+=1){e(n[r])}},Interpolate.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.outputs.map(function(e){return e.possibleOutputs()}));var e},module.exports=Interpolate;
},{"../../util/interpolate":169,"../stops":148,"../types":149,"@mapbox/unitbezier":7}],136:[function(_dereq_,module,exports){
"use strict";var Let=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e};Let.prototype.evaluate=function(t){t.pushScope(this.bindings);var e=this.result.evaluate(t);return t.popScope(),e},Let.prototype.eachChild=function(t){for(var e=this,r=0,n=e.bindings;r<n.length;r+=1){t(n[r][1])}t(this.result)},Let.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var s=t[n];if("string"!=typeof s)return e.error("Expected string, but found "+typeof s+" instead.",n);if(/[^a-zA-Z0-9_]/.test(s))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var i=e.parse(t[n+1],n+1);if(!i)return null;r.push([s,i])}var u=e.parse(t[t.length-1],t.length-1,void 0,r);return u?new Let(r,u):null},Let.prototype.possibleOutputs=function(){return this.result.possibleOutputs()},module.exports=Let;
},{}],137:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../values"),isValue=ref.isValue,typeOf=ref.typeOf,Literal=function(e,r){this.type=e,this.value=r};Literal.parse=function(e,r){if(2!==e.length)return r.error("'literal' expression requires exactly one argument, but found "+(e.length-1)+" instead.");if(!isValue(e[1]))return r.error("invalid value");var t=e[1],i=typeOf(t),a=r.expectedType;return"array"!==i.kind||0!==i.N||!a||"array"!==a.kind||"number"==typeof a.N&&0!==a.N||(i=a),new Literal(i,t)},Literal.prototype.evaluate=function(){return this.value},Literal.prototype.eachChild=function(){},Literal.prototype.possibleOutputs=function(){return[this.value]},module.exports=Literal;
},{"../values":150}],138:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../values"),typeOf=ref.typeOf,Match=function(e,t,r,n,u,s){this.inputType=e,this.type=t,this.input=r,this.cases=n,this.outputs=u,this.otherwise=s};Match.parse=function(e,t){if(e.length<5)return t.error("Expected at least 4 arguments, but found only "+(e.length-1)+".");if(e.length%2!=1)return t.error("Expected an even number of arguments.");var r,n;t.expectedType&&"value"!==t.expectedType.kind&&(n=t.expectedType);for(var u={},s=[],a=2;a<e.length-1;a+=2){var i=e[a],o=e[a+1];Array.isArray(i)||(i=[i]);var p=t.concat(a);if(0===i.length)return p.error("Expected at least one branch label.");for(var h=0,l=i;h<l.length;h+=1){var c=l[h];if("number"!=typeof c&&"string"!=typeof c)return p.error("Branch labels must be numbers or strings.");if("number"==typeof c&&Math.abs(c)>Number.MAX_SAFE_INTEGER)return p.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof c&&Math.floor(c)!==c)return p.error("Numeric branch labels must be integer values.");if(r){if(p.checkSubtype(r,typeOf(c)))return null}else r=typeOf(c);if(void 0!==u[String(c)])return p.error("Branch labels must be unique.");u[String(c)]=s.length}var f=t.parse(o,a,n);if(!f)return null;n=n||f.type,s.push(f)}var b=t.parse(e[1],1,r);if(!b)return null;var y=t.parse(e[e.length-1],e.length-1,n);return y?new Match(r,n,b,u,s,y):null},Match.prototype.evaluate=function(e){var t=this.input.evaluate(e);return(this.outputs[this.cases[t]]||this.otherwise).evaluate(e)},Match.prototype.eachChild=function(e){e(this.input),this.outputs.forEach(e),e(this.otherwise)},Match.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.outputs.map(function(e){return e.possibleOutputs()})).concat(this.otherwise.possibleOutputs());var e},module.exports=Match;
},{"../values":150}],139:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../types"),NumberType=ref.NumberType,ref$1=_dereq_("../stops"),findStopLessThanOrEqualTo=ref$1.findStopLessThanOrEqualTo,Step=function(e,t,r){var u=this;this.type=e,this.input=t,this.labels=[],this.outputs=[];for(var n=0,s=r;n<s.length;n+=1){var p=s[n],a=p[0],i=p[1];u.labels.push(a),u.outputs.push(i)}};Step.parse=function(e,t){var r=e[1],u=e.slice(2);if(e.length-1<4)return t.error("Expected at least 4 arguments, but found only "+(e.length-1)+".");if((e.length-1)%2!=0)return t.error("Expected an even number of arguments.");if(!(r=t.parse(r,1,NumberType)))return null;var n=[],s=null;t.expectedType&&"value"!==t.expectedType.kind&&(s=t.expectedType),u.unshift(-1/0);for(var p=0;p<u.length;p+=2){var a=u[p],i=u[p+1],o=p+1,l=p+2;if("number"!=typeof a)return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',o);if(n.length&&n[n.length-1][0]>=a)return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',o);var f=t.parse(i,l,s);if(!f)return null;s=s||f.type,n.push([a,f])}return new Step(s,r,n)},Step.prototype.evaluate=function(e){var t=this.labels,r=this.outputs;if(1===t.length)return r[0].evaluate(e);var u=this.input.evaluate(e);if(u<=t[0])return r[0].evaluate(e);var n=t.length;return u>=t[n-1]?r[n-1].evaluate(e):r[findStopLessThanOrEqualTo(t,u)].evaluate(e)},Step.prototype.eachChild=function(e){var t=this;e(this.input);for(var r=0,u=t.outputs;r<u.length;r+=1){e(u[r])}},Step.prototype.possibleOutputs=function(){return(e=[]).concat.apply(e,this.outputs.map(function(e){return e.possibleOutputs()}));var e},module.exports=Step;
},{"../stops":148,"../types":149}],140:[function(_dereq_,module,exports){
"use strict";var Var=function(e,r){this.type=r,this.name=e};Var.parse=function(e,r){if(2!==e.length||"string"!=typeof e[1])return r.error("'var' expression requires exactly one string literal argument.");var t=e[1];return r.scope.has(t)?new Var(t,r.scope.get(t).type):r.error('Unknown variable "'+t+'". Make sure "'+t+'" has been bound in an enclosing "let" expression before using it.',1)},Var.prototype.evaluate=function(e){return e.scope.get(this.name).evaluate(e)},Var.prototype.eachChild=function(){},Var.prototype.possibleOutputs=function(){return[void 0]},module.exports=Var;
},{}],141:[function(_dereq_,module,exports){
"use strict";var Scope=_dereq_("./scope"),ref=_dereq_("./values"),Color=ref.Color,geometryTypes=["Unknown","Point","LineString","Polygon"],EvaluationContext=function(){this.scope=new Scope,this._parseColorCache={}};EvaluationContext.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},EvaluationContext.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?geometryTypes[this.feature.type]:this.feature.type:null},EvaluationContext.prototype.properties=function(){return this.feature&&this.feature.properties||{}},EvaluationContext.prototype.pushScope=function(t){this.scope=this.scope.concat(t)},EvaluationContext.prototype.popScope=function(){this.scope=this.scope.parent},EvaluationContext.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=Color.parse(t)),e},module.exports=EvaluationContext;
},{"./scope":147,"./values":150}],142:[function(_dereq_,module,exports){
"use strict";function isExpression(e){return Array.isArray(e)&&e.length>0&&"string"==typeof e[0]&&e[0]in definitions}function createExpression(e,r,n){void 0===n&&(n={});var t=new ParsingContext(definitions,[],getExpectedType(r)),o=t.parse(e);return o?success(!1===n.handleErrors?new StyleExpression(o):new StyleExpressionWithErrorHandling(o,r)):error(t.errors)}function createPropertyExpression(e,r,n){if(void 0===n&&(n={}),e=createExpression(e,r,n),"error"===e.result)return e;var t=e.value.expression,o=isConstant.isFeatureConstant(t);if(!o&&!r["property-function"])return error([new ParsingError("","property expressions not supported")]);var i=isConstant.isGlobalPropertyConstant(t,["zoom"]);if(!i&&!1===r["zoom-function"])return error([new ParsingError("","zoom expressions not supported")]);var s=findZoomCurve(t);return s||i?s instanceof ParsingError?error([s]):s instanceof Interpolate&&"piecewise-constant"===r.function?error([new ParsingError("",'"interpolate" expressions cannot be used with this property')]):success(s?o?new ZoomDependentExpression("camera",e.value,s):new ZoomDependentExpression("composite",e.value,s):o?new ZoomConstantExpression("constant",e.value):new ZoomConstantExpression("source",e.value)):error([new ParsingError("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}function normalizePropertyExpression(e,r){if(isFunction(e))return new StylePropertyFunction(e,r);if(isExpression(e)){var n=createPropertyExpression(e,r);if("error"===n.result)throw new Error(n.value.map(function(e){return e.key+": "+e.message}).join(", "));return n.value}var t=e;return"string"==typeof e&&"color"===r.type&&(t=Color.parse(e)),{kind:"constant",evaluate:function(){return t}}}function findZoomCurve(e){var r=null;if(e instanceof Let)r=findZoomCurve(e.result);else if(e instanceof Coalesce)for(var n=0,t=e.args;n<t.length;n+=1){var o=t[n];if(r=findZoomCurve(o))break}else(e instanceof Step||e instanceof Interpolate)&&e.input instanceof CompoundExpression&&"zoom"===e.input.name&&(r=e);return r instanceof ParsingError?r:(e.eachChild(function(e){var n=findZoomCurve(e);n instanceof ParsingError?r=n:!r&&n?r=new ParsingError("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new ParsingError("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'))}),r)}function getExpectedType(e){var r={color:ColorType,string:StringType,number:NumberType,enum:StringType,boolean:BooleanType};return"array"===e.type?array(r[e.value]||ValueType,e.length):r[e.type]||null}function getDefaultValue(e){return"color"===e.type&&isFunction(e.default)?new Color(0,0,0,0):"color"===e.type?Color.parse(e.default)||null:void 0===e.default?null:e.default}var extend=_dereq_("../util/extend"),ParsingError=_dereq_("./parsing_error"),ParsingContext=_dereq_("./parsing_context"),EvaluationContext=_dereq_("./evaluation_context"),ref=_dereq_("./compound_expression"),CompoundExpression=ref.CompoundExpression,Step=_dereq_("./definitions/step"),Interpolate=_dereq_("./definitions/interpolate"),Coalesce=_dereq_("./definitions/coalesce"),Let=_dereq_("./definitions/let"),definitions=_dereq_("./definitions"),isConstant=_dereq_("./is_constant"),RuntimeError=_dereq_("./runtime_error"),ref$1=_dereq_("../util/result"),success=ref$1.success,error=ref$1.error,StyleExpression=function(e){this.expression=e};StyleExpression.prototype.evaluate=function(e,r){return this._evaluator||(this._evaluator=new EvaluationContext),this._evaluator.globals=e,this._evaluator.feature=r,this.expression.evaluate(this._evaluator)};var StyleExpressionWithErrorHandling=function(e){function r(r,n){e.call(this,r),this._warningHistory={},this._defaultValue=getDefaultValue(n),"enum"===n.type&&(this._enumValues=n.values)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.evaluate=function(e,r){this._evaluator||(this._evaluator=new EvaluationContext),this._evaluator.globals=e,this._evaluator.feature=r;try{var n=this.expression.evaluate(this._evaluator);if(null===n||void 0===n)return this._defaultValue;if(this._enumValues&&!(n in this._enumValues))throw new RuntimeError("Expected value to be one of "+Object.keys(this._enumValues).map(function(e){return JSON.stringify(e)}).join(", ")+", but found "+JSON.stringify(n)+" instead.");return n}catch(e){return this._warningHistory[e.message]||(this._warningHistory[e.message]=!0,"undefined"!=typeof console&&console.warn(e.message)),this._defaultValue}},r}(StyleExpression),ZoomConstantExpression=function(e,r){this.kind=e,this._styleExpression=r};ZoomConstantExpression.prototype.evaluate=function(e,r){return this._styleExpression.evaluate(e,r)};var ZoomDependentExpression=function(e,r,n){this.kind=e,this.zoomStops=n.labels,this._styleExpression=r,n instanceof Interpolate&&(this._interpolationType=n.interpolation)};ZoomDependentExpression.prototype.evaluate=function(e,r){return this._styleExpression.evaluate(e,r)},ZoomDependentExpression.prototype.interpolationFactor=function(e,r,n){return this._interpolationType?Interpolate.interpolationFactor(this._interpolationType,e,r,n):0};var ref$2=_dereq_("../function"),isFunction=ref$2.isFunction,createFunction=ref$2.createFunction,ref$3=_dereq_("./values"),Color=ref$3.Color,StylePropertyFunction=function(e,r){this._parameters=e,this._specification=r,extend(this,createFunction(this._parameters,this._specification))};StylePropertyFunction.deserialize=function(e){return new StylePropertyFunction(e._parameters,e._specification)},StylePropertyFunction.serialize=function(e){return{_parameters:e._parameters,_specification:e._specification}},module.exports={StyleExpression:StyleExpression,StyleExpressionWithErrorHandling:StyleExpressionWithErrorHandling,isExpression:isExpression,createExpression:createExpression,createPropertyExpression:createPropertyExpression,normalizePropertyExpression:normalizePropertyExpression,ZoomConstantExpression:ZoomConstantExpression,ZoomDependentExpression:ZoomDependentExpression,StylePropertyFunction:StylePropertyFunction};var ref$4=_dereq_("./types"),ColorType=ref$4.ColorType,StringType=ref$4.StringType,NumberType=ref$4.NumberType,BooleanType=ref$4.BooleanType,ValueType=ref$4.ValueType,array=ref$4.array;
},{"../function":152,"../util/extend":167,"../util/result":171,"./compound_expression":126,"./definitions":134,"./definitions/coalesce":131,"./definitions/interpolate":135,"./definitions/let":136,"./definitions/step":139,"./evaluation_context":141,"./is_constant":143,"./parsing_context":144,"./parsing_error":145,"./runtime_error":146,"./types":149,"./values":150}],143:[function(_dereq_,module,exports){
"use strict";function isFeatureConstant(n){if(n instanceof CompoundExpression){if("get"===n.name&&1===n.args.length)return!1;if("has"===n.name&&1===n.args.length)return!1;if("properties"===n.name||"geometry-type"===n.name||"id"===n.name)return!1}var e=!0;return n.eachChild(function(n){e&&!isFeatureConstant(n)&&(e=!1)}),e}function isGlobalPropertyConstant(n,e){if(n instanceof CompoundExpression&&e.indexOf(n.name)>=0)return!1;var t=!0;return n.eachChild(function(n){t&&!isGlobalPropertyConstant(n,e)&&(t=!1)}),t}var ref=_dereq_("./compound_expression"),CompoundExpression=ref.CompoundExpression;module.exports={isFeatureConstant:isFeatureConstant,isGlobalPropertyConstant:isGlobalPropertyConstant};
},{"./compound_expression":126}],144:[function(_dereq_,module,exports){
"use strict";function isConstant(e){var r=_dereq_("./compound_expression"),t=r.CompoundExpression,n=_dereq_("./is_constant"),i=n.isGlobalPropertyConstant,o=n.isFeatureConstant;if(e instanceof _dereq_("./definitions/var"))return!1;if(e instanceof t&&"error"===e.name)return!1;var a=!0;return e.eachChild(function(e){e instanceof Literal||(a=!1)}),!!a&&(o(e)&&i(e,["zoom","heatmap-density"]))}var Scope=_dereq_("./scope"),ref=_dereq_("./types"),checkSubtype=ref.checkSubtype,ParsingError=_dereq_("./parsing_error"),Literal=_dereq_("./definitions/literal"),Assertion=_dereq_("./definitions/assertion"),ArrayAssertion=_dereq_("./definitions/array"),Coercion=_dereq_("./definitions/coercion"),ParsingContext=function(e,r,t,n,i){void 0===r&&(r=[]),void 0===n&&(n=new Scope),void 0===i&&(i=[]),this.definitions=e,this.path=r,this.key=r.map(function(e){return"["+e+"]"}).join(""),this.scope=n,this.errors=i,this.expectedType=t};ParsingContext.prototype.parse=function(e,r,t,n,i){void 0===i&&(i={});var o=this;if(r&&(o=o.concat(r,t,n)),null!==e&&"string"!=typeof e&&"boolean"!=typeof e&&"number"!=typeof e||(e=["literal",e]),Array.isArray(e)){if(0===e.length)return o.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var a=e[0];if("string"!=typeof a)return o.error("Expression name must be a string, but found "+typeof a+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var s=o.definitions[a];if(s){var u=s.parse(e,o);if(!u)return null;if(o.expectedType){var p=o.expectedType,l=u.type;if("string"!==p.kind&&"number"!==p.kind&&"boolean"!==p.kind||"value"!==l.kind)if("array"===p.kind&&"value"===l.kind)i.omitTypeAnnotations||(u=new ArrayAssertion(p,u));else if("color"!==p.kind||"value"!==l.kind&&"string"!==l.kind){if(o.checkSubtype(o.expectedType,u.type))return null}else i.omitTypeAnnotations||(u=new Coercion(p,[u]));else i.omitTypeAnnotations||(u=new Assertion(p,[u]))}if(!(u instanceof Literal)&&isConstant(u)){var c=new(_dereq_("./evaluation_context"));try{u=new Literal(u.type,u.evaluate(c))}catch(e){return o.error(e.message),null}}return u}return o.error('Unknown expression "'+a+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===e?o.error("'undefined' value invalid. Use null instead."):"object"==typeof e?o.error('Bare objects invalid. Use ["literal", {...}] instead.'):o.error("Expected an array, but found "+typeof e+" instead.")},ParsingContext.prototype.concat=function(e,r,t){var n="number"==typeof e?this.path.concat(e):this.path,i=t?this.scope.concat(t):this.scope;return new ParsingContext(this.definitions,n,r||null,i,this.errors)},ParsingContext.prototype.error=function(e){for(var r=[],t=arguments.length-1;t-- >0;)r[t]=arguments[t+1];var n=""+this.key+r.map(function(e){return"["+e+"]"}).join("");this.errors.push(new ParsingError(n,e))},ParsingContext.prototype.checkSubtype=function(e,r){var t=checkSubtype(e,r);return t&&this.error(t),t},module.exports=ParsingContext;
},{"./compound_expression":126,"./definitions/array":127,"./definitions/assertion":128,"./definitions/coercion":132,"./definitions/literal":137,"./definitions/var":140,"./evaluation_context":141,"./is_constant":143,"./parsing_error":145,"./scope":147,"./types":149}],145:[function(_dereq_,module,exports){
"use strict";var ParsingError=function(r){function t(t,o){r.call(this,o),this.message=o,this.key=t}return r&&(t.__proto__=r),t.prototype=Object.create(r&&r.prototype),t.prototype.constructor=t,t}(Error);module.exports=ParsingError;
},{}],146:[function(_dereq_,module,exports){
"use strict";var RuntimeError=function(r){this.name="ExpressionEvaluationError",this.message=r};RuntimeError.prototype.toJSON=function(){return this.message},module.exports=RuntimeError;
},{}],147:[function(_dereq_,module,exports){
"use strict";var Scope=function(t,n){var i=this;void 0===n&&(n=[]),this.parent=t,this.bindings={};for(var e=0,r=n;e<r.length;e+=1){var o=r[e],s=o[0],p=o[1];i.bindings[s]=p}};Scope.prototype.concat=function(t){return new Scope(this,t)},Scope.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Scope.prototype.has=function(t){return!!this.bindings[t]||!!this.parent&&this.parent.has(t)},module.exports=Scope;
},{}],148:[function(_dereq_,module,exports){
"use strict";function findStopLessThanOrEqualTo(r,e){for(var n,t,o=r.length,u=0,i=o-1,a=0;u<=i;){if(a=Math.floor((u+i)/2),n=r[a],t=r[a+1],e===n||e>n&&e<t)return a;if(n<e)u=a+1;else{if(!(n>e))throw new RuntimeError("Input is not a number.");i=a-1}}return Math.max(a-1,0)}var RuntimeError=_dereq_("./runtime_error");module.exports={findStopLessThanOrEqualTo:findStopLessThanOrEqualTo};
},{"./runtime_error":146}],149:[function(_dereq_,module,exports){
"use strict";function array(e,r){return{kind:"array",itemType:e,N:r}}function toString(e){if("array"===e.kind){var r=toString(e.itemType);return"number"==typeof e.N?"array<"+r+", "+e.N+">":"value"===e.itemType.kind?"array":"array<"+r+">"}return e.kind}function checkSubtype(e,r){if("error"===r.kind)return null;if("array"===e.kind){if("array"===r.kind&&!checkSubtype(e.itemType,r.itemType)&&("number"!=typeof e.N||e.N===r.N))return null}else{if(e.kind===r.kind)return null;if("value"===e.kind)for(var n=0,y=valueMemberTypes;n<y.length;n+=1){var t=y[n];if(!checkSubtype(t,r))return null}}return"Expected "+toString(e)+" but found "+toString(r)+" instead."}var NullType={kind:"null"},NumberType={kind:"number"},StringType={kind:"string"},BooleanType={kind:"boolean"},ColorType={kind:"color"},ObjectType={kind:"object"},ValueType={kind:"value"},ErrorType={kind:"error"},valueMemberTypes=[NullType,NumberType,StringType,BooleanType,ColorType,ObjectType,array(ValueType)];module.exports={NullType:NullType,NumberType:NumberType,StringType:StringType,BooleanType:BooleanType,ColorType:ColorType,ObjectType:ObjectType,ValueType:ValueType,array:array,ErrorType:ErrorType,toString:toString,checkSubtype:checkSubtype};
},{}],150:[function(_dereq_,module,exports){
"use strict";function validateRGBA(e,r,t,n){if(!("number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255&&"number"==typeof t&&t>=0&&t<=255)){return"Invalid rgba value ["+("number"==typeof n?[e,r,t,n]:[e,r,t]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}return void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[e,r,t,n].join(", ")+"]: 'a' must be between 0 and 1."}function isValue(e){if(null===e)return!0;if("string"==typeof e)return!0;if("boolean"==typeof e)return!0;if("number"==typeof e)return!0;if(e instanceof Color)return!0;if(Array.isArray(e)){for(var r=0,t=e;r<t.length;r+=1){if(!isValue(t[r]))return!1}return!0}if("object"==typeof e){for(var n in e)if(!isValue(e[n]))return!1;return!0}return!1}function typeOf(e){if(null===e)return NullType;if("string"==typeof e)return StringType;if("boolean"==typeof e)return BooleanType;if("number"==typeof e)return NumberType;if(e instanceof Color)return ColorType;if(Array.isArray(e)){for(var r,t=e.length,n=0,u=e;n<u.length;n+=1){var o=u[n],f=typeOf(o);if(r){if(r===f)continue;r=ValueType;break}r=f}return array(r||ValueType,t)}return ObjectType}var Color=_dereq_("../util/color"),ref=_dereq_("./types"),NullType=ref.NullType,NumberType=ref.NumberType,StringType=ref.StringType,BooleanType=ref.BooleanType,ColorType=ref.ColorType,ObjectType=ref.ObjectType,ValueType=ref.ValueType,array=ref.array;module.exports={Color:Color,validateRGBA:validateRGBA,isValue:isValue,typeOf:typeOf};
},{"../util/color":165,"./types":149}],151:[function(_dereq_,module,exports){
"use strict";function isExpressionFilter(e){if(!Array.isArray(e)||0===e.length)return!1;switch(e[0]){case"has":return e.length>=2&&"$id"!==e[1]&&"$type"!==e[1];case"in":case"!in":case"!has":case"none":return!1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3===e.length&&(Array.isArray(e[1])||Array.isArray(e[2]));case"any":case"all":for(var r=0,i=e.slice(1);r<i.length;r+=1){var n=i[r];if(!isExpressionFilter(n)&&"boolean"!=typeof n)return!1}return!0;default:return!0}}function createFilter(e){if(!e)return function(){return!0};if(!isExpressionFilter(e))return new Function("g","f","var p = (f && f.properties || {}); return "+compile(e));var r=createExpression(e,filterSpec);if("error"===r.result)throw new Error(r.value.map(function(e){return e.key+": "+e.message}).join(", "));return function(e,i){return r.value.evaluate(e,i)}}function compile(e){if(!e)return"true";var r=e[0];return e.length<=1?"any"===r?"false":"true":"("+("=="===r?compileComparisonOp(e[1],e[2],"===",!1):"!="===r?compileComparisonOp(e[1],e[2],"!==",!1):"<"===r||">"===r||"<="===r||">="===r?compileComparisonOp(e[1],e[2],r,!0):"any"===r?compileLogicalOp(e.slice(1),"||"):"all"===r?compileLogicalOp(e.slice(1),"&&"):"none"===r?compileNegation(compileLogicalOp(e.slice(1),"||")):"in"===r?compileInOp(e[1],e.slice(2)):"!in"===r?compileNegation(compileInOp(e[1],e.slice(2))):"has"===r?compileHasOp(e[1]):"!has"===r?compileNegation(compileHasOp(e[1])):"true")+")"}function compilePropertyReference(e){return"$type"===e?"f.type":"$id"===e?"f.id":"p["+JSON.stringify(e)+"]"}function compileComparisonOp(e,r,i,n){var t=compilePropertyReference(e),o="$type"===e?types.indexOf(r):JSON.stringify(r);return(n?"typeof "+t+"=== typeof "+o+"&&":"")+t+i+o}function compileLogicalOp(e,r){return e.map(compile).join(r)}function compileInOp(e,r){"$type"===e&&(r=r.map(function(e){return types.indexOf(e)}));var i=JSON.stringify(r.sort(compare)),n=compilePropertyReference(e);return r.length<=200?i+".indexOf("+n+") !== -1":"function(v, a, i, j) {while (i <= j) { var m = (i + j) >> 1;    if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;}return false; }("+n+", "+i+",0,"+(r.length-1)+")"}function compileHasOp(e){return"$id"===e?'"id" in f':JSON.stringify(e)+" in p"}function compileNegation(e){return"!("+e+")"}function compare(e,r){return e<r?-1:e>r?1:0}var ref=_dereq_("../expression"),createExpression=ref.createExpression;module.exports=createFilter,module.exports.isExpressionFilter=isExpressionFilter;var types=["Unknown","Point","LineString","Polygon"],filterSpec={type:"boolean",default:!1,function:!0,"property-function":!0,"zoom-function":!0};
},{"../expression":142}],152:[function(_dereq_,module,exports){
"use strict";function isFunction(e){return"object"==typeof e&&null!==e&&!Array.isArray(e)}function identityFunction(e){return e}function createFunction(e,t){var o="color"===t.type,r=e.stops&&"object"==typeof e.stops[0][0],n=r||void 0!==e.property,a=r||!n,i=e.type||("interpolated"===t.function?"exponential":"interval");if(o&&(e=extend({},e),e.stops&&(e.stops=e.stops.map(function(e){return[e[0],Color.parse(e[1])]})),e.default?e.default=Color.parse(e.default):e.default=Color.parse(t.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!colorSpaces[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);var u,p,l;if("exponential"===i)u=evaluateExponentialFunction;else if("interval"===i)u=evaluateIntervalFunction;else if("categorical"===i){u=evaluateCategoricalFunction,p=Object.create(null);for(var s=0,c=e.stops;s<c.length;s+=1){var f=c[s];p[f[0]]=f[1]}l=typeof e.stops[0][0]}else{if("identity"!==i)throw new Error('Unknown function type "'+i+'"');u=evaluateIdentityFunction}if(r){for(var v={},d=[],y=0;y<e.stops.length;y++){var F=e.stops[y],h=F[0].zoom;void 0===v[h]&&(v[h]={zoom:h,type:e.type,property:e.property,default:e.default,stops:[]},d.push(h)),v[h].stops.push([F[0].value,F[1]])}for(var m=[],g=0,b=d;g<b.length;g+=1){var S=b[g];m.push([v[S].zoom,createFunction(v[S],t)])}return{kind:"composite",interpolationFactor:Interpolate.interpolationFactor.bind(void 0,{name:"linear"}),zoomStops:m.map(function(e){return e[0]}),evaluate:function(o,r){var n=o.zoom;return evaluateExponentialFunction({stops:m,base:e.base},t,n).evaluate(n,r)}}}return a?{kind:"camera",interpolationFactor:"exponential"===i?Interpolate.interpolationFactor.bind(void 0,{name:"exponential",base:void 0!==e.base?e.base:1}):function(){return 0},zoomStops:e.stops.map(function(e){return e[0]}),evaluate:function(o){var r=o.zoom;return u(e,t,r,p,l)}}:{kind:"source",evaluate:function(o,r){var n=r&&r.properties?r.properties[e.property]:void 0;return void 0===n?coalesce(e.default,t.default):u(e,t,n,p,l)}}}function coalesce(e,t,o){return void 0!==e?e:void 0!==t?t:void 0!==o?o:void 0}function evaluateCategoricalFunction(e,t,o,r,n){return coalesce(typeof o===n?r[o]:void 0,e.default,t.default)}function evaluateIntervalFunction(e,t,o){if("number"!==getType(o))return coalesce(e.default,t.default);var r=e.stops.length;if(1===r)return e.stops[0][1];if(o<=e.stops[0][0])return e.stops[0][1];if(o>=e.stops[r-1][0])return e.stops[r-1][1];var n=findStopLessThanOrEqualTo(e.stops,o);return e.stops[n][1]}function evaluateExponentialFunction(e,t,o){var r=void 0!==e.base?e.base:1;if("number"!==getType(o))return coalesce(e.default,t.default);var n=e.stops.length;if(1===n)return e.stops[0][1];if(o<=e.stops[0][0])return e.stops[0][1];if(o>=e.stops[n-1][0])return e.stops[n-1][1];var a=findStopLessThanOrEqualTo(e.stops,o),i=interpolationFactor(o,r,e.stops[a][0],e.stops[a+1][0]),u=e.stops[a][1],p=e.stops[a+1][1],l=interpolate[t.type]||identityFunction;if(e.colorSpace&&"rgb"!==e.colorSpace){var s=colorSpaces[e.colorSpace];l=function(e,t){return s.reverse(s.interpolate(s.forward(e),s.forward(t),i))}}return"function"==typeof u.evaluate?{evaluate:function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var o=u.evaluate.apply(void 0,e),r=p.evaluate.apply(void 0,e);if(void 0!==o&&void 0!==r)return l(o,r,i)}}:l(u,p,i)}function evaluateIdentityFunction(e,t,o){return"color"===t.type?o=Color.parse(o):getType(o)===t.type||"enum"===t.type&&t.values[o]||(o=void 0),coalesce(o,e.default,t.default)}function findStopLessThanOrEqualTo(e,t){for(var o,r,n=e.length,a=0,i=n-1,u=0;a<=i;){if(u=Math.floor((a+i)/2),o=e[u][0],r=e[u+1][0],t===o||t>o&&t<r)return u;o<t?a=u+1:o>t&&(i=u-1)}return Math.max(u-1,0)}function interpolationFactor(e,t,o,r){var n=r-o,a=e-o;return 0===n?0:1===t?a/n:(Math.pow(t,a)-1)/(Math.pow(t,n)-1)}var colorSpaces=_dereq_("../util/color_spaces"),Color=_dereq_("../util/color"),extend=_dereq_("../util/extend"),getType=_dereq_("../util/get_type"),interpolate=_dereq_("../util/interpolate"),Interpolate=_dereq_("../expression/definitions/interpolate");module.exports={createFunction:createFunction,isFunction:isFunction};
},{"../expression/definitions/interpolate":135,"../util/color":165,"../util/color_spaces":166,"../util/extend":167,"../util/get_type":168,"../util/interpolate":169}],153:[function(_dereq_,module,exports){
"use strict";function stringify(r){var t=typeof r;if("number"===t||"boolean"===t||"string"===t||void 0===r||null===r)return JSON.stringify(r);if(Array.isArray(r)){for(var e="[",i=0,n=r;i<n.length;i+=1){e+=stringify(n[i])+","}return e+"]"}for(var o=Object.keys(r).sort(),f="{",u=0;u<o.length;u++)f+=JSON.stringify(o[u])+":"+stringify(r[o[u]])+",";return f+"}"}function getKey(r){for(var t="",e=0,i=refProperties;e<i.length;e+=1){t+="/"+stringify(r[i[e]])}return t}function groupByLayout(r){for(var t={},e=0;e<r.length;e++){var i=getKey(r[e]),n=t[i];n||(n=t[i]=[]),n.push(r[e])}var o=[];for(var f in t)o.push(t[f]);return o}var refProperties=_dereq_("./util/ref_properties");module.exports=groupByLayout;
},{"./util/ref_properties":170}],154:[function(_dereq_,module,exports){
function clamp_css_byte(e){return e=Math.round(e),e<0?0:e>255?255:e}function clamp_css_float(e){return e<0?0:e>1?1:e}function parse_css_int(e){return clamp_css_byte("%"===e[e.length-1]?parseFloat(e)/100*255:parseInt(e))}function parse_css_float(e){return clamp_css_float("%"===e[e.length-1]?parseFloat(e)/100:parseFloat(e))}function css_hue_to_rgb(e,r,l){return l<0?l+=1:l>1&&(l-=1),6*l<1?e+(r-e)*l*6:2*l<1?r:3*l<2?e+(r-e)*(2/3-l)*6:e}function parseCSSColor(e){var r=e.replace(/ /g,"").toLowerCase();if(r in kCSSColorTable)return kCSSColorTable[r].slice();if("#"===r[0]){if(4===r.length){var l=parseInt(r.substr(1),16);return l>=0&&l<=4095?[(3840&l)>>4|(3840&l)>>8,240&l|(240&l)>>4,15&l|(15&l)<<4,1]:null}if(7===r.length){var l=parseInt(r.substr(1),16);return l>=0&&l<=16777215?[(16711680&l)>>16,(65280&l)>>8,255&l,1]:null}return null}var a=r.indexOf("("),t=r.indexOf(")");if(-1!==a&&t+1===r.length){var n=r.substr(0,a),s=r.substr(a+1,t-(a+1)).split(","),o=1;switch(n){case"rgba":if(4!==s.length)return null;o=parse_css_float(s.pop());case"rgb":return 3!==s.length?null:[parse_css_int(s[0]),parse_css_int(s[1]),parse_css_int(s[2]),o];case"hsla":if(4!==s.length)return null;o=parse_css_float(s.pop());case"hsl":if(3!==s.length)return null;var i=(parseFloat(s[0])%360+360)%360/360,u=parse_css_float(s[1]),g=parse_css_float(s[2]),d=g<=.5?g*(u+1):g+u-g*u,c=2*g-d;return[clamp_css_byte(255*css_hue_to_rgb(c,d,i+1/3)),clamp_css_byte(255*css_hue_to_rgb(c,d,i)),clamp_css_byte(255*css_hue_to_rgb(c,d,i-1/3)),o];default:return null}}return null}var kCSSColorTable={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};try{exports.parseCSSColor=parseCSSColor}catch(e){}
},{}],155:[function(_dereq_,module,exports){
function isObjectLike(r){return!!r&&"object"==typeof r}function arraySome(r,e){for(var a=-1,t=r.length;++a<t;)if(e(r[a],a,r))return!0;return!1}function baseIsEqual(r,e,a,t,o,n){return r===e||(null==r||null==e||!isObject(r)&&!isObjectLike(e)?r!==r&&e!==e:baseIsEqualDeep(r,e,baseIsEqual,a,t,o,n))}function baseIsEqualDeep(r,e,a,t,o,n,u){var c=isArray(r),s=isArray(e),i=arrayTag,g=arrayTag;c||(i=objToString.call(r),i==argsTag?i=objectTag:i!=objectTag&&(c=isTypedArray(r))),s||(g=objToString.call(e),g==argsTag?g=objectTag:g!=objectTag&&(s=isTypedArray(e)));var b=i==objectTag,l=g==objectTag,f=i==g;if(f&&!c&&!b)return equalByTag(r,e,i);if(!o){var y=b&&hasOwnProperty.call(r,"__wrapped__"),T=l&&hasOwnProperty.call(e,"__wrapped__");if(y||T)return a(y?r.value():r,T?e.value():e,t,o,n,u)}if(!f)return!1;n||(n=[]),u||(u=[]);for(var j=n.length;j--;)if(n[j]==r)return u[j]==e;n.push(r),u.push(e);var p=(c?equalArrays:equalObjects)(r,e,a,t,o,n,u);return n.pop(),u.pop(),p}function equalArrays(r,e,a,t,o,n,u){var c=-1,s=r.length,i=e.length;if(s!=i&&!(o&&i>s))return!1;for(;++c<s;){var g=r[c],b=e[c],l=t?t(o?b:g,o?g:b,c):void 0;if(void 0!==l){if(l)continue;return!1}if(o){if(!arraySome(e,function(r){return g===r||a(g,r,t,o,n,u)}))return!1}else if(g!==b&&!a(g,b,t,o,n,u))return!1}return!0}function equalByTag(r,e,a){switch(a){case boolTag:case dateTag:return+r==+e;case errorTag:return r.name==e.name&&r.message==e.message;case numberTag:return r!=+r?e!=+e:r==+e;case regexpTag:case stringTag:return r==e+""}return!1}function equalObjects(r,e,a,t,o,n,u){var c=keys(r),s=c.length;if(s!=keys(e).length&&!o)return!1;for(var i=s;i--;){var g=c[i];if(!(o?g in e:hasOwnProperty.call(e,g)))return!1}for(var b=o;++i<s;){g=c[i];var l=r[g],f=e[g],y=t?t(o?f:l,o?l:f,g):void 0;if(!(void 0===y?a(l,f,t,o,n,u):y))return!1;b||(b="constructor"==g)}if(!b){var T=r.constructor,j=e.constructor;if(T!=j&&"constructor"in r&&"constructor"in e&&!("function"==typeof T&&T instanceof T&&"function"==typeof j&&j instanceof j))return!1}return!0}function isObject(r){var e=typeof r;return!!r&&("object"==e||"function"==e)}var isArray=_dereq_("lodash.isarray"),isTypedArray=_dereq_("lodash.istypedarray"),keys=_dereq_("lodash.keys"),argsTag="[object Arguments]",arrayTag="[object Array]",boolTag="[object Boolean]",dateTag="[object Date]",errorTag="[object Error]",numberTag="[object Number]",objectTag="[object Object]",regexpTag="[object RegExp]",stringTag="[object String]",objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString;module.exports=baseIsEqual;
},{"lodash.isarray":159,"lodash.istypedarray":161,"lodash.keys":162}],156:[function(_dereq_,module,exports){
function bindCallback(n,t,r){if("function"!=typeof n)return identity;if(void 0===t)return n;switch(r){case 1:return function(r){return n.call(t,r)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,c){return n.call(t,r,e,u,c)};case 5:return function(r,e,u,c,i){return n.call(t,r,e,u,c,i)}}return function(){return n.apply(t,arguments)}}function identity(n){return n}module.exports=bindCallback;
},{}],157:[function(_dereq_,module,exports){
function isObjectLike(t){return!!t&&"object"==typeof t}function getNative(t,o){var e=null==t?void 0:t[o];return isNative(e)?e:void 0}function isFunction(t){return isObject(t)&&objToString.call(t)==funcTag}function isObject(t){var o=typeof t;return!!t&&("object"==o||"function"==o)}function isNative(t){return null!=t&&(isFunction(t)?reIsNative.test(fnToString.call(t)):isObjectLike(t)&&reIsHostCtor.test(t))}var funcTag="[object Function]",reIsHostCtor=/^\[object .+?Constructor\]$/,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp("^"+fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");module.exports=getNative;
},{}],158:[function(_dereq_,module,exports){
function isArguments(t){return isArrayLikeObject(t)&&hasOwnProperty.call(t,"callee")&&(!propertyIsEnumerable.call(t,"callee")||objectToString.call(t)==argsTag)}function isArrayLike(t){return null!=t&&isLength(t.length)&&!isFunction(t)}function isArrayLikeObject(t){return isObjectLike(t)&&isArrayLike(t)}function isFunction(t){var e=isObject(t)?objectToString.call(t):"";return e==funcTag||e==genTag}function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=MAX_SAFE_INTEGER}function isObject(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function isObjectLike(t){return!!t&&"object"==typeof t}var MAX_SAFE_INTEGER=9007199254740991,argsTag="[object Arguments]",funcTag="[object Function]",genTag="[object GeneratorFunction]",objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,objectToString=objectProto.toString,propertyIsEnumerable=objectProto.propertyIsEnumerable;module.exports=isArguments;
},{}],159:[function(_dereq_,module,exports){
function isObjectLike(t){return!!t&&"object"==typeof t}function getNative(t,r){var e=null==t?void 0:t[r];return isNative(e)?e:void 0}function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=MAX_SAFE_INTEGER}function isFunction(t){return isObject(t)&&objToString.call(t)==funcTag}function isObject(t){var r=typeof t;return!!t&&("object"==r||"function"==r)}function isNative(t){return null!=t&&(isFunction(t)?reIsNative.test(fnToString.call(t)):isObjectLike(t)&&reIsHostCtor.test(t))}var arrayTag="[object Array]",funcTag="[object Function]",reIsHostCtor=/^\[object .+?Constructor\]$/,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp("^"+fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),nativeIsArray=getNative(Array,"isArray"),MAX_SAFE_INTEGER=9007199254740991,isArray=nativeIsArray||function(t){return isObjectLike(t)&&isLength(t.length)&&objToString.call(t)==arrayTag};module.exports=isArray;
},{}],160:[function(_dereq_,module,exports){
function isEqual(a,l,i,e){i="function"==typeof i?bindCallback(i,e,3):void 0;var s=i?i(a,l):void 0;return void 0===s?baseIsEqual(a,l,i):!!s}var baseIsEqual=_dereq_("lodash._baseisequal"),bindCallback=_dereq_("lodash._bindcallback");module.exports=isEqual;
},{"lodash._baseisequal":155,"lodash._bindcallback":156}],161:[function(_dereq_,module,exports){
function isLength(a){return"number"==typeof a&&a>-1&&a%1==0&&a<=MAX_SAFE_INTEGER}function isObjectLike(a){return!!a&&"object"==typeof a}function isTypedArray(a){return isObjectLike(a)&&isLength(a.length)&&!!typedArrayTags[objectToString.call(a)]}var MAX_SAFE_INTEGER=9007199254740991,argsTag="[object Arguments]",arrayTag="[object Array]",boolTag="[object Boolean]",dateTag="[object Date]",errorTag="[object Error]",funcTag="[object Function]",mapTag="[object Map]",numberTag="[object Number]",objectTag="[object Object]",regexpTag="[object RegExp]",setTag="[object Set]",stringTag="[object String]",weakMapTag="[object WeakMap]",arrayBufferTag="[object ArrayBuffer]",dataViewTag="[object DataView]",float32Tag="[object Float32Array]",float64Tag="[object Float64Array]",int8Tag="[object Int8Array]",int16Tag="[object Int16Array]",int32Tag="[object Int32Array]",uint8Tag="[object Uint8Array]",uint8ClampedTag="[object Uint8ClampedArray]",uint16Tag="[object Uint16Array]",uint32Tag="[object Uint32Array]",typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var objectProto=Object.prototype,objectToString=objectProto.toString;module.exports=isTypedArray;
},{}],162:[function(_dereq_,module,exports){
function baseProperty(e){return function(t){return null==t?void 0:t[e]}}function isArrayLike(e){return null!=e&&isLength(getLength(e))}function isIndex(e,t){return e="number"==typeof e||reIsUint.test(e)?+e:-1,t=null==t?MAX_SAFE_INTEGER:t,e>-1&&e%1==0&&e<t}function isLength(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=MAX_SAFE_INTEGER}function shimKeys(e){for(var t=keysIn(e),r=t.length,n=r&&e.length,s=!!n&&isLength(n)&&(isArray(e)||isArguments(e)),o=-1,i=[];++o<r;){var u=t[o];(s&&isIndex(u,n)||hasOwnProperty.call(e,u))&&i.push(u)}return i}function isObject(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function keysIn(e){if(null==e)return[];isObject(e)||(e=Object(e));var t=e.length;t=t&&isLength(t)&&(isArray(e)||isArguments(e))&&t||0;for(var r=e.constructor,n=-1,s="function"==typeof r&&r.prototype===e,o=Array(t),i=t>0;++n<t;)o[n]=n+"";for(var u in e)i&&isIndex(u,t)||"constructor"==u&&(s||!hasOwnProperty.call(e,u))||o.push(u);return o}var getNative=_dereq_("lodash._getnative"),isArguments=_dereq_("lodash.isarguments"),isArray=_dereq_("lodash.isarray"),reIsUint=/^\d+$/,objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,nativeKeys=getNative(Object,"keys"),MAX_SAFE_INTEGER=9007199254740991,getLength=baseProperty("length"),keys=nativeKeys?function(e){var t=null==e?void 0:e.constructor;return"function"==typeof t&&t.prototype===e||"function"!=typeof e&&isArrayLike(e)?shimKeys(e):isObject(e)?nativeKeys(e):[]}:shimKeys;module.exports=keys;
},{"lodash._getnative":157,"lodash.isarguments":158,"lodash.isarray":159}],163:[function(_dereq_,module,exports){
"use strict";module.exports=_dereq_("./v8.json");
},{"./v8.json":164}],164:[function(_dereq_,module,exports){
module.exports={"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image","source_canvas"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.0511,180,85.0511]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.0511,180,85.0511]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.0511,180,85.0511]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_canvas":{"type":{"required":true,"type":"enum","values":{"canvas":{}}},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}},"animate":{"type":"boolean","default":"true"},"canvas":{"type":"string","required":true}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_fill":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_circle":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_line":{"line-cap":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"butt":{},"round":{},"square":{}},"default":"butt"},"line-join":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"bevel":{},"round":{},"miter":{}},"default":"miter"},"line-miter-limit":{"type":"number","default":2,"function":"interpolated","zoom-function":true,"requires":[{"line-join":"miter"}]},"line-round-limit":{"type":"number","default":1.05,"function":"interpolated","zoom-function":true,"requires":[{"line-join":"round"}]},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_symbol":{"symbol-placement":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"point":{},"line":{}},"default":"point"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"function":"interpolated","zoom-function":true,"units":"pixels","requires":[{"symbol-placement":"line"}]},"symbol-avoid-edges":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false},"icon-allow-overlap":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["icon-image"]},"icon-ignore-placement":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["icon-image"]},"icon-optional":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["icon-image","text-field"]},"icon-rotation-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"]},"icon-size":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"units":"factor of the original icon size","requires":["icon-image"]},"icon-text-fit":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"]},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","function":"interpolated","zoom-function":true,"requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}]},"icon-image":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"tokens":true},"icon-rotate":{"type":"number","default":0,"period":360,"function":"interpolated","zoom-function":true,"property-function":true,"units":"degrees","requires":["icon-image"]},"icon-padding":{"type":"number","default":2,"minimum":0,"function":"interpolated","zoom-function":true,"units":"pixels","requires":["icon-image"]},"icon-keep-upright":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":"line"}]},"icon-offset":{"type":"array","value":"number","units":"pixels multiplied by the value of \"icon-size\"","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"requires":["icon-image"]},"icon-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"]},"icon-pitch-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"]},"text-pitch-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"]},"text-rotation-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"]},"text-field":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":"","tokens":true},"text-font":{"type":"array","value":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"]},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-line-height":{"type":"number","default":1.2,"units":"ems","function":"interpolated","zoom-function":true,"requires":["text-field"]},"text-letter-spacing":{"type":"number","default":0,"units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-justify":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"]},"text-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field"]},"text-max-angle":{"type":"number","default":45,"units":"degrees","function":"interpolated","zoom-function":true,"requires":["text-field",{"symbol-placement":"line"}]},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","function":"interpolated","zoom-function":true,"requires":["text-field"]},"text-keep-upright":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":"line"}]},"text-transform":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"]},"text-offset":{"type":"array","value":"number","units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"length":2,"default":[0,0],"requires":["text-field"]},"text-allow-overlap":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["text-field"]},"text-ignore-placement":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["text-field"]},"text-optional":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":false,"requires":["text-field","icon-image"]},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible"}},"filter":{"type":"array","value":"*"},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":22,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"expression_name":{"type":"enum","values":{"let":{"group":"Variable binding"},"var":{"group":"Variable binding"},"literal":{"group":"Types"},"array":{"group":"Types"},"at":{"group":"Lookup"},"case":{"group":"Decision"},"match":{"group":"Decision"},"coalesce":{"group":"Decision"},"step":{"group":"Ramps, scales, curves"},"interpolate":{"group":"Ramps, scales, curves"},"ln2":{"group":"Math"},"pi":{"group":"Math"},"e":{"group":"Math"},"typeof":{"group":"Types"},"string":{"group":"Types"},"number":{"group":"Types"},"boolean":{"group":"Types"},"object":{"group":"Types"},"to-string":{"group":"Types"},"to-number":{"group":"Types"},"to-boolean":{"group":"Types"},"to-rgba":{"group":"Color"},"to-color":{"group":"Types"},"rgb":{"group":"Color"},"rgba":{"group":"Color"},"get":{"group":"Lookup"},"has":{"group":"Lookup"},"length":{"group":"Lookup"},"properties":{"group":"Feature data"},"geometry-type":{"group":"Feature data"},"id":{"group":"Feature data"},"zoom":{"group":"Zoom"},"heatmap-density":{"group":"Heatmap"},"+":{"group":"Math"},"*":{"group":"Math"},"-":{"group":"Math"},"/":{"group":"Math"},"%":{"group":"Math"},"^":{"group":"Math"},"sqrt":{"group":"Math"},"log10":{"group":"Math"},"ln":{"group":"Math"},"log2":{"group":"Math"},"sin":{"group":"Math"},"cos":{"group":"Math"},"tan":{"group":"Math"},"asin":{"group":"Math"},"acos":{"group":"Math"},"atan":{"group":"Math"},"min":{"group":"Math"},"max":{"group":"Math"},"==":{"group":"Decision"},"!=":{"group":"Decision"},">":{"group":"Decision"},"<":{"group":"Decision"},">=":{"group":"Decision"},"<=":{"group":"Decision"},"all":{"group":"Decision"},"any":{"group":"Decision"},"!":{"group":"Decision"},"upcase":{"group":"String"},"downcase":{"group":"String"},"concat":{"group":"String"}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"transition":false,"zoom-function":true,"property-function":false,"function":"piecewise-constant"},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"function":"interpolated","zoom-function":true,"property-function":false},"color":{"type":"color","default":"#ffffff","function":"interpolated","zoom-function":true,"property-function":false,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":false,"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],"paint_fill":{"fill-antialias":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"default":true},"fill-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"fill-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-pattern"}]},"fill-outline-color":{"type":"color","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}]},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels"},"fill-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"]},"fill-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"transition":true}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":false,"default":1,"minimum":0,"maximum":1,"transition":true},"fill-extrusion-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-extrusion-pattern"}]},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels"},"fill-extrusion-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"]},"fill-extrusion-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"transition":true},"fill-extrusion-height":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":0,"minimum":0,"units":"meters","transition":true},"fill-extrusion-base":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"]}},"paint_line":{"line-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"line-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"line-pattern"}]},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels"},"line-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"]},"line-width":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-gap-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-offset":{"type":"number","default":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-dasharray":{"type":"array","value":"number","function":"piecewise-constant","zoom-function":true,"minimum":0,"transition":true,"units":"line widths","requires":[{"!":"line-pattern"}]},"line-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"transition":true}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"circle-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-blur":{"type":"number","default":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels"},"circle-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"]},"circle-pitch-scale":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map"},"circle-pitch-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"viewport"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"circle-stroke-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":false},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":false,"transition":true},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"function":"interpolated","zoom-function":false,"property-function":false,"transition":false},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":false,"transition":true}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-halo-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"]},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-halo-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-halo-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"]}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-hue-rotate":{"type":"number","default":0,"period":360,"function":"interpolated","zoom-function":true,"transition":true,"units":"degrees"},"raster-brightness-min":{"type":"number","function":"interpolated","zoom-function":true,"default":0,"minimum":0,"maximum":1,"transition":true},"raster-brightness-max":{"type":"number","function":"interpolated","zoom-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"function":"interpolated","zoom-function":true,"transition":false,"units":"milliseconds"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"function":"interpolated","zoom-function":true,"transition":true},"hillshade-illumination-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"map":{},"viewport":{}},"default":"viewport"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"hillshade-shadow-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"transition":true},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","function":"interpolated","zoom-function":true,"transition":true},"hillshade-accent-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"transition":true}},"paint_background":{"background-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"transition":true,"requires":[{"!":"background-pattern"}]},"background-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"transition":true},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}}}
},{}],165:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("csscolorparser"),parseCSSColor=ref.parseCSSColor,Color=function(r,o,t,e){void 0===e&&(e=1),this.r=r,this.g=o,this.b=t,this.a=e};Color.parse=function(r){if(r){if(r instanceof Color)return r;if("string"==typeof r){var o=parseCSSColor(r);if(o)return new Color(o[0]/255*o[3],o[1]/255*o[3],o[2]/255*o[3],o[3])}}},Color.prototype.toString=function(){var r=this,o=function(o){return Math.round(255*o/r.a)};return"rgba("+[this.r,this.g,this.b].map(o).concat(this.a).join(",")+")"},Color.black=new Color(0,0,0,1),Color.white=new Color(1,1,1,1),Color.transparent=new Color(0,0,0,0),module.exports=Color;
},{"csscolorparser":154}],166:[function(_dereq_,module,exports){
"use strict";function xyz2lab(a){return a>t3?Math.pow(a,1/3):a/t2+t0}function lab2xyz(a){return a>t1?a*a*a:t2*(a-t0)}function xyz2rgb(a){return 255*(a<=.0031308?12.92*a:1.055*Math.pow(a,1/2.4)-.055)}function rgb2xyz(a){return a/=255,a<=.04045?a/12.92:Math.pow((a+.055)/1.055,2.4)}function rgbToLab(a){var r=rgb2xyz(a.r),t=rgb2xyz(a.g),e=rgb2xyz(a.b),n=xyz2lab((.4124564*r+.3575761*t+.1804375*e)/Xn),l=xyz2lab((.2126729*r+.7151522*t+.072175*e)/Yn);return{l:116*l-16,a:500*(n-l),b:200*(l-xyz2lab((.0193339*r+.119192*t+.9503041*e)/Zn)),alpha:a.a}}function labToRgb(a){var r=(a.l+16)/116,t=isNaN(a.a)?r:r+a.a/500,e=isNaN(a.b)?r:r-a.b/200;return r=Yn*lab2xyz(r),t=Xn*lab2xyz(t),e=Zn*lab2xyz(e),new Color(xyz2rgb(3.2404542*t-1.5371385*r-.4985314*e),xyz2rgb(-.969266*t+1.8760108*r+.041556*e),xyz2rgb(.0556434*t-.2040259*r+1.0572252*e),a.alpha)}function interpolateLab(a,r,t){return{l:interpolateNumber(a.l,r.l,t),a:interpolateNumber(a.a,r.a,t),b:interpolateNumber(a.b,r.b,t),alpha:interpolateNumber(a.alpha,r.alpha,t)}}function rgbToHcl(a){var r=rgbToLab(a),t=r.l,e=r.a,n=r.b,l=Math.atan2(n,e)*rad2deg;return{h:l<0?l+360:l,c:Math.sqrt(e*e+n*n),l:t,alpha:a.a}}function hclToRgb(a){var r=a.h*deg2rad,t=a.c;return labToRgb({l:a.l,a:Math.cos(r)*t,b:Math.sin(r)*t,alpha:a.alpha})}function interpolateHue(a,r,t){var e=r-a;return a+t*(e>180||e<-180?e-360*Math.round(e/360):e)}function interpolateHcl(a,r,t){return{h:interpolateHue(a.h,r.h,t),c:interpolateNumber(a.c,r.c,t),l:interpolateNumber(a.l,r.l,t),alpha:interpolateNumber(a.alpha,r.alpha,t)}}var Color=_dereq_("./color"),interpolateNumber=_dereq_("./interpolate").number,Xn=.95047,Yn=1,Zn=1.08883,t0=4/29,t1=6/29,t2=3*t1*t1,t3=t1*t1*t1,deg2rad=Math.PI/180,rad2deg=180/Math.PI;module.exports={lab:{forward:rgbToLab,reverse:labToRgb,interpolate:interpolateLab},hcl:{forward:rgbToHcl,reverse:hclToRgb,interpolate:interpolateHcl}};
},{"./color":165,"./interpolate":169}],167:[function(_dereq_,module,exports){
"use strict";module.exports=function(r){for(var t=[],e=arguments.length-1;e-- >0;)t[e]=arguments[e+1];for(var n=0,o=t;n<o.length;n+=1){var a=o[n];for(var f in a)r[f]=a[f]}return r};
},{}],168:[function(_dereq_,module,exports){
"use strict";module.exports=function(n){return n instanceof Number?"number":n instanceof String?"string":n instanceof Boolean?"boolean":Array.isArray(n)?"array":null===n?"null":typeof n};
},{}],169:[function(_dereq_,module,exports){
"use strict";function number(r,n,u){return r*(1-u)+n*u}function color(r,n,u){return new Color(number(r.r,n.r,u),number(r.g,n.g,u),number(r.b,n.b,u),number(r.a,n.a,u))}function array(r,n,u){return r.map(function(r,e){return number(r,n[e],u)})}var Color=_dereq_("./color");module.exports={number:number,color:color,array:array};
},{"./color":165}],170:[function(_dereq_,module,exports){
"use strict";module.exports=["type","source","source-layer","minzoom","maxzoom","filter","layout"];
},{}],171:[function(_dereq_,module,exports){
"use strict";function success(r){return{result:"success",value:r}}function error(r){return{result:"error",value:r}}module.exports={success:success,error:error};
},{}],172:[function(_dereq_,module,exports){
"use strict";function unbundle(e){return e instanceof Number||e instanceof String||e instanceof Boolean?e.valueOf():e}function deepUnbundle(e){return Array.isArray(e)?e.map(deepUnbundle):unbundle(e)}module.exports=unbundle,module.exports.deep=deepUnbundle;
},{}],173:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),extend=_dereq_("../util/extend"),unbundle=_dereq_("../util/unbundle_jsonlint"),ref=_dereq_("../expression"),isExpression=ref.isExpression,ref$1=_dereq_("../function"),isFunction=ref$1.isFunction;module.exports=function(e){var r=_dereq_("./validate_function"),i=_dereq_("./validate_expression"),t=_dereq_("./validate_object"),n={"*":function(){return[]},array:_dereq_("./validate_array"),boolean:_dereq_("./validate_boolean"),number:_dereq_("./validate_number"),color:_dereq_("./validate_color"),constants:_dereq_("./validate_constants"),enum:_dereq_("./validate_enum"),filter:_dereq_("./validate_filter"),function:_dereq_("./validate_function"),layer:_dereq_("./validate_layer"),object:_dereq_("./validate_object"),source:_dereq_("./validate_source"),light:_dereq_("./validate_light"),string:_dereq_("./validate_string")},a=e.value,u=e.valueSpec,o=e.key,l=e.styleSpec,s=e.style;if("string"===getType(a)&&"@"===a[0]){if(l.$version>7)return[new ValidationError(o,a,"constants have been deprecated as of v8")];if(!(a in s.constants))return[new ValidationError(o,a,'constant "%s" not found',a)];e=extend({},e,{value:s.constants[a]})}return u.function&&isFunction(unbundle(a))?r(e):u.function&&isExpression(unbundle.deep(a))?i(e):u.type&&n[u.type]?n[u.type](e):t(extend({},e,{valueSpec:u.type?l[u.type]:u}))};
},{"../error/validation_error":125,"../expression":142,"../function":152,"../util/extend":167,"../util/get_type":168,"../util/unbundle_jsonlint":172,"./validate_array":174,"./validate_boolean":175,"./validate_color":176,"./validate_constants":177,"./validate_enum":178,"./validate_expression":179,"./validate_filter":180,"./validate_function":181,"./validate_layer":183,"./validate_light":185,"./validate_number":186,"./validate_object":187,"./validate_source":190,"./validate_string":191}],174:[function(_dereq_,module,exports){
"use strict";var getType=_dereq_("../util/get_type"),validate=_dereq_("./validate"),ValidationError=_dereq_("../error/validation_error");module.exports=function(e){var r=e.value,t=e.valueSpec,a=e.style,n=e.styleSpec,l=e.key,i=e.arrayElementValidator||validate;if("array"!==getType(r))return[new ValidationError(l,r,"array expected, %s found",getType(r))];if(t.length&&r.length!==t.length)return[new ValidationError(l,r,"array length %d expected, length %d found",t.length,r.length)];if(t["min-length"]&&r.length<t["min-length"])return[new ValidationError(l,r,"array length at least %d expected, length %d found",t["min-length"],r.length)];var o={type:t.value};n.$version<7&&(o.function=t.function),"object"===getType(t.value)&&(o=t.value);for(var u=[],d=0;d<r.length;d++)u=u.concat(i({array:r,arrayIndex:d,value:r[d],valueSpec:o,style:a,styleSpec:n,key:l+"["+d+"]"}));return u};
},{"../error/validation_error":125,"../util/get_type":168,"./validate":173}],175:[function(_dereq_,module,exports){
"use strict";var getType=_dereq_("../util/get_type"),ValidationError=_dereq_("../error/validation_error");module.exports=function(e){var r=e.value,o=e.key,t=getType(r);return"boolean"!==t?[new ValidationError(o,r,"boolean expected, %s found",t)]:[]};
},{"../error/validation_error":125,"../util/get_type":168}],176:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),parseCSSColor=_dereq_("csscolorparser").parseCSSColor;module.exports=function(r){var e=r.key,o=r.value,t=getType(o);return"string"!==t?[new ValidationError(e,o,"color expected, %s found",t)]:null===parseCSSColor(o)?[new ValidationError(e,o,'color expected, "%s" found',o)]:[]};
},{"../error/validation_error":125,"../util/get_type":168,"csscolorparser":154}],177:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error");module.exports=function(r){var e=r.key,a=r.value;return a?[new ValidationError(e,a,"constants have been deprecated as of v8")]:[]};
},{"../error/validation_error":125}],178:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),unbundle=_dereq_("../util/unbundle_jsonlint");module.exports=function(e){var r=e.key,n=e.value,u=e.valueSpec,i=[];return Array.isArray(u.values)?-1===u.values.indexOf(unbundle(n))&&i.push(new ValidationError(r,n,"expected one of [%s], %s found",u.values.join(", "),JSON.stringify(n))):-1===Object.keys(u.values).indexOf(unbundle(n))&&i.push(new ValidationError(r,n,"expected one of [%s], %s found",Object.keys(u.values).join(", "),JSON.stringify(n))),i};
},{"../error/validation_error":125,"../util/unbundle_jsonlint":172}],179:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),ref=_dereq_("../expression"),createExpression=ref.createExpression,createPropertyExpression=ref.createPropertyExpression,unbundle=_dereq_("../util/unbundle_jsonlint");module.exports=function(e){var r=("property"===e.expressionContext?createPropertyExpression:createExpression)(unbundle.deep(e.value),e.valueSpec);return"error"===r.result?r.value.map(function(r){return new ValidationError(""+e.key+r.key,e.value,r.message)}):"property"===e.expressionContext&&"text-font"===e.propertyKey&&-1!==r.value._styleExpression.expression.possibleOutputs().indexOf(void 0)?[new ValidationError(e.key,e.value,'Invalid data expression for "text-font". Output values must be contained as literals within the expression.')]:[]};
},{"../error/validation_error":125,"../expression":142,"../util/unbundle_jsonlint":172}],180:[function(_dereq_,module,exports){
"use strict";function validateNonExpressionFilter(e){var r=e.value,t=e.key;if("array"!==getType(r))return[new ValidationError(t,r,"array expected, %s found",getType(r))];var a,n=e.styleSpec,s=[];if(r.length<1)return[new ValidationError(t,r,"filter array must have at least 1 element")];switch(s=s.concat(validateEnum({key:t+"[0]",value:r[0],valueSpec:n.filter_operator,style:e.style,styleSpec:e.styleSpec})),unbundle(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===unbundle(r[1])&&s.push(new ValidationError(t,r,'"$type" cannot be use with operator "%s"',r[0]));case"==":case"!=":3!==r.length&&s.push(new ValidationError(t,r,'filter array for operator "%s" must have 3 elements',r[0]));case"in":case"!in":r.length>=2&&"string"!==(a=getType(r[1]))&&s.push(new ValidationError(t+"[1]",r[1],"string expected, %s found",a));for(var i=2;i<r.length;i++)a=getType(r[i]),"$type"===unbundle(r[1])?s=s.concat(validateEnum({key:t+"["+i+"]",value:r[i],valueSpec:n.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==a&&"number"!==a&&"boolean"!==a&&s.push(new ValidationError(t+"["+i+"]",r[i],"string, number, or boolean expected, %s found",a));break;case"any":case"all":case"none":for(var l=1;l<r.length;l++)s=s.concat(validateNonExpressionFilter({key:t+"["+l+"]",value:r[l],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":a=getType(r[1]),2!==r.length?s.push(new ValidationError(t,r,'filter array for "%s" operator must have 2 elements',r[0])):"string"!==a&&s.push(new ValidationError(t+"[1]",r[1],"string expected, %s found",a))}return s}var ValidationError=_dereq_("../error/validation_error"),validateExpression=_dereq_("./validate_expression"),validateEnum=_dereq_("./validate_enum"),getType=_dereq_("../util/get_type"),unbundle=_dereq_("../util/unbundle_jsonlint"),extend=_dereq_("../util/extend"),ref=_dereq_("../feature_filter"),isExpressionFilter=ref.isExpressionFilter;module.exports=function(e){return isExpressionFilter(unbundle.deep(e.value))?validateExpression(extend({},e,{expressionContext:"filter",valueSpec:{value:"boolean"}})):validateNonExpressionFilter(e)};
},{"../error/validation_error":125,"../feature_filter":151,"../util/extend":167,"../util/get_type":168,"../util/unbundle_jsonlint":172,"./validate_enum":178,"./validate_expression":179}],181:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),validate=_dereq_("./validate"),validateObject=_dereq_("./validate_object"),validateArray=_dereq_("./validate_array"),validateNumber=_dereq_("./validate_number"),unbundle=_dereq_("../util/unbundle_jsonlint");module.exports=function(e){function t(e){if("identity"===p)return[new ValidationError(e.key,e.value,'identity function may not have a "stops" property')];var t=[],a=e.value;return t=t.concat(validateArray({key:e.key,value:a,valueSpec:e.valueSpec,style:e.style,styleSpec:e.styleSpec,arrayElementValidator:r})),"array"===getType(a)&&0===a.length&&t.push(new ValidationError(e.key,a,"array must have at least one stop")),t}function r(e){var t=[],r=e.value,o=e.key;if("array"!==getType(r))return[new ValidationError(o,r,"array expected, %s found",getType(r))];if(2!==r.length)return[new ValidationError(o,r,"array length %d expected, length %d found",2,r.length)];if(d){if("object"!==getType(r[0]))return[new ValidationError(o,r,"object expected, %s found",getType(r[0]))];if(void 0===r[0].zoom)return[new ValidationError(o,r,"object stop key must have zoom")];if(void 0===r[0].value)return[new ValidationError(o,r,"object stop key must have value")];if(l&&l>unbundle(r[0].zoom))return[new ValidationError(o,r[0].zoom,"stop zoom values must appear in ascending order")];unbundle(r[0].zoom)!==l&&(l=unbundle(r[0].zoom),i=void 0,s={}),t=t.concat(validateObject({key:o+"[0]",value:r[0],valueSpec:{zoom:{}},style:e.style,styleSpec:e.styleSpec,objectElementValidators:{zoom:validateNumber,value:a}}))}else t=t.concat(a({key:o+"[0]",value:r[0],valueSpec:{},style:e.style,styleSpec:e.styleSpec},r));return t.concat(validate({key:o+"[1]",value:r[1],valueSpec:u,style:e.style,styleSpec:e.styleSpec}))}function a(e,t){var r=getType(e.value),a=unbundle(e.value),o=null!==e.value?e.value:t;if(n){if(r!==n)return[new ValidationError(e.key,o,"%s stop domain type must match previous stop domain type %s",r,n)]}else n=r;if("number"!==r&&"string"!==r&&"boolean"!==r)return[new ValidationError(e.key,o,"stop domain value must be a number, string, or boolean")];if("number"!==r&&"categorical"!==p){var l="number expected, %s found";return u["property-function"]&&void 0===p&&(l+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new ValidationError(e.key,o,l,r)]}return"categorical"!==p||"number"!==r||isFinite(a)&&Math.floor(a)===a?"categorical"!==p&&"number"===r&&void 0!==i&&a<i?[new ValidationError(e.key,o,"stop domain values must appear in ascending order")]:(i=a,"categorical"===p&&a in s?[new ValidationError(e.key,o,"stop domain values must be unique")]:(s[a]=!0,[])):[new ValidationError(e.key,o,"integer expected, found %s",a)]}function o(e){return validate({key:e.key,value:e.value,valueSpec:u,style:e.style,styleSpec:e.styleSpec})}var n,i,l,u=e.valueSpec,p=unbundle(e.value.type),s={},y="categorical"!==p&&void 0===e.value.property,c=!y,d="array"===getType(e.value.stops)&&"array"===getType(e.value.stops[0])&&"object"===getType(e.value.stops[0][0]),v=validateObject({key:e.key,value:e.value,valueSpec:e.styleSpec.function,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{stops:t,default:o}});return"identity"===p&&y&&v.push(new ValidationError(e.key,e.value,'missing required property "property"')),"identity"===p||e.value.stops||v.push(new ValidationError(e.key,e.value,'missing required property "stops"')),"exponential"===p&&"piecewise-constant"===e.valueSpec.function&&v.push(new ValidationError(e.key,e.value,"exponential functions not supported")),e.styleSpec.$version>=8&&(c&&!e.valueSpec["property-function"]?v.push(new ValidationError(e.key,e.value,"property functions not supported")):y&&!e.valueSpec["zoom-function"]&&"heatmap-color"!==e.objectKey&&v.push(new ValidationError(e.key,e.value,"zoom functions not supported"))),"categorical"!==p&&!d||void 0!==e.value.property||v.push(new ValidationError(e.key,e.value,'"property" property is required')),v};
},{"../error/validation_error":125,"../util/get_type":168,"../util/unbundle_jsonlint":172,"./validate":173,"./validate_array":174,"./validate_number":186,"./validate_object":187}],182:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),validateString=_dereq_("./validate_string");module.exports=function(r){var e=r.value,t=r.key,a=validateString(r);return a.length?a:(-1===e.indexOf("{fontstack}")&&a.push(new ValidationError(t,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&a.push(new ValidationError(t,e,'"glyphs" url must include a "{range}" token')),a)};
},{"../error/validation_error":125,"./validate_string":191}],183:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),unbundle=_dereq_("../util/unbundle_jsonlint"),validateObject=_dereq_("./validate_object"),validateFilter=_dereq_("./validate_filter"),validatePaintProperty=_dereq_("./validate_paint_property"),validateLayoutProperty=_dereq_("./validate_layout_property"),validateSpec=_dereq_("./validate"),extend=_dereq_("../util/extend");module.exports=function(e){var r=[],t=e.value,a=e.key,l=e.style,i=e.styleSpec;t.type||t.ref||r.push(new ValidationError(a,t,'either "type" or "ref" is required'));var u=unbundle(t.type),n=unbundle(t.ref);if(t.id)for(var o=unbundle(t.id),s=0;s<e.arrayIndex;s++){var y=l.layers[s];unbundle(y.id)===o&&r.push(new ValidationError(a,t.id,'duplicate layer id "%s", previously used at line %d',t.id,y.id.__line__))}if("ref"in t){["type","source","source-layer","filter","layout"].forEach(function(e){e in t&&r.push(new ValidationError(a,t[e],'"%s" is prohibited for ref layers',e))});var d;l.layers.forEach(function(e){unbundle(e.id)===n&&(d=e)}),d?d.ref?r.push(new ValidationError(a,t.ref,"ref cannot reference another ref layer")):u=unbundle(d.type):r.push(new ValidationError(a,t.ref,'ref layer "%s" not found',n))}else if("background"!==u)if(t.source){var c=l.sources&&l.sources[t.source],p=c&&unbundle(c.type);c?"vector"===p&&"raster"===u?r.push(new ValidationError(a,t.source,'layer "%s" requires a raster source',t.id)):"raster"===p&&"raster"!==u?r.push(new ValidationError(a,t.source,'layer "%s" requires a vector source',t.id)):"vector"!==p||t["source-layer"]?"raster-dem"===p&&"hillshade"!==u&&r.push(new ValidationError(a,t.source,"raster-dem source can only be used with layer type 'hillshade'.",t.id)):r.push(new ValidationError(a,t,'layer "%s" must specify a "source-layer"',t.id)):r.push(new ValidationError(a,t.source,'source "%s" not found',t.source))}else r.push(new ValidationError(a,t,'missing required property "source"'));return r=r.concat(validateObject({key:a,value:t,valueSpec:i.layer,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(){return[]},type:function(){return validateSpec({key:a+".type",value:t.type,valueSpec:i.layer.type,style:e.style,styleSpec:e.styleSpec,object:t,objectKey:"type"})},filter:validateFilter,layout:function(e){return validateObject({layer:t,key:e.key,value:e.value,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(e){return validateLayoutProperty(extend({layerType:u},e))}}})},paint:function(e){return validateObject({layer:t,key:e.key,value:e.value,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(e){return validatePaintProperty(extend({layerType:u},e))}}})}}}))};
},{"../error/validation_error":125,"../util/extend":167,"../util/unbundle_jsonlint":172,"./validate":173,"./validate_filter":180,"./validate_layout_property":184,"./validate_object":187,"./validate_paint_property":188}],184:[function(_dereq_,module,exports){
"use strict";var validateProperty=_dereq_("./validate_property");module.exports=function(r){return validateProperty(r,"layout")};
},{"./validate_property":189}],185:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),validate=_dereq_("./validate");module.exports=function(e){var t=e.value,r=e.styleSpec,a=r.light,i=e.style,n=[],o=getType(t);if(void 0===t)return n;if("object"!==o)return n=n.concat([new ValidationError("light",t,"object expected, %s found",o)]);for(var l in t){var c=l.match(/^(.*)-transition$/);n=c&&a[c[1]]&&a[c[1]].transition?n.concat(validate({key:l,value:t[l],valueSpec:r.transition,style:i,styleSpec:r})):a[l]?n.concat(validate({key:l,value:t[l],valueSpec:a[l],style:i,styleSpec:r})):n.concat([new ValidationError(l,t[l],'unknown property "%s"',l)])}return n};
},{"../error/validation_error":125,"../util/get_type":168,"./validate":173}],186:[function(_dereq_,module,exports){
"use strict";var getType=_dereq_("../util/get_type"),ValidationError=_dereq_("../error/validation_error");module.exports=function(e){var r=e.key,i=e.value,m=e.valueSpec,a=getType(i);return"number"!==a?[new ValidationError(r,i,"number expected, %s found",a)]:"minimum"in m&&i<m.minimum?[new ValidationError(r,i,"%s is less than the minimum value %s",i,m.minimum)]:"maximum"in m&&i>m.maximum?[new ValidationError(r,i,"%s is greater than the maximum value %s",i,m.maximum)]:[]};
},{"../error/validation_error":125,"../util/get_type":168}],187:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),validateSpec=_dereq_("./validate");module.exports=function(e){var r=e.key,t=e.value,i=e.valueSpec||{},a=e.objectElementValidators||{},o=e.style,l=e.styleSpec,n=[],u=getType(t);if("object"!==u)return[new ValidationError(r,t,"object expected, %s found",u)];for(var d in t){var p=d.split(".")[0],s=i[p]||i["*"],c=void 0;if(a[p])c=a[p];else if(i[p])c=validateSpec;else if(a["*"])c=a["*"];else{if(!i["*"]){n.push(new ValidationError(r,t[d],'unknown property "%s"',d));continue}c=validateSpec}n=n.concat(c({key:(r?r+".":r)+d,value:t[d],valueSpec:s,style:o,styleSpec:l,object:t,objectKey:d},t))}for(var v in i)a[v]||i[v].required&&void 0===i[v].default&&void 0===t[v]&&n.push(new ValidationError(r,t,'missing required property "%s"',v));return n};
},{"../error/validation_error":125,"../util/get_type":168,"./validate":173}],188:[function(_dereq_,module,exports){
"use strict";var validateProperty=_dereq_("./validate_property");module.exports=function(r){return validateProperty(r,"paint")};
},{"./validate_property":189}],189:[function(_dereq_,module,exports){
"use strict";var validate=_dereq_("./validate"),ValidationError=_dereq_("../error/validation_error"),getType=_dereq_("../util/get_type"),ref=_dereq_("../function"),isFunction=ref.isFunction,unbundle=_dereq_("../util/unbundle_jsonlint");module.exports=function(e,t){var r=e.key,n=e.style,i=e.styleSpec,o=e.value,a=e.objectKey,u=i[t+"_"+e.layerType];if(!u)return[];var p=a.match(/^(.*)-transition$/);if("paint"===t&&p&&u[p[1]]&&u[p[1]].transition)return validate({key:r,value:o,valueSpec:i.transition,style:n,styleSpec:i});var s=e.valueSpec||u[a];if(!s)return[new ValidationError(r,o,'unknown property "%s"',a)];var l;if("string"===getType(o)&&s["property-function"]&&!s.tokens&&(l=/^{([^}]+)}$/.exec(o)))return[new ValidationError(r,o,'"%s" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": %s` }`.',a,JSON.stringify(l[1]))];var y=[];return"symbol"===e.layerType&&("text-field"===a&&n&&!n.glyphs&&y.push(new ValidationError(r,o,'use of "text-field" requires a style "glyphs" property')),"text-font"===a&&isFunction(unbundle.deep(o))&&"identity"===unbundle(o.type)&&y.push(new ValidationError(r,o,'"text-font" does not support identity functions'))),y.concat(validate({key:e.key,value:o,valueSpec:s,style:n,styleSpec:i,expressionContext:"property",propertyKey:a}))};
},{"../error/validation_error":125,"../function":152,"../util/get_type":168,"../util/unbundle_jsonlint":172,"./validate":173}],190:[function(_dereq_,module,exports){
"use strict";var ValidationError=_dereq_("../error/validation_error"),unbundle=_dereq_("../util/unbundle_jsonlint"),validateObject=_dereq_("./validate_object"),validateEnum=_dereq_("./validate_enum");module.exports=function(e){var a=e.value,r=e.key,t=e.styleSpec,l=e.style;if(!a.type)return[new ValidationError(r,a,'"type" is required')];var u=unbundle(a.type),s=[];switch(u){case"vector":case"raster":case"raster-dem":if(s=s.concat(validateObject({key:r,value:a,valueSpec:t["source_"+u.replace("-","_")],style:e.style,styleSpec:t})),"url"in a)for(var c in a)["type","url","tileSize"].indexOf(c)<0&&s.push(new ValidationError(r+"."+c,a[c],'a source with a "url" property may not include a "%s" property',c));return s;case"geojson":return validateObject({key:r,value:a,valueSpec:t.source_geojson,style:l,styleSpec:t});case"video":return validateObject({key:r,value:a,valueSpec:t.source_video,style:l,styleSpec:t});case"image":return validateObject({key:r,value:a,valueSpec:t.source_image,style:l,styleSpec:t});case"canvas":return validateObject({key:r,value:a,valueSpec:t.source_canvas,style:l,styleSpec:t});default:return validateEnum({key:r+".type",value:a.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image","canvas"]},style:l,styleSpec:t})}};
},{"../error/validation_error":125,"../util/unbundle_jsonlint":172,"./validate_enum":178,"./validate_object":187}],191:[function(_dereq_,module,exports){
"use strict";var getType=_dereq_("../util/get_type"),ValidationError=_dereq_("../error/validation_error");module.exports=function(r){var e=r.value,t=r.key,i=getType(e);return"string"!==i?[new ValidationError(t,e,"string expected, %s found",i)]:[]};
},{"../error/validation_error":125,"../util/get_type":168}],192:[function(_dereq_,module,exports){
"use strict";function validateStyleMin(e,a){a=a||latestStyleSpec;var t=[];return t=t.concat(validate({key:"",value:e,valueSpec:a.$root,styleSpec:a,style:e,objectElementValidators:{glyphs:validateGlyphsURL,"*":function(){return[]}}})),e.constants&&(t=t.concat(validateConstants({key:"constants",value:e.constants,style:e,styleSpec:a}))),sortErrors(t)}function sortErrors(e){return[].concat(e).sort(function(e,a){return e.line-a.line})}function wrapCleanErrors(e){return function(){return sortErrors(e.apply(this,arguments))}}var validateConstants=_dereq_("./validate/validate_constants"),validate=_dereq_("./validate/validate"),latestStyleSpec=_dereq_("./reference/latest"),validateGlyphsURL=_dereq_("./validate/validate_glyphs_url");validateStyleMin.source=wrapCleanErrors(_dereq_("./validate/validate_source")),validateStyleMin.light=wrapCleanErrors(_dereq_("./validate/validate_light")),validateStyleMin.layer=wrapCleanErrors(_dereq_("./validate/validate_layer")),validateStyleMin.filter=wrapCleanErrors(_dereq_("./validate/validate_filter")),validateStyleMin.paintProperty=wrapCleanErrors(_dereq_("./validate/validate_paint_property")),validateStyleMin.layoutProperty=wrapCleanErrors(_dereq_("./validate/validate_layout_property")),module.exports=validateStyleMin;
},{"./reference/latest":163,"./validate/validate":173,"./validate/validate_constants":177,"./validate/validate_filter":180,"./validate/validate_glyphs_url":182,"./validate/validate_layer":183,"./validate/validate_layout_property":184,"./validate/validate_light":185,"./validate/validate_paint_property":188,"./validate/validate_source":190}],193:[function(_dereq_,module,exports){
"use strict";var ZoomHistory=_dereq_("./zoom_history"),EvaluationParameters=function(t,o){this.zoom=t,o?(this.now=o.now,this.fadeDuration=o.fadeDuration,this.zoomHistory=o.zoomHistory,this.transition=o.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new ZoomHistory,this.transition={})};EvaluationParameters.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},module.exports=EvaluationParameters;
},{"./zoom_history":223}],194:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../style-spec/reference/latest"),util=_dereq_("../util/util"),Evented=_dereq_("../util/evented"),validateStyle=_dereq_("./validate_style"),ref=_dereq_("../util/util"),sphericalToCartesian=ref.sphericalToCartesian,Color=_dereq_("../style-spec/util/color"),interpolate=_dereq_("../style-spec/util/interpolate"),ref$1=_dereq_("./properties"),Properties=ref$1.Properties,Transitionable=ref$1.Transitionable,Transitioning=ref$1.Transitioning,PossiblyEvaluated=ref$1.PossiblyEvaluated,DataConstantProperty=ref$1.DataConstantProperty,LightPositionProperty=function(){this.specification=styleSpec.light.position};LightPositionProperty.prototype.possiblyEvaluate=function(t,e){return sphericalToCartesian(t.expression.evaluate(e))},LightPositionProperty.prototype.interpolate=function(t,e,i){return{x:interpolate.number(t.x,e.x,i),y:interpolate.number(t.y,e.y,i),z:interpolate.number(t.z,e.z,i)}};var properties=new Properties({anchor:new DataConstantProperty(styleSpec.light.anchor),position:new LightPositionProperty,color:new DataConstantProperty(styleSpec.light.color),intensity:new DataConstantProperty(styleSpec.light.intensity)}),TRANSITION_SUFFIX="-transition",Light=function(t){function e(e){t.call(this),this._transitionable=new Transitionable(properties),this.setLight(e),this._transitioning=this._transitionable.untransitioned()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getLight=function(){return this._transitionable.serialize()},e.prototype.setLight=function(t){var e=this;if(!this._validate(validateStyle.light,t))for(var i in t){var r=t[i];util.endsWith(i,TRANSITION_SUFFIX)?e._transitionable.setTransition(i.slice(0,-TRANSITION_SUFFIX.length),r):e._transitionable.setValue(i,r)}},e.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning)},e.prototype.hasTransition=function(){return this._transitioning.hasTransition()},e.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t)},e.prototype._validate=function(t,e){return validateStyle.emitErrors(this,t.call(validateStyle,util.extend({value:e,style:{glyphs:!0,sprite:!0},styleSpec:styleSpec})))},e}(Evented);module.exports=Light;
},{"../style-spec/reference/latest":163,"../style-spec/util/color":165,"../style-spec/util/interpolate":169,"../util/evented":271,"../util/util":285,"./properties":199,"./validate_style":222}],195:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/mapbox"),normalizeGlyphsURL=ref.normalizeGlyphsURL,ajax=_dereq_("../util/ajax"),parseGlyphPBF=_dereq_("./parse_glyph_pbf");module.exports=function(e,r,a,l,p){var i=256*r,s=i+255,t=l(normalizeGlyphsURL(a).replace("{fontstack}",e).replace("{range}",i+"-"+s),ajax.ResourceType.Glyphs);ajax.getArrayBuffer(t,function(e,r){if(e)p(e);else if(r){for(var a={},l=0,i=parseGlyphPBF(r.data);l<i.length;l+=1){var s=i[l];a[s.id]=s}p(null,a)}})};
},{"../util/ajax":262,"../util/mapbox":278,"./parse_glyph_pbf":197}],196:[function(_dereq_,module,exports){
"use strict";var ajax=_dereq_("../util/ajax"),browser=_dereq_("../util/browser"),ref=_dereq_("../util/mapbox"),normalizeSpriteURL=ref.normalizeSpriteURL,ref$1=_dereq_("../util/image"),RGBAImage=ref$1.RGBAImage;module.exports=function(e,i,r){function a(){if(n)r(n);else if(t&&o){var e=browser.getImageData(o),i={};for(var a in t){var u=t[a],g=u.width,l=u.height,x=u.x,m=u.y,p=u.sdf,f=u.pixelRatio,s=new RGBAImage({width:g,height:l});RGBAImage.copy(e,s,{x:x,y:m},{x:0,y:0},{width:g,height:l}),i[a]={data:s,pixelRatio:f,sdf:p}}r(null,i)}}var t,o,n,u=browser.devicePixelRatio>1?"@2x":"";ajax.getJSON(i(normalizeSpriteURL(e,u,".json"),ajax.ResourceType.SpriteJSON),function(e,i){n||(n=e,t=i,a())}),ajax.getImage(i(normalizeSpriteURL(e,u,".png"),ajax.ResourceType.SpriteImage),function(e,i){n||(n=e,o=i,a())})};
},{"../util/ajax":262,"../util/browser":263,"../util/image":274,"../util/mapbox":278}],197:[function(_dereq_,module,exports){
"use strict";function readFontstacks(e,a,r){1===e&&r.readMessage(readFontstack,a)}function readFontstack(e,a,r){if(3===e){var t=r.readMessage(readGlyph,{}),d=t.id,i=t.bitmap,n=t.width,o=t.height,h=t.left,s=t.top,p=t.advance;a.push({id:d,bitmap:new AlphaImage({width:n+2*border,height:o+2*border},i),metrics:{width:n,height:o,left:h,top:s,advance:p}})}}function readGlyph(e,a,r){1===e?a.id=r.readVarint():2===e?a.bitmap=r.readBytes():3===e?a.width=r.readVarint():4===e?a.height=r.readVarint():5===e?a.left=r.readSVarint():6===e?a.top=r.readSVarint():7===e&&(a.advance=r.readVarint())}var ref=_dereq_("../util/image"),AlphaImage=ref.AlphaImage,Protobuf=_dereq_("pbf"),border=3;module.exports=function(e){return new Protobuf(e).readFields(readFontstacks,[])},module.exports.GLYPH_PBF_BORDER=border;
},{"../util/image":274,"pbf":29}],198:[function(_dereq_,module,exports){
"use strict";var browser=_dereq_("../util/browser"),CollisionIndex=_dereq_("../symbol/collision_index"),LayerPlacement=function(e){this._currentTileIndex=0,this._tileIDs=e};LayerPlacement.prototype.continuePlacement=function(e,n,t,i,r){for(var o=this;this._currentTileIndex<this._tileIDs.length;){if(e.getTileByID(o._tileIDs[o._currentTileIndex]).placeLayer(t,n,i,e.id),o._currentTileIndex++,r())return!0}};var Placement=function(e,n,t,i,r,o){this.collisionIndex=new CollisionIndex(e.clone()),this._currentPlacementIndex=n.length-1,this._forceFullPlacement=t,this._showCollisionBoxes=i,this._sourceCacheTileIDs={},this._done=!1,this._delayUntil=t||!o||0===r?browser.now():o._delayUntil+300,this._collisionFadeTimes=o?o._collisionFadeTimes:{latestStart:0,duration:r}};Placement.prototype.isDone=function(){return this._done},Placement.prototype.continuePlacement=function(e,n,t){var i=this,r=browser.now();if(r<this._delayUntil)return!0;for(var o=function(){var e=browser.now()-r;return!i._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=e[i._currentPlacementIndex],l=n[s];if("symbol"===l.type){var c=t[l.source];i._inProgressLayer||(i._sourceCacheTileIDs[l.source]||(i._sourceCacheTileIDs[l.source]=c.getRenderableIds().sort(function(e,n){var t=c.getTileByID(e).tileID,i=c.getTileByID(n).tileID;return t.isLessThan(i)?-1:i.isLessThan(t)?1:0})),i._inProgressLayer=new LayerPlacement(i._sourceCacheTileIDs[l.source]));if(i._inProgressLayer.continuePlacement(c,i.collisionIndex,i._showCollisionBoxes,l,o))return;delete i._inProgressLayer}i._currentPlacementIndex--}for(var a in t)t[a].commitPlacement(i.collisionIndex,i._collisionFadeTimes);this._done=!0},Placement.prototype.stillFading=function(){return browser.now()<this._collisionFadeTimes.latestStart+this._collisionFadeTimes.duration},module.exports=Placement;
},{"../symbol/collision_index":228,"../util/browser":263}],199:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/util"),clone=ref.clone,extend=ref.extend,easeCubicInOut=ref.easeCubicInOut,interpolate=_dereq_("../style-spec/util/interpolate"),ref$1=_dereq_("../style-spec/expression"),normalizePropertyExpression=ref$1.normalizePropertyExpression,Color=_dereq_("../style-spec/util/color"),ref$2=_dereq_("../util/web_worker_transfer"),register=ref$2.register,PropertyValue=function(t,e){this.property=t,this.value=e,this.expression=normalizePropertyExpression(void 0===e?t.specification.default:e,t.specification)};PropertyValue.prototype.isDataDriven=function(){return"source"===this.expression.kind||"composite"===this.expression.kind},PropertyValue.prototype.possiblyEvaluate=function(t){return this.property.possiblyEvaluate(this,t)};var TransitionablePropertyValue=function(t){this.property=t,this.value=new PropertyValue(t,void 0)};TransitionablePropertyValue.prototype.transitioned=function(t,e){return new TransitioningPropertyValue(this.property,this.value,e,extend({},t.transition,this.transition),t.now)},TransitionablePropertyValue.prototype.untransitioned=function(){return new TransitioningPropertyValue(this.property,this.value,null,{},0)};var Transitionable=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues)};Transitionable.prototype.getValue=function(t){return clone(this._values[t].value.value)},Transitionable.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new TransitionablePropertyValue(this._values[t].property)),this._values[t].value=new PropertyValue(this._values[t].property,null===e?void 0:clone(e))},Transitionable.prototype.getTransition=function(t){return clone(this._values[t].transition)},Transitionable.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new TransitionablePropertyValue(this._values[t].property)),this._values[t].transition=clone(e)||void 0},Transitionable.prototype.serialize=function(){for(var t=this,e={},r=0,a=Object.keys(t._values);r<a.length;r+=1){var o=a[r],i=t.getValue(o);void 0!==i&&(e[o]=i);var n=t.getTransition(o);void 0!==n&&(e[o+"-transition"]=n)}return e},Transitionable.prototype.transitioned=function(t,e){for(var r=this,a=new Transitioning(this._properties),o=0,i=Object.keys(r._values);o<i.length;o+=1){var n=i[o];a._values[n]=r._values[n].transitioned(t,e._values[n])}return a},Transitionable.prototype.untransitioned=function(){for(var t=this,e=new Transitioning(this._properties),r=0,a=Object.keys(t._values);r<a.length;r+=1){var o=a[r];e._values[o]=t._values[o].untransitioned()}return e};var TransitioningPropertyValue=function(t,e,r,a,o){this.property=t,this.value=e,this.begin=o+a.delay||0,this.end=this.begin+a.duration||0,t.specification.transition&&(a.delay||a.duration)&&(this.prior=r)};TransitioningPropertyValue.prototype.possiblyEvaluate=function(t){var e=t.now||0,r=this.value.possiblyEvaluate(t),a=this.prior;if(a){if(e>this.end)return this.prior=null,r;if(this.value.isDataDriven())return this.prior=null,r;if(e<this.begin)return a.possiblyEvaluate(t);var o=(e-this.begin)/(this.end-this.begin);return this.property.interpolate(a.possiblyEvaluate(t),r,easeCubicInOut(o))}return r};var Transitioning=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues)};Transitioning.prototype.possiblyEvaluate=function(t){for(var e=this,r=new PossiblyEvaluated(this._properties),a=0,o=Object.keys(e._values);a<o.length;a+=1){var i=o[a];r._values[i]=e._values[i].possiblyEvaluate(t)}return r},Transitioning.prototype.hasTransition=function(){for(var t=this,e=0,r=Object.keys(t._values);e<r.length;e+=1){var a=r[e];if(t._values[a].prior)return!0}return!1};var Layout=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues)};Layout.prototype.getValue=function(t){return clone(this._values[t].value)},Layout.prototype.setValue=function(t,e){this._values[t]=new PropertyValue(this._values[t].property,null===e?void 0:clone(e))},Layout.prototype.serialize=function(){for(var t=this,e={},r=0,a=Object.keys(t._values);r<a.length;r+=1){var o=a[r],i=t.getValue(o);void 0!==i&&(e[o]=i)}return e},Layout.prototype.possiblyEvaluate=function(t){for(var e=this,r=new PossiblyEvaluated(this._properties),a=0,o=Object.keys(e._values);a<o.length;a+=1){var i=o[a];r._values[i]=e._values[i].possiblyEvaluate(t)}return r};var PossiblyEvaluatedPropertyValue=function(t,e,r){this.property=t,this.value=e,this.globals=r};PossiblyEvaluatedPropertyValue.prototype.isConstant=function(){return"constant"===this.value.kind},PossiblyEvaluatedPropertyValue.prototype.constantOr=function(t){return"constant"===this.value.kind?this.value.value:t},PossiblyEvaluatedPropertyValue.prototype.evaluate=function(t){return this.property.evaluate(this.value,this.globals,t)};var PossiblyEvaluated=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues)};PossiblyEvaluated.prototype.get=function(t){return this._values[t]};var DataConstantProperty=function(t){this.specification=t};DataConstantProperty.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},DataConstantProperty.prototype.interpolate=function(t,e,r){var a=interpolate[this.specification.type];return a?a(t,e,r):t};var DataDrivenProperty=function(t){this.specification=t};DataDrivenProperty.prototype.possiblyEvaluate=function(t,e){return"constant"===t.expression.kind||"camera"===t.expression.kind?new PossiblyEvaluatedPropertyValue(this,{kind:"constant",value:t.expression.evaluate(e)},e):new PossiblyEvaluatedPropertyValue(this,t.expression,e)},DataDrivenProperty.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0!==t.value.value&&void 0!==t.value.value){var a=interpolate[this.specification.type];return a?new PossiblyEvaluatedPropertyValue(this,{kind:"constant",value:a(t.value.value,e.value.value,r)},t.globals):t}},DataDrivenProperty.prototype.evaluate=function(t,e,r){return"constant"===t.kind?t.value:t.evaluate(e,r)};var CrossFadedProperty=function(t){this.specification=t};CrossFadedProperty.prototype.possiblyEvaluate=function(t,e){if(void 0!==t.value){if("constant"===t.expression.kind){var r=t.expression.evaluate(e);return this._calculate(r,r,r,e)}return this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e)}},CrossFadedProperty.prototype._calculate=function(t,e,r,a){var o=a.zoom,i=o-Math.floor(o),n=a.crossFadingFactor();return o>a.zoomHistory.lastIntegerZoom?{from:t,to:e,fromScale:2,toScale:1,t:i+(1-i)*n}:{from:r,to:e,fromScale:.5,toScale:1,t:1-(1-n)*i}},CrossFadedProperty.prototype.interpolate=function(t){return t};var HeatmapColorProperty=function(t){this.specification=t};HeatmapColorProperty.prototype.possiblyEvaluate=function(){},HeatmapColorProperty.prototype.interpolate=function(){};var Properties=function(t){var e=this;this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={};for(var r in t){var a=t[r],o=e.defaultPropertyValues[r]=new PropertyValue(a,void 0),i=e.defaultTransitionablePropertyValues[r]=new TransitionablePropertyValue(a);e.defaultTransitioningPropertyValues[r]=i.untransitioned(),e.defaultPossiblyEvaluatedValues[r]=o.possiblyEvaluate({})}};register("DataDrivenProperty",DataDrivenProperty),register("DataConstantProperty",DataConstantProperty),register("CrossFadedProperty",CrossFadedProperty),register("HeatmapColorProperty",HeatmapColorProperty),module.exports={PropertyValue:PropertyValue,Transitionable:Transitionable,Transitioning:Transitioning,Layout:Layout,PossiblyEvaluatedPropertyValue:PossiblyEvaluatedPropertyValue,PossiblyEvaluated:PossiblyEvaluated,DataConstantProperty:DataConstantProperty,DataDrivenProperty:DataDrivenProperty,CrossFadedProperty:CrossFadedProperty,HeatmapColorProperty:HeatmapColorProperty,Properties:Properties};
},{"../style-spec/expression":142,"../style-spec/util/color":165,"../style-spec/util/interpolate":169,"../util/util":285,"../util/web_worker_transfer":288}],200:[function(_dereq_,module,exports){
"use strict";function getMaximumPaintValue(t,a,e){var n=a.paint.get(t).value;return"constant"===n.kind?n.value:e.programConfigurations.get(a.id).binders[t].statistics.max}function translateDistance(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function translate(t,a,e,n,r){if(!a[0]&&!a[1])return t;var i=Point.convert(a);"viewport"===e&&i._rotate(-n);for(var u=[],s=0;s<t.length;s++){for(var o=t[s],l=[],m=0;m<o.length;m++)l.push(o[m].sub(i._mult(r)));u.push(l)}return u}var Point=_dereq_("@mapbox/point-geometry");module.exports={getMaximumPaintValue:getMaximumPaintValue,translateDistance:translateDistance,translate:translate};
},{"@mapbox/point-geometry":4}],201:[function(_dereq_,module,exports){
"use strict";var Evented=_dereq_("../util/evented"),StyleLayer=_dereq_("./style_layer"),loadSprite=_dereq_("./load_sprite"),ImageManager=_dereq_("../render/image_manager"),GlyphManager=_dereq_("../render/glyph_manager"),Light=_dereq_("./light"),LineAtlas=_dereq_("../render/line_atlas"),util=_dereq_("../util/util"),ajax=_dereq_("../util/ajax"),mapbox=_dereq_("../util/mapbox"),browser=_dereq_("../util/browser"),Dispatcher=_dereq_("../util/dispatcher"),validateStyle=_dereq_("./validate_style"),getSourceType=_dereq_("../source/source").getType,setSourceType=_dereq_("../source/source").setType,QueryFeatures=_dereq_("../source/query_features"),SourceCache=_dereq_("../source/source_cache"),GeoJSONSource=_dereq_("../source/geojson_source"),styleSpec=_dereq_("../style-spec/reference/latest"),getWorkerPool=_dereq_("../util/global_worker_pool"),deref=_dereq_("../style-spec/deref"),diff=_dereq_("../style-spec/diff"),rtlTextPlugin=_dereq_("../source/rtl_text_plugin"),Placement=_dereq_("./placement"),ZoomHistory=_dereq_("./zoom_history"),supportedDiffOperations=util.pick(diff.operations,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),ignoredDiffOperations=util.pick(diff.operations,["setCenter","setZoom","setBearing","setPitch"]),Style=function(e){function t(t,r){var i=this;void 0===r&&(r={}),e.call(this),this.map=t,this.dispatcher=new Dispatcher(getWorkerPool(),this),this.imageManager=new ImageManager,this.glyphManager=new GlyphManager(t._transformRequest,r.localIdeographFontFamily),this.lineAtlas=new LineAtlas(256,512),this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory=new ZoomHistory,this._loaded=!1,this._resetUpdates();var a=this;this._rtlTextPluginCallback=rtlTextPlugin.registerForPluginAvailability(function(e){a.dispatcher.broadcast("loadRTLTextPlugin",e.pluginBlobURL,e.errorCallback);for(var t in a.sourceCaches)a.sourceCaches[t].reload()}),this.on("data",function(e){if("source"===e.dataType&&"metadata"===e.sourceDataType){var t=i.sourceCaches[e.sourceId];if(t){var r=t.getSource();if(r&&r.vectorLayerIds)for(var a in i._layers){var s=i._layers[a];s.source===r.id&&i._validateLayer(s)}}}})}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.loadURL=function(e,t){var r=this;void 0===t&&(t={}),this.fire("dataloading",{dataType:"style"});var i="boolean"==typeof t.validate?t.validate:!mapbox.isMapboxURL(e);e=mapbox.normalizeStyleURL(e,t.accessToken);var a=this.map._transformRequest(e,ajax.ResourceType.Style);ajax.getJSON(a,function(e,t){e?r.fire("error",{error:e}):t&&r._load(t,i)})},t.prototype.loadJSON=function(e,t){var r=this;void 0===t&&(t={}),this.fire("dataloading",{dataType:"style"}),browser.frame(function(){r._load(e,!1!==t.validate)})},t.prototype._load=function(e,t){var r=this;if(!t||!validateStyle.emitErrors(this,validateStyle(e))){this._loaded=!0,this.stylesheet=e;for(var i in e.sources)r.addSource(i,e.sources[i],{validate:!1});e.sprite?loadSprite(e.sprite,this.map._transformRequest,function(e,t){if(e)r.fire("error",e);else if(t)for(var i in t)r.imageManager.addImage(i,t[i]);r.imageManager.setLoaded(!0),r.fire("data",{dataType:"style"})}):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var a=deref(this.stylesheet.layers);this._order=a.map(function(e){return e.id}),this._layers={};for(var s=0,o=a;s<o.length;s+=1){var n=o[s];n=StyleLayer.create(n),n.setEventedParent(r,{layer:{id:n.id}}),r._layers[n.id]=n}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new Light(this.stylesheet.light),this.fire("data",{dataType:"style"}),this.fire("style.load")}},t.prototype._validateLayer=function(e){var t=this.sourceCaches[e.source];if(t){var r=e.sourceLayer;if(r){var i=t.getSource();("geojson"===i.type||i.vectorLayerIds&&-1===i.vectorLayerIds.indexOf(r))&&this.fire("error",{error:new Error('Source layer "'+r+'" does not exist on source "'+i.id+'" as specified by style layer "'+e.id+'"')})}}},t.prototype.loaded=function(){var e=this;if(!this._loaded)return!1;if(Object.keys(this._updatedSources).length)return!1;for(var t in e.sourceCaches)if(!e.sourceCaches[t].loaded())return!1;return!!this.imageManager.isLoaded()},t.prototype._serializeLayers=function(e){var t=this;return e.map(function(e){return t._layers[e].serialize()})},t.prototype.hasTransitions=function(){var e=this;if(this.light&&this.light.hasTransition())return!0;for(var t in e.sourceCaches)if(e.sourceCaches[t].hasTransition())return!0;for(var r in e._layers)if(e._layers[r].hasTransition())return!0;return!1},t.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},t.prototype.update=function(e){var t=this;if(this._loaded){if(this._changed){var r=Object.keys(this._updatedLayers),i=Object.keys(this._removedLayers);(r.length||i.length)&&this._updateWorkerLayers(r,i);for(var a in t._updatedSources){var s=t._updatedSources[a];"reload"===s?t._reloadSource(a):"clear"===s&&t._clearSource(a)}for(var o in t._updatedPaintProps)t._layers[o].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates(),this.fire("data",{dataType:"style"})}for(var n in t.sourceCaches)t.sourceCaches[n].used=!1;for(var h=0,l=t._order;h<l.length;h+=1){var u=l[h],d=t._layers[u];d.recalculate(e),!d.isHidden(e.zoom)&&d.source&&(t.sourceCaches[d.source].used=!0)}this.light.recalculate(e),this.z=e.zoom}},t.prototype._updateWorkerLayers=function(e,t){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(e),removedIds:t})},t.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={}},t.prototype.setState=function(e){var t=this;if(this._checkLoaded(),validateStyle.emitErrors(this,validateStyle(e)))return!1;e=util.clone(e),e.layers=deref(e.layers);var r=diff(this.serialize(),e).filter(function(e){return!(e.command in ignoredDiffOperations)});if(0===r.length)return!1;var i=r.filter(function(e){return!(e.command in supportedDiffOperations)});if(i.length>0)throw new Error("Unimplemented: "+i.map(function(e){return e.command}).join(", ")+".");return r.forEach(function(e){"setTransition"!==e.command&&t[e.command].apply(t,e.args)}),this.stylesheet=e,!0},t.prototype.addImage=function(e,t){if(this.getImage(e))return this.fire("error",{error:new Error("An image with this name already exists.")});this.imageManager.addImage(e,t),this.fire("data",{dataType:"style"})},t.prototype.getImage=function(e){return this.imageManager.getImage(e)},t.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire("error",{error:new Error("No image with this name exists.")});this.imageManager.removeImage(e),this.fire("data",{dataType:"style"})},t.prototype.addSource=function(e,t,r){var i=this;if(this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!t.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(t).join(", ")+".");if(!(["vector","raster","geojson","video","image","canvas"].indexOf(t.type)>=0&&this._validate(validateStyle.source,"sources."+e,t,null,r))){var a=this.sourceCaches[e]=new SourceCache(e,t,this.dispatcher);a.style=this,a.setEventedParent(this,function(){return{isSourceLoaded:i.loaded(),source:a.serialize(),sourceId:e}}),a.onAdd(this.map),this._changed=!0}},t.prototype.removeSource=function(e){var t=this;if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var r in t._layers)if(t._layers[r].source===e)return t.fire("error",{error:new Error('Source "'+e+'" cannot be removed while layer "'+r+'" is using it.')});var i=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],i.fire("data",{sourceDataType:"metadata",dataType:"source",sourceId:e}),i.setEventedParent(null),i.clearTiles(),i.onRemove&&i.onRemove(this.map),this._changed=!0},t.prototype.setGeoJSONSourceData=function(e,t){this._checkLoaded(),this.sourceCaches[e].getSource().setData(t),this._changed=!0},t.prototype.getSource=function(e){return this.sourceCaches[e]&&this.sourceCaches[e].getSource()},t.prototype.addLayer=function(e,t,r){this._checkLoaded();var i=e.id;if("object"==typeof e.source&&(this.addSource(i,e.source),e=util.clone(e),e=util.extend(e,{source:i})),!this._validate(validateStyle.layer,"layers."+i,e,{arrayIndex:-1},r)){var a=StyleLayer.create(e);this._validateLayer(a),a.setEventedParent(this,{layer:{id:i}});var s=t?this._order.indexOf(t):this._order.length;if(t&&-1===s)return void this.fire("error",{error:new Error('Layer with id "'+t+'" does not exist on this map.')});if(this._order.splice(s,0,i),this._layerOrderChanged=!0,this._layers[i]=a,this._removedLayers[i]&&a.source){var o=this._removedLayers[i];delete this._removedLayers[i],o.type!==a.type?this._updatedSources[a.source]="clear":(this._updatedSources[a.source]="reload",this.sourceCaches[a.source].pause())}this._updateLayer(a)}},t.prototype.moveLayer=function(e,t){if(this._checkLoaded(),this._changed=!0,!this._layers[e])return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")});var r=this._order.indexOf(e);this._order.splice(r,1);var i=t?this._order.indexOf(t):this._order.length;if(t&&-1===i)return void this.fire("error",{error:new Error('Layer with id "'+t+'" does not exist on this map.')});this._order.splice(i,0,e),this._layerOrderChanged=!0},t.prototype.removeLayer=function(e){this._checkLoaded();var t=this._layers[e];if(!t)return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")});t.setEventedParent(null);var r=this._order.indexOf(e);this._order.splice(r,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=t,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e]},t.prototype.getLayer=function(e){return this._layers[e]},t.prototype.setLayerZoomRange=function(e,t,r){this._checkLoaded();var i=this.getLayer(e);if(!i)return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")});i.minzoom===t&&i.maxzoom===r||(null!=t&&(i.minzoom=t),null!=r&&(i.maxzoom=r),this._updateLayer(i))},t.prototype.setFilter=function(e,t){this._checkLoaded();var r=this.getLayer(e);if(!r)return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")});if(!util.deepEqual(r.filter,t))return null===t||void 0===t?(r.filter=void 0,void this._updateLayer(r)):void(this._validate(validateStyle.filter,"layers."+r.id+".filter",t)||(r.filter=util.clone(t),this._updateLayer(r)))},t.prototype.getFilter=function(e){return util.clone(this.getLayer(e).filter)},t.prototype.setLayoutProperty=function(e,t,r){this._checkLoaded();var i=this.getLayer(e);if(!i)return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")});util.deepEqual(i.getLayoutProperty(t),r)||(i.setLayoutProperty(t,r),this._updateLayer(i))},t.prototype.getLayoutProperty=function(e,t){return this.getLayer(e).getLayoutProperty(t)},t.prototype.setPaintProperty=function(e,t,r){this._checkLoaded();var i=this.getLayer(e);if(!i)return void this.fire("error",{error:new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")});if(!util.deepEqual(i.getPaintProperty(t),r)){var a=i._transitionablePaint._values[t].value.isDataDriven();i.setPaintProperty(t,r);(i._transitionablePaint._values[t].value.isDataDriven()||a)&&this._updateLayer(i),this._changed=!0,this._updatedPaintProps[e]=!0}},t.prototype.getPaintProperty=function(e,t){return this.getLayer(e).getPaintProperty(t)},t.prototype.getTransition=function(){return util.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},t.prototype.serialize=function(){var e=this;return util.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:util.mapObject(this.sourceCaches,function(e){return e.serialize()}),layers:this._order.map(function(t){return e._layers[t].serialize()})},function(e){return void 0!==e})},t.prototype._updateLayer=function(e){this._updatedLayers[e.id]=!0,e.source&&!this._updatedSources[e.source]&&(this._updatedSources[e.source]="reload",this.sourceCaches[e.source].pause()),this._changed=!0},t.prototype._flattenRenderedFeatures=function(e){for(var t=this,r=[],i=this._order.length-1;i>=0;i--)for(var a=t._order[i],s=0,o=e;s<o.length;s+=1){var n=o[s],h=n[a];if(h)for(var l=0,u=h;l<u.length;l+=1){var d=u[l];r.push(d)}}return r},t.prototype.queryRenderedFeatures=function(e,t,r,i){var a=this;t&&t.filter&&this._validate(validateStyle.filter,"queryRenderedFeatures.filter",t.filter);var s={};if(t&&t.layers){if(!Array.isArray(t.layers))return this.fire("error",{error:"parameters.layers must be an Array."}),[];for(var o=0,n=t.layers;o<n.length;o+=1){var h=n[o],l=a._layers[h];if(!l)return a.fire("error",{error:"The layer '"+h+"' does not exist in the map's style and cannot be queried for features."}),[];s[l.source]=!0}}var u=[];for(var d in a.sourceCaches)if(!t.layers||s[d]){var c=QueryFeatures.rendered(a.sourceCaches[d],a._layers,e,t,r,i);u.push(c)}return this._flattenRenderedFeatures(u)},t.prototype.querySourceFeatures=function(e,t){t&&t.filter&&this._validate(validateStyle.filter,"querySourceFeatures.filter",t.filter);var r=this.sourceCaches[e];return r?QueryFeatures.source(r,t):[]},t.prototype.addSourceType=function(e,t,r){return getSourceType(e)?r(new Error('A source type called "'+e+'" already exists.')):(setSourceType(e,t),t.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:e,url:t.workerSourceURL},r):r(null,null))},t.prototype.getLight=function(){return this.light.getLight()},t.prototype.setLight=function(e){this._checkLoaded();var t=this.light.getLight(),r=!1;for(var i in e)if(!util.deepEqual(e[i],t[i])){r=!0;break}if(r){var a=util.extend({duration:300,delay:0},this.stylesheet.transition);this.light.setLight(e),this.light.updateTransitions(a)}},t.prototype._validate=function(e,t,r,i,a){return(!a||!1!==a.validate)&&validateStyle.emitErrors(this,e.call(validateStyle,util.extend({key:t,style:this.serialize(),value:r,styleSpec:styleSpec},i)))},t.prototype._remove=function(){var e=this;rtlTextPlugin.evented.off("pluginAvailable",this._rtlTextPluginCallback);for(var t in e.sourceCaches)e.sourceCaches[t].clearTiles();this.dispatcher.remove()},t.prototype._clearSource=function(e){this.sourceCaches[e].clearTiles()},t.prototype._reloadSource=function(e){this.sourceCaches[e].resume(),this.sourceCaches[e].reload()},t.prototype._updateSources=function(e){var t=this;for(var r in t.sourceCaches)t.sourceCaches[r].update(e)},t.prototype.getNeedsFullPlacement=function(){var e=this;if(this._layerOrderChanged)return!0;for(var t in e.sourceCaches)if(e.sourceCaches[t].getNeedsFullPlacement())return!0;return!1},t.prototype._generateCollisionBoxes=function(){var e=this;for(var t in e.sourceCaches)e._reloadSource(t)},t.prototype._updatePlacement=function(e,t,r){var i=this.getNeedsFullPlacement();return(i||!this.placement||this.placement.isDone())&&(this.placement=new Placement(e,this._order,i,t,r,this.placement),this._layerOrderChanged=!1),this.placement.continuePlacement(this._order,this._layers,this.sourceCaches),this.placement.isDone()&&(this.collisionIndex=this.placement.collisionIndex),!this.placement.isDone()||this.placement.stillFading()},t.prototype.getImages=function(e,t,r){this.imageManager.getImages(t.icons,r)},t.prototype.getGlyphs=function(e,t,r){this.glyphManager.getGlyphs(t.stacks,r)},t}(Evented);module.exports=Style;
},{"../render/glyph_manager":89,"../render/image_manager":91,"../render/line_atlas":92,"../source/geojson_source":102,"../source/query_features":108,"../source/rtl_text_plugin":112,"../source/source":113,"../source/source_cache":114,"../style-spec/deref":123,"../style-spec/diff":124,"../style-spec/reference/latest":163,"../util/ajax":262,"../util/browser":263,"../util/dispatcher":269,"../util/evented":271,"../util/global_worker_pool":273,"../util/mapbox":278,"../util/util":285,"./light":194,"./load_sprite":196,"./placement":198,"./style_layer":202,"./validate_style":222,"./zoom_history":223}],202:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),styleSpec=_dereq_("../style-spec/reference/latest"),validateStyle=_dereq_("./validate_style"),Evented=_dereq_("../util/evented"),ref=_dereq_("./properties"),Layout=ref.Layout,Transitionable=ref.Transitionable,Transitioning=ref.Transitioning,Properties=ref.Properties,TRANSITION_SUFFIX="-transition",StyleLayer=function(t){function e(e,i){var a=this;t.call(this),this.id=e.id,this.metadata=e.metadata,this.type=e.type,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,this.visibility="visible","background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),this._featureFilter=function(){return!0},i.layout&&(this._unevaluatedLayout=new Layout(i.layout)),this._transitionablePaint=new Transitionable(i.paint);for(var r in e.paint)a.setPaintProperty(r,e.paint[r],{validate:!1});for(var s in e.layout)a.setLayoutProperty(s,e.layout[s],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getLayoutProperty=function(t){return"visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,i){if(null!==e&&void 0!==e){var a="layers."+this.id+".layout."+t;if(this._validate(validateStyle.layoutProperty,a,t,e,i))return}if("visibility"===t)return void(this.visibility="none"===e?e:"visible");this._unevaluatedLayout.setValue(t,e)},e.prototype.getPaintProperty=function(t){return util.endsWith(t,TRANSITION_SUFFIX)?this._transitionablePaint.getTransition(t.slice(0,-TRANSITION_SUFFIX.length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,i){if(null!==e&&void 0!==e){var a="layers."+this.id+".paint."+t;if(this._validate(validateStyle.paintProperty,a,t,e,i))return}util.endsWith(t,TRANSITION_SUFFIX)?this._transitionablePaint.setTransition(t.slice(0,-TRANSITION_SUFFIX.length),e||void 0):this._transitionablePaint.setValue(t,e)},e.prototype.isHidden=function(t){return!!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility)},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint)},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t){this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t)),this.paint=this._transitioningPaint.possiblyEvaluate(t)},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return"none"===this.visibility&&(t.layout=t.layout||{},t.layout.visibility="none"),util.filterObject(t,function(t,e){return!(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)})},e.prototype._validate=function(t,e,i,a,r){return(!r||!1!==r.validate)&&validateStyle.emitErrors(this,t.call(validateStyle,{key:e,layerType:this.type,objectKey:i,value:a,styleSpec:styleSpec,style:{glyphs:!0,sprite:!0}}))},e.prototype.hasOffscreenPass=function(){return!1},e.prototype.resize=function(){},e}(Evented);module.exports=StyleLayer;var subclasses={circle:_dereq_("./style_layer/circle_style_layer"),heatmap:_dereq_("./style_layer/heatmap_style_layer"),hillshade:_dereq_("./style_layer/hillshade_style_layer"),fill:_dereq_("./style_layer/fill_style_layer"),"fill-extrusion":_dereq_("./style_layer/fill_extrusion_style_layer"),line:_dereq_("./style_layer/line_style_layer"),symbol:_dereq_("./style_layer/symbol_style_layer"),background:_dereq_("./style_layer/background_style_layer"),raster:_dereq_("./style_layer/raster_style_layer")};StyleLayer.create=function(t){return new subclasses[t.type](t)};
},{"../style-spec/reference/latest":163,"../util/evented":271,"../util/util":285,"./properties":199,"./style_layer/background_style_layer":203,"./style_layer/circle_style_layer":205,"./style_layer/fill_extrusion_style_layer":207,"./style_layer/fill_style_layer":209,"./style_layer/heatmap_style_layer":211,"./style_layer/hillshade_style_layer":213,"./style_layer/line_style_layer":215,"./style_layer/raster_style_layer":217,"./style_layer/symbol_style_layer":219,"./validate_style":222}],203:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),properties=_dereq_("./background_style_layer_properties"),ref=_dereq_("../properties"),Transitionable=ref.Transitionable,Transitioning=ref.Transitioning,PossiblyEvaluated=ref.PossiblyEvaluated,BackgroundStyleLayer=function(e){function r(r){e.call(this,r,properties)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r}(StyleLayer);module.exports=BackgroundStyleLayer;
},{"../properties":199,"../style_layer":202,"./background_style_layer_properties":204}],204:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"background-color":new DataConstantProperty(styleSpec.paint_background["background-color"]),"background-pattern":new CrossFadedProperty(styleSpec.paint_background["background-pattern"]),"background-opacity":new DataConstantProperty(styleSpec.paint_background["background-opacity"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],205:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),CircleBucket=_dereq_("../../data/bucket/circle_bucket"),ref=_dereq_("../../util/intersection_tests"),multiPolygonIntersectsBufferedMultiPoint=ref.multiPolygonIntersectsBufferedMultiPoint,ref$1=_dereq_("../query_utils"),getMaximumPaintValue=ref$1.getMaximumPaintValue,translateDistance=ref$1.translateDistance,translate=ref$1.translate,properties=_dereq_("./circle_style_layer_properties"),ref$2=_dereq_("../properties"),Transitionable=ref$2.Transitionable,Transitioning=ref$2.Transitioning,PossiblyEvaluated=ref$2.PossiblyEvaluated,CircleStyleLayer=function(e){function t(t){e.call(this,t,properties)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.createBucket=function(e){return new CircleBucket(e)},t.prototype.queryRadius=function(e){var t=e;return getMaximumPaintValue("circle-radius",this,t)+getMaximumPaintValue("circle-stroke-width",this,t)+translateDistance(this.paint.get("circle-translate"))},t.prototype.queryIntersectsFeature=function(e,t,r,i,a,n){var l=translate(e,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a,n),s=this.paint.get("circle-radius").evaluate(t)*n,u=this.paint.get("circle-stroke-width").evaluate(t)*n;return multiPolygonIntersectsBufferedMultiPoint(l,r,s+u)},t}(StyleLayer);module.exports=CircleStyleLayer;
},{"../../data/bucket/circle_bucket":45,"../../util/intersection_tests":275,"../properties":199,"../query_utils":200,"../style_layer":202,"./circle_style_layer_properties":206}],206:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"circle-radius":new DataDrivenProperty(styleSpec.paint_circle["circle-radius"]),"circle-color":new DataDrivenProperty(styleSpec.paint_circle["circle-color"]),"circle-blur":new DataDrivenProperty(styleSpec.paint_circle["circle-blur"]),"circle-opacity":new DataDrivenProperty(styleSpec.paint_circle["circle-opacity"]),"circle-translate":new DataConstantProperty(styleSpec.paint_circle["circle-translate"]),"circle-translate-anchor":new DataConstantProperty(styleSpec.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new DataConstantProperty(styleSpec.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new DataConstantProperty(styleSpec.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new DataDrivenProperty(styleSpec.paint_circle["circle-stroke-width"]),"circle-stroke-color":new DataDrivenProperty(styleSpec.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new DataDrivenProperty(styleSpec.paint_circle["circle-stroke-opacity"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],207:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),FillExtrusionBucket=_dereq_("../../data/bucket/fill_extrusion_bucket"),ref=_dereq_("../../util/intersection_tests"),multiPolygonIntersectsMultiPolygon=ref.multiPolygonIntersectsMultiPolygon,ref$1=_dereq_("../query_utils"),translateDistance=ref$1.translateDistance,translate=ref$1.translate,properties=_dereq_("./fill_extrusion_style_layer_properties"),ref$2=_dereq_("../properties"),Transitionable=ref$2.Transitionable,Transitioning=ref$2.Transitioning,PossiblyEvaluated=ref$2.PossiblyEvaluated,FillExtrusionStyleLayer=function(t){function e(e){t.call(this,e,properties)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new FillExtrusionBucket(t)},e.prototype.queryRadius=function(){return translateDistance(this.paint.get("fill-extrusion-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,i,n,o){var s=translate(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),n,o);return multiPolygonIntersectsMultiPolygon(s,r)},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("fill-extrusion-opacity")&&"none"!==this.visibility},e.prototype.resize=function(){this.viewportFrame&&(this.viewportFrame.destroy(),this.viewportFrame=null)},e}(StyleLayer);module.exports=FillExtrusionStyleLayer;
},{"../../data/bucket/fill_extrusion_bucket":49,"../../util/intersection_tests":275,"../properties":199,"../query_utils":200,"../style_layer":202,"./fill_extrusion_style_layer_properties":208}],208:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"fill-extrusion-opacity":new DataConstantProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new DataDrivenProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new DataConstantProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new DataConstantProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new CrossFadedProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new DataDrivenProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new DataDrivenProperty(styleSpec["paint_fill-extrusion"]["fill-extrusion-base"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],209:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),FillBucket=_dereq_("../../data/bucket/fill_bucket"),ref=_dereq_("../../util/intersection_tests"),multiPolygonIntersectsMultiPolygon=ref.multiPolygonIntersectsMultiPolygon,ref$1=_dereq_("../query_utils"),translateDistance=ref$1.translateDistance,translate=ref$1.translate,properties=_dereq_("./fill_style_layer_properties"),ref$2=_dereq_("../properties"),Transitionable=ref$2.Transitionable,Transitioning=ref$2.Transitioning,PossiblyEvaluated=ref$2.PossiblyEvaluated,FillStyleLayer=function(t){function e(e){t.call(this,e,properties)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(t){this.paint=this._transitioningPaint.possiblyEvaluate(t),void 0===this._transitionablePaint.getValue("fill-outline-color")&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"])},e.prototype.createBucket=function(t){return new FillBucket(t)},e.prototype.queryRadius=function(){return translateDistance(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,i,l,n){var a=translate(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),l,n);return multiPolygonIntersectsMultiPolygon(a,r)},e}(StyleLayer);module.exports=FillStyleLayer;
},{"../../data/bucket/fill_bucket":47,"../../util/intersection_tests":275,"../properties":199,"../query_utils":200,"../style_layer":202,"./fill_style_layer_properties":210}],210:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"fill-antialias":new DataConstantProperty(styleSpec.paint_fill["fill-antialias"]),"fill-opacity":new DataDrivenProperty(styleSpec.paint_fill["fill-opacity"]),"fill-color":new DataDrivenProperty(styleSpec.paint_fill["fill-color"]),"fill-outline-color":new DataDrivenProperty(styleSpec.paint_fill["fill-outline-color"]),"fill-translate":new DataConstantProperty(styleSpec.paint_fill["fill-translate"]),"fill-translate-anchor":new DataConstantProperty(styleSpec.paint_fill["fill-translate-anchor"]),"fill-pattern":new CrossFadedProperty(styleSpec.paint_fill["fill-pattern"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],211:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),HeatmapBucket=_dereq_("../../data/bucket/heatmap_bucket"),RGBAImage=_dereq_("../../util/image").RGBAImage,properties=_dereq_("./heatmap_style_layer_properties"),ref=_dereq_("../properties"),Transitionable=ref.Transitionable,Transitioning=ref.Transitioning,PossiblyEvaluated=ref.PossiblyEvaluated,HeatmapStyleLayer=function(t){function e(e){t.call(this,e,properties),this._updateColorRamp()}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new HeatmapBucket(t)},e.prototype.setPaintProperty=function(e,r,a){t.prototype.setPaintProperty.call(this,e,r,a),"heatmap-color"===e&&this._updateColorRamp()},e.prototype._updateColorRamp=function(){for(var t=this._transitionablePaint._values["heatmap-color"].value.expression,e=new Uint8Array(1024),r=e.length,a=4;a<r;a+=4){var o=t.evaluate({heatmapDensity:a/r});e[a+0]=Math.floor(255*o.r/o.a),e[a+1]=Math.floor(255*o.g/o.a),e[a+2]=Math.floor(255*o.b/o.a),e[a+3]=Math.floor(255*o.a)}this.colorRamp=new RGBAImage({width:256,height:1},e),this.colorRampTexture=null},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return!1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(StyleLayer);module.exports=HeatmapStyleLayer;
},{"../../data/bucket/heatmap_bucket":50,"../../util/image":274,"../properties":199,"../style_layer":202,"./heatmap_style_layer_properties":212}],212:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"heatmap-radius":new DataDrivenProperty(styleSpec.paint_heatmap["heatmap-radius"]),"heatmap-weight":new DataDrivenProperty(styleSpec.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new DataConstantProperty(styleSpec.paint_heatmap["heatmap-intensity"]),"heatmap-color":new HeatmapColorProperty(styleSpec.paint_heatmap["heatmap-color"]),"heatmap-opacity":new DataConstantProperty(styleSpec.paint_heatmap["heatmap-opacity"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],213:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),properties=_dereq_("./hillshade_style_layer_properties"),ref=_dereq_("../properties"),Transitionable=ref.Transitionable,Transitioning=ref.Transitioning,PossiblyEvaluated=ref.PossiblyEvaluated,HillshadeStyleLayer=function(e){function r(r){e.call(this,r,properties)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},r}(StyleLayer);module.exports=HillshadeStyleLayer;
},{"../properties":199,"../style_layer":202,"./hillshade_style_layer_properties":214}],214:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"hillshade-illumination-direction":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new DataConstantProperty(styleSpec.paint_hillshade["hillshade-accent-color"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],215:[function(_dereq_,module,exports){
"use strict";function getLineWidth(t,e){return e>0?e+2*t:t}function offsetLine(t,e){for(var r=[],i=new Point(0,0),n=0;n<t.length;n++){for(var a=t[n],o=[],l=0;l<a.length;l++){var u=a[l-1],s=a[l],p=a[l+1],y=0===l?i:s.sub(u)._unit()._perp(),f=l===a.length-1?i:p.sub(s)._unit()._perp(),c=y._add(f)._unit(),h=c.x*f.x+c.y*f.y;c._mult(1/h),o.push(c._mult(e)._add(s))}r.push(o)}return r}var Point=_dereq_("@mapbox/point-geometry"),StyleLayer=_dereq_("../style_layer"),LineBucket=_dereq_("../../data/bucket/line_bucket"),ref=_dereq_("../../util/intersection_tests"),multiPolygonIntersectsBufferedMultiLine=ref.multiPolygonIntersectsBufferedMultiLine,ref$1=_dereq_("../query_utils"),getMaximumPaintValue=ref$1.getMaximumPaintValue,translateDistance=ref$1.translateDistance,translate=ref$1.translate,properties=_dereq_("./line_style_layer_properties"),ref$2=_dereq_("../../util/util"),extend=ref$2.extend,EvaluationParameters=_dereq_("../evaluation_parameters"),ref$3=_dereq_("../properties"),Transitionable=ref$3.Transitionable,Transitioning=ref$3.Transitioning,Layout=ref$3.Layout,PossiblyEvaluated=ref$3.PossiblyEvaluated,DataDrivenProperty=ref$3.DataDrivenProperty,LineFloorwidthProperty=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new EvaluationParameters(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,i){return r=extend({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,i)},e}(DataDrivenProperty),lineFloorwidthProperty=new LineFloorwidthProperty(properties.paint.properties["line-width"].specification);lineFloorwidthProperty.useIntegerZoom=!0;var LineStyleLayer=function(t){function e(e){t.call(this,e,properties)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),this.paint._values["line-floorwidth"]=lineFloorwidthProperty.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e)},e.prototype.createBucket=function(t){return new LineBucket(t)},e.prototype.queryRadius=function(t){var e=t,r=getLineWidth(getMaximumPaintValue("line-width",this,e),getMaximumPaintValue("line-gap-width",this,e)),i=getMaximumPaintValue("line-offset",this,e);return r/2+Math.abs(i)+translateDistance(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,i,n,a){var o=translate(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),n,a),l=a/2*getLineWidth(this.paint.get("line-width").evaluate(e),this.paint.get("line-gap-width").evaluate(e)),u=this.paint.get("line-offset").evaluate(e);return u&&(r=offsetLine(r,u*a)),multiPolygonIntersectsBufferedMultiLine(o,r,l)},e}(StyleLayer);module.exports=LineStyleLayer;
},{"../../data/bucket/line_bucket":52,"../../util/intersection_tests":275,"../../util/util":285,"../evaluation_parameters":193,"../properties":199,"../query_utils":200,"../style_layer":202,"./line_style_layer_properties":216,"@mapbox/point-geometry":4}],216:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,layout=new Properties({"line-cap":new DataConstantProperty(styleSpec.layout_line["line-cap"]),"line-join":new DataDrivenProperty(styleSpec.layout_line["line-join"]),"line-miter-limit":new DataConstantProperty(styleSpec.layout_line["line-miter-limit"]),"line-round-limit":new DataConstantProperty(styleSpec.layout_line["line-round-limit"])}),paint=new Properties({"line-opacity":new DataDrivenProperty(styleSpec.paint_line["line-opacity"]),"line-color":new DataDrivenProperty(styleSpec.paint_line["line-color"]),"line-translate":new DataConstantProperty(styleSpec.paint_line["line-translate"]),"line-translate-anchor":new DataConstantProperty(styleSpec.paint_line["line-translate-anchor"]),"line-width":new DataDrivenProperty(styleSpec.paint_line["line-width"]),"line-gap-width":new DataDrivenProperty(styleSpec.paint_line["line-gap-width"]),"line-offset":new DataDrivenProperty(styleSpec.paint_line["line-offset"]),"line-blur":new DataDrivenProperty(styleSpec.paint_line["line-blur"]),"line-dasharray":new CrossFadedProperty(styleSpec.paint_line["line-dasharray"]),"line-pattern":new CrossFadedProperty(styleSpec.paint_line["line-pattern"])});module.exports={paint:paint,layout:layout};
},{"../../style-spec/reference/latest":163,"../properties":199}],217:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),properties=_dereq_("./raster_style_layer_properties"),ref=_dereq_("../properties"),Transitionable=ref.Transitionable,Transitioning=ref.Transitioning,PossiblyEvaluated=ref.PossiblyEvaluated,RasterStyleLayer=function(e){function r(r){e.call(this,r,properties)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r}(StyleLayer);module.exports=RasterStyleLayer;
},{"../properties":199,"../style_layer":202,"./raster_style_layer_properties":218}],218:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,paint=new Properties({"raster-opacity":new DataConstantProperty(styleSpec.paint_raster["raster-opacity"]),"raster-hue-rotate":new DataConstantProperty(styleSpec.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new DataConstantProperty(styleSpec.paint_raster["raster-brightness-min"]),"raster-brightness-max":new DataConstantProperty(styleSpec.paint_raster["raster-brightness-max"]),"raster-saturation":new DataConstantProperty(styleSpec.paint_raster["raster-saturation"]),"raster-contrast":new DataConstantProperty(styleSpec.paint_raster["raster-contrast"]),"raster-fade-duration":new DataConstantProperty(styleSpec.paint_raster["raster-fade-duration"])});module.exports={paint:paint};
},{"../../style-spec/reference/latest":163,"../properties":199}],219:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("../style_layer"),SymbolBucket=_dereq_("../../data/bucket/symbol_bucket"),resolveTokens=_dereq_("../../util/token"),ref=_dereq_("../../style-spec/expression"),isExpression=ref.isExpression,properties=_dereq_("./symbol_style_layer_properties"),ref$1=_dereq_("../properties"),Transitionable=ref$1.Transitionable,Transitioning=ref$1.Transitioning,Layout=ref$1.Layout,PossiblyEvaluated=ref$1.PossiblyEvaluated,SymbolStyleLayer=function(t){function e(e){t.call(this,e,properties)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e){t.prototype.recalculate.call(this,e),"auto"===this.layout.get("icon-rotation-alignment")&&("line"===this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("line"===this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment"))},e.prototype.getValueAndResolveTokens=function(t,e){var o=this.layout.get(t).evaluate(e),i=this._unevaluatedLayout._values[t];return i.isDataDriven()||isExpression(i.value)?o:resolveTokens(e.properties,o)},e.prototype.createBucket=function(t){return new SymbolBucket(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return!1},e}(StyleLayer);module.exports=SymbolStyleLayer;
},{"../../data/bucket/symbol_bucket":54,"../../style-spec/expression":142,"../../util/token":284,"../properties":199,"../style_layer":202,"./symbol_style_layer_properties":220}],220:[function(_dereq_,module,exports){
"use strict";var styleSpec=_dereq_("../../style-spec/reference/latest"),ref=_dereq_("../properties"),Properties=ref.Properties,DataConstantProperty=ref.DataConstantProperty,DataDrivenProperty=ref.DataDrivenProperty,CrossFadedProperty=ref.CrossFadedProperty,HeatmapColorProperty=ref.HeatmapColorProperty,layout=new Properties({"symbol-placement":new DataConstantProperty(styleSpec.layout_symbol["symbol-placement"]),"symbol-spacing":new DataConstantProperty(styleSpec.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new DataConstantProperty(styleSpec.layout_symbol["symbol-avoid-edges"]),"icon-allow-overlap":new DataConstantProperty(styleSpec.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new DataConstantProperty(styleSpec.layout_symbol["icon-ignore-placement"]),"icon-optional":new DataConstantProperty(styleSpec.layout_symbol["icon-optional"]),"icon-rotation-alignment":new DataConstantProperty(styleSpec.layout_symbol["icon-rotation-alignment"]),"icon-size":new DataDrivenProperty(styleSpec.layout_symbol["icon-size"]),"icon-text-fit":new DataConstantProperty(styleSpec.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new DataConstantProperty(styleSpec.layout_symbol["icon-text-fit-padding"]),"icon-image":new DataDrivenProperty(styleSpec.layout_symbol["icon-image"]),"icon-rotate":new DataDrivenProperty(styleSpec.layout_symbol["icon-rotate"]),"icon-padding":new DataConstantProperty(styleSpec.layout_symbol["icon-padding"]),"icon-keep-upright":new DataConstantProperty(styleSpec.layout_symbol["icon-keep-upright"]),"icon-offset":new DataDrivenProperty(styleSpec.layout_symbol["icon-offset"]),"icon-anchor":new DataDrivenProperty(styleSpec.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new DataConstantProperty(styleSpec.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new DataConstantProperty(styleSpec.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new DataConstantProperty(styleSpec.layout_symbol["text-rotation-alignment"]),"text-field":new DataDrivenProperty(styleSpec.layout_symbol["text-field"]),"text-font":new DataDrivenProperty(styleSpec.layout_symbol["text-font"]),"text-size":new DataDrivenProperty(styleSpec.layout_symbol["text-size"]),"text-max-width":new DataDrivenProperty(styleSpec.layout_symbol["text-max-width"]),"text-line-height":new DataConstantProperty(styleSpec.layout_symbol["text-line-height"]),"text-letter-spacing":new DataDrivenProperty(styleSpec.layout_symbol["text-letter-spacing"]),"text-justify":new DataDrivenProperty(styleSpec.layout_symbol["text-justify"]),"text-anchor":new DataDrivenProperty(styleSpec.layout_symbol["text-anchor"]),"text-max-angle":new DataConstantProperty(styleSpec.layout_symbol["text-max-angle"]),"text-rotate":new DataDrivenProperty(styleSpec.layout_symbol["text-rotate"]),"text-padding":new DataConstantProperty(styleSpec.layout_symbol["text-padding"]),"text-keep-upright":new DataConstantProperty(styleSpec.layout_symbol["text-keep-upright"]),"text-transform":new DataDrivenProperty(styleSpec.layout_symbol["text-transform"]),"text-offset":new DataDrivenProperty(styleSpec.layout_symbol["text-offset"]),"text-allow-overlap":new DataConstantProperty(styleSpec.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new DataConstantProperty(styleSpec.layout_symbol["text-ignore-placement"]),"text-optional":new DataConstantProperty(styleSpec.layout_symbol["text-optional"])}),paint=new Properties({"icon-opacity":new DataDrivenProperty(styleSpec.paint_symbol["icon-opacity"]),"icon-color":new DataDrivenProperty(styleSpec.paint_symbol["icon-color"]),"icon-halo-color":new DataDrivenProperty(styleSpec.paint_symbol["icon-halo-color"]),"icon-halo-width":new DataDrivenProperty(styleSpec.paint_symbol["icon-halo-width"]),"icon-halo-blur":new DataDrivenProperty(styleSpec.paint_symbol["icon-halo-blur"]),"icon-translate":new DataConstantProperty(styleSpec.paint_symbol["icon-translate"]),"icon-translate-anchor":new DataConstantProperty(styleSpec.paint_symbol["icon-translate-anchor"]),"text-opacity":new DataDrivenProperty(styleSpec.paint_symbol["text-opacity"]),"text-color":new DataDrivenProperty(styleSpec.paint_symbol["text-color"]),"text-halo-color":new DataDrivenProperty(styleSpec.paint_symbol["text-halo-color"]),"text-halo-width":new DataDrivenProperty(styleSpec.paint_symbol["text-halo-width"]),"text-halo-blur":new DataDrivenProperty(styleSpec.paint_symbol["text-halo-blur"]),"text-translate":new DataConstantProperty(styleSpec.paint_symbol["text-translate"]),"text-translate-anchor":new DataConstantProperty(styleSpec.paint_symbol["text-translate-anchor"])});module.exports={paint:paint,layout:layout};
},{"../../style-spec/reference/latest":163,"../properties":199}],221:[function(_dereq_,module,exports){
"use strict";var StyleLayer=_dereq_("./style_layer"),util=_dereq_("../util/util"),featureFilter=_dereq_("../style-spec/feature_filter"),groupByLayout=_dereq_("../style-spec/group_by_layout"),StyleLayerIndex=function(e){e&&this.replace(e)};StyleLayerIndex.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[])},StyleLayerIndex.prototype.update=function(e,r){for(var t=this,a=0,i=e;a<i.length;a+=1){var l=i[a];t._layerConfigs[l.id]=l;var y=t._layers[l.id]=StyleLayer.create(l);y._featureFilter=featureFilter(y.filter)}for(var u=0,s=r;u<s.length;u+=1){var o=s[u];delete t._layerConfigs[o],delete t._layers[o]}this.familiesBySource={};for(var n=groupByLayout(util.values(this._layerConfigs)),f=0,p=n;f<p.length;f+=1){var c=p[f],_=c.map(function(e){return t._layers[e.id]}),d=_[0];if("none"!==d.visibility){var v=d.source||"",g=t.familiesBySource[v];g||(g=t.familiesBySource[v]={});var h=d.sourceLayer||"_geojsonTileLayer",L=g[h];L||(L=g[h]=[]),L.push(_)}}},module.exports=StyleLayerIndex;
},{"../style-spec/feature_filter":151,"../style-spec/group_by_layout":153,"../util/util":285,"./style_layer":202}],222:[function(_dereq_,module,exports){
"use strict";module.exports=_dereq_("../style-spec/validate_style.min"),module.exports.emitErrors=function(r,e){if(e&&e.length){for(var t=0,o=e;t<o.length;t+=1){var s=o[t],i=s.message;r.fire("error",{error:new Error(i)})}return!0}return!1};
},{"../style-spec/validate_style.min":192}],223:[function(_dereq_,module,exports){
"use strict";var ZoomHistory=function(){this.first=!0};ZoomHistory.prototype.update=function(o,t){var s=Math.floor(o);return this.first?(this.first=!1,this.lastIntegerZoom=s,this.lastIntegerZoomTime=0,this.lastZoom=o,this.lastFloorZoom=s,!0):(this.lastFloorZoom>s?(this.lastIntegerZoom=s+1,this.lastIntegerZoomTime=t):this.lastFloorZoom<s&&(this.lastIntegerZoom=s,this.lastIntegerZoomTime=t),o!==this.lastZoom&&(this.lastZoom=o,this.lastFloorZoom=s,!0))},module.exports=ZoomHistory;
},{}],224:[function(_dereq_,module,exports){
"use strict";var Point=_dereq_("@mapbox/point-geometry"),ref=_dereq_("../util/web_worker_transfer"),register=ref.register,Anchor=function(t){function e(e,r,o,n){t.call(this,e,r),this.angle=o,void 0!==n&&(this.segment=n)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(Point);register("Anchor",Anchor),module.exports=Anchor;
},{"../util/web_worker_transfer":288,"@mapbox/point-geometry":4}],225:[function(_dereq_,module,exports){
"use strict";function checkMaxAngle(e,t,a,r,n){if(void 0===t.segment)return!0;for(var i=t,s=t.segment+1,f=0;f>-a/2;){if(--s<0)return!1;f-=e[s].dist(i),i=e[s]}f+=e[s].dist(e[s+1]),s++;for(var l=[],o=0;f<a/2;){var u=e[s-1],c=e[s],g=e[s+1];if(!g)return!1;var h=u.angleTo(c)-c.angleTo(g);for(h=Math.abs((h+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:f,angleDelta:h}),o+=h;f-l[0].distance>r;)o-=l.shift().angleDelta;if(o>n)return!1;s++,f+=c.dist(g)}return!0}module.exports=checkMaxAngle;
},{}],226:[function(_dereq_,module,exports){
"use strict";function clipLine(n,x,y,o,e){for(var r=[],t=0;t<n.length;t++)for(var i=n[t],u=void 0,d=0;d<i.length-1;d++){var P=i[d],w=i[d+1];P.x<x&&w.x<x||(P.x<x?P=new Point(x,P.y+(w.y-P.y)*((x-P.x)/(w.x-P.x)))._round():w.x<x&&(w=new Point(x,P.y+(w.y-P.y)*((x-P.x)/(w.x-P.x)))._round()),P.y<y&&w.y<y||(P.y<y?P=new Point(P.x+(w.x-P.x)*((y-P.y)/(w.y-P.y)),y)._round():w.y<y&&(w=new Point(P.x+(w.x-P.x)*((y-P.y)/(w.y-P.y)),y)._round()),P.x>=o&&w.x>=o||(P.x>=o?P=new Point(o,P.y+(w.y-P.y)*((o-P.x)/(w.x-P.x)))._round():w.x>=o&&(w=new Point(o,P.y+(w.y-P.y)*((o-P.x)/(w.x-P.x)))._round()),P.y>=e&&w.y>=e||(P.y>=e?P=new Point(P.x+(w.x-P.x)*((e-P.y)/(w.y-P.y)),e)._round():w.y>=e&&(w=new Point(P.x+(w.x-P.x)*((e-P.y)/(w.y-P.y)),e)._round()),u&&P.equals(u[u.length-1])||(u=[P],r.push(u)),u.push(w)))))}return r}var Point=_dereq_("@mapbox/point-geometry");module.exports=clipLine;
},{"@mapbox/point-geometry":4}],227:[function(_dereq_,module,exports){
"use strict";var CollisionFeature=function(t,e,i,o,a,r,l,n,s,d,h){var u=l.top*n-s,f=l.bottom*n+s,c=l.left*n-s,x=l.right*n+s;if(this.boxStartIndex=t.length,d){var m=f-u,v=x-c;m>0&&(m=Math.max(10*n,m),this._addLineCollisionCircles(t,e,i,i.segment,v,m,o,a,r,h))}else t.emplaceBack(i.x,i.y,c,u,x,f,o,a,r,0,0);this.boxEndIndex=t.length};CollisionFeature.prototype._addLineCollisionCircles=function(t,e,i,o,a,r,l,n,s,d){var h=r/2,u=Math.floor(a/h),f=1+.4*Math.log(d)/Math.LN2,c=Math.floor(u*f/2),x=-r/2,m=i,v=o+1,C=x,b=-a/2,g=b-a/4;do{if(--v<0){if(C>b)return;v=0;break}C-=e[v].dist(m),m=e[v]}while(C>g);for(var p=e[v].dist(e[v+1]),M=-c;M<u+c;M++){var _=M*h,k=b+_;if(_<0&&(k+=_),_>a&&(k+=_-a),!(k<C)){for(;C+p<k;){if(C+=p,++v+1>=e.length)return;p=e[v].dist(e[v+1])}var y=k-C,F=e[v],L=e[v+1],B=L.sub(F)._unit()._mult(y)._add(F)._round(),I=Math.abs(k-x)<h?0:.8*(k-x);t.emplaceBack(B.x,B.y,-r/2,-r/2,r/2,r/2,l,n,s,r/2,I)}}},module.exports=CollisionFeature;
},{}],228:[function(_dereq_,module,exports){
"use strict";function markCollisionCircleUsed(i,t,e){i[t+4]=e?1:0}var Point=_dereq_("@mapbox/point-geometry"),intersectionTests=_dereq_("../util/intersection_tests"),Grid=_dereq_("./grid_index"),glmatrix=_dereq_("@mapbox/gl-matrix"),mat4=glmatrix.mat4,projection=_dereq_("../symbol/projection"),viewportPadding=100,CollisionIndex=function(i,t,e){void 0===t&&(t=new Grid(i.width+2*viewportPadding,i.height+2*viewportPadding,25)),void 0===e&&(e=new Grid(i.width+2*viewportPadding,i.height+2*viewportPadding,25)),this.transform=i,this.grid=t,this.ignoredGrid=e,this.pitchfactor=Math.cos(i._pitch)*i.cameraToCenterDistance};CollisionIndex.prototype.placeCollisionBox=function(i,t,e,r){var o=this.projectAndGetPerspectiveRatio(r,i.anchorPointX,i.anchorPointY),n=e*o.perspectiveRatio,a=i.x1/n+o.point.x,s=i.y1/n+o.point.y,c=i.x2/n+o.point.x,p=i.y2/n+o.point.y;return!t&&this.grid.hitTest(a,s,c,p)?[]:[a,s,c,p]},CollisionIndex.prototype.approximateTileDistance=function(i,t,e,r,o){var n=o?1:r/this.pitchfactor,a=i.lastSegmentViewportDistance*e;return i.prevTileDistance+a+(n-1)*a*Math.abs(Math.sin(t))},CollisionIndex.prototype.placeCollisionCircles=function(i,t,e,r,o,n,a,s,c,p,l,h,d){var x=this,g=[],f=this.projectAnchor(p,n.anchorX,n.anchorY),v={},u=c/24,m=n.lineOffsetX*c,y=n.lineOffsetY*c,C=new Point(n.anchorX,n.anchorY),P=projection.project(C,l).point,I=projection.placeFirstAndLastGlyph(u,s,m,y,!1,P,C,n,a,l,v,!0),w=!1,D=f.perspectiveRatio*r,j=D/e,T=0,G=0;I&&(T=this.approximateTileDistance(I.first.tileDistance,I.first.angle,j,f.cameraDistance,d),G=this.approximateTileDistance(I.last.tileDistance,I.last.angle,j,f.cameraDistance,d));for(var M=0;M<i.length;M+=5){var b=i[M],R=i[M+1],k=i[M+2],q=i[M+3];if(!I||q<-T||q>G)markCollisionCircleUsed(i,M,!1);else{var A=x.projectPoint(p,b,R),U=k/D;if(g.length>0){var X=A.x-g[g.length-4],Y=A.y-g[g.length-3];if(U*U*2>X*X+Y*Y){if(M+8<i.length){var L=i[M+8];if(L>-T&&L<G){markCollisionCircleUsed(i,M,!1);continue}}}}var _=M/5;if(g.push(A.x,A.y,U,_),markCollisionCircleUsed(i,M,!0),!t&&x.grid.hitTestCircle(A.x,A.y,U)){if(!h)return[];w=!0}}}return w?[]:g},CollisionIndex.prototype.queryRenderedSymbols=function(i,t,e,r,o){var n=this,a={},s=[];if(0===i.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return s;for(var c=this.transform.calculatePosMatrix(t.toUnwrapped()),p=[],l=1/0,h=1/0,d=-1/0,x=-1/0,g=0;g<i.length;g++)for(var f=i[g],v=0;v<f.length;v++){var u=n.projectPoint(c,f[v].x,f[v].y);l=Math.min(l,u.x),h=Math.min(h,u.y),d=Math.max(d,u.x),x=Math.max(x,u.y),p.push(u)}for(var m=t.key,y=[],C=this.grid.query(l,h,d,x),P=0;P<C.length;P++)C[P].sourceID===o&&C[P].tileID===m&&y.push(C[P].boxIndex);for(var I=this.ignoredGrid.query(l,h,d,x),w=0;w<I.length;w++)I[w].sourceID===o&&I[w].tileID===m&&y.push(I[w].boxIndex);for(var D=0;D<y.length;D++){var j=r.get(y[D]),T=j.sourceLayerIndex,G=j.featureIndex,M=j.bucketIndex;if(void 0===a[T]&&(a[T]={}),void 0===a[T][G]&&(a[T][G]={}),!a[T][G][M]){var b=n.projectAndGetPerspectiveRatio(c,j.anchorPointX,j.anchorPointY),R=e*b.perspectiveRatio,k=j.x1/R+b.point.x,q=j.y1/R+b.point.y,A=j.x2/R+b.point.x,U=j.y2/R+b.point.y,X=[new Point(k,q),new Point(A,q),new Point(A,U),new Point(k,U)];intersectionTests.polygonIntersectsPolygon(p,X)&&(a[T][G][M]=!0,s.push(y[D]))}}return s},CollisionIndex.prototype.insertCollisionBox=function(i,t,e,r,o){var n=t?this.ignoredGrid:this.grid,a={tileID:e,sourceID:r,boxIndex:o};n.insert(a,i[0],i[1],i[2],i[3])},CollisionIndex.prototype.insertCollisionCircles=function(i,t,e,r,o){for(var n=t?this.ignoredGrid:this.grid,a=0;a<i.length;a+=4){var s={tileID:e,sourceID:r,boxIndex:o+i[a+3]};n.insertCircle(s,i[a],i[a+1],i[a+2])}},CollisionIndex.prototype.projectAnchor=function(i,t,e){var r=[t,e,0,1];return projection.xyTransformMat4(r,r,i),{perspectiveRatio:.5+r[3]/this.transform.cameraToCenterDistance*.5,cameraDistance:r[3]}},CollisionIndex.prototype.projectPoint=function(i,t,e){var r=[t,e,0,1];return projection.xyTransformMat4(r,r,i),new Point((r[0]/r[3]+1)/2*this.transform.width+viewportPadding,(-r[1]/r[3]+1)/2*this.transform.height+viewportPadding)},CollisionIndex.prototype.projectAndGetPerspectiveRatio=function(i,t,e){var r=[t,e,0,1];return projection.xyTransformMat4(r,r,i),{point:new Point((r[0]/r[3]+1)/2*this.transform.width+viewportPadding,(-r[1]/r[3]+1)/2*this.transform.height+viewportPadding),perspectiveRatio:.5+r[3]/this.transform.cameraToCenterDistance*.5}},module.exports=CollisionIndex;
},{"../symbol/projection":234,"../util/intersection_tests":275,"./grid_index":231,"@mapbox/gl-matrix":2,"@mapbox/point-geometry":4}],229:[function(_dereq_,module,exports){
"use strict";var EXTENT=_dereq_("../data/extent"),OpacityState=_dereq_("./opacity_state"),roundingFactor=512/EXTENT/2,TileLayerIndex=function(e,t){var a=this;this.tileID=e,this.symbolInstances={};for(var i=0,o=t;i<o.length;i+=1){var n=o[i],s=n.key;a.symbolInstances[s]||(a.symbolInstances[s]=[]),a.symbolInstances[s].push({instance:n,coordinates:a.getScaledCoordinates(n,e)}),n.isDuplicate=!1,n.textOpacityState=new OpacityState,n.iconOpacityState=new OpacityState}};TileLayerIndex.prototype.getScaledCoordinates=function(e,t){var a=t.canonical.z-this.tileID.canonical.z,i=roundingFactor/(1<<a),o=e.anchor;return{x:Math.floor((t.canonical.x*EXTENT+o.x)*i),y:Math.floor((t.canonical.y*EXTENT+o.y)*i)}},TileLayerIndex.prototype.getMatchingSymbol=function(e,t){var a=this;if(this.symbolInstances[e.key])for(var i=this.getScaledCoordinates(e,t),o=0,n=a.symbolInstances[e.key];o<n.length;o+=1){var s=n[o];if(Math.abs(s.coordinates.x-i.x)<=1&&Math.abs(s.coordinates.y-i.y)<=1)return s.instance}},TileLayerIndex.prototype.forEachSymbolInstance=function(e){var t=this;for(var a in t.symbolInstances)for(var i=t.symbolInstances[a],o=0,n=i;o<n.length;o+=1){var s=n[o];e(s.instance)}};var CrossTileSymbolLayerIndex=function(){this.indexes={}};CrossTileSymbolLayerIndex.prototype.addTile=function(e,t){var a=this,i=25,o=0;for(var n in a.indexes)i=Math.min(n,i),o=Math.max(n,o);for(var s=new TileLayerIndex(e,t),r=o;r>e.overscaledZ;r--){var l=a.indexes[r];for(var c in l){var y=l[c];y.tileID.isChildOf(e)&&a.blockLabels(y,s,!1)}}var d=this.indexes[e.overscaledZ]&&this.indexes[e.overscaledZ][e.key];d&&(this.blockLabels(s,d,!0),this.removeTile(e));for(var v=e.overscaledZ-1;v>=i;v--){var x=e.scaledTo(v),h=a.indexes[v]&&a.indexes[v][x.key];h&&a.blockLabels(s,h,!0)}void 0===this.indexes[e.overscaledZ]&&(this.indexes[e.overscaledZ]={}),this.indexes[e.overscaledZ][e.key]=s},CrossTileSymbolLayerIndex.prototype.removeTile=function(e){var t=this,a=this.indexes[e.overscaledZ][e.key];delete this.indexes[e.overscaledZ][e.key],0===Object.keys(this.indexes[e.overscaledZ]).length&&delete this.indexes[e.overscaledZ];for(var i=Math.min.apply(Math,[25].concat(Object.keys(this.indexes))),o=e.overscaledZ-1;o>=i;o--){var n=e.scaledTo(o);if(!n)break;var s=t.indexes[o]&&t.indexes[o][n.key];s&&t.unblockLabels(a,s)}},CrossTileSymbolLayerIndex.prototype.blockLabels=function(e,t,a){e.forEachSymbolInstance(function(i){if(!i.isDuplicate){var o=t.getMatchingSymbol(i,e.tileID);void 0!==o&&(o.isDuplicate||(o.isDuplicate=!0,a&&(i.textOpacityState=o.textOpacityState.clone(),i.iconOpacityState=o.iconOpacityState.clone())))}})},CrossTileSymbolLayerIndex.prototype.unblockLabels=function(e,t){e.forEachSymbolInstance(function(a){if(!a.isDuplicate){var i=t.getMatchingSymbol(a,e.tileID);void 0!==i&&(i.isDuplicate=!1,i.textOpacityState=a.textOpacityState.clone(),i.iconOpacityState=a.iconOpacityState.clone(),a.isDuplicate=!0)}})};var CrossTileSymbolIndex=function(){this.layerIndexes={}};CrossTileSymbolIndex.prototype.addTileLayer=function(e,t,a){var i=this.layerIndexes[e];void 0===i&&(i=this.layerIndexes[e]=new CrossTileSymbolLayerIndex),i.addTile(t,a)},CrossTileSymbolIndex.prototype.removeTileLayer=function(e,t){var a=this.layerIndexes[e];void 0!==a&&a.removeTile(t)},module.exports=CrossTileSymbolIndex;
},{"../data/extent":56,"./opacity_state":233}],230:[function(_dereq_,module,exports){
"use strict";function getAnchors(e,r,t,n,a,l,o,i,c){var h=n?.6*l*o:0,s=Math.max(n?n.right-n.left:0,a?a.right-a.left:0),u=0===e[0].x||e[0].x===c||0===e[0].y||e[0].y===c;r-s*o<r/4&&(r=s*o+r/4);var g=2*l;return resample(e,u?r/2*i%r:(s/2+g)*o*i%r,r,h,t,s*o,u,!1,c)}function resample(e,r,t,n,a,l,o,i,c){for(var h=l/2,s=0,u=0;u<e.length-1;u++)s+=e[u].dist(e[u+1]);for(var g=0,p=r-t,x=[],f=0;f<e.length-1;f++){for(var m=e[f],v=e[f+1],y=m.dist(v),A=v.angleTo(m);p+t<g+y;){p+=t;var d=(p-g)/y,k=interpolate(m.x,v.x,d),q=interpolate(m.y,v.y,d);if(k>=0&&k<c&&q>=0&&q<c&&p-h>=0&&p+h<=s){var M=new Anchor(k,q,A,f);M._round(),n&&!checkMaxAngle(e,M,l,n,a)||x.push(M)}}g+=y}return i||x.length||o||(x=resample(e,g/2,t,n,a,l,o,!0,c)),x}var interpolate=_dereq_("../style-spec/util/interpolate").number,Anchor=_dereq_("../symbol/anchor"),checkMaxAngle=_dereq_("./check_max_angle");module.exports=getAnchors;
},{"../style-spec/util/interpolate":169,"../symbol/anchor":224,"./check_max_angle":225}],231:[function(_dereq_,module,exports){
"use strict";var GridIndex=function(e,t,i){var r=this.boxCells=[],s=this.circleCells=[];this.xCellCount=Math.ceil(e/i),this.yCellCount=Math.ceil(t/i);for(var l=0;l<this.xCellCount*this.yCellCount;l++)r.push([]),s.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=e,this.height=t,this.xScale=this.xCellCount/e,this.yScale=this.yCellCount/t,this.boxUid=0,this.circleUid=0};GridIndex.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},GridIndex.prototype.insert=function(e,t,i,r,s){this._forEachCell(t,i,r,s,this._insertBoxCell,this.boxUid++),this.boxKeys.push(e),this.bboxes.push(t),this.bboxes.push(i),this.bboxes.push(r),this.bboxes.push(s)},GridIndex.prototype.insertCircle=function(e,t,i,r){this._forEachCell(t-r,i-r,t+r,i+r,this._insertCircleCell,this.circleUid++),this.circleKeys.push(e),this.circles.push(t),this.circles.push(i),this.circles.push(r)},GridIndex.prototype._insertBoxCell=function(e,t,i,r,s,l){this.boxCells[s].push(l)},GridIndex.prototype._insertCircleCell=function(e,t,i,r,s,l){this.circleCells[s].push(l)},GridIndex.prototype._query=function(e,t,i,r,s){if(i<0||e>this.width||r<0||t>this.height)return!s&&[];var l=[];if(e<=0&&t<=0&&this.width<=i&&this.height<=r)l=Array.prototype.slice.call(this.boxKeys).concat(this.circleKeys);else{var o={hitTest:s,seenUids:{box:{},circle:{}}};this._forEachCell(e,t,i,r,this._queryCell,l,o)}return s?l.length>0:l},GridIndex.prototype._queryCircle=function(e,t,i,r){var s=e-i,l=e+i,o=t-i,h=t+i;if(l<0||s>this.width||h<0||o>this.height)return!r&&[];var n=[],c={hitTest:r,circle:{x:e,y:t,radius:i},seenUids:{box:{},circle:{}}};return this._forEachCell(s,o,l,h,this._queryCellCircle,n,c),r?n.length>0:n},GridIndex.prototype.query=function(e,t,i,r){return this._query(e,t,i,r,!1)},GridIndex.prototype.hitTest=function(e,t,i,r){return this._query(e,t,i,r,!0)},GridIndex.prototype.hitTestCircle=function(e,t,i){return this._queryCircle(e,t,i,!0)},GridIndex.prototype._queryCell=function(e,t,i,r,s,l,o){var h=this,n=o.seenUids,c=this.boxCells[s];if(null!==c)for(var u=this.bboxes,d=0,C=c;d<C.length;d+=1){var a=C[d];if(!n.box[a]){n.box[a]=!0;var x=4*a;if(e<=u[x+2]&&t<=u[x+3]&&i>=u[x+0]&&r>=u[x+1]){if(o.hitTest)return l.push(!0),!0;l.push(h.boxKeys[a])}}}var p=this.circleCells[s];if(null!==p)for(var f=this.circles,y=0,v=p;y<v.length;y+=1){var b=v[y];if(!n.circle[b]){n.circle[b]=!0;var _=3*b;if(h._circleAndRectCollide(f[_],f[_+1],f[_+2],e,t,i,r)){if(o.hitTest)return l.push(!0),!0;l.push(h.circleKeys[b])}}}},GridIndex.prototype._queryCellCircle=function(e,t,i,r,s,l,o){var h=this,n=o.circle,c=o.seenUids,u=this.boxCells[s];if(null!==u)for(var d=this.bboxes,C=0,a=u;C<a.length;C+=1){var x=a[C];if(!c.box[x]){c.box[x]=!0;var p=4*x;if(h._circleAndRectCollide(n.x,n.y,n.radius,d[p+0],d[p+1],d[p+2],d[p+3]))return l.push(!0),!0}}var f=this.circleCells[s];if(null!==f)for(var y=this.circles,v=0,b=f;v<b.length;v+=1){var _=b[v];if(!c.circle[_]){c.circle[_]=!0;var G=3*_;if(h._circlesCollide(y[G],y[G+1],y[G+2],n.x,n.y,n.radius))return l.push(!0),!0}}},GridIndex.prototype._forEachCell=function(e,t,i,r,s,l,o){for(var h=this,n=this._convertToXCellCoord(e),c=this._convertToYCellCoord(t),u=this._convertToXCellCoord(i),d=this._convertToYCellCoord(r),C=n;C<=u;C++)for(var a=c;a<=d;a++){var x=h.xCellCount*a+C;if(s.call(h,e,t,i,r,x,l,o))return}},GridIndex.prototype._convertToXCellCoord=function(e){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(e*this.xScale)))},GridIndex.prototype._convertToYCellCoord=function(e){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(e*this.yScale)))},GridIndex.prototype._circlesCollide=function(e,t,i,r,s,l){var o=r-e,h=s-t,n=i+l;return n*n>o*o+h*h},GridIndex.prototype._circleAndRectCollide=function(e,t,i,r,s,l,o){var h=(l-r)/2,n=Math.abs(e-(r+h));if(n>h+i)return!1;var c=(o-s)/2,u=Math.abs(t-(s+c));if(u>c+i)return!1;if(n<=h||u<=c)return!0;var d=n-h,C=u-c;return d*d+C*C<=i*i},module.exports=GridIndex;
},{}],232:[function(_dereq_,module,exports){
"use strict";module.exports=function(e){function t(t){g.push(e[t]),l++}function r(e,t,r){var n=u[e];return delete u[e],u[t]=n,g[n].geometry[0].pop(),g[n].geometry[0]=g[n].geometry[0].concat(r[0]),n}function n(e,t,r){var n=i[t];return delete i[t],i[e]=n,g[n].geometry[0].shift(),g[n].geometry[0]=r[0].concat(g[n].geometry[0]),n}function o(e,t,r){var n=r?t[0][t[0].length-1]:t[0][0];return e+":"+n.x+":"+n.y}for(var i={},u={},g=[],l=0,m=0;m<e.length;m++){var y=e[m],c=y.geometry,f=y.text;if(f){var a=o(f,c),s=o(f,c,!0);if(a in u&&s in i&&u[a]!==i[s]){var v=n(a,s,c),d=r(a,s,g[v].geometry);delete i[a],delete u[s],u[o(f,g[d].geometry,!0)]=d,g[v].geometry=null}else a in u?r(a,s,c):s in i?n(a,s,c):(t(m),i[a]=l-1,u[s]=l-1)}else t(m)}return g.filter(function(e){return e.geometry})};
},{}],233:[function(_dereq_,module,exports){
"use strict";var ref=_dereq_("../util/web_worker_transfer"),register=ref.register,OpacityState=function(){this.opacity=0,this.targetOpacity=0,this.time=0};OpacityState.prototype.clone=function(){var t=new OpacityState;return t.opacity=this.opacity,t.targetOpacity=this.targetOpacity,t.time=this.time,t},register("OpacityState",OpacityState),module.exports=OpacityState;
},{"../util/web_worker_transfer":288}],234:[function(_dereq_,module,exports){
"use strict";function getLabelPlaneMatrix(e,t,r,n,a){var i=mat4.identity(new Float32Array(16));return t?(mat4.identity(i),mat4.scale(i,i,[1/a,1/a,1]),r||mat4.rotateZ(i,i,n.angle)):(mat4.scale(i,i,[n.width/2,-n.height/2,1]),mat4.translate(i,i,[1,-1,0]),mat4.multiply(i,i,e)),i}function getGlCoordMatrix(e,t,r,n,a){var i=mat4.identity(new Float32Array(16));return t?(mat4.multiply(i,i,e),mat4.scale(i,i,[a,a,1]),r||mat4.rotateZ(i,i,-n.angle)):(mat4.scale(i,i,[1,-1,1]),mat4.translate(i,i,[-1,-1,0]),mat4.scale(i,i,[2/n.width,2/n.height,1])),i}function project(e,t){var r=[e.x,e.y,0,1];xyTransformMat4(r,r,t);var n=r[3];return{point:new Point(r[0]/n,r[1]/n),signedDistanceFromCamera:n}}function isVisible(e,t){var r=e[0]/e[3],n=e[1]/e[3];return r>=-t[0]&&r<=t[0]&&n>=-t[1]&&n<=t[1]}function updateLineLabels(e,t,r,n,a,i,o,l){var s=n?e.textSizeData:e.iconSizeData,p=symbolSize.evaluateSizeForZoom(s,r.transform.zoom,symbolLayoutProperties.properties[n?"text-size":"icon-size"]),u=[256/r.width*2+1,256/r.height*2+1],y=n?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;y.clear();for(var c=e.lineVertexArray,d=n?e.placedGlyphArray:e.placedIconArray,m=r.transform.width/r.transform.height,g=!1,h=0;h<d.length;h++){var f=d.get(h);if(f.hidden||f.writingMode===WritingMode.vertical&&!g)hideGlyphs(f.numGlyphs,y);else{g=!1;var x=[f.anchorX,f.anchorY,0,1];if(vec4.transformMat4(x,x,t),isVisible(x,u)){var v=x[3],L=.5+v/r.transform.cameraToCenterDistance*.5,b=symbolSize.evaluateSizeForFeature(s,p,f),A=o?b*L:b/L,G=new Point(f.anchorX,f.anchorY),M=project(G,a).point,S={},w=placeGlyphsAlongLine(f,A,!1,l,t,a,i,e.glyphOffsetArray,c,y,M,G,S,m);g=w.useVertical,(w.notEnoughRoom||g||w.needsFlipping&&placeGlyphsAlongLine(f,A,!0,l,t,a,i,e.glyphOffsetArray,c,y,M,G,S,m).notEnoughRoom)&&hideGlyphs(f.numGlyphs,y)}else hideGlyphs(f.numGlyphs,y)}}n?e.text.dynamicLayoutVertexBuffer.updateData(y):e.icon.dynamicLayoutVertexBuffer.updateData(y)}function placeFirstAndLastGlyph(e,t,r,n,a,i,o,l,s,p,u,y){var c=l.glyphStartIndex+l.numGlyphs,d=l.lineStartIndex,m=l.lineStartIndex+l.lineLength,g=t.getoffsetX(l.glyphStartIndex),h=t.getoffsetX(c-1),f=placeGlyphAlongLine(e*g,r,n,a,i,o,l.segment,d,m,s,p,u,y);if(!f)return null;var x=placeGlyphAlongLine(e*h,r,n,a,i,o,l.segment,d,m,s,p,u,y);return x?{first:f,last:x}:null}function requiresOrientationChange(e,t,r,n){if(e===WritingMode.horizontal){if(Math.abs(r.y-t.y)>Math.abs(r.x-t.x)*n)return{useVertical:!0}}return(e===WritingMode.vertical?t.y<r.y:t.x>r.x)?{needsFlipping:!0}:null}function placeGlyphsAlongLine(e,t,r,n,a,i,o,l,s,p,u,y,c,d){var m,g=t/24,h=e.lineOffsetX*t,f=e.lineOffsetY*t;if(e.numGlyphs>1){var x=e.glyphStartIndex+e.numGlyphs,v=e.lineStartIndex,L=e.lineStartIndex+e.lineLength,b=placeFirstAndLastGlyph(g,l,h,f,r,u,y,e,s,i,c,!1);if(!b)return{notEnoughRoom:!0};var A=project(b.first.point,o).point,G=project(b.last.point,o).point;if(n&&!r){var M=requiresOrientationChange(e.writingMode,A,G,d);if(M)return M}m=[b.first];for(var S=e.glyphStartIndex+1;S<x-1;S++)m.push(placeGlyphAlongLine(g*l.getoffsetX(S),h,f,r,u,y,e.segment,v,L,s,i,c,!1));m.push(b.last)}else{if(n&&!r){var w=project(y,a).point,F=e.lineStartIndex+e.segment+1,D=new Point(s.getx(F),s.gety(F)),I=project(D,a),j=I.signedDistanceFromCamera>0?I.point:projectTruncatedLineSegment(y,D,w,1,a),z=requiresOrientationChange(e.writingMode,w,j,d);if(z)return z}var P=placeGlyphAlongLine(g*l.getoffsetX(e.glyphStartIndex),h,f,r,u,y,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,s,i,c,!1);if(!P)return{notEnoughRoom:!0};m=[P]}for(var _=0,C=m;_<C.length;_+=1){var V=C[_];addDynamicAttributes(p,V.point,V.angle)}return{}}function projectTruncatedLineSegment(e,t,r,n,a){var i=project(e.add(e.sub(t)._unit()),a).point,o=r.sub(i);return r.add(o._mult(n/o.mag()))}function placeGlyphAlongLine(e,t,r,n,a,i,o,l,s,p,u,y,c){var d=n?e-t:e+t,m=d>0?1:-1,g=0;n&&(m*=-1,g=Math.PI),m<0&&(g+=Math.PI);for(var h=m>0?l+o:l+o+1,f=h,x=a,v=a,L=0,b=0,A=Math.abs(d);L+b<=A;){if((h+=m)<l||h>=s)return null;if(v=x,void 0===(x=y[h])){var G=new Point(p.getx(h),p.gety(h)),M=project(G,u);if(M.signedDistanceFromCamera>0)x=y[h]=M.point;else{var S=h-m;x=projectTruncatedLineSegment(0===L?i:new Point(p.getx(S),p.gety(S)),G,v,A-L+1,u)}}L+=b,b=v.dist(x)}var w=(A-L)/b,F=x.sub(v),D=F.mult(w)._add(v);return D._add(F._unit()._perp()._mult(r*m)),{point:D,angle:g+Math.atan2(x.y-v.y,x.x-v.x),tileDistance:c?{prevTileDistance:h-m===f?0:p.gettileUnitDistanceFromAnchor(h-m),lastSegmentViewportDistance:A-L}:null}}function hideGlyphs(e,t){for(var r=0;r<e;r++){var n=t.length;t.resize(n+4),t.float32.set(hiddenGlyphAttributes,3*n)}}function xyTransformMat4(e,t,r){var n=t[0],a=t[1];return e[0]=r[0]*n+r[4]*a+r[12],e[1]=r[1]*n+r[5]*a+r[13],e[3]=r[3]*n+r[7]*a+r[15],e}var Point=_dereq_("@mapbox/point-geometry"),ref=_dereq_("@mapbox/gl-matrix"),mat4=ref.mat4,vec4=ref.vec4,symbolSize=_dereq_("./symbol_size"),ref$1=_dereq_("../data/bucket/symbol_bucket"),addDynamicAttributes=ref$1.addDynamicAttributes,symbolLayoutProperties=_dereq_("../style/style_layer/symbol_style_layer_properties").layout,WritingMode=_dereq_("../symbol/shaping").WritingMode;module.exports={updateLineLabels:updateLineLabels,getLabelPlaneMatrix:getLabelPlaneMatrix,getGlCoordMatrix:getGlCoordMatrix,project:project,placeFirstAndLastGlyph:placeFirstAndLastGlyph,xyTransformMat4:xyTransformMat4};var hiddenGlyphAttributes=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);
},{"../data/bucket/symbol_bucket":54,"../style/style_layer/symbol_style_layer_properties":220,"../symbol/shaping":236,"./symbol_size":239,"@mapbox/gl-matrix":2,"@mapbox/point-geometry":4}],235:[function(_dereq_,module,exports){
"use strict";function getIconQuads(t,e,i,o,n,a,r){var u,l,g,d,f=e.image,c=i.layout,h=e.top-1/f.pixelRatio,x=e.left-1/f.pixelRatio,p=e.bottom+1/f.pixelRatio,s=e.right+1/f.pixelRatio;if("none"!==c.get("icon-text-fit")&&n){var P=s-x,_=p-h,w=c.get("text-size").evaluate(r)/24,m=n.left*w,v=n.right*w,y=n.top*w,M=n.bottom*w,R=v-m,b=M-y,G=c.get("icon-text-fit-padding")[0],B=c.get("icon-text-fit-padding")[1],I=c.get("icon-text-fit-padding")[2],Q=c.get("icon-text-fit-padding")[3],O="width"===c.get("icon-text-fit")?.5*(b-_):0,A="height"===c.get("icon-text-fit")?.5*(R-P):0,D="width"===c.get("icon-text-fit")||"both"===c.get("icon-text-fit")?R:P,E="height"===c.get("icon-text-fit")||"both"===c.get("icon-text-fit")?b:_;u=new Point(m+A-Q,y+O-G),l=new Point(m+A+B+D,y+O-G),g=new Point(m+A+B+D,y+O+I+E),d=new Point(m+A-Q,y+O+I+E)}else u=new Point(x,h),l=new Point(s,h),g=new Point(s,p),d=new Point(x,p);var F=i.layout.get("icon-rotate").evaluate(r)*Math.PI/180;if(F){var H=Math.sin(F),L=Math.cos(F),Y=[L,-H,H,L];u._matMult(Y),l._matMult(Y),d._matMult(Y),g._matMult(Y)}return[{tl:u,tr:l,bl:d,br:g,tex:{x:f.textureRect.x-1,y:f.textureRect.y-1,w:f.textureRect.w+2,h:f.textureRect.h+2},writingMode:void 0,glyphOffset:[0,0]}]}function getGlyphQuads(t,e,i,o,n,a,r){for(var u=i.layout.get("text-rotate").evaluate(a)*Math.PI/180,l=i.layout.get("text-offset").evaluate(a).map(function(t){return 24*t}),g=e.positionedGlyphs,d=[],f=0;f<g.length;f++){var c=g[f],h=r[c.glyph];if(h){var x=h.rect;if(x){var p=GLYPH_PBF_BORDER+1,s=h.metrics.advance/2,P=o?[c.x+s,c.y]:[0,0],_=o?[0,0]:[c.x+s+l[0],c.y+l[1]],w=h.metrics.left-p-s+_[0],m=-h.metrics.top-p+_[1],v=w+x.w,y=m+x.h,M=new Point(w,m),R=new Point(v,m),b=new Point(w,y),G=new Point(v,y);if(o&&c.vertical){var B=new Point(-s,s),I=-Math.PI/2,Q=new Point(5,0);M._rotateAround(I,B)._add(Q),R._rotateAround(I,B)._add(Q),b._rotateAround(I,B)._add(Q),G._rotateAround(I,B)._add(Q)}if(u){var O=Math.sin(u),A=Math.cos(u),D=[A,-O,O,A];M._matMult(D),R._matMult(D),b._matMult(D),G._matMult(D)}d.push({tl:M,tr:R,bl:b,br:G,tex:x,writingMode:e.writingMode,glyphOffset:P})}}}return d}var Point=_dereq_("@mapbox/point-geometry"),ref=_dereq_("../style/parse_glyph_pbf"),GLYPH_PBF_BORDER=ref.GLYPH_PBF_BORDER;module.exports={getIconQuads:getIconQuads,getGlyphQuads:getGlyphQuads};
},{"../style/parse_glyph_pbf":197,"@mapbox/point-geometry":4}],236:[function(_dereq_,module,exports){
"use strict";function breakLines(e,t){for(var a=[],r=0,i=0,n=t;i<n.length;i+=1){var l=n[i];a.push(e.substring(r,l)),r=l}return r<e.length&&a.push(e.substring(r,e.length)),a}function shapeText(e,t,a,r,i,n,l,o,c,s){var h=e.trim();s===WritingMode.vertical&&(h=verticalizePunctuation(h));var g,u=[],p={positionedGlyphs:u,text:h,top:o[1],bottom:o[1],left:o[0],right:o[0],writingMode:s},b=rtlTextPlugin.processBidirectionalText;return g=b?b(h,determineLineBreaks(h,l,a,t)):breakLines(h,determineLineBreaks(h,l,a,t)),shapeLines(p,t,g,r,i,n,s,l,c),!!u.length&&p}function determineAverageLineWidth(e,t,a,r){for(var i=0,n=0;n<e.length;n++){var l=r[e.charCodeAt(n)];l&&(i+=l.metrics.advance+t)}return i/Math.max(1,Math.ceil(i/a))}function calculateBadness(e,t,a,r){var i=Math.pow(e-t,2);return r?e<t?i/2:2*i:i+Math.abs(a)*a}function calculatePenalty(e,t){var a=0;return 10===e&&(a-=1e4),40!==e&&65288!==e||(a+=50),41!==t&&65289!==t||(a+=50),a}function evaluateBreak(e,t,a,r,i,n){for(var l=null,o=calculateBadness(t,a,i,n),c=0,s=r;c<s.length;c+=1){var h=s[c],g=t-h.x,u=calculateBadness(g,a,i,n)+h.badness;u<=o&&(l=h,o=u)}return{index:e,x:t,priorBreak:l,badness:o}}function leastBadBreaks(e){return e?leastBadBreaks(e.priorBreak).concat(e.index):[]}function determineLineBreaks(e,t,a,r){if(!a)return[];if(!e)return[];for(var i=[],n=determineAverageLineWidth(e,t,a,r),l=0,o=0;o<e.length;o++){var c=e.charCodeAt(o),s=r[c];s&&!whitespace[c]&&(l+=s.metrics.advance+t),o<e.length-1&&(breakable[c]||scriptDetection.charAllowsIdeographicBreaking(c))&&i.push(evaluateBreak(o+1,l,n,i,calculatePenalty(c,e.charCodeAt(o+1)),!1))}return leastBadBreaks(evaluateBreak(e.length,l,n,i,0,!0))}function getAnchorAlignment(e){var t=.5,a=.5;switch(e){case"right":case"top-right":case"bottom-right":t=1;break;case"left":case"top-left":case"bottom-left":t=0}switch(e){case"bottom":case"bottom-right":case"bottom-left":a=1;break;case"top":case"top-right":case"top-left":a=0}return{horizontalAlign:t,verticalAlign:a}}function shapeLines(e,t,a,r,i,n,l,o,c){for(var s=0,h=-17,g=0,u=e.positionedGlyphs,p="right"===n?1:"left"===n?0:.5,b=0,v=a;b<v.length;b+=1){var d=v[b];if(d=d.trim(),d.length){for(var f=u.length,k=0;k<d.length;k++){var m=d.charCodeAt(k),x=t[m];x&&(scriptDetection.charHasUprightVerticalOrientation(m)&&l!==WritingMode.horizontal?(u.push({glyph:m,x:s,y:0,vertical:!0}),s+=c+o):(u.push({glyph:m,x:s,y:h,vertical:!1}),s+=x.metrics.advance+o))}if(u.length!==f){var A=s-o;g=Math.max(A,g),justifyLine(u,t,f,u.length-1,p)}s=0,h+=r}else h+=r}var B=getAnchorAlignment(i),y=B.horizontalAlign,w=B.verticalAlign;align(u,p,y,w,g,r,a.length);var z=a.length*r;e.top+=-w*z,e.bottom=e.top+z,e.left+=-y*g,e.right=e.left+g}function justifyLine(e,t,a,r,i){if(i){var n=t[e[r].glyph];if(n)for(var l=n.metrics.advance,o=(e[r].x+l)*i,c=a;c<=r;c++)e[c].x-=o}}function align(e,t,a,r,i,n,l){for(var o=(t-a)*i,c=(-r*l+.5)*n,s=0;s<e.length;s++)e[s].x+=o,e[s].y+=c}function shapeIcon(e,t,a){var r=getAnchorAlignment(a),i=r.horizontalAlign,n=r.verticalAlign,l=t[0],o=t[1],c=l-e.displaySize[0]*i,s=c+e.displaySize[0],h=o-e.displaySize[1]*n;return{image:e,top:h,bottom:h+e.displaySize[1],left:c,right:s}}var scriptDetection=_dereq_("../util/script_detection"),verticalizePunctuation=_dereq_("../util/verticalize_punctuation"),rtlTextPlugin=_dereq_("../source/rtl_text_plugin"),WritingMode={horizontal:1,vertical:2,horizontalOnly:3};module.exports={shapeText:shapeText,shapeIcon:shapeIcon,WritingMode:WritingMode};var whitespace={};whitespace[9]=!0,whitespace[10]=!0,whitespace[11]=!0,whitespace[12]=!0,whitespace[13]=!0,whitespace[32]=!0;var breakable={};breakable[10]=!0,breakable[32]=!0,breakable[38]=!0,breakable[40]=!0,breakable[41]=!0,breakable[43]=!0,breakable[45]=!0,breakable[47]=!0,breakable[173]=!0,breakable[183]=!0,breakable[8203]=!0,breakable[8208]=!0,breakable[8211]=!0,breakable[8231]=!0;
},{"../source/rtl_text_plugin":112,"../util/script_detection":279,"../util/verticalize_punctuation":287}],237:[function(_dereq_,module,exports){
"use strict";function performSymbolLayout(e,t,a,i,o,n){e.createArrays(),e.symbolInstances=[];var r=512*e.overscaling;e.tilePixelRatio=EXTENT/r,e.compareText={},e.iconsNeedLinear=!1;var l=e.layers[0].layout,s=e.layers[0]._unevaluatedLayout._values,c={};if("composite"===e.textSizeData.functionType){var u=e.textSizeData.zoomRange,y=u.min,x=u.max;c.compositeTextSizes=[s["text-size"].possiblyEvaluate(new EvaluationParameters(y)),s["text-size"].possiblyEvaluate(new EvaluationParameters(x))]}if("composite"===e.iconSizeData.functionType){var g=e.iconSizeData.zoomRange,p=g.min,d=g.max;c.compositeIconSizes=[s["icon-size"].possiblyEvaluate(new EvaluationParameters(p)),s["icon-size"].possiblyEvaluate(new EvaluationParameters(d))]}c.layoutTextSize=s["text-size"].possiblyEvaluate(new EvaluationParameters(e.zoom+1)),c.layoutIconSize=s["icon-size"].possiblyEvaluate(new EvaluationParameters(e.zoom+1)),c.textMaxSize=s["text-size"].possiblyEvaluate(new EvaluationParameters(18));for(var m=24*l.get("text-line-height"),v="map"===l.get("text-rotation-alignment")&&"line"===l.get("symbol-placement"),f=l.get("text-keep-upright"),h=0,z=e.features;h<z.length;h+=1){var S=z[h],b=l.get("text-font").evaluate(S).join(","),T=t[b]||{},I=a[b]||{},E={},P=S.text;if(P){var w=scriptDetection.allowsVerticalWritingMode(P),A=l.get("text-offset").evaluate(S).map(function(e){return 24*e}),q=24*l.get("text-letter-spacing").evaluate(S),L=scriptDetection.allowsLetterSpacing(P)?q:0,O=l.get("text-anchor").evaluate(S),_=l.get("text-justify").evaluate(S),D="line"!==l.get("symbol-placement")?24*l.get("text-max-width").evaluate(S):0;E.horizontal=shapeText(P,T,D,m,O,_,L,A,24,WritingMode.horizontal),w&&v&&f&&(E.vertical=shapeText(P,T,D,m,O,_,L,A,24,WritingMode.vertical))}var R=void 0;if(S.icon){var B=i[S.icon];B&&(R=shapeIcon(o[S.icon],l.get("icon-offset").evaluate(S),l.get("icon-anchor").evaluate(S)),void 0===e.sdfIcons?e.sdfIcons=B.sdf:e.sdfIcons!==B.sdf&&util.warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),B.pixelRatio!==e.pixelRatio?e.iconsNeedLinear=!0:0!==l.get("icon-rotate").constantOr(1)&&(e.iconsNeedLinear=!0))}(E.horizontal||R)&&addFeature(e,S,E,R,I,c)}n&&e.generateCollisionDebugBuffers()}function addFeature(e,t,a,i,o,n){var r=n.layoutTextSize.evaluate(t),l=n.layoutIconSize.evaluate(t),s=n.textMaxSize.evaluate(t);void 0===s&&(s=r);var c=e.layers[0].layout,u=c.get("text-offset").evaluate(t),y=c.get("icon-offset").evaluate(t),x=r/24,g=e.tilePixelRatio*x,p=e.tilePixelRatio*s/24,d=e.tilePixelRatio*l,m=e.tilePixelRatio*c.get("symbol-spacing"),v=c.get("text-padding")*e.tilePixelRatio,f=c.get("icon-padding")*e.tilePixelRatio,h=c.get("text-max-angle")/180*Math.PI,z="map"===c.get("text-rotation-alignment")&&"line"===c.get("symbol-placement"),S="map"===c.get("icon-rotation-alignment")&&"line"===c.get("symbol-placement"),b=c.get("symbol-placement"),T=m/2,I=function(r,l){l.x<0||l.x>=EXTENT||l.y<0||l.y>=EXTENT||e.symbolInstances.push(addSymbol(e,l,r,a,i,e.layers[0],e.collisionBoxArray,t.index,t.sourceLayerIndex,e.index,g,v,z,u,d,f,S,y,{zoom:e.zoom},t,o,n))};if("line"===b)for(var E=0,P=clipLine(t.geometry,0,0,EXTENT,EXTENT);E<P.length;E+=1)for(var w=P[E],A=getAnchors(w,m,h,a.vertical||a.horizontal,i,24,p,e.overscaling,EXTENT),q=0,L=A;q<L.length;q+=1){var O=L[q],_=a.horizontal;_&&anchorIsTooClose(e,_.text,T,O)||I(w,O)}else if("Polygon"===t.type)for(var D=0,R=classifyRings(t.geometry,0);D<R.length;D+=1){var B=R[D],M=findPoleOfInaccessibility(B,16);I(B[0],new Anchor(M.x,M.y,0))}else if("LineString"===t.type)for(var N=0,V=t.geometry;N<V.length;N+=1){var G=V[N];I(G,new Anchor(G[0].x,G[0].y,0))}else if("Point"===t.type)for(var W=0,X=t.geometry;W<X.length;W+=1)for(var C=X[W],F=0,k=C;F<k.length;F+=1){var Q=k[F];I([Q],new Anchor(Q.x,Q.y,0))}}function addTextVertices(e,t,a,i,o,n,r,l,s,c,u,y,x){var g=getGlyphQuads(t,a,i,o,n,r,y),p=e.textSizeData,d=null;return"source"===p.functionType?d=[10*i.layout.get("text-size").evaluate(r)]:"composite"===p.functionType&&(d=[10*x.compositeTextSizes[0].evaluate(r),10*x.compositeTextSizes[1].evaluate(r)]),e.addSymbols(e.text,g,d,l,o,r,c,t,s.lineStartIndex,s.lineLength,e.placedGlyphArray),u.push(e.placedGlyphArray.length-1),4*g.length}function addSymbol(e,t,a,i,o,n,r,l,s,c,u,y,x,g,p,d,m,v,f,h,z,S){var b,T,I=e.addToLineVertexArray(t,a),E=0,P=0,w=0,A=i.horizontal?i.horizontal.text:"",q=[];i.horizontal&&(b=new CollisionFeature(r,a,t,l,s,c,i.horizontal,u,y,x,e.overscaling),P+=addTextVertices(e,t,i.horizontal,n,x,f,h,g,I,i.vertical?WritingMode.horizontal:WritingMode.horizontalOnly,q,z,S),i.vertical&&(w+=addTextVertices(e,t,i.vertical,n,x,f,h,g,I,WritingMode.vertical,q,z,S)));var L=b?b.boxStartIndex:e.collisionBoxArray.length,O=b?b.boxEndIndex:e.collisionBoxArray.length;if(o){var _=getIconQuads(t,o,n,m,i.horizontal,f,h);T=new CollisionFeature(r,a,t,l,s,c,o,p,d,!1,e.overscaling),E=4*_.length;var D=e.iconSizeData,R=null;"source"===D.functionType?R=[10*n.layout.get("icon-size").evaluate(h)]:"composite"===D.functionType&&(R=[10*S.compositeIconSizes[0].evaluate(h),10*S.compositeIconSizes[1].evaluate(h)]),e.addSymbols(e.icon,_,R,v,m,h,!1,t,I.lineStartIndex,I.lineLength,e.placedIconArray)}var B=T?T.boxStartIndex:e.collisionBoxArray.length,M=T?T.boxEndIndex:e.collisionBoxArray.length;return e.glyphOffsetArray.length>=SymbolBucket.MAX_GLYPHS&&util.warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),{key:A,textBoxStartIndex:L,textBoxEndIndex:O,iconBoxStartIndex:B,iconBoxEndIndex:M,textOffset:g,iconOffset:v,anchor:t,line:a,featureIndex:l,feature:h,numGlyphVertices:P,numVerticalGlyphVertices:w,numIconVertices:E,textOpacityState:new OpacityState,iconOpacityState:new OpacityState,isDuplicate:!1,placedTextSymbolIndices:q}}function anchorIsTooClose(e,t,a,i){var o=e.compareText;if(t in o){for(var n=o[t],r=n.length-1;r>=0;r--)if(i.dist(n[r])<a)return!0}else o[t]=[];return o[t].push(i),!1}var Anchor=_dereq_("./anchor"),getAnchors=_dereq_("./get_anchors"),clipLine=_dereq_("./clip_line"),OpacityState=_dereq_("./opacity_state"),ref=_dereq_("./shaping"),shapeText=ref.shapeText,shapeIcon=ref.shapeIcon,WritingMode=ref.WritingMode,ref$1=_dereq_("./quads"),getGlyphQuads=ref$1.getGlyphQuads,getIconQuads=ref$1.getIconQuads,CollisionFeature=_dereq_("./collision_feature"),util=_dereq_("../util/util"),scriptDetection=_dereq_("../util/script_detection"),findPoleOfInaccessibility=_dereq_("../util/find_pole_of_inaccessibility"),classifyRings=_dereq_("../util/classify_rings"),EXTENT=_dereq_("../data/extent"),SymbolBucket=_dereq_("../data/bucket/symbol_bucket"),EvaluationParameters=_dereq_("../style/evaluation_parameters"),Point=_dereq_("@mapbox/point-geometry");module.exports={performSymbolLayout:performSymbolLayout};
},{"../data/bucket/symbol_bucket":54,"../data/extent":56,"../style/evaluation_parameters":193,"../util/classify_rings":266,"../util/find_pole_of_inaccessibility":272,"../util/script_detection":279,"../util/util":285,"./anchor":224,"./clip_line":226,"./collision_feature":227,"./get_anchors":230,"./opacity_state":233,"./quads":235,"./shaping":236,"@mapbox/point-geometry":4}],238:[function(_dereq_,module,exports){
"use strict";function updateOpacity(e,t,i,o,a,r){if(e.isDuplicate)t.opacity=0,t.targetOpacity=0;else{t.targetOpacity!==i&&(a.latestStart=o);var l=a.duration?(o-t.time)/a.duration:1;t.opacity=r?i:Math.max(0,Math.min(1,t.opacity+(1===t.targetOpacity?l:-l))),t.targetOpacity=i,t.time=o}}function packOpacity(e){if(0===e.opacity&&0===e.targetOpacity)return 0;if(1===e.opacity&&1===e.targetOpacity)return 4294967295;var t=1===e.targetOpacity?1:0,i=Math.floor(127*e.opacity);return i*shift25+t*shift24+i*shift17+t*shift16+i*shift9+t*shift8+i*shift1+t}function updateOpacities(e,t,i){var o=e.text&&e.text.opacityVertexArray,a=e.icon&&e.icon.opacityVertexArray;o&&o.clear(),a&&a.clear(),e.fadeStartTime=browser.now();for(var r=0,l=e.symbolInstances;r<l.length;r+=1){var c=l[r],n=!(c.textBoxStartIndex===c.textBoxEndIndex),s=!(c.iconBoxStartIndex===c.iconBoxEndIndex);if(n||s){if(n){var p=c.placedText?1:0,x=c.textOpacityState,y=0===x.opacity&&0===x.targetOpacity;updateOpacity(c,x,p,e.fadeStartTime,t,i);var f=0===x.opacity&&0===x.targetOpacity;if(y!==f)for(var d=0,m=c.placedTextSymbolIndices;d<m.length;d+=1){var u=m[d],B=e.placedGlyphArray.get(u);B.hidden=f}for(var h=(c.numGlyphVertices+c.numVerticalGlyphVertices)/4,g=packOpacity(x),v=0;v<h;v++)o.emplaceBack(g)}if(s){var S=c.placedIcon?1:0,C=c.iconOpacityState;updateOpacity(c,C,S,e.fadeStartTime,t,i);for(var A=c.numIconVertices/4,I=packOpacity(C),O=0;O<A;O++)a.emplaceBack(I)}}}o&&e.text.opacityVertexBuffer&&e.text.opacityVertexBuffer.updateData(o),a&&e.icon.opacityVertexBuffer&&e.icon.opacityVertexBuffer.updateData(a)}function updateCollisionBox(e,t){e.emplaceBack(t?1:0,0),e.emplaceBack(t?1:0,0),e.emplaceBack(t?1:0,0),e.emplaceBack(t?1:0,0)}function updateCollisionCircles(e,t,i,o){for(var a=0;a<t.length;a+=5){var r=o||0===t[a+4];e.emplaceBack(i?1:0,r?1:0),e.emplaceBack(i?1:0,r?1:0),e.emplaceBack(i?1:0,r?1:0),e.emplaceBack(i?1:0,r?1:0)}}function performSymbolPlacement(e,t,i,o,a,r,l,c,n,s){var p,x,y=e.layers[0],f=y.layout,d=Math.pow(2,o-e.zoom);i&&(e.collisionBox&&e.collisionBox.collisionVertexArray&&e.collisionBox.collisionVertexArray.length&&(p=e.collisionBox.collisionVertexArray,p.clear()),e.collisionCircle&&e.collisionCircle.collisionVertexArray&&e.collisionCircle.collisionVertexArray.length&&(x=e.collisionCircle.collisionVertexArray,x.clear()));for(var m=symbolSize.evaluateSizeForZoom(e.textSizeData,t.transform.zoom,symbolLayoutProperties.properties["text-size"]),u="map"===f.get("text-pitch-alignment"),B=0,h=e.symbolInstances;B<h.length;B+=1){var g=h[B],v=!(g.textBoxStartIndex===g.textBoxEndIndex),S=!(g.iconBoxStartIndex===g.iconBoxEndIndex),C=f.get("text-optional")||!v,A=f.get("icon-optional")||!S;g.collisionArrays||(g.collisionArrays=e.deserializeCollisionBoxes(s,g.textBoxStartIndex,g.textBoxEndIndex,g.iconBoxStartIndex,g.iconBoxEndIndex));var I=[],O=[],V=[],b=!1;if(!g.isDuplicate){g.collisionArrays.textBox&&(I=t.placeCollisionBox(g.collisionArrays.textBox,f.get("text-allow-overlap"),a,r)),g.collisionArrays.iconBox&&(O=t.placeCollisionBox(g.collisionArrays.iconBox,f.get("icon-allow-overlap"),a,r));var w=g.collisionArrays.textCircles;if(w){var k=e.placedGlyphArray.get(g.placedTextSymbolIndices[0]),z=symbolSize.evaluateSizeForFeature(e.textSizeData,m,k);V=t.placeCollisionCircles(w,f.get("text-allow-overlap"),d,a,g.key,k,e.lineVertexArray,e.glyphOffsetArray,z,r,l,i,u),b=f.get("text-allow-overlap")||V.length>0}}var M=I.length>0||b,D=O.length>0;C||A?A?C||(D=D&&M):M=D&&M:D=M=D&&M,g.placedText=M,g.placedIcon=D,g.collisionArrays.textBox&&(p&&updateCollisionBox(p,M),M&&t.insertCollisionBox(I,f.get("text-ignore-placement"),c,n,g.textBoxStartIndex)),g.collisionArrays.iconBox&&(p&&updateCollisionBox(p,D),D&&t.insertCollisionBox(O,f.get("icon-ignore-placement"),c,n,g.iconBoxStartIndex)),g.collisionArrays.textCircles&&(x&&updateCollisionCircles(x,g.collisionArrays.textCircles,M,g.isDuplicate),M&&t.insertCollisionCircles(V,f.get("text-ignore-placement"),c,n,g.textBoxStartIndex))}p&&e.collisionBox.collisionVertexBuffer&&e.collisionBox.collisionVertexBuffer.updateData(p),x&&e.collisionCircle.collisionVertexBuffer&&e.collisionCircle.collisionVertexBuffer.updateData(x)}var symbolSize=_dereq_("./symbol_size"),symbolLayoutProperties=_dereq_("../style/style_layer/symbol_style_layer_properties").layout,browser=_dereq_("../util/browser"),mat4=_dereq_("@mapbox/gl-matrix").mat4;module.exports={updateOpacities:updateOpacities,performSymbolPlacement:performSymbolPlacement};var shift25=Math.pow(2,25),shift24=Math.pow(2,24),shift17=Math.pow(2,17),shift16=Math.pow(2,16),shift9=Math.pow(2,9),shift8=Math.pow(2,8),shift1=Math.pow(2,1);
},{"../style/style_layer/symbol_style_layer_properties":220,"../util/browser":263,"./symbol_size":239,"@mapbox/gl-matrix":2}],239:[function(_dereq_,module,exports){
"use strict";function getSizeData(e,o){var i=o.expression;if("constant"===i.kind)return{functionType:"constant",layoutSize:i.evaluate({zoom:e+1})};if("source"===i.kind)return{functionType:"source"};for(var t=i.zoomStops,r=0;r<t.length&&t[r]<=e;)r++;r=Math.max(0,r-1);for(var a=r;a<t.length&&t[a]<e+1;)a++;a=Math.min(t.length-1,a);var n={min:t[r],max:t[a]};return"composite"===i.kind?{functionType:"composite",zoomRange:n,propertyValue:o.value}:{functionType:"camera",layoutSize:i.evaluate({zoom:e+1}),zoomRange:n,sizeRange:{min:i.evaluate({zoom:n.min}),max:i.evaluate({zoom:n.max})},propertyValue:o.value}}function evaluateSizeForFeature(e,o,i){var t=o;return"source"===e.functionType?i.lowerSize/10:"composite"===e.functionType?interpolate.number(i.lowerSize/10,i.upperSize/10,t.uSizeT):t.uSize}function evaluateSizeForZoom(e,o,i){if("constant"===e.functionType)return{uSizeT:0,uSize:e.layoutSize};if("source"===e.functionType)return{uSizeT:0,uSize:0};if("camera"===e.functionType){var t=e.propertyValue,r=e.zoomRange,a=e.sizeRange,n=normalizePropertyExpression(t,i.specification),u=util.clamp(n.interpolationFactor(o,r.min,r.max),0,1);return{uSizeT:0,uSize:a.min+u*(a.max-a.min)}}var p=e.propertyValue,l=e.zoomRange,m=normalizePropertyExpression(p,i.specification);return{uSizeT:util.clamp(m.interpolationFactor(o,l.min,l.max),0,1),uSize:0}}var ref=_dereq_("../style-spec/expression"),normalizePropertyExpression=ref.normalizePropertyExpression,interpolate=_dereq_("../style-spec/util/interpolate"),util=_dereq_("../util/util");module.exports={getSizeData:getSizeData,evaluateSizeForFeature:evaluateSizeForFeature,evaluateSizeForZoom:evaluateSizeForZoom};
},{"../style-spec/expression":142,"../style-spec/util/interpolate":169,"../util/util":285}],240:[function(_dereq_,module,exports){
"use strict";var rtlTextPlugin=_dereq_("../source/rtl_text_plugin");module.exports=function(e,t,r){var a=t.layout.get("text-transform").evaluate(r);return"uppercase"===a?e=e.toLocaleUpperCase():"lowercase"===a&&(e=e.toLocaleLowerCase()),rtlTextPlugin.applyArabicShaping&&(e=rtlTextPlugin.applyArabicShaping(e)),e};
},{"../source/rtl_text_plugin":112}],241:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../util/dom"),Point=_dereq_("@mapbox/point-geometry"),handlers={scrollZoom:_dereq_("./handler/scroll_zoom"),boxZoom:_dereq_("./handler/box_zoom"),dragRotate:_dereq_("./handler/drag_rotate"),dragPan:_dereq_("./handler/drag_pan"),keyboard:_dereq_("./handler/keyboard"),doubleClickZoom:_dereq_("./handler/dblclick_zoom"),touchZoomRotate:_dereq_("./handler/touch_zoom_rotate")};module.exports=function(e,t){function n(e){h("mouseout",e)}function o(t){e.doubleClickZoom.isActive()||e.stop(),L=DOM.mousePos(g,t),h("mousedown",t),E=!0}function r(t){var n=e.dragRotate&&e.dragRotate.isActive();p&&!n&&h("contextmenu",p),p=null,E=!1,h("mouseup",t)}function u(t){if(!(e.dragPan&&e.dragPan.isActive()||e.dragRotate&&e.dragRotate.isActive())){for(var n=t.toElement||t.target;n&&n!==g;)n=n.parentNode;n===g&&h("mousemove",t)}}function a(t){e.stop(),f("touchstart",t),!t.touches||t.touches.length>1||(b?(clearTimeout(b),b=null,h("dblclick",t)):b=setTimeout(l,300))}function i(e){f("touchmove",e)}function c(e){f("touchend",e)}function d(e){f("touchcancel",e)}function l(){b=null}function s(e){DOM.mousePos(g,e).equals(L)&&h("click",e)}function m(e){h("dblclick",e),e.preventDefault()}function v(t){var n=e.dragRotate&&e.dragRotate.isActive();E||n?E&&(p=t):h("contextmenu",t),t.preventDefault()}function h(t,n){var o=DOM.mousePos(g,n);return e.fire(t,{lngLat:e.unproject(o),point:o,originalEvent:n})}function f(t,n){var o=DOM.touchPos(g,n),r=o.reduce(function(e,t,n,o){return e.add(t.div(o.length))},new Point(0,0));return e.fire(t,{lngLat:e.unproject(r),point:r,lngLats:o.map(function(t){return e.unproject(t)},this),points:o,originalEvent:n})}var g=e.getCanvasContainer(),p=null,E=!1,L=null,b=null;for(var k in handlers)e[k]=new handlers[k](e,t),t.interactive&&t[k]&&e[k].enable(t[k]);g.addEventListener("mouseout",n,!1),g.addEventListener("mousedown",o,!1),g.addEventListener("mouseup",r,!1),g.addEventListener("mousemove",u,!1),g.addEventListener("touchstart",a,!1),g.addEventListener("touchend",c,!1),g.addEventListener("touchmove",i,!1),g.addEventListener("touchcancel",d,!1),g.addEventListener("click",s,!1),g.addEventListener("dblclick",m,!1),g.addEventListener("contextmenu",v,!1)};
},{"../util/dom":270,"./handler/box_zoom":250,"./handler/dblclick_zoom":251,"./handler/drag_pan":252,"./handler/drag_rotate":253,"./handler/keyboard":254,"./handler/scroll_zoom":255,"./handler/touch_zoom_rotate":256,"@mapbox/point-geometry":4}],242:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),interpolate=_dereq_("../style-spec/util/interpolate").number,browser=_dereq_("../util/browser"),LngLat=_dereq_("../geo/lng_lat"),LngLatBounds=_dereq_("../geo/lng_lat_bounds"),Point=_dereq_("@mapbox/point-geometry"),Evented=_dereq_("../util/evented"),Camera=function(t){function e(e,i){t.call(this),this.moving=!1,this.transform=e,this._bearingSnap=i.bearingSnap}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCenter=function(){return this.transform.center},e.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},e.prototype.panBy=function(t,e,i){return t=Point.convert(t).mult(-1),this.panTo(this.transform.center,util.extend({offset:t},e),i)},e.prototype.panTo=function(t,e,i){return this.easeTo(util.extend({center:t},e),i)},e.prototype.getZoom=function(){return this.transform.zoom},e.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},e.prototype.zoomTo=function(t,e,i){return this.easeTo(util.extend({zoom:t},e),i)},e.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},e.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},e.prototype.getBearing=function(){return this.transform.bearing},e.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},e.prototype.rotateTo=function(t,e,i){return this.easeTo(util.extend({bearing:t},e),i)},e.prototype.resetNorth=function(t,e){return this.rotateTo(0,util.extend({duration:1e3},t),e),this},e.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},e.prototype.getPitch=function(){return this.transform.pitch},e.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},e.prototype.fitBounds=function(t,e,i){if(e=util.extend({padding:{top:0,bottom:0,right:0,left:0},offset:[0,0],maxZoom:this.transform.maxZoom},e),"number"==typeof e.padding){var o=e.padding;e.padding={top:o,bottom:o,right:o,left:o}}if(!util.deepEqual(Object.keys(e.padding).sort(function(t,e){return t<e?-1:t>e?1:0}),["bottom","left","right","top"]))return util.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'"),this;t=LngLatBounds.convert(t);var n=[(e.padding.left-e.padding.right)/2,(e.padding.top-e.padding.bottom)/2],r=Math.min(e.padding.right,e.padding.left),a=Math.min(e.padding.top,e.padding.bottom);e.offset=[e.offset[0]+n[0],e.offset[1]+n[1]];var s=Point.convert(e.offset),h=this.transform,p=h.project(t.getNorthWest()),u=h.project(t.getSouthEast()),c=u.sub(p),m=(h.width-2*r-2*Math.abs(s.x))/c.x,f=(h.height-2*a-2*Math.abs(s.y))/c.y;return f<0||m<0?(util.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset."),this):(e.center=h.unproject(p.add(u).div(2)),e.zoom=Math.min(h.scaleZoom(h.scale*Math.min(m,f)),e.maxZoom),e.bearing=0,e.linear?this.easeTo(e,i):this.flyTo(e,i))},e.prototype.jumpTo=function(t,e){this.stop();var i=this.transform,o=!1,n=!1,r=!1;return"zoom"in t&&i.zoom!==+t.zoom&&(o=!0,i.zoom=+t.zoom),void 0!==t.center&&(i.center=LngLat.convert(t.center)),"bearing"in t&&i.bearing!==+t.bearing&&(n=!0,i.bearing=+t.bearing),"pitch"in t&&i.pitch!==+t.pitch&&(r=!0,i.pitch=+t.pitch),this.fire("movestart",e).fire("move",e),o&&this.fire("zoomstart",e).fire("zoom",e).fire("zoomend",e),n&&this.fire("rotate",e),r&&this.fire("pitchstart",e).fire("pitch",e).fire("pitchend",e),this.fire("moveend",e)},e.prototype.easeTo=function(t,e){var i=this;this.stop(),t=util.extend({offset:[0,0],duration:500,easing:util.ease},t),!1===t.animate&&(t.duration=0),t.smoothEasing&&0!==t.duration&&(t.easing=this._smoothOutEasing(t.duration));var o=this.transform,n=this.getZoom(),r=this.getBearing(),a=this.getPitch(),s="zoom"in t?+t.zoom:n,h="bearing"in t?this._normalizeBearing(t.bearing,r):r,p="pitch"in t?+t.pitch:a,u=o.centerPoint.add(Point.convert(t.offset)),c=o.pointLocation(u),m=LngLat.convert(t.center||c);this._normalizeCenter(m);var f,g,d=o.project(c),l=o.project(m).sub(d),v=o.zoomScale(s-n);return t.around&&(f=LngLat.convert(t.around),g=o.locationPoint(f)),this.zooming=s!==n,this.rotating=r!==h,this.pitching=p!==a,this._prepareEase(e,t.noMoveStart),clearTimeout(this._onEaseEnd),this._ease(function(t){if(i.zooming&&(o.zoom=interpolate(n,s,t)),i.rotating&&(o.bearing=interpolate(r,h,t)),i.pitching&&(o.pitch=interpolate(a,p,t)),f)o.setLocationAtPoint(f,g);else{var c=o.zoomScale(o.zoom-n),m=s>n?Math.min(2,v):Math.max(.5,v),_=Math.pow(m,1-t),b=o.unproject(d.add(l.mult(t*_)).mult(c));o.setLocationAtPoint(o.renderWorldCopies?b.wrap():b,u)}i._fireMoveEvents(e)},function(){t.delayEndEvents?i._onEaseEnd=setTimeout(function(){return i._easeToEnd(e)},t.delayEndEvents):i._easeToEnd(e)},t),this},e.prototype._prepareEase=function(t,e){this.moving=!0,e||this.fire("movestart",t),this.zooming&&this.fire("zoomstart",t),this.pitching&&this.fire("pitchstart",t)},e.prototype._fireMoveEvents=function(t){this.fire("move",t),this.zooming&&this.fire("zoom",t),this.rotating&&this.fire("rotate",t),this.pitching&&this.fire("pitch",t)},e.prototype._easeToEnd=function(t){var e=this.zooming,i=this.pitching;this.moving=!1,this.zooming=!1,this.rotating=!1,this.pitching=!1,e&&this.fire("zoomend",t),i&&this.fire("pitchend",t),this.fire("moveend",t)},e.prototype.flyTo=function(t,e){function i(t){var e=(M*M-z*z+(t?-1:1)*w*w*E*E)/(2*(t?M:z)*w*E);return Math.log(Math.sqrt(e*e+1)-e)}function o(t){return(Math.exp(t)-Math.exp(-t))/2}function n(t){return(Math.exp(t)+Math.exp(-t))/2}function r(t){return o(t)/n(t)}var a=this;this.stop(),t=util.extend({offset:[0,0],speed:1.2,curve:1.42,easing:util.ease},t);var s=this.transform,h=this.getZoom(),p=this.getBearing(),u=this.getPitch(),c="zoom"in t?util.clamp(+t.zoom,s.minZoom,s.maxZoom):h,m="bearing"in t?this._normalizeBearing(t.bearing,p):p,f="pitch"in t?+t.pitch:u,g=s.zoomScale(c-h),d=s.centerPoint.add(Point.convert(t.offset)),l=s.pointLocation(d),v=LngLat.convert(t.center||l);this._normalizeCenter(v);var _=s.project(l),b=s.project(v).sub(_),y=t.curve,z=Math.max(s.width,s.height),M=z/g,E=b.mag();if("minZoom"in t){var T=util.clamp(Math.min(t.minZoom,h,c),s.minZoom,s.maxZoom),x=z/s.zoomScale(T-h);y=Math.sqrt(x/E*2)}var w=y*y,L=i(0),j=function(t){return n(L)/n(L+y*t)},Z=function(t){return z*((n(L)*r(L+y*t)-o(L))/w)/E},P=(i(1)-L)/y;if(Math.abs(E)<1e-6||!isFinite(P)){if(Math.abs(z-M)<1e-6)return this.easeTo(t,e);var S=M<z?-1:1;P=Math.abs(Math.log(M/z))/y,Z=function(){return 0},j=function(t){return Math.exp(S*y*t)}}if("duration"in t)t.duration=+t.duration;else{var q="screenSpeed"in t?+t.screenSpeed/y:+t.speed;t.duration=1e3*P/q}return t.maxDuration&&t.duration>t.maxDuration&&(t.duration=0),this.zooming=!0,this.rotating=p!==m,this.pitching=f!==u,this._prepareEase(e,!1),this._ease(function(t){var i=t*P,o=1/j(i);s.zoom=h+s.scaleZoom(o),a.rotating&&(s.bearing=interpolate(p,m,t)),a.pitching&&(s.pitch=interpolate(u,f,t));var n=s.unproject(_.add(b.mult(Z(i))).mult(o));s.setLocationAtPoint(s.renderWorldCopies?n.wrap():n,d),a._fireMoveEvents(e)},function(){return a._easeToEnd(e)},t),this},e.prototype.isEasing=function(){return!!this._easeFn},e.prototype.isMoving=function(){return this.moving},e.prototype.stop=function(){return this._easeFn&&this._finishEase(),this},e.prototype._ease=function(t,e,i){!1===i.animate||0===i.duration?(t(1),e()):(this._easeStart=browser.now(),this._easeFn=t,this._finishFn=e,this._easeOptions=i,this._update())},e.prototype._updateEase=function(){var t=Math.min((browser.now()-this._easeStart)/this._easeOptions.duration,1);this._easeFn(this._easeOptions.easing(t)),1===t&&this._finishEase()},e.prototype._finishEase=function(){delete this._easeFn;var t=this._finishFn;delete this._finishFn,t.call(this)},e.prototype._normalizeBearing=function(t,e){t=util.wrap(t,-180,180);var i=Math.abs(t-e);return Math.abs(t-360-e)<i&&(t-=360),Math.abs(t+360-e)<i&&(t+=360),t},e.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0}},e.prototype._smoothOutEasing=function(t){var e=util.ease;if(this._prevEase){var i=this._prevEase,o=(browser.now()-i.start)/i.duration,n=i.easing(o+.01)-i.easing(o),r=.27/Math.sqrt(n*n+1e-4)*.01,a=Math.sqrt(.0729-r*r);e=util.bezier(r,a,.25,1)}return this._prevEase={start:(new Date).getTime(),duration:t,easing:e},e},e}(Evented);module.exports=Camera;
},{"../geo/lng_lat":65,"../geo/lng_lat_bounds":66,"../style-spec/util/interpolate":169,"../util/browser":263,"../util/evented":271,"../util/util":285,"@mapbox/point-geometry":4}],243:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),config=_dereq_("../../util/config"),AttributionControl=function(t){this.options=t,util.bindAll(["_updateEditLink","_updateData","_updateCompact"],this)};AttributionControl.prototype.getDefaultPosition=function(){return"bottom-right"},AttributionControl.prototype.onAdd=function(t){var i=this.options&&this.options.compact;return this._map=t,this._container=DOM.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),i&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===i&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},AttributionControl.prototype.onRemove=function(){DOM.remove(this._container),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0},AttributionControl.prototype._updateEditLink=function(){var t=this._editLink;t||(t=this._editLink=this._container.querySelector(".mapbox-improve-map"));var i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:config.ACCESS_TOKEN}];if(t){var o=i.reduce(function(t,o,e){return o.value&&(t+=o.key+"="+o.value+(e<i.length-1?"&":"")),t},"?");t.href="https://www.mapbox.com/feedback/"+o+(this._map._hash?this._map._hash.getHashString(!0):"")}},AttributionControl.prototype._updateData=function(t){t&&"metadata"===t.sourceDataType&&(this._updateAttributions(),this._updateEditLink())},AttributionControl.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this._map.style.stylesheet){var i=this._map.style.stylesheet;this.styleOwner=i.owner,this.styleId=i.id}var o=this._map.style.sourceCaches;for(var e in o){var n=o[e].getSource();n.attribution&&t.indexOf(n.attribution)<0&&t.push(n.attribution)}t.sort(function(t,i){return t.length-i.length}),t=t.filter(function(i,o){for(var e=o+1;e<t.length;e++)if(t[e].indexOf(i)>=0)return!1;return!0}),this._container.innerHTML=t.join(" | "),this._editLink=null}},AttributionControl.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact")},module.exports=AttributionControl;
},{"../../util/config":267,"../../util/dom":270,"../../util/util":285}],244:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),window=_dereq_("../../util/window"),FullscreenControl=function(){this._fullscreen=!1,util.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in window.document&&(this._fullscreenchange="MSFullscreenChange"),this._className="mapboxgl-ctrl"};FullscreenControl.prototype.onAdd=function(e){return this._map=e,this._mapContainer=this._map.getContainer(),this._container=DOM.create("div",this._className+" mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._container.style.display="none",util.warnOnce("This device does not support fullscreen mode.")),this._container},FullscreenControl.prototype.onRemove=function(){DOM.remove(this._container),this._map=null,window.document.removeEventListener(this._fullscreenchange,this._changeIcon)},FullscreenControl.prototype._checkFullscreenSupport=function(){return!!(window.document.fullscreenEnabled||window.document.mozFullScreenEnabled||window.document.msFullscreenEnabled||window.document.webkitFullscreenEnabled)},FullscreenControl.prototype._setupUI=function(){var e=this._fullscreenButton=DOM.create("button",this._className+"-icon "+this._className+"-fullscreen",this._container);e.setAttribute("aria-label","Toggle fullscreen"),e.type="button",this._fullscreenButton.addEventListener("click",this._onClickFullscreen),window.document.addEventListener(this._fullscreenchange,this._changeIcon)},FullscreenControl.prototype._isFullscreen=function(){return this._fullscreen},FullscreenControl.prototype._changeIcon=function(){(window.document.fullscreenElement||window.document.mozFullScreenElement||window.document.webkitFullscreenElement||window.document.msFullscreenElement)===this._mapContainer!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle(this._className+"-shrink"),this._fullscreenButton.classList.toggle(this._className+"-fullscreen"))},FullscreenControl.prototype._onClickFullscreen=function(){this._isFullscreen()?window.document.exitFullscreen?window.document.exitFullscreen():window.document.mozCancelFullScreen?window.document.mozCancelFullScreen():window.document.msExitFullscreen?window.document.msExitFullscreen():window.document.webkitCancelFullScreen&&window.document.webkitCancelFullScreen():this._mapContainer.requestFullscreen?this._mapContainer.requestFullscreen():this._mapContainer.mozRequestFullScreen?this._mapContainer.mozRequestFullScreen():this._mapContainer.msRequestFullscreen?this._mapContainer.msRequestFullscreen():this._mapContainer.webkitRequestFullscreen&&this._mapContainer.webkitRequestFullscreen()},module.exports=FullscreenControl;
},{"../../util/dom":270,"../../util/util":285,"../../util/window":265}],245:[function(_dereq_,module,exports){
"use strict";function checkGeolocationSupport(t){void 0!==supportsGeolocation?t(supportsGeolocation):void 0!==window.navigator.permissions?window.navigator.permissions.query({name:"geolocation"}).then(function(o){supportsGeolocation="denied"!==o.state,t(supportsGeolocation)}):(supportsGeolocation=!!window.navigator.geolocation,t(supportsGeolocation))}var Evented=_dereq_("../../util/evented"),DOM=_dereq_("../../util/dom"),window=_dereq_("../../util/window"),util=_dereq_("../../util/util"),LngLat=_dereq_("../../geo/lng_lat"),Marker=_dereq_("../marker"),defaultOptions={positionOptions:{enableHighAccuracy:!1,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showUserLocation:!0},className="mapboxgl-ctrl",supportsGeolocation,GeolocateControl=function(t){function o(o){t.call(this),this.options=util.extend({},defaultOptions,o),util.bindAll(["_onSuccess","_onError","_finish","_setupUI","_updateCamera","_updateMarker","_onClickGeolocate"],this)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(t){return this._map=t,this._container=DOM.create("div",className+" "+className+"-group"),checkGeolocationSupport(this._setupUI),this._container},o.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker.remove(),DOM.remove(this._container),this._map=void 0},o.prototype._onSuccess=function(t){if(this.options.trackUserLocation)switch(this._lastKnownPosition=t,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background")}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(t),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(t),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire("geolocate",t),this._finish()},o.prototype._updateCamera=function(t){var o=new LngLat(t.coords.longitude,t.coords.latitude),e=t.coords.accuracy;this._map.fitBounds(o.toBounds(e),this.options.fitBoundsOptions,{geolocateSource:!0})},o.prototype._updateMarker=function(t){t?this._userLocationDotMarker.setLngLat([t.coords.longitude,t.coords.latitude]).addTo(this._map):this._userLocationDotMarker.remove()},o.prototype._onError=function(t){if(this.options.trackUserLocation)if(1===t.code)this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),void 0!==this._geolocationWatchID&&this._clearWatch();else switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting")}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire("error",t),this._finish()},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0},o.prototype._setupUI=function(t){var o=this;!1!==t&&(this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._geolocateButton=DOM.create("button",className+"-icon "+className+"-geolocate",this._container),this._geolocateButton.type="button",this._geolocateButton.setAttribute("aria-label","Geolocate"),this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=DOM.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new Marker(this._dotElement),this.options.trackUserLocation&&(this._watchState="OFF")),this._geolocateButton.addEventListener("click",this._onClickGeolocate.bind(this)),this.options.trackUserLocation&&this._map.on("movestart",function(t){t.geolocateSource||"ACTIVE_LOCK"!==o._watchState||(o._watchState="BACKGROUND",o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),o.fire("trackuserlocationend"))}))},o.prototype._onClickGeolocate=function(){if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire("trackuserlocationstart");break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire("trackuserlocationend");break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire("trackuserlocationstart")}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error")}"OFF"===this._watchState&&void 0!==this._geolocationWatchID?this._clearWatch():void 0===this._geolocationWatchID&&(this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._geolocationWatchID=window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,this.options.positionOptions))}else window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4)},o.prototype._clearWatch=function(){window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null)},o}(Evented);module.exports=GeolocateControl;
},{"../../geo/lng_lat":65,"../../util/dom":270,"../../util/evented":271,"../../util/util":285,"../../util/window":265,"../marker":259}],246:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),LogoControl=function(){util.bindAll(["_updateLogo"],this)};LogoControl.prototype.onAdd=function(o){this._map=o,this._container=DOM.create("div","mapboxgl-ctrl");var t=DOM.create("a","mapboxgl-ctrl-logo");return t.target="_blank",t.href="https://www.mapbox.com/",t.setAttribute("aria-label","Mapbox logo"),this._container.appendChild(t),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._container},LogoControl.prototype.onRemove=function(){DOM.remove(this._container),this._map.off("sourcedata",this._updateLogo)},LogoControl.prototype.getDefaultPosition=function(){return"bottom-left"},LogoControl.prototype._updateLogo=function(o){o&&"metadata"!==o.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none")},LogoControl.prototype._logoRequired=function(){if(this._map.style){var o=this._map.style.sourceCaches;for(var t in o){if(o[t].getSource().mapbox_logo)return!0}return!1}},module.exports=LogoControl;
},{"../../util/dom":270,"../../util/util":285}],247:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),DragRotateHandler=_dereq_("../handler/drag_rotate"),NavigationControl=function(){var t=this;util.bindAll(["_rotateCompassArrow"],this),this._container=DOM.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._zoomInButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in","Zoom In",function(){return t._map.zoomIn()}),this._zoomOutButton=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out","Zoom Out",function(){return t._map.zoomOut()}),this._compass=this._createButton("mapboxgl-ctrl-icon mapboxgl-ctrl-compass","Reset North",function(){return t._map.resetNorth()}),this._compassArrow=DOM.create("span","mapboxgl-ctrl-compass-arrow",this._compass)};NavigationControl.prototype._rotateCompassArrow=function(){var t="rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassArrow.style.transform=t},NavigationControl.prototype.onAdd=function(t){return this._map=t,this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new DragRotateHandler(t,{button:"left",element:this._compass}),this._handler.enable(),this._container},NavigationControl.prototype.onRemove=function(){DOM.remove(this._container),this._map.off("rotate",this._rotateCompassArrow),delete this._map,this._handler.disable(),delete this._handler},NavigationControl.prototype._createButton=function(t,o,r){var e=DOM.create("button",t,this._container);return e.type="button",e.setAttribute("aria-label",o),e.addEventListener("click",r),e},module.exports=NavigationControl;
},{"../../util/dom":270,"../../util/util":285,"../handler/drag_rotate":253}],248:[function(_dereq_,module,exports){
"use strict";function updateScale(t,e,o){var n=o&&o.maxWidth||100,i=t._container.clientHeight/2,a=getDistance(t.unproject([0,i]),t.unproject([n,i]));if(o&&"imperial"===o.unit){var l=3.2808*a;if(l>5280){setScale(e,n,l/5280,"mi")}else setScale(e,n,l,"ft")}else if(o&&"nautical"===o.unit){var r=a/1852;setScale(e,n,r,"nm")}else setScale(e,n,a,"m")}function setScale(t,e,o,n){var i=getRoundNum(o),a=i/o;"m"===n&&i>=1e3&&(i/=1e3,n="km"),t.style.width=e*a+"px",t.innerHTML=i+n}function getDistance(t,e){var o=Math.PI/180,n=t.lat*o,i=e.lat*o,a=Math.sin(n)*Math.sin(i)+Math.cos(n)*Math.cos(i)*Math.cos((e.lng-t.lng)*o);return 6371e3*Math.acos(Math.min(a,1))}function getRoundNum(t){var e=Math.pow(10,(""+Math.floor(t)).length-1),o=t/e;return o=o>=10?10:o>=5?5:o>=3?3:o>=2?2:1,e*o}var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),ScaleControl=function(t){this.options=t,util.bindAll(["_onMove"],this)};ScaleControl.prototype.getDefaultPosition=function(){return"bottom-left"},ScaleControl.prototype._onMove=function(){updateScale(this._map,this._container,this.options)},ScaleControl.prototype.onAdd=function(t){return this._map=t,this._container=DOM.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},ScaleControl.prototype.onRemove=function(){DOM.remove(this._container),this._map.off("move",this._onMove),this._map=void 0},module.exports=ScaleControl;
},{"../../util/dom":270,"../../util/util":285}],249:[function(_dereq_,module,exports){
"use strict";
},{}],250:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),LngLatBounds=_dereq_("../../geo/lng_lat_bounds"),util=_dereq_("../../util/util"),window=_dereq_("../../util/window"),BoxZoomHandler=function(o){this._map=o,this._el=o.getCanvasContainer(),this._container=o.getContainer(),util.bindAll(["_onMouseDown","_onMouseMove","_onMouseUp","_onKeyDown"],this)};BoxZoomHandler.prototype.isEnabled=function(){return!!this._enabled},BoxZoomHandler.prototype.isActive=function(){return!!this._active},BoxZoomHandler.prototype.enable=function(){this.isEnabled()||(this._map.dragPan&&this._map.dragPan.disable(),this._el.addEventListener("mousedown",this._onMouseDown,!1),this._map.dragPan&&this._map.dragPan.enable(),this._enabled=!0)},BoxZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("mousedown",this._onMouseDown),this._enabled=!1)},BoxZoomHandler.prototype._onMouseDown=function(o){o.shiftKey&&0===o.button&&(window.document.addEventListener("mousemove",this._onMouseMove,!1),window.document.addEventListener("keydown",this._onKeyDown,!1),window.document.addEventListener("mouseup",this._onMouseUp,!1),DOM.disableDrag(),this._startPos=DOM.mousePos(this._el,o),this._active=!0)},BoxZoomHandler.prototype._onMouseMove=function(o){var e=this._startPos,t=DOM.mousePos(this._el,o);this._box||(this._box=DOM.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",o));var n=Math.min(e.x,t.x),i=Math.max(e.x,t.x),s=Math.min(e.y,t.y),a=Math.max(e.y,t.y);DOM.setTransform(this._box,"translate("+n+"px,"+s+"px)"),this._box.style.width=i-n+"px",this._box.style.height=a-s+"px"},BoxZoomHandler.prototype._onMouseUp=function(o){if(0===o.button){var e=this._startPos,t=DOM.mousePos(this._el,o),n=(new LngLatBounds).extend(this._map.unproject(e)).extend(this._map.unproject(t));this._finish(),e.x===t.x&&e.y===t.y?this._fireEvent("boxzoomcancel",o):this._map.fitBounds(n,{linear:!0}).fire("boxzoomend",{originalEvent:o,boxZoomBounds:n})}},BoxZoomHandler.prototype._onKeyDown=function(o){27===o.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",o))},BoxZoomHandler.prototype._finish=function(){this._active=!1,window.document.removeEventListener("mousemove",this._onMouseMove,!1),window.document.removeEventListener("keydown",this._onKeyDown,!1),window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(DOM.remove(this._box),this._box=null),DOM.enableDrag()},BoxZoomHandler.prototype._fireEvent=function(o,e){return this._map.fire(o,{originalEvent:e})},module.exports=BoxZoomHandler;
},{"../../geo/lng_lat_bounds":66,"../../util/dom":270,"../../util/util":285,"../../util/window":265}],251:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../../util/util"),DoubleClickZoomHandler=function(o){this._map=o,util.bindAll(["_onDblClick","_onZoomEnd"],this)};DoubleClickZoomHandler.prototype.isEnabled=function(){return!!this._enabled},DoubleClickZoomHandler.prototype.isActive=function(){return!!this._active},DoubleClickZoomHandler.prototype.enable=function(){this.isEnabled()||(this._map.on("dblclick",this._onDblClick),this._enabled=!0)},DoubleClickZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._map.off("dblclick",this._onDblClick),this._enabled=!1)},DoubleClickZoomHandler.prototype._onDblClick=function(o){this._active=!0,this._map.on("zoomend",this._onZoomEnd),this._map.zoomTo(this._map.getZoom()+(o.originalEvent.shiftKey?-1:1),{around:o.lngLat},o)},DoubleClickZoomHandler.prototype._onZoomEnd=function(){this._active=!1,this._map.off("zoomend",this._onZoomEnd)},module.exports=DoubleClickZoomHandler;
},{"../../util/util":285}],252:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),window=_dereq_("../../util/window"),browser=_dereq_("../../util/browser"),inertiaLinearity=.3,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaMaxSpeed=1400,inertiaDeceleration=2500,DragPanHandler=function(e){this._map=e,this._el=e.getCanvasContainer(),util.bindAll(["_onDown","_onMove","_onUp","_onTouchEnd","_onMouseUp"],this)};DragPanHandler.prototype.isEnabled=function(){return!!this._enabled},DragPanHandler.prototype.isActive=function(){return!!this._active},DragPanHandler.prototype.enable=function(){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-drag-pan"),this._el.addEventListener("mousedown",this._onDown),this._el.addEventListener("touchstart",this._onDown),this._enabled=!0)},DragPanHandler.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-drag-pan"),this._el.removeEventListener("mousedown",this._onDown),this._el.removeEventListener("touchstart",this._onDown),this._enabled=!1)},DragPanHandler.prototype._onDown=function(e){this._ignoreEvent(e)||this.isActive()||(e.touches?(window.document.addEventListener("touchmove",this._onMove),window.document.addEventListener("touchend",this._onTouchEnd)):(window.document.addEventListener("mousemove",this._onMove),window.document.addEventListener("mouseup",this._onMouseUp)),window.addEventListener("blur",this._onMouseUp),this._active=!1,this._startPos=this._pos=DOM.mousePos(this._el,e),this._inertia=[[browser.now(),this._pos]])},DragPanHandler.prototype._onMove=function(e){if(!this._ignoreEvent(e)){this.isActive()||(this._active=!0,this._map.moving=!0,this._fireEvent("dragstart",e),this._fireEvent("movestart",e));var t=DOM.mousePos(this._el,e),n=this._map;n.stop(),this._drainInertiaBuffer(),this._inertia.push([browser.now(),t]),n.transform.setLocationAtPoint(n.transform.pointLocation(this._pos),t),this._fireEvent("drag",e),this._fireEvent("move",e),this._pos=t,e.preventDefault()}},DragPanHandler.prototype._onUp=function(e){var t=this;if(this.isActive()){this._active=!1,this._fireEvent("dragend",e),this._drainInertiaBuffer();var n=function(){t._map.moving=!1,t._fireEvent("moveend",e)},i=this._inertia;if(i.length<2)return void n();var o=i[i.length-1],r=i[0],a=o[1].sub(r[1]),s=(o[0]-r[0])/1e3;if(0===s||o[1].equals(r[1]))return void n();var u=a.mult(inertiaLinearity/s),d=u.mag();d>inertiaMaxSpeed&&(d=inertiaMaxSpeed,u._unit()._mult(d));var h=d/(inertiaDeceleration*inertiaLinearity),v=u.mult(-h/2);this._map.panBy(v,{duration:1e3*h,easing:inertiaEasing,noMoveStart:!0},{originalEvent:e})}},DragPanHandler.prototype._onMouseUp=function(e){this._ignoreEvent(e)||(this._onUp(e),window.document.removeEventListener("mousemove",this._onMove),window.document.removeEventListener("mouseup",this._onMouseUp),window.removeEventListener("blur",this._onMouseUp))},DragPanHandler.prototype._onTouchEnd=function(e){this._ignoreEvent(e)||(this._onUp(e),window.document.removeEventListener("touchmove",this._onMove),window.document.removeEventListener("touchend",this._onTouchEnd))},DragPanHandler.prototype._fireEvent=function(e,t){return this._map.fire(e,{originalEvent:t})},DragPanHandler.prototype._ignoreEvent=function(e){var t=this._map;return!(!t.boxZoom||!t.boxZoom.isActive())||(!(!t.dragRotate||!t.dragRotate.isActive())||(e.touches?e.touches.length>1:!!e.ctrlKey||"mousemove"!==e.type&&e.button&&0!==e.button))},DragPanHandler.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,t=browser.now();e.length>0&&t-e[0][0]>160;)e.shift()},module.exports=DragPanHandler;
},{"../../util/browser":263,"../../util/dom":270,"../../util/util":285,"../../util/window":265}],253:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),window=_dereq_("../../util/window"),browser=_dereq_("../../util/browser"),inertiaLinearity=.25,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaMaxSpeed=180,inertiaDeceleration=720,DragRotateHandler=function(t,e){this._map=t,this._el=e.element||t.getCanvasContainer(),this._button=e.button||"right",this._bearingSnap=e.bearingSnap||0,this._pitchWithRotate=!1!==e.pitchWithRotate,util.bindAll(["_onDown","_onMove","_onUp"],this)};DragRotateHandler.prototype.isEnabled=function(){return!!this._enabled},DragRotateHandler.prototype.isActive=function(){return!!this._active},DragRotateHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("mousedown",this._onDown),this._enabled=!0)},DragRotateHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("mousedown",this._onDown),this._enabled=!1)},DragRotateHandler.prototype._onDown=function(t){if(!(this._map.boxZoom&&this._map.boxZoom.isActive()||this._map.dragPan&&this._map.dragPan.isActive()||this.isActive())){if("right"===this._button){var e=t.ctrlKey?0:2,i=t.button;if(void 0!==window.InstallTrigger&&2===t.button&&t.ctrlKey&&window.navigator.platform.toUpperCase().indexOf("MAC")>=0&&(i=0),i!==e)return}else if(t.ctrlKey||0!==t.button)return;DOM.disableDrag(),window.document.addEventListener("mousemove",this._onMove,{capture:!0}),window.document.addEventListener("mouseup",this._onUp),window.addEventListener("blur",this._onUp),this._active=!1,this._inertia=[[browser.now(),this._map.getBearing()]],this._startPos=this._pos=DOM.mousePos(this._el,t),this._center=this._map.transform.centerPoint,t.preventDefault()}},DragRotateHandler.prototype._onMove=function(t){this.isActive()||(this._active=!0,this._map.moving=!0,this._fireEvent("rotatestart",t),this._fireEvent("movestart",t),this._pitchWithRotate&&this._fireEvent("pitchstart",t));var e=this._map;e.stop();var i=this._pos,n=DOM.mousePos(this._el,t),r=.8*(i.x-n.x),a=-.5*(i.y-n.y),o=e.getBearing()-r,s=e.getPitch()-a,h=this._inertia,_=h[h.length-1];this._drainInertiaBuffer(),h.push([browser.now(),e._normalizeBearing(o,_[1])]),e.transform.bearing=o,this._pitchWithRotate&&(this._fireEvent("pitch",t),e.transform.pitch=s),this._fireEvent("rotate",t),this._fireEvent("move",t),this._pos=n},DragRotateHandler.prototype._onUp=function(t){var e=this;if(window.document.removeEventListener("mousemove",this._onMove,{capture:!0}),window.document.removeEventListener("mouseup",this._onUp),window.removeEventListener("blur",this._onUp),DOM.enableDrag(),this.isActive()){this._active=!1,this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,n=i.getBearing(),r=this._inertia,a=function(){Math.abs(n)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):(e._map.moving=!1,e._fireEvent("moveend",t)),e._pitchWithRotate&&e._fireEvent("pitchend",t)};if(r.length<2)return void a();var o=r[0],s=r[r.length-1],h=r[r.length-2],_=i._normalizeBearing(n,h[1]),p=s[1]-o[1],v=p<0?-1:1,d=(s[0]-o[0])/1e3;if(0===p||0===d)return void a();var l=Math.abs(p*(inertiaLinearity/d));l>inertiaMaxSpeed&&(l=inertiaMaxSpeed);var u=l/(inertiaDeceleration*inertiaLinearity);_+=v*l*(u/2),Math.abs(i._normalizeBearing(_,0))<this._bearingSnap&&(_=i._normalizeBearing(0,_)),i.rotateTo(_,{duration:1e3*u,easing:inertiaEasing,noMoveStart:!0},{originalEvent:t})}},DragRotateHandler.prototype._fireEvent=function(t,e){return this._map.fire(t,{originalEvent:e})},DragRotateHandler.prototype._drainInertiaBuffer=function(){for(var t=this._inertia,e=browser.now();t.length>0&&e-t[0][0]>160;)t.shift()},module.exports=DragRotateHandler;
},{"../../util/browser":263,"../../util/dom":270,"../../util/util":285,"../../util/window":265}],254:[function(_dereq_,module,exports){
"use strict";function easeOut(e){return e*(2-e)}var util=_dereq_("../../util/util"),panStep=100,bearingStep=15,pitchStep=10,KeyboardHandler=function(e){this._map=e,this._el=e.getCanvasContainer(),util.bindAll(["_onKeyDown"],this)};KeyboardHandler.prototype.isEnabled=function(){return!!this._enabled},KeyboardHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0)},KeyboardHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1)},KeyboardHandler.prototype._onKeyDown=function(e){if(!(e.altKey||e.ctrlKey||e.metaKey)){var t=0,a=0,n=0,r=0,i=0;switch(e.keyCode){case 61:case 107:case 171:case 187:t=1;break;case 189:case 109:case 173:t=-1;break;case 37:e.shiftKey?a=-1:(e.preventDefault(),r=-1);break;case 39:e.shiftKey?a=1:(e.preventDefault(),r=1);break;case 38:e.shiftKey?n=1:(e.preventDefault(),i=-1);break;case 40:e.shiftKey?n=-1:(i=1,e.preventDefault());break;default:return}var s=this._map,o=s.getZoom(),l={duration:300,delayEndEvents:500,easing:easeOut,zoom:t?Math.round(o)+t*(e.shiftKey?2:1):o,bearing:s.getBearing()+a*bearingStep,pitch:s.getPitch()+n*pitchStep,offset:[-r*panStep,-i*panStep],center:s.getCenter()};s.easeTo(l,{originalEvent:e})}},module.exports=KeyboardHandler;
},{"../../util/util":285}],255:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),browser=_dereq_("../../util/browser"),window=_dereq_("../../util/window"),ua=window.navigator.userAgent.toLowerCase(),firefox=-1!==ua.indexOf("firefox"),safari=-1!==ua.indexOf("safari")&&-1===ua.indexOf("chrom"),ScrollZoomHandler=function(e){this._map=e,this._el=e.getCanvasContainer(),util.bindAll(["_onWheel","_onTimeout"],this)};ScrollZoomHandler.prototype.isEnabled=function(){return!!this._enabled},ScrollZoomHandler.prototype.enable=function(e){this.isEnabled()||(this._el.addEventListener("wheel",this._onWheel,!1),this._el.addEventListener("mousewheel",this._onWheel,!1),this._enabled=!0,this._aroundCenter=e&&"center"===e.around)},ScrollZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("wheel",this._onWheel),this._el.removeEventListener("mousewheel",this._onWheel),this._enabled=!1)},ScrollZoomHandler.prototype._onWheel=function(e){var t=0;"wheel"===e.type?(t=e.deltaY,firefox&&e.deltaMode===window.WheelEvent.DOM_DELTA_PIXEL&&(t/=browser.devicePixelRatio),e.deltaMode===window.WheelEvent.DOM_DELTA_LINE&&(t*=40)):"mousewheel"===e.type&&(t=-e.wheelDeltaY,safari&&(t/=3));var o=browser.now(),i=o-(this._time||0);this._pos=DOM.mousePos(this._el,e),this._time=o,0!==t&&t%4.000244140625==0?this._type="wheel":0!==t&&Math.abs(t)<4?this._type="trackpad":i>400?(this._type=null,this._lastValue=t,this._timeout=setTimeout(this._onTimeout,40)):this._type||(this._type=Math.abs(i*t)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,t+=this._lastValue)),e.shiftKey&&t&&(t/=4),this._type&&this._zoom(-t,e),e.preventDefault()},ScrollZoomHandler.prototype._onTimeout=function(){this._type="wheel",this._zoom(-this._lastValue)},ScrollZoomHandler.prototype._zoom=function(e,t){if(0!==e){var o=this._map,i=2/(1+Math.exp(-Math.abs(e/100)));e<0&&0!==i&&(i=1/i);var l=o.ease?o.ease.to:o.transform.scale,s=o.transform.scaleZoom(l*i);o.zoomTo(s,{duration:"wheel"===this._type?200:0,around:this._aroundCenter?o.getCenter():o.unproject(this._pos),delayEndEvents:200,smoothEasing:!0},{originalEvent:t})}},module.exports=ScrollZoomHandler;
},{"../../util/browser":263,"../../util/dom":270,"../../util/util":285,"../../util/window":265}],256:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../../util/dom"),util=_dereq_("../../util/util"),window=_dereq_("../../util/window"),browser=_dereq_("../../util/browser"),inertiaLinearity=.15,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaDeceleration=12,inertiaMaxSpeed=2.5,significantScaleThreshold=.15,significantRotateThreshold=10,TouchZoomRotateHandler=function(t){this._map=t,this._el=t.getCanvasContainer(),util.bindAll(["_onStart","_onMove","_onEnd"],this)};TouchZoomRotateHandler.prototype.isEnabled=function(){return!!this._enabled},TouchZoomRotateHandler.prototype.enable=function(t){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-zoom-rotate"),this._el.addEventListener("touchstart",this._onStart,!1),this._enabled=!0,this._aroundCenter=t&&"center"===t.around)},TouchZoomRotateHandler.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-zoom-rotate"),this._el.removeEventListener("touchstart",this._onStart),this._enabled=!1)},TouchZoomRotateHandler.prototype.disableRotation=function(){this._rotationDisabled=!0},TouchZoomRotateHandler.prototype.enableRotation=function(){this._rotationDisabled=!1},TouchZoomRotateHandler.prototype._onStart=function(t){if(2===t.touches.length){var e=DOM.mousePos(this._el,t.touches[0]),o=DOM.mousePos(this._el,t.touches[1]);this._startVec=e.sub(o),this._startScale=this._map.transform.scale,this._startBearing=this._map.transform.bearing,this._gestureIntent=void 0,this._inertia=[],window.document.addEventListener("touchmove",this._onMove,!1),window.document.addEventListener("touchend",this._onEnd,!1)}},TouchZoomRotateHandler.prototype._onMove=function(t){if(2===t.touches.length){var e=DOM.mousePos(this._el,t.touches[0]),o=DOM.mousePos(this._el,t.touches[1]),i=e.add(o).div(2),n=e.sub(o),a=n.mag()/this._startVec.mag(),r=this._rotationDisabled?0:180*n.angleWith(this._startVec)/Math.PI,s=this._map;if(this._gestureIntent){var h={duration:0,around:s.unproject(i)};"rotate"===this._gestureIntent&&(h.bearing=this._startBearing+r),"zoom"!==this._gestureIntent&&"rotate"!==this._gestureIntent||(h.zoom=s.transform.scaleZoom(this._startScale*a)),s.stop(),this._drainInertiaBuffer(),this._inertia.push([browser.now(),a,i]),s.easeTo(h,{originalEvent:t})}else{var u=Math.abs(1-a)>significantScaleThreshold;Math.abs(r)>significantRotateThreshold?this._gestureIntent="rotate":u&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._startVec=n,this._startScale=s.transform.scale,this._startBearing=s.transform.bearing)}t.preventDefault()}},TouchZoomRotateHandler.prototype._onEnd=function(t){window.document.removeEventListener("touchmove",this._onMove),window.document.removeEventListener("touchend",this._onEnd),this._drainInertiaBuffer();var e=this._inertia,o=this._map;if(e.length<2)return void o.snapToNorth({},{originalEvent:t});var i=e[e.length-1],n=e[0],a=o.transform.scaleZoom(this._startScale*i[1]),r=o.transform.scaleZoom(this._startScale*n[1]),s=a-r,h=(i[0]-n[0])/1e3,u=i[2];if(0===h||a===r)return void o.snapToNorth({},{originalEvent:t});var l=s*inertiaLinearity/h;Math.abs(l)>inertiaMaxSpeed&&(l=l>0?inertiaMaxSpeed:-inertiaMaxSpeed);var d=1e3*Math.abs(l/(inertiaDeceleration*inertiaLinearity)),c=a+l*d/2e3;c<0&&(c=0),o.easeTo({zoom:c,duration:d,easing:inertiaEasing,around:this._aroundCenter?o.getCenter():o.unproject(u)},{originalEvent:t})},TouchZoomRotateHandler.prototype._drainInertiaBuffer=function(){for(var t=this._inertia,e=browser.now();t.length>2&&e-t[0][0]>160;)t.shift()},module.exports=TouchZoomRotateHandler;
},{"../../util/browser":263,"../../util/dom":270,"../../util/util":285,"../../util/window":265}],257:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("../util/util"),window=_dereq_("../util/window"),throttle=_dereq_("../util/throttle"),Hash=function(){util.bindAll(["_onHashChange","_updateHash"],this),this._updateHash=throttle(this._updateHashUnthrottled.bind(this),300)};Hash.prototype.addTo=function(t){return this._map=t,window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},Hash.prototype.remove=function(){return window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),delete this._map,this},Hash.prototype.getHashString=function(t){var e=this._map.getCenter(),h=Math.round(100*this._map.getZoom())/100,a=Math.ceil((h*Math.LN2+Math.log(512/360/.5))/Math.LN10),n=Math.pow(10,a),i=Math.round(e.lng*n)/n,o=Math.round(e.lat*n)/n,s=this._map.getBearing(),r=this._map.getPitch(),u="";return u+=t?"#/"+i+"/"+o+"/"+h:"#"+h+"/"+o+"/"+i,(s||r)&&(u+="/"+Math.round(10*s)/10),r&&(u+="/"+Math.round(r)),u},Hash.prototype._onHashChange=function(){var t=window.location.hash.replace("#","").split("/");return t.length>=3&&(this._map.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:+(t[3]||0),pitch:+(t[4]||0)}),!0)},Hash.prototype._updateHashUnthrottled=function(){var t=this.getHashString();window.history.replaceState("","",t)},module.exports=Hash;
},{"../util/throttle":282,"../util/util":285,"../util/window":265}],258:[function(_dereq_,module,exports){
"use strict";function removeNode(t){t.parentNode&&t.parentNode.removeChild(t)}var util=_dereq_("../util/util"),browser=_dereq_("../util/browser"),window=_dereq_("../util/window"),ref=_dereq_("../util/window"),HTMLImageElement=ref.HTMLImageElement,HTMLElement=ref.HTMLElement,DOM=_dereq_("../util/dom"),ajax=_dereq_("../util/ajax"),Style=_dereq_("../style/style"),EvaluationParameters=_dereq_("../style/evaluation_parameters"),Painter=_dereq_("../render/painter"),Transform=_dereq_("../geo/transform"),Hash=_dereq_("./hash"),bindHandlers=_dereq_("./bind_handlers"),Camera=_dereq_("./camera"),LngLat=_dereq_("../geo/lng_lat"),LngLatBounds=_dereq_("../geo/lng_lat_bounds"),Point=_dereq_("@mapbox/point-geometry"),AttributionControl=_dereq_("./control/attribution_control"),LogoControl=_dereq_("./control/logo_control"),isSupported=_dereq_("@mapbox/mapbox-gl-supported"),ref$1=_dereq_("../util/image"),RGBAImage=ref$1.RGBAImage;_dereq_("./events");var defaultMinZoom=0,defaultMaxZoom=22,defaultOptions={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:defaultMinZoom,maxZoom:defaultMaxZoom,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,transformRequest:null,fadeDuration:300},Map=function(t){function e(e){var r=this;if(e=util.extend({},defaultOptions,e),null!=e.minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than minZoom");var i=new Transform(e.minZoom,e.maxZoom,e.renderWorldCopies);t.call(this,i,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossFadingFactor=1;var o=e.transformRequest;if(this._transformRequest=o?function(t,e){return o(t,e)||{url:t}}:function(t){return{url:t}},"string"==typeof e.container){var n=window.document.getElementById(e.container);if(!n)throw new Error("Container '"+e.container+"' not found.");this._container=n}else{if(!(e.container instanceof HTMLElement))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container}e.maxBounds&&this.setMaxBounds(e.maxBounds),util.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored","_update","_render","_onData","_onDataLoading"],this),this._setupContainer(),this._setupPainter(),this.on("move",this._update.bind(this,!1)),this.on("zoom",this._update.bind(this,!0)),this.on("move",function(){r._rerender()}),void 0!==window&&(window.addEventListener("online",this._onWindowOnline,!1),window.addEventListener("resize",this._onWindowResize,!1)),bindHandlers(this,e),this._hash=e.hash&&(new Hash).addTo(this),this._hash&&this._hash._onHashChange()||this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),this.resize(),e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new AttributionControl),this.addControl(new LogoControl,e.logoPosition),this.on("style.load",function(){this.transform.unmodified&&this.jumpTo(this.style.stylesheet)}),this.on("data",this._onData),this.on("dataloading",this._onDataLoading)}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={showTileBoundaries:{},showCollisionBoxes:{},showOverdrawInspector:{},repaint:{},vertices:{}};return e.prototype.addControl=function(t,e){void 0===e&&t.getDefaultPosition&&(e=t.getDefaultPosition()),void 0===e&&(e="top-right");var r=t.onAdd(this),i=this._controlPositions[e];return-1!==e.indexOf("bottom")?i.insertBefore(r,i.firstChild):i.appendChild(r),this},e.prototype.removeControl=function(t){return t.onRemove(this),this},e.prototype.resize=function(){var t=this._containerDimensions(),e=t[0],r=t[1];return this._resizeCanvas(e,r),this.transform.resize(e,r),this.painter.resize(e,r),this.fire("movestart").fire("move").fire("resize").fire("moveend")},e.prototype.getBounds=function(){var t=new LngLatBounds(this.transform.pointLocation(new Point(0,this.transform.height)),this.transform.pointLocation(new Point(this.transform.width,0)));return(this.transform.angle||this.transform.pitch)&&(t.extend(this.transform.pointLocation(new Point(this.transform.size.x,0))),t.extend(this.transform.pointLocation(new Point(0,this.transform.size.y)))),t},e.prototype.getMaxBounds=function(){return this.transform.latRange&&2===this.transform.latRange.length&&this.transform.lngRange&&2===this.transform.lngRange.length?new LngLatBounds([this.transform.lngRange[0],this.transform.latRange[0]],[this.transform.lngRange[1],this.transform.latRange[1]]):null},e.prototype.setMaxBounds=function(t){if(t){var e=LngLatBounds.convert(t);this.transform.lngRange=[e.getWest(),e.getEast()],this.transform.latRange=[e.getSouth(),e.getNorth()],this.transform._constrain(),this._update()}else null!==t&&void 0!==t||(this.transform.lngRange=null,this.transform.latRange=null,this._update());return this},e.prototype.setMinZoom=function(t){if((t=null===t||void 0===t?defaultMinZoom:t)>=defaultMinZoom&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between "+defaultMinZoom+" and the current maxZoom, inclusive")},e.prototype.getMinZoom=function(){return this.transform.minZoom},e.prototype.setMaxZoom=function(t){if((t=null===t||void 0===t?defaultMaxZoom:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},e.prototype.getMaxZoom=function(){return this.transform.maxZoom},e.prototype.project=function(t){return this.transform.locationPoint(LngLat.convert(t))},e.prototype.unproject=function(t){return this.transform.pointLocation(Point.convert(t))},e.prototype.on=function(e,r,i){var o=this;if(void 0===i)return t.prototype.on.call(this,e,r);var n=function(){if("mouseenter"===e||"mouseover"===e){var t=!1;return{layer:r,listener:i,delegates:{mousemove:function(n){var s=o.getLayer(r)?o.queryRenderedFeatures(n.point,{layers:[r]}):[];s.length?t||(t=!0,i.call(o,util.extend({features:s},n,{type:e}))):t=!1},mouseout:function(){t=!1}}}}if("mouseleave"===e||"mouseout"===e){var n=!1;return{layer:r,listener:i,delegates:{mousemove:function(t){(o.getLayer(r)?o.queryRenderedFeatures(t.point,{layers:[r]}):[]).length?n=!0:n&&(n=!1,i.call(o,util.extend({},t,{type:e})))},mouseout:function(t){n&&(n=!1,i.call(o,util.extend({},t,{type:e})))}}}}var s=function(t){var e=o.getLayer(r)?o.queryRenderedFeatures(t.point,{layers:[r]}):[];e.length&&i.call(o,util.extend({features:e},t))};return{layer:r,listener:i,delegates:(a={},a[e]=s,a)};var a}();this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[e]=this._delegatedListeners[e]||[],this._delegatedListeners[e].push(n);for(var s in n.delegates)o.on(s,n.delegates[s]);return this},e.prototype.off=function(e,r,i){var o=this;if(void 0===i)return t.prototype.off.call(this,e,r);if(this._delegatedListeners&&this._delegatedListeners[e])for(var n=this._delegatedListeners[e],s=0;s<n.length;s++){var a=n[s];if(a.layer===r&&a.listener===i){for(var h in a.delegates)o.off(h,a.delegates[h]);return n.splice(s,1),o}}return this},e.prototype.queryRenderedFeatures=function(t,e){return 2===arguments.length?(t=arguments[0],e=arguments[1]):1===arguments.length&&function(t){return t instanceof Point||Array.isArray(t)}(arguments[0])?(t=arguments[0],e={}):1===arguments.length?(t=void 0,e=arguments[0]):(t=void 0,e={}),this.style?this.style.queryRenderedFeatures(this._makeQueryGeometry(t),e,this.transform.zoom,this.transform.angle):[]},e.prototype._makeQueryGeometry=function(t){var e=this;void 0===t&&(t=[Point.convert([0,0]),Point.convert([this.transform.width,this.transform.height])]);var r;if(t instanceof Point||"number"==typeof t[0]){r=[Point.convert(t)]}else{var i=[Point.convert(t[0]),Point.convert(t[1])];r=[i[0],new Point(i[1].x,i[0].y),i[1],new Point(i[0].x,i[1].y),i[0]]}return r=r.map(function(t){return e.transform.pointCoordinate(t)})},e.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},e.prototype.setStyle=function(t,e){if((!e||!1!==e.diff&&!e.localIdeographFontFamily)&&this.style&&t&&"object"==typeof t)try{return this.style.setState(t)&&this._update(!0),this}catch(t){util.warnOnce("Unable to perform style diff: "+(t.message||t.error||t)+".  Rebuilding the style from scratch.")}return this.style&&(this.style.setEventedParent(null),this.style._remove()),t?(this.style=new Style(this,e||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof t?this.style.loadURL(t):this.style.loadJSON(t),this):(delete this.style,this)},e.prototype.getStyle=function(){if(this.style)return this.style.serialize()},e.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():util.warnOnce("There is no style added to the map.")},e.prototype.addSource=function(t,e){return this.style.addSource(t,e),this._update(!0),this},e.prototype.isSourceLoaded=function(t){var e=this.style&&this.style.sourceCaches[t];return void 0===e?void this.fire("error",{error:new Error("There is no source with ID '"+t+"'")}):e.loaded()},e.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var r=t[e],i=r._tiles;for(var o in i){var n=i[o];if("loaded"!==n.state&&"errored"!==n.state)return!1}}return!0},e.prototype.addSourceType=function(t,e,r){return this.style.addSourceType(t,e,r)},e.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0),this},e.prototype.getSource=function(t){return this.style.getSource(t)},e.prototype.addImage=function(t,e,r){void 0===r&&(r={});var i=r.pixelRatio;void 0===i&&(i=1);var o=r.sdf;if(void 0===o&&(o=!1),e instanceof HTMLImageElement){var n=browser.getImageData(e),s=n.width,a=n.height,h=n.data;this.style.addImage(t,{data:new RGBAImage({width:s,height:a},h),pixelRatio:i,sdf:o})}else{if(void 0===e.width||void 0===e.height)return this.fire("error",{error:new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")});var l=e.width,u=e.height,d=e.data;this.style.addImage(t,{data:new RGBAImage({width:l,height:u},d.slice(0)),pixelRatio:i,sdf:o})}},e.prototype.hasImage=function(t){return t?!!this.style.getImage(t):(this.fire("error",{error:new Error("Missing required image id")}),!1)},e.prototype.removeImage=function(t){this.style.removeImage(t)},e.prototype.loadImage=function(t,e){ajax.getImage(this._transformRequest(t,ajax.ResourceType.Image),e)},e.prototype.addLayer=function(t,e){return this.style.addLayer(t,e),this._update(!0),this},e.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0),this},e.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0),this},e.prototype.getLayer=function(t){return this.style.getLayer(t)},e.prototype.setFilter=function(t,e){return this.style.setFilter(t,e),this._update(!0),this},e.prototype.setLayerZoomRange=function(t,e,r){return this.style.setLayerZoomRange(t,e,r),this._update(!0),this},e.prototype.getFilter=function(t){return this.style.getFilter(t)},e.prototype.setPaintProperty=function(t,e,r){return this.style.setPaintProperty(t,e,r),this._update(!0),this},e.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},e.prototype.setLayoutProperty=function(t,e,r){return this.style.setLayoutProperty(t,e,r),this._update(!0),this},e.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},e.prototype.setLight=function(t){return this.style.setLight(t),this._update(!0),this},e.prototype.getLight=function(){return this.style.getLight()},e.prototype.getContainer=function(){return this._container},e.prototype.getCanvasContainer=function(){return this._canvasContainer},e.prototype.getCanvas=function(){return this._canvas},e.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.offsetWidth||400,e=this._container.offsetHeight||300),[t,e]},e.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSContainer=DOM.create("div","mapboxgl-missing-css",t)).innerHTML="Missing Mapbox GL JS CSS";var e=this._canvasContainer=DOM.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=DOM.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var r=this._containerDimensions();this._resizeCanvas(r[0],r[1]);var i=this._controlContainer=DOM.create("div","mapboxgl-control-container",t),o=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach(function(t){o[t]=DOM.create("div","mapboxgl-ctrl-"+t,i)})},e.prototype._resizeCanvas=function(t,e){var r=window.devicePixelRatio||1;this._canvas.width=r*t,this._canvas.height=r*e,this._canvas.style.width=t+"px",this._canvas.style.height=e+"px"},e.prototype._setupPainter=function(){var t=util.extend({failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer},isSupported.webGLContextAttributes),e=this._canvas.getContext("webgl",t)||this._canvas.getContext("experimental-webgl",t);if(!e)return void this.fire("error",{error:new Error("Failed to initialize WebGL")});this.painter=new Painter(e,this.transform)},e.prototype._contextLost=function(t){t.preventDefault(),this._frameId&&(browser.cancelFrame(this._frameId),this._frameId=null),this.fire("webglcontextlost",{originalEvent:t})},e.prototype._contextRestored=function(t){this._setupPainter(),this.resize(),this._update(),this.fire("webglcontextrestored",{originalEvent:t})},e.prototype.loaded=function(){return!this._styleDirty&&!this._sourcesDirty&&!(!this.style||!this.style.loaded())},e.prototype._update=function(t){this.style&&(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this._rerender())},e.prototype._render=function(){this.isEasing()&&this._updateEase();var t=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var e=this.transform.zoom,r=browser.now();this.style.zoomHistory.update(e,r);var i=new EvaluationParameters(e,{now:r,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:util.extend({duration:300,delay:0},this.style.stylesheet.transition)}),o=i.crossFadingFactor();1===o&&o===this._crossFadingFactor||(t=!0,this._crossFadingFactor=o),this.style.update(i)}return this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.rotating,zooming:this.zooming,fadeDuration:this._fadeDuration}),this.fire("render"),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire("load")),this.style&&(this.style.hasTransitions()||t)&&(this._styleDirty=!0),(this._sourcesDirty||this._repaint||this._styleDirty||this._placementDirty||this.isEasing())&&this._rerender(),this},e.prototype.remove=function(){this._hash&&this._hash.remove(),browser.cancelFrame(this._frameId),this._frameId=null,this.setStyle(null),void 0!==window&&(window.removeEventListener("resize",this._onWindowResize,!1),window.removeEventListener("online",this._onWindowOnline,!1));var t=this.painter.context.gl.getExtension("WEBGL_lose_context");t&&t.loseContext(),removeNode(this._canvasContainer),removeNode(this._controlContainer),removeNode(this._missingCSSContainer),this._container.classList.remove("mapboxgl-map"),this.fire("remove")},e.prototype._rerender=function(){var t=this;this.style&&!this._frameId&&(this._frameId=browser.frame(function(){t._frameId=null,t._render()}))},e.prototype._onWindowOnline=function(){this._update()},e.prototype._onWindowResize=function(){this._trackResize&&this.stop().resize()._update()},r.showTileBoundaries.get=function(){return!!this._showTileBoundaries},r.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update())},r.showCollisionBoxes.get=function(){return!!this._showCollisionBoxes},r.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update())},r.showOverdrawInspector.get=function(){return!!this._showOverdrawInspector},r.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update())},r.repaint.get=function(){return!!this._repaint},r.repaint.set=function(t){this._repaint=t,this._update()},r.vertices.get=function(){return!!this._vertices},r.vertices.set=function(t){this._vertices=t,this._update()},e.prototype._onData=function(t){this._update("style"===t.dataType),this.fire(t.dataType+"data",t)},e.prototype._onDataLoading=function(t){this.fire(t.dataType+"dataloading",t)},Object.defineProperties(e.prototype,r),e}(Camera);module.exports=Map;
},{"../geo/lng_lat":65,"../geo/lng_lat_bounds":66,"../geo/transform":67,"../render/painter":93,"../style/evaluation_parameters":193,"../style/style":201,"../util/ajax":262,"../util/browser":263,"../util/dom":270,"../util/image":274,"../util/util":285,"../util/window":265,"./bind_handlers":241,"./camera":242,"./control/attribution_control":243,"./control/logo_control":246,"./events":249,"./hash":257,"@mapbox/mapbox-gl-supported":3,"@mapbox/point-geometry":4}],259:[function(_dereq_,module,exports){
"use strict";var DOM=_dereq_("../util/dom"),LngLat=_dereq_("../geo/lng_lat"),Point=_dereq_("@mapbox/point-geometry"),smartWrap=_dereq_("../util/smart_wrap"),ref=_dereq_("../util/util"),bindAll=ref.bindAll,Marker=function(t,e){if(this._offset=Point.convert(e&&e.offset||[0,0]),bindAll(["_update","_onMapClick"],this),!t){t=DOM.create("div");var r=DOM.createNS("http://www.w3.org/2000/svg","svg");r.setAttributeNS(null,"height","41px"),r.setAttributeNS(null,"width","27px"),r.setAttributeNS(null,"viewBox","0 0 27 41");var i=DOM.createNS("http://www.w3.org/2000/svg","g");i.setAttributeNS(null,"stroke","none"),i.setAttributeNS(null,"stroke-width","1"),i.setAttributeNS(null,"fill","none"),i.setAttributeNS(null,"fill-rule","evenodd");var s=DOM.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"fill-rule","nonzero");var p=DOM.createNS("http://www.w3.org/2000/svg","g");p.setAttributeNS(null,"transform","translate(3.0, 29.0)"),p.setAttributeNS(null,"fill","#000000");for(var n=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}],l=0,o=n;l<o.length;l+=1){var a=o[l],u=DOM.createNS("http://www.w3.org/2000/svg","ellipse");u.setAttributeNS(null,"opacity","0.04"),u.setAttributeNS(null,"cx","10.5"),u.setAttributeNS(null,"cy","5.80029008"),u.setAttributeNS(null,"rx",a.rx),u.setAttributeNS(null,"ry",a.ry),p.appendChild(u)}var h=DOM.createNS("http://www.w3.org/2000/svg","g");h.setAttributeNS(null,"fill","#3FB1CE");var _=DOM.createNS("http://www.w3.org/2000/svg","path");_.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),h.appendChild(_);var g=DOM.createNS("http://www.w3.org/2000/svg","g");g.setAttributeNS(null,"opacity","0.25"),g.setAttributeNS(null,"fill","#000000");var d=DOM.createNS("http://www.w3.org/2000/svg","path");d.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),g.appendChild(d);var f=DOM.createNS("http://www.w3.org/2000/svg","g");f.setAttributeNS(null,"transform","translate(6.0, 7.0)"),f.setAttributeNS(null,"fill","#FFFFFF");var w=DOM.createNS("http://www.w3.org/2000/svg","g");w.setAttributeNS(null,"transform","translate(8.0, 8.0)");var c=DOM.createNS("http://www.w3.org/2000/svg","circle");c.setAttributeNS(null,"fill","#000000"),c.setAttributeNS(null,"opacity","0.25"),c.setAttributeNS(null,"cx","5.5"),c.setAttributeNS(null,"cy","5.5"),c.setAttributeNS(null,"r","5.4999962");var v=DOM.createNS("http://www.w3.org/2000/svg","circle");v.setAttributeNS(null,"fill","#FFFFFF"),v.setAttributeNS(null,"cx","5.5"),v.setAttributeNS(null,"cy","5.5"),v.setAttributeNS(null,"r","5.4999962"),w.appendChild(c),w.appendChild(v),s.appendChild(p),s.appendChild(h),s.appendChild(g),s.appendChild(f),s.appendChild(w),r.appendChild(s),t.appendChild(r)}t.classList.add("mapboxgl-marker"),this._element=t,this._popup=null};Marker.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this._update(),this._map.on("click",this._onMapClick),this},Marker.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),delete this._map),DOM.remove(this._element),this._popup&&this._popup.remove(),this},Marker.prototype.getLngLat=function(){return this._lngLat},Marker.prototype.setLngLat=function(t){return this._lngLat=LngLat.convert(t),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},Marker.prototype.getElement=function(){return this._element},Marker.prototype.setPopup=function(t){return this._popup&&(this._popup.remove(),this._popup=null),t&&("offset"in t.options||(t.options.offset=this._offset),this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat)),this},Marker.prototype._onMapClick=function(t){var e=t.originalEvent.target,r=this._element;this._popup&&(e===r||r.contains(e))&&this.togglePopup()},Marker.prototype.getPopup=function(){return this._popup},Marker.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},Marker.prototype._update=function(t){this._map&&(this._map.transform.renderWorldCopies&&(this._lngLat=smartWrap(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset),t&&"moveend"!==t.type||(this._pos=this._pos.round()),DOM.setTransform(this._element,"translate(-50%, -50%) translate("+this._pos.x+"px, "+this._pos.y+"px)"))},Marker.prototype.getOffset=function(){return this._offset},Marker.prototype.setOffset=function(t){return this._offset=Point.convert(t),this._update(),this},module.exports=Marker;
},{"../geo/lng_lat":65,"../util/dom":270,"../util/smart_wrap":280,"../util/util":285,"@mapbox/point-geometry":4}],260:[function(_dereq_,module,exports){
"use strict";function normalizeOffset(t){if(t){if("number"==typeof t){var o=Math.round(Math.sqrt(.5*Math.pow(t,2)));return{top:new Point(0,t),"top-left":new Point(o,o),"top-right":new Point(-o,o),bottom:new Point(0,-t),"bottom-left":new Point(o,-o),"bottom-right":new Point(-o,-o),left:new Point(t,0),right:new Point(-t,0)}}if(t instanceof Point||Array.isArray(t)){var e=Point.convert(t);return{top:e,"top-left":e,"top-right":e,bottom:e,"bottom-left":e,"bottom-right":e,left:e,right:e}}return{top:Point.convert(t.top||[0,0]),"top-left":Point.convert(t["top-left"]||[0,0]),"top-right":Point.convert(t["top-right"]||[0,0]),bottom:Point.convert(t.bottom||[0,0]),"bottom-left":Point.convert(t["bottom-left"]||[0,0]),"bottom-right":Point.convert(t["bottom-right"]||[0,0]),left:Point.convert(t.left||[0,0]),right:Point.convert(t.right||[0,0])}}return normalizeOffset(new Point(0,0))}var util=_dereq_("../util/util"),Evented=_dereq_("../util/evented"),DOM=_dereq_("../util/dom"),LngLat=_dereq_("../geo/lng_lat"),Point=_dereq_("@mapbox/point-geometry"),window=_dereq_("../util/window"),smartWrap=_dereq_("../util/smart_wrap"),defaultOptions={closeButton:!0,closeOnClick:!0},Popup=function(t){function o(o){t.call(this),this.options=util.extend(Object.create(defaultOptions),o),util.bindAll(["_update","_onClickClose"],this)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.addTo=function(t){return this._map=t,this._map.on("move",this._update),this.options.closeOnClick&&this._map.on("click",this._onClickClose),this._update(),this},o.prototype.isOpen=function(){return!!this._map},o.prototype.remove=function(){return this._content&&DOM.remove(this._content),this._container&&(DOM.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("click",this._onClickClose),delete this._map),this.fire("close"),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(t){return this._lngLat=LngLat.convert(t),this._pos=null,this._update(),this},o.prototype.setText=function(t){return this.setDOMContent(window.document.createTextNode(t))},o.prototype.setHTML=function(t){var o,e=window.document.createDocumentFragment(),n=window.document.createElement("body");for(n.innerHTML=t;;){if(!(o=n.firstChild))break;e.appendChild(o)}return this.setDOMContent(e)},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype._createContent=function(){this._content&&DOM.remove(this._content),this._content=DOM.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=DOM.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClickClose))},o.prototype._update=function(){if(this._map&&this._lngLat&&this._content){this._container||(this._container=DOM.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=DOM.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content)),this._map.transform.renderWorldCopies&&(this._lngLat=smartWrap(this._lngLat,this._pos,this._map.transform));var t=this._pos=this._map.project(this._lngLat),o=this.options.anchor,e=normalizeOffset(this.options.offset);if(!o){var n=this._container.offsetWidth,i=this._container.offsetHeight;o=t.y+e.bottom.y<i?["top"]:t.y>this._map.transform.height-i?["bottom"]:[],t.x<n/2?o.push("left"):t.x>this._map.transform.width-n/2&&o.push("right"),o=0===o.length?"bottom":o.join("-")}var r=t.add(e[o]).round(),s={top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"},p=this._container.classList;for(var a in s)p.remove("mapboxgl-popup-anchor-"+a);p.add("mapboxgl-popup-anchor-"+o),DOM.setTransform(this._container,s[o]+" translate("+r.x+"px,"+r.y+"px)")}},o.prototype._onClickClose=function(){this.remove()},o}(Evented);module.exports=Popup;
},{"../geo/lng_lat":65,"../util/dom":270,"../util/evented":271,"../util/smart_wrap":280,"../util/util":285,"../util/window":265,"@mapbox/point-geometry":4}],261:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("./util"),ref=_dereq_("./web_worker_transfer"),serialize=ref.serialize,deserialize=ref.deserialize,Actor=function(e,t,r){this.target=e,this.parent=t,this.mapId=r,this.callbacks={},this.callbackID=0,util.bindAll(["receive"],this),this.target.addEventListener("message",this.receive,!1)};Actor.prototype.send=function(e,t,r,i){var a=r?this.mapId+":"+this.callbackID++:null;r&&(this.callbacks[a]=r);var s=[];this.target.postMessage({targetMapId:i,sourceMapId:this.mapId,type:e,id:String(a),data:serialize(t,s)},s)},Actor.prototype.receive=function(e){var t,r=this,i=e.data,a=i.id;if(!i.targetMapId||this.mapId===i.targetMapId){var s=function(e,t){var i=[];r.target.postMessage({sourceMapId:r.mapId,type:"<response>",id:String(a),error:e?String(e):null,data:serialize(t,i)},i)};if("<response>"===i.type)t=this.callbacks[i.id],delete this.callbacks[i.id],t&&i.error?t(new Error(i.error)):t&&t(null,deserialize(i.data));else if(void 0!==i.id&&this.parent[i.type])this.parent[i.type](i.sourceMapId,deserialize(i.data),s);else if(void 0!==i.id&&this.parent.getWorkerSource){var d=i.type.split("."),l=this.parent.getWorkerSource(i.sourceMapId,d[0]);l[d[1]](deserialize(i.data),s)}else this.parent[i.type](deserialize(i.data))}},Actor.prototype.remove=function(){this.target.removeEventListener("message",this.receive,!1)},module.exports=Actor;
},{"./util":285,"./web_worker_transfer":288}],262:[function(_dereq_,module,exports){
"use strict";function makeRequest(e){var t=new window.XMLHttpRequest;t.open("GET",e.url,!0);for(var r in e.headers)t.setRequestHeader(r,e.headers[r]);return t.withCredentials="include"===e.credentials,t}function sameOrigin(e){var t=window.document.createElement("a");return t.href=e,t.protocol===window.document.location.protocol&&t.host===window.document.location.host}var window=_dereq_("./window"),ResourceType={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};exports.ResourceType=ResourceType,"function"==typeof Object.freeze&&Object.freeze(ResourceType);var AJAXError=function(e){function t(t,r){e.call(this,t),this.status=r}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t}(Error);exports.getJSON=function(e,t){var r=makeRequest(e);return r.setRequestHeader("Accept","application/json"),r.onerror=function(){t(new Error(r.statusText))},r.onload=function(){if(r.status>=200&&r.status<300&&r.response){var e;try{e=JSON.parse(r.response)}catch(e){return t(e)}t(null,e)}else t(new AJAXError(r.statusText,r.status))},r.send(),r},exports.getArrayBuffer=function(e,t){var r=makeRequest(e);return r.responseType="arraybuffer",r.onerror=function(){t(new Error(r.statusText))},r.onload=function(){var e=r.response;if(0===e.byteLength&&200===r.status)return t(new Error("http status 200 returned without content."));r.status>=200&&r.status<300&&r.response?t(null,{data:e,cacheControl:r.getResponseHeader("Cache-Control"),expires:r.getResponseHeader("Expires")}):t(new AJAXError(r.statusText,r.status))},r.send(),r};var transparentPngUrl="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";exports.getImage=function(e,t){return exports.getArrayBuffer(e,function(e,r){if(e)t(e);else if(r){var n=new window.Image,o=window.URL||window.webkitURL;n.onload=function(){t(null,n),o.revokeObjectURL(n.src)};var s=new window.Blob([new Uint8Array(r.data)],{type:"image/png"});n.cacheControl=r.cacheControl,n.expires=r.expires,n.src=r.data.byteLength?o.createObjectURL(s):transparentPngUrl}})},exports.getVideo=function(e,t){var r=window.document.createElement("video");r.onloadstart=function(){t(null,r)};for(var n=0;n<e.length;n++){var o=window.document.createElement("source");sameOrigin(e[n])||(r.crossOrigin="Anonymous"),o.src=e[n],r.appendChild(o)}return r};
},{"./window":265}],263:[function(_dereq_,module,exports){
"use strict";var window=_dereq_("./window"),now=window.performance&&window.performance.now?window.performance.now.bind(window.performance):Date.now.bind(Date),frame=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,cancel=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.msCancelAnimationFrame;module.exports={now:now,frame:function(e){return frame(e)},cancelFrame:function(e){return cancel(e)},getImageData:function(e){var n=window.document.createElement("canvas"),t=n.getContext("2d");if(!t)throw new Error("failed to create canvas 2d context");return n.width=e.width,n.height=e.height,t.drawImage(e,0,0,e.width,e.height),t.getImageData(0,0,e.width,e.height)},hardwareConcurrency:window.navigator.hardwareConcurrency||4,get devicePixelRatio(){return window.devicePixelRatio},supportsWebp:!1};var webpImgTest=window.document.createElement("img");webpImgTest.onload=function(){module.exports.supportsWebp=!0},webpImgTest.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=";
},{"./window":265}],264:[function(_dereq_,module,exports){
"use strict";var WebWorkify=_dereq_("webworkify"),window=_dereq_("../window"),workerURL=window.URL.createObjectURL(new WebWorkify(_dereq_("../../source/worker"),{bare:!0}));module.exports=function(){return new window.Worker(workerURL)};
},{"../../source/worker":121,"../window":265,"webworkify":39}],265:[function(_dereq_,module,exports){
"use strict";module.exports=self;
},{}],266:[function(_dereq_,module,exports){
"use strict";function compareAreas(e,r){return r.area-e.area}var quickselect=_dereq_("quickselect"),calculateSignedArea=_dereq_("./util").calculateSignedArea;module.exports=function(e,r){var a=e.length;if(a<=1)return[e];for(var t,u,c=[],i=0;i<a;i++){var l=calculateSignedArea(e[i]);0!==l&&(e[i].area=Math.abs(l),void 0===u&&(u=l<0),u===l<0?(t&&c.push(t),t=[e[i]]):t.push(e[i]))}if(t&&c.push(t),r>1)for(var n=0;n<c.length;n++)c[n].length<=r||(quickselect(c[n],r,1,c[n].length-1,compareAreas),c[n]=c[n].slice(0,r));return c};
},{"./util":285,"quickselect":31}],267:[function(_dereq_,module,exports){
"use strict";var config={API_URL:"https://api.mapbox.com",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null};module.exports=config;
},{}],268:[function(_dereq_,module,exports){
"use strict";var DictionaryCoder=function(r){var t=this;this._stringToNumber={},this._numberToString=[];for(var o=0;o<r.length;o++){var i=r[o];t._stringToNumber[i]=o,t._numberToString[o]=i}};DictionaryCoder.prototype.encode=function(r){return this._stringToNumber[r]},DictionaryCoder.prototype.decode=function(r){return this._numberToString[r]},module.exports=DictionaryCoder;
},{}],269:[function(_dereq_,module,exports){
"use strict";var util=_dereq_("./util"),Actor=_dereq_("./actor"),Dispatcher=function(t,r){var o=this;this.workerPool=t,this.actors=[],this.currentActor=0,this.id=util.uniqueId();for(var i=this.workerPool.acquire(this.id),e=0;e<i.length;e++){var s=i[e],c=new Actor(s,r,o.id);c.name="Worker "+e,o.actors.push(c)}};Dispatcher.prototype.broadcast=function(t,r,o){o=o||function(){},util.asyncAll(this.actors,function(o,i){o.send(t,r,i)},o)},Dispatcher.prototype.send=function(t,r,o,i){return("number"!=typeof i||isNaN(i))&&(i=this.currentActor=(this.currentActor+1)%this.actors.length),this.actors[i].send(t,r,o),i},Dispatcher.prototype.remove=function(){this.actors.forEach(function(t){t.remove()}),this.actors=[],this.workerPool.release(this.id)},module.exports=Dispatcher;
},{"./actor":261,"./util":285}],270:[function(_dereq_,module,exports){
"use strict";function testProp(e){for(var t=0;t<e.length;t++)if(e[t]in docStyle)return e[t];return e[0]}var Point=_dereq_("@mapbox/point-geometry"),window=_dereq_("./window");exports.create=function(e,t,n){var o=window.document.createElement(e);return t&&(o.className=t),n&&n.appendChild(o),o},exports.createNS=function(e,t){return window.document.createElementNS(e,t)};var docStyle=window.document.documentElement.style,selectProp=testProp(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]),userSelect;exports.disableDrag=function(){selectProp&&(userSelect=docStyle[selectProp],docStyle[selectProp]="none")},exports.enableDrag=function(){selectProp&&(docStyle[selectProp]=userSelect)};var transformProp=testProp(["transform","WebkitTransform"]);exports.setTransform=function(e,t){e.style[transformProp]=t};var suppressClick=function(e){e.preventDefault(),e.stopPropagation(),window.removeEventListener("click",suppressClick,!0)};exports.suppressClick=function(){window.addEventListener("click",suppressClick,!0),window.setTimeout(function(){window.removeEventListener("click",suppressClick,!0)},0)},exports.mousePos=function(e,t){var n=e.getBoundingClientRect();return t=t.touches?t.touches[0]:t,new Point(t.clientX-n.left-e.clientLeft,t.clientY-n.top-e.clientTop)},exports.touchPos=function(e,t){for(var n=e.getBoundingClientRect(),o=[],r="touchend"===t.type?t.changedTouches:t.touches,c=0;c<r.length;c++)o.push(new Point(r[c].clientX-n.left-e.clientLeft,r[c].clientY-n.top-e.clientTop));return o},exports.remove=function(e){e.parentNode&&e.parentNode.removeChild(e)};
},{"./window":265,"@mapbox/point-geometry":4}],271:[function(_dereq_,module,exports){
"use strict";function _addEventListener(e,t,n){n[e]=n[e]||[],n[e].push(t)}function _removeEventListener(e,t,n){if(n&&n[e]){var i=n[e].indexOf(t);-1!==i&&n[e].splice(i,1)}}var util=_dereq_("./util"),Evented=function(){};Evented.prototype.on=function(e,t){return this._listeners=this._listeners||{},_addEventListener(e,t,this._listeners),this},Evented.prototype.off=function(e,t){return _removeEventListener(e,t,this._listeners),_removeEventListener(e,t,this._oneTimeListeners),this},Evented.prototype.once=function(e,t){return this._oneTimeListeners=this._oneTimeListeners||{},_addEventListener(e,t,this._oneTimeListeners),this},Evented.prototype.fire=function(e,t){var n=this;if(this.listens(e)){t=util.extend({},t,{type:e,target:this});for(var i=this._listeners&&this._listeners[e]?this._listeners[e].slice():[],s=0,r=i;s<r.length;s+=1){r[s].call(n,t)}for(var o=this._oneTimeListeners&&this._oneTimeListeners[e]?this._oneTimeListeners[e].slice():[],h=0,_=o;h<_.length;h+=1){var v=_[h];_removeEventListener(e,v,n._oneTimeListeners),v.call(n,t)}this._eventedParent&&this._eventedParent.fire(e,util.extend({},t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData))}else util.endsWith(e,"error")&&console.error(t&&t.error||t||"Empty error event");return this},Evented.prototype.listens=function(e){return this._listeners&&this._listeners[e]&&this._listeners[e].length>0||this._oneTimeListeners&&this._oneTimeListeners[e]&&this._oneTimeListeners[e].length>0||this._eventedParent&&this._eventedParent.listens(e)},Evented.prototype.setEventedParent=function(e,t){return this._eventedParent=e,this._eventedParentData=t,this},module.exports=Evented;
},{"./util":285}],272:[function(_dereq_,module,exports){
"use strict";function compareMax(e,t){return t.max-e.max}function Cell(e,t,n,o){this.p=new Point(e,t),this.h=n,this.d=pointToPolygonDist(this.p,o),this.max=this.d+this.h*Math.SQRT2}function pointToPolygonDist(e,t){for(var n=!1,o=1/0,r=0;r<t.length;r++)for(var i=t[r],l=0,u=i.length,a=u-1;l<u;a=l++){var s=i[l],p=i[a];s.y>e.y!=p.y>e.y&&e.x<(p.x-s.x)*(e.y-s.y)/(p.y-s.y)+s.x&&(n=!n),o=Math.min(o,distToSegmentSquared(e,s,p))}return(n?1:-1)*Math.sqrt(o)}function getCentroidCell(e){for(var t=0,n=0,o=0,r=e[0],i=0,l=r.length,u=l-1;i<l;u=i++){var a=r[i],s=r[u],p=a.x*s.y-s.x*a.y;n+=(a.x+s.x)*p,o+=(a.y+s.y)*p,t+=3*p}return new Cell(n/t,o/t,0,e)}var Queue=_dereq_("tinyqueue"),Point=_dereq_("@mapbox/point-geometry"),distToSegmentSquared=_dereq_("./intersection_tests").distToSegmentSquared;module.exports=function(e,t,n){void 0===t&&(t=1),void 0===n&&(n=!1);for(var o=1/0,r=1/0,i=-1/0,l=-1/0,u=e[0],a=0;a<u.length;a++){var s=u[a];(!a||s.x<o)&&(o=s.x),(!a||s.y<r)&&(r=s.y),(!a||s.x>i)&&(i=s.x),(!a||s.y>l)&&(l=s.y)}var p=i-o,h=l-r,d=Math.min(p,h),x=d/2,y=new Queue(null,compareMax);if(0===d)return new Point(o,r);for(var g=o;g<i;g+=d)for(var f=r;f<l;f+=d)y.push(new Cell(g+x,f+x,x,e));for(var m=getCentroidCell(e),v=y.length;y.length;){var c=y.pop();(c.d>m.d||!m.d)&&(m=c,n&&console.log("found best %d after %d probes",Math.round(1e4*c.d)/1e4,v)),c.max-m.d<=t||(x=c.h/2,y.push(new Cell(c.p.x-x,c.p.y-x,x,e)),y.push(new Cell(c.p.x+x,c.p.y-x,x,e)),y.push(new Cell(c.p.x-x,c.p.y+x,x,e)),y.push(new Cell(c.p.x+x,c.p.y+x,x,e)),v+=4)}return n&&(console.log("num probes: "+v),console.log("best distance: "+m.d)),m.p};
},{"./intersection_tests":275,"@mapbox/point-geometry":4,"tinyqueue":33}],273:[function(_dereq_,module,exports){
"use strict";var WorkerPool=_dereq_("./worker_pool"),globalWorkerPool;module.exports=function(){return globalWorkerPool||(globalWorkerPool=new WorkerPool),globalWorkerPool};
},{"./worker_pool":289}],274:[function(_dereq_,module,exports){
"use strict";function createImage(e,t,i,h){var a=t.width,r=t.height;if(h){if(h.length!==a*r*i)throw new RangeError("mismatched image size")}else h=new Uint8Array(a*r*i);return e.width=a,e.height=r,e.data=h,e}function resizeImage(e,t,i){var h=t.width,a=t.height;if(h!==e.width||a!==e.height){var r=createImage({},{width:h,height:a},i);copyImage(e,r,{x:0,y:0},{x:0,y:0},{width:Math.min(e.width,h),height:Math.min(e.height,a)},i),e.width=h,e.height=a,e.data=r.data}}function copyImage(e,t,i,h,a,r){if(0===a.width||0===a.height)return t;if(a.width>e.width||a.height>e.height||i.x>e.width-a.width||i.y>e.height-a.height)throw new RangeError("out of range source coordinates for image copy");if(a.width>t.width||a.height>t.height||h.x>t.width-a.width||h.y>t.height-a.height)throw new RangeError("out of range destination coordinates for image copy");for(var g=e.data,n=t.data,o=0;o<a.height;o++)for(var m=((i.y+o)*e.width+i.x)*r,w=((h.y+o)*t.width+h.x)*r,d=0;d<a.width*r;d++)n[w+d]=g[m+d];return t}var ref=_dereq_("./web_worker_transfer"),register=ref.register,AlphaImage=function(e,t){createImage(this,e,1,t)};AlphaImage.prototype.resize=function(e){resizeImage(this,e,1)},AlphaImage.prototype.clone=function(){return new AlphaImage({width:this.width,height:this.height},new Uint8Array(this.data))},AlphaImage.copy=function(e,t,i,h,a){copyImage(e,t,i,h,a,1)};var RGBAImage=function(e,t){createImage(this,e,4,t)};RGBAImage.prototype.resize=function(e){resizeImage(this,e,4)},RGBAImage.prototype.clone=function(){return new RGBAImage({width:this.width,height:this.height},new Uint8Array(this.data))},RGBAImage.copy=function(e,t,i,h,a){copyImage(e,t,i,h,a,4)},register("AlphaImage",AlphaImage),register("RGBAImage",RGBAImage),module.exports={AlphaImage:AlphaImage,RGBAImage:RGBAImage};
},{"./web_worker_transfer":288}],275:[function(_dereq_,module,exports){
"use strict";function polygonIntersectsPolygon(n,t){for(var e=0;e<n.length;e++)if(polygonContainsPoint(t,n[e]))return!0;for(var r=0;r<t.length;r++)if(polygonContainsPoint(n,t[r]))return!0;return!!lineIntersectsLine(n,t)}function multiPolygonIntersectsBufferedMultiPoint(n,t,e){for(var r=0;r<n.length;r++)for(var o=n[r],i=0;i<t.length;i++)for(var l=t[i],u=0;u<l.length;u++){var s=l[u];if(polygonContainsPoint(o,s))return!0;if(pointIntersectsBufferedLine(s,o,e))return!0}return!1}function multiPolygonIntersectsMultiPolygon(n,t){if(1===n.length&&1===n[0].length)return multiPolygonContainsPoint(t,n[0][0]);for(var e=0;e<t.length;e++)for(var r=t[e],o=0;o<r.length;o++)if(multiPolygonContainsPoint(n,r[o]))return!0;for(var i=0;i<n.length;i++){for(var l=n[i],u=0;u<l.length;u++)if(multiPolygonContainsPoint(t,l[u]))return!0;for(var s=0;s<t.length;s++)if(lineIntersectsLine(l,t[s]))return!0}return!1}function multiPolygonIntersectsBufferedMultiLine(n,t,e){for(var r=0;r<t.length;r++)for(var o=t[r],i=0;i<n.length;i++){var l=n[i];if(l.length>=3)for(var u=0;u<o.length;u++)if(polygonContainsPoint(l,o[u]))return!0;if(lineIntersectsBufferedLine(l,o,e))return!0}return!1}function lineIntersectsBufferedLine(n,t,e){if(n.length>1){if(lineIntersectsLine(n,t))return!0;for(var r=0;r<t.length;r++)if(pointIntersectsBufferedLine(t[r],n,e))return!0}for(var o=0;o<n.length;o++)if(pointIntersectsBufferedLine(n[o],t,e))return!0;return!1}function lineIntersectsLine(n,t){if(0===n.length||0===t.length)return!1;for(var e=0;e<n.length-1;e++)for(var r=n[e],o=n[e+1],i=0;i<t.length-1;i++){var l=t[i],u=t[i+1];if(lineSegmentIntersectsLineSegment(r,o,l,u))return!0}return!1}function lineSegmentIntersectsLineSegment(n,t,e,r){return isCounterClockwise(n,e,r)!==isCounterClockwise(t,e,r)&&isCounterClockwise(n,t,e)!==isCounterClockwise(n,t,r)}function pointIntersectsBufferedLine(n,t,e){var r=e*e;if(1===t.length)return n.distSqr(t[0])<r;for(var o=1;o<t.length;o++){if(distToSegmentSquared(n,t[o-1],t[o])<r)return!0}return!1}function distToSegmentSquared(n,t,e){var r=t.distSqr(e);if(0===r)return n.distSqr(t);var o=((n.x-t.x)*(e.x-t.x)+(n.y-t.y)*(e.y-t.y))/r;return o<0?n.distSqr(t):o>1?n.distSqr(e):n.distSqr(e.sub(t)._mult(o)._add(t))}function multiPolygonContainsPoint(n,t){for(var e,r,o,i=!1,l=0;l<n.length;l++){e=n[l];for(var u=0,s=e.length-1;u<e.length;s=u++)r=e[u],o=e[s],r.y>t.y!=o.y>t.y&&t.x<(o.x-r.x)*(t.y-r.y)/(o.y-r.y)+r.x&&(i=!i)}return i}function polygonContainsPoint(n,t){for(var e=!1,r=0,o=n.length-1;r<n.length;o=r++){var i=n[r],l=n[o];i.y>t.y!=l.y>t.y&&t.x<(l.x-i.x)*(t.y-i.y)/(l.y-i.y)+i.x&&(e=!e)}return e}var ref=_dereq_("./util"),isCounterClockwise=ref.isCounterClockwise;module.exports={multiPolygonIntersectsBufferedMultiPoint:multiPolygonIntersectsBufferedMultiPoint,multiPolygonIntersectsMultiPolygon:multiPolygonIntersectsMultiPolygon,multiPolygonIntersectsBufferedMultiLine:multiPolygonIntersectsBufferedMultiLine,polygonIntersectsPolygon:polygonIntersectsPolygon,distToSegmentSquared:distToSegmentSquared};
},{"./util":285}],276:[function(_dereq_,module,exports){
"use strict";var unicodeBlockLookup={"Latin-1 Supplement":function(n){return n>=128&&n<=255},Arabic:function(n){return n>=1536&&n<=1791},"Arabic Supplement":function(n){return n>=1872&&n<=1919},"Arabic Extended-A":function(n){return n>=2208&&n<=2303},"Hangul Jamo":function(n){return n>=4352&&n<=4607},"Unified Canadian Aboriginal Syllabics":function(n){return n>=5120&&n<=5759},"Unified Canadian Aboriginal Syllabics Extended":function(n){return n>=6320&&n<=6399},"General Punctuation":function(n){return n>=8192&&n<=8303},"Letterlike Symbols":function(n){return n>=8448&&n<=8527},"Number Forms":function(n){return n>=8528&&n<=8591},"Miscellaneous Technical":function(n){return n>=8960&&n<=9215},"Control Pictures":function(n){return n>=9216&&n<=9279},"Optical Character Recognition":function(n){return n>=9280&&n<=9311},"Enclosed Alphanumerics":function(n){return n>=9312&&n<=9471},"Geometric Shapes":function(n){return n>=9632&&n<=9727},"Miscellaneous Symbols":function(n){return n>=9728&&n<=9983},"Miscellaneous Symbols and Arrows":function(n){return n>=11008&&n<=11263},"CJK Radicals Supplement":function(n){return n>=11904&&n<=12031},"Kangxi Radicals":function(n){return n>=12032&&n<=12255},"Ideographic Description Characters":function(n){return n>=12272&&n<=12287},"CJK Symbols and Punctuation":function(n){return n>=12288&&n<=12351},Hiragana:function(n){return n>=12352&&n<=12447},Katakana:function(n){return n>=12448&&n<=12543},Bopomofo:function(n){return n>=12544&&n<=12591},"Hangul Compatibility Jamo":function(n){return n>=12592&&n<=12687},Kanbun:function(n){return n>=12688&&n<=12703},"Bopomofo Extended":function(n){return n>=12704&&n<=12735},"CJK Strokes":function(n){return n>=12736&&n<=12783},"Katakana Phonetic Extensions":function(n){return n>=12784&&n<=12799},"Enclosed CJK Letters and Months":function(n){return n>=12800&&n<=13055},"CJK Compatibility":function(n){return n>=13056&&n<=13311},"CJK Unified Ideographs Extension A":function(n){return n>=13312&&n<=19903},"Yijing Hexagram Symbols":function(n){return n>=19904&&n<=19967},"CJK Unified Ideographs":function(n){return n>=19968&&n<=40959},"Yi Syllables":function(n){return n>=40960&&n<=42127},"Yi Radicals":function(n){return n>=42128&&n<=42191},"Hangul Jamo Extended-A":function(n){return n>=43360&&n<=43391},"Hangul Syllables":function(n){return n>=44032&&n<=55215},"Hangul Jamo Extended-B":function(n){return n>=55216&&n<=55295},"Private Use Area":function(n){return n>=57344&&n<=63743},"CJK Compatibility Ideographs":function(n){return n>=63744&&n<=64255},"Arabic Presentation Forms-A":function(n){return n>=64336&&n<=65023},"Vertical Forms":function(n){return n>=65040&&n<=65055},"CJK Compatibility Forms":function(n){return n>=65072&&n<=65103},"Small Form Variants":function(n){return n>=65104&&n<=65135},"Arabic Presentation Forms-B":function(n){return n>=65136&&n<=65279},"Halfwidth and Fullwidth Forms":function(n){return n>=65280&&n<=65519}};module.exports=unicodeBlockLookup;
},{}],277:[function(_dereq_,module,exports){
"use strict";var LRUCache=function(t,e){this.max=t,this.onRemove=e,this.reset()};LRUCache.prototype.reset=function(){var t=this;for(var e in t.data)t.onRemove(t.data[e]);return this.data={},this.order=[],this},LRUCache.prototype.add=function(t,e){if(this.has(t))this.order.splice(this.order.indexOf(t),1),this.data[t]=e,this.order.push(t);else if(this.data[t]=e,this.order.push(t),this.order.length>this.max){var r=this.getAndRemove(this.order[0]);r&&this.onRemove(r)}return this},LRUCache.prototype.has=function(t){return t in this.data},LRUCache.prototype.keys=function(){return this.order},LRUCache.prototype.getAndRemove=function(t){if(!this.has(t))return null;var e=this.data[t];return delete this.data[t],this.order.splice(this.order.indexOf(t),1),e},LRUCache.prototype.get=function(t){return this.has(t)?this.data[t]:null},LRUCache.prototype.remove=function(t){if(!this.has(t))return this;var e=this.data[t];return delete this.data[t],this.onRemove(e),this.order.splice(this.order.indexOf(t),1),this},LRUCache.prototype.setMaxSize=function(t){var e=this;for(this.max=t;this.order.length>this.max;){var r=e.getAndRemove(e.order[0]);r&&e.onRemove(r)}return this},module.exports=LRUCache;
},{}],278:[function(_dereq_,module,exports){
"use strict";function makeAPIURL(r,e){var t=parseUrl(config.API_URL);if(r.protocol=t.protocol,r.authority=t.authority,"/"!==t.path&&(r.path=""+t.path+r.path),!config.REQUIRE_ACCESS_TOKEN)return formatUrl(r);if(!(e=e||config.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+help);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+help);return r.params.push("access_token="+e),formatUrl(r)}function isMapboxURL(r){return 0===r.indexOf("mapbox:")}function replaceTempAccessToken(r){for(var e=0;e<r.length;e++)0===r[e].indexOf("access_token=tk.")&&(r[e]="access_token="+(config.ACCESS_TOKEN||""))}function parseUrl(r){var e=r.match(urlRe);if(!e)throw new Error("Unable to parse URL object");return{protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function formatUrl(r){var e=r.params.length?"?"+r.params.join("&"):"";return r.protocol+"://"+r.authority+r.path+e}var config=_dereq_("./config"),browser=_dereq_("./browser"),help="See https://www.mapbox.com/api-documentation/#access-tokens";exports.isMapboxURL=isMapboxURL,exports.normalizeStyleURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/styles/v1"+t.path,makeAPIURL(t,e)},exports.normalizeGlyphsURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/fonts/v1"+t.path,makeAPIURL(t,e)},exports.normalizeSourceURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/v4/"+t.authority+".json",t.params.push("secure"),makeAPIURL(t,e)},exports.normalizeSpriteURL=function(r,e,t,a){var o=parseUrl(r);return isMapboxURL(r)?(o.path="/styles/v1"+o.path+"/sprite"+e+t,makeAPIURL(o,a)):(o.path+=""+e+t,formatUrl(o))};var imageExtensionRe=/(\.(png|jpg)\d*)(?=$)/;exports.normalizeTileURL=function(r,e,t){if(!e||!isMapboxURL(e))return r;var a=parseUrl(r),o=browser.devicePixelRatio>=2||512===t?"@2x":"",p=browser.supportsWebp?".webp":"$1";return a.path=a.path.replace(imageExtensionRe,""+o+p),replaceTempAccessToken(a.params),formatUrl(a)};var urlRe=/^(\w+):\/\/([^\/?]*)(\/[^?]+)?\??(.+)?/;
},{"./browser":263,"./config":267}],279:[function(_dereq_,module,exports){
"use strict";var isChar=_dereq_("./is_char_in_unicode_block");module.exports.allowsIdeographicBreaking=function(a){for(var i=0,r=a;i<r.length;i+=1){var s=r[i];if(!exports.charAllowsIdeographicBreaking(s.charCodeAt(0)))return!1}return!0},module.exports.allowsVerticalWritingMode=function(a){for(var i=0,r=a;i<r.length;i+=1){var s=r[i];if(exports.charHasUprightVerticalOrientation(s.charCodeAt(0)))return!0}return!1},module.exports.allowsLetterSpacing=function(a){for(var i=0,r=a;i<r.length;i+=1){var s=r[i];if(!exports.charAllowsLetterSpacing(s.charCodeAt(0)))return!1}return!0},module.exports.charAllowsLetterSpacing=function(a){return!isChar.Arabic(a)&&(!isChar["Arabic Supplement"](a)&&(!isChar["Arabic Extended-A"](a)&&(!isChar["Arabic Presentation Forms-A"](a)&&!isChar["Arabic Presentation Forms-B"](a))))},module.exports.charAllowsIdeographicBreaking=function(a){return!(a<11904)&&(!!isChar["Bopomofo Extended"](a)||(!!isChar.Bopomofo(a)||(!!isChar["CJK Compatibility Forms"](a)||(!!isChar["CJK Compatibility Ideographs"](a)||(!!isChar["CJK Compatibility"](a)||(!!isChar["CJK Radicals Supplement"](a)||(!!isChar["CJK Strokes"](a)||(!!isChar["CJK Symbols and Punctuation"](a)||(!!isChar["CJK Unified Ideographs Extension A"](a)||(!!isChar["CJK Unified Ideographs"](a)||(!!isChar["Enclosed CJK Letters and Months"](a)||(!!isChar["Halfwidth and Fullwidth Forms"](a)||(!!isChar.Hiragana(a)||(!!isChar["Ideographic Description Characters"](a)||(!!isChar["Kangxi Radicals"](a)||(!!isChar["Katakana Phonetic Extensions"](a)||(!!isChar.Katakana(a)||(!!isChar["Vertical Forms"](a)||(!!isChar["Yi Radicals"](a)||!!isChar["Yi Syllables"](a))))))))))))))))))))},exports.charHasUprightVerticalOrientation=function(a){return 746===a||747===a||!(a<4352)&&(!!isChar["Bopomofo Extended"](a)||(!!isChar.Bopomofo(a)||(!(!isChar["CJK Compatibility Forms"](a)||a>=65097&&a<=65103)||(!!isChar["CJK Compatibility Ideographs"](a)||(!!isChar["CJK Compatibility"](a)||(!!isChar["CJK Radicals Supplement"](a)||(!!isChar["CJK Strokes"](a)||(!(!isChar["CJK Symbols and Punctuation"](a)||a>=12296&&a<=12305||a>=12308&&a<=12319||12336===a)||(!!isChar["CJK Unified Ideographs Extension A"](a)||(!!isChar["CJK Unified Ideographs"](a)||(!!isChar["Enclosed CJK Letters and Months"](a)||(!!isChar["Hangul Compatibility Jamo"](a)||(!!isChar["Hangul Jamo Extended-A"](a)||(!!isChar["Hangul Jamo Extended-B"](a)||(!!isChar["Hangul Jamo"](a)||(!!isChar["Hangul Syllables"](a)||(!!isChar.Hiragana(a)||(!!isChar["Ideographic Description Characters"](a)||(!!isChar.Kanbun(a)||(!!isChar["Kangxi Radicals"](a)||(!!isChar["Katakana Phonetic Extensions"](a)||(!(!isChar.Katakana(a)||12540===a)||(!(!isChar["Halfwidth and Fullwidth Forms"](a)||65288===a||65289===a||65293===a||a>=65306&&a<=65310||65339===a||65341===a||65343===a||a>=65371&&a<=65503||65507===a||a>=65512&&a<=65519)||(!(!isChar["Small Form Variants"](a)||a>=65112&&a<=65118||a>=65123&&a<=65126)||(!!isChar["Unified Canadian Aboriginal Syllabics"](a)||(!!isChar["Unified Canadian Aboriginal Syllabics Extended"](a)||(!!isChar["Vertical Forms"](a)||(!!isChar["Yijing Hexagram Symbols"](a)||(!!isChar["Yi Syllables"](a)||!!isChar["Yi Radicals"](a))))))))))))))))))))))))))))))},exports.charHasNeutralVerticalOrientation=function(a){return!(!isChar["Latin-1 Supplement"](a)||167!==a&&169!==a&&174!==a&&177!==a&&188!==a&&189!==a&&190!==a&&215!==a&&247!==a)||(!(!isChar["General Punctuation"](a)||8214!==a&&8224!==a&&8225!==a&&8240!==a&&8241!==a&&8251!==a&&8252!==a&&8258!==a&&8263!==a&&8264!==a&&8265!==a&&8273!==a)||(!!isChar["Letterlike Symbols"](a)||(!!isChar["Number Forms"](a)||(!(!isChar["Miscellaneous Technical"](a)||!(a>=8960&&a<=8967||a>=8972&&a<=8991||a>=8996&&a<=9e3||9003===a||a>=9085&&a<=9114||a>=9150&&a<=9165||9167===a||a>=9169&&a<=9179||a>=9186&&a<=9215))||(!(!isChar["Control Pictures"](a)||9251===a)||(!!isChar["Optical Character Recognition"](a)||(!!isChar["Enclosed Alphanumerics"](a)||(!!isChar["Geometric Shapes"](a)||(!(!isChar["Miscellaneous Symbols"](a)||a>=9754&&a<=9759)||(!(!isChar["Miscellaneous Symbols and Arrows"](a)||!(a>=11026&&a<=11055||a>=11088&&a<=11097||a>=11192&&a<=11243))||(!!isChar["CJK Symbols and Punctuation"](a)||(!!isChar.Katakana(a)||(!!isChar["Private Use Area"](a)||(!!isChar["CJK Compatibility Forms"](a)||(!!isChar["Small Form Variants"](a)||(!!isChar["Halfwidth and Fullwidth Forms"](a)||(8734===a||8756===a||8757===a||a>=9984&&a<=10087||a>=10102&&a<=10131||65532===a||65533===a)))))))))))))))))},exports.charHasRotatedVerticalOrientation=function(a){return!(exports.charHasUprightVerticalOrientation(a)||exports.charHasNeutralVerticalOrientation(a))};
},{"./is_char_in_unicode_block":276}],280:[function(_dereq_,module,exports){
"use strict";var LngLat=_dereq_("../geo/lng_lat");module.exports=function(n,t,l){if(n=new LngLat(n.lng,n.lat),t){var a=new LngLat(n.lng-360,n.lat),i=new LngLat(n.lng+360,n.lat),o=l.locationPoint(n).distSqr(t);l.locationPoint(a).distSqr(t)<o?n=a:l.locationPoint(i).distSqr(t)<o&&(n=i)}for(;Math.abs(n.lng-l.center.lng)>180;){var e=l.locationPoint(n);if(e.x>=0&&e.y>=0&&e.x<=l.width&&e.y<=l.height)break;n.lng>l.center.lng?n.lng-=360:n.lng+=360}return n};
},{"../geo/lng_lat":65}],281:[function(_dereq_,module,exports){
"use strict";function createLayout(t,r){void 0===r&&(r=1);var e=0,i=0;return{members:t.map(function(t){var a=sizeOf(t.type),s=e=align(e,Math.max(r,a)),n=t.components||1;return i=Math.max(i,a),e+=a*n,{name:t.name,type:t.type,components:n,offset:s}}),size:align(e,Math.max(i,r)),alignment:r}}function sizeOf(t){return viewTypes[t].BYTES_PER_ELEMENT}function align(t,r){return Math.ceil(t/r)*r}var viewTypes={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},Struct=function(t,r){this._structArray=t,this._pos1=r*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8},DEFAULT_CAPACITY=128,RESIZE_MULTIPLIER=5,StructArray=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0)};StructArray.serialize=function(t,r){return t._trim(),r&&(t.isTransferred=!0,r.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},StructArray.deserialize=function(t){var r=Object.create(this.prototype);return r.arrayBuffer=t.arrayBuffer,r.length=t.length,r.capacity=t.arrayBuffer.byteLength/r.bytesPerElement,r._refreshViews(),r},StructArray.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews())},StructArray.prototype.clear=function(){this.length=0},StructArray.prototype.resize=function(t){this.reserve(t),this.length=t},StructArray.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(this.capacity*RESIZE_MULTIPLIER),DEFAULT_CAPACITY),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var r=this.uint8;this._refreshViews(),r&&this.uint8.set(r)}},StructArray.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")},module.exports.StructArray=StructArray,module.exports.Struct=Struct,module.exports.viewTypes=viewTypes,module.exports.createLayout=createLayout;
},{}],282:[function(_dereq_,module,exports){
"use strict";module.exports=function(t,n){var u=!1,e=0,r=function(){e=0,u&&(t(),e=setTimeout(r,n),u=!1)};return function(){return u=!0,e||r(),e}};
},{}],283:[function(_dereq_,module,exports){
"use strict";function tileCover(e,r,a,n){function d(r,d,t){var y,c,l,x;if(t>=0&&t<=o)for(y=r;y<d;y++)c=Math.floor(y/o),l=(y%o+o)%o,0!==c&&!0!==n||(x=new OverscaledTileID(a,c,e,l,t),i[x.key]=x)}void 0===n&&(n=!0);var o=1<<e,i={};return scanTriangle(r[0],r[1],r[2],0,o,d),scanTriangle(r[2],r[3],r[0],0,o,d),Object.keys(i).map(function(e){return i[e]})}function edge(e,r){if(e.row>r.row){var a=e;e=r,r=a}return{x0:e.column,y0:e.row,x1:r.column,y1:r.row,dx:r.column-e.column,dy:r.row-e.row}}function scanSpans(e,r,a,n,d){var o=Math.max(a,Math.floor(r.y0)),i=Math.min(n,Math.ceil(r.y1));if(e.x0===r.x0&&e.y0===r.y0?e.x0+r.dy/e.dy*e.dx<r.x1:e.x1-r.dy/e.dy*e.dx<r.x0){var t=e;e=r,r=t}for(var y=e.dx/e.dy,c=r.dx/r.dy,l=e.dx>0,x=r.dx<0,u=o;u<i;u++){var s=y*Math.max(0,Math.min(e.dy,u+l-e.y0))+e.x0,f=c*Math.max(0,Math.min(r.dy,u+x-r.y0))+r.x0;d(Math.floor(f),Math.ceil(s),u)}}function scanTriangle(e,r,a,n,d,o){var i,t=edge(e,r),y=edge(r,a),c=edge(a,e);t.dy>y.dy&&(i=t,t=y,y=i),t.dy>c.dy&&(i=t,t=c,c=i),y.dy>c.dy&&(i=y,y=c,c=i),t.dy&&scanSpans(c,t,n,d,o),y.dy&&scanSpans(c,y,n,d,o)}var Coordinate=_dereq_("../geo/coordinate"),ref=_dereq_("../source/tile_id"),OverscaledTileID=ref.OverscaledTileID;module.exports=tileCover;
},{"../geo/coordinate":64,"../source/tile_id":117}],284:[function(_dereq_,module,exports){
"use strict";function resolveTokens(e,n){return n.replace(/{([^{}]+)}/g,function(n,r){return r in e?String(e[r]):""})}module.exports=resolveTokens;
},{}],285:[function(_dereq_,module,exports){
"use strict";var UnitBezier=_dereq_("@mapbox/unitbezier"),Coordinate=_dereq_("../geo/coordinate"),Point=_dereq_("@mapbox/point-geometry");exports.easeCubicInOut=function(r){if(r<=0)return 0;if(r>=1)return 1;var e=r*r,t=e*r;return 4*(r<.5?t:3*(r-e)+t-.75)},exports.bezier=function(r,e,t,n){var o=new UnitBezier(r,e,t,n);return function(r){return o.solve(r)}},exports.ease=exports.bezier(.25,.1,.25,1),exports.clamp=function(r,e,t){return Math.min(t,Math.max(e,r))},exports.wrap=function(r,e,t){var n=t-e,o=((r-e)%n+n)%n+e;return o===e?t:o},exports.asyncAll=function(r,e,t){if(!r.length)return t(null,[]);var n=r.length,o=new Array(r.length),a=null;r.forEach(function(r,i){e(r,function(r,e){r&&(a=r),o[i]=e,0==--n&&t(a,o)})})},exports.values=function(r){var e=[];for(var t in r)e.push(r[t]);return e},exports.keysDifference=function(r,e){var t=[];for(var n in r)n in e||t.push(n);return t},exports.extend=function(r){for(var e=[],t=arguments.length-1;t-- >0;)e[t]=arguments[t+1];for(var n=0,o=e;n<o.length;n+=1){var a=o[n];for(var i in a)r[i]=a[i]}return r},exports.pick=function(r,e){for(var t={},n=0;n<e.length;n++){var o=e[n];o in r&&(t[o]=r[o])}return t};var id=1;exports.uniqueId=function(){return id++},exports.bindAll=function(r,e){r.forEach(function(r){e[r]&&(e[r]=e[r].bind(e))})},exports.getCoordinatesCenter=function(r){for(var e=1/0,t=1/0,n=-1/0,o=-1/0,a=0;a<r.length;a++)e=Math.min(e,r[a].column),t=Math.min(t,r[a].row),n=Math.max(n,r[a].column),o=Math.max(o,r[a].row);var i=n-e,u=o-t,s=Math.max(i,u),c=Math.max(0,Math.floor(-Math.log(s)/Math.LN2));return new Coordinate((e+n)/2,(t+o)/2,0).zoomTo(c)},exports.endsWith=function(r,e){return-1!==r.indexOf(e,r.length-e.length)},exports.mapObject=function(r,e,t){var n=this,o={};for(var a in r)o[a]=e.call(t||n,r[a],a,r);return o},exports.filterObject=function(r,e,t){var n=this,o={};for(var a in r)e.call(t||n,r[a],a,r)&&(o[a]=r[a]);return o},exports.deepEqual=function(r,e){if(Array.isArray(r)){if(!Array.isArray(e)||r.length!==e.length)return!1;for(var t=0;t<r.length;t++)if(!exports.deepEqual(r[t],e[t]))return!1;return!0}if("object"==typeof r&&null!==r&&null!==e){if("object"!=typeof e)return!1;if(Object.keys(r).length!==Object.keys(e).length)return!1;for(var n in r)if(!exports.deepEqual(r[n],e[n]))return!1;return!0}return r===e},exports.clone=function(r){return Array.isArray(r)?r.map(exports.clone):"object"==typeof r&&r?exports.mapObject(r,exports.clone):r},exports.arraysIntersect=function(r,e){for(var t=0;t<r.length;t++)if(e.indexOf(r[t])>=0)return!0;return!1};var warnOnceHistory={};exports.warnOnce=function(r){warnOnceHistory[r]||("undefined"!=typeof console&&console.warn(r),warnOnceHistory[r]=!0)},exports.isCounterClockwise=function(r,e,t){return(t.y-r.y)*(e.x-r.x)>(e.y-r.y)*(t.x-r.x)},exports.calculateSignedArea=function(r){for(var e=0,t=0,n=r.length,o=n-1,a=void 0,i=void 0;t<n;o=t++)a=r[t],i=r[o],e+=(i.x-a.x)*(a.y+i.y);return e},exports.isClosedPolygon=function(r){if(r.length<4)return!1;var e=r[0],t=r[r.length-1];return!(Math.abs(e.x-t.x)>0||Math.abs(e.y-t.y)>0)&&Math.abs(exports.calculateSignedArea(r))>.01},exports.sphericalToCartesian=function(r){var e=r[0],t=r[1],n=r[2];return t+=90,t*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(t)*Math.sin(n),y:e*Math.sin(t)*Math.sin(n),z:e*Math.cos(n)}},exports.parseCacheControl=function(r){var e=/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,t={};if(r.replace(e,function(r,e,n,o){var a=n||o;return t[e]=!a||a.toLowerCase(),""}),t["max-age"]){var n=parseInt(t["max-age"],10);isNaN(n)?delete t["max-age"]:t["max-age"]=n}return t};
},{"../geo/coordinate":64,"@mapbox/point-geometry":4,"@mapbox/unitbezier":7}],286:[function(_dereq_,module,exports){
"use strict";var Feature=function(e,t,r,o){this.type="Feature",this._vectorTileFeature=e,e._z=t,e._x=r,e._y=o,this.properties=e.properties,null!=e.id&&(this.id=e.id)},prototypeAccessors={geometry:{}};prototypeAccessors.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},prototypeAccessors.geometry.set=function(e){this._geometry=e},Feature.prototype.toJSON=function(){var e=this,t={geometry:this.geometry};for(var r in e)"_geometry"!==r&&"_vectorTileFeature"!==r&&(t[r]=e[r]);return t},Object.defineProperties(Feature.prototype,prototypeAccessors),module.exports=Feature;
},{}],287:[function(_dereq_,module,exports){
"use strict";var scriptDetection=_dereq_("./script_detection");module.exports=function(t){for(var o="",e=0;e<t.length;e++){var r=t.charCodeAt(e+1)||null,l=t.charCodeAt(e-1)||null;(!r||!scriptDetection.charHasRotatedVerticalOrientation(r)||module.exports.lookup[t[e+1]])&&(!l||!scriptDetection.charHasRotatedVerticalOrientation(l)||module.exports.lookup[t[e-1]])&&module.exports.lookup[t[e]]?o+=module.exports.lookup[t[e]]:o+=t[e]}return o},module.exports.lookup={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};
},{"./script_detection":279}],288:[function(_dereq_,module,exports){
"use strict";function register(e,r,i){void 0===i&&(i={}),Object.defineProperty(r,"_classRegistryKey",{value:e,writeable:!1}),registry[e]={klass:r,omit:i.omit||[],shallow:i.shallow||[]}}function serialize(e,r){if(null===e||void 0===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||e instanceof Boolean||e instanceof Number||e instanceof String||e instanceof Date||e instanceof RegExp)return e;if(e instanceof ArrayBuffer)return r&&r.push(e),e;if(ArrayBuffer.isView(e)){var i=e;return r&&r.push(i.buffer),i}if(e instanceof ImageData)return r&&r.push(e.data.buffer),e;if(Array.isArray(e)){for(var s=[],o=0,t=e;o<t.length;o+=1){var n=t[o];s.push(serialize(n,r))}return s}if("object"==typeof e){var a=e.constructor,f=a._classRegistryKey;if(!f)throw new Error("can't serialize object of unregistered class");var l={};if(a.serialize)l._serialized=a.serialize(e,r);else for(var p in e)if(e.hasOwnProperty(p)&&!(registry[f].omit.indexOf(p)>=0)){var u=e[p];l[p]=registry[f].shallow.indexOf(p)>=0?u:serialize(u,r)}return{name:f,properties:l}}throw new Error("can't serialize object of type "+typeof e)}function deserialize(e){if(null===e||void 0===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||e instanceof Boolean||e instanceof Number||e instanceof String||e instanceof Date||e instanceof RegExp||e instanceof ArrayBuffer||ArrayBuffer.isView(e)||e instanceof ImageData)return e;if(Array.isArray(e))return e.map(function(e){return deserialize(e)});if("object"==typeof e){var r=e,i=r.name,s=r.properties;if(!i)throw new Error("can't deserialize object of anonymous class");var o=registry[i],t=o.klass;if(!t)throw new Error("can't deserialize unregistered class "+i);if(t.deserialize)return t.deserialize(s._serialized);for(var n=Object.create(t.prototype),a=0,f=Object.keys(s);a<f.length;a+=1){var l=f[a];n[l]=registry[i].shallow.indexOf(l)>=0?s[l]:deserialize(s[l])}return n}throw new Error("can't deserialize object of type "+typeof e)}var Grid=_dereq_("grid-index"),Color=_dereq_("../style-spec/util/color"),ref=_dereq_("../style-spec/expression"),StylePropertyFunction=ref.StylePropertyFunction,StyleExpression=ref.StyleExpression,StyleExpressionWithErrorHandling=ref.StyleExpressionWithErrorHandling,ZoomDependentExpression=ref.ZoomDependentExpression,ZoomConstantExpression=ref.ZoomConstantExpression,ref$1=_dereq_("../style-spec/expression/compound_expression"),CompoundExpression=ref$1.CompoundExpression,expressions=_dereq_("../style-spec/expression/definitions"),ref$2=_dereq_("./window"),ImageData=ref$2.ImageData,registry={};register("Object",Object),Grid.serialize=function(e,r){var i=e.toArrayBuffer();return r&&r.push(i),i},Grid.deserialize=function(e){return new Grid(e)},register("Grid",Grid),register("Color",Color),register("StylePropertyFunction",StylePropertyFunction),register("StyleExpression",StyleExpression,{omit:["_evaluator"]}),register("StyleExpressionWithErrorHandling",StyleExpressionWithErrorHandling,{omit:["_evaluator"]}),register("ZoomDependentExpression",ZoomDependentExpression),register("ZoomConstantExpression",ZoomConstantExpression),register("CompoundExpression",CompoundExpression,{omit:["_evaluate"]});for(var name in expressions)expressions[name]._classRegistryKey||register("Expression_"+name,expressions[name]);module.exports={register:register,serialize:serialize,deserialize:deserialize};
},{"../style-spec/expression":142,"../style-spec/expression/compound_expression":126,"../style-spec/expression/definitions":134,"../style-spec/util/color":165,"./window":265,"grid-index":23}],289:[function(_dereq_,module,exports){
"use strict";var WebWorker=_dereq_("./web_worker"),WorkerPool=function(){this.active={}};WorkerPool.prototype.acquire=function(r){var e=this;if(!this.workers){var o=_dereq_("../").workerCount;for(this.workers=[];this.workers.length<o;)e.workers.push(new WebWorker)}return this.active[r]=!0,this.workers.slice()},WorkerPool.prototype.release=function(r){delete this.active[r],0===Object.keys(this.active).length&&(this.workers.forEach(function(r){r.terminate()}),this.workers=null)},module.exports=WorkerPool;
},{"../":76,"./web_worker":264}]},{},[76])(76)
});


//# sourceMappingURL=mapbox-gl.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.983289,40.75973]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983955,40.741298]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.01524,40.703814]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.037775,40.762682]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988996,40.74064]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.932245,40.742743]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993403,40.715047]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.005313,40.724104]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.98942,40.719174]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.966349,40.709261]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.973095,40.747666]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.993619,40.748635]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.950298,40.723074]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.981679,40.739408]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.016784,40.69098]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.981801,40.736694]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985888,40.758625]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99663,40.737368]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.962593,40.697871]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.96534,40.715571]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.030475,40.757853]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99157,40.700718]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.982393,40.720827]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.982289,40.751319]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.988118,40.722853]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999072,40.721092]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.00475,40.675466]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986074,40.744618]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.945958,40.70221]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.006309,40.726125]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.978487,40.743268]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.980632,40.7347]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985014,40.726634]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.988625,40.773586]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983604,40.719174]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.978513,40.696514]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985796,40.691094]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997294,40.762256]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.958837,40.711024]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.946452,40.753534]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00735,40.742676]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00427,40.753991]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.963834,40.688471]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.934868,40.71482]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.957626,40.715669]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.979485,40.73313]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.989456,40.771875]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992131,40.743135]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.993695,40.711057]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.994221,40.735535]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.995339,40.734007]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.004685,40.728356]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.937551,40.724581]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.009586,40.724209]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.95872,40.742059]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.039061,40.755549]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.982269,40.703024]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.981196,40.695023]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.009905,40.728038]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000235,40.75944]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.040552,40.713788]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.992536,40.72157]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.990546,40.730589]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.965723,40.767336]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99935,40.719185]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.976654,40.762426]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.991146,40.744559]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.98312,40.757545]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.971489,40.760481]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.962056,40.776886]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.995148,40.696379]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.019385,40.782372]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.985139,40.755409]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.992467,40.755707]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.987099,40.700854]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.982358,40.679085]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.930396,40.726886]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.987297,40.775961]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.007758,40.727767]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.989893,40.71549]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983616,40.769491]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.98853,40.713871]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993002,40.752256]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.940145,40.70282]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.981284,40.753657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.924493,40.713871]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.994894,40.728082]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.979754,40.736547]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000961,40.78806]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.976813,40.776548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.009824,40.706021]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.950941,40.725705]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999992,40.739661]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.946315,40.731449]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.037776,40.775286]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.978275,40.768495]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.007149,40.724135]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.038746,40.736588]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.023668,40.769582]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.962897,40.714304]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.956959,40.690208]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.992812,40.712747]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.040852,40.749581]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.003571,40.731504]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991453,40.713348]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.932721,40.695158]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.975651,40.764017]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.952741,40.72132]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.98657,40.737982]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.995251,40.726477]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.993598,40.727091]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.980659,40.697464]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.967783,40.757655]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.002984,40.726183]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.979728,40.721194]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.956422,40.720989]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.954894,40.730563]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.991614,40.76627]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991456,40.740843]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.973773,40.779799]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.98683,40.686003]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.98557,40.731555]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993398,40.723336]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.989511,40.729594]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.931041,40.75072]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002504,40.752405]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.030654,40.751078]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.987943,40.747405]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991929,40.739312]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985495,40.676151]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.009952,40.715961]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.0105,40.735149]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.969301,40.795779]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.925745,40.732036]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.946584,40.693056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.995872,40.739814]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.968228,40.701057]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989503,40.732484]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.9908,40.732768]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.982665,40.729259]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.955259,40.781085]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986666,40.740788]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.95017,40.728043]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.986006,40.73647]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.979126,40.69124]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99352,40.726555]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.951841,40.70897]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.005101,40.725391]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.956012,40.742059]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.953003,40.742059]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99615,40.750809]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986835,40.764752]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.987456,40.695158]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.97997,40.723398]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.993542,40.741255]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985543,40.732946]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.994762,40.729396]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.991016,40.745988]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.001944,40.755643]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.959379,40.718224]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.96422,40.765069]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.001329,40.740687]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.033865,40.755114]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.98312,40.748]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.013482,40.712719]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.994969,40.699227]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.978046,40.745832]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.947889,40.750265]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.992233,40.734109]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.983497,40.773113]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989918,40.754008]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999612,40.742209]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.964203,40.777564]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.032264,40.76842]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999839,40.712196]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.009135,40.719669]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.023788,40.767771]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.009905,40.726276]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.966843,40.691893]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.920558,40.713735]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004449,40.727157]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.994964,40.737011]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.94399,40.714549]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99532,40.735486]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.980634,40.731129]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.939766,40.759608]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.965983,40.714694]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.019245,40.767409]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998457,40.793342]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.974977,40.749399]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.945515,40.716961]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.946852,40.725394]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.008806,40.708914]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.941665,40.725259]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.957137,40.735069]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.967397,40.764666]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991271,40.723356]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986027,40.727621]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.005169,40.709257]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.032801,40.730478]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999596,40.74543]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.981596,40.712166]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.939465,40.741375]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.987846,40.741939]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.988118,40.720022]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.961341,40.701125]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.985058,40.717705]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.989431,40.726608]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.982518,40.772108]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.982627,40.70004]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997098,40.735596]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.992798,40.737555]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.991236,40.737685]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.011633,40.703001]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.97887,40.75101]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.962593,40.711837]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.973862,40.756701]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.002275,40.743193]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.988782,40.725368]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.967512,40.798352]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.983521,40.695023]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997192,40.723033]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.976545,40.753449]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.033874,40.727089]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992456,40.724164]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.952101,40.744111]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.003721,40.73442]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.023429,40.764058]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.976732,40.743638]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.969969,40.757655]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.015629,40.707295]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000237,40.679117]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99587,40.723554]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.008561,40.714032]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988619,40.762866]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.015271,40.779528]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.960374,40.681399]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.971541,40.764149]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.966542,40.680486]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.929838,40.757785]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.953381,40.718955]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.995937,40.715121]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.97178,40.75147]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.964918,40.770655]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.982269,40.701261]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989896,40.768853]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.956914,40.686646]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.981181,40.718072]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.97422,40.695972]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.986027,40.721745]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002465,40.735473]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.934331,40.725937]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.981593,40.745715]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.93708,40.708792]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.03441,40.760969]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.969583,40.762621]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983855,40.761613]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.012409,40.708787]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.961212,40.772344]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.965324,40.756179]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.991513,40.684365]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.991271,40.724802]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.988918,40.745337]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.008742,40.732714]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.977976,40.787451]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991745,40.750728]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.98446,40.73798]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.034947,40.729122]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.012706,40.703814]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986008,40.729292]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.976634,40.740683]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993985,40.68641]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.005165,40.745725]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.965544,40.80106]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.00114,40.709193]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.97896,40.772484]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.03441,40.737797]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.025103,40.763062]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.928786,40.714142]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.006555,40.679117]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.986624,40.726123]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983847,40.727621]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.042056,40.722225]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.023438,40.773211]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002881,40.733836]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.987553,40.750802]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.955982,40.77241]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.984574,40.723031]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.982899,40.778274]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.943172,40.706305]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.969659,40.695769]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.990381,40.748752]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.956511,40.708041]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.981908,40.742126]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.970642,40.780679]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.95669,40.778106]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.957853,40.695226]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.953334,40.724209]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.926997,40.691903]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.985668,40.703702]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.992381,40.734966]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.028809,40.772298]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.965726,40.762037]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998431,40.737286]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.987205,40.731971]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.003009,40.728246]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.941343,40.732484]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.955824,40.769683]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998277,40.724283]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993014,40.72525]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.00191,40.725837]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.007656,40.719698]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.989692,40.692107]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004718,40.784945]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.943075,40.744566]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99428,40.746001]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.002041,40.731661]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.994267,40.761647]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.975562,40.742678]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.948491,40.745478]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.956552,40.732927]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.972709,40.681056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.987481,40.72365]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.945482,40.758013]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999632,40.752723]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.036039,40.724277]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.008577,40.72694]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.956726,40.721515]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.992297,40.736539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.947155,40.708614]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.974667,40.778444]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997971,40.734837]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002762,40.713495]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.964135,40.682768]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.984625,40.767977]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.954797,40.723618]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.003555,40.742337]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.988627,40.728896]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.980838,40.781492]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.953003,40.696911]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989904,40.739005]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.964561,40.712244]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997371,40.742783]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988984,40.735342]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99233,40.716303]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.95991,40.774855]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.048853,40.771895]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.950903,40.712166]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000081,40.723949]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.987562,40.755998]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.993992,40.721459]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.951861,40.71604]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.971541,40.749477]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999153,40.715571]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.984594,40.699091]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002177,40.714752]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.02319,40.76605]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.959576,40.729111]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.944795,40.695769]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.005612,40.707159]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.982085,40.723376]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.988993,40.758329]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.951682,40.706414]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.019311,40.770579]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.954808,40.681627]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997115,40.693124]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985543,40.71642]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.950597,40.753227]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.957626,40.719274]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.010978,40.723158]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.986624,40.730273]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.979073,40.76442]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.990442,40.720463]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.991541,40.72884]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985058,40.713481]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.93612,40.697192]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.942023,40.700176]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991358,40.717154]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.970106,40.695972]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002951,40.729126]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.993644,40.744647]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996487,40.745112]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.96707,40.773409]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.019191,40.688015]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.96444,40.717617]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.986526,40.760665]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.980051,40.75611]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.001636,40.747]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996365,40.730791]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999323,40.751088]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.991069,40.742114]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.974309,40.691157]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988918,40.743416]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.990386,40.725733]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988013,40.734948]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.945181,40.739324]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.995424,40.680258]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.010466,40.676379]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.035437,40.718121]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.967012,40.766321]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.955824,40.766489]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.979765,40.785013]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998059,40.738919]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.990356,40.727775]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.965726,40.764666]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.950597,40.694402]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.986448,40.723868]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.96474,40.696379]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.944755,40.732631]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.976009,40.789347]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.993946,40.733867]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.987609,40.73925]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.952703,40.749125]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.953828,40.714142]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.034053,40.743218]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.966528,40.712515]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.956469,40.726679]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.974966,40.768495]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998244,40.748285]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.026538,40.770487]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.001677,40.748774]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.024625,40.765326]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992697,40.727907]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997115,40.688241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.97527,40.729391]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.007423,40.725401]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.994233,40.724357]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.969508,40.753281]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.008896,40.725431]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99475,40.730559]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.970152,40.770774]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.948283,40.704651]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996847,40.796998]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.929502,40.69326]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.977523,40.6806]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996085,40.764285]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99506,40.713274]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.978576,40.779431]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.960198,40.763984]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.006609,40.71216]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.956614,40.705464]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.005327,40.73427]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.964183,40.759894]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.991306,40.763584]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.953334,40.72613]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.976771,40.688699]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.003838,40.730224]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.939657,40.71998]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996548,40.747117]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.952555,40.73433]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.995914,40.725523]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.006685,40.750807]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.95669,40.712108]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.938982,40.698277]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.029237,40.744506]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.001998,40.730348]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.961976,40.763153]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992076,40.73323]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.942774,40.75072]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.017687,40.688699]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.974665,40.771685]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998766,40.722238]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.986375,40.719771]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.019385,40.773703]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.959374,40.768923]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.998336,40.740657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.001051,40.682409]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.030394,40.747234]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.939519,40.714685]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.994566,40.743104]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.941766,40.717672]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.965276,40.704787]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.995004,40.722523]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.010767,40.724526]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.940067,40.754595]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004522,40.725944]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998862,40.718077]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004562,40.732376]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.947747,40.718345]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.009781,40.718077]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.003372,40.724634]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989289,40.733751]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996224,40.720805]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.982447,40.72618]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.96626,40.803633]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992539,40.757862]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.007222,40.786706]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.012051,40.779257]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.953139,40.729085]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983377,40.765145]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.97928,40.748285]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004147,40.73354]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.94882,40.714007]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.992417,40.730348]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.970152,40.684136]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000765,40.728746]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.044352,40.777911]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.987456,40.753313]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.004622,40.735257]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.007401,40.783862]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.026151,40.750935]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.003639,40.715417]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.984239,40.766613]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.978082,40.713054]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.984434,40.7347]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996835,40.724545]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.011157,40.710956]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.006867,40.717325]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.988118,40.727513]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.924493,40.690005]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.955449,40.744582]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.976207,40.733119]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.972926,40.762621]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99624,40.753541]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.986048,40.772344]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.032276,40.773475]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.94399,40.720921]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.946385,40.743199]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.995931,40.73483]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.985861,40.739275]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.978682,40.738098]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.965639,40.67444]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992465,40.695565]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.993221,40.732218]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.949694,40.685847]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.980534,40.732114]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.041721,40.776282]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.94036,40.751226]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.955528,40.701735]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.009547,40.78183]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.93435,40.764166]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.00607,40.727814]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.960804,40.714142]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988948,40.730902]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.97527,40.724775]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.984327,40.735805]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996446,40.755526]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.928428,40.72919]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002459,40.727111]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.954504,40.735586]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.992716,40.673185]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.998904,40.684037]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.966886,40.778647]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.042119,40.742278]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.9876,40.730559]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.945046,40.711456]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.987688,40.768973]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.987839,40.724556]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.991262,40.726638]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.008474,40.713668]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989692,40.723971]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.983975,40.776282]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.994352,40.73854]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.978516,40.717705]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.006076,40.736251]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.966639,40.763153]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.027434,40.754601]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.995777,40.75903]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.008899,40.720808]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.959807,40.703819]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.959426,40.765932]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.967783,40.760284]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.039598,40.726411]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.971,40.792462]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99496,40.732252]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.981464,40.686953]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.96894,40.760966]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.969969,40.759115]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.961447,40.709147]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.989407,40.680486]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.992193,40.73137]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.973113,40.753424]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99318,40.728953]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988208,40.721194]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.0042,40.716787]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.027434,40.747283]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.988487,40.737887]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.923599,40.733799]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.983193,40.739311]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.988526,40.73673]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.936456,40.748441]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.003644,40.749316]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.990108,40.731706]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.97527,40.744081]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.940413,40.72309]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.977439,40.758598]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.996745,40.718879]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.99641,40.741706]},"type":"Feature","properties":{"color":"pink"}}]}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.981908,40.742126],[-73.983955,40.741298]]},{"type":"LineString","coordinates":[[-73.983193,40.739311],[-73.983955,40.741298]]},{"type":"LineString","coordinates":[[-74.012706,40.703814],[-74.01524,40.703814]]},{"type":"LineString","coordinates":[[-73.986666,40.740788],[-73.988996,40.74064]]},{"type":"LineString","coordinates":[[-73.987846,40.741939],[-73.988996,40.74064]]},{"type":"LineString","coordinates":[[-73.987609,40.73925],[-73.988996,40.74064]]},{"type":"LineString","coordinates":[[-73.99233,40.716303],[-73.993403,40.715047]]},{"type":"LineString","coordinates":[[-74.005101,40.725391],[-74.005313,40.724104]]},{"type":"LineString","coordinates":[[-74.004522,40.725944],[-74.005313,40.724104]]},{"type":"LineString","coordinates":[[-74.003372,40.724634],[-74.005313,40.724104]]},{"type":"LineString","coordinates":[[-73.988118,40.720022],[-73.98942,40.719174]]},{"type":"LineString","coordinates":[[-73.971541,40.749477],[-73.973095,40.747666]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.998676,40.732548]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.998676,40.732548]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.998676,40.732548]]},{"type":"LineString","coordinates":[[-73.979754,40.736547],[-73.981801,40.736694]]},{"type":"LineString","coordinates":[[-73.994964,40.737011],[-73.99663,40.737368]]},{"type":"LineString","coordinates":[[-73.99532,40.735486],[-73.99663,40.737368]]},{"type":"LineString","coordinates":[[-73.994352,40.73854],[-73.99663,40.737368]]},{"type":"LineString","coordinates":[[-73.96444,40.717617],[-73.96534,40.715571]]},{"type":"LineString","coordinates":[[-73.979728,40.721194],[-73.982393,40.720827]]},{"type":"LineString","coordinates":[[-73.986027,40.721745],[-73.988118,40.722853]]},{"type":"LineString","coordinates":[[-73.987481,40.72365],[-73.988118,40.722853]]},{"type":"LineString","coordinates":[[-73.986448,40.723868],[-73.988118,40.722853]]},{"type":"LineString","coordinates":[[-73.987839,40.724556],[-73.988118,40.722853]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998412,40.727146]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998412,40.727146]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.998412,40.727146]]},{"type":"LineString","coordinates":[[-73.998766,40.722238],[-73.999072,40.721092]]},{"type":"LineString","coordinates":[[-74.005313,40.724104],[-74.006309,40.726125]]},{"type":"LineString","coordinates":[[-74.005101,40.725391],[-74.006309,40.726125]]},{"type":"LineString","coordinates":[[-74.004449,40.727157],[-74.006309,40.726125]]},{"type":"LineString","coordinates":[[-74.004522,40.725944],[-74.006309,40.726125]]},{"type":"LineString","coordinates":[[-74.00607,40.727814],[-74.006309,40.726125]]},{"type":"LineString","coordinates":[[-73.976732,40.743638],[-73.978487,40.743268]]},{"type":"LineString","coordinates":[[-73.979485,40.73313],[-73.980632,40.7347]]},{"type":"LineString","coordinates":[[-73.979754,40.736547],[-73.980632,40.7347]]},{"type":"LineString","coordinates":[[-73.983847,40.727621],[-73.985014,40.726634]]},{"type":"LineString","coordinates":[[-73.982447,40.72618],[-73.985014,40.726634]]},{"type":"LineString","coordinates":[[-73.982393,40.720827],[-73.983604,40.719174]]},{"type":"LineString","coordinates":[[-73.981181,40.718072],[-73.983604,40.719174]]},{"type":"LineString","coordinates":[[-73.95669,40.712108],[-73.958837,40.711024]]},{"type":"LineString","coordinates":[[-74.002504,40.752405],[-74.00427,40.753991]]},{"type":"LineString","coordinates":[[-73.988625,40.773586],[-73.989456,40.771875]]},{"type":"LineString","coordinates":[[-73.991146,40.744559],[-73.992131,40.743135]]},{"type":"LineString","coordinates":[[-73.991069,40.742114],[-73.992131,40.743135]]},{"type":"LineString","coordinates":[[-73.992812,40.712747],[-73.993695,40.711057]]},{"type":"LineString","coordinates":[[-73.992233,40.734109],[-73.994221,40.735535]]},{"type":"LineString","coordinates":[[-73.992381,40.734966],[-73.994221,40.735535]]},{"type":"LineString","coordinates":[[-73.992297,40.736539],[-73.994221,40.735535]]},{"type":"LineString","coordinates":[[-73.993946,40.733867],[-73.994221,40.735535]]},{"type":"LineString","coordinates":[[-73.994221,40.735535],[-73.995339,40.734007]]},{"type":"LineString","coordinates":[[-73.99532,40.735486],[-73.995339,40.734007]]},{"type":"LineString","coordinates":[[-73.993946,40.733867],[-73.995339,40.734007]]},{"type":"LineString","coordinates":[[-73.99496,40.732252],[-73.995339,40.734007]]},{"type":"LineString","coordinates":[[-74.004449,40.727157],[-74.004685,40.728356]]},{"type":"LineString","coordinates":[[-74.003009,40.728246],[-74.004685,40.728356]]},{"type":"LineString","coordinates":[[-74.002951,40.729126],[-74.004685,40.728356]]},{"type":"LineString","coordinates":[[-74.003838,40.730224],[-74.004685,40.728356]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.004685,40.728356]]},{"type":"LineString","coordinates":[[-74.007149,40.724135],[-74.009586,40.724209]]},{"type":"LineString","coordinates":[[-74.007423,40.725401],[-74.009586,40.724209]]},{"type":"LineString","coordinates":[[-74.008896,40.725431],[-74.009586,40.724209]]},{"type":"LineString","coordinates":[[-73.956012,40.742059],[-73.95872,40.742059]]},{"type":"LineString","coordinates":[[-74.007758,40.727767],[-74.009905,40.728038]]},{"type":"LineString","coordinates":[[-74.008577,40.72694],[-74.009905,40.728038]]},{"type":"LineString","coordinates":[[-73.991271,40.723356],[-73.992536,40.72157]]},{"type":"LineString","coordinates":[[-73.990442,40.720463],[-73.992536,40.72157]]},{"type":"LineString","coordinates":[[-73.989511,40.729594],[-73.990546,40.730589]]},{"type":"LineString","coordinates":[[-73.989503,40.732484],[-73.990546,40.730589]]},{"type":"LineString","coordinates":[[-73.988948,40.730902],[-73.990546,40.730589]]},{"type":"LineString","coordinates":[[-73.990108,40.731706],[-73.990546,40.730589]]},{"type":"LineString","coordinates":[[-73.999072,40.721092],[-73.99935,40.719185]]},{"type":"LineString","coordinates":[[-73.998862,40.718077],[-73.99935,40.719185]]},{"type":"LineString","coordinates":[[-73.996745,40.718879],[-73.99935,40.719185]]},{"type":"LineString","coordinates":[[-73.975651,40.764017],[-73.976654,40.762426]]},{"type":"LineString","coordinates":[[-73.991016,40.745988],[-73.991146,40.744559]]},{"type":"LineString","coordinates":[[-73.988918,40.745337],[-73.991146,40.744559]]},{"type":"LineString","coordinates":[[-73.988918,40.743416],[-73.991146,40.744559]]},{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999682,40.73146]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.999682,40.73146]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.999682,40.73146]]},{"type":"LineString","coordinates":[[-73.96894,40.760966],[-73.971489,40.760481]]},{"type":"LineString","coordinates":[[-73.969969,40.759115],[-73.971489,40.760481]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999917,40.730016]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.999917,40.730016]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.999917,40.730016]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.999917,40.730016]]},{"type":"LineString","coordinates":[[-74.006309,40.726125],[-74.007758,40.727767]]},{"type":"LineString","coordinates":[[-74.00607,40.727814],[-74.007758,40.727767]]},{"type":"LineString","coordinates":[[-73.98853,40.713871],[-73.989893,40.71549]]},{"type":"LineString","coordinates":[[-73.994894,40.728082],[-73.997304,40.728657]]},{"type":"LineString","coordinates":[[-73.994762,40.729396],[-73.997304,40.728657]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.997304,40.728657]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997304,40.728657]]},{"type":"LineString","coordinates":[[-73.998431,40.737286],[-74.000224,40.735864]]},{"type":"LineString","coordinates":[[-73.997971,40.734837],[-74.000224,40.735864]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.000224,40.735864]]},{"type":"LineString","coordinates":[[-73.991745,40.750728],[-73.993002,40.752256]]},{"type":"LineString","coordinates":[[-73.993598,40.727091],[-73.994894,40.728082]]},{"type":"LineString","coordinates":[[-73.99352,40.726555],[-73.994894,40.728082]]},{"type":"LineString","coordinates":[[-73.994762,40.729396],[-73.994894,40.728082]]},{"type":"LineString","coordinates":[[-73.992697,40.727907],[-73.994894,40.728082]]},{"type":"LineString","coordinates":[[-73.99318,40.728953],[-73.994894,40.728082]]},{"type":"LineString","coordinates":[[-73.978682,40.738098],[-73.979754,40.736547]]},{"type":"LineString","coordinates":[[-73.998059,40.738919],[-73.999992,40.739661]]},{"type":"LineString","coordinates":[[-73.998336,40.740657],[-73.999992,40.739661]]},{"type":"LineString","coordinates":[[-73.944755,40.732631],[-73.946315,40.731449]]},{"type":"LineString","coordinates":[[-74.005313,40.724104],[-74.007149,40.724135]]},{"type":"LineString","coordinates":[[-74.006309,40.726125],[-74.007149,40.724135]]},{"type":"LineString","coordinates":[[-74.005101,40.725391],[-74.007149,40.724135]]},{"type":"LineString","coordinates":[[-73.960804,40.714142],[-73.962897,40.714304]]},{"type":"LineString","coordinates":[[-73.991453,40.713348],[-73.992812,40.712747]]},{"type":"LineString","coordinates":[[-74.002041,40.731661],[-74.003571,40.731504]]},{"type":"LineString","coordinates":[[-74.001998,40.730348],[-74.003571,40.731504]]},{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.999128,40.728689]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.999128,40.728689]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.999128,40.728689]]},{"type":"LineString","coordinates":[[-73.986006,40.73647],[-73.98657,40.737982]]},{"type":"LineString","coordinates":[[-73.98446,40.73798],[-73.98657,40.737982]]},{"type":"LineString","coordinates":[[-73.985861,40.739275],[-73.98657,40.737982]]},{"type":"LineString","coordinates":[[-73.994894,40.728082],[-73.995251,40.726477]]},{"type":"LineString","coordinates":[[-73.993598,40.727091],[-73.995251,40.726477]]},{"type":"LineString","coordinates":[[-73.99352,40.726555],[-73.995251,40.726477]]},{"type":"LineString","coordinates":[[-73.993014,40.72525],[-73.995251,40.726477]]},{"type":"LineString","coordinates":[[-73.99352,40.726555],[-73.993598,40.727091]]},{"type":"LineString","coordinates":[[-73.993014,40.72525],[-73.993598,40.727091]]},{"type":"LineString","coordinates":[[-73.992697,40.727907],[-73.993598,40.727091]]},{"type":"LineString","coordinates":[[-73.991262,40.726638],[-73.993598,40.727091]]},{"type":"LineString","coordinates":[[-73.99318,40.728953],[-73.993598,40.727091]]},{"type":"LineString","coordinates":[[-73.978513,40.696514],[-73.980659,40.697464]]},{"type":"LineString","coordinates":[[-74.00191,40.725837],[-74.002984,40.726183]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.002984,40.726183]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-74.002984,40.726183]]},{"type":"LineString","coordinates":[[-73.953139,40.729085],[-73.954894,40.730563]]},{"type":"LineString","coordinates":[[-73.988996,40.74064],[-73.991456,40.740843]]},{"type":"LineString","coordinates":[[-73.991069,40.742114],[-73.991456,40.740843]]},{"type":"LineString","coordinates":[[-73.985543,40.732946],[-73.98557,40.731555]]},{"type":"LineString","coordinates":[[-73.992536,40.72157],[-73.993398,40.723336]]},{"type":"LineString","coordinates":[[-73.991271,40.723356],[-73.993398,40.723336]]},{"type":"LineString","coordinates":[[-73.992456,40.724164],[-73.993398,40.723336]]},{"type":"LineString","coordinates":[[-73.993014,40.72525],[-73.993398,40.723336]]},{"type":"LineString","coordinates":[[-73.988627,40.728896],[-73.989511,40.729594]]},{"type":"LineString","coordinates":[[-73.988948,40.730902],[-73.989511,40.729594]]},{"type":"LineString","coordinates":[[-73.9876,40.730559],[-73.989511,40.729594]]},{"type":"LineString","coordinates":[[-73.991456,40.740843],[-73.991929,40.739312]]},{"type":"LineString","coordinates":[[-73.991236,40.737685],[-73.991929,40.739312]]},{"type":"LineString","coordinates":[[-73.989904,40.739005],[-73.991929,40.739312]]},{"type":"LineString","coordinates":[[-74.009781,40.718077],[-74.009952,40.715961]]},{"type":"LineString","coordinates":[[-73.994352,40.73854],[-73.995872,40.739814]]},{"type":"LineString","coordinates":[[-73.987205,40.731971],[-73.989503,40.732484]]},{"type":"LineString","coordinates":[[-73.989289,40.733751],[-73.989503,40.732484]]},{"type":"LineString","coordinates":[[-73.988948,40.730902],[-73.989503,40.732484]]},{"type":"LineString","coordinates":[[-73.989503,40.732484],[-73.9908,40.732768]]},{"type":"LineString","coordinates":[[-73.989289,40.733751],[-73.9908,40.732768]]},{"type":"LineString","coordinates":[[-73.990108,40.731706],[-73.9908,40.732768]]},{"type":"LineString","coordinates":[[-73.983955,40.741298],[-73.986666,40.740788]]},{"type":"LineString","coordinates":[[-73.985861,40.739275],[-73.986666,40.740788]]},{"type":"LineString","coordinates":[[-73.98446,40.73798],[-73.986006,40.73647]]},{"type":"LineString","coordinates":[[-73.984434,40.7347],[-73.986006,40.73647]]},{"type":"LineString","coordinates":[[-73.984327,40.735805],[-73.986006,40.73647]]},{"type":"LineString","coordinates":[[-73.993014,40.72525],[-73.99352,40.726555]]},{"type":"LineString","coordinates":[[-73.992697,40.727907],[-73.99352,40.726555]]},{"type":"LineString","coordinates":[[-73.991262,40.726638],[-73.99352,40.726555]]},{"type":"LineString","coordinates":[[-74.002984,40.726183],[-74.005101,40.725391]]},{"type":"LineString","coordinates":[[-74.004449,40.727157],[-74.005101,40.725391]]},{"type":"LineString","coordinates":[[-74.004522,40.725944],[-74.005101,40.725391]]},{"type":"LineString","coordinates":[[-74.003372,40.724634],[-74.005101,40.725391]]},{"type":"LineString","coordinates":[[-73.952101,40.744111],[-73.953003,40.742059]]},{"type":"LineString","coordinates":[[-73.992131,40.743135],[-73.993542,40.741255]]},{"type":"LineString","coordinates":[[-73.991456,40.740843],[-73.993542,40.741255]]},{"type":"LineString","coordinates":[[-73.991069,40.742114],[-73.993542,40.741255]]},{"type":"LineString","coordinates":[[-73.984434,40.7347],[-73.985543,40.732946]]},{"type":"LineString","coordinates":[[-73.992697,40.727907],[-73.994762,40.729396]]},{"type":"LineString","coordinates":[[-73.99475,40.730559],[-73.994762,40.729396]]},{"type":"LineString","coordinates":[[-73.992417,40.730348],[-73.994762,40.729396]]},{"type":"LineString","coordinates":[[-73.99318,40.728953],[-73.994762,40.729396]]},{"type":"LineString","coordinates":[[-73.988918,40.745337],[-73.991016,40.745988]]},{"type":"LineString","coordinates":[[-73.957626,40.719274],[-73.959379,40.718224]]},{"type":"LineString","coordinates":[[-73.999992,40.739661],[-74.001329,40.740687]]},{"type":"LineString","coordinates":[[-73.999612,40.742209],[-74.001329,40.740687]]},{"type":"LineString","coordinates":[[-73.9908,40.732768],[-73.992233,40.734109]]},{"type":"LineString","coordinates":[[-73.992076,40.73323],[-73.992233,40.734109]]},{"type":"LineString","coordinates":[[-73.982518,40.772108],[-73.983497,40.773113]]},{"type":"LineString","coordinates":[[-73.987456,40.753313],[-73.989918,40.754008]]},{"type":"LineString","coordinates":[[-73.997371,40.742783],[-73.999612,40.742209]]},{"type":"LineString","coordinates":[[-73.998336,40.740657],[-73.999612,40.742209]]},{"type":"LineString","coordinates":[[-73.962056,40.776886],[-73.964203,40.777564]]},{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999177,40.733797]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.999177,40.733797]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.999177,40.733797]]},{"type":"LineString","coordinates":[[-73.997971,40.734837],[-73.999177,40.733797]]},{"type":"LineString","coordinates":[[-73.995339,40.734007],[-73.997234,40.733579]]},{"type":"LineString","coordinates":[[-73.997098,40.735596],[-73.997234,40.733579]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997234,40.733579]]},{"type":"LineString","coordinates":[[-73.995931,40.73483],[-73.997234,40.733579]]},{"type":"LineString","coordinates":[[-73.994894,40.728082],[-73.996831,40.727328]]},{"type":"LineString","coordinates":[[-73.995251,40.726477],[-73.996831,40.727328]]},{"type":"LineString","coordinates":[[-73.995914,40.725523],[-73.996831,40.727328]]},{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.002077,40.737309]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.002077,40.737309]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.002077,40.737309]]},{"type":"LineString","coordinates":[[-74.007656,40.719698],[-74.009135,40.719669]]},{"type":"LineString","coordinates":[[-74.008899,40.720808],[-74.009135,40.719669]]},{"type":"LineString","coordinates":[[-74.023668,40.769582],[-74.023788,40.767771]]},{"type":"LineString","coordinates":[[-74.02319,40.76605],[-74.023788,40.767771]]},{"type":"LineString","coordinates":[[-74.009586,40.724209],[-74.009905,40.726276]]},{"type":"LineString","coordinates":[[-74.009905,40.728038],[-74.009905,40.726276]]},{"type":"LineString","coordinates":[[-74.008577,40.72694],[-74.009905,40.726276]]},{"type":"LineString","coordinates":[[-74.007423,40.725401],[-74.009905,40.726276]]},{"type":"LineString","coordinates":[[-74.008896,40.725431],[-74.009905,40.726276]]},{"type":"LineString","coordinates":[[-74.002984,40.726183],[-74.004449,40.727157]]},{"type":"LineString","coordinates":[[-74.003009,40.728246],[-74.004449,40.727157]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.004449,40.727157]]},{"type":"LineString","coordinates":[[-73.994221,40.735535],[-73.994964,40.737011]]},{"type":"LineString","coordinates":[[-73.992798,40.737555],[-73.994964,40.737011]]},{"type":"LineString","coordinates":[[-73.992297,40.736539],[-73.994964,40.737011]]},{"type":"LineString","coordinates":[[-73.994352,40.73854],[-73.994964,40.737011]]},{"type":"LineString","coordinates":[[-73.994221,40.735535],[-73.99532,40.735486]]},{"type":"LineString","coordinates":[[-73.994964,40.737011],[-73.99532,40.735486]]},{"type":"LineString","coordinates":[[-73.993946,40.733867],[-73.99532,40.735486]]},{"type":"LineString","coordinates":[[-73.980534,40.732114],[-73.980634,40.731129]]},{"type":"LineString","coordinates":[[-73.96534,40.715571],[-73.965983,40.714694]]},{"type":"LineString","coordinates":[[-73.954504,40.735586],[-73.957137,40.735069]]},{"type":"LineString","coordinates":[[-73.967012,40.766321],[-73.967397,40.764666]]},{"type":"LineString","coordinates":[[-73.965726,40.764666],[-73.967397,40.764666]]},{"type":"LineString","coordinates":[[-73.966639,40.763153],[-73.967397,40.764666]]},{"type":"LineString","coordinates":[[-73.991271,40.724802],[-73.991271,40.723356]]},{"type":"LineString","coordinates":[[-73.989692,40.723971],[-73.991271,40.723356]]},{"type":"LineString","coordinates":[[-73.985014,40.726634],[-73.986027,40.727621]]},{"type":"LineString","coordinates":[[-73.986008,40.729292],[-73.986027,40.727621]]},{"type":"LineString","coordinates":[[-73.983847,40.727621],[-73.986027,40.727621]]},{"type":"LineString","coordinates":[[-73.986666,40.740788],[-73.987846,40.741939]]},{"type":"LineString","coordinates":[[-73.986375,40.719771],[-73.988118,40.720022]]},{"type":"LineString","coordinates":[[-73.983604,40.719174],[-73.985058,40.717705]]},{"type":"LineString","coordinates":[[-73.988782,40.725368],[-73.989431,40.726608]]},{"type":"LineString","coordinates":[[-73.988118,40.727513],[-73.989431,40.726608]]},{"type":"LineString","coordinates":[[-73.982269,40.701261],[-73.982627,40.70004]]},{"type":"LineString","coordinates":[[-73.99663,40.737368],[-73.997098,40.735596]]},{"type":"LineString","coordinates":[[-73.995339,40.734007],[-73.997098,40.735596]]},{"type":"LineString","coordinates":[[-73.994964,40.737011],[-73.997098,40.735596]]},{"type":"LineString","coordinates":[[-73.99532,40.735486],[-73.997098,40.735596]]},{"type":"LineString","coordinates":[[-73.995931,40.73483],[-73.997098,40.735596]]},{"type":"LineString","coordinates":[[-73.991929,40.739312],[-73.992798,40.737555]]},{"type":"LineString","coordinates":[[-73.991236,40.737685],[-73.992798,40.737555]]},{"type":"LineString","coordinates":[[-73.992297,40.736539],[-73.992798,40.737555]]},{"type":"LineString","coordinates":[[-73.989904,40.739005],[-73.991236,40.737685]]},{"type":"LineString","coordinates":[[-73.988487,40.737887],[-73.991236,40.737685]]},{"type":"LineString","coordinates":[[-73.986624,40.726123],[-73.988782,40.725368]]},{"type":"LineString","coordinates":[[-73.987481,40.72365],[-73.988782,40.725368]]},{"type":"LineString","coordinates":[[-73.987839,40.724556],[-73.988782,40.725368]]},{"type":"LineString","coordinates":[[-73.981196,40.695023],[-73.983521,40.695023]]},{"type":"LineString","coordinates":[[-73.994894,40.728082],[-73.996239,40.729638]]},{"type":"LineString","coordinates":[[-73.994762,40.729396],[-73.996239,40.729638]]},{"type":"LineString","coordinates":[[-73.99475,40.730559],[-73.996239,40.729638]]},{"type":"LineString","coordinates":[[-73.99587,40.723554],[-73.997192,40.723033]]},{"type":"LineString","coordinates":[[-73.995004,40.722523],[-73.997192,40.723033]]},{"type":"LineString","coordinates":[[-73.996835,40.724545],[-73.997192,40.723033]]},{"type":"LineString","coordinates":[[-73.991271,40.723356],[-73.992456,40.724164]]},{"type":"LineString","coordinates":[[-73.991271,40.724802],[-73.992456,40.724164]]},{"type":"LineString","coordinates":[[-73.989692,40.723971],[-73.992456,40.724164]]},{"type":"LineString","coordinates":[[-74.002465,40.735473],[-74.003721,40.73442]]},{"type":"LineString","coordinates":[[-74.002881,40.733836],[-74.003721,40.73442]]},{"type":"LineString","coordinates":[[-74.02319,40.76605],[-74.023429,40.764058]]},{"type":"LineString","coordinates":[[-73.975562,40.742678],[-73.976732,40.743638]]},{"type":"LineString","coordinates":[[-73.97527,40.744081],[-73.976732,40.743638]]},{"type":"LineString","coordinates":[[-73.967783,40.757655],[-73.969969,40.757655]]},{"type":"LineString","coordinates":[[-73.969969,40.759115],[-73.969969,40.757655]]},{"type":"LineString","coordinates":[[-73.993398,40.723336],[-73.99587,40.723554]]},{"type":"LineString","coordinates":[[-73.994233,40.724357],[-73.99587,40.723554]]},{"type":"LineString","coordinates":[[-73.995004,40.722523],[-73.99587,40.723554]]},{"type":"LineString","coordinates":[[-74.008474,40.713668],[-74.008561,40.714032]]},{"type":"LineString","coordinates":[[-73.969583,40.762621],[-73.971541,40.764149]]},{"type":"LineString","coordinates":[[-73.995339,40.734007],[-73.99701,40.73241]]},{"type":"LineString","coordinates":[[-73.996365,40.730791],[-73.99701,40.73241]]},{"type":"LineString","coordinates":[[-73.99496,40.732252],[-73.99701,40.73241]]},{"type":"LineString","coordinates":[[-73.993403,40.715047],[-73.995937,40.715121]]},{"type":"LineString","coordinates":[[-73.99506,40.713274],[-73.995937,40.715121]]},{"type":"LineString","coordinates":[[-73.971541,40.749477],[-73.97178,40.75147]]},{"type":"LineString","coordinates":[[-73.982269,40.703024],[-73.982269,40.701261]]},{"type":"LineString","coordinates":[[-73.987688,40.768973],[-73.989896,40.768853]]},{"type":"LineString","coordinates":[[-73.978516,40.717705],[-73.981181,40.718072]]},{"type":"LineString","coordinates":[[-73.984574,40.723031],[-73.986027,40.721745]]},{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.002465,40.735473]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.002465,40.735473]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.002465,40.735473]]},{"type":"LineString","coordinates":[[-73.96894,40.760966],[-73.969583,40.762621]]},{"type":"LineString","coordinates":[[-73.983289,40.75973],[-73.983855,40.761613]]},{"type":"LineString","coordinates":[[-73.988782,40.725368],[-73.991271,40.724802]]},{"type":"LineString","coordinates":[[-73.990386,40.725733],[-73.991271,40.724802]]},{"type":"LineString","coordinates":[[-73.991262,40.726638],[-73.991271,40.724802]]},{"type":"LineString","coordinates":[[-73.989692,40.723971],[-73.991271,40.724802]]},{"type":"LineString","coordinates":[[-73.983193,40.739311],[-73.98446,40.73798]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998082,40.725539]]},{"type":"LineString","coordinates":[[-73.995914,40.725523],[-73.998082,40.725539]]},{"type":"LineString","coordinates":[[-73.996835,40.724545],[-73.998082,40.725539]]},{"type":"LineString","coordinates":[[-74.032801,40.730478],[-74.034947,40.729122]]},{"type":"LineString","coordinates":[[-74.011633,40.703001],[-74.012706,40.703814]]},{"type":"LineString","coordinates":[[-73.975562,40.742678],[-73.976634,40.740683]]},{"type":"LineString","coordinates":[[-74.023429,40.764058],[-74.025103,40.763062]]},{"type":"LineString","coordinates":[[-73.985014,40.726634],[-73.986624,40.726123]]},{"type":"LineString","coordinates":[[-73.986027,40.727621],[-73.986624,40.726123]]},{"type":"LineString","coordinates":[[-73.982665,40.729259],[-73.983847,40.727621]]},{"type":"LineString","coordinates":[[-73.982447,40.72618],[-73.983847,40.727621]]},{"type":"LineString","coordinates":[[-74.002465,40.735473],[-74.002881,40.733836]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.002881,40.733836]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-74.002881,40.733836]]},{"type":"LineString","coordinates":[[-73.982085,40.723376],[-73.984574,40.723031]]},{"type":"LineString","coordinates":[[-73.953334,40.72613],[-73.953334,40.724209]]},{"type":"LineString","coordinates":[[-73.992233,40.734109],[-73.992381,40.734966]]},{"type":"LineString","coordinates":[[-73.992297,40.736539],[-73.992381,40.734966]]},{"type":"LineString","coordinates":[[-73.992076,40.73323],[-73.992381,40.734966]]},{"type":"LineString","coordinates":[[-73.99663,40.737368],[-73.998431,40.737286]]},{"type":"LineString","coordinates":[[-73.997098,40.735596],[-73.998431,40.737286]]},{"type":"LineString","coordinates":[[-73.998059,40.738919],[-73.998431,40.737286]]},{"type":"LineString","coordinates":[[-73.98557,40.731555],[-73.987205,40.731971]]},{"type":"LineString","coordinates":[[-73.985543,40.732946],[-73.987205,40.731971]]},{"type":"LineString","coordinates":[[-73.986624,40.730273],[-73.987205,40.731971]]},{"type":"LineString","coordinates":[[-74.002984,40.726183],[-74.003009,40.728246]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-74.003009,40.728246]]},{"type":"LineString","coordinates":[[-74.002951,40.729126],[-74.003009,40.728246]]},{"type":"LineString","coordinates":[[-74.000765,40.728746],[-74.003009,40.728246]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.003009,40.728246]]},{"type":"LineString","coordinates":[[-73.997192,40.723033],[-73.998277,40.724283]]},{"type":"LineString","coordinates":[[-73.99587,40.723554],[-73.998277,40.724283]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.998277,40.724283]]},{"type":"LineString","coordinates":[[-73.996835,40.724545],[-73.998277,40.724283]]},{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000548,40.734881]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.000548,40.734881]]},{"type":"LineString","coordinates":[[-73.997971,40.734837],[-74.000548,40.734881]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.000548,40.734881]]},{"type":"LineString","coordinates":[[-73.992456,40.724164],[-73.993014,40.72525]]},{"type":"LineString","coordinates":[[-73.991271,40.724802],[-73.993014,40.72525]]},{"type":"LineString","coordinates":[[-73.990386,40.725733],[-73.993014,40.72525]]},{"type":"LineString","coordinates":[[-73.991262,40.726638],[-73.993014,40.72525]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-74.00191,40.725837]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-74.00191,40.725837]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-74.00191,40.725837]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-74.00191,40.725837]]},{"type":"LineString","coordinates":[[-73.993644,40.744647],[-73.99428,40.746001]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.002041,40.731661]]},{"type":"LineString","coordinates":[[-74.001998,40.730348],[-74.002041,40.731661]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-74.002041,40.731661]]},{"type":"LineString","coordinates":[[-73.97527,40.744081],[-73.975562,40.742678]]},{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000626,40.737742]]},{"type":"LineString","coordinates":[[-73.999992,40.739661],[-74.000626,40.737742]]},{"type":"LineString","coordinates":[[-73.998431,40.737286],[-74.000626,40.737742]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.000626,40.737742]]},{"type":"LineString","coordinates":[[-73.986448,40.723868],[-73.987481,40.72365]]},{"type":"LineString","coordinates":[[-73.999323,40.751088],[-73.999632,40.752723]]},{"type":"LineString","coordinates":[[-74.006309,40.726125],[-74.008577,40.72694]]},{"type":"LineString","coordinates":[[-74.007758,40.727767],[-74.008577,40.72694]]},{"type":"LineString","coordinates":[[-74.007423,40.725401],[-74.008577,40.72694]]},{"type":"LineString","coordinates":[[-74.00607,40.727814],[-74.008577,40.72694]]},{"type":"LineString","coordinates":[[-73.956422,40.720989],[-73.956726,40.721515]]},{"type":"LineString","coordinates":[[-73.991236,40.737685],[-73.992297,40.736539]]},{"type":"LineString","coordinates":[[-73.998412,40.727146],[-74.000574,40.72774]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-74.000574,40.72774]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-74.000574,40.72774]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-74.000574,40.72774]]},{"type":"LineString","coordinates":[[-73.973773,40.779799],[-73.974667,40.778444]]},{"type":"LineString","coordinates":[[-73.995339,40.734007],[-73.997971,40.734837]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997971,40.734837]]},{"type":"LineString","coordinates":[[-73.99532,40.735486],[-73.997971,40.734837]]},{"type":"LineString","coordinates":[[-73.997098,40.735596],[-73.997971,40.734837]]},{"type":"LineString","coordinates":[[-73.995931,40.73483],[-73.997971,40.734837]]},{"type":"LineString","coordinates":[[-74.002177,40.714752],[-74.002762,40.713495]]},{"type":"LineString","coordinates":[[-73.983616,40.769491],[-73.984625,40.767977]]},{"type":"LineString","coordinates":[[-73.984239,40.766613],[-73.984625,40.767977]]},{"type":"LineString","coordinates":[[-73.953334,40.724209],[-73.954797,40.723618]]},{"type":"LineString","coordinates":[[-74.002275,40.743193],[-74.003555,40.742337]]},{"type":"LineString","coordinates":[[-73.986008,40.729292],[-73.988627,40.728896]]},{"type":"LineString","coordinates":[[-73.986624,40.730273],[-73.988627,40.728896]]},{"type":"LineString","coordinates":[[-73.988118,40.727513],[-73.988627,40.728896]]},{"type":"LineString","coordinates":[[-73.9876,40.730559],[-73.988627,40.728896]]},{"type":"LineString","coordinates":[[-73.988996,40.74064],[-73.989904,40.739005]]},{"type":"LineString","coordinates":[[-73.987609,40.73925],[-73.989904,40.739005]]},{"type":"LineString","coordinates":[[-73.988487,40.737887],[-73.989904,40.739005]]},{"type":"LineString","coordinates":[[-73.962593,40.711837],[-73.964561,40.712244]]},{"type":"LineString","coordinates":[[-73.994566,40.743104],[-73.997371,40.742783]]},{"type":"LineString","coordinates":[[-73.99641,40.741706],[-73.997371,40.742783]]},{"type":"LineString","coordinates":[[-73.988013,40.734948],[-73.988984,40.735342]]},{"type":"LineString","coordinates":[[-73.988526,40.73673],[-73.988984,40.735342]]},{"type":"LineString","coordinates":[[-73.989893,40.71549],[-73.99233,40.716303]]},{"type":"LineString","coordinates":[[-73.991358,40.717154],[-73.99233,40.716303]]},{"type":"LineString","coordinates":[[-73.998277,40.724283],[-74.000081,40.723949]]},{"type":"LineString","coordinates":[[-73.998766,40.722238],[-74.000081,40.723949]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-74.000081,40.723949]]},{"type":"LineString","coordinates":[[-73.985139,40.755409],[-73.987562,40.755998]]},{"type":"LineString","coordinates":[[-73.992536,40.72157],[-73.993992,40.721459]]},{"type":"LineString","coordinates":[[-73.993398,40.723336],[-73.993992,40.721459]]},{"type":"LineString","coordinates":[[-73.982627,40.70004],[-73.984594,40.699091]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997987,40.729969]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997987,40.729969]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.997987,40.729969]]},{"type":"LineString","coordinates":[[-73.996365,40.730791],[-73.997987,40.729969]]},{"type":"LineString","coordinates":[[-74.005169,40.709257],[-74.005612,40.707159]]},{"type":"LineString","coordinates":[[-73.97997,40.723398],[-73.982085,40.723376]]},{"type":"LineString","coordinates":[[-73.985058,40.717705],[-73.985543,40.71642]]},{"type":"LineString","coordinates":[[-73.956422,40.720989],[-73.957626,40.719274]]},{"type":"LineString","coordinates":[[-74.009586,40.724209],[-74.010978,40.723158]]},{"type":"LineString","coordinates":[[-74.010767,40.724526],[-74.010978,40.723158]]},{"type":"LineString","coordinates":[[-73.98557,40.731555],[-73.986624,40.730273]]},{"type":"LineString","coordinates":[[-73.986008,40.729292],[-73.986624,40.730273]]},{"type":"LineString","coordinates":[[-73.98942,40.719174],[-73.990442,40.720463]]},{"type":"LineString","coordinates":[[-73.988118,40.720022],[-73.990442,40.720463]]},{"type":"LineString","coordinates":[[-73.988208,40.721194],[-73.990442,40.720463]]},{"type":"LineString","coordinates":[[-73.990546,40.730589],[-73.991541,40.72884]]},{"type":"LineString","coordinates":[[-73.989511,40.729594],[-73.991541,40.72884]]},{"type":"LineString","coordinates":[[-73.990356,40.727775],[-73.991541,40.72884]]},{"type":"LineString","coordinates":[[-73.989893,40.71549],[-73.991358,40.717154]]},{"type":"LineString","coordinates":[[-73.969659,40.695769],[-73.970106,40.695972]]},{"type":"LineString","coordinates":[[-74.001998,40.730348],[-74.002951,40.729126]]},{"type":"LineString","coordinates":[[-74.000765,40.728746],[-74.002951,40.729126]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.002951,40.729126]]},{"type":"LineString","coordinates":[[-73.992131,40.743135],[-73.993644,40.744647]]},{"type":"LineString","coordinates":[[-73.991146,40.744559],[-73.993644,40.744647]]},{"type":"LineString","coordinates":[[-73.99428,40.746001],[-73.996487,40.745112]]},{"type":"LineString","coordinates":[[-74.017687,40.688699],[-74.019191,40.688015]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997822,40.731318]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997822,40.731318]]},{"type":"LineString","coordinates":[[-73.996365,40.730791],[-73.997822,40.731318]]},{"type":"LineString","coordinates":[[-73.985888,40.758625],[-73.986526,40.760665]]},{"type":"LineString","coordinates":[[-73.998431,40.737286],[-73.999838,40.736752]]},{"type":"LineString","coordinates":[[-73.994762,40.729396],[-73.996365,40.730791]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.996365,40.730791]]},{"type":"LineString","coordinates":[[-73.99475,40.730559],[-73.996365,40.730791]]},{"type":"LineString","coordinates":[[-73.99496,40.732252],[-73.996365,40.730791]]},{"type":"LineString","coordinates":[[-73.988996,40.74064],[-73.991069,40.742114]]},{"type":"LineString","coordinates":[[-73.988918,40.743416],[-73.991069,40.742114]]},{"type":"LineString","coordinates":[[-73.987846,40.741939],[-73.988918,40.743416]]},{"type":"LineString","coordinates":[[-73.988918,40.745337],[-73.988918,40.743416]]},{"type":"LineString","coordinates":[[-73.989431,40.726608],[-73.990386,40.725733]]},{"type":"LineString","coordinates":[[-73.988782,40.725368],[-73.990386,40.725733]]},{"type":"LineString","coordinates":[[-73.990356,40.727775],[-73.990386,40.725733]]},{"type":"LineString","coordinates":[[-73.989692,40.723971],[-73.990386,40.725733]]},{"type":"LineString","coordinates":[[-73.986006,40.73647],[-73.988013,40.734948]]},{"type":"LineString","coordinates":[[-73.965723,40.767336],[-73.967012,40.766321]]},{"type":"LineString","coordinates":[[-73.965726,40.764666],[-73.967012,40.766321]]},{"type":"LineString","coordinates":[[-73.99663,40.737368],[-73.998059,40.738919]]},{"type":"LineString","coordinates":[[-73.995872,40.739814],[-73.998059,40.738919]]},{"type":"LineString","coordinates":[[-73.989511,40.729594],[-73.990356,40.727775]]},{"type":"LineString","coordinates":[[-73.989431,40.726608],[-73.990356,40.727775]]},{"type":"LineString","coordinates":[[-73.988627,40.728896],[-73.990356,40.727775]]},{"type":"LineString","coordinates":[[-73.988118,40.727513],[-73.990356,40.727775]]},{"type":"LineString","coordinates":[[-73.96422,40.765069],[-73.965726,40.764666]]},{"type":"LineString","coordinates":[[-73.986027,40.721745],[-73.986448,40.723868]]},{"type":"LineString","coordinates":[[-73.984574,40.723031],[-73.986448,40.723868]]},{"type":"LineString","coordinates":[[-73.992233,40.734109],[-73.993946,40.733867]]},{"type":"LineString","coordinates":[[-73.992381,40.734966],[-73.993946,40.733867]]},{"type":"LineString","coordinates":[[-73.992076,40.73323],[-73.993946,40.733867]]},{"type":"LineString","coordinates":[[-73.993221,40.732218],[-73.993946,40.733867]]},{"type":"LineString","coordinates":[[-73.98657,40.737982],[-73.987609,40.73925]]},{"type":"LineString","coordinates":[[-73.986666,40.740788],[-73.987609,40.73925]]},{"type":"LineString","coordinates":[[-73.985861,40.739275],[-73.987609,40.73925]]},{"type":"LineString","coordinates":[[-73.964561,40.712244],[-73.966528,40.712515]]},{"type":"LineString","coordinates":[[-73.996548,40.747117],[-73.998244,40.748285]]},{"type":"LineString","coordinates":[[-74.001636,40.747],[-74.001677,40.748774]]},{"type":"LineString","coordinates":[[-74.023429,40.764058],[-74.024625,40.765326]]},{"type":"LineString","coordinates":[[-74.02319,40.76605],[-74.024625,40.765326]]},{"type":"LineString","coordinates":[[-73.991541,40.72884],[-73.992697,40.727907]]},{"type":"LineString","coordinates":[[-73.990356,40.727775],[-73.992697,40.727907]]},{"type":"LineString","coordinates":[[-73.991262,40.726638],[-73.992697,40.727907]]},{"type":"LineString","coordinates":[[-74.005313,40.724104],[-74.007423,40.725401]]},{"type":"LineString","coordinates":[[-74.006309,40.726125],[-74.007423,40.725401]]},{"type":"LineString","coordinates":[[-74.007149,40.724135],[-74.007423,40.725401]]},{"type":"LineString","coordinates":[[-74.005101,40.725391],[-74.007423,40.725401]]},{"type":"LineString","coordinates":[[-73.993398,40.723336],[-73.994233,40.724357]]},{"type":"LineString","coordinates":[[-73.992456,40.724164],[-73.994233,40.724357]]},{"type":"LineString","coordinates":[[-73.993014,40.72525],[-73.994233,40.724357]]},{"type":"LineString","coordinates":[[-74.006309,40.726125],[-74.008896,40.725431]]},{"type":"LineString","coordinates":[[-74.007149,40.724135],[-74.008896,40.725431]]},{"type":"LineString","coordinates":[[-74.008577,40.72694],[-74.008896,40.725431]]},{"type":"LineString","coordinates":[[-74.007423,40.725401],[-74.008896,40.725431]]},{"type":"LineString","coordinates":[[-73.992417,40.730348],[-73.99475,40.730559]]},{"type":"LineString","coordinates":[[-73.993221,40.732218],[-73.99475,40.730559]]},{"type":"LineString","coordinates":[[-73.992193,40.73137],[-73.99475,40.730559]]},{"type":"LineString","coordinates":[[-73.99318,40.728953],[-73.99475,40.730559]]},{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.999568,40.727056]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.999568,40.727056]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.999568,40.727056]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.999568,40.727056]]},{"type":"LineString","coordinates":[[-73.992812,40.712747],[-73.99506,40.713274]]},{"type":"LineString","coordinates":[[-73.959426,40.765932],[-73.960198,40.763984]]},{"type":"LineString","coordinates":[[-74.003721,40.73442],[-74.005327,40.73427]]},{"type":"LineString","coordinates":[[-74.002881,40.733836],[-74.005327,40.73427]]},{"type":"LineString","coordinates":[[-74.004562,40.732376],[-74.005327,40.73427]]},{"type":"LineString","coordinates":[[-74.004147,40.73354],[-74.005327,40.73427]]},{"type":"LineString","coordinates":[[-74.004622,40.735257],[-74.005327,40.73427]]},{"type":"LineString","coordinates":[[-73.988619,40.762866],[-73.991306,40.763584]]},{"type":"LineString","coordinates":[[-73.950941,40.725705],[-73.953334,40.72613]]},{"type":"LineString","coordinates":[[-74.003571,40.731504],[-74.003838,40.730224]]},{"type":"LineString","coordinates":[[-74.003009,40.728246],[-74.003838,40.730224]]},{"type":"LineString","coordinates":[[-74.002041,40.731661],[-74.003838,40.730224]]},{"type":"LineString","coordinates":[[-74.002951,40.729126],[-74.003838,40.730224]]},{"type":"LineString","coordinates":[[-74.001998,40.730348],[-74.003838,40.730224]]},{"type":"LineString","coordinates":[[-73.99428,40.746001],[-73.996548,40.747117]]},{"type":"LineString","coordinates":[[-73.996487,40.745112],[-73.996548,40.747117]]},{"type":"LineString","coordinates":[[-73.995251,40.726477],[-73.995914,40.725523]]},{"type":"LineString","coordinates":[[-73.99352,40.726555],[-73.995914,40.725523]]},{"type":"LineString","coordinates":[[-73.99587,40.723554],[-73.995914,40.725523]]},{"type":"LineString","coordinates":[[-73.994233,40.724357],[-73.995914,40.725523]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.001998,40.730348]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.001998,40.730348]]},{"type":"LineString","coordinates":[[-74.000765,40.728746],[-74.001998,40.730348]]},{"type":"LineString","coordinates":[[-73.960198,40.763984],[-73.961976,40.763153]]},{"type":"LineString","coordinates":[[-73.989503,40.732484],[-73.992076,40.73323]]},{"type":"LineString","coordinates":[[-73.9908,40.732768],[-73.992076,40.73323]]},{"type":"LineString","coordinates":[[-73.990108,40.731706],[-73.992076,40.73323]]},{"type":"LineString","coordinates":[[-73.94036,40.751226],[-73.942774,40.75072]]},{"type":"LineString","coordinates":[[-73.997192,40.723033],[-73.998766,40.722238]]},{"type":"LineString","coordinates":[[-73.998277,40.724283],[-73.998766,40.722238]]},{"type":"LineString","coordinates":[[-73.986027,40.721745],[-73.986375,40.719771]]},{"type":"LineString","coordinates":[[-73.995872,40.739814],[-73.998336,40.740657]]},{"type":"LineString","coordinates":[[-73.998059,40.738919],[-73.998336,40.740657]]},{"type":"LineString","coordinates":[[-73.99641,40.741706],[-73.998336,40.740657]]},{"type":"LineString","coordinates":[[-73.992131,40.743135],[-73.994566,40.743104]]},{"type":"LineString","coordinates":[[-73.993542,40.741255],[-73.994566,40.743104]]},{"type":"LineString","coordinates":[[-73.993644,40.744647],[-73.994566,40.743104]]},{"type":"LineString","coordinates":[[-73.992536,40.72157],[-73.995004,40.722523]]},{"type":"LineString","coordinates":[[-73.993398,40.723336],[-73.995004,40.722523]]},{"type":"LineString","coordinates":[[-73.993992,40.721459],[-73.995004,40.722523]]},{"type":"LineString","coordinates":[[-73.994233,40.724357],[-73.995004,40.722523]]},{"type":"LineString","coordinates":[[-74.009586,40.724209],[-74.010767,40.724526]]},{"type":"LineString","coordinates":[[-74.009905,40.726276],[-74.010767,40.724526]]},{"type":"LineString","coordinates":[[-74.008896,40.725431],[-74.010767,40.724526]]},{"type":"LineString","coordinates":[[-74.002984,40.726183],[-74.004522,40.725944]]},{"type":"LineString","coordinates":[[-74.004449,40.727157],[-74.004522,40.725944]]},{"type":"LineString","coordinates":[[-74.00191,40.725837],[-74.004522,40.725944]]},{"type":"LineString","coordinates":[[-74.003372,40.724634],[-74.004522,40.725944]]},{"type":"LineString","coordinates":[[-74.002459,40.727111],[-74.004522,40.725944]]},{"type":"LineString","coordinates":[[-73.996745,40.718879],[-73.998862,40.718077]]},{"type":"LineString","coordinates":[[-74.003571,40.731504],[-74.004562,40.732376]]},{"type":"LineString","coordinates":[[-74.003721,40.73442],[-74.004562,40.732376]]},{"type":"LineString","coordinates":[[-74.002881,40.733836],[-74.004562,40.732376]]},{"type":"LineString","coordinates":[[-74.002041,40.731661],[-74.004562,40.732376]]},{"type":"LineString","coordinates":[[-74.004147,40.73354],[-74.004562,40.732376]]},{"type":"LineString","coordinates":[[-74.009135,40.719669],[-74.009781,40.718077]]},{"type":"LineString","coordinates":[[-73.999992,40.739661],[-74.002303,40.739491]]},{"type":"LineString","coordinates":[[-74.001329,40.740687],[-74.002303,40.739491]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.002303,40.739491]]},{"type":"LineString","coordinates":[[-74.002984,40.726183],[-74.003372,40.724634]]},{"type":"LineString","coordinates":[[-74.00191,40.725837],[-74.003372,40.724634]]},{"type":"LineString","coordinates":[[-73.988984,40.735342],[-73.989289,40.733751]]},{"type":"LineString","coordinates":[[-73.988013,40.734948],[-73.989289,40.733751]]},{"type":"LineString","coordinates":[[-73.993992,40.721459],[-73.996224,40.720805]]},{"type":"LineString","coordinates":[[-73.995004,40.722523],[-73.996224,40.720805]]},{"type":"LineString","coordinates":[[-73.992467,40.755707],[-73.992539,40.757862]]},{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.999786,40.725565]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.999786,40.725565]]},{"type":"LineString","coordinates":[[-73.998277,40.724283],[-73.999786,40.725565]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.999786,40.725565]]},{"type":"LineString","coordinates":[[-74.003571,40.731504],[-74.004147,40.73354]]},{"type":"LineString","coordinates":[[-74.003721,40.73442],[-74.004147,40.73354]]},{"type":"LineString","coordinates":[[-74.002881,40.733836],[-74.004147,40.73354]]},{"type":"LineString","coordinates":[[-73.990546,40.730589],[-73.992417,40.730348]]},{"type":"LineString","coordinates":[[-73.991541,40.72884],[-73.992417,40.730348]]},{"type":"LineString","coordinates":[[-73.992193,40.73137],[-73.992417,40.730348]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.000765,40.728746]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-74.000765,40.728746]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-74.000765,40.728746]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-74.000765,40.728746]]},{"type":"LineString","coordinates":[[-74.003721,40.73442],[-74.004622,40.735257]]},{"type":"LineString","coordinates":[[-74.002465,40.735473],[-74.004622,40.735257]]},{"type":"LineString","coordinates":[[-74.002881,40.733836],[-74.004622,40.735257]]},{"type":"LineString","coordinates":[[-74.004147,40.73354],[-74.004622,40.735257]]},{"type":"LineString","coordinates":[[-74.002762,40.713495],[-74.003639,40.715417]]},{"type":"LineString","coordinates":[[-74.002177,40.714752],[-74.003639,40.715417]]},{"type":"LineString","coordinates":[[-73.983377,40.765145],[-73.984239,40.766613]]},{"type":"LineString","coordinates":[[-73.984327,40.735805],[-73.984434,40.7347]]},{"type":"LineString","coordinates":[[-73.99587,40.723554],[-73.996835,40.724545]]},{"type":"LineString","coordinates":[[-73.994233,40.724357],[-73.996835,40.724545]]},{"type":"LineString","coordinates":[[-73.995914,40.725523],[-73.996835,40.724545]]},{"type":"LineString","coordinates":[[-74.0042,40.716787],[-74.006867,40.717325]]},{"type":"LineString","coordinates":[[-73.986027,40.727621],[-73.988118,40.727513]]},{"type":"LineString","coordinates":[[-73.986624,40.726123],[-73.988118,40.727513]]},{"type":"LineString","coordinates":[[-73.971541,40.764149],[-73.972926,40.762621]]},{"type":"LineString","coordinates":[[-73.983497,40.773113],[-73.986048,40.772344]]},{"type":"LineString","coordinates":[[-73.994221,40.735535],[-73.995931,40.73483]]},{"type":"LineString","coordinates":[[-73.995339,40.734007],[-73.995931,40.73483]]},{"type":"LineString","coordinates":[[-73.99532,40.735486],[-73.995931,40.73483]]},{"type":"LineString","coordinates":[[-73.993946,40.733867],[-73.995931,40.73483]]},{"type":"LineString","coordinates":[[-73.98446,40.73798],[-73.985861,40.739275]]},{"type":"LineString","coordinates":[[-73.983193,40.739311],[-73.985861,40.739275]]},{"type":"LineString","coordinates":[[-73.9908,40.732768],[-73.993221,40.732218]]},{"type":"LineString","coordinates":[[-73.992233,40.734109],[-73.993221,40.732218]]},{"type":"LineString","coordinates":[[-73.992076,40.73323],[-73.993221,40.732218]]},{"type":"LineString","coordinates":[[-73.992417,40.730348],[-73.993221,40.732218]]},{"type":"LineString","coordinates":[[-73.992193,40.73137],[-73.993221,40.732218]]},{"type":"LineString","coordinates":[[-73.979485,40.73313],[-73.980534,40.732114]]},{"type":"LineString","coordinates":[[-74.004685,40.728356],[-74.00607,40.727814]]},{"type":"LineString","coordinates":[[-74.004449,40.727157],[-74.00607,40.727814]]},{"type":"LineString","coordinates":[[-73.987205,40.731971],[-73.988948,40.730902]]},{"type":"LineString","coordinates":[[-73.988627,40.728896],[-73.988948,40.730902]]},{"type":"LineString","coordinates":[[-73.986624,40.730273],[-73.988948,40.730902]]},{"type":"LineString","coordinates":[[-73.9876,40.730559],[-73.988948,40.730902]]},{"type":"LineString","coordinates":[[-73.981801,40.736694],[-73.984327,40.735805]]},{"type":"LineString","coordinates":[[-73.99624,40.753541],[-73.996446,40.755526]]},{"type":"LineString","coordinates":[[-74.00191,40.725837],[-74.002459,40.727111]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-74.002459,40.727111]]},{"type":"LineString","coordinates":[[-74.000765,40.728746],[-74.002459,40.727111]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-74.002459,40.727111]]},{"type":"LineString","coordinates":[[-73.952555,40.73433],[-73.954504,40.735586]]},{"type":"LineString","coordinates":[[-73.998676,40.732548],[-74.000762,40.732961]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.000762,40.732961]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.000762,40.732961]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000762,40.732961]]},{"type":"LineString","coordinates":[[-73.98557,40.731555],[-73.9876,40.730559]]},{"type":"LineString","coordinates":[[-73.986008,40.729292],[-73.9876,40.730559]]},{"type":"LineString","coordinates":[[-73.987205,40.731971],[-73.9876,40.730559]]},{"type":"LineString","coordinates":[[-73.986624,40.730273],[-73.9876,40.730559]]},{"type":"LineString","coordinates":[[-73.986624,40.726123],[-73.987839,40.724556]]},{"type":"LineString","coordinates":[[-73.987481,40.72365],[-73.987839,40.724556]]},{"type":"LineString","coordinates":[[-73.986448,40.723868],[-73.987839,40.724556]]},{"type":"LineString","coordinates":[[-73.998412,40.727146],[-74.00047,40.726141]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-74.00047,40.726141]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-74.00047,40.726141]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-74.00047,40.726141]]},{"type":"LineString","coordinates":[[-73.989431,40.726608],[-73.991262,40.726638]]},{"type":"LineString","coordinates":[[-73.990386,40.725733],[-73.991262,40.726638]]},{"type":"LineString","coordinates":[[-73.990356,40.727775],[-73.991262,40.726638]]},{"type":"LineString","coordinates":[[-74.006609,40.71216],[-74.008474,40.713668]]},{"type":"LineString","coordinates":[[-73.988118,40.722853],[-73.989692,40.723971]]},{"type":"LineString","coordinates":[[-73.988782,40.725368],[-73.989692,40.723971]]},{"type":"LineString","coordinates":[[-73.987481,40.72365],[-73.989692,40.723971]]},{"type":"LineString","coordinates":[[-73.987839,40.724556],[-73.989692,40.723971]]},{"type":"LineString","coordinates":[[-73.982899,40.778274],[-73.983975,40.776282]]},{"type":"LineString","coordinates":[[-73.991929,40.739312],[-73.994352,40.73854]]},{"type":"LineString","coordinates":[[-73.992798,40.737555],[-73.994352,40.73854]]},{"type":"LineString","coordinates":[[-74.005327,40.73427],[-74.006076,40.736251]]},{"type":"LineString","coordinates":[[-74.004622,40.735257],[-74.006076,40.736251]]},{"type":"LineString","coordinates":[[-73.965726,40.762037],[-73.966639,40.763153]]},{"type":"LineString","coordinates":[[-73.965726,40.764666],[-73.966639,40.763153]]},{"type":"LineString","coordinates":[[-74.007656,40.719698],[-74.008899,40.720808]]},{"type":"LineString","coordinates":[[-73.993946,40.733867],[-73.99496,40.732252]]},{"type":"LineString","coordinates":[[-73.99475,40.730559],[-73.99496,40.732252]]},{"type":"LineString","coordinates":[[-73.993221,40.732218],[-73.99496,40.732252]]},{"type":"LineString","coordinates":[[-73.967783,40.760284],[-73.96894,40.760966]]},{"type":"LineString","coordinates":[[-73.967783,40.760284],[-73.969969,40.759115]]},{"type":"LineString","coordinates":[[-73.96894,40.760966],[-73.969969,40.759115]]},{"type":"LineString","coordinates":[[-73.990546,40.730589],[-73.992193,40.73137]]},{"type":"LineString","coordinates":[[-73.9908,40.732768],[-73.992193,40.73137]]},{"type":"LineString","coordinates":[[-73.992076,40.73323],[-73.992193,40.73137]]},{"type":"LineString","coordinates":[[-73.990108,40.731706],[-73.992193,40.73137]]},{"type":"LineString","coordinates":[[-73.991541,40.72884],[-73.99318,40.728953]]},{"type":"LineString","coordinates":[[-73.992697,40.727907],[-73.99318,40.728953]]},{"type":"LineString","coordinates":[[-73.992417,40.730348],[-73.99318,40.728953]]},{"type":"LineString","coordinates":[[-73.988118,40.722853],[-73.988208,40.721194]]},{"type":"LineString","coordinates":[[-73.988118,40.720022],[-73.988208,40.721194]]},{"type":"LineString","coordinates":[[-73.986027,40.721745],[-73.988208,40.721194]]},{"type":"LineString","coordinates":[[-73.986375,40.719771],[-73.988208,40.721194]]},{"type":"LineString","coordinates":[[-74.003639,40.715417],[-74.0042,40.716787]]},{"type":"LineString","coordinates":[[-73.98657,40.737982],[-73.988487,40.737887]]},{"type":"LineString","coordinates":[[-73.987609,40.73925],[-73.988487,40.737887]]},{"type":"LineString","coordinates":[[-73.981679,40.739408],[-73.983193,40.739311]]},{"type":"LineString","coordinates":[[-73.98657,40.737982],[-73.988526,40.73673]]},{"type":"LineString","coordinates":[[-73.986006,40.73647],[-73.988526,40.73673]]},{"type":"LineString","coordinates":[[-73.988013,40.734948],[-73.988526,40.73673]]},{"type":"LineString","coordinates":[[-73.988487,40.737887],[-73.988526,40.73673]]},{"type":"LineString","coordinates":[[-74.001677,40.748774],[-74.003644,40.749316]]},{"type":"LineString","coordinates":[[-73.989511,40.729594],[-73.990108,40.731706]]},{"type":"LineString","coordinates":[[-73.989503,40.732484],[-73.990108,40.731706]]},{"type":"LineString","coordinates":[[-73.989289,40.733751],[-73.990108,40.731706]]},{"type":"LineString","coordinates":[[-73.988948,40.730902],[-73.990108,40.731706]]},{"type":"LineString","coordinates":[[-73.996224,40.720805],[-73.996745,40.718879]]},{"type":"LineString","coordinates":[[-73.995872,40.739814],[-73.99641,40.741706]]},{"type":"LineString","coordinates":[[-73.994566,40.743104],[-73.99641,40.741706]]}]}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = {"type":"LineString","coordinates":[[-73.999188,40.726481],[-73.99917946068226,40.72649111754119],[-73.99917092136407,40.72650123507186],[-73.99916238204538,40.72651135259201],[-73.99915384272623,40.726521470101645],[-73.99914530340656,40.72653158760077],[-73.99913676408647,40.72654170508937],[-73.99912822476587,40.72655182256746],[-73.99911968544484,40.72656194003502],[-73.99911114612331,40.72657205749208],[-73.99910260680132,40.72658217493861],[-73.99909406747882,40.726592292374626],[-73.99908552815592,40.72660240980013],[-73.99907698883247,40.72661252721512],[-73.99906844950857,40.72662264461959],[-73.99905991018422,40.72663276201354],[-73.99905137085936,40.72664287939698],[-73.99904283153407,40.72665299676989],[-73.99903429220826,40.72666311413229],[-73.999025752882,40.72667323148418],[-73.99901721355528,40.726683348825546],[-73.99900867422805,40.7266934661564],[-73.99900013490038,40.72670358347674],[-73.99899159557225,40.72671370078656],[-73.99898305624359,40.726723818085866],[-73.99897451691452,40.726733935374654],[-73.99896597758492,40.72674405265292],[-73.99895743825488,40.72675416992067],[-73.99894889892434,40.72676428717791],[-73.99894035959335,40.72677440442463],[-73.99893182026187,40.72678452166084],[-73.99892328092994,40.726794638886524],[-73.99891474159752,40.72680475610169],[-73.99890620226464,40.72681487330635],[-73.99889766293127,40.72682499050049],[-73.99888912359742,40.72683510768411],[-73.99888058426315,40.726845224857215],[-73.99887204492835,40.72685534201981],[-73.99886350559308,40.72686545917188],[-73.99885496625737,40.72687557631345],[-73.99884642692116,40.72688569344448],[-73.99883788758449,40.726895810565004],[-73.99882934824736,40.72690592767502],[-73.99882080890971,40.72691604477451],[-73.99881226957162,40.72692616186348],[-73.99880373023304,40.72693627894195],[-73.99879519089401,40.72694639600989],[-73.9987866515545,40.72695651306732],[-73.99877811221451,40.726966630114234],[-73.99876957287404,40.72697674715063],[-73.9987610335331,40.72698686417651],[-73.99875249419172,40.726996981191874],[-73.99874395484983,40.72700709819672],[-73.99873541550747,40.727017215191054],[-73.99872687616462,40.72702733217487],[-73.99871833682134,40.72703744914817],[-73.99870979747753,40.727047566110954],[-73.99870125813331,40.72705768306322],[-73.99869271878858,40.727067800004974],[-73.99868417944339,40.72707791693621],[-73.99867564009772,40.72708803385693],[-73.99866710075159,40.72709815076714],[-73.99865856140494,40.72710826766683],[-73.99865002205787,40.727118384556],[-73.9986414827103,40.727128501434656],[-73.99863294336225,40.727138618302796],[-73.99862440401375,40.727148735160426],[-73.99861586466479,40.727158852007534],[-73.99860732531532,40.727168968844126],[-73.99859878596536,40.72717908567021],[-73.99859024661497,40.72718920248577],[-73.99858170726408,40.72719931929081],[-73.99857316791275,40.727209436085346],[-73.99856462856093,40.72721955286936],[-73.99855608920865,40.72722966964286],[-73.99854754985586,40.727239786405846],[-73.99853901050263,40.72724990315832],[-73.9985304711489,40.727260019900264],[-73.99852193179473,40.7272701366317],[-73.99851339244005,40.727280253352625],[-73.99850485308494,40.72729037006303],[-73.9984963137293,40.72730048676292],[-73.99848777437325,40.727310603452295],[-73.99847923501666,40.727320720131154],[-73.99847069565966,40.727330836799496],[-73.99846215630211,40.72734095345733],[-73.99845361694416,40.72735107010464],[-73.99844507758571,40.72736118674143],[-73.99843653822678,40.72737130336772],[-73.9984279988674,40.72738141998349],[-73.99841945950752,40.72739153658873],[-73.99841092014718,40.72740165318348],[-73.99840238078639,40.72741176976769],[-73.99839384142507,40.727421886341396],[-73.99838530206331,40.727432002904585],[-73.99837676270108,40.727442119457265],[-73.99836822333836,40.72745223599942],[-73.99835968397518,40.72746235253106],[-73.99835114461153,40.72747246905219],[-73.9983426052474,40.727482585562804],[-73.99833406588282,40.727492702062904],[-73.99832552651773,40.72750281855249],[-73.99831698715217,40.727512935031555],[-73.99830844778614,40.72752305150011],[-73.99829990841963,40.72753316795814],[-73.99829136905268,40.72754328440567],[-73.99828282968524,40.72755340084267],[-73.99827429031731,40.72756351726916],[-73.99826575094893,40.72757363368514],[-73.99825721158005,40.7275837500906],[-73.99824867221075,40.72759386648554],[-73.9982401328409,40.72760398286998],[-73.99823159347065,40.727614099243894],[-73.99822305409988,40.72762421560729],[-73.99821451472866,40.72763433196018],[-73.99820597535697,40.727644448302556],[-73.99819743598478,40.72765456463441],[-73.99818889661215,40.72766468095575],[-73.998180357239,40.72767479726657],[-73.998176,40.72768],[-73.998176,40.72768],[-73.998175,40.727682],[-73.998175,40.727682],[-73.998175,40.727684],[-73.998175,40.727684],[-73.99818390098454,40.72768839884058],[-73.998192801969,40.72769279768591],[-73.99820170295341,40.72769719653601],[-73.99821060393772,40.727701595390876],[-73.99821950492186,40.72770599425051],[-73.99822840590599,40.72771039311491],[-73.99823730689,40.72771479198408],[-73.99824620787395,40.727719190858004],[-73.99825510885778,40.727723589736705],[-73.99826400984153,40.72772798862017],[-73.99827291082516,40.7277323875084],[-73.99828181180875,40.727736786401394],[-73.99829071279224,40.72774118529915],[-73.99829961377563,40.72774558420168],[-73.99830851475893,40.727749983108964],[-73.99831741574215,40.727754382021025],[-73.99832631672531,40.72775878093785],[-73.99833521770832,40.72776317985944],[-73.99834411869128,40.727767578785794],[-73.99835301967413,40.72777197771691],[-73.99836192065688,40.7277763766528],[-73.99837082163955,40.72778077559345],[-73.99837972262215,40.72778517453887],[-73.99838862360461,40.727789573489055],[-73.99839752458705,40.72779397244401],[-73.99840642556939,40.72779837140373],[-73.99841532655158,40.72780277036821],[-73.99842422753372,40.72780716933745],[-73.9984331285158,40.72781156831147],[-73.99844202949774,40.727815967290255],[-73.99845093047959,40.727820366273804],[-73.9984598314614,40.72782476526211],[-73.99846873244309,40.72782916425519],[-73.99847763342468,40.72783356325304],[-73.99848653440621,40.72783796225565],[-73.9984954353876,40.72784236126303],[-73.99850433636892,40.72784676027517],[-73.9985132373502,40.72785115929208],[-73.99852213833134,40.727855558313756],[-73.99853103931241,40.72785995734019],[-73.99853994029341,40.727864356371406],[-73.99854884127427,40.72786875540738],[-73.99855774225506,40.72787315444812],[-73.99856664323579,40.72787755349363],[-73.99857554421637,40.727881952543896],[-73.99858444519694,40.72788635159893],[-73.99859334617739,40.727890750658744],[-73.9986022471577,40.72789514972331],[-73.99861114813797,40.72789954879265],[-73.99862004911814,40.72790394786675],[-73.99862895009822,40.72790834694562],[-73.99863785107823,40.727912746029254],[-73.99864675205812,40.72791714511765],[-73.99865565303791,40.72792154421082],[-73.99866455401767,40.72792594330876],[-73.99867345499729,40.727930342411454],[-73.99868235597683,40.72793474151892],[-73.99869125695628,40.72793914063116],[-73.99870015793564,40.72794353974816],[-73.99870905891493,40.727947938869924],[-73.99871795989412,40.727952337996456],[-73.9987268608732,40.727956737127755],[-73.9987357618522,40.727961136263815],[-73.99874466283113,40.72796553540464],[-73.99875356380998,40.72796993455024],[-73.99876246478868,40.72797433370061],[-73.99877136576735,40.72797873285574],[-73.99878026674591,40.72798313201563],[-73.99878916772435,40.72798753118029],[-73.99879806870275,40.72799193034972],[-73.99880696968106,40.72799632952391],[-73.99881587065923,40.72800072870288],[-73.99882477163737,40.728005127886604],[-73.9988336726154,40.728009527075095],[-73.99884257359331,40.72801392626836],[-73.99885147457117,40.72801832546638],[-73.99886037554892,40.728022724669174],[-73.99886927652656,40.728027123876736],[-73.99887817750414,40.72803152308906],[-73.99888707848162,40.728035922306155],[-73.99889597945902,40.72804032152801],[-73.99890488043634,40.72804472075464],[-73.99891378141355,40.728049119986025],[-73.99892268239068,40.728053519222186],[-73.99893158336772,40.72805791846311],[-73.99894048434466,40.7280623177088],[-73.99894938532154,40.72806671695926],[-73.998952,40.728068],[-73.998952,40.728068],[-73.998953,40.728069],[-73.998953,40.728069],[-73.998952,40.72807],[-73.998952,40.72807],[-73.99894346418061,40.7280801561723],[-73.99893492836077,40.72809031233404],[-73.99892639254048,40.72810046848524],[-73.99891785671966,40.72811062462588],[-73.99890932089838,40.728120780755965],[-73.99890078507663,40.7281309368755],[-73.99889224925438,40.72814109298449],[-73.99888371343167,40.72815124908291],[-73.9988751776085,40.728161405170795],[-73.99886664178483,40.72817156124812],[-73.99885810596068,40.7281817173149],[-73.99884957013606,40.72819187337111],[-73.99884103431098,40.728202029416785],[-73.99883249848541,40.7282121854519],[-73.99882396265936,40.72822234147647],[-73.99881542683283,40.72823249749048],[-73.99880689100584,40.728242653493936],[-73.99879835517835,40.72825280948685],[-73.99878981935039,40.7282629654692],[-73.99878128352195,40.728273121441],[-73.99877274769305,40.728283277402255],[-73.99876421186367,40.72829343335295],[-73.9987556760338,40.7283035892931],[-73.99874714020343,40.72831374522269],[-73.99873860437263,40.728323901141735],[-73.99873006854132,40.728334057050226],[-73.99872153270955,40.728344212948166],[-73.9987129968773,40.728354368835554],[-73.99870446104458,40.72836452471238],[-73.99869592521136,40.72837468057867],[-73.9986873893777,40.728384836434394],[-73.99867885354352,40.728394992279576],[-73.99867031770891,40.7284051481142],[-73.99866178187378,40.72841530393828],[-73.99865324603817,40.7284254597518],[-73.99864471020211,40.728435615554766],[-73.9986361743656,40.72844577134718],[-73.99862763852857,40.728455927129055],[-73.99861910269108,40.72846608290036],[-73.9986105668531,40.72847623866113],[-73.99860203101464,40.728486394411334],[-73.99859349517571,40.72849655015099],[-73.99858495933631,40.7285067058801],[-73.99857642349643,40.728516861598656],[-73.99856788765608,40.72852701730666],[-73.99855935181525,40.72853717300411],[-73.99855081597391,40.728547328691015],[-73.99854228013213,40.72855748436736],[-73.99853374428984,40.72856764003315],[-73.9985252084471,40.7285777956884],[-73.99852,40.728584],[-73.99852,40.728584],[-73.99851144161836,40.72859390287498],[-73.99850288323626,40.72860380573964],[-73.99849432485372,40.72861370859399],[-73.99848576647071,40.72862361143802],[-73.99847720808724,40.72863351427173],[-73.99846864970333,40.72864341709513],[-73.99846009131896,40.72865331990821],[-73.99845153293417,40.72866322271098],[-73.99844297454888,40.72867312550343],[-73.99843441616315,40.728683028285566],[-73.99842585777695,40.728692931057374],[-73.99841729939035,40.728702833818886],[-73.99840874100325,40.72871273657007],[-73.99840018261573,40.72872263931094],[-73.99839162422774,40.728732542041485],[-73.99838306583928,40.72874244476173],[-73.9983745074504,40.72875234747165],[-73.99836594906103,40.72876225017126],[-73.99835739067122,40.72877215286054],[-73.99834883228095,40.72878205553952],[-73.99834027389025,40.72879195820817],[-73.99833171549909,40.72880186086652],[-73.99832315710745,40.72881176351454],[-73.99831459871538,40.72882166615226],[-73.99830604032286,40.72883156877965],[-73.99829748192988,40.72884147139672],[-73.99828892353645,40.72885137400349],[-73.99828036514255,40.72886127659993],[-73.9982718067482,40.728871179186065],[-73.99826324835338,40.72888108176188],[-73.998259,40.728886],[-73.998259,40.728886],[-73.99825042625271,40.72889572623743],[-73.99824185250502,40.728905452464716],[-73.99823327875689,40.72891517868185],[-73.9982247050083,40.728924904888835],[-73.99821613125924,40.72893463108567],[-73.99820755750982,40.728944357272354],[-73.99819898375989,40.72895408344888],[-73.99819041000958,40.72896380961527],[-73.9981818362588,40.7289735357715],[-73.99817326250758,40.728983261917584],[-73.99816468875594,40.72899298805352],[-73.99815611500385,40.7290027141793],[-73.99814754125133,40.72901244029493],[-73.99813896749836,40.72902216640041],[-73.99813039374497,40.72903189249575],[-73.99812181999113,40.72904161858092],[-73.99811324623688,40.72905134465596],[-73.99810467248217,40.729061070720846],[-73.99809609872702,40.729070796775574],[-73.99808752497144,40.729080522820155],[-73.9980789512154,40.72909024885459],[-73.99807037745894,40.72909997487887],[-73.99806180370204,40.729109700893005],[-73.9980532299447,40.729119426896986],[-73.99804465618695,40.72912915289082],[-73.99803608242873,40.7291388788745],[-73.99802750867008,40.729148604848035],[-73.99801893491099,40.72915833081142],[-73.99801036115149,40.72916805676466],[-73.9980017873915,40.72917778270774],[-73.9979932136311,40.72918750864067],[-73.99798463987028,40.72919723456346],[-73.997976066109,40.72920696047609],[-73.99796749234731,40.72921668637858],[-73.99795891858516,40.729226412270904],[-73.99795034482254,40.72923613815309],[-73.9979417710595,40.72924586402513],[-73.99793319729608,40.72925558988702],[-73.99792462353217,40.72926531573875],[-73.99791604976784,40.72927504158034],[-73.99790747600309,40.72928476741178],[-73.99789890223788,40.72929449323306],[-73.99789032847221,40.729304219044195],[-73.997887,40.729308],[-73.997887,40.729308],[-73.997886,40.729309],[-73.997886,40.729309],[-73.997887,40.72931],[-73.997887,40.72931],[-73.99789589848217,40.72931446488736],[-73.99790479696426,40.72931892977955],[-73.9979136954463,40.72932339467659],[-73.99792259392821,40.729327859578454],[-73.99793149240999,40.729332324485156],[-73.99794039089173,40.7293367893967],[-73.99794928937335,40.72934125431307],[-73.99795818785492,40.72934571923428],[-73.99796708633635,40.72935018416033],[-73.9979759848177,40.72935464909121],[-73.99798488329895,40.729359114026934],[-73.99799378178014,40.72936357896749],[-73.99800268026121,40.72936804391288],[-73.99801157874218,40.7293725088631],[-73.99802047722308,40.72937697381817],[-73.99802937570388,40.72938143877806],[-73.99803827418461,40.7293859037428],[-73.99804717266522,40.72939036871237],[-73.99805607114575,40.729394833686776],[-73.99806496962617,40.72939929866602],[-73.99807386810652,40.729403763650105],[-73.99808276658676,40.729408228639016],[-73.99809166506692,40.72941269363277],[-73.99810056354697,40.72941715863136],[-73.99810946202696,40.72942162363478],[-73.99811836050685,40.72942608864304],[-73.99812725898661,40.72943055365614],[-73.9981361574663,40.72943501867407],[-73.99814505594594,40.72943948369684],[-73.99815395442545,40.72944394872444],[-73.99816285290484,40.72944841375688],[-73.99817175138418,40.729452878794156],[-73.99818064986344,40.729457343836266],[-73.99818954834257,40.729461808883215],[-73.99819844682162,40.729466273934996],[-73.99820734530059,40.72947073899162],[-73.99821624377944,40.729475204053074],[-73.99822514225819,40.72947966911937],[-73.99823404073688,40.7294841341905],[-73.99824293921547,40.72948859926647],[-73.99825183769397,40.72949306434727],[-73.99826073617236,40.729497529432905],[-73.99826963465068,40.72950199452338],[-73.99827853312888,40.72950645961869],[-73.99828743160703,40.72951092471884],[-73.99829633008505,40.729515389823824],[-73.99830522856301,40.729519854933635],[-73.99831412704087,40.72952432004829],[-73.99832302551862,40.72952878516779],[-73.99833192399628,40.72953325029212],[-73.99834082247388,40.72953771542128],[-73.99834972095134,40.72954218055528],[-73.99835861942874,40.729546645694114],[-73.99836751790603,40.72955111083779],[-73.99837641638324,40.7295555759863],[-73.99838531486036,40.72956004113965],[-73.99839421333738,40.72956450629783],[-73.99840311181431,40.72956897146085],[-73.99841201029115,40.729573436628705],[-73.99842090876787,40.72957790180139],[-73.9984298072445,40.729582366978924],[-73.99843870572109,40.72958683216129],[-73.99844760419757,40.72959129734849],[-73.99845650267393,40.72959576254052],[-73.99846540115023,40.7296002277374],[-73.99847429962641,40.729604692939105],[-73.99848319810252,40.72960915814566],[-73.99849209657852,40.72961362335704],[-73.99850099505443,40.72961808857326],[-73.99850989353025,40.729622553794314],[-73.998518792006,40.72962701902021],[-73.99852769048162,40.72963148425094],[-73.9985365889572,40.7296359494865],[-73.99854548743265,40.7296404147269],[-73.998554385908,40.72964487997214],[-73.99856328438328,40.729649345222214],[-73.99857218285842,40.729653810477124],[-73.9985810813335,40.729658275736874],[-73.99858997980849,40.729662741001455],[-73.9985988782834,40.729667206270875],[-73.99860777675822,40.729671671545134],[-73.99861667523292,40.729676136824224],[-73.99862557370756,40.72968060210816],[-73.99863447218209,40.72968506739692],[-73.99864337065652,40.72968953269053],[-73.99865226913089,40.72969399798897],[-73.99866116760515,40.72969846329224],[-73.9986700660793,40.72970292860036],[-73.99867896455338,40.7297073939133],[-73.99868786302736,40.72971185923109],[-73.99869676150124,40.72971632455371],[-73.99870565997502,40.72972078988117],[-73.99871455844873,40.72972525521347],[-73.99872345692232,40.7297297205506],[-73.99873235539586,40.729734185892575],[-73.99874125386926,40.72973865123938],[-73.99875015234261,40.729743116591024],[-73.99875905081585,40.7297475819475],[-73.99876794928902,40.729752047308814],[-73.99877684776204,40.72975651267497],[-73.99878574623504,40.72976097804596],[-73.99879464470791,40.72976544342178],[-73.99880354318068,40.729769908802446],[-73.99881244165334,40.72977437418795],[-73.99882134012594,40.72977883957828],[-73.99883023859846,40.72978330497346],[-73.99883913707087,40.72978777037347],[-73.99884803554319,40.72979223577831],[-73.9988569340154,40.729796701188],[-73.99886583248755,40.72980116660252],[-73.9988747309596,40.72980563202187],[-73.99888362943156,40.72981009744607],[-73.99889252790341,40.7298145628751],[-73.99890142637518,40.72981902830897],[-73.99891032484682,40.729823493747666],[-73.99891922331842,40.72982795919121],[-73.9989281217899,40.72983242463958],[-73.99893702026128,40.7298368900928],[-73.9989459187326,40.72984135555085],[-73.99895481720382,40.72984582101374],[-73.99896371567493,40.72985028648147],[-73.99897261414597,40.72985475195403],[-73.99898151261691,40.729859217431425],[-73.99899041108773,40.72986368291366],[-73.99899930955847,40.72986814840073],[-73.99900820802914,40.729872613892645],[-73.99901710649969,40.72987707938939],[-73.99902600497018,40.72988154489097],[-73.99903490344057,40.729886010397394],[-73.99904380191087,40.729890475908654],[-73.99905270038104,40.729894941424746],[-73.99906159885117,40.72989940694568],[-73.99907049732116,40.729903872471446],[-73.9990793957911,40.72990833800205],[-73.99908829426091,40.72991280353749],[-73.99909719273067,40.729917269077774],[-73.99910609120032,40.729921734622884],[-73.99911498966986,40.72992620017284],[-73.99912388813932,40.72993066572763],[-73.99913278660871,40.729935131287256],[-73.99914168507794,40.72993959685172],[-73.99915058354713,40.72994406242102],[-73.99915948201622,40.729948527995155],[-73.99916838048523,40.72995299357413],[-73.99917727895414,40.729957459157944],[-73.99918617742294,40.7299619247466],[-73.99919507589168,40.72996639034008],[-73.99920397436031,40.729970855938404],[-73.99921287282883,40.72997532154156],[-73.99922177129729,40.72997978714956],[-73.99923066976565,40.72998425276239],[-73.99923956823389,40.72998871838007],[-73.9992484667021,40.72999318400258],[-73.99925736517017,40.72999764962992],[-73.99926626363812,40.7300021152621],[-73.99927516210602,40.73000658089912],[-73.99928406057381,40.73001104654099],[-73.99929295904151,40.73001551218768],[-73.99930185750914,40.730019977839206],[-73.99931075597668,40.73002444349557],[-73.99931965444412,40.73002890915678],[-73.99932855291144,40.730033374822824],[-73.99933745137868,40.7300378404937],[-73.99934634984585,40.73004230616942],[-73.9993552483129,40.73004677184998],[-73.99936414677988,40.73005123753537],[-73.99937304524677,40.730055703225595],[-73.99938194371353,40.730060168920666],[-73.9993908421802,40.73006463462057],[-73.99939974064684,40.73006910032531],[-73.99940863911334,40.73007356603489],[-73.99941753757977,40.7300780317493],[-73.9994264360461,40.73008249746855],[-73.99943533451228,40.73008696319264],[-73.99944423297845,40.730091428921575],[-73.9994531314445,40.730095894655335],[-73.99946202991045,40.730100360393934],[-73.99947092837631,40.73010482613738],[-73.99947982684208,40.730109291885654],[-73.99948872530774,40.73011375763877],[-73.99949762377334,40.730118223396715],[-73.99950652223886,40.73012268915951],[-73.99951542070426,40.73012715492713],[-73.99952431916954,40.730131620699595],[-73.99953321763478,40.7301360864769],[-73.9995421160999,40.73014055225903],[-73.99955101456494,40.73014501804601],[-73.99955991302987,40.73014948383783],[-73.99956881149471,40.73015394963447],[-73.99957770995945,40.73015841543596],[-73.99958660842414,40.730162881242286],[-73.99959550688871,40.730167347053445],[-73.99960440535321,40.73017181286945],[-73.99961330381757,40.73017627869029],[-73.99962220228188,40.73018074451596],[-73.99963110074607,40.73018521034647],[-73.9996399992102,40.730189676181816],[-73.9996488976742,40.730194142022],[-73.99965779613811,40.73019860786703],[-73.99966669460197,40.73020307371689],[-73.99967559306569,40.730207539571595],[-73.99968449152935,40.730212005431135],[-73.99969338999291,40.7302164712955],[-73.99970228845636,40.73022093716472],[-73.99971118691975,40.730225403038766],[-73.99972008538305,40.730229868917654],[-73.9997289838462,40.730234334801374],[-73.99973788230932,40.73023880068994],[-73.99974678077231,40.730243266583344],[-73.99975567923524,40.73024773248158],[-73.99976457769804,40.730252198384655],[-73.99977347616075,40.73025666429256],[-73.99978237462341,40.730261130205314],[-73.99979127308595,40.7302655961229],[-73.9998001715484,40.73027006204533],[-73.99980907001076,40.73027452797259],[-73.99981796847304,40.73027899390469],[-73.99982686693521,40.73028345984163],[-73.9998357653973,40.7302879257834],[-73.99984466385928,40.73029239173002],[-73.99985356232118,40.73029685768147],[-73.999862460783,40.73030132363776],[-73.9998713592447,40.73030578959889],[-73.99988025770628,40.730310255564845],[-73.99988915616784,40.730314721535656],[-73.99989805462928,40.73031918751129],[-73.9999069530906,40.730323653491766],[-73.99991585155186,40.73032811947708],[-73.99992475001305,40.73033258546724],[-73.99993364847408,40.73033705146223],[-73.99994254693506,40.73034151746205],[-73.99995144539594,40.73034598346672],[-73.99996034385674,40.73035044947623],[-73.99996924231742,40.730354915490565],[-73.99997814077804,40.73035938150975],[-73.99998703923856,40.730363847533766],[-73.99999593769897,40.730368313562614],[-74.00000483615929,40.73037277959631],[-74.00001373461956,40.730377245634834],[-74.00002263307968,40.730381711678206],[-74.00003153153973,40.73038617772641],[-74.00004042999971,40.73039064377946],[-74.0000493284596,40.73039510983734],[-74.00005822691934,40.73039957590006],[-74.00006712537903,40.73040404196762],[-74.00007602383863,40.730408508040014],[-74.00008492229811,40.73041297411725],[-74.00009382075754,40.73041744019931],[-74.00010271921686,40.730421906286224],[-74.00011161767605,40.73042637237797],[-74.000119,40.73043],[-74.000119,40.73043],[-74.00012,40.730431],[-74.00012,40.730431],[-74.000119,40.730433],[-74.000119,40.730433],[-74.0001104487632,40.73044298474101],[-74.00010189752598,40.73045296947162],[-74.00009334628828,40.73046295419184],[-74.00008479505011,40.73047293890167],[-74.00007624381149,40.730482923601095],[-74.0000676925724,40.73049290829014],[-74.00005914133286,40.73050289296879],[-74.00005059009285,40.73051287763704],[-74.00004203885237,40.7305228622949],[-74.00003348761146,40.73053284694236],[-74.00002493637005,40.73054283157942],[-74.00001638512822,40.7305528162061],[-74.0000078338859,40.730562800822376],[-73.99999928264313,40.73057278542827],[-73.99999073139989,40.730582770023766],[-73.99998218015621,40.730592754608864],[-73.99997362891204,40.730602739183574],[-73.99996507766743,40.73061272374788],[-73.99995652642235,40.73062270830181],[-73.9999479751768,40.73063269284533],[-73.99993942393081,40.73064267737847],[-73.99993087268436,40.7306526619012],[-73.99992232143742,40.73066264641355],[-73.99991377019003,40.7306726309155],[-73.99990521894219,40.73068261540706],[-73.99989666769387,40.73069259988822],[-73.9998881164451,40.730702584358994],[-73.99987956519588,40.73071256881938],[-73.99987101394622,40.73072255326936],[-73.99986246269607,40.73073253770895],[-73.99985391144543,40.730742522138144],[-73.99984536019439,40.730752506556954],[-73.99983680894286,40.73076249096536],[-73.99982825769085,40.73077247536338],[-73.99981970643839,40.730782459751005],[-73.99981115518548,40.73079244412823],[-73.9998026039321,40.73080242849507],[-73.99979405267827,40.730812412851506],[-73.99978550142397,40.730822397197564],[-73.99977695016923,40.73083238153322],[-73.999768398914,40.73084236585848],[-73.99975984765831,40.73085235017335],[-73.99975129640218,40.73086233447783],[-73.99974274514557,40.730872318771915],[-73.99973419388847,40.7308823030556],[-73.99972564263099,40.7308922873289],[-73.99971709137297,40.7309022715918],[-73.99970854011457,40.730912255844316],[-73.99969998885562,40.730922240086436],[-73.99969143759624,40.73093222431816],[-73.99968288633646,40.73094220853949],[-73.99967433507614,40.73095219275043],[-73.9996657838154,40.730962176950975],[-73.99965723255417,40.730972161141125],[-73.99964868129251,40.73098214532089],[-73.99964013003039,40.73099212949025],[-73.99963157876778,40.731002113649225],[-73.99962302750471,40.73101209779781],[-73.99961447624119,40.73102208193599],[-73.99960592497723,40.73103206606378],[-73.99959737371277,40.73104205018119],[-73.999594,40.731046],[-73.999594,40.731046],[-73.99958546447631,40.731056159839326],[-73.99957692895215,40.73106631966809],[-73.99956839342755,40.73107647948629],[-73.99955985790245,40.73108663929394],[-73.99955132237685,40.73109679909104],[-73.99954278685078,40.73110695887758],[-73.99953425132425,40.731117118653565],[-73.99952571579723,40.73112727841899],[-73.99951718026973,40.73113743817387],[-73.99950864474177,40.73114759791818],[-73.99950010921333,40.731157757651935],[-73.99949157368442,40.73116791737514],[-73.99948303815498,40.73117807708778],[-73.99947450262512,40.731188236789876],[-73.99946596709478,40.7311983964814],[-73.99945743156393,40.73120855616238],[-73.99944889603262,40.7312187158328],[-73.99944036050086,40.73122887549267],[-73.99943182496858,40.731239035141975],[-73.99942328943581,40.73124919478072],[-73.99941475390258,40.73125935440893],[-73.99940621836892,40.731269514026565],[-73.99939768283473,40.73127967363365],[-73.99938914730005,40.73128983323018],[-73.99938061176495,40.73129999281615],[-73.99937207622935,40.731310152391565],[-73.99936354069324,40.73132031195642],[-73.99935500515667,40.731330471510724],[-73.99934646961967,40.73134063105447],[-73.99933793408212,40.73135079058767],[-73.99932939854415,40.73136095011031],[-73.99932086300566,40.73137110962239],[-73.99931232746675,40.731381269123915],[-73.99930379192729,40.73139142861488],[-73.99929525638737,40.73140158809529],[-73.999286720847,40.73141174756515],[-73.99927818530611,40.731421907024455],[-73.99926964976478,40.7314320664732],[-73.999261114223,40.73144222591139],[-73.99925257868071,40.73145238533902],[-73.99924404313795,40.7314625447561],[-73.9992355075947,40.73147270416262],[-73.99922697205098,40.73148286355858],[-73.99921843650675,40.731493022944],[-73.99920990096209,40.73150318231885],[-73.99920136541694,40.73151334168315],[-73.99919282987132,40.7315235010369],[-73.99918429432518,40.73153366038008],[-73.99917575877862,40.73154381971272],[-73.99916722323155,40.73155397903479],[-73.99915868768402,40.73156413834631],[-73.999150152136,40.73157429764728],[-73.9991416165875,40.73158445693769],[-73.99913308103854,40.73159461621754],[-73.99912454548907,40.73160477548684],[-73.99911600993914,40.731614934745586],[-73.99910747438874,40.73162509399377],[-73.9991,40.731634],[-73.9991,40.731634],[-73.9990914560668,40.7316440660752],[-73.99908291213316,40.73165413213993],[-73.99907436819905,40.73166419819419],[-73.99906582426446,40.73167426423798],[-73.99905728032935,40.7316843302713],[-73.99904873639383,40.73169439629415],[-73.99904019245783,40.73170446230654],[-73.99903164852135,40.73171452830845],[-73.99902310458442,40.7317245942999],[-73.99901456064701,40.73173466028088],[-73.99900601670915,40.73174472625139],[-73.99899747277081,40.731754792211426],[-73.99898892883198,40.731764858161],[-73.99898038489272,40.7317749241001],[-73.99897184095296,40.73178499002874],[-73.99896329701275,40.731795055946904],[-73.99895475307207,40.7318051218546],[-73.99894620913089,40.731815187751835],[-73.99893766518927,40.73182525363859],[-73.99892912124717,40.73183531951488],[-73.99892057730462,40.7318453853807],[-73.99891203336159,40.73185545123605],[-73.99890348941808,40.73186551708094],[-73.99889494547412,40.73187558291535],[-73.99888640152969,40.73188564873931],[-73.99887785758477,40.731895714552785],[-73.9988693136394,40.731905780355795],[-73.99886076969355,40.73191584614834],[-73.99885222574726,40.73192591193041],[-73.99884368180045,40.731935977702015],[-73.99883513785323,40.731946043463154],[-73.99882659390549,40.73195610921382],[-73.99881804995734,40.73196617495402],[-73.99880950600866,40.73197624068375],[-73.99880096205953,40.73198630640301],[-73.99879241810997,40.73199637211181],[-73.99878387415988,40.732006437810135],[-73.99877533020936,40.732016503497995],[-73.99876678625839,40.73202656917538],[-73.9987582423069,40.7320366348423],[-73.99874969835498,40.732046700498756],[-73.99874115440257,40.73205676614474],[-73.99873261044972,40.73206683178026],[-73.99872406649637,40.73207689740531],[-73.99871552254255,40.73208696301988],[-73.99870697858829,40.732097028624],[-73.99869843463352,40.73210709421764],[-73.99868989067832,40.732117159800815],[-73.99868134672262,40.73212722537352],[-73.99867280276649,40.73213729093575],[-73.99866425880988,40.73214735648753],[-73.99865571485277,40.732157422028834],[-73.99864717089523,40.732167487559664],[-73.9986386269372,40.73217755308003],[-73.99863008297874,40.73218761858993],[-73.99862153901974,40.732197684089364],[-73.99861299506031,40.73220774957832],[-73.998606,40.732216],[-73.998606,40.732216],[-73.99859746847837,40.73222620337097],[-73.99858893695627,40.732236406731346],[-73.9985804054337,40.73224661008112],[-73.99857187391063,40.73225681342031],[-73.99856334238704,40.73226701674889],[-73.99855481086306,40.73227722006688],[-73.99854627933851,40.73228742337428],[-73.99853774781354,40.73229762667107],[-73.99852921628806,40.73230782995728],[-73.9985206847621,40.73231803323288],[-73.99851215323565,40.7323282364979],[-73.99850362170875,40.732338439752304],[-73.99849509018132,40.73234864299613],[-73.99848655865344,40.73235884622935],[-73.99847802712509,40.732369049451975],[-73.99846949559624,40.73237925266401],[-73.99846096406695,40.732389455865444],[-73.99845243253714,40.73239965905629],[-73.99844390100682,40.73240986223653],[-73.99843536947607,40.73242006540619],[-73.99842683794482,40.73243026856524],[-73.99841830641307,40.732440471713694],[-73.99840977488086,40.732450674851556],[-73.99840124334814,40.73246087797882],[-73.99839271181497,40.7324710810955],[-73.99838418028132,40.73248128420157],[-73.99837564874716,40.732491487297054],[-73.99836711721254,40.73250169038193],[-73.99835858567744,40.73251189345622],[-73.99835005414185,40.732522096519915],[-73.99834152260578,40.732532299573016],[-73.99833299106922,40.732542502615516],[-73.99832445953221,40.73255270564742],[-73.99831592799471,40.73256290866874],[-73.99830739645668,40.73257311167945],[-73.99829886491823,40.73258331467957],[-73.99829033337924,40.7325935176691],[-73.99828180183982,40.73260372064803],[-73.99827327029993,40.73261392361636],[-73.99826473875952,40.7326241265741],[-73.99825620721863,40.73263432952125],[-73.99824767567726,40.73264453245779],[-73.99823914413543,40.73265473538375],[-73.99823061259309,40.7326649382991],[-73.99822208105027,40.73267514120386],[-73.99821354950699,40.73268534409803],[-73.99820501796322,40.73269554698161],[-73.99819648641898,40.73270574985458],[-73.99818795487423,40.732715952716966],[-73.99817942332902,40.732726155568756],[-73.99817089178336,40.732736358409944],[-73.998162,40.732747],[-73.998162,40.732747],[-73.99815342089919,40.73275666386057],[-73.99814484179797,40.73276632771105],[-73.99813626269632,40.73277599155143],[-73.99812768359423,40.732785655381726],[-73.99811910449169,40.73279531920193],[-73.99811052538875,40.73280498301204],[-73.99810194628535,40.73281464681206],[-73.99809336718157,40.732824310601984],[-73.99808478807728,40.732833974381826],[-73.99807620897259,40.732843638151564],[-73.99806762986749,40.73285330191122],[-73.99805905076195,40.732862965660786],[-73.99805047165597,40.732872629400255],[-73.99804189254958,40.73288229312964],[-73.9980333134427,40.732891956848924],[-73.99802473433543,40.73290162055813],[-73.99801615522776,40.732911284257234],[-73.99800757611962,40.732920947946255],[-73.99799899701105,40.73293061162518],[-73.99799041790205,40.73294027529401],[-73.997988,40.732943],[-73.997988,40.732943],[-73.997988,40.732945],[-73.997988,40.732945],[-73.997989,40.732947],[-73.997989,40.732947],[-73.99799792428513,40.732950726120926],[-73.99800684857021,40.732954452245885],[-73.99801577285523,40.73295817837489],[-73.99802469714017,40.73296190450795],[-73.99803362142502,40.732965630645054],[-73.99804254570986,40.73296935678621],[-73.99805146999458,40.732973082931416],[-73.9980603942793,40.73297680908066],[-73.9980693185639,40.732980535233956],[-73.99807824284848,40.7329842613913],[-73.99808716713294,40.73298798755269],[-73.9980960914174,40.73299171371813],[-73.99810501570175,40.73299543988762],[-73.99811393998607,40.73299916606115],[-73.99812286427029,40.73300289223873],[-73.99813178855446,40.73300661842036],[-73.99814071283859,40.733010344606036],[-73.99814963712264,40.73301407079576],[-73.99815856140663,40.73301779698953],[-73.99816748569052,40.73302152318735],[-73.99817640997436,40.73302524938922],[-73.99818533425817,40.73302897559513],[-73.99819425854189,40.733032701805094],[-73.99820318282552,40.733036428019105],[-73.99821210710913,40.73304015423716],[-73.99822103139267,40.73304388045926],[-73.99822995567612,40.733047606685425],[-73.9982388799595,40.73305133291562],[-73.99824780424288,40.73305505914987],[-73.99825672852614,40.73305878538816],[-73.99826565280934,40.73306251163051],[-73.99827457709249,40.7330662378769],[-73.99828350137557,40.73306996412734],[-73.99829242565859,40.73307369038182],[-73.99830134994154,40.733077416640356],[-73.99831027422444,40.73308114290294],[-73.99831919850726,40.733084869169566],[-73.99832812279,40.73308859544024],[-73.99833704707272,40.73309232171497],[-73.99834597135536,40.73309604799375],[-73.9983548956379,40.73309977427656],[-73.99836381992041,40.73310350056343],[-73.99837274420287,40.73310722685435],[-73.99838166848524,40.73311095314931],[-73.99839059276754,40.73311467944832],[-73.99839951704978,40.733118405751384],[-73.99840844133196,40.73312213205849],[-73.99841736561409,40.73312585836965],[-73.99842628989613,40.733129584684846],[-73.99843521417812,40.733133311004096],[-73.99844413846004,40.733137037327396],[-73.99845306274192,40.73314076365474],[-73.9984619870237,40.73314448998613],[-73.99847091130545,40.733148216321574],[-73.99847983558712,40.73315194266106],[-73.9984887598687,40.7331556690046],[-73.99849768415022,40.73315939535218],[-73.99850660843174,40.73316312170382],[-73.99851553271313,40.7331668480595],[-73.99852445699449,40.733170574419226],[-73.99853338127575,40.733174300783006],[-73.99854230555698,40.73317802715083],[-73.99855122983816,40.7331817535227],[-73.99856015411925,40.73318547989862],[-73.99856907840027,40.73318920627859],[-73.99857800268121,40.733192932662604],[-73.9985869269621,40.73319665905067],[-73.99859585124297,40.733200385442785],[-73.9986047755237,40.73320411183894],[-73.99861369980441,40.73320783823915],[-73.99862262408506,40.733211564643405],[-73.99863154836565,40.73321529105171],[-73.99864047264616,40.73321901746406],[-73.9986493969266,40.73322274388046],[-73.99865832120699,40.733226470300906],[-73.9986672454873,40.7332301967254],[-73.99867616976756,40.733233923153946],[-73.99868509404774,40.733237649586535],[-73.99869401832787,40.73324137602318],[-73.99870294260795,40.73324510246386],[-73.99871186688794,40.73324882890859],[-73.99872079116788,40.73325255535738],[-73.99872971544777,40.73325628181021],[-73.99873863972755,40.73326000826709],[-73.99874756400727,40.73326373472802],[-73.99875648828697,40.733267461192995],[-73.9987654125666,40.73327118766202],[-73.99877433684611,40.73327491413509],[-73.99878326112562,40.73327864061221],[-73.99879218540505,40.73328236709338],[-73.9988011096844,40.73328609357859],[-73.99881003396368,40.73328982006786],[-73.99881895824294,40.73329354656117],[-73.99882788252208,40.73329727305853],[-73.99883680680118,40.73330099955994],[-73.9988457310802,40.7333047260654],[-73.99885465535918,40.733308452574896],[-73.99886357963808,40.73331217908845],[-73.99887250391693,40.733315905606055],[-73.99888142819572,40.7333196321277],[-73.99889035247443,40.7333233586534],[-73.99889927675308,40.73332708518314],[-73.99890820103164,40.73333081171693],[-73.99891712531016,40.73333453825478],[-73.99892604958866,40.73333826479667],[-73.99893497386701,40.733341991342606],[-73.99894389814537,40.73334571789259],[-73.99895282242362,40.733349444446624],[-73.99896174670182,40.73335317100471],[-73.99897067097994,40.733356897566836],[-73.99897959525804,40.73336062413302],[-73.99898851953604,40.73336435070324],[-73.99899744381398,40.73336807727752],[-73.99900636809186,40.733371803855846],[-73.99901529236966,40.73337553043821],[-73.99902421664741,40.73337925702464],[-73.99903314092512,40.7333829836151],[-73.99904206520273,40.73338671020962],[-73.9990509894803,40.733390436808186],[-73.9990599137578,40.73339416341079],[-73.9990688380352,40.733397890017464],[-73.99907776231258,40.733401616628164],[-73.99908668658988,40.73340534324292],[-73.9990956108671,40.733409069861736],[-73.99910453514428,40.733412796484586],[-73.99911345942137,40.733416523111494],[-73.99912238369842,40.733420249742444],[-73.99913130797542,40.733423976377445],[-73.99914023225234,40.73342770301649],[-73.99914915652919,40.73343142965958],[-73.99915808080596,40.73343515630673],[-73.99916700508271,40.73343888295793],[-73.99917592935935,40.733442609613164],[-73.99918485363597,40.73344633627245],[-73.99919377791248,40.733450062935795],[-73.99920270218895,40.733453789603175],[-73.99921162646535,40.73345751627461],[-73.9992205507417,40.73346124295009],[-73.99922947501794,40.73346496962962],[-73.99923839929419,40.7334686963132],[-73.99924732357032,40.73347242300083],[-73.99925624784639,40.73347614969251],[-73.99926517212242,40.73347987638824],[-73.99927409639837,40.73348360308801],[-73.99928302067423,40.73348732979183],[-73.99929194495006,40.7334910564997],[-73.99930086922583,40.73349478321162],[-73.99930979350151,40.733498509927585],[-73.99931871777714,40.7335022366476],[-73.99932764205273,40.73350596337167],[-73.99933656632821,40.73350969009978],[-73.99934549060366,40.73351341683194],[-73.99935441487905,40.73351714356815],[-73.99936333915433,40.73352087030841],[-73.9993722634296,40.733524597052714],[-73.9993811877048,40.733528323801075],[-73.99939011197989,40.73353205055347],[-73.99939903625494,40.73353577730993],[-73.99940796052995,40.73353950407043],[-73.999414,40.733542],[-73.999414,40.733542],[-73.99942292116982,40.73354582335814],[-73.99943184233958,40.73354964672044],[-73.999435,40.733551],[-73.999435,40.733551],[-73.99944384239664,40.73355674755748],[-73.99945268479317,40.73356249512114],[-73.999455,40.733564],[-73.999455,40.733564],[-73.99946379717927,40.733570597883265],[-73.9994725943584,40.7335771957736],[-73.999479,40.733582],[-73.999479,40.733582],[-73.99948752873901,40.73359223448776],[-73.999494,40.7336],[-73.999494,40.7336],[-73.999501996355,40.73361485037542],[-73.999508,40.733626],[-73.999508,40.733626],[-73.99951497774768,40.73364652509243],[-73.99952195549342,40.7336670502023],[-73.99952893323724,40.733687575329604],[-73.9995359109791,40.73370810047434],[-73.99954288871896,40.73372862563651],[-73.99954986645693,40.73374915081612],[-73.99955684419294,40.73376967601315],[-73.999563821927,40.73379020122762],[-73.99957079965911,40.73381072645953],[-73.99957777738928,40.73383125170887],[-73.99958475511748,40.73385177697564],[-73.99959173284375,40.733872302259854],[-73.99959871056805,40.73389282756149],[-73.99960568829042,40.73391335288056],[-73.99961266601085,40.73393387821708],[-73.99961964372932,40.73395440357102],[-73.99962662144583,40.7339749289424],[-73.99963359916042,40.73399545433122],[-73.99964057687303,40.734015979737464],[-73.99964755458375,40.73403650516115],[-73.99965453229245,40.734057030602266],[-73.99966150999926,40.73407755606082],[-73.99966848770408,40.7340980815368],[-73.99967546540692,40.73411860703022],[-73.999679,40.734129],[-73.999679,40.734129],[-73.99968556849389,40.73415123182067],[-73.9996921369855,40.73417346365912],[-73.99969870547487,40.73419569551533],[-73.999705,40.734217],[-73.999705,40.734217],[-73.99971301054671,40.73423174955791],[-73.99972102109238,40.73424649913019],[-73.99972903163712,40.734261248716855],[-73.99973704218081,40.734275998317905],[-73.99974505272345,40.734290747933336],[-73.99975306326516,40.734305497563156],[-73.9997610738058,40.73432024720735],[-73.999768,40.734333],[-73.999768,40.734333],[-73.99977612621663,40.73434689187968],[-73.99978425243239,40.734360783773106],[-73.99979237864727,40.734374675680264],[-73.99980050486121,40.73438856760117],[-73.99980863107427,40.73440245953582],[-73.99981675728645,40.734416351484214],[-73.99982488349772,40.73443024344634],[-73.99983300970814,40.73444413542222],[-73.99984113591765,40.73445802741184],[-73.99984926212626,40.7344719194152],[-73.99985738833396,40.7344858114323],[-73.99986551454079,40.73449970346314],[-73.9998736407467,40.734513595507735],[-73.99988176695176,40.73452748756606],[-73.99988989315591,40.73454137963813],[-73.99989801935916,40.73455527172395],[-73.99990614556154,40.7345691638235],[-73.999914271763,40.7345830559368],[-73.99992239796359,40.73459694806384],[-73.99993052416323,40.734610840204624],[-73.99993865036204,40.73462473235915],[-73.99994677655995,40.73463862452743],[-73.99995490275695,40.73465251670943],[-73.99996302895305,40.73466640890519],[-73.99997115514829,40.73468030111468],[-73.999978,40.734692],[-73.999978,40.734692],[-73.99998621067839,40.734705222243505],[-73.99999442135598,40.73471844450023],[-74.00000263203277,40.734731666770166],[-74.00001084270875,40.73474488905332],[-74.00001905338384,40.734758111349684],[-74.0000272640582,40.73477133365927],[-74.00003547473175,40.73478455598207],[-74.00004368540448,40.73479777831808],[-74.0000518960764,40.734811000667314],[-74.00006010674751,40.73482422302976],[-74.00006831741783,40.734837445405425],[-74.00007652808732,40.734850667794305],[-74.000084738756,40.7348638901964],[-74.00009294942387,40.73487711261172],[-74.00010116009095,40.73489033504024],[-74.00010937075722,40.73490355748199],[-74.00011758142267,40.73491677993695],[-74.00012579208732,40.73493000240512],[-74.00013400275115,40.73494322488652],[-74.00014221341416,40.73495644738113],[-74.0001504240764,40.734969669888955],[-74.0001586347378,40.734982892409995],[-74.0001668453984,40.73499611494425],[-74.00017505605817,40.735009337491725],[-74.00018326671717,40.735022560052414],[-74.00019147737537,40.73503578262632],[-74.00019968803272,40.73504900521345],[-74.00020789868927,40.735062227813785],[-74.00021610934505,40.73507545042734],[-74.00022431999999,40.735088673054115],[-74.00023253065409,40.7351018956941],[-74.00024074130742,40.7351151183473],[-74.00024895195996,40.73512834101373],[-74.00025716261166,40.73514156369337],[-74.00026537326256,40.73515478638622],[-74.00027358391266,40.73516800909229],[-74.00028179456193,40.73518123181157],[-74.00029000521042,40.735194454544086],[-74.00029821585807,40.7352076772898],[-74.00030642650492,40.73522090004874],[-74.00031463715098,40.73523412282089],[-74.00032284779621,40.73524734560626],[-74.00033105844065,40.73526056840485],[-74.00033926908426,40.73527379121665],[-74.00034747972707,40.735287014041674],[-74.0003556903691,40.73530023687991],[-74.000363,40.735312],[-74.000363,40.735312],[-74.00037114871634,40.73532571781278],[-74.0003792974318,40.73533943563915],[-74.00038744614645,40.73535315347914],[-74.00039559486017,40.73536687133273],[-74.000403743573,40.73538058919993],[-74.000411892285,40.73539430708074],[-74.00042004099612,40.73540802497516],[-74.00042818970635,40.735421742883176],[-74.00043633841575,40.735435460804815],[-74.00044448712424,40.735449178740055],[-74.00045263583188,40.7354628966889],[-74.00046078453869,40.73547661465136],[-74.00046893324456,40.73549033262743],[-74.00047708194961,40.7355040506171],[-74.00048523065375,40.73551776862038],[-74.00049337935705,40.73553148663728],[-74.00050152805946,40.73554520466777],[-74.000509676761,40.73555892271189],[-74.00051782546167,40.7355726407696],[-74.00052597416148,40.73558635884092],[-74.0005341228604,40.73560007692586],[-74.0005422715585,40.7356137950244],[-74.00055042025569,40.73562751313655],[-74.00055856895199,40.73564123126231],[-74.00056671764747,40.73565494940167],[-74.00057486634205,40.73566866755465],[-74.00058301503576,40.73568238572123],[-74.00059116372859,40.735696103901425],[-74.0005993124206,40.73570982209523],[-74.00060746111168,40.73572354030264],[-74.00061560980191,40.735737258523656],[-74.00062375849126,40.73575097675828],[-74.0006319071798,40.735764695006516],[-74.00064005586738,40.73577841326836],[-74.00064820455414,40.73579213154382],[-74.00065635324002,40.73580584983288],[-74.00066450192504,40.73581956813555],[-74.0006726506092,40.73583328645183],[-74.00068079929247,40.73584700478172],[-74.00068894797487,40.735860723125214],[-74.00069709665641,40.735874441482316],[-74.00070524533707,40.73588815985303],[-74.00071339401684,40.73590187823736],[-74.00072154269576,40.73591559663529],[-74.0007296913738,40.73592931504683],[-74.000737840051,40.735943033471976],[-74.0007459887273,40.735956751910734],[-74.00075413740277,40.7359704703631],[-74.00076228607732,40.73598418882908],[-74.00077043475102,40.73599790730867],[-74.00077858342384,40.736011625801865],[-74.0007867320958,40.736025344308665],[-74.00079488076692,40.73603906282907],[-74.00080302943711,40.7360527813631],[-74.00081117810647,40.736066499910734],[-74.00081932677494,40.73608021847197],[-74.00082747544255,40.736093937046824],[-74.00083562410927,40.73610765563528],[-74.00084377277516,40.73612137423734],[-74.00085192144013,40.73613509285302],[-74.00086007010427,40.73614881148231],[-74.00086821876752,40.7361625301252],[-74.00087636742994,40.7361762487817],[-74.00088451609142,40.736189967451814],[-74.00089266475209,40.736203686135546],[-74.00090081341183,40.73621740483287],[-74.00090896207077,40.73623112354381],[-74.00091711072878,40.73624484226836],[-74.00092525938595,40.73625856100652],[-74.00093340804223,40.73627227975829],[-74.00094155669767,40.73628599852367],[-74.00094970535223,40.736299717302664],[-74.00095785400592,40.73631343609526],[-74.00096600265873,40.73632715490147],[-74.00097415131066,40.73634087372128],[-74.00098229996175,40.736354592554704],[-74.00099044861193,40.73636831140174],[-74.00099859726129,40.736382030262384],[-74.0010067459097,40.73639574913664],[-74.00101489455733,40.736409468024505],[-74.00102304320403,40.736423186925975],[-74.00103119184989,40.73643690584106],[-74.00103934049487,40.73645062476975],[-74.00104748913898,40.73646434371205],[-74.00105563778222,40.73647806266796],[-74.0010637864246,40.73649178163748],[-74.0010719350661,40.736505500620616],[-74.00108008370674,40.736519219617364],[-74.00108823234649,40.73653293862771],[-74.00109638098536,40.73654665765167],[-74.00110452962336,40.73656037668924],[-74.00111267826054,40.73657409574042],[-74.00112082689682,40.73658781480521],[-74.00112897553223,40.736601533883615],[-74.00113712416675,40.736615252975625],[-74.0011452728004,40.73662897208124],[-74.00115342143322,40.736642691200466],[-74.00116157006514,40.73665641033331],[-74.00116971869619,40.736670129479755],[-74.00117786732638,40.736683848639814],[-74.00118601595568,40.736697567813486],[-74.00119416458413,40.736711287000766],[-74.0012023132117,40.73672500620165],[-74.00121046183841,40.73673872541615],[-74.00121861046425,40.73675244464427],[-74.0012267590892,40.73676616388598],[-74.0012349077133,40.73677988314131],[-74.0012430563365,40.73679360241025],[-74.00125120495888,40.7368073216928],[-74.00125935358037,40.73682104098896],[-74.00126750220097,40.73683476029873],[-74.00127565082072,40.73684847962211],[-74.00128379943958,40.736862198959095],[-74.00129194805757,40.7368759183097],[-74.0013000966747,40.73688963767391],[-74.00130824529097,40.73690335705173],[-74.00131639390635,40.73691707644316],[-74.00132454252086,40.7369307958482],[-74.00133269113451,40.736944515266856],[-74.0013408397473,40.73695823469912],[-74.0013489883592,40.736971954144984],[-74.00135713697024,40.73698567360447],[-74.00136528558042,40.73699939307757],[-74.00137343418972,40.73701311256427],[-74.00138158279815,40.73702683206458],[-74.00138973140565,40.73704055157851],[-74.00139788001236,40.73705427110605],[-74.00140602861819,40.73706799064718],[-74.00141417722314,40.73708171020194],[-74.00142232582718,40.73709542977031],[-74.0014304744304,40.737109149352285],[-74.00143862303274,40.73712286894787],[-74.0014467716342,40.73713658855707],[-74.00145492023479,40.73715030817988],[-74.00146306883452,40.7371640278163],[-74.00147121743339,40.737177747466326],[-74.00147936603136,40.737191467129975],[-74.00148751462847,40.73720518680722],[-74.00149566322472,40.737218906498086],[-74.00150381182007,40.737232626202555],[-74.00151196041456,40.73724634592064],[-74.00152010900821,40.73726006565233],[-74.00152825760095,40.73727378539764],[-74.00153640619286,40.73728750515655],[-74.00154455478385,40.737301224929084],[-74.00155270337402,40.737314944715216],[-74.0015608519633,40.73732866451497],[-74.00156900055171,40.73734238432833],[-74.00157714913921,40.73735610415529],[-74.00158529772591,40.73736982399588],[-74.0015934463117,40.737383543850065],[-74.00160159489661,40.737397263717874],[-74.0016097434807,40.73741098359928],[-74.00161789206385,40.73742470349431],[-74.00162604064619,40.73743842340295],[-74.00163418922762,40.737452143325186],[-74.00164233780819,40.73746586326105],[-74.00165048638789,40.737479583210515],[-74.00165863496673,40.7374933031736],[-74.00166678354469,40.73750702315029],[-74.00167493212177,40.73752074314059],[-74.00168308069803,40.737534463144506],[-74.00169122927336,40.737548183162026],[-74.00169937784787,40.73756190319317],[-74.00170752642146,40.73757562323791],[-74.0017156749942,40.737589343296264],[-74.00172382356607,40.73760306336824],[-74.00173197213707,40.73761678345382],[-74.00174012070718,40.73763050355301],[-74.00174826927646,40.73764422366582],[-74.00175641784483,40.73765794379223],[-74.00176456641236,40.737671663932254],[-74.001772714979,40.73768538408589],[-74.00178086354477,40.73769910425314],[-74.00178901210967,40.737712824434],[-74.00179716067372,40.73772654462847],[-74.00180530923687,40.73774026483655],[-74.00181345779917,40.73775398505825],[-74.00182160636062,40.73776770529356],[-74.00182975492113,40.73778142554247],[-74.00183790348085,40.737795145805],[-74.00184605203965,40.73780886608114],[-74.00185420059759,40.737822586370896],[-74.00186234915466,40.737836306674254],[-74.00187049771085,40.73785002699123],[-74.0018786462662,40.73786374732182],[-74.00188679482066,40.73787746766602],[-74.00189494337424,40.73789118802382],[-74.00190309192698,40.73790490839525],[-74.0019112404788,40.737918628780285],[-74.00191938902981,40.73793234917893],[-74.00192753757992,40.73794606959118],[-74.00193568612916,40.73795979001705],[-74.00194383467752,40.737973510456534],[-74.00195198322501,40.737987230909624],[-74.00196013177163,40.73800095137633],[-74.00196828031741,40.73801467185665],[-74.00197642886228,40.73802839235057],[-74.00198457740629,40.73804211285811],[-74.00199272594944,40.738055833379256],[-74.0020008744917,40.73806955391402],[-74.00200902303312,40.7380832744624],[-74.00201717157366,40.738096995024385],[-74.0020253201133,40.73811071559999],[-74.0020334686521,40.738124436189196],[-74.00204161719005,40.73813815679202],[-74.00204976572707,40.73815187740845],[-74.00205791426329,40.7381655980385],[-74.00206606279858,40.73817931868216],[-74.00207421133302,40.73819303933943],[-74.00208235986658,40.738206760010314],[-74.00209050839928,40.73822048069481],[-74.00209865693111,40.73823420139291],[-74.00210680546208,40.73824792210464],[-74.00211495399216,40.73826164282996],[-74.0021231025214,40.73827536356891],[-74.00213125104973,40.738289084321465],[-74.00213939957719,40.738302805087635],[-74.00214754810382,40.73831652586741],[-74.00215569662956,40.73833024666081],[-74.0021638451544,40.73834396746781],[-74.00217199367842,40.73835768828843],[-74.00218014220152,40.738371409122664],[-74.00218829072375,40.7383851299705],[-74.00219643924518,40.738398850831956],[-74.00220458776569,40.73841257170702],[-74.0022127362853,40.738426292595705],[-74.0022208848041,40.73844001349799],[-74.00222903332198,40.7384537344139],[-74.00223718183902,40.73846745534342],[-74.00224533035517,40.73848117628655],[-74.00225347887044,40.73849489724329],[-74.00226162738487,40.738508618213636],[-74.00226977589841,40.73852233919761],[-74.0022779244111,40.73853606019519],[-74.00228607292291,40.73854978120637],[-74.00229422143386,40.73856350223118],[-74.00230236994393,40.738577223269594],[-74.00231051845313,40.73859094432163],[-74.00231866696143,40.73860466538727],[-74.00232681546888,40.73861838646653],[-74.00233496397551,40.7386321075594],[-74.0023431124812,40.738645828665874],[-74.00235126098603,40.73865954978597],[-74.00235940949003,40.73867327091967],[-74.00236755799314,40.738686992066995],[-74.00237570649536,40.73870071322792],[-74.0023838549967,40.73871443440246],[-74.0023920034972,40.73872815559062],[-74.00240015199682,40.738741876792396],[-74.00240830049555,40.73875559800778],[-74.00241644899346,40.73876931923677],[-74.00242459749046,40.738783040479376],[-74.0024327459866,40.7387967617356],[-74.00244089448185,40.73881048300543],[-74.00244904297627,40.73882420428888],[-74.00245719146979,40.73883792558595],[-74.00246533996246,40.73885164689661],[-74.00247348845423,40.7388653682209],[-74.00248163694518,40.7388790895588],[-74.00248978543519,40.738892810910315],[-74.00249793392436,40.73890653227544],[-74.00250608241264,40.73892025365418],[-74.0025142309001,40.738933975046535],[-74.00252237938666,40.7389476964525],[-74.00253052787235,40.738961417872076],[-74.00253867635718,40.73897513930526],[-74.00254682484113,40.738988860752066],[-74.00255497332421,40.739002582212485],[-74.00256312180642,40.73901630368652],[-74.00257127028773,40.73903002517416],[-74.0025794187682,40.73904374667542],[-74.00258756724782,40.73905746819029],[-74.00259571572654,40.73907118971877],[-74.00260386420439,40.73908491126087],[-74.00261201268138,40.73909863281658],[-74.00262016115752,40.7391123543859],[-74.00262830963275,40.73912607596884],[-74.00263645810715,40.73913979756539],[-74.00264460658062,40.73915351917555],[-74.00265275505325,40.73916724079933],[-74.00266090352503,40.73918096243673],[-74.00266905199591,40.73919468408773],[-74.00267720046593,40.73920840575235],[-74.0026853489351,40.73922212743058],[-74.00269349740336,40.73923584912242],[-74.00270164587077,40.73924957082788],[-74.0027097943373,40.73926329254696],[-74.00271794280299,40.739277014279644],[-74.00272609126777,40.739290736025936],[-74.0027342397317,40.739304457785856],[-74.00274238819478,40.73931817955938],[-74.00275053665695,40.739331901346524],[-74.0027586851183,40.73934562314728],[-74.0027668335787,40.73935934496164],[-74.002771,40.739366]]}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"geometry":{"type":"Polygon","coordinates":[[[-73.986006,40.73647],[-73.98446,40.73798],[-73.98657,40.737982],[-73.986006,40.73647]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.98446,40.73798],[-73.985861,40.739275],[-73.98657,40.737982],[-73.98446,40.73798]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.984327,40.735805],[-73.986006,40.73647],[-73.984434,40.7347],[-73.984327,40.735805]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.983193,40.739311],[-73.985861,40.739275],[-73.98446,40.73798],[-73.983193,40.739311]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987609,40.73925],[-73.988487,40.737887],[-73.98657,40.737982],[-73.987609,40.73925]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.985861,40.739275],[-73.987609,40.73925],[-73.98657,40.737982],[-73.985861,40.739275]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987609,40.73925],[-73.985861,40.739275],[-73.986666,40.740788],[-73.987609,40.73925]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988526,40.73673],[-73.986006,40.73647],[-73.98657,40.737982],[-73.988526,40.73673]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988487,40.737887],[-73.988526,40.73673],[-73.98657,40.737982],[-73.988487,40.737887]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995004,40.722523],[-73.99587,40.723554],[-73.997192,40.723033],[-73.995004,40.722523]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994233,40.724357],[-73.995004,40.722523],[-73.993398,40.723336],[-73.994233,40.724357]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995004,40.722523],[-73.994233,40.724357],[-73.99587,40.723554],[-73.995004,40.722523]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994894,40.728082],[-73.996831,40.727328],[-73.995251,40.726477],[-73.994894,40.728082]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996831,40.727328],[-73.998412,40.727146],[-73.998082,40.725539],[-73.996831,40.727328]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988118,40.720022],[-73.990442,40.720463],[-73.98942,40.719174],[-73.988118,40.720022]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.985543,40.732946],[-73.987205,40.731971],[-73.98557,40.731555],[-73.985543,40.732946]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.005327,40.73427],[-74.004622,40.735257],[-74.006076,40.736251],[-74.005327,40.73427]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000765,40.728746],[-74.002951,40.729126],[-74.003009,40.728246],[-74.000765,40.728746]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.02319,40.76605],[-74.024625,40.765326],[-74.023429,40.764058],[-74.02319,40.76605]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.010978,40.723158],[-74.009586,40.724209],[-74.010767,40.724526],[-74.010978,40.723158]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.009586,40.724209],[-74.009905,40.726276],[-74.010767,40.724526],[-74.009586,40.724209]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.009905,40.726276],[-74.009586,40.724209],[-74.008896,40.725431],[-74.009905,40.726276]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.008896,40.725431],[-74.009586,40.724209],[-74.007149,40.724135],[-74.008896,40.725431]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99587,40.723554],[-73.996835,40.724545],[-73.997192,40.723033],[-73.99587,40.723554]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992456,40.724164],[-73.994233,40.724357],[-73.993398,40.723336],[-73.992456,40.724164]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992456,40.724164],[-73.991271,40.723356],[-73.991271,40.724802],[-73.992456,40.724164]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991271,40.723356],[-73.992456,40.724164],[-73.993398,40.723336],[-73.991271,40.723356]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.007758,40.727767],[-74.006309,40.726125],[-74.00607,40.727814],[-74.007758,40.727767]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.006309,40.726125],[-74.004449,40.727157],[-74.00607,40.727814],[-74.006309,40.726125]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004449,40.727157],[-74.006309,40.726125],[-74.004522,40.725944],[-74.004449,40.727157]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992536,40.72157],[-73.991271,40.723356],[-73.993398,40.723336],[-73.992536,40.72157]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99318,40.728953],[-73.992417,40.730348],[-73.99475,40.730559],[-73.99318,40.728953]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991541,40.72884],[-73.99318,40.728953],[-73.992697,40.727907],[-73.991541,40.72884]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99318,40.728953],[-73.991541,40.72884],[-73.992417,40.730348],[-73.99318,40.728953]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991541,40.72884],[-73.990546,40.730589],[-73.992417,40.730348],[-73.991541,40.72884]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99352,40.726555],[-73.991262,40.726638],[-73.992697,40.727907],[-73.99352,40.726555]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.9876,40.730559],[-73.987205,40.731971],[-73.988948,40.730902],[-73.9876,40.730559]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.985014,40.726634],[-73.982447,40.72618],[-73.983847,40.727621],[-73.985014,40.726634]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988782,40.725368],[-73.987839,40.724556],[-73.986624,40.726123],[-73.988782,40.725368]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988118,40.720022],[-73.988208,40.721194],[-73.990442,40.720463],[-73.988118,40.720022]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988208,40.721194],[-73.988118,40.720022],[-73.986375,40.719771],[-73.988208,40.721194]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988526,40.73673],[-73.988013,40.734948],[-73.986006,40.73647],[-73.988526,40.73673]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993542,40.741255],[-73.991069,40.742114],[-73.992131,40.743135],[-73.993542,40.741255]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994762,40.729396],[-73.99318,40.728953],[-73.99475,40.730559],[-73.994762,40.729396]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99318,40.728953],[-73.994762,40.729396],[-73.994894,40.728082],[-73.99318,40.728953]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.998412,40.727146],[-73.996831,40.727328],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994894,40.728082],[-73.997304,40.728657],[-73.996831,40.727328],[-73.994894,40.728082]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000765,40.728746],[-73.999128,40.728689],[-73.999917,40.730016],[-74.000765,40.728746]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-74.000574,40.72774],[-73.999568,40.727056],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000574,40.72774],[-73.999128,40.728689],[-74.000765,40.728746],[-74.000574,40.72774]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989904,40.739005],[-73.991236,40.737685],[-73.988487,40.737887],[-73.989904,40.739005]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991236,40.737685],[-73.989904,40.739005],[-73.991929,40.739312],[-73.991236,40.737685]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987609,40.73925],[-73.989904,40.739005],[-73.988487,40.737887],[-73.987609,40.73925]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994233,40.724357],[-73.995914,40.725523],[-73.99587,40.723554],[-73.994233,40.724357]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995914,40.725523],[-73.996835,40.724545],[-73.99587,40.723554],[-73.995914,40.725523]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996831,40.727328],[-73.995914,40.725523],[-73.995251,40.726477],[-73.996831,40.727328]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995914,40.725523],[-73.996831,40.727328],[-73.998082,40.725539],[-73.995914,40.725523]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996835,40.724545],[-73.995914,40.725523],[-73.998082,40.725539],[-73.996835,40.724545]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993598,40.727091],[-73.99352,40.726555],[-73.992697,40.727907],[-73.993598,40.727091]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99318,40.728953],[-73.993598,40.727091],[-73.992697,40.727907],[-73.99318,40.728953]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993598,40.727091],[-73.99318,40.728953],[-73.994894,40.728082],[-73.993598,40.727091]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993598,40.727091],[-73.994894,40.728082],[-73.995251,40.726477],[-73.993598,40.727091]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99352,40.726555],[-73.993598,40.727091],[-73.995251,40.726477],[-73.99352,40.726555]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992456,40.724164],[-73.993014,40.72525],[-73.994233,40.724357],[-73.992456,40.724164]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993014,40.72525],[-73.992456,40.724164],[-73.991271,40.724802],[-73.993014,40.72525]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991262,40.726638],[-73.993014,40.72525],[-73.991271,40.724802],[-73.991262,40.726638]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993014,40.72525],[-73.991262,40.726638],[-73.99352,40.726555],[-73.993014,40.72525]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987839,40.724556],[-73.989692,40.723971],[-73.988118,40.722853],[-73.987839,40.724556]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989692,40.723971],[-73.987839,40.724556],[-73.988782,40.725368],[-73.989692,40.723971]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991271,40.723356],[-73.989692,40.723971],[-73.991271,40.724802],[-73.991271,40.723356]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99233,40.716303],[-73.989893,40.71549],[-73.991358,40.717154],[-73.99233,40.716303]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004449,40.727157],[-74.004685,40.728356],[-74.00607,40.727814],[-74.004449,40.727157]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004685,40.728356],[-74.004449,40.727157],[-74.003009,40.728246],[-74.004685,40.728356]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002951,40.729126],[-74.004685,40.728356],[-74.003009,40.728246],[-74.002951,40.729126]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004685,40.728356],[-74.002951,40.729126],[-74.003838,40.730224],[-74.004685,40.728356]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.007423,40.725401],[-74.008896,40.725431],[-74.007149,40.724135],[-74.007423,40.725401]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.006309,40.726125],[-74.007423,40.725401],[-74.007149,40.724135],[-74.006309,40.726125]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.006309,40.726125],[-74.005101,40.725391],[-74.004522,40.725944],[-74.006309,40.726125]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003372,40.724634],[-74.005101,40.725391],[-74.005313,40.724104],[-74.003372,40.724634]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.005101,40.725391],[-74.003372,40.724634],[-74.004522,40.725944],[-74.005101,40.725391]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002459,40.727111],[-74.000765,40.728746],[-74.003009,40.728246],[-74.002459,40.727111]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002459,40.727111],[-74.000574,40.72774],[-74.000765,40.728746],[-74.002459,40.727111]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004449,40.727157],[-74.002459,40.727111],[-74.003009,40.728246],[-74.004449,40.727157]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99935,40.719185],[-73.998862,40.718077],[-73.996745,40.718879],[-73.99935,40.719185]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996224,40.720805],[-73.993992,40.721459],[-73.995004,40.722523],[-73.996224,40.720805]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995004,40.722523],[-73.993992,40.721459],[-73.993398,40.723336],[-73.995004,40.722523]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993992,40.721459],[-73.992536,40.72157],[-73.993398,40.723336],[-73.993992,40.721459]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992417,40.730348],[-73.993221,40.732218],[-73.99475,40.730559],[-73.992417,40.730348]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993221,40.732218],[-73.99496,40.732252],[-73.99475,40.730559],[-73.993221,40.732218]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990546,40.730589],[-73.989511,40.729594],[-73.988948,40.730902],[-73.990546,40.730589]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989511,40.729594],[-73.991541,40.72884],[-73.990356,40.727775],[-73.989511,40.729594]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991541,40.72884],[-73.989511,40.729594],[-73.990546,40.730589],[-73.991541,40.72884]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990108,40.731706],[-73.990546,40.730589],[-73.988948,40.730902],[-73.990108,40.731706]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990386,40.725733],[-73.991262,40.726638],[-73.991271,40.724802],[-73.990386,40.725733]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989692,40.723971],[-73.990386,40.725733],[-73.991271,40.724802],[-73.989692,40.723971]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990386,40.725733],[-73.989692,40.723971],[-73.988782,40.725368],[-73.990386,40.725733]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987205,40.731971],[-73.986624,40.730273],[-73.98557,40.731555],[-73.987205,40.731971]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.9876,40.730559],[-73.986624,40.730273],[-73.987205,40.731971],[-73.9876,40.730559]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.986027,40.727621],[-73.988118,40.727513],[-73.986624,40.726123],[-73.986027,40.727621]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.985014,40.726634],[-73.986027,40.727621],[-73.986624,40.726123],[-73.985014,40.726634]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.986027,40.727621],[-73.985014,40.726634],[-73.983847,40.727621],[-73.986027,40.727621]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.986624,40.730273],[-73.988627,40.728896],[-73.986008,40.729292],[-73.986624,40.730273]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988627,40.728896],[-73.986624,40.730273],[-73.9876,40.730559],[-73.988627,40.728896]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988627,40.728896],[-73.9876,40.730559],[-73.988948,40.730902],[-73.988627,40.728896]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989511,40.729594],[-73.988627,40.728896],[-73.988948,40.730902],[-73.989511,40.729594]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988118,40.727513],[-73.988627,40.728896],[-73.990356,40.727775],[-73.988118,40.727513]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988627,40.728896],[-73.989511,40.729594],[-73.990356,40.727775],[-73.988627,40.728896]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993946,40.733867],[-73.994221,40.735535],[-73.995339,40.734007],[-73.993946,40.733867]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99496,40.732252],[-73.993946,40.733867],[-73.995339,40.734007],[-73.99496,40.732252]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993221,40.732218],[-73.993946,40.733867],[-73.99496,40.732252],[-73.993221,40.732218]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995872,40.739814],[-73.99641,40.741706],[-73.998336,40.740657],[-73.995872,40.739814]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994221,40.735535],[-73.99532,40.735486],[-73.995339,40.734007],[-73.994221,40.735535]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.97527,40.744081],[-73.976732,40.743638],[-73.975562,40.742678],[-73.97527,40.744081]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988984,40.735342],[-73.988013,40.734948],[-73.988526,40.73673],[-73.988984,40.735342]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002303,40.739491],[-73.999992,40.739661],[-74.001329,40.740687],[-74.002303,40.739491]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993542,40.741255],[-73.991456,40.740843],[-73.991069,40.742114],[-73.993542,40.741255]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.99496,40.732252],[-73.995339,40.734007],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991146,40.744559],[-73.993644,40.744647],[-73.992131,40.743135],[-73.991146,40.744559]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994566,40.743104],[-73.993542,40.741255],[-73.992131,40.743135],[-73.994566,40.743104]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993644,40.744647],[-73.994566,40.743104],[-73.992131,40.743135],[-73.993644,40.744647]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994566,40.743104],[-73.997371,40.742783],[-73.99641,40.741706],[-73.994566,40.743104]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99428,40.746001],[-73.996548,40.747117],[-73.996487,40.745112],[-73.99428,40.746001]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992381,40.734966],[-73.992297,40.736539],[-73.994221,40.735535],[-73.992381,40.734966]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992381,40.734966],[-73.993946,40.733867],[-73.992233,40.734109],[-73.992381,40.734966]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993946,40.733867],[-73.992381,40.734966],[-73.994221,40.735535],[-73.993946,40.733867]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992798,40.737555],[-73.991929,40.739312],[-73.994352,40.73854],[-73.992798,40.737555]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992798,40.737555],[-73.991236,40.737685],[-73.991929,40.739312],[-73.992798,40.737555]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992798,40.737555],[-73.992297,40.736539],[-73.991236,40.737685],[-73.992798,40.737555]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991146,40.744559],[-73.988918,40.745337],[-73.991016,40.745988],[-73.991146,40.744559]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988918,40.745337],[-73.991146,40.744559],[-73.988918,40.743416],[-73.988918,40.745337]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.009135,40.719669],[-74.007656,40.719698],[-74.008899,40.720808],[-74.009135,40.719669]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.007423,40.725401],[-74.008577,40.72694],[-74.008896,40.725431],[-74.007423,40.725401]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.008577,40.72694],[-74.009905,40.726276],[-74.008896,40.725431],[-74.008577,40.72694]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.008577,40.72694],[-74.007758,40.727767],[-74.009905,40.728038],[-74.008577,40.72694]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.009905,40.726276],[-74.008577,40.72694],[-74.009905,40.728038],[-74.009905,40.726276]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000574,40.72774],[-74.00047,40.726141],[-73.999568,40.727056],[-74.000574,40.72774]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.00047,40.726141],[-73.999786,40.725565],[-73.999568,40.727056],[-74.00047,40.726141]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002459,40.727111],[-74.00047,40.726141],[-74.000574,40.72774],[-74.002459,40.727111]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.00047,40.726141],[-74.002459,40.727111],[-74.00191,40.725837],[-74.00047,40.726141]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998277,40.724283],[-73.998082,40.725539],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996835,40.724545],[-73.998277,40.724283],[-73.997192,40.723033],[-73.996835,40.724545]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998277,40.724283],[-73.996835,40.724545],[-73.998082,40.725539],[-73.998277,40.724283]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000081,40.723949],[-73.998277,40.724283],[-73.999786,40.725565],[-74.000081,40.723949]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002984,40.726183],[-74.004449,40.727157],[-74.004522,40.725944],[-74.002984,40.726183]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002984,40.726183],[-74.002459,40.727111],[-74.004449,40.727157],[-74.002984,40.726183]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002459,40.727111],[-74.002984,40.726183],[-74.00191,40.725837],[-74.002459,40.727111]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003372,40.724634],[-74.002984,40.726183],[-74.004522,40.725944],[-74.003372,40.724634]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002984,40.726183],[-74.003372,40.724634],[-74.00191,40.725837],[-74.002984,40.726183]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003639,40.715417],[-74.002762,40.713495],[-74.002177,40.714752],[-74.003639,40.715417]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992076,40.73323],[-73.9908,40.732768],[-73.992233,40.734109],[-73.992076,40.73323]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.993946,40.733867],[-73.992076,40.73323],[-73.992233,40.734109],[-73.993946,40.733867]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992076,40.73323],[-73.993946,40.733867],[-73.993221,40.732218],[-73.992076,40.73323]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992193,40.73137],[-73.993221,40.732218],[-73.992417,40.730348],[-73.992193,40.73137]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990546,40.730589],[-73.992193,40.73137],[-73.992417,40.730348],[-73.990546,40.730589]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992076,40.73323],[-73.992193,40.73137],[-73.9908,40.732768],[-73.992076,40.73323]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992193,40.73137],[-73.992076,40.73323],[-73.993221,40.732218],[-73.992193,40.73137]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.992193,40.73137],[-73.990108,40.731706],[-73.9908,40.732768],[-73.992193,40.73137]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990108,40.731706],[-73.992193,40.73137],[-73.990546,40.730589],[-73.990108,40.731706]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988984,40.735342],[-73.989289,40.733751],[-73.988013,40.734948],[-73.988984,40.735342]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989431,40.726608],[-73.990386,40.725733],[-73.988782,40.725368],[-73.989431,40.726608]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989431,40.726608],[-73.988118,40.727513],[-73.990356,40.727775],[-73.989431,40.726608]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991262,40.726638],[-73.989431,40.726608],[-73.990356,40.727775],[-73.991262,40.726638]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990386,40.725733],[-73.989431,40.726608],[-73.991262,40.726638],[-73.990386,40.725733]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998059,40.738919],[-73.995872,40.739814],[-73.998336,40.740657],[-73.998059,40.738919]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999992,40.739661],[-73.998059,40.738919],[-73.998336,40.740657],[-73.999992,40.739661]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987481,40.72365],[-73.987839,40.724556],[-73.988118,40.722853],[-73.987481,40.72365]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987481,40.72365],[-73.986448,40.723868],[-73.987839,40.724556],[-73.987481,40.72365]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988208,40.721194],[-73.986027,40.721745],[-73.988118,40.722853],[-73.988208,40.721194]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.986027,40.721745],[-73.988208,40.721194],[-73.986375,40.719771],[-73.986027,40.721745]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.986448,40.723868],[-73.986027,40.721745],[-73.984574,40.723031],[-73.986448,40.723868]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.002881,40.733836],[-74.000548,40.734881],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000626,40.737742],[-73.999838,40.736752],[-73.998431,40.737286],[-74.000626,40.737742]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000626,40.737742],[-74.000224,40.735864],[-73.999838,40.736752],[-74.000626,40.737742]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000626,40.737742],[-73.999992,40.739661],[-74.002303,40.739491],[-74.000626,40.737742]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988996,40.74064],[-73.989904,40.739005],[-73.987609,40.73925],[-73.988996,40.74064]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.991456,40.740843],[-73.988996,40.74064],[-73.991069,40.742114],[-73.991456,40.740843]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987846,40.741939],[-73.988996,40.74064],[-73.986666,40.740788],[-73.987846,40.741939]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.988996,40.74064],[-73.987609,40.73925],[-73.986666,40.740788],[-73.988996,40.74064]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996365,40.730791],[-73.99701,40.73241],[-73.997822,40.731318],[-73.996365,40.730791]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996365,40.730791],[-73.997822,40.731318],[-73.997987,40.729969],[-73.996365,40.730791]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99496,40.732252],[-73.996365,40.730791],[-73.99475,40.730559],[-73.99496,40.732252]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.996365,40.730791],[-73.99496,40.732252],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994964,40.737011],[-73.992798,40.737555],[-73.994352,40.73854],[-73.994964,40.737011]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994964,40.737011],[-73.99532,40.735486],[-73.994221,40.735535],[-73.994964,40.737011]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000081,40.723949],[-73.998766,40.722238],[-73.998277,40.724283],[-74.000081,40.723949]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998277,40.724283],[-73.998766,40.722238],[-73.997192,40.723033],[-73.998277,40.724283]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.990108,40.731706],[-73.989503,40.732484],[-73.9908,40.732768],[-73.990108,40.731706]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989503,40.732484],[-73.989289,40.733751],[-73.9908,40.732768],[-73.989503,40.732484]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.989503,40.732484],[-73.990108,40.731706],[-73.988948,40.730902],[-73.989503,40.732484]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.987205,40.731971],[-73.989503,40.732484],[-73.988948,40.730902],[-73.987205,40.731971]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99532,40.735486],[-73.995931,40.73483],[-73.995339,40.734007],[-73.99532,40.735486]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997098,40.735596],[-73.995931,40.73483],[-73.99532,40.735486],[-73.997098,40.735596]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003721,40.73442],[-74.002465,40.735473],[-74.004622,40.735257],[-74.003721,40.73442]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003721,40.73442],[-74.002881,40.733836],[-74.002465,40.735473],[-74.003721,40.73442]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003721,40.73442],[-74.004147,40.73354],[-74.002881,40.733836],[-74.003721,40.73442]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003721,40.73442],[-74.004622,40.735257],[-74.005327,40.73427],[-74.003721,40.73442]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004147,40.73354],[-74.003721,40.73442],[-74.005327,40.73427],[-74.004147,40.73354]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.996239,40.729638],[-73.997987,40.729969],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996239,40.729638],[-73.996365,40.730791],[-73.997987,40.729969],[-73.996239,40.729638]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994762,40.729396],[-73.996239,40.729638],[-73.994894,40.728082],[-73.994762,40.729396]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996239,40.729638],[-73.997304,40.728657],[-73.994894,40.728082],[-73.996239,40.729638]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996239,40.729638],[-73.994762,40.729396],[-73.99475,40.730559],[-73.996239,40.729638]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.996365,40.730791],[-73.996239,40.729638],[-73.99475,40.730559],[-73.996365,40.730791]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99663,40.737368],[-73.994964,40.737011],[-73.994352,40.73854],[-73.99663,40.737368]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99663,40.737368],[-73.998059,40.738919],[-73.998431,40.737286],[-73.99663,40.737368]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997098,40.735596],[-73.99663,40.737368],[-73.998431,40.737286],[-73.997098,40.735596]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99663,40.737368],[-73.997098,40.735596],[-73.99532,40.735486],[-73.99663,40.737368]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.994964,40.737011],[-73.99663,40.737368],[-73.99532,40.735486],[-73.994964,40.737011]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.995931,40.73483],[-73.997098,40.735596],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.99701,40.73241],[-73.995339,40.734007],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.995931,40.73483],[-73.997234,40.733579],[-73.995339,40.734007],[-73.995931,40.73483]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002041,40.731661],[-74.001998,40.730348],[-73.999682,40.73146],[-74.002041,40.731661]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.001998,40.730348],[-74.000765,40.728746],[-73.999917,40.730016],[-74.001998,40.730348]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000765,40.728746],[-74.001998,40.730348],[-74.002951,40.729126],[-74.000765,40.728746]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002951,40.729126],[-74.001998,40.730348],[-74.003838,40.730224],[-74.002951,40.729126]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.001998,40.730348],[-74.003571,40.731504],[-74.003838,40.730224],[-74.001998,40.730348]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.003571,40.731504],[-74.001998,40.730348],[-74.002041,40.731661],[-74.003571,40.731504]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-74.002041,40.731661],[-73.999682,40.73146],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999682,40.73146],[-73.998676,40.732548],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002881,40.733836],[-74.000762,40.732961],[-74.000548,40.734881],[-74.002881,40.733836]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.997971,40.734837],[-73.999177,40.733797],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997971,40.734837],[-73.997234,40.733579],[-73.997098,40.735596],[-73.997971,40.734837]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.965726,40.764666],[-73.967397,40.764666],[-73.966639,40.763153],[-73.965726,40.764666]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.967012,40.766321],[-73.967397,40.764666],[-73.965726,40.764666],[-73.967012,40.766321]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004562,40.732376],[-74.004147,40.73354],[-74.005327,40.73427],[-74.004562,40.732376]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.004562,40.732376],[-74.003571,40.731504],[-74.004147,40.73354],[-74.004562,40.732376]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.96894,40.760966],[-73.969969,40.759115],[-73.967783,40.760284],[-73.96894,40.760966]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.971489,40.760481],[-73.969969,40.759115],[-73.96894,40.760966],[-73.971489,40.760481]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.005313,40.724104],[-74.005101,40.725391],[-74.007149,40.724135],[-74.005313,40.724104]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.005101,40.725391],[-74.006309,40.726125],[-74.007149,40.724135],[-74.005101,40.725391]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.008577,40.72694],[-74.007423,40.725401],[-74.006309,40.726125],[-74.008577,40.72694]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.008577,40.72694],[-74.006309,40.726125],[-74.007758,40.727767],[-74.008577,40.72694]]]},"type":"Feature","properties":{}}]}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = [{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.999188,40.726481]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.999188,40.726481]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.999188,40.726481]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.999188,40.726481]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.999188,40.726481]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99917946068226,40.72649111754119]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99917946068226,40.72649111754119]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99917946068226,40.72649111754119]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99917946068226,40.72649111754119]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99917946068226,40.72649111754119]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99917092136407,40.72650123507186]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99917092136407,40.72650123507186]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99917092136407,40.72650123507186]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99917092136407,40.72650123507186]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99917092136407,40.72650123507186]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99916238204538,40.72651135259201]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99916238204538,40.72651135259201]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99916238204538,40.72651135259201]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99916238204538,40.72651135259201]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99916238204538,40.72651135259201]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99915384272623,40.726521470101645]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99915384272623,40.726521470101645]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99915384272623,40.726521470101645]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99915384272623,40.726521470101645]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99915384272623,40.726521470101645]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99914530340656,40.72653158760077]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99914530340656,40.72653158760077]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99914530340656,40.72653158760077]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99914530340656,40.72653158760077]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99914530340656,40.72653158760077]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99913676408647,40.72654170508937]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99913676408647,40.72654170508937]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99913676408647,40.72654170508937]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99913676408647,40.72654170508937]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99913676408647,40.72654170508937]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99912822476587,40.72655182256746]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99912822476587,40.72655182256746]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99912822476587,40.72655182256746]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99912822476587,40.72655182256746]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99912822476587,40.72655182256746]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99911968544484,40.72656194003502]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99911968544484,40.72656194003502]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99911968544484,40.72656194003502]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99911968544484,40.72656194003502]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99911968544484,40.72656194003502]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99911114612331,40.72657205749208]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99911114612331,40.72657205749208]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99911114612331,40.72657205749208]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99911114612331,40.72657205749208]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99911114612331,40.72657205749208]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99910260680132,40.72658217493861]]},{"type":"LineString","coordinates":[[-73.998082,40.725539],[-73.99910260680132,40.72658217493861]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99910260680132,40.72658217493861]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99910260680132,40.72658217493861]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99910260680132,40.72658217493861]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99909406747882,40.726592292374626]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99909406747882,40.726592292374626]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99909406747882,40.726592292374626]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99909406747882,40.726592292374626]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99908552815592,40.72660240980013]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99908552815592,40.72660240980013]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99908552815592,40.72660240980013]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99908552815592,40.72660240980013]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99907698883247,40.72661252721512]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99907698883247,40.72661252721512]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99907698883247,40.72661252721512]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99907698883247,40.72661252721512]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99906844950857,40.72662264461959]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99906844950857,40.72662264461959]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99906844950857,40.72662264461959]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99906844950857,40.72662264461959]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99905991018422,40.72663276201354]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99905991018422,40.72663276201354]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99905991018422,40.72663276201354]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99905991018422,40.72663276201354]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99905137085936,40.72664287939698]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99905137085936,40.72664287939698]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99905137085936,40.72664287939698]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99905137085936,40.72664287939698]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99904283153407,40.72665299676989]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99904283153407,40.72665299676989]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99904283153407,40.72665299676989]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99904283153407,40.72665299676989]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99903429220826,40.72666311413229]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99903429220826,40.72666311413229]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99903429220826,40.72666311413229]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99903429220826,40.72666311413229]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.999025752882,40.72667323148418]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.999025752882,40.72667323148418]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.999025752882,40.72667323148418]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.999025752882,40.72667323148418]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99901721355528,40.726683348825546]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99901721355528,40.726683348825546]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99901721355528,40.726683348825546]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99901721355528,40.726683348825546]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99900867422805,40.7266934661564]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99900867422805,40.7266934661564]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99900867422805,40.7266934661564]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99900867422805,40.7266934661564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99900013490038,40.72670358347674]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99900013490038,40.72670358347674]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99900013490038,40.72670358347674]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99900013490038,40.72670358347674]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99899159557225,40.72671370078656]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99899159557225,40.72671370078656]]},{"type":"LineString","coordinates":[[-73.999786,40.725565],[-73.99899159557225,40.72671370078656]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99899159557225,40.72671370078656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99898305624359,40.726723818085866]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99898305624359,40.726723818085866]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99898305624359,40.726723818085866]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99897451691452,40.726733935374654]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99897451691452,40.726733935374654]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99897451691452,40.726733935374654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99896597758492,40.72674405265292]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99896597758492,40.72674405265292]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99896597758492,40.72674405265292]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99895743825488,40.72675416992067]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99895743825488,40.72675416992067]]},{"type":"LineString","coordinates":[[-74.00047,40.726141],[-73.99895743825488,40.72675416992067]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99894889892434,40.72676428717791]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99894889892434,40.72676428717791]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99894035959335,40.72677440442463]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99894035959335,40.72677440442463]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99893182026187,40.72678452166084]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99893182026187,40.72678452166084]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99892328092994,40.726794638886524]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99892328092994,40.726794638886524]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99891474159752,40.72680475610169]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99891474159752,40.72680475610169]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99890620226464,40.72681487330635]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99890620226464,40.72681487330635]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99889766293127,40.72682499050049]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99889766293127,40.72682499050049]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99888912359742,40.72683510768411]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99888912359742,40.72683510768411]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99888058426315,40.726845224857215]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99888058426315,40.726845224857215]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99887204492835,40.72685534201981]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99887204492835,40.72685534201981]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99886350559308,40.72686545917188]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99886350559308,40.72686545917188]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99885496625737,40.72687557631345]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99885496625737,40.72687557631345]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99884642692116,40.72688569344448]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99884642692116,40.72688569344448]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99883788758449,40.726895810565004]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99883788758449,40.726895810565004]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99882934824736,40.72690592767502]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99882934824736,40.72690592767502]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99882080890971,40.72691604477451]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99882080890971,40.72691604477451]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99881226957162,40.72692616186348]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99881226957162,40.72692616186348]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99880373023304,40.72693627894195]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99880373023304,40.72693627894195]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99879519089401,40.72694639600989]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99879519089401,40.72694639600989]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987866515545,40.72695651306732]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9987866515545,40.72695651306732]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99877811221451,40.726966630114234]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99877811221451,40.726966630114234]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99876957287404,40.72697674715063]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99876957287404,40.72697674715063]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987610335331,40.72698686417651]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9987610335331,40.72698686417651]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99875249419172,40.726996981191874]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99875249419172,40.726996981191874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99874395484983,40.72700709819672]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99874395484983,40.72700709819672]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99873541550747,40.727017215191054]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99873541550747,40.727017215191054]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99872687616462,40.72702733217487]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99872687616462,40.72702733217487]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99871833682134,40.72703744914817]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99871833682134,40.72703744914817]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99870979747753,40.727047566110954]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99870979747753,40.727047566110954]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99870125813331,40.72705768306322]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99870125813331,40.72705768306322]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99869271878858,40.727067800004974]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99869271878858,40.727067800004974]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99868417944339,40.72707791693621]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99868417944339,40.72707791693621]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99867564009772,40.72708803385693]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99867564009772,40.72708803385693]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99866710075159,40.72709815076714]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99866710075159,40.72709815076714]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99865856140494,40.72710826766683]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99865856140494,40.72710826766683]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99865002205787,40.727118384556]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99865002205787,40.727118384556]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9986414827103,40.727128501434656]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9986414827103,40.727128501434656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99863294336225,40.727138618302796]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99863294336225,40.727138618302796]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99862440401375,40.727148735160426]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99862440401375,40.727148735160426]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99861586466479,40.727158852007534]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99861586466479,40.727158852007534]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99860732531532,40.727168968844126]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99860732531532,40.727168968844126]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99859878596536,40.72717908567021]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99859878596536,40.72717908567021]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99859024661497,40.72718920248577]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99859024661497,40.72718920248577]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99858170726408,40.72719931929081]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99858170726408,40.72719931929081]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99857316791275,40.727209436085346]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99857316791275,40.727209436085346]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99856462856093,40.72721955286936]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99856462856093,40.72721955286936]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99855608920865,40.72722966964286]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99855608920865,40.72722966964286]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99854754985586,40.727239786405846]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99854754985586,40.727239786405846]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99853901050263,40.72724990315832]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99853901050263,40.72724990315832]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99853901050263,40.72724990315832]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9985304711489,40.727260019900264]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.9985304711489,40.727260019900264]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9985304711489,40.727260019900264]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99852193179473,40.7272701366317]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99852193179473,40.7272701366317]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99852193179473,40.7272701366317]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99851339244005,40.727280253352625]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99851339244005,40.727280253352625]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99851339244005,40.727280253352625]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99850485308494,40.72729037006303]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99850485308494,40.72729037006303]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99850485308494,40.72729037006303]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9984963137293,40.72730048676292]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.9984963137293,40.72730048676292]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9984963137293,40.72730048676292]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99848777437325,40.727310603452295]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99848777437325,40.727310603452295]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99848777437325,40.727310603452295]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99847923501666,40.727320720131154]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99847923501666,40.727320720131154]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99847923501666,40.727320720131154]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99847069565966,40.727330836799496]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99847069565966,40.727330836799496]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99847069565966,40.727330836799496]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99846215630211,40.72734095345733]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99846215630211,40.72734095345733]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99846215630211,40.72734095345733]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99845361694416,40.72735107010464]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99845361694416,40.72735107010464]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99845361694416,40.72735107010464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99844507758571,40.72736118674143]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99844507758571,40.72736118674143]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99844507758571,40.72736118674143]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99843653822678,40.72737130336772]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99843653822678,40.72737130336772]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99843653822678,40.72737130336772]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9984279988674,40.72738141998349]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.9984279988674,40.72738141998349]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9984279988674,40.72738141998349]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99841945950752,40.72739153658873]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99841945950752,40.72739153658873]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99841945950752,40.72739153658873]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99841092014718,40.72740165318348]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99841092014718,40.72740165318348]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99841092014718,40.72740165318348]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99840238078639,40.72741176976769]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99840238078639,40.72741176976769]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99840238078639,40.72741176976769]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99839384142507,40.727421886341396]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99839384142507,40.727421886341396]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99839384142507,40.727421886341396]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99838530206331,40.727432002904585]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99838530206331,40.727432002904585]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99838530206331,40.727432002904585]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99837676270108,40.727442119457265]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99837676270108,40.727442119457265]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99837676270108,40.727442119457265]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99836822333836,40.72745223599942]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99836822333836,40.72745223599942]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99836822333836,40.72745223599942]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99835968397518,40.72746235253106]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99835968397518,40.72746235253106]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99835968397518,40.72746235253106]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99835114461153,40.72747246905219]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99835114461153,40.72747246905219]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99835114461153,40.72747246905219]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9983426052474,40.727482585562804]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.9983426052474,40.727482585562804]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9983426052474,40.727482585562804]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99833406588282,40.727492702062904]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99833406588282,40.727492702062904]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99833406588282,40.727492702062904]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99832552651773,40.72750281855249]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99832552651773,40.72750281855249]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99832552651773,40.72750281855249]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99831698715217,40.727512935031555]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99831698715217,40.727512935031555]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99831698715217,40.727512935031555]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99830844778614,40.72752305150011]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99830844778614,40.72752305150011]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99830844778614,40.72752305150011]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99829990841963,40.72753316795814]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99829990841963,40.72753316795814]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99829990841963,40.72753316795814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99829136905268,40.72754328440567]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99829136905268,40.72754328440567]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99829136905268,40.72754328440567]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99828282968524,40.72755340084267]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99828282968524,40.72755340084267]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99828282968524,40.72755340084267]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99827429031731,40.72756351726916]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99827429031731,40.72756351726916]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99827429031731,40.72756351726916]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99827429031731,40.72756351726916]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99826575094893,40.72757363368514]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99826575094893,40.72757363368514]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99826575094893,40.72757363368514]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99826575094893,40.72757363368514]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99825721158005,40.7275837500906]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99825721158005,40.7275837500906]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99825721158005,40.7275837500906]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99825721158005,40.7275837500906]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99825721158005,40.7275837500906]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99824867221075,40.72759386648554]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99824867221075,40.72759386648554]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99824867221075,40.72759386648554]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99824867221075,40.72759386648554]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99824867221075,40.72759386648554]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9982401328409,40.72760398286998]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9982401328409,40.72760398286998]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9982401328409,40.72760398286998]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.9982401328409,40.72760398286998]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9982401328409,40.72760398286998]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99823159347065,40.727614099243894]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99823159347065,40.727614099243894]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99823159347065,40.727614099243894]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99823159347065,40.727614099243894]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99823159347065,40.727614099243894]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99822305409988,40.72762421560729]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99822305409988,40.72762421560729]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99822305409988,40.72762421560729]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99822305409988,40.72762421560729]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99822305409988,40.72762421560729]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99821451472866,40.72763433196018]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99821451472866,40.72763433196018]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99821451472866,40.72763433196018]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99821451472866,40.72763433196018]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99821451472866,40.72763433196018]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99820597535697,40.727644448302556]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99820597535697,40.727644448302556]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99820597535697,40.727644448302556]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99820597535697,40.727644448302556]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99820597535697,40.727644448302556]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99819743598478,40.72765456463441]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99819743598478,40.72765456463441]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99819743598478,40.72765456463441]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99819743598478,40.72765456463441]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99819743598478,40.72765456463441]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99818889661215,40.72766468095575]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99818889661215,40.72766468095575]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99818889661215,40.72766468095575]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99818889661215,40.72766468095575]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99818889661215,40.72766468095575]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998180357239,40.72767479726657]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998180357239,40.72767479726657]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998180357239,40.72767479726657]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998180357239,40.72767479726657]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998180357239,40.72767479726657]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998176,40.72768]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998176,40.72768]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998176,40.72768]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998175,40.727682]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998175,40.727682]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998175,40.727682]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998175,40.727684]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998175,40.727684]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998175,40.727684]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99818390098454,40.72768839884058]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99818390098454,40.72768839884058]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99818390098454,40.72768839884058]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99818390098454,40.72768839884058]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99818390098454,40.72768839884058]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998192801969,40.72769279768591]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998192801969,40.72769279768591]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998192801969,40.72769279768591]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.998192801969,40.72769279768591]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998192801969,40.72769279768591]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99820170295341,40.72769719653601]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99820170295341,40.72769719653601]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99820170295341,40.72769719653601]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99820170295341,40.72769719653601]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99820170295341,40.72769719653601]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99821060393772,40.727701595390876]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99821060393772,40.727701595390876]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99821060393772,40.727701595390876]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99821060393772,40.727701595390876]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99821060393772,40.727701595390876]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99821950492186,40.72770599425051]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99821950492186,40.72770599425051]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99821950492186,40.72770599425051]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99821950492186,40.72770599425051]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99821950492186,40.72770599425051]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99822840590599,40.72771039311491]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99822840590599,40.72771039311491]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99822840590599,40.72771039311491]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99822840590599,40.72771039311491]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99822840590599,40.72771039311491]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99823730689,40.72771479198408]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99823730689,40.72771479198408]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99823730689,40.72771479198408]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99823730689,40.72771479198408]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99823730689,40.72771479198408]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99824620787395,40.727719190858004]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99824620787395,40.727719190858004]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99824620787395,40.727719190858004]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99824620787395,40.727719190858004]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99824620787395,40.727719190858004]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99825510885778,40.727723589736705]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99825510885778,40.727723589736705]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99825510885778,40.727723589736705]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99825510885778,40.727723589736705]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99825510885778,40.727723589736705]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99826400984153,40.72772798862017]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99826400984153,40.72772798862017]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99826400984153,40.72772798862017]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99826400984153,40.72772798862017]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99826400984153,40.72772798862017]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99827291082516,40.7277323875084]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99827291082516,40.7277323875084]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99827291082516,40.7277323875084]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99827291082516,40.7277323875084]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99827291082516,40.7277323875084]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99828181180875,40.727736786401394]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99828181180875,40.727736786401394]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99828181180875,40.727736786401394]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99828181180875,40.727736786401394]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99828181180875,40.727736786401394]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99829071279224,40.72774118529915]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99829071279224,40.72774118529915]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99829071279224,40.72774118529915]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99829071279224,40.72774118529915]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99829071279224,40.72774118529915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99829961377563,40.72774558420168]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99829961377563,40.72774558420168]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99829961377563,40.72774558420168]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99829961377563,40.72774558420168]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99829961377563,40.72774558420168]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99830851475893,40.727749983108964]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99830851475893,40.727749983108964]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99830851475893,40.727749983108964]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99830851475893,40.727749983108964]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99830851475893,40.727749983108964]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99831741574215,40.727754382021025]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99831741574215,40.727754382021025]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99831741574215,40.727754382021025]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99831741574215,40.727754382021025]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99831741574215,40.727754382021025]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99832631672531,40.72775878093785]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99832631672531,40.72775878093785]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99832631672531,40.72775878093785]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99832631672531,40.72775878093785]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99832631672531,40.72775878093785]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99833521770832,40.72776317985944]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99833521770832,40.72776317985944]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99833521770832,40.72776317985944]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99833521770832,40.72776317985944]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99833521770832,40.72776317985944]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99834411869128,40.727767578785794]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99834411869128,40.727767578785794]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99834411869128,40.727767578785794]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99834411869128,40.727767578785794]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99834411869128,40.727767578785794]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99835301967413,40.72777197771691]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99835301967413,40.72777197771691]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99835301967413,40.72777197771691]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99835301967413,40.72777197771691]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99835301967413,40.72777197771691]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99836192065688,40.7277763766528]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99836192065688,40.7277763766528]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99836192065688,40.7277763766528]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99836192065688,40.7277763766528]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99836192065688,40.7277763766528]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99837082163955,40.72778077559345]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99837082163955,40.72778077559345]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99837082163955,40.72778077559345]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99837082163955,40.72778077559345]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99837082163955,40.72778077559345]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99837972262215,40.72778517453887]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99837972262215,40.72778517453887]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99837972262215,40.72778517453887]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99837972262215,40.72778517453887]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99837972262215,40.72778517453887]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99838862360461,40.727789573489055]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99838862360461,40.727789573489055]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99838862360461,40.727789573489055]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99838862360461,40.727789573489055]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99838862360461,40.727789573489055]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99839752458705,40.72779397244401]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99839752458705,40.72779397244401]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99839752458705,40.72779397244401]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99839752458705,40.72779397244401]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99839752458705,40.72779397244401]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99840642556939,40.72779837140373]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99840642556939,40.72779837140373]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99840642556939,40.72779837140373]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99840642556939,40.72779837140373]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99840642556939,40.72779837140373]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99841532655158,40.72780277036821]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99841532655158,40.72780277036821]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99841532655158,40.72780277036821]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99841532655158,40.72780277036821]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99841532655158,40.72780277036821]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99842422753372,40.72780716933745]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99842422753372,40.72780716933745]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99842422753372,40.72780716933745]]},{"type":"LineString","coordinates":[[-73.996831,40.727328],[-73.99842422753372,40.72780716933745]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99842422753372,40.72780716933745]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9984331285158,40.72781156831147]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9984331285158,40.72781156831147]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9984331285158,40.72781156831147]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9984331285158,40.72781156831147]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99844202949774,40.727815967290255]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99844202949774,40.727815967290255]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99844202949774,40.727815967290255]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99844202949774,40.727815967290255]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99845093047959,40.727820366273804]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99845093047959,40.727820366273804]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99845093047959,40.727820366273804]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99845093047959,40.727820366273804]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9984598314614,40.72782476526211]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9984598314614,40.72782476526211]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9984598314614,40.72782476526211]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9984598314614,40.72782476526211]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99846873244309,40.72782916425519]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99846873244309,40.72782916425519]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99846873244309,40.72782916425519]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99846873244309,40.72782916425519]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99847763342468,40.72783356325304]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99847763342468,40.72783356325304]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99847763342468,40.72783356325304]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99847763342468,40.72783356325304]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99848653440621,40.72783796225565]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99848653440621,40.72783796225565]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99848653440621,40.72783796225565]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99848653440621,40.72783796225565]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9984954353876,40.72784236126303]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9984954353876,40.72784236126303]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9984954353876,40.72784236126303]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9984954353876,40.72784236126303]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99850433636892,40.72784676027517]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99850433636892,40.72784676027517]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99850433636892,40.72784676027517]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99850433636892,40.72784676027517]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9985132373502,40.72785115929208]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9985132373502,40.72785115929208]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9985132373502,40.72785115929208]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9985132373502,40.72785115929208]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99852213833134,40.727855558313756]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99852213833134,40.727855558313756]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99852213833134,40.727855558313756]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99852213833134,40.727855558313756]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99853103931241,40.72785995734019]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99853103931241,40.72785995734019]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99853103931241,40.72785995734019]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99853103931241,40.72785995734019]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99853994029341,40.727864356371406]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99853994029341,40.727864356371406]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99853994029341,40.727864356371406]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99853994029341,40.727864356371406]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99854884127427,40.72786875540738]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99854884127427,40.72786875540738]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99854884127427,40.72786875540738]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99854884127427,40.72786875540738]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99855774225506,40.72787315444812]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99855774225506,40.72787315444812]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99855774225506,40.72787315444812]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99855774225506,40.72787315444812]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99856664323579,40.72787755349363]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99856664323579,40.72787755349363]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99856664323579,40.72787755349363]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99856664323579,40.72787755349363]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99857554421637,40.727881952543896]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99857554421637,40.727881952543896]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99857554421637,40.727881952543896]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99857554421637,40.727881952543896]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99858444519694,40.72788635159893]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99858444519694,40.72788635159893]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99858444519694,40.72788635159893]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99858444519694,40.72788635159893]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99859334617739,40.727890750658744]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99859334617739,40.727890750658744]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99859334617739,40.727890750658744]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99859334617739,40.727890750658744]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9986022471577,40.72789514972331]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9986022471577,40.72789514972331]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9986022471577,40.72789514972331]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9986022471577,40.72789514972331]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99861114813797,40.72789954879265]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99861114813797,40.72789954879265]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99861114813797,40.72789954879265]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99861114813797,40.72789954879265]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99862004911814,40.72790394786675]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99862004911814,40.72790394786675]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99862004911814,40.72790394786675]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99862004911814,40.72790394786675]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99862895009822,40.72790834694562]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99862895009822,40.72790834694562]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99862895009822,40.72790834694562]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99862895009822,40.72790834694562]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99863785107823,40.727912746029254]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99863785107823,40.727912746029254]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99863785107823,40.727912746029254]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99863785107823,40.727912746029254]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99864675205812,40.72791714511765]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99864675205812,40.72791714511765]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99864675205812,40.72791714511765]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99864675205812,40.72791714511765]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99865565303791,40.72792154421082]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99865565303791,40.72792154421082]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99865565303791,40.72792154421082]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99865565303791,40.72792154421082]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99866455401767,40.72792594330876]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99866455401767,40.72792594330876]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99866455401767,40.72792594330876]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99866455401767,40.72792594330876]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99867345499729,40.727930342411454]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99867345499729,40.727930342411454]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99867345499729,40.727930342411454]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99867345499729,40.727930342411454]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99868235597683,40.72793474151892]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99868235597683,40.72793474151892]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99868235597683,40.72793474151892]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99868235597683,40.72793474151892]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99869125695628,40.72793914063116]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99869125695628,40.72793914063116]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99869125695628,40.72793914063116]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99869125695628,40.72793914063116]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99870015793564,40.72794353974816]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99870015793564,40.72794353974816]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99870015793564,40.72794353974816]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99870015793564,40.72794353974816]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99870905891493,40.727947938869924]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99870905891493,40.727947938869924]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99870905891493,40.727947938869924]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99870905891493,40.727947938869924]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99871795989412,40.727952337996456]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99871795989412,40.727952337996456]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99871795989412,40.727952337996456]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99871795989412,40.727952337996456]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987268608732,40.727956737127755]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9987268608732,40.727956737127755]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9987268608732,40.727956737127755]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9987268608732,40.727956737127755]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987357618522,40.727961136263815]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9987357618522,40.727961136263815]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9987357618522,40.727961136263815]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9987357618522,40.727961136263815]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99874466283113,40.72796553540464]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99874466283113,40.72796553540464]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99874466283113,40.72796553540464]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99874466283113,40.72796553540464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99875356380998,40.72796993455024]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99875356380998,40.72796993455024]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99875356380998,40.72796993455024]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99875356380998,40.72796993455024]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99876246478868,40.72797433370061]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99876246478868,40.72797433370061]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99876246478868,40.72797433370061]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99876246478868,40.72797433370061]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99877136576735,40.72797873285574]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99877136576735,40.72797873285574]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99877136576735,40.72797873285574]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99878026674591,40.72798313201563]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99878026674591,40.72798313201563]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99878026674591,40.72798313201563]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99878916772435,40.72798753118029]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99878916772435,40.72798753118029]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99878916772435,40.72798753118029]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99879806870275,40.72799193034972]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99879806870275,40.72799193034972]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99879806870275,40.72799193034972]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99880696968106,40.72799632952391]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99880696968106,40.72799632952391]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99880696968106,40.72799632952391]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99881587065923,40.72800072870288]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99881587065923,40.72800072870288]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99881587065923,40.72800072870288]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99882477163737,40.728005127886604]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99882477163737,40.728005127886604]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99882477163737,40.728005127886604]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9988336726154,40.728009527075095]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9988336726154,40.728009527075095]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9988336726154,40.728009527075095]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99884257359331,40.72801392626836]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99884257359331,40.72801392626836]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99884257359331,40.72801392626836]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99885147457117,40.72801832546638]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99885147457117,40.72801832546638]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99885147457117,40.72801832546638]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99886037554892,40.728022724669174]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99886037554892,40.728022724669174]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99886037554892,40.728022724669174]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99886927652656,40.728027123876736]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99886927652656,40.728027123876736]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99886927652656,40.728027123876736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99887817750414,40.72803152308906]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99887817750414,40.72803152308906]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99887817750414,40.72803152308906]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99888707848162,40.728035922306155]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99888707848162,40.728035922306155]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99888707848162,40.728035922306155]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99889597945902,40.72804032152801]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99889597945902,40.72804032152801]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99889597945902,40.72804032152801]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99890488043634,40.72804472075464]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99890488043634,40.72804472075464]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99890488043634,40.72804472075464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99891378141355,40.728049119986025]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99891378141355,40.728049119986025]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99891378141355,40.728049119986025]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99891378141355,40.728049119986025]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99892268239068,40.728053519222186]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99892268239068,40.728053519222186]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99892268239068,40.728053519222186]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99892268239068,40.728053519222186]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99893158336772,40.72805791846311]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99893158336772,40.72805791846311]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99893158336772,40.72805791846311]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99893158336772,40.72805791846311]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99894048434466,40.7280623177088]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99894048434466,40.7280623177088]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99894048434466,40.7280623177088]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99894048434466,40.7280623177088]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99894938532154,40.72806671695926]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99894938532154,40.72806671695926]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99894938532154,40.72806671695926]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99894938532154,40.72806671695926]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998952,40.728068]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998952,40.728068]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998952,40.728068]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998953,40.728069]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998953,40.728069]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998953,40.728069]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998952,40.72807]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.998952,40.72807]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.998952,40.72807]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99894346418061,40.7280801561723]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99894346418061,40.7280801561723]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99894346418061,40.7280801561723]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99894346418061,40.7280801561723]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99893492836077,40.72809031233404]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99893492836077,40.72809031233404]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99893492836077,40.72809031233404]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99893492836077,40.72809031233404]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99892639254048,40.72810046848524]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99892639254048,40.72810046848524]]},{"type":"LineString","coordinates":[[-74.000574,40.72774],[-73.99892639254048,40.72810046848524]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99892639254048,40.72810046848524]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99891785671966,40.72811062462588]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99891785671966,40.72811062462588]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99891785671966,40.72811062462588]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99890932089838,40.728120780755965]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99890932089838,40.728120780755965]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99890932089838,40.728120780755965]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99890078507663,40.7281309368755]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99890078507663,40.7281309368755]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99890078507663,40.7281309368755]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99889224925438,40.72814109298449]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99889224925438,40.72814109298449]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99889224925438,40.72814109298449]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99888371343167,40.72815124908291]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99888371343167,40.72815124908291]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99888371343167,40.72815124908291]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99888371343167,40.72815124908291]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9988751776085,40.728161405170795]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9988751776085,40.728161405170795]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9988751776085,40.728161405170795]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.9988751776085,40.728161405170795]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99886664178483,40.72817156124812]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99886664178483,40.72817156124812]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99886664178483,40.72817156124812]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99886664178483,40.72817156124812]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99885810596068,40.7281817173149]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99885810596068,40.7281817173149]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99885810596068,40.7281817173149]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99885810596068,40.7281817173149]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99884957013606,40.72819187337111]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99884957013606,40.72819187337111]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99884957013606,40.72819187337111]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99884957013606,40.72819187337111]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99884103431098,40.728202029416785]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99884103431098,40.728202029416785]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99884103431098,40.728202029416785]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99884103431098,40.728202029416785]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99883249848541,40.7282121854519]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99883249848541,40.7282121854519]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99883249848541,40.7282121854519]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99883249848541,40.7282121854519]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99882396265936,40.72822234147647]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99882396265936,40.72822234147647]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99882396265936,40.72822234147647]]},{"type":"LineString","coordinates":[[-73.999568,40.727056],[-73.99882396265936,40.72822234147647]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99881542683283,40.72823249749048]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99881542683283,40.72823249749048]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99881542683283,40.72823249749048]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99880689100584,40.728242653493936]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99880689100584,40.728242653493936]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99880689100584,40.728242653493936]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99879835517835,40.72825280948685]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99879835517835,40.72825280948685]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99879835517835,40.72825280948685]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99878981935039,40.7282629654692]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99878981935039,40.7282629654692]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99878981935039,40.7282629654692]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99878128352195,40.728273121441]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99878128352195,40.728273121441]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99878128352195,40.728273121441]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99877274769305,40.728283277402255]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99877274769305,40.728283277402255]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99877274769305,40.728283277402255]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99876421186367,40.72829343335295]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99876421186367,40.72829343335295]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99876421186367,40.72829343335295]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987556760338,40.7283035892931]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9987556760338,40.7283035892931]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9987556760338,40.7283035892931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99874714020343,40.72831374522269]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99874714020343,40.72831374522269]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99874714020343,40.72831374522269]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99873860437263,40.728323901141735]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99873860437263,40.728323901141735]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99873860437263,40.728323901141735]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99873006854132,40.728334057050226]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99873006854132,40.728334057050226]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99873006854132,40.728334057050226]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99872153270955,40.728344212948166]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99872153270955,40.728344212948166]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99872153270955,40.728344212948166]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9987129968773,40.728354368835554]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9987129968773,40.728354368835554]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9987129968773,40.728354368835554]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99870446104458,40.72836452471238]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99870446104458,40.72836452471238]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99870446104458,40.72836452471238]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99869592521136,40.72837468057867]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99869592521136,40.72837468057867]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99869592521136,40.72837468057867]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.9986873893777,40.728384836434394]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9986873893777,40.728384836434394]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9986873893777,40.728384836434394]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99867885354352,40.728394992279576]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99867885354352,40.728394992279576]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99867885354352,40.728394992279576]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99867031770891,40.7284051481142]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99867031770891,40.7284051481142]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99867031770891,40.7284051481142]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99866178187378,40.72841530393828]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99866178187378,40.72841530393828]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99866178187378,40.72841530393828]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99865324603817,40.7284254597518]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99865324603817,40.7284254597518]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99865324603817,40.7284254597518]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998412,40.727146],[-73.99864471020211,40.728435615554766]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99864471020211,40.728435615554766]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99864471020211,40.728435615554766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9986361743656,40.72844577134718]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9986361743656,40.72844577134718]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99862763852857,40.728455927129055]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99862763852857,40.728455927129055]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99861910269108,40.72846608290036]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99861910269108,40.72846608290036]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9986105668531,40.72847623866113]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9986105668531,40.72847623866113]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99860203101464,40.728486394411334]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99860203101464,40.728486394411334]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99859349517571,40.72849655015099]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99859349517571,40.72849655015099]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99858495933631,40.7285067058801]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99858495933631,40.7285067058801]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99857642349643,40.728516861598656]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99857642349643,40.728516861598656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99856788765608,40.72852701730666]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99856788765608,40.72852701730666]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99855935181525,40.72853717300411]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99855935181525,40.72853717300411]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99855081597391,40.728547328691015]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99855081597391,40.728547328691015]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99854228013213,40.72855748436736]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99854228013213,40.72855748436736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99853374428984,40.72856764003315]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99853374428984,40.72856764003315]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9985252084471,40.7285777956884]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9985252084471,40.7285777956884]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99852,40.728584]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99852,40.728584]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99852,40.728584]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99852,40.728584]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99851144161836,40.72859390287498]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99851144161836,40.72859390287498]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99850288323626,40.72860380573964]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99850288323626,40.72860380573964]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99849432485372,40.72861370859399]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99849432485372,40.72861370859399]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99848576647071,40.72862361143802]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99848576647071,40.72862361143802]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99847720808724,40.72863351427173]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99847720808724,40.72863351427173]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99846864970333,40.72864341709513]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99846864970333,40.72864341709513]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99846009131896,40.72865331990821]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99846009131896,40.72865331990821]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99845153293417,40.72866322271098]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99845153293417,40.72866322271098]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99844297454888,40.72867312550343]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99844297454888,40.72867312550343]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99843441616315,40.728683028285566]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99843441616315,40.728683028285566]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99842585777695,40.728692931057374]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99842585777695,40.728692931057374]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99841729939035,40.728702833818886]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99841729939035,40.728702833818886]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99840874100325,40.72871273657007]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99840874100325,40.72871273657007]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99840874100325,40.72871273657007]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99840018261573,40.72872263931094]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99840018261573,40.72872263931094]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99840018261573,40.72872263931094]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99839162422774,40.728732542041485]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99839162422774,40.728732542041485]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99839162422774,40.728732542041485]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99838306583928,40.72874244476173]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99838306583928,40.72874244476173]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99838306583928,40.72874244476173]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9983745074504,40.72875234747165]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9983745074504,40.72875234747165]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9983745074504,40.72875234747165]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99836594906103,40.72876225017126]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99836594906103,40.72876225017126]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99836594906103,40.72876225017126]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99835739067122,40.72877215286054]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99835739067122,40.72877215286054]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99835739067122,40.72877215286054]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99834883228095,40.72878205553952]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99834883228095,40.72878205553952]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99834883228095,40.72878205553952]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99834027389025,40.72879195820817]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99834027389025,40.72879195820817]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99834027389025,40.72879195820817]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99833171549909,40.72880186086652]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99833171549909,40.72880186086652]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99833171549909,40.72880186086652]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99832315710745,40.72881176351454]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99832315710745,40.72881176351454]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99832315710745,40.72881176351454]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99831459871538,40.72882166615226]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99831459871538,40.72882166615226]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99831459871538,40.72882166615226]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99830604032286,40.72883156877965]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99830604032286,40.72883156877965]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99830604032286,40.72883156877965]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99829748192988,40.72884147139672]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99829748192988,40.72884147139672]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99829748192988,40.72884147139672]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99828892353645,40.72885137400349]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99828892353645,40.72885137400349]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99828892353645,40.72885137400349]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99828036514255,40.72886127659993]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99828036514255,40.72886127659993]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99828036514255,40.72886127659993]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9982718067482,40.728871179186065]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9982718067482,40.728871179186065]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9982718067482,40.728871179186065]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99826324835338,40.72888108176188]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99826324835338,40.72888108176188]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99826324835338,40.72888108176188]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998259,40.728886]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998259,40.728886]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.998259,40.728886]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.998259,40.728886]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998259,40.728886]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.998259,40.728886]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99825042625271,40.72889572623743]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99825042625271,40.72889572623743]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99825042625271,40.72889572623743]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99824185250502,40.728905452464716]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99824185250502,40.728905452464716]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99824185250502,40.728905452464716]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99823327875689,40.72891517868185]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99823327875689,40.72891517868185]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99823327875689,40.72891517868185]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9982247050083,40.728924904888835]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9982247050083,40.728924904888835]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9982247050083,40.728924904888835]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99821613125924,40.72893463108567]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99821613125924,40.72893463108567]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99821613125924,40.72893463108567]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99820755750982,40.728944357272354]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99820755750982,40.728944357272354]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99820755750982,40.728944357272354]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99819898375989,40.72895408344888]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99819898375989,40.72895408344888]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99819898375989,40.72895408344888]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99819041000958,40.72896380961527]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99819041000958,40.72896380961527]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99819041000958,40.72896380961527]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9981818362588,40.7289735357715]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9981818362588,40.7289735357715]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9981818362588,40.7289735357715]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99817326250758,40.728983261917584]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99817326250758,40.728983261917584]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99817326250758,40.728983261917584]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99816468875594,40.72899298805352]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99816468875594,40.72899298805352]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99816468875594,40.72899298805352]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99815611500385,40.7290027141793]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99815611500385,40.7290027141793]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99815611500385,40.7290027141793]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99814754125133,40.72901244029493]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99814754125133,40.72901244029493]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99814754125133,40.72901244029493]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99813896749836,40.72902216640041]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99813896749836,40.72902216640041]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99813896749836,40.72902216640041]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99813039374497,40.72903189249575]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99813039374497,40.72903189249575]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99813039374497,40.72903189249575]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99812181999113,40.72904161858092]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99812181999113,40.72904161858092]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99812181999113,40.72904161858092]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99811324623688,40.72905134465596]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99811324623688,40.72905134465596]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99811324623688,40.72905134465596]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99810467248217,40.729061070720846]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99810467248217,40.729061070720846]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99810467248217,40.729061070720846]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99809609872702,40.729070796775574]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99809609872702,40.729070796775574]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99809609872702,40.729070796775574]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99808752497144,40.729080522820155]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99808752497144,40.729080522820155]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99808752497144,40.729080522820155]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9980789512154,40.72909024885459]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9980789512154,40.72909024885459]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9980789512154,40.72909024885459]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99807037745894,40.72909997487887]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99807037745894,40.72909997487887]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99807037745894,40.72909997487887]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99806180370204,40.729109700893005]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99806180370204,40.729109700893005]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99806180370204,40.729109700893005]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9980532299447,40.729119426896986]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9980532299447,40.729119426896986]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9980532299447,40.729119426896986]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99804465618695,40.72912915289082]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99804465618695,40.72912915289082]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99804465618695,40.72912915289082]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99803608242873,40.7291388788745]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99803608242873,40.7291388788745]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99803608242873,40.7291388788745]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99802750867008,40.729148604848035]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99802750867008,40.729148604848035]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99802750867008,40.729148604848035]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99801893491099,40.72915833081142]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99801893491099,40.72915833081142]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99801893491099,40.72915833081142]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99801036115149,40.72916805676466]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99801036115149,40.72916805676466]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99801036115149,40.72916805676466]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9980017873915,40.72917778270774]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9980017873915,40.72917778270774]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9980017873915,40.72917778270774]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9979932136311,40.72918750864067]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9979932136311,40.72918750864067]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9979932136311,40.72918750864067]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99798463987028,40.72919723456346]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99798463987028,40.72919723456346]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99798463987028,40.72919723456346]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997976066109,40.72920696047609]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997976066109,40.72920696047609]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997976066109,40.72920696047609]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99796749234731,40.72921668637858]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99796749234731,40.72921668637858]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99796749234731,40.72921668637858]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99795891858516,40.729226412270904]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99795891858516,40.729226412270904]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99795891858516,40.729226412270904]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99795034482254,40.72923613815309]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99795034482254,40.72923613815309]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99795034482254,40.72923613815309]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9979417710595,40.72924586402513]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9979417710595,40.72924586402513]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9979417710595,40.72924586402513]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99793319729608,40.72925558988702]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99793319729608,40.72925558988702]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99793319729608,40.72925558988702]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99792462353217,40.72926531573875]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99792462353217,40.72926531573875]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99792462353217,40.72926531573875]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99791604976784,40.72927504158034]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99791604976784,40.72927504158034]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99791604976784,40.72927504158034]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99790747600309,40.72928476741178]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99790747600309,40.72928476741178]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99790747600309,40.72928476741178]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99789890223788,40.72929449323306]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99789890223788,40.72929449323306]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99789890223788,40.72929449323306]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99789032847221,40.729304219044195]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99789032847221,40.729304219044195]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.99789032847221,40.729304219044195]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99789032847221,40.729304219044195]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997887,40.729308]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997887,40.729308]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997887,40.729308]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997886,40.729309]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997886,40.729309]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997886,40.729309]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997887,40.72931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.997887,40.72931]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.997887,40.72931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99789589848217,40.72931446488736]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99789589848217,40.72931446488736]]},{"type":"LineString","coordinates":[[-73.996239,40.729638],[-73.99789589848217,40.72931446488736]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99789589848217,40.72931446488736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99790479696426,40.72931892977955]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99790479696426,40.72931892977955]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99790479696426,40.72931892977955]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9979136954463,40.72932339467659]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9979136954463,40.72932339467659]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9979136954463,40.72932339467659]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99792259392821,40.729327859578454]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99792259392821,40.729327859578454]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99792259392821,40.729327859578454]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99793149240999,40.729332324485156]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99793149240999,40.729332324485156]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99793149240999,40.729332324485156]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99794039089173,40.7293367893967]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99794039089173,40.7293367893967]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99794039089173,40.7293367893967]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99794928937335,40.72934125431307]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99794928937335,40.72934125431307]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99794928937335,40.72934125431307]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99795818785492,40.72934571923428]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99795818785492,40.72934571923428]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99795818785492,40.72934571923428]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99796708633635,40.72935018416033]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99796708633635,40.72935018416033]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99796708633635,40.72935018416033]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9979759848177,40.72935464909121]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9979759848177,40.72935464909121]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9979759848177,40.72935464909121]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99798488329895,40.729359114026934]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99798488329895,40.729359114026934]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99798488329895,40.729359114026934]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99799378178014,40.72936357896749]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99799378178014,40.72936357896749]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99799378178014,40.72936357896749]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99800268026121,40.72936804391288]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99800268026121,40.72936804391288]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99800268026121,40.72936804391288]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99801157874218,40.7293725088631]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99801157874218,40.7293725088631]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99801157874218,40.7293725088631]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99802047722308,40.72937697381817]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99802047722308,40.72937697381817]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99802047722308,40.72937697381817]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99802937570388,40.72938143877806]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99802937570388,40.72938143877806]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99802937570388,40.72938143877806]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99803827418461,40.7293859037428]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99803827418461,40.7293859037428]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99803827418461,40.7293859037428]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99804717266522,40.72939036871237]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99804717266522,40.72939036871237]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99804717266522,40.72939036871237]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99805607114575,40.729394833686776]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99805607114575,40.729394833686776]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99805607114575,40.729394833686776]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99806496962617,40.72939929866602]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99806496962617,40.72939929866602]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99806496962617,40.72939929866602]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99807386810652,40.729403763650105]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99807386810652,40.729403763650105]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99807386810652,40.729403763650105]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99808276658676,40.729408228639016]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99808276658676,40.729408228639016]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99808276658676,40.729408228639016]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99809166506692,40.72941269363277]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99809166506692,40.72941269363277]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99809166506692,40.72941269363277]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99810056354697,40.72941715863136]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99810056354697,40.72941715863136]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99810056354697,40.72941715863136]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99810946202696,40.72942162363478]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99810946202696,40.72942162363478]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99810946202696,40.72942162363478]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99811836050685,40.72942608864304]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99811836050685,40.72942608864304]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99811836050685,40.72942608864304]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99812725898661,40.72943055365614]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99812725898661,40.72943055365614]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99812725898661,40.72943055365614]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9981361574663,40.72943501867407]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9981361574663,40.72943501867407]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9981361574663,40.72943501867407]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99814505594594,40.72943948369684]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99814505594594,40.72943948369684]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99814505594594,40.72943948369684]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99815395442545,40.72944394872444]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99815395442545,40.72944394872444]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99815395442545,40.72944394872444]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99816285290484,40.72944841375688]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99816285290484,40.72944841375688]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99816285290484,40.72944841375688]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99817175138418,40.729452878794156]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99817175138418,40.729452878794156]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99817175138418,40.729452878794156]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99818064986344,40.729457343836266]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99818064986344,40.729457343836266]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99818064986344,40.729457343836266]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99818954834257,40.729461808883215]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99818954834257,40.729461808883215]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99818954834257,40.729461808883215]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99819844682162,40.729466273934996]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99819844682162,40.729466273934996]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99819844682162,40.729466273934996]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99820734530059,40.72947073899162]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99820734530059,40.72947073899162]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99820734530059,40.72947073899162]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99821624377944,40.729475204053074]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99821624377944,40.729475204053074]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99821624377944,40.729475204053074]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99822514225819,40.72947966911937]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99822514225819,40.72947966911937]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99822514225819,40.72947966911937]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99823404073688,40.7294841341905]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99823404073688,40.7294841341905]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99823404073688,40.7294841341905]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99824293921547,40.72948859926647]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99824293921547,40.72948859926647]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99824293921547,40.72948859926647]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99825183769397,40.72949306434727]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99825183769397,40.72949306434727]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99825183769397,40.72949306434727]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99826073617236,40.729497529432905]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99826073617236,40.729497529432905]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99826073617236,40.729497529432905]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99826963465068,40.72950199452338]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99826963465068,40.72950199452338]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99826963465068,40.72950199452338]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99827853312888,40.72950645961869]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99827853312888,40.72950645961869]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99827853312888,40.72950645961869]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99828743160703,40.72951092471884]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99828743160703,40.72951092471884]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99828743160703,40.72951092471884]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99829633008505,40.729515389823824]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99829633008505,40.729515389823824]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99829633008505,40.729515389823824]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99830522856301,40.729519854933635]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99830522856301,40.729519854933635]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99830522856301,40.729519854933635]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99831412704087,40.72952432004829]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99831412704087,40.72952432004829]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99831412704087,40.72952432004829]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99832302551862,40.72952878516779]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99832302551862,40.72952878516779]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99832302551862,40.72952878516779]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99833192399628,40.72953325029212]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99833192399628,40.72953325029212]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99833192399628,40.72953325029212]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99833192399628,40.72953325029212]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99834082247388,40.72953771542128]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99834082247388,40.72953771542128]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99834082247388,40.72953771542128]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99834082247388,40.72953771542128]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99834972095134,40.72954218055528]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99834972095134,40.72954218055528]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99834972095134,40.72954218055528]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99834972095134,40.72954218055528]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99835861942874,40.729546645694114]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99835861942874,40.729546645694114]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99835861942874,40.729546645694114]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99835861942874,40.729546645694114]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99836751790603,40.72955111083779]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99836751790603,40.72955111083779]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99836751790603,40.72955111083779]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99836751790603,40.72955111083779]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99837641638324,40.7295555759863]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99837641638324,40.7295555759863]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99837641638324,40.7295555759863]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99837641638324,40.7295555759863]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99838531486036,40.72956004113965]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99838531486036,40.72956004113965]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99838531486036,40.72956004113965]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99838531486036,40.72956004113965]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99839421333738,40.72956450629783]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99839421333738,40.72956450629783]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99839421333738,40.72956450629783]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99839421333738,40.72956450629783]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99840311181431,40.72956897146085]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99840311181431,40.72956897146085]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99840311181431,40.72956897146085]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99840311181431,40.72956897146085]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99841201029115,40.729573436628705]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99841201029115,40.729573436628705]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99841201029115,40.729573436628705]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99841201029115,40.729573436628705]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99842090876787,40.72957790180139]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99842090876787,40.72957790180139]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99842090876787,40.72957790180139]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99842090876787,40.72957790180139]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9984298072445,40.729582366978924]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.9984298072445,40.729582366978924]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9984298072445,40.729582366978924]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9984298072445,40.729582366978924]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99843870572109,40.72958683216129]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99843870572109,40.72958683216129]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99843870572109,40.72958683216129]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99843870572109,40.72958683216129]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99844760419757,40.72959129734849]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99844760419757,40.72959129734849]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99844760419757,40.72959129734849]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99844760419757,40.72959129734849]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99845650267393,40.72959576254052]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99845650267393,40.72959576254052]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99845650267393,40.72959576254052]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99845650267393,40.72959576254052]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99846540115023,40.7296002277374]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99846540115023,40.7296002277374]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99846540115023,40.7296002277374]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99846540115023,40.7296002277374]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99847429962641,40.729604692939105]]},{"type":"LineString","coordinates":[[-73.997304,40.728657],[-73.99847429962641,40.729604692939105]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99847429962641,40.729604692939105]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99847429962641,40.729604692939105]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99848319810252,40.72960915814566]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99848319810252,40.72960915814566]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99848319810252,40.72960915814566]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99849209657852,40.72961362335704]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99849209657852,40.72961362335704]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99849209657852,40.72961362335704]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99850099505443,40.72961808857326]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99850099505443,40.72961808857326]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99850099505443,40.72961808857326]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99850989353025,40.729622553794314]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99850989353025,40.729622553794314]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99850989353025,40.729622553794314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.998518792006,40.72962701902021]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998518792006,40.72962701902021]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.998518792006,40.72962701902021]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99852769048162,40.72963148425094]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99852769048162,40.72963148425094]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99852769048162,40.72963148425094]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9985365889572,40.7296359494865]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9985365889572,40.7296359494865]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9985365889572,40.7296359494865]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99854548743265,40.7296404147269]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99854548743265,40.7296404147269]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99854548743265,40.7296404147269]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.998554385908,40.72964487997214]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.998554385908,40.72964487997214]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.998554385908,40.72964487997214]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99856328438328,40.729649345222214]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99856328438328,40.729649345222214]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99856328438328,40.729649345222214]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99857218285842,40.729653810477124]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99857218285842,40.729653810477124]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99857218285842,40.729653810477124]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9985810813335,40.729658275736874]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9985810813335,40.729658275736874]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9985810813335,40.729658275736874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99858997980849,40.729662741001455]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99858997980849,40.729662741001455]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99858997980849,40.729662741001455]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9985988782834,40.729667206270875]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9985988782834,40.729667206270875]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9985988782834,40.729667206270875]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99860777675822,40.729671671545134]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99860777675822,40.729671671545134]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99860777675822,40.729671671545134]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99861667523292,40.729676136824224]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99861667523292,40.729676136824224]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99861667523292,40.729676136824224]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99862557370756,40.72968060210816]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99862557370756,40.72968060210816]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99862557370756,40.72968060210816]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99863447218209,40.72968506739692]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99863447218209,40.72968506739692]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99863447218209,40.72968506739692]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99864337065652,40.72968953269053]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99864337065652,40.72968953269053]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99864337065652,40.72968953269053]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99865226913089,40.72969399798897]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99865226913089,40.72969399798897]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99865226913089,40.72969399798897]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99866116760515,40.72969846329224]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99866116760515,40.72969846329224]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99866116760515,40.72969846329224]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9986700660793,40.72970292860036]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9986700660793,40.72970292860036]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9986700660793,40.72970292860036]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99867896455338,40.7297073939133]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99867896455338,40.7297073939133]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99867896455338,40.7297073939133]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99868786302736,40.72971185923109]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99868786302736,40.72971185923109]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99868786302736,40.72971185923109]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99869676150124,40.72971632455371]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99869676150124,40.72971632455371]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99869676150124,40.72971632455371]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99870565997502,40.72972078988117]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99870565997502,40.72972078988117]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99870565997502,40.72972078988117]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99871455844873,40.72972525521347]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99871455844873,40.72972525521347]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99871455844873,40.72972525521347]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99872345692232,40.7297297205506]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99872345692232,40.7297297205506]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99872345692232,40.7297297205506]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99873235539586,40.729734185892575]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99873235539586,40.729734185892575]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99873235539586,40.729734185892575]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99874125386926,40.72973865123938]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99874125386926,40.72973865123938]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99874125386926,40.72973865123938]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99875015234261,40.729743116591024]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99875015234261,40.729743116591024]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99875015234261,40.729743116591024]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99875905081585,40.7297475819475]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99875905081585,40.7297475819475]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99875905081585,40.7297475819475]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99876794928902,40.729752047308814]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99876794928902,40.729752047308814]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99876794928902,40.729752047308814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99877684776204,40.72975651267497]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99877684776204,40.72975651267497]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99877684776204,40.72975651267497]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99878574623504,40.72976097804596]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99878574623504,40.72976097804596]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99878574623504,40.72976097804596]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99879464470791,40.72976544342178]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99879464470791,40.72976544342178]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99879464470791,40.72976544342178]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99880354318068,40.729769908802446]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99880354318068,40.729769908802446]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99880354318068,40.729769908802446]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99881244165334,40.72977437418795]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99881244165334,40.72977437418795]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99881244165334,40.72977437418795]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99882134012594,40.72977883957828]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99882134012594,40.72977883957828]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99882134012594,40.72977883957828]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99883023859846,40.72978330497346]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99883023859846,40.72978330497346]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99883023859846,40.72978330497346]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99883913707087,40.72978777037347]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99883913707087,40.72978777037347]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99883913707087,40.72978777037347]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99884803554319,40.72979223577831]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99884803554319,40.72979223577831]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99884803554319,40.72979223577831]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9988569340154,40.729796701188]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9988569340154,40.729796701188]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9988569340154,40.729796701188]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99886583248755,40.72980116660252]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99886583248755,40.72980116660252]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99886583248755,40.72980116660252]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9988747309596,40.72980563202187]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9988747309596,40.72980563202187]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9988747309596,40.72980563202187]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99888362943156,40.72981009744607]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99888362943156,40.72981009744607]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99888362943156,40.72981009744607]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99889252790341,40.7298145628751]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99889252790341,40.7298145628751]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99889252790341,40.7298145628751]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99890142637518,40.72981902830897]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99890142637518,40.72981902830897]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99890142637518,40.72981902830897]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99891032484682,40.729823493747666]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99891032484682,40.729823493747666]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99891032484682,40.729823493747666]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99891922331842,40.72982795919121]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99891922331842,40.72982795919121]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99891922331842,40.72982795919121]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9989281217899,40.72983242463958]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9989281217899,40.72983242463958]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9989281217899,40.72983242463958]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99893702026128,40.7298368900928]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99893702026128,40.7298368900928]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99893702026128,40.7298368900928]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9989459187326,40.72984135555085]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9989459187326,40.72984135555085]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9989459187326,40.72984135555085]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99895481720382,40.72984582101374]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99895481720382,40.72984582101374]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99895481720382,40.72984582101374]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99896371567493,40.72985028648147]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99896371567493,40.72985028648147]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99896371567493,40.72985028648147]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99897261414597,40.72985475195403]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99897261414597,40.72985475195403]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99897261414597,40.72985475195403]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99898151261691,40.729859217431425]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99898151261691,40.729859217431425]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99898151261691,40.729859217431425]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99899041108773,40.72986368291366]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99899041108773,40.72986368291366]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99899041108773,40.72986368291366]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99899930955847,40.72986814840073]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99899930955847,40.72986814840073]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99899930955847,40.72986814840073]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99900820802914,40.729872613892645]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99900820802914,40.729872613892645]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99900820802914,40.729872613892645]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99901710649969,40.72987707938939]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99901710649969,40.72987707938939]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99901710649969,40.72987707938939]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99902600497018,40.72988154489097]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99902600497018,40.72988154489097]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99902600497018,40.72988154489097]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99903490344057,40.729886010397394]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99903490344057,40.729886010397394]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99903490344057,40.729886010397394]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99904380191087,40.729890475908654]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99904380191087,40.729890475908654]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99904380191087,40.729890475908654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99905270038104,40.729894941424746]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99905270038104,40.729894941424746]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99905270038104,40.729894941424746]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99906159885117,40.72989940694568]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99906159885117,40.72989940694568]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99906159885117,40.72989940694568]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99907049732116,40.729903872471446]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99907049732116,40.729903872471446]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99907049732116,40.729903872471446]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9990793957911,40.72990833800205]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.9990793957911,40.72990833800205]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9990793957911,40.72990833800205]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99908829426091,40.72991280353749]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99908829426091,40.72991280353749]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99908829426091,40.72991280353749]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99909719273067,40.729917269077774]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99909719273067,40.729917269077774]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99909719273067,40.729917269077774]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99910609120032,40.729921734622884]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99910609120032,40.729921734622884]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99910609120032,40.729921734622884]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99911498966986,40.72992620017284]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99911498966986,40.72992620017284]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99911498966986,40.72992620017284]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99912388813932,40.72993066572763]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99912388813932,40.72993066572763]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99912388813932,40.72993066572763]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99913278660871,40.729935131287256]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99913278660871,40.729935131287256]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99913278660871,40.729935131287256]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99914168507794,40.72993959685172]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99914168507794,40.72993959685172]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99914168507794,40.72993959685172]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99915058354713,40.72994406242102]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99915058354713,40.72994406242102]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99915058354713,40.72994406242102]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99915948201622,40.729948527995155]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99915948201622,40.729948527995155]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99915948201622,40.729948527995155]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99916838048523,40.72995299357413]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99916838048523,40.72995299357413]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99916838048523,40.72995299357413]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99917727895414,40.729957459157944]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99917727895414,40.729957459157944]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99917727895414,40.729957459157944]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99918617742294,40.7299619247466]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99918617742294,40.7299619247466]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99918617742294,40.7299619247466]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99919507589168,40.72996639034008]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99919507589168,40.72996639034008]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99919507589168,40.72996639034008]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99920397436031,40.729970855938404]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99920397436031,40.729970855938404]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99920397436031,40.729970855938404]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99921287282883,40.72997532154156]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99921287282883,40.72997532154156]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99921287282883,40.72997532154156]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99922177129729,40.72997978714956]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99922177129729,40.72997978714956]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99922177129729,40.72997978714956]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99923066976565,40.72998425276239]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99923066976565,40.72998425276239]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99923066976565,40.72998425276239]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99923956823389,40.72998871838007]]},{"type":"LineString","coordinates":[[-73.999128,40.728689],[-73.99923956823389,40.72998871838007]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99923956823389,40.72998871838007]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9992484667021,40.72999318400258]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9992484667021,40.72999318400258]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99925736517017,40.72999764962992]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99925736517017,40.72999764962992]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99926626363812,40.7300021152621]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99926626363812,40.7300021152621]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99927516210602,40.73000658089912]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99927516210602,40.73000658089912]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99928406057381,40.73001104654099]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99928406057381,40.73001104654099]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99929295904151,40.73001551218768]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99929295904151,40.73001551218768]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99930185750914,40.730019977839206]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99930185750914,40.730019977839206]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99931075597668,40.73002444349557]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99931075597668,40.73002444349557]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99931965444412,40.73002890915678]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99931965444412,40.73002890915678]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99932855291144,40.730033374822824]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99932855291144,40.730033374822824]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99933745137868,40.7300378404937]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99933745137868,40.7300378404937]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99934634984585,40.73004230616942]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99934634984585,40.73004230616942]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9993552483129,40.73004677184998]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9993552483129,40.73004677184998]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99936414677988,40.73005123753537]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99936414677988,40.73005123753537]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99937304524677,40.730055703225595]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99937304524677,40.730055703225595]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99938194371353,40.730060168920666]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99938194371353,40.730060168920666]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9993908421802,40.73006463462057]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9993908421802,40.73006463462057]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99939974064684,40.73006910032531]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99939974064684,40.73006910032531]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99940863911334,40.73007356603489]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99940863911334,40.73007356603489]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99941753757977,40.7300780317493]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99941753757977,40.7300780317493]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9994264360461,40.73008249746855]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9994264360461,40.73008249746855]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99943533451228,40.73008696319264]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99943533451228,40.73008696319264]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99944423297845,40.730091428921575]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99944423297845,40.730091428921575]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9994531314445,40.730095894655335]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9994531314445,40.730095894655335]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99946202991045,40.730100360393934]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99946202991045,40.730100360393934]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99947092837631,40.73010482613738]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99947092837631,40.73010482613738]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99947982684208,40.730109291885654]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99947982684208,40.730109291885654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99948872530774,40.73011375763877]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99948872530774,40.73011375763877]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99949762377334,40.730118223396715]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99949762377334,40.730118223396715]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99950652223886,40.73012268915951]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99950652223886,40.73012268915951]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99951542070426,40.73012715492713]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99951542070426,40.73012715492713]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99952431916954,40.730131620699595]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99952431916954,40.730131620699595]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99953321763478,40.7301360864769]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99953321763478,40.7301360864769]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9995421160999,40.73014055225903]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9995421160999,40.73014055225903]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99955101456494,40.73014501804601]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99955101456494,40.73014501804601]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99955991302987,40.73014948383783]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99955991302987,40.73014948383783]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99956881149471,40.73015394963447]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99956881149471,40.73015394963447]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99957770995945,40.73015841543596]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99957770995945,40.73015841543596]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99957770995945,40.73015841543596]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99958660842414,40.730162881242286]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99958660842414,40.730162881242286]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99958660842414,40.730162881242286]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99959550688871,40.730167347053445]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99959550688871,40.730167347053445]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99959550688871,40.730167347053445]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99960440535321,40.73017181286945]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99960440535321,40.73017181286945]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99960440535321,40.73017181286945]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99961330381757,40.73017627869029]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99961330381757,40.73017627869029]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99961330381757,40.73017627869029]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99962220228188,40.73018074451596]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99962220228188,40.73018074451596]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99962220228188,40.73018074451596]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99963110074607,40.73018521034647]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99963110074607,40.73018521034647]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99963110074607,40.73018521034647]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9996399992102,40.730189676181816]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9996399992102,40.730189676181816]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9996399992102,40.730189676181816]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9996488976742,40.730194142022]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9996488976742,40.730194142022]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.9996488976742,40.730194142022]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99965779613811,40.73019860786703]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99965779613811,40.73019860786703]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99965779613811,40.73019860786703]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99966669460197,40.73020307371689]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99966669460197,40.73020307371689]]},{"type":"LineString","coordinates":[[-73.997987,40.729969],[-73.99966669460197,40.73020307371689]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99967559306569,40.730207539571595]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99967559306569,40.730207539571595]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99968449152935,40.730212005431135]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99968449152935,40.730212005431135]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99969338999291,40.7302164712955]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99969338999291,40.7302164712955]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99970228845636,40.73022093716472]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99970228845636,40.73022093716472]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99971118691975,40.730225403038766]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99971118691975,40.730225403038766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99972008538305,40.730229868917654]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99972008538305,40.730229868917654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9997289838462,40.730234334801374]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9997289838462,40.730234334801374]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99973788230932,40.73023880068994]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99973788230932,40.73023880068994]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99974678077231,40.730243266583344]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99974678077231,40.730243266583344]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99975567923524,40.73024773248158]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99975567923524,40.73024773248158]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99976457769804,40.730252198384655]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99976457769804,40.730252198384655]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99977347616075,40.73025666429256]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99977347616075,40.73025666429256]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99978237462341,40.730261130205314]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99978237462341,40.730261130205314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99979127308595,40.7302655961229]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99979127308595,40.7302655961229]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9998001715484,40.73027006204533]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9998001715484,40.73027006204533]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99980907001076,40.73027452797259]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99980907001076,40.73027452797259]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99981796847304,40.73027899390469]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99981796847304,40.73027899390469]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99982686693521,40.73028345984163]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99982686693521,40.73028345984163]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9998357653973,40.7302879257834]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9998357653973,40.7302879257834]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99984466385928,40.73029239173002]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99984466385928,40.73029239173002]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99985356232118,40.73029685768147]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99985356232118,40.73029685768147]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999862460783,40.73030132363776]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.999862460783,40.73030132363776]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9998713592447,40.73030578959889]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9998713592447,40.73030578959889]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99988025770628,40.730310255564845]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99988025770628,40.730310255564845]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99988915616784,40.730314721535656]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99988915616784,40.730314721535656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99989805462928,40.73031918751129]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99989805462928,40.73031918751129]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9999069530906,40.730323653491766]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9999069530906,40.730323653491766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99991585155186,40.73032811947708]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99991585155186,40.73032811947708]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99992475001305,40.73033258546724]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99992475001305,40.73033258546724]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99993364847408,40.73033705146223]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99993364847408,40.73033705146223]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99994254693506,40.73034151746205]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99994254693506,40.73034151746205]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99995144539594,40.73034598346672]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99995144539594,40.73034598346672]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99996034385674,40.73035044947623]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99996034385674,40.73035044947623]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99996924231742,40.730354915490565]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99996924231742,40.730354915490565]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99997814077804,40.73035938150975]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99997814077804,40.73035938150975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99998703923856,40.730363847533766]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99998703923856,40.730363847533766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99999593769897,40.730368313562614]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99999593769897,40.730368313562614]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00000483615929,40.73037277959631]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00000483615929,40.73037277959631]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00001373461956,40.730377245634834]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00001373461956,40.730377245634834]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00002263307968,40.730381711678206]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00002263307968,40.730381711678206]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00003153153973,40.73038617772641]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00003153153973,40.73038617772641]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00004042999971,40.73039064377946]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00004042999971,40.73039064377946]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.0000493284596,40.73039510983734]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.0000493284596,40.73039510983734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00005822691934,40.73039957590006]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00005822691934,40.73039957590006]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00006712537903,40.73040404196762]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00006712537903,40.73040404196762]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00007602383863,40.730408508040014]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00007602383863,40.730408508040014]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00008492229811,40.73041297411725]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00008492229811,40.73041297411725]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00009382075754,40.73041744019931]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00009382075754,40.73041744019931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00010271921686,40.730421906286224]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00010271921686,40.730421906286224]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00011161767605,40.73042637237797]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00011161767605,40.73042637237797]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.000119,40.73043]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.000119,40.73043]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.000119,40.73043]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.000119,40.73043]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00012,40.730431]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00012,40.730431]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00012,40.730431]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00012,40.730431]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.000119,40.730433]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.000119,40.730433]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.000119,40.730433]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.000119,40.730433]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.0001104487632,40.73044298474101]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.0001104487632,40.73044298474101]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00010189752598,40.73045296947162]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00010189752598,40.73045296947162]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00009334628828,40.73046295419184]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00009334628828,40.73046295419184]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00008479505011,40.73047293890167]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00008479505011,40.73047293890167]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00007624381149,40.730482923601095]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00007624381149,40.730482923601095]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.0000676925724,40.73049290829014]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.0000676925724,40.73049290829014]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00005914133286,40.73050289296879]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00005914133286,40.73050289296879]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00005059009285,40.73051287763704]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00005059009285,40.73051287763704]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00004203885237,40.7305228622949]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00004203885237,40.7305228622949]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00003348761146,40.73053284694236]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00003348761146,40.73053284694236]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00002493637005,40.73054283157942]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00002493637005,40.73054283157942]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.00001638512822,40.7305528162061]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.00001638512822,40.7305528162061]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-74.0000078338859,40.730562800822376]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-74.0000078338859,40.730562800822376]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99999928264313,40.73057278542827]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99999928264313,40.73057278542827]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99999073139989,40.730582770023766]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99999073139989,40.730582770023766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99998218015621,40.730592754608864]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99998218015621,40.730592754608864]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99997362891204,40.730602739183574]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99997362891204,40.730602739183574]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99996507766743,40.73061272374788]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99996507766743,40.73061272374788]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99995652642235,40.73062270830181]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99995652642235,40.73062270830181]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9999479751768,40.73063269284533]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9999479751768,40.73063269284533]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99993942393081,40.73064267737847]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99993942393081,40.73064267737847]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99993087268436,40.7306526619012]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99993087268436,40.7306526619012]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99992232143742,40.73066264641355]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99992232143742,40.73066264641355]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99991377019003,40.7306726309155]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99991377019003,40.7306726309155]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99990521894219,40.73068261540706]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99990521894219,40.73068261540706]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99989666769387,40.73069259988822]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99989666769387,40.73069259988822]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9998881164451,40.730702584358994]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9998881164451,40.730702584358994]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99987956519588,40.73071256881938]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99987956519588,40.73071256881938]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99987101394622,40.73072255326936]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99987101394622,40.73072255326936]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99986246269607,40.73073253770895]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99986246269607,40.73073253770895]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99985391144543,40.730742522138144]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99985391144543,40.730742522138144]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99984536019439,40.730752506556954]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99984536019439,40.730752506556954]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99983680894286,40.73076249096536]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99983680894286,40.73076249096536]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99982825769085,40.73077247536338]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99982825769085,40.73077247536338]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99981970643839,40.730782459751005]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99981970643839,40.730782459751005]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99981115518548,40.73079244412823]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99981115518548,40.73079244412823]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9998026039321,40.73080242849507]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9998026039321,40.73080242849507]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99979405267827,40.730812412851506]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99979405267827,40.730812412851506]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99978550142397,40.730822397197564]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99978550142397,40.730822397197564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99977695016923,40.73083238153322]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99977695016923,40.73083238153322]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999768398914,40.73084236585848]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.999768398914,40.73084236585848]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99975984765831,40.73085235017335]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99975984765831,40.73085235017335]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99975129640218,40.73086233447783]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99975129640218,40.73086233447783]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99974274514557,40.730872318771915]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99974274514557,40.730872318771915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99973419388847,40.7308823030556]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99973419388847,40.7308823030556]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99972564263099,40.7308922873289]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99972564263099,40.7308922873289]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99971709137297,40.7309022715918]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99971709137297,40.7309022715918]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99970854011457,40.730912255844316]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99970854011457,40.730912255844316]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99969998885562,40.730922240086436]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99969998885562,40.730922240086436]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99969143759624,40.73093222431816]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99969143759624,40.73093222431816]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99968288633646,40.73094220853949]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99968288633646,40.73094220853949]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99967433507614,40.73095219275043]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99967433507614,40.73095219275043]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9996657838154,40.730962176950975]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.9996657838154,40.730962176950975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99965723255417,40.730972161141125]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99965723255417,40.730972161141125]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99964868129251,40.73098214532089]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99964868129251,40.73098214532089]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99964013003039,40.73099212949025]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99964013003039,40.73099212949025]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99963157876778,40.731002113649225]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99963157876778,40.731002113649225]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99962302750471,40.73101209779781]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99962302750471,40.73101209779781]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99961447624119,40.73102208193599]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99961447624119,40.73102208193599]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99960592497723,40.73103206606378]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99960592497723,40.73103206606378]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99959737371277,40.73104205018119]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99959737371277,40.73104205018119]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999594,40.731046]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.999594,40.731046]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999594,40.731046]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.999594,40.731046]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99958546447631,40.731056159839326]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99958546447631,40.731056159839326]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99957692895215,40.73106631966809]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99957692895215,40.73106631966809]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99956839342755,40.73107647948629]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99956839342755,40.73107647948629]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99955985790245,40.73108663929394]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99955985790245,40.73108663929394]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99955132237685,40.73109679909104]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99955132237685,40.73109679909104]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99954278685078,40.73110695887758]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99954278685078,40.73110695887758]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99953425132425,40.731117118653565]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99953425132425,40.731117118653565]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99952571579723,40.73112727841899]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99952571579723,40.73112727841899]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99951718026973,40.73113743817387]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99951718026973,40.73113743817387]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99951718026973,40.73113743817387]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99950864474177,40.73114759791818]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99950864474177,40.73114759791818]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99950864474177,40.73114759791818]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99950010921333,40.731157757651935]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99950010921333,40.731157757651935]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99950010921333,40.731157757651935]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99949157368442,40.73116791737514]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99949157368442,40.73116791737514]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99949157368442,40.73116791737514]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99948303815498,40.73117807708778]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99948303815498,40.73117807708778]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99948303815498,40.73117807708778]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99947450262512,40.731188236789876]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99947450262512,40.731188236789876]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99947450262512,40.731188236789876]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99946596709478,40.7311983964814]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99946596709478,40.7311983964814]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99946596709478,40.7311983964814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99945743156393,40.73120855616238]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99945743156393,40.73120855616238]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99945743156393,40.73120855616238]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99944889603262,40.7312187158328]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99944889603262,40.7312187158328]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99944889603262,40.7312187158328]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99944036050086,40.73122887549267]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99944036050086,40.73122887549267]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99944036050086,40.73122887549267]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99943182496858,40.731239035141975]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99943182496858,40.731239035141975]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99943182496858,40.731239035141975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99942328943581,40.73124919478072]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99942328943581,40.73124919478072]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99942328943581,40.73124919478072]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99941475390258,40.73125935440893]]},{"type":"LineString","coordinates":[[-73.999917,40.730016],[-73.99941475390258,40.73125935440893]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99941475390258,40.73125935440893]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99940621836892,40.731269514026565]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99940621836892,40.731269514026565]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99939768283473,40.73127967363365]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99939768283473,40.73127967363365]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99938914730005,40.73128983323018]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99938914730005,40.73128983323018]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99938061176495,40.73129999281615]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99938061176495,40.73129999281615]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99937207622935,40.731310152391565]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99937207622935,40.731310152391565]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99936354069324,40.73132031195642]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99936354069324,40.73132031195642]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99935500515667,40.731330471510724]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99935500515667,40.731330471510724]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99934646961967,40.73134063105447]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99934646961967,40.73134063105447]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99933793408212,40.73135079058767]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99933793408212,40.73135079058767]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99933793408212,40.73135079058767]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99932939854415,40.73136095011031]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99932939854415,40.73136095011031]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99932939854415,40.73136095011031]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99932086300566,40.73137110962239]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99932086300566,40.73137110962239]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99932086300566,40.73137110962239]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99931232746675,40.731381269123915]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99931232746675,40.731381269123915]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99931232746675,40.731381269123915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99930379192729,40.73139142861488]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99930379192729,40.73139142861488]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99930379192729,40.73139142861488]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99929525638737,40.73140158809529]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99929525638737,40.73140158809529]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99929525638737,40.73140158809529]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999286720847,40.73141174756515]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999286720847,40.73141174756515]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.999286720847,40.73141174756515]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99927818530611,40.731421907024455]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99927818530611,40.731421907024455]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99927818530611,40.731421907024455]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99926964976478,40.7314320664732]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99926964976478,40.7314320664732]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99926964976478,40.7314320664732]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999261114223,40.73144222591139]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999261114223,40.73144222591139]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.999261114223,40.73144222591139]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99925257868071,40.73145238533902]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99925257868071,40.73145238533902]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99925257868071,40.73145238533902]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99924404313795,40.7314625447561]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99924404313795,40.7314625447561]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99924404313795,40.7314625447561]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9992355075947,40.73147270416262]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9992355075947,40.73147270416262]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9992355075947,40.73147270416262]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99922697205098,40.73148286355858]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99922697205098,40.73148286355858]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99922697205098,40.73148286355858]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99921843650675,40.731493022944]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99921843650675,40.731493022944]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99921843650675,40.731493022944]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99920990096209,40.73150318231885]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99920990096209,40.73150318231885]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99920990096209,40.73150318231885]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99920136541694,40.73151334168315]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99920136541694,40.73151334168315]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99920136541694,40.73151334168315]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99919282987132,40.7315235010369]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99919282987132,40.7315235010369]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99919282987132,40.7315235010369]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99918429432518,40.73153366038008]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99918429432518,40.73153366038008]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99918429432518,40.73153366038008]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99917575877862,40.73154381971272]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99917575877862,40.73154381971272]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99917575877862,40.73154381971272]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99916722323155,40.73155397903479]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99916722323155,40.73155397903479]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99916722323155,40.73155397903479]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99915868768402,40.73156413834631]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99915868768402,40.73156413834631]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99915868768402,40.73156413834631]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999150152136,40.73157429764728]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.999150152136,40.73157429764728]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.999150152136,40.73157429764728]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9991416165875,40.73158445693769]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9991416165875,40.73158445693769]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9991416165875,40.73158445693769]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99913308103854,40.73159461621754]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99913308103854,40.73159461621754]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99913308103854,40.73159461621754]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99912454548907,40.73160477548684]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99912454548907,40.73160477548684]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99912454548907,40.73160477548684]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99911600993914,40.731614934745586]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99911600993914,40.731614934745586]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99911600993914,40.731614934745586]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99910747438874,40.73162509399377]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99910747438874,40.73162509399377]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99910747438874,40.73162509399377]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9991,40.731634]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9991,40.731634]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9991,40.731634]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9991,40.731634]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9991,40.731634]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9991,40.731634]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9990914560668,40.7316440660752]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9990914560668,40.7316440660752]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9990914560668,40.7316440660752]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99908291213316,40.73165413213993]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99908291213316,40.73165413213993]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99908291213316,40.73165413213993]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99907436819905,40.73166419819419]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99907436819905,40.73166419819419]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99907436819905,40.73166419819419]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99906582426446,40.73167426423798]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99906582426446,40.73167426423798]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99906582426446,40.73167426423798]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99905728032935,40.7316843302713]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99905728032935,40.7316843302713]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99905728032935,40.7316843302713]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99904873639383,40.73169439629415]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99904873639383,40.73169439629415]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99904873639383,40.73169439629415]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99904019245783,40.73170446230654]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99904019245783,40.73170446230654]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99904019245783,40.73170446230654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99903164852135,40.73171452830845]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99903164852135,40.73171452830845]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99903164852135,40.73171452830845]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99902310458442,40.7317245942999]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99902310458442,40.7317245942999]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99902310458442,40.7317245942999]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99901456064701,40.73173466028088]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99901456064701,40.73173466028088]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99901456064701,40.73173466028088]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99900601670915,40.73174472625139]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99900601670915,40.73174472625139]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99900601670915,40.73174472625139]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99899747277081,40.731754792211426]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99899747277081,40.731754792211426]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99899747277081,40.731754792211426]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99898892883198,40.731764858161]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99898892883198,40.731764858161]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99898892883198,40.731764858161]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99898038489272,40.7317749241001]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99898038489272,40.7317749241001]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99898038489272,40.7317749241001]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99897184095296,40.73178499002874]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99897184095296,40.73178499002874]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99897184095296,40.73178499002874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99896329701275,40.731795055946904]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99896329701275,40.731795055946904]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99896329701275,40.731795055946904]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99895475307207,40.7318051218546]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99895475307207,40.7318051218546]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99895475307207,40.7318051218546]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99894620913089,40.731815187751835]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99894620913089,40.731815187751835]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99894620913089,40.731815187751835]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99893766518927,40.73182525363859]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99893766518927,40.73182525363859]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99893766518927,40.73182525363859]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99892912124717,40.73183531951488]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99892912124717,40.73183531951488]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99892912124717,40.73183531951488]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99892057730462,40.7318453853807]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99892057730462,40.7318453853807]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99892057730462,40.7318453853807]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99891203336159,40.73185545123605]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99891203336159,40.73185545123605]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99891203336159,40.73185545123605]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99890348941808,40.73186551708094]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99890348941808,40.73186551708094]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99890348941808,40.73186551708094]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99889494547412,40.73187558291535]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99889494547412,40.73187558291535]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99889494547412,40.73187558291535]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99888640152969,40.73188564873931]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99888640152969,40.73188564873931]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99888640152969,40.73188564873931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99887785758477,40.731895714552785]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99887785758477,40.731895714552785]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99887785758477,40.731895714552785]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9988693136394,40.731905780355795]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9988693136394,40.731905780355795]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9988693136394,40.731905780355795]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99886076969355,40.73191584614834]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99886076969355,40.73191584614834]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99886076969355,40.73191584614834]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99885222574726,40.73192591193041]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99885222574726,40.73192591193041]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99885222574726,40.73192591193041]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99884368180045,40.731935977702015]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99884368180045,40.731935977702015]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99884368180045,40.731935977702015]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99883513785323,40.731946043463154]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99883513785323,40.731946043463154]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99883513785323,40.731946043463154]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99882659390549,40.73195610921382]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99882659390549,40.73195610921382]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99882659390549,40.73195610921382]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99881804995734,40.73196617495402]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99881804995734,40.73196617495402]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99881804995734,40.73196617495402]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99880950600866,40.73197624068375]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99880950600866,40.73197624068375]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99880950600866,40.73197624068375]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99880096205953,40.73198630640301]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99880096205953,40.73198630640301]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99880096205953,40.73198630640301]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99879241810997,40.73199637211181]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99879241810997,40.73199637211181]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99879241810997,40.73199637211181]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99878387415988,40.732006437810135]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99878387415988,40.732006437810135]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99878387415988,40.732006437810135]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99877533020936,40.732016503497995]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99877533020936,40.732016503497995]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99877533020936,40.732016503497995]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99876678625839,40.73202656917538]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99876678625839,40.73202656917538]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99876678625839,40.73202656917538]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9987582423069,40.7320366348423]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9987582423069,40.7320366348423]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9987582423069,40.7320366348423]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99874969835498,40.732046700498756]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99874969835498,40.732046700498756]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99874969835498,40.732046700498756]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99874115440257,40.73205676614474]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99874115440257,40.73205676614474]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99874115440257,40.73205676614474]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99873261044972,40.73206683178026]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99873261044972,40.73206683178026]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99873261044972,40.73206683178026]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99872406649637,40.73207689740531]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99872406649637,40.73207689740531]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99872406649637,40.73207689740531]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99871552254255,40.73208696301988]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99871552254255,40.73208696301988]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99871552254255,40.73208696301988]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99870697858829,40.732097028624]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99870697858829,40.732097028624]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99870697858829,40.732097028624]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99869843463352,40.73210709421764]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99869843463352,40.73210709421764]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99869843463352,40.73210709421764]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99868989067832,40.732117159800815]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99868989067832,40.732117159800815]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99868989067832,40.732117159800815]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99868134672262,40.73212722537352]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99868134672262,40.73212722537352]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99868134672262,40.73212722537352]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99868134672262,40.73212722537352]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99867280276649,40.73213729093575]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99867280276649,40.73213729093575]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99867280276649,40.73213729093575]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99867280276649,40.73213729093575]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99866425880988,40.73214735648753]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99866425880988,40.73214735648753]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99866425880988,40.73214735648753]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99866425880988,40.73214735648753]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99865571485277,40.732157422028834]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99865571485277,40.732157422028834]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99865571485277,40.732157422028834]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99865571485277,40.732157422028834]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99864717089523,40.732167487559664]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99864717089523,40.732167487559664]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99864717089523,40.732167487559664]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99864717089523,40.732167487559664]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9986386269372,40.73217755308003]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9986386269372,40.73217755308003]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9986386269372,40.73217755308003]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9986386269372,40.73217755308003]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99863008297874,40.73218761858993]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99863008297874,40.73218761858993]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99863008297874,40.73218761858993]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99863008297874,40.73218761858993]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99862153901974,40.732197684089364]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99862153901974,40.732197684089364]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99862153901974,40.732197684089364]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99862153901974,40.732197684089364]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99861299506031,40.73220774957832]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99861299506031,40.73220774957832]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99861299506031,40.73220774957832]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99861299506031,40.73220774957832]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.998606,40.732216]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.998606,40.732216]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.998606,40.732216]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99859746847837,40.73222620337097]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99859746847837,40.73222620337097]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99859746847837,40.73222620337097]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99859746847837,40.73222620337097]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99858893695627,40.732236406731346]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99858893695627,40.732236406731346]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99858893695627,40.732236406731346]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99858893695627,40.732236406731346]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9985804054337,40.73224661008112]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9985804054337,40.73224661008112]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9985804054337,40.73224661008112]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9985804054337,40.73224661008112]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99857187391063,40.73225681342031]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99857187391063,40.73225681342031]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99857187391063,40.73225681342031]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99857187391063,40.73225681342031]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99856334238704,40.73226701674889]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99856334238704,40.73226701674889]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99856334238704,40.73226701674889]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99856334238704,40.73226701674889]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99855481086306,40.73227722006688]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99855481086306,40.73227722006688]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99855481086306,40.73227722006688]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99855481086306,40.73227722006688]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99854627933851,40.73228742337428]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99854627933851,40.73228742337428]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99854627933851,40.73228742337428]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99854627933851,40.73228742337428]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99853774781354,40.73229762667107]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99853774781354,40.73229762667107]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99853774781354,40.73229762667107]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99853774781354,40.73229762667107]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99852921628806,40.73230782995728]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99852921628806,40.73230782995728]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99852921628806,40.73230782995728]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99852921628806,40.73230782995728]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9985206847621,40.73231803323288]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.9985206847621,40.73231803323288]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9985206847621,40.73231803323288]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.9985206847621,40.73231803323288]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99851215323565,40.7323282364979]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99851215323565,40.7323282364979]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99851215323565,40.7323282364979]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99851215323565,40.7323282364979]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99850362170875,40.732338439752304]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99850362170875,40.732338439752304]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99850362170875,40.732338439752304]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99850362170875,40.732338439752304]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99849509018132,40.73234864299613]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99849509018132,40.73234864299613]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99849509018132,40.73234864299613]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99849509018132,40.73234864299613]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99848655865344,40.73235884622935]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99848655865344,40.73235884622935]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99848655865344,40.73235884622935]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99848655865344,40.73235884622935]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99847802712509,40.732369049451975]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99847802712509,40.732369049451975]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99847802712509,40.732369049451975]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99847802712509,40.732369049451975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99846949559624,40.73237925266401]]},{"type":"LineString","coordinates":[[-73.999682,40.73146],[-73.99846949559624,40.73237925266401]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99846949559624,40.73237925266401]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99846949559624,40.73237925266401]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99846096406695,40.732389455865444]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99846096406695,40.732389455865444]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99846096406695,40.732389455865444]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99845243253714,40.73239965905629]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99845243253714,40.73239965905629]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99845243253714,40.73239965905629]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99844390100682,40.73240986223653]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99844390100682,40.73240986223653]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99844390100682,40.73240986223653]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99843536947607,40.73242006540619]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99843536947607,40.73242006540619]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99843536947607,40.73242006540619]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99842683794482,40.73243026856524]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99842683794482,40.73243026856524]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99842683794482,40.73243026856524]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99841830641307,40.732440471713694]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99841830641307,40.732440471713694]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99841830641307,40.732440471713694]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99840977488086,40.732450674851556]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99840977488086,40.732450674851556]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99840977488086,40.732450674851556]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99840124334814,40.73246087797882]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99840124334814,40.73246087797882]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99840124334814,40.73246087797882]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99839271181497,40.7324710810955]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99839271181497,40.7324710810955]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99839271181497,40.7324710810955]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99838418028132,40.73248128420157]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99838418028132,40.73248128420157]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99838418028132,40.73248128420157]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99837564874716,40.732491487297054]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99837564874716,40.732491487297054]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99837564874716,40.732491487297054]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99836711721254,40.73250169038193]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99836711721254,40.73250169038193]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99836711721254,40.73250169038193]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99835858567744,40.73251189345622]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99835858567744,40.73251189345622]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99835858567744,40.73251189345622]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99835005414185,40.732522096519915]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99835005414185,40.732522096519915]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99835005414185,40.732522096519915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99834152260578,40.732532299573016]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99834152260578,40.732532299573016]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99834152260578,40.732532299573016]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99833299106922,40.732542502615516]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99833299106922,40.732542502615516]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99833299106922,40.732542502615516]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99832445953221,40.73255270564742]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99832445953221,40.73255270564742]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99832445953221,40.73255270564742]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99831592799471,40.73256290866874]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99831592799471,40.73256290866874]]},{"type":"LineString","coordinates":[[-73.997822,40.731318],[-73.99831592799471,40.73256290866874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99830739645668,40.73257311167945]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99830739645668,40.73257311167945]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99830739645668,40.73257311167945]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99829886491823,40.73258331467957]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99829886491823,40.73258331467957]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99829886491823,40.73258331467957]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99829033337924,40.7325935176691]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99829033337924,40.7325935176691]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99829033337924,40.7325935176691]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99828180183982,40.73260372064803]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99828180183982,40.73260372064803]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99828180183982,40.73260372064803]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99827327029993,40.73261392361636]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99827327029993,40.73261392361636]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99827327029993,40.73261392361636]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99826473875952,40.7326241265741]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99826473875952,40.7326241265741]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99826473875952,40.7326241265741]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99825620721863,40.73263432952125]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99825620721863,40.73263432952125]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99825620721863,40.73263432952125]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99824767567726,40.73264453245779]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99824767567726,40.73264453245779]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99824767567726,40.73264453245779]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99823914413543,40.73265473538375]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99823914413543,40.73265473538375]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99823914413543,40.73265473538375]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99823061259309,40.7326649382991]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99823061259309,40.7326649382991]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99823061259309,40.7326649382991]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99822208105027,40.73267514120386]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99822208105027,40.73267514120386]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99822208105027,40.73267514120386]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99821354950699,40.73268534409803]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99821354950699,40.73268534409803]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99821354950699,40.73268534409803]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99820501796322,40.73269554698161]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99820501796322,40.73269554698161]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99820501796322,40.73269554698161]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99819648641898,40.73270574985458]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99819648641898,40.73270574985458]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99819648641898,40.73270574985458]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99818795487423,40.732715952716966]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99818795487423,40.732715952716966]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99818795487423,40.732715952716966]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99817942332902,40.732726155568756]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99817942332902,40.732726155568756]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99817942332902,40.732726155568756]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99817089178336,40.732736358409944]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99817089178336,40.732736358409944]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99817089178336,40.732736358409944]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.998162,40.732747]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.998162,40.732747]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.998162,40.732747]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99815342089919,40.73275666386057]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99815342089919,40.73275666386057]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99815342089919,40.73275666386057]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99815342089919,40.73275666386057]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99814484179797,40.73276632771105]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99814484179797,40.73276632771105]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99814484179797,40.73276632771105]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99814484179797,40.73276632771105]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99813626269632,40.73277599155143]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99813626269632,40.73277599155143]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99813626269632,40.73277599155143]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99813626269632,40.73277599155143]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99812768359423,40.732785655381726]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99812768359423,40.732785655381726]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99812768359423,40.732785655381726]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99812768359423,40.732785655381726]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99811910449169,40.73279531920193]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99811910449169,40.73279531920193]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99811910449169,40.73279531920193]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99811910449169,40.73279531920193]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99811052538875,40.73280498301204]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99811052538875,40.73280498301204]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99811052538875,40.73280498301204]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99811052538875,40.73280498301204]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99810194628535,40.73281464681206]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99810194628535,40.73281464681206]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99810194628535,40.73281464681206]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99810194628535,40.73281464681206]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99809336718157,40.732824310601984]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99809336718157,40.732824310601984]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99809336718157,40.732824310601984]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99809336718157,40.732824310601984]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99808478807728,40.732833974381826]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99808478807728,40.732833974381826]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99808478807728,40.732833974381826]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99808478807728,40.732833974381826]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99807620897259,40.732843638151564]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99807620897259,40.732843638151564]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99807620897259,40.732843638151564]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99807620897259,40.732843638151564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99806762986749,40.73285330191122]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99806762986749,40.73285330191122]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99806762986749,40.73285330191122]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99806762986749,40.73285330191122]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99805905076195,40.732862965660786]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99805905076195,40.732862965660786]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99805905076195,40.732862965660786]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99805905076195,40.732862965660786]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99805047165597,40.732872629400255]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99805047165597,40.732872629400255]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99805047165597,40.732872629400255]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99805047165597,40.732872629400255]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99804189254958,40.73288229312964]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99804189254958,40.73288229312964]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99804189254958,40.73288229312964]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99804189254958,40.73288229312964]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9980333134427,40.732891956848924]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9980333134427,40.732891956848924]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9980333134427,40.732891956848924]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9980333134427,40.732891956848924]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99802473433543,40.73290162055813]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99802473433543,40.73290162055813]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99802473433543,40.73290162055813]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99802473433543,40.73290162055813]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99801615522776,40.732911284257234]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99801615522776,40.732911284257234]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99801615522776,40.732911284257234]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99801615522776,40.732911284257234]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99800757611962,40.732920947946255]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99800757611962,40.732920947946255]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99800757611962,40.732920947946255]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99800757611962,40.732920947946255]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99799899701105,40.73293061162518]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99799899701105,40.73293061162518]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99799899701105,40.73293061162518]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99799899701105,40.73293061162518]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99799041790205,40.73294027529401]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99799041790205,40.73294027529401]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99799041790205,40.73294027529401]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99799041790205,40.73294027529401]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997988,40.732943]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997988,40.732943]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997988,40.732943]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997988,40.732945]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997988,40.732945]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997988,40.732945]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997989,40.732947]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.997989,40.732947]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.997989,40.732947]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99799792428513,40.732950726120926]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99799792428513,40.732950726120926]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99799792428513,40.732950726120926]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99799792428513,40.732950726120926]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99800684857021,40.732954452245885]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99800684857021,40.732954452245885]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99800684857021,40.732954452245885]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99800684857021,40.732954452245885]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99801577285523,40.73295817837489]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99801577285523,40.73295817837489]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99801577285523,40.73295817837489]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99801577285523,40.73295817837489]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99802469714017,40.73296190450795]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99802469714017,40.73296190450795]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99802469714017,40.73296190450795]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99802469714017,40.73296190450795]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99803362142502,40.732965630645054]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99803362142502,40.732965630645054]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99803362142502,40.732965630645054]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99803362142502,40.732965630645054]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99804254570986,40.73296935678621]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99804254570986,40.73296935678621]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99804254570986,40.73296935678621]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99804254570986,40.73296935678621]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99805146999458,40.732973082931416]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99805146999458,40.732973082931416]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99805146999458,40.732973082931416]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99805146999458,40.732973082931416]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9980603942793,40.73297680908066]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9980603942793,40.73297680908066]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9980603942793,40.73297680908066]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9980603942793,40.73297680908066]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9980693185639,40.732980535233956]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9980693185639,40.732980535233956]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9980693185639,40.732980535233956]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9980693185639,40.732980535233956]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99807824284848,40.7329842613913]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99807824284848,40.7329842613913]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99807824284848,40.7329842613913]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99807824284848,40.7329842613913]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99808716713294,40.73298798755269]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99808716713294,40.73298798755269]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99808716713294,40.73298798755269]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99808716713294,40.73298798755269]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9980960914174,40.73299171371813]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9980960914174,40.73299171371813]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9980960914174,40.73299171371813]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9980960914174,40.73299171371813]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99810501570175,40.73299543988762]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99810501570175,40.73299543988762]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99810501570175,40.73299543988762]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99810501570175,40.73299543988762]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99811393998607,40.73299916606115]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99811393998607,40.73299916606115]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99811393998607,40.73299916606115]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99811393998607,40.73299916606115]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99812286427029,40.73300289223873]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99812286427029,40.73300289223873]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99812286427029,40.73300289223873]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99812286427029,40.73300289223873]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99813178855446,40.73300661842036]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99813178855446,40.73300661842036]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99813178855446,40.73300661842036]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99813178855446,40.73300661842036]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99814071283859,40.733010344606036]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99814071283859,40.733010344606036]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99814071283859,40.733010344606036]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99814071283859,40.733010344606036]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99814963712264,40.73301407079576]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99814963712264,40.73301407079576]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99814963712264,40.73301407079576]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99814963712264,40.73301407079576]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99815856140663,40.73301779698953]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99815856140663,40.73301779698953]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99815856140663,40.73301779698953]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99815856140663,40.73301779698953]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99816748569052,40.73302152318735]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99816748569052,40.73302152318735]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99816748569052,40.73302152318735]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99816748569052,40.73302152318735]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99817640997436,40.73302524938922]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99817640997436,40.73302524938922]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99817640997436,40.73302524938922]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99817640997436,40.73302524938922]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99818533425817,40.73302897559513]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99818533425817,40.73302897559513]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99818533425817,40.73302897559513]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99818533425817,40.73302897559513]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99819425854189,40.733032701805094]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99819425854189,40.733032701805094]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99819425854189,40.733032701805094]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99819425854189,40.733032701805094]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99820318282552,40.733036428019105]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99820318282552,40.733036428019105]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99820318282552,40.733036428019105]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99820318282552,40.733036428019105]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99821210710913,40.73304015423716]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99821210710913,40.73304015423716]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99821210710913,40.73304015423716]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99821210710913,40.73304015423716]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99822103139267,40.73304388045926]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99822103139267,40.73304388045926]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99822103139267,40.73304388045926]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99822103139267,40.73304388045926]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99822995567612,40.733047606685425]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99822995567612,40.733047606685425]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99822995567612,40.733047606685425]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99822995567612,40.733047606685425]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9982388799595,40.73305133291562]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9982388799595,40.73305133291562]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9982388799595,40.73305133291562]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9982388799595,40.73305133291562]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99824780424288,40.73305505914987]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99824780424288,40.73305505914987]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99824780424288,40.73305505914987]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99824780424288,40.73305505914987]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99825672852614,40.73305878538816]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99825672852614,40.73305878538816]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99825672852614,40.73305878538816]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99825672852614,40.73305878538816]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99826565280934,40.73306251163051]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99826565280934,40.73306251163051]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99826565280934,40.73306251163051]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99826565280934,40.73306251163051]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99827457709249,40.7330662378769]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99827457709249,40.7330662378769]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99827457709249,40.7330662378769]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99827457709249,40.7330662378769]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99828350137557,40.73306996412734]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99828350137557,40.73306996412734]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99828350137557,40.73306996412734]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99828350137557,40.73306996412734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99829242565859,40.73307369038182]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99829242565859,40.73307369038182]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99829242565859,40.73307369038182]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99829242565859,40.73307369038182]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99830134994154,40.733077416640356]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99830134994154,40.733077416640356]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99830134994154,40.733077416640356]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99830134994154,40.733077416640356]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99831027422444,40.73308114290294]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99831027422444,40.73308114290294]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99831027422444,40.73308114290294]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99831027422444,40.73308114290294]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99831919850726,40.733084869169566]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99831919850726,40.733084869169566]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99831919850726,40.733084869169566]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99831919850726,40.733084869169566]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99832812279,40.73308859544024]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99832812279,40.73308859544024]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99832812279,40.73308859544024]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99832812279,40.73308859544024]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99833704707272,40.73309232171497]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99833704707272,40.73309232171497]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99833704707272,40.73309232171497]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99833704707272,40.73309232171497]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99834597135536,40.73309604799375]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99834597135536,40.73309604799375]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99834597135536,40.73309604799375]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99834597135536,40.73309604799375]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9983548956379,40.73309977427656]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9983548956379,40.73309977427656]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9983548956379,40.73309977427656]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.9983548956379,40.73309977427656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99836381992041,40.73310350056343]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99836381992041,40.73310350056343]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99836381992041,40.73310350056343]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99836381992041,40.73310350056343]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99837274420287,40.73310722685435]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99837274420287,40.73310722685435]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99837274420287,40.73310722685435]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99837274420287,40.73310722685435]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99838166848524,40.73311095314931]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99838166848524,40.73311095314931]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99838166848524,40.73311095314931]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99838166848524,40.73311095314931]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99839059276754,40.73311467944832]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99839059276754,40.73311467944832]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99839059276754,40.73311467944832]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99839059276754,40.73311467944832]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99839951704978,40.733118405751384]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99839951704978,40.733118405751384]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99839951704978,40.733118405751384]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99839951704978,40.733118405751384]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99840844133196,40.73312213205849]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99840844133196,40.73312213205849]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99840844133196,40.73312213205849]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99840844133196,40.73312213205849]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99841736561409,40.73312585836965]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99841736561409,40.73312585836965]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99841736561409,40.73312585836965]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99841736561409,40.73312585836965]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99842628989613,40.733129584684846]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99842628989613,40.733129584684846]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99842628989613,40.733129584684846]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99842628989613,40.733129584684846]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99843521417812,40.733133311004096]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99843521417812,40.733133311004096]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99843521417812,40.733133311004096]]},{"type":"LineString","coordinates":[[-73.99701,40.73241],[-73.99843521417812,40.733133311004096]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99844413846004,40.733137037327396]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99844413846004,40.733137037327396]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99844413846004,40.733137037327396]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99845306274192,40.73314076365474]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99845306274192,40.73314076365474]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99845306274192,40.73314076365474]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9984619870237,40.73314448998613]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9984619870237,40.73314448998613]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9984619870237,40.73314448998613]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99847091130545,40.733148216321574]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99847091130545,40.733148216321574]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99847091130545,40.733148216321574]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99847983558712,40.73315194266106]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99847983558712,40.73315194266106]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99847983558712,40.73315194266106]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9984887598687,40.7331556690046]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9984887598687,40.7331556690046]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9984887598687,40.7331556690046]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99849768415022,40.73315939535218]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99849768415022,40.73315939535218]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99849768415022,40.73315939535218]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99850660843174,40.73316312170382]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99850660843174,40.73316312170382]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99850660843174,40.73316312170382]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99851553271313,40.7331668480595]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99851553271313,40.7331668480595]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99851553271313,40.7331668480595]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99852445699449,40.733170574419226]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99852445699449,40.733170574419226]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99852445699449,40.733170574419226]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99853338127575,40.733174300783006]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99853338127575,40.733174300783006]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99853338127575,40.733174300783006]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99854230555698,40.73317802715083]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99854230555698,40.73317802715083]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99854230555698,40.73317802715083]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99855122983816,40.7331817535227]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99855122983816,40.7331817535227]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99855122983816,40.7331817535227]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99856015411925,40.73318547989862]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99856015411925,40.73318547989862]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99856015411925,40.73318547989862]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99856907840027,40.73318920627859]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99856907840027,40.73318920627859]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99856907840027,40.73318920627859]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99857800268121,40.733192932662604]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99857800268121,40.733192932662604]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99857800268121,40.733192932662604]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9985869269621,40.73319665905067]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9985869269621,40.73319665905067]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9985869269621,40.73319665905067]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99859585124297,40.733200385442785]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99859585124297,40.733200385442785]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99859585124297,40.733200385442785]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9986047755237,40.73320411183894]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9986047755237,40.73320411183894]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9986047755237,40.73320411183894]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99861369980441,40.73320783823915]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99861369980441,40.73320783823915]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99861369980441,40.73320783823915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99862262408506,40.733211564643405]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99862262408506,40.733211564643405]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99862262408506,40.733211564643405]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99863154836565,40.73321529105171]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99863154836565,40.73321529105171]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99863154836565,40.73321529105171]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99864047264616,40.73321901746406]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99864047264616,40.73321901746406]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99864047264616,40.73321901746406]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9986493969266,40.73322274388046]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9986493969266,40.73322274388046]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9986493969266,40.73322274388046]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99865832120699,40.733226470300906]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99865832120699,40.733226470300906]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99865832120699,40.733226470300906]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9986672454873,40.7332301967254]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9986672454873,40.7332301967254]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9986672454873,40.7332301967254]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99867616976756,40.733233923153946]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99867616976756,40.733233923153946]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99867616976756,40.733233923153946]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99868509404774,40.733237649586535]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99868509404774,40.733237649586535]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99868509404774,40.733237649586535]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99869401832787,40.73324137602318]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99869401832787,40.73324137602318]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99869401832787,40.73324137602318]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99870294260795,40.73324510246386]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99870294260795,40.73324510246386]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99870294260795,40.73324510246386]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99871186688794,40.73324882890859]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99871186688794,40.73324882890859]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99871186688794,40.73324882890859]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99872079116788,40.73325255535738]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99872079116788,40.73325255535738]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99872079116788,40.73325255535738]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99872971544777,40.73325628181021]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99872971544777,40.73325628181021]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99872971544777,40.73325628181021]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99873863972755,40.73326000826709]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99873863972755,40.73326000826709]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99873863972755,40.73326000826709]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99874756400727,40.73326373472802]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99874756400727,40.73326373472802]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99874756400727,40.73326373472802]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99875648828697,40.733267461192995]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99875648828697,40.733267461192995]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99875648828697,40.733267461192995]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9987654125666,40.73327118766202]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9987654125666,40.73327118766202]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9987654125666,40.73327118766202]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99877433684611,40.73327491413509]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99877433684611,40.73327491413509]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99877433684611,40.73327491413509]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99878326112562,40.73327864061221]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99878326112562,40.73327864061221]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99878326112562,40.73327864061221]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99879218540505,40.73328236709338]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99879218540505,40.73328236709338]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99879218540505,40.73328236709338]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9988011096844,40.73328609357859]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9988011096844,40.73328609357859]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9988011096844,40.73328609357859]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99881003396368,40.73328982006786]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99881003396368,40.73328982006786]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99881003396368,40.73328982006786]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99881895824294,40.73329354656117]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99881895824294,40.73329354656117]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99881895824294,40.73329354656117]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99882788252208,40.73329727305853]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99882788252208,40.73329727305853]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99882788252208,40.73329727305853]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99883680680118,40.73330099955994]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99883680680118,40.73330099955994]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99883680680118,40.73330099955994]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9988457310802,40.7333047260654]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9988457310802,40.7333047260654]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.9988457310802,40.7333047260654]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99885465535918,40.733308452574896]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99885465535918,40.733308452574896]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99885465535918,40.733308452574896]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99886357963808,40.73331217908845]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99886357963808,40.73331217908845]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99886357963808,40.73331217908845]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99887250391693,40.733315905606055]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99887250391693,40.733315905606055]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99887250391693,40.733315905606055]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99888142819572,40.7333196321277]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99888142819572,40.7333196321277]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99888142819572,40.7333196321277]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99889035247443,40.7333233586534]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99889035247443,40.7333233586534]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99889035247443,40.7333233586534]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99889927675308,40.73332708518314]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99889927675308,40.73332708518314]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99889927675308,40.73332708518314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99890820103164,40.73333081171693]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99890820103164,40.73333081171693]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99890820103164,40.73333081171693]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99891712531016,40.73333453825478]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99891712531016,40.73333453825478]]},{"type":"LineString","coordinates":[[-73.997234,40.733579],[-73.99891712531016,40.73333453825478]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99892604958866,40.73333826479667]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99892604958866,40.73333826479667]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99893497386701,40.733341991342606]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99893497386701,40.733341991342606]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99894389814537,40.73334571789259]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99894389814537,40.73334571789259]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99895282242362,40.733349444446624]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99895282242362,40.733349444446624]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99896174670182,40.73335317100471]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99896174670182,40.73335317100471]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99897067097994,40.733356897566836]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99897067097994,40.733356897566836]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99897959525804,40.73336062413302]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99897959525804,40.73336062413302]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99898851953604,40.73336435070324]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99898851953604,40.73336435070324]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99899744381398,40.73336807727752]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99899744381398,40.73336807727752]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99900636809186,40.733371803855846]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99900636809186,40.733371803855846]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99901529236966,40.73337553043821]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99901529236966,40.73337553043821]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99902421664741,40.73337925702464]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99902421664741,40.73337925702464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99903314092512,40.7333829836151]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99903314092512,40.7333829836151]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99904206520273,40.73338671020962]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99904206520273,40.73338671020962]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9990509894803,40.733390436808186]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9990509894803,40.733390436808186]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9990599137578,40.73339416341079]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9990599137578,40.73339416341079]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9990688380352,40.733397890017464]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9990688380352,40.733397890017464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99907776231258,40.733401616628164]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99907776231258,40.733401616628164]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99908668658988,40.73340534324292]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99908668658988,40.73340534324292]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9990956108671,40.733409069861736]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9990956108671,40.733409069861736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99910453514428,40.733412796484586]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99910453514428,40.733412796484586]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99911345942137,40.733416523111494]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99911345942137,40.733416523111494]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99912238369842,40.733420249742444]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99912238369842,40.733420249742444]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99913130797542,40.733423976377445]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99913130797542,40.733423976377445]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99914023225234,40.73342770301649]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99914023225234,40.73342770301649]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99914915652919,40.73343142965958]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99914915652919,40.73343142965958]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99915808080596,40.73343515630673]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99915808080596,40.73343515630673]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99916700508271,40.73343888295793]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99916700508271,40.73343888295793]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99916700508271,40.73343888295793]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99917592935935,40.733442609613164]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99917592935935,40.733442609613164]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99917592935935,40.733442609613164]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99918485363597,40.73344633627245]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99918485363597,40.73344633627245]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99918485363597,40.73344633627245]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99919377791248,40.733450062935795]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99919377791248,40.733450062935795]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99919377791248,40.733450062935795]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99920270218895,40.733453789603175]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99920270218895,40.733453789603175]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99920270218895,40.733453789603175]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99921162646535,40.73345751627461]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99921162646535,40.73345751627461]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99921162646535,40.73345751627461]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9992205507417,40.73346124295009]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9992205507417,40.73346124295009]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.9992205507417,40.73346124295009]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99922947501794,40.73346496962962]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99922947501794,40.73346496962962]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99922947501794,40.73346496962962]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99923839929419,40.7334686963132]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99923839929419,40.7334686963132]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99923839929419,40.7334686963132]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99924732357032,40.73347242300083]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99924732357032,40.73347242300083]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99924732357032,40.73347242300083]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99925624784639,40.73347614969251]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99925624784639,40.73347614969251]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99925624784639,40.73347614969251]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99926517212242,40.73347987638824]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99926517212242,40.73347987638824]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99926517212242,40.73347987638824]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99927409639837,40.73348360308801]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99927409639837,40.73348360308801]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99927409639837,40.73348360308801]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99928302067423,40.73348732979183]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99928302067423,40.73348732979183]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99928302067423,40.73348732979183]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99929194495006,40.7334910564997]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99929194495006,40.7334910564997]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99929194495006,40.7334910564997]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99930086922583,40.73349478321162]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99930086922583,40.73349478321162]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99930086922583,40.73349478321162]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99930979350151,40.733498509927585]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99930979350151,40.733498509927585]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99930979350151,40.733498509927585]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99931871777714,40.7335022366476]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99931871777714,40.7335022366476]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99931871777714,40.7335022366476]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99932764205273,40.73350596337167]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99932764205273,40.73350596337167]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99932764205273,40.73350596337167]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99933656632821,40.73350969009978]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99933656632821,40.73350969009978]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99933656632821,40.73350969009978]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99934549060366,40.73351341683194]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99934549060366,40.73351341683194]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99934549060366,40.73351341683194]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99935441487905,40.73351714356815]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99935441487905,40.73351714356815]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99935441487905,40.73351714356815]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99936333915433,40.73352087030841]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99936333915433,40.73352087030841]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99936333915433,40.73352087030841]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9993722634296,40.733524597052714]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9993722634296,40.733524597052714]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.9993722634296,40.733524597052714]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9993811877048,40.733528323801075]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9993811877048,40.733528323801075]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.9993811877048,40.733528323801075]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99939011197989,40.73353205055347]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99939011197989,40.73353205055347]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99939011197989,40.73353205055347]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99939903625494,40.73353577730993]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99939903625494,40.73353577730993]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99939903625494,40.73353577730993]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99940796052995,40.73353950407043]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99940796052995,40.73353950407043]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99940796052995,40.73353950407043]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999414,40.733542]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999414,40.733542]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999414,40.733542]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999414,40.733542]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999414,40.733542]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999414,40.733542]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99942292116982,40.73354582335814]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99942292116982,40.73354582335814]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99942292116982,40.73354582335814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99943184233958,40.73354964672044]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99943184233958,40.73354964672044]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99943184233958,40.73354964672044]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999435,40.733551]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999435,40.733551]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999435,40.733551]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999435,40.733551]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999435,40.733551]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999435,40.733551]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99944384239664,40.73355674755748]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99944384239664,40.73355674755748]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99944384239664,40.73355674755748]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99945268479317,40.73356249512114]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99945268479317,40.73356249512114]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99945268479317,40.73356249512114]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999455,40.733564]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999455,40.733564]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999455,40.733564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999455,40.733564]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999455,40.733564]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999455,40.733564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99946379717927,40.733570597883265]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99946379717927,40.733570597883265]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99946379717927,40.733570597883265]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.9994725943584,40.7335771957736]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9994725943584,40.7335771957736]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.9994725943584,40.7335771957736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999479,40.733582]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999479,40.733582]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999479,40.733582]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999479,40.733582]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999479,40.733582]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999479,40.733582]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99948752873901,40.73359223448776]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99948752873901,40.73359223448776]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99948752873901,40.73359223448776]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999494,40.7336]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999494,40.7336]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999494,40.7336]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999494,40.7336]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999494,40.7336]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999494,40.7336]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999501996355,40.73361485037542]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999501996355,40.73361485037542]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999501996355,40.73361485037542]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999508,40.733626]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999508,40.733626]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999508,40.733626]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.999508,40.733626]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999508,40.733626]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999508,40.733626]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99951497774768,40.73364652509243]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99951497774768,40.73364652509243]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99951497774768,40.73364652509243]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.998676,40.732548],[-73.99952195549342,40.7336670502023]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99952195549342,40.7336670502023]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99952195549342,40.7336670502023]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99952893323724,40.733687575329604]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99952893323724,40.733687575329604]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9995359109791,40.73370810047434]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.9995359109791,40.73370810047434]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99954288871896,40.73372862563651]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99954288871896,40.73372862563651]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99954986645693,40.73374915081612]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99954986645693,40.73374915081612]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99955684419294,40.73376967601315]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99955684419294,40.73376967601315]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999563821927,40.73379020122762]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.999563821927,40.73379020122762]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99957079965911,40.73381072645953]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99957079965911,40.73381072645953]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99957079965911,40.73381072645953]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99957777738928,40.73383125170887]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99957777738928,40.73383125170887]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99957777738928,40.73383125170887]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99958475511748,40.73385177697564]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99958475511748,40.73385177697564]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99958475511748,40.73385177697564]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99959173284375,40.733872302259854]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99959173284375,40.733872302259854]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99959173284375,40.733872302259854]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99959871056805,40.73389282756149]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99959871056805,40.73389282756149]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99959871056805,40.73389282756149]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99960568829042,40.73391335288056]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99960568829042,40.73391335288056]]},{"type":"LineString","coordinates":[[-74.000762,40.732961],[-73.99960568829042,40.73391335288056]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99961266601085,40.73393387821708]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99961266601085,40.73393387821708]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99961964372932,40.73395440357102]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99961964372932,40.73395440357102]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99962662144583,40.7339749289424]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99962662144583,40.7339749289424]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99963359916042,40.73399545433122]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99963359916042,40.73399545433122]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99964057687303,40.734015979737464]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99964057687303,40.734015979737464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99964755458375,40.73403650516115]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99964755458375,40.73403650516115]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99965453229245,40.734057030602266]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99965453229245,40.734057030602266]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99966150999926,40.73407755606082]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99966150999926,40.73407755606082]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99966848770408,40.7340980815368]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99966848770408,40.7340980815368]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99967546540692,40.73411860703022]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99967546540692,40.73411860703022]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999679,40.734129]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999679,40.734129]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999679,40.734129]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999679,40.734129]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99968556849389,40.73415123182067]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99968556849389,40.73415123182067]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9996921369855,40.73417346365912]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.9996921369855,40.73417346365912]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99969870547487,40.73419569551533]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99969870547487,40.73419569551533]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999705,40.734217]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999705,40.734217]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999705,40.734217]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999705,40.734217]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99971301054671,40.73423174955791]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99971301054671,40.73423174955791]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99972102109238,40.73424649913019]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99972102109238,40.73424649913019]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99972903163712,40.734261248716855]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99972903163712,40.734261248716855]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99973704218081,40.734275998317905]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99973704218081,40.734275998317905]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99974505272345,40.734290747933336]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99974505272345,40.734290747933336]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99975306326516,40.734305497563156]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99975306326516,40.734305497563156]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9997610738058,40.73432024720735]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.9997610738058,40.73432024720735]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999768,40.734333]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999768,40.734333]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999768,40.734333]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999768,40.734333]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99977612621663,40.73434689187968]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99977612621663,40.73434689187968]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99978425243239,40.734360783773106]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99978425243239,40.734360783773106]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99979237864727,40.734374675680264]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99979237864727,40.734374675680264]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99980050486121,40.73438856760117]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99980050486121,40.73438856760117]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99980863107427,40.73440245953582]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99980863107427,40.73440245953582]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99981675728645,40.734416351484214]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99981675728645,40.734416351484214]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99982488349772,40.73443024344634]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99982488349772,40.73443024344634]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99983300970814,40.73444413542222]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99983300970814,40.73444413542222]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99984113591765,40.73445802741184]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99984113591765,40.73445802741184]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99984926212626,40.7344719194152]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99984926212626,40.7344719194152]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99985738833396,40.7344858114323]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99985738833396,40.7344858114323]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99986551454079,40.73449970346314]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99986551454079,40.73449970346314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.9998736407467,40.734513595507735]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.9998736407467,40.734513595507735]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99988176695176,40.73452748756606]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99988176695176,40.73452748756606]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99988989315591,40.73454137963813]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99988989315591,40.73454137963813]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99989801935916,40.73455527172395]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99989801935916,40.73455527172395]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99990614556154,40.7345691638235]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99990614556154,40.7345691638235]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.999914271763,40.7345830559368]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999914271763,40.7345830559368]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999914271763,40.7345830559368]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99992239796359,40.73459694806384]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99992239796359,40.73459694806384]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99992239796359,40.73459694806384]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99993052416323,40.734610840204624]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99993052416323,40.734610840204624]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99993052416323,40.734610840204624]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99993865036204,40.73462473235915]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99993865036204,40.73462473235915]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99993865036204,40.73462473235915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99994677655995,40.73463862452743]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99994677655995,40.73463862452743]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99994677655995,40.73463862452743]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99995490275695,40.73465251670943]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99995490275695,40.73465251670943]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99995490275695,40.73465251670943]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99996302895305,40.73466640890519]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99996302895305,40.73466640890519]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99996302895305,40.73466640890519]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99997115514829,40.73468030111468]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99997115514829,40.73468030111468]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99997115514829,40.73468030111468]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.999978,40.734692]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999978,40.734692]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999978,40.734692]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.999978,40.734692]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.999978,40.734692]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.999978,40.734692]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99998621067839,40.734705222243505]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99998621067839,40.734705222243505]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99998621067839,40.734705222243505]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-73.99999442135598,40.73471844450023]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-73.99999442135598,40.73471844450023]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-73.99999442135598,40.73471844450023]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00000263203277,40.734731666770166]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00000263203277,40.734731666770166]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00000263203277,40.734731666770166]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00001084270875,40.73474488905332]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00001084270875,40.73474488905332]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00001084270875,40.73474488905332]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00001905338384,40.734758111349684]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00001905338384,40.734758111349684]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00001905338384,40.734758111349684]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0000272640582,40.73477133365927]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.0000272640582,40.73477133365927]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0000272640582,40.73477133365927]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00003547473175,40.73478455598207]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00003547473175,40.73478455598207]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00003547473175,40.73478455598207]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00004368540448,40.73479777831808]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00004368540448,40.73479777831808]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00004368540448,40.73479777831808]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0000518960764,40.734811000667314]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.0000518960764,40.734811000667314]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0000518960764,40.734811000667314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00006010674751,40.73482422302976]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00006010674751,40.73482422302976]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00006010674751,40.73482422302976]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00006831741783,40.734837445405425]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00006831741783,40.734837445405425]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00006831741783,40.734837445405425]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00007652808732,40.734850667794305]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00007652808732,40.734850667794305]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00007652808732,40.734850667794305]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000084738756,40.7348638901964]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.000084738756,40.7348638901964]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000084738756,40.7348638901964]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00009294942387,40.73487711261172]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00009294942387,40.73487711261172]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00009294942387,40.73487711261172]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00010116009095,40.73489033504024]]},{"type":"LineString","coordinates":[[-73.999177,40.733797],[-74.00010116009095,40.73489033504024]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00010116009095,40.73489033504024]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00010937075722,40.73490355748199]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00010937075722,40.73490355748199]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00011758142267,40.73491677993695]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00011758142267,40.73491677993695]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00012579208732,40.73493000240512]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00012579208732,40.73493000240512]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00013400275115,40.73494322488652]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00013400275115,40.73494322488652]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00014221341416,40.73495644738113]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00014221341416,40.73495644738113]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0001504240764,40.734969669888955]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0001504240764,40.734969669888955]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0001586347378,40.734982892409995]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0001586347378,40.734982892409995]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0001668453984,40.73499611494425]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0001668453984,40.73499611494425]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00017505605817,40.735009337491725]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00017505605817,40.735009337491725]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00018326671717,40.735022560052414]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00018326671717,40.735022560052414]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00019147737537,40.73503578262632]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00019147737537,40.73503578262632]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00019968803272,40.73504900521345]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00019968803272,40.73504900521345]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00020789868927,40.735062227813785]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00020789868927,40.735062227813785]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00021610934505,40.73507545042734]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00021610934505,40.73507545042734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00022431999999,40.735088673054115]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00022431999999,40.735088673054115]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00023253065409,40.7351018956941]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00023253065409,40.7351018956941]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00024074130742,40.7351151183473]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00024074130742,40.7351151183473]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00024895195996,40.73512834101373]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00024895195996,40.73512834101373]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00025716261166,40.73514156369337]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00025716261166,40.73514156369337]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00026537326256,40.73515478638622]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00026537326256,40.73515478638622]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00027358391266,40.73516800909229]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00027358391266,40.73516800909229]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00028179456193,40.73518123181157]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00028179456193,40.73518123181157]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00029000521042,40.735194454544086]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00029000521042,40.735194454544086]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00029821585807,40.7352076772898]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00029821585807,40.7352076772898]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00030642650492,40.73522090004874]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00030642650492,40.73522090004874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00031463715098,40.73523412282089]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00031463715098,40.73523412282089]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00032284779621,40.73524734560626]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00032284779621,40.73524734560626]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00033105844065,40.73526056840485]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00033105844065,40.73526056840485]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00033926908426,40.73527379121665]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00033926908426,40.73527379121665]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00034747972707,40.735287014041674]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00034747972707,40.735287014041674]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0003556903691,40.73530023687991]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0003556903691,40.73530023687991]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000363,40.735312]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000363,40.735312]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000363,40.735312]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000363,40.735312]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00037114871634,40.73532571781278]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00037114871634,40.73532571781278]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0003792974318,40.73533943563915]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0003792974318,40.73533943563915]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00038744614645,40.73535315347914]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00038744614645,40.73535315347914]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00039559486017,40.73536687133273]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00039559486017,40.73536687133273]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000403743573,40.73538058919993]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000403743573,40.73538058919993]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000411892285,40.73539430708074]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000411892285,40.73539430708074]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00042004099612,40.73540802497516]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00042004099612,40.73540802497516]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00042818970635,40.735421742883176]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00042818970635,40.735421742883176]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00043633841575,40.735435460804815]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00043633841575,40.735435460804815]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00044448712424,40.735449178740055]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00044448712424,40.735449178740055]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00045263583188,40.7354628966889]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00045263583188,40.7354628966889]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00046078453869,40.73547661465136]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00046078453869,40.73547661465136]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00046893324456,40.73549033262743]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00046893324456,40.73549033262743]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00047708194961,40.7355040506171]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00047708194961,40.7355040506171]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00048523065375,40.73551776862038]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00048523065375,40.73551776862038]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00049337935705,40.73553148663728]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00049337935705,40.73553148663728]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00050152805946,40.73554520466777]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00050152805946,40.73554520466777]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000509676761,40.73555892271189]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000509676761,40.73555892271189]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.000509676761,40.73555892271189]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00051782546167,40.7355726407696]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00051782546167,40.7355726407696]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00051782546167,40.7355726407696]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00052597416148,40.73558635884092]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00052597416148,40.73558635884092]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00052597416148,40.73558635884092]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0005341228604,40.73560007692586]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0005341228604,40.73560007692586]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0005341228604,40.73560007692586]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0005422715585,40.7356137950244]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0005422715585,40.7356137950244]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0005422715585,40.7356137950244]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00055042025569,40.73562751313655]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00055042025569,40.73562751313655]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00055042025569,40.73562751313655]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00055856895199,40.73564123126231]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00055856895199,40.73564123126231]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00055856895199,40.73564123126231]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00056671764747,40.73565494940167]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00056671764747,40.73565494940167]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00056671764747,40.73565494940167]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00057486634205,40.73566866755465]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00057486634205,40.73566866755465]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00057486634205,40.73566866755465]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00058301503576,40.73568238572123]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00058301503576,40.73568238572123]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00058301503576,40.73568238572123]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00059116372859,40.735696103901425]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00059116372859,40.735696103901425]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00059116372859,40.735696103901425]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0005993124206,40.73570982209523]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0005993124206,40.73570982209523]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0005993124206,40.73570982209523]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00060746111168,40.73572354030264]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00060746111168,40.73572354030264]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00060746111168,40.73572354030264]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00061560980191,40.735737258523656]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00061560980191,40.735737258523656]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00061560980191,40.735737258523656]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00062375849126,40.73575097675828]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00062375849126,40.73575097675828]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00062375849126,40.73575097675828]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0006319071798,40.735764695006516]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0006319071798,40.735764695006516]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0006319071798,40.735764695006516]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00064005586738,40.73577841326836]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00064005586738,40.73577841326836]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00064005586738,40.73577841326836]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00064820455414,40.73579213154382]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00064820455414,40.73579213154382]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00064820455414,40.73579213154382]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00065635324002,40.73580584983288]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00065635324002,40.73580584983288]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00065635324002,40.73580584983288]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00066450192504,40.73581956813555]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00066450192504,40.73581956813555]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00066450192504,40.73581956813555]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0006726506092,40.73583328645183]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0006726506092,40.73583328645183]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0006726506092,40.73583328645183]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00068079929247,40.73584700478172]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00068079929247,40.73584700478172]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00068079929247,40.73584700478172]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00068894797487,40.735860723125214]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00068894797487,40.735860723125214]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00068894797487,40.735860723125214]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00069709665641,40.735874441482316]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00069709665641,40.735874441482316]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00069709665641,40.735874441482316]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00070524533707,40.73588815985303]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00070524533707,40.73588815985303]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00070524533707,40.73588815985303]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00071339401684,40.73590187823736]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00071339401684,40.73590187823736]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00071339401684,40.73590187823736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00072154269576,40.73591559663529]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00072154269576,40.73591559663529]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00072154269576,40.73591559663529]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0007296913738,40.73592931504683]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0007296913738,40.73592931504683]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0007296913738,40.73592931504683]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.000737840051,40.735943033471976]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.000737840051,40.735943033471976]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.000737840051,40.735943033471976]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0007459887273,40.735956751910734]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0007459887273,40.735956751910734]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0007459887273,40.735956751910734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00075413740277,40.7359704703631]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00075413740277,40.7359704703631]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00075413740277,40.7359704703631]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00076228607732,40.73598418882908]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00076228607732,40.73598418882908]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00076228607732,40.73598418882908]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00077043475102,40.73599790730867]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00077043475102,40.73599790730867]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00077043475102,40.73599790730867]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00077858342384,40.736011625801865]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00077858342384,40.736011625801865]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00077858342384,40.736011625801865]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0007867320958,40.736025344308665]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.0007867320958,40.736025344308665]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0007867320958,40.736025344308665]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00079488076692,40.73603906282907]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00079488076692,40.73603906282907]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00079488076692,40.73603906282907]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00080302943711,40.7360527813631]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00080302943711,40.7360527813631]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00080302943711,40.7360527813631]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00081117810647,40.736066499910734]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00081117810647,40.736066499910734]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00081117810647,40.736066499910734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00081932677494,40.73608021847197]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00081932677494,40.73608021847197]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00081932677494,40.73608021847197]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00082747544255,40.736093937046824]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00082747544255,40.736093937046824]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00082747544255,40.736093937046824]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00083562410927,40.73610765563528]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00083562410927,40.73610765563528]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00083562410927,40.73610765563528]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00084377277516,40.73612137423734]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00084377277516,40.73612137423734]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00084377277516,40.73612137423734]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00085192144013,40.73613509285302]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00085192144013,40.73613509285302]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00085192144013,40.73613509285302]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00086007010427,40.73614881148231]]},{"type":"LineString","coordinates":[[-74.000548,40.734881],[-74.00086007010427,40.73614881148231]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00086007010427,40.73614881148231]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00086821876752,40.7361625301252]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00086821876752,40.7361625301252]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00087636742994,40.7361762487817]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00087636742994,40.7361762487817]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00088451609142,40.736189967451814]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00088451609142,40.736189967451814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00089266475209,40.736203686135546]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00089266475209,40.736203686135546]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00090081341183,40.73621740483287]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00090081341183,40.73621740483287]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00090896207077,40.73623112354381]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00090896207077,40.73623112354381]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00091711072878,40.73624484226836]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00091711072878,40.73624484226836]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00092525938595,40.73625856100652]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00092525938595,40.73625856100652]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00093340804223,40.73627227975829]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00093340804223,40.73627227975829]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00094155669767,40.73628599852367]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00094155669767,40.73628599852367]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00094970535223,40.736299717302664]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00094970535223,40.736299717302664]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00095785400592,40.73631343609526]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00095785400592,40.73631343609526]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00096600265873,40.73632715490147]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00096600265873,40.73632715490147]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00096600265873,40.73632715490147]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00097415131066,40.73634087372128]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00097415131066,40.73634087372128]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00097415131066,40.73634087372128]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00098229996175,40.736354592554704]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00098229996175,40.736354592554704]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00098229996175,40.736354592554704]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00099044861193,40.73636831140174]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00099044861193,40.73636831140174]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00099044861193,40.73636831140174]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00099859726129,40.736382030262384]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00099859726129,40.736382030262384]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00099859726129,40.736382030262384]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0010067459097,40.73639574913664]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0010067459097,40.73639574913664]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0010067459097,40.73639574913664]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00101489455733,40.736409468024505]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00101489455733,40.736409468024505]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00101489455733,40.736409468024505]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00102304320403,40.736423186925975]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00102304320403,40.736423186925975]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00102304320403,40.736423186925975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00103119184989,40.73643690584106]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00103119184989,40.73643690584106]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00103119184989,40.73643690584106]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00103934049487,40.73645062476975]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00103934049487,40.73645062476975]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00103934049487,40.73645062476975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00104748913898,40.73646434371205]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00104748913898,40.73646434371205]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00104748913898,40.73646434371205]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00105563778222,40.73647806266796]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00105563778222,40.73647806266796]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00105563778222,40.73647806266796]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0010637864246,40.73649178163748]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0010637864246,40.73649178163748]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0010637864246,40.73649178163748]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0010637864246,40.73649178163748]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0010719350661,40.736505500620616]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0010719350661,40.736505500620616]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0010719350661,40.736505500620616]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0010719350661,40.736505500620616]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00108008370674,40.736519219617364]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00108008370674,40.736519219617364]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00108008370674,40.736519219617364]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00108008370674,40.736519219617364]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00108823234649,40.73653293862771]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00108823234649,40.73653293862771]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00108823234649,40.73653293862771]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00108823234649,40.73653293862771]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00109638098536,40.73654665765167]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00109638098536,40.73654665765167]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00109638098536,40.73654665765167]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00109638098536,40.73654665765167]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00110452962336,40.73656037668924]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00110452962336,40.73656037668924]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00110452962336,40.73656037668924]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00110452962336,40.73656037668924]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00111267826054,40.73657409574042]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00111267826054,40.73657409574042]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00111267826054,40.73657409574042]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00111267826054,40.73657409574042]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00112082689682,40.73658781480521]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00112082689682,40.73658781480521]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00112082689682,40.73658781480521]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00112082689682,40.73658781480521]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00112897553223,40.736601533883615]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00112897553223,40.736601533883615]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00112897553223,40.736601533883615]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00112897553223,40.736601533883615]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00113712416675,40.736615252975625]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00113712416675,40.736615252975625]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00113712416675,40.736615252975625]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00113712416675,40.736615252975625]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0011452728004,40.73662897208124]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0011452728004,40.73662897208124]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0011452728004,40.73662897208124]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0011452728004,40.73662897208124]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00115342143322,40.736642691200466]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00115342143322,40.736642691200466]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00115342143322,40.736642691200466]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00115342143322,40.736642691200466]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00116157006514,40.73665641033331]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00116157006514,40.73665641033331]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00116157006514,40.73665641033331]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00116157006514,40.73665641033331]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00116971869619,40.736670129479755]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00116971869619,40.736670129479755]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00116971869619,40.736670129479755]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00116971869619,40.736670129479755]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00117786732638,40.736683848639814]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00117786732638,40.736683848639814]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00117786732638,40.736683848639814]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00117786732638,40.736683848639814]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00118601595568,40.736697567813486]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00118601595568,40.736697567813486]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00118601595568,40.736697567813486]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00118601595568,40.736697567813486]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00119416458413,40.736711287000766]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00119416458413,40.736711287000766]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00119416458413,40.736711287000766]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00119416458413,40.736711287000766]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0012023132117,40.73672500620165]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0012023132117,40.73672500620165]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0012023132117,40.73672500620165]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0012023132117,40.73672500620165]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00121046183841,40.73673872541615]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00121046183841,40.73673872541615]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00121046183841,40.73673872541615]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00121046183841,40.73673872541615]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00121861046425,40.73675244464427]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00121861046425,40.73675244464427]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00121861046425,40.73675244464427]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00121861046425,40.73675244464427]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0012267590892,40.73676616388598]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0012267590892,40.73676616388598]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0012267590892,40.73676616388598]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0012267590892,40.73676616388598]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0012349077133,40.73677988314131]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0012349077133,40.73677988314131]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0012349077133,40.73677988314131]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0012349077133,40.73677988314131]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.0012430563365,40.73679360241025]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0012430563365,40.73679360241025]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0012430563365,40.73679360241025]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0012430563365,40.73679360241025]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00125120495888,40.7368073216928]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00125120495888,40.7368073216928]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00125120495888,40.7368073216928]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00125120495888,40.7368073216928]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00125935358037,40.73682104098896]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00125935358037,40.73682104098896]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00125935358037,40.73682104098896]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00125935358037,40.73682104098896]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00126750220097,40.73683476029873]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00126750220097,40.73683476029873]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00126750220097,40.73683476029873]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00126750220097,40.73683476029873]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00127565082072,40.73684847962211]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00127565082072,40.73684847962211]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00127565082072,40.73684847962211]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00127565082072,40.73684847962211]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00128379943958,40.736862198959095]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00128379943958,40.736862198959095]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00128379943958,40.736862198959095]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00128379943958,40.736862198959095]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.000224,40.735864],[-74.00129194805757,40.7368759183097]]},{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00129194805757,40.7368759183097]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00129194805757,40.7368759183097]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00129194805757,40.7368759183097]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0013000966747,40.73688963767391]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0013000966747,40.73688963767391]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0013000966747,40.73688963767391]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00130824529097,40.73690335705173]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00130824529097,40.73690335705173]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00130824529097,40.73690335705173]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00131639390635,40.73691707644316]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00131639390635,40.73691707644316]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00131639390635,40.73691707644316]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00132454252086,40.7369307958482]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00132454252086,40.7369307958482]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00132454252086,40.7369307958482]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00133269113451,40.736944515266856]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00133269113451,40.736944515266856]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00133269113451,40.736944515266856]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0013408397473,40.73695823469912]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0013408397473,40.73695823469912]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0013408397473,40.73695823469912]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0013489883592,40.736971954144984]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0013489883592,40.736971954144984]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0013489883592,40.736971954144984]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00135713697024,40.73698567360447]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00135713697024,40.73698567360447]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00135713697024,40.73698567360447]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00136528558042,40.73699939307757]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00136528558042,40.73699939307757]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00136528558042,40.73699939307757]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00137343418972,40.73701311256427]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00137343418972,40.73701311256427]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00137343418972,40.73701311256427]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00138158279815,40.73702683206458]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00138158279815,40.73702683206458]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00138158279815,40.73702683206458]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00138973140565,40.73704055157851]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00138973140565,40.73704055157851]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00138973140565,40.73704055157851]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00139788001236,40.73705427110605]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00139788001236,40.73705427110605]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00139788001236,40.73705427110605]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00140602861819,40.73706799064718]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00140602861819,40.73706799064718]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00140602861819,40.73706799064718]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00141417722314,40.73708171020194]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00141417722314,40.73708171020194]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00141417722314,40.73708171020194]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00142232582718,40.73709542977031]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00142232582718,40.73709542977031]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00142232582718,40.73709542977031]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0014304744304,40.737109149352285]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0014304744304,40.737109149352285]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0014304744304,40.737109149352285]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00143862303274,40.73712286894787]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00143862303274,40.73712286894787]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00143862303274,40.73712286894787]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0014467716342,40.73713658855707]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0014467716342,40.73713658855707]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.0014467716342,40.73713658855707]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00145492023479,40.73715030817988]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00145492023479,40.73715030817988]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00145492023479,40.73715030817988]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00146306883452,40.7371640278163]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00146306883452,40.7371640278163]]},{"type":"LineString","coordinates":[[-73.999838,40.736752],[-74.00146306883452,40.7371640278163]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00147121743339,40.737177747466326]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00147121743339,40.737177747466326]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00147936603136,40.737191467129975]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00147936603136,40.737191467129975]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00148751462847,40.73720518680722]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00148751462847,40.73720518680722]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00149566322472,40.737218906498086]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00149566322472,40.737218906498086]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00150381182007,40.737232626202555]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00150381182007,40.737232626202555]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00151196041456,40.73724634592064]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00151196041456,40.73724634592064]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00152010900821,40.73726006565233]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00152010900821,40.73726006565233]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00152825760095,40.73727378539764]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00152825760095,40.73727378539764]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00153640619286,40.73728750515655]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00153640619286,40.73728750515655]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00154455478385,40.737301224929084]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00154455478385,40.737301224929084]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00155270337402,40.737314944715216]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00155270337402,40.737314944715216]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0015608519633,40.73732866451497]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0015608519633,40.73732866451497]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00156900055171,40.73734238432833]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00156900055171,40.73734238432833]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00157714913921,40.73735610415529]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00157714913921,40.73735610415529]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00158529772591,40.73736982399588]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00158529772591,40.73736982399588]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0015934463117,40.737383543850065]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0015934463117,40.737383543850065]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00160159489661,40.737397263717874]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00160159489661,40.737397263717874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0016097434807,40.73741098359928]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0016097434807,40.73741098359928]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00161789206385,40.73742470349431]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00161789206385,40.73742470349431]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00162604064619,40.73743842340295]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00162604064619,40.73743842340295]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00163418922762,40.737452143325186]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00163418922762,40.737452143325186]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00164233780819,40.73746586326105]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00164233780819,40.73746586326105]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00165048638789,40.737479583210515]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00165048638789,40.737479583210515]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00165863496673,40.7374933031736]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00165863496673,40.7374933031736]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00166678354469,40.73750702315029]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00166678354469,40.73750702315029]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00167493212177,40.73752074314059]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00167493212177,40.73752074314059]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00168308069803,40.737534463144506]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00168308069803,40.737534463144506]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00169122927336,40.737548183162026]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00169122927336,40.737548183162026]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00169937784787,40.73756190319317]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00169937784787,40.73756190319317]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00170752642146,40.73757562323791]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00170752642146,40.73757562323791]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0017156749942,40.737589343296264]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0017156749942,40.737589343296264]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00172382356607,40.73760306336824]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00172382356607,40.73760306336824]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00173197213707,40.73761678345382]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00173197213707,40.73761678345382]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00174012070718,40.73763050355301]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00174012070718,40.73763050355301]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00174826927646,40.73764422366582]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00174826927646,40.73764422366582]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00175641784483,40.73765794379223]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00175641784483,40.73765794379223]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00176456641236,40.737671663932254]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00176456641236,40.737671663932254]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.001772714979,40.73768538408589]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.001772714979,40.73768538408589]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00178086354477,40.73769910425314]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00178086354477,40.73769910425314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00178901210967,40.737712824434]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00178901210967,40.737712824434]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00179716067372,40.73772654462847]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00179716067372,40.73772654462847]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00180530923687,40.73774026483655]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00180530923687,40.73774026483655]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00181345779917,40.73775398505825]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00181345779917,40.73775398505825]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00182160636062,40.73776770529356]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00182160636062,40.73776770529356]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00182975492113,40.73778142554247]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00182975492113,40.73778142554247]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00183790348085,40.737795145805]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00183790348085,40.737795145805]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00184605203965,40.73780886608114]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00184605203965,40.73780886608114]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00185420059759,40.737822586370896]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00185420059759,40.737822586370896]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00186234915466,40.737836306674254]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00186234915466,40.737836306674254]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00187049771085,40.73785002699123]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00187049771085,40.73785002699123]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0018786462662,40.73786374732182]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0018786462662,40.73786374732182]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00188679482066,40.73787746766602]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00188679482066,40.73787746766602]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00189494337424,40.73789118802382]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00189494337424,40.73789118802382]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00190309192698,40.73790490839525]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00190309192698,40.73790490839525]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0019112404788,40.737918628780285]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0019112404788,40.737918628780285]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00191938902981,40.73793234917893]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00191938902981,40.73793234917893]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00192753757992,40.73794606959118]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00192753757992,40.73794606959118]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00193568612916,40.73795979001705]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00193568612916,40.73795979001705]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00194383467752,40.737973510456534]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00194383467752,40.737973510456534]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00195198322501,40.737987230909624]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00195198322501,40.737987230909624]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00196013177163,40.73800095137633]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00196013177163,40.73800095137633]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00196828031741,40.73801467185665]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00196828031741,40.73801467185665]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00197642886228,40.73802839235057]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00197642886228,40.73802839235057]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00198457740629,40.73804211285811]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00198457740629,40.73804211285811]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00199272594944,40.738055833379256]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00199272594944,40.738055833379256]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0020008744917,40.73806955391402]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0020008744917,40.73806955391402]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00200902303312,40.7380832744624]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00200902303312,40.7380832744624]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00201717157366,40.738096995024385]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00201717157366,40.738096995024385]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0020253201133,40.73811071559999]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0020253201133,40.73811071559999]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0020334686521,40.738124436189196]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0020334686521,40.738124436189196]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00204161719005,40.73813815679202]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00204161719005,40.73813815679202]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00204976572707,40.73815187740845]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00204976572707,40.73815187740845]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00205791426329,40.7381655980385]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00205791426329,40.7381655980385]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00206606279858,40.73817931868216]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00206606279858,40.73817931868216]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00207421133302,40.73819303933943]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00207421133302,40.73819303933943]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00208235986658,40.738206760010314]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00208235986658,40.738206760010314]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00208235986658,40.738206760010314]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00209050839928,40.73822048069481]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00209050839928,40.73822048069481]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00209050839928,40.73822048069481]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00209865693111,40.73823420139291]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00209865693111,40.73823420139291]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00209865693111,40.73823420139291]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00210680546208,40.73824792210464]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00210680546208,40.73824792210464]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00210680546208,40.73824792210464]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00211495399216,40.73826164282996]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00211495399216,40.73826164282996]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00211495399216,40.73826164282996]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0021231025214,40.73827536356891]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.0021231025214,40.73827536356891]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0021231025214,40.73827536356891]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00213125104973,40.738289084321465]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00213125104973,40.738289084321465]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00213125104973,40.738289084321465]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00213939957719,40.738302805087635]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00213939957719,40.738302805087635]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00213939957719,40.738302805087635]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00214754810382,40.73831652586741]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00214754810382,40.73831652586741]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00214754810382,40.73831652586741]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00215569662956,40.73833024666081]]},{"type":"LineString","coordinates":[[-74.000626,40.737742],[-74.00215569662956,40.73833024666081]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00215569662956,40.73833024666081]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0021638451544,40.73834396746781]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0021638451544,40.73834396746781]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00217199367842,40.73835768828843]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00217199367842,40.73835768828843]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00218014220152,40.738371409122664]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00218014220152,40.738371409122664]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00218829072375,40.7383851299705]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00218829072375,40.7383851299705]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00219643924518,40.738398850831956]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00219643924518,40.738398850831956]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00220458776569,40.73841257170702]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00220458776569,40.73841257170702]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0022127362853,40.738426292595705]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0022127362853,40.738426292595705]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0022208848041,40.73844001349799]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0022208848041,40.73844001349799]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00222903332198,40.7384537344139]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00222903332198,40.7384537344139]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00223718183902,40.73846745534342]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00223718183902,40.73846745534342]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00224533035517,40.73848117628655]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00224533035517,40.73848117628655]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00225347887044,40.73849489724329]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00225347887044,40.73849489724329]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00226162738487,40.738508618213636]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00226162738487,40.738508618213636]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00226977589841,40.73852233919761]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00226977589841,40.73852233919761]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.0022779244111,40.73853606019519]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0022779244111,40.73853606019519]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00228607292291,40.73854978120637]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00228607292291,40.73854978120637]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00229422143386,40.73856350223118]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00229422143386,40.73856350223118]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00230236994393,40.738577223269594]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00230236994393,40.738577223269594]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002077,40.737309],[-74.00231051845313,40.73859094432163]]},{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00231051845313,40.73859094432163]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00231866696143,40.73860466538727]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00232681546888,40.73861838646653]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00233496397551,40.7386321075594]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0023431124812,40.738645828665874]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00235126098603,40.73865954978597]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00235940949003,40.73867327091967]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00236755799314,40.738686992066995]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00237570649536,40.73870071322792]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0023838549967,40.73871443440246]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0023920034972,40.73872815559062]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00240015199682,40.738741876792396]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00240830049555,40.73875559800778]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00241644899346,40.73876931923677]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00242459749046,40.738783040479376]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0024327459866,40.7387967617356]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00244089448185,40.73881048300543]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00244904297627,40.73882420428888]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00245719146979,40.73883792558595]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00246533996246,40.73885164689661]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00247348845423,40.7388653682209]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00248163694518,40.7388790895588]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00248978543519,40.738892810910315]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00249793392436,40.73890653227544]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00250608241264,40.73892025365418]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0025142309001,40.738933975046535]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00252237938666,40.7389476964525]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00253052787235,40.738961417872076]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00253867635718,40.73897513930526]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00254682484113,40.738988860752066]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00255497332421,40.739002582212485]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00256312180642,40.73901630368652]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00257127028773,40.73903002517416]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0025794187682,40.73904374667542]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00258756724782,40.73905746819029]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00259571572654,40.73907118971877]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00260386420439,40.73908491126087]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00261201268138,40.73909863281658]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00262016115752,40.7391123543859]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00262830963275,40.73912607596884]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00263645810715,40.73913979756539]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00264460658062,40.73915351917555]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00265275505325,40.73916724079933]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00266090352503,40.73918096243673]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00266905199591,40.73919468408773]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00267720046593,40.73920840575235]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0026853489351,40.73922212743058]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00269349740336,40.73923584912242]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00270164587077,40.73924957082788]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0027097943373,40.73926329254696]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00271794280299,40.739277014279644]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00272609126777,40.739290736025936]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0027342397317,40.739304457785856]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00274238819478,40.73931817955938]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.00275053665695,40.739331901346524]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0027586851183,40.73934562314728]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.0027668335787,40.73935934496164]]}]},{"type":"GeometryCollection","geometries":[{"type":"LineString","coordinates":[[-74.002303,40.739491],[-74.002771,40.739366]]}]}]

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = [{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.998082,40.725539]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999786,40.725565]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.00047,40.726141]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996831,40.727328]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000574,40.72774]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999568,40.727056]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998412,40.727146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.996239,40.729638]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997304,40.728657]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999128,40.728689]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997987,40.729969]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.999917,40.730016]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999682,40.73146]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997822,40.731318]},"type":"Feature","properties":{"color":"pink"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.99701,40.73241]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-73.997234,40.733579]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.998676,40.732548]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000762,40.732961]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999177,40.733797]},"type":"Feature","properties":{"color":"green"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.000548,40.734881]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.000224,40.735864]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-73.999838,40.736752]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.000626,40.737742]},"type":"Feature","properties":{"color":"blue"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002077,40.737309]},"type":"Feature","properties":{"color":"pink"}},{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]},{"type":"FeatureCollection","features":[{"geometry":{"type":"Point","coordinates":[-74.002303,40.739491]},"type":"Feature","properties":{"color":"blue"}}]}]

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = [{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999786,40.725565],[-73.998082,40.725539],[-73.999568,40.727056],[-73.999786,40.725565]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998082,40.725539],[-73.998412,40.727146],[-73.999568,40.727056],[-73.998082,40.725539]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.998412,40.727146],[-73.999128,40.728689],[-73.999568,40.727056],[-73.998412,40.727146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997304,40.728657],[-73.999128,40.728689],[-73.998412,40.727146],[-73.997304,40.728657]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997304,40.728657],[-73.997987,40.729969],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999128,40.728689],[-73.997987,40.729969],[-73.999917,40.730016],[-73.999128,40.728689]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-74.001998,40.730348],[-73.999917,40.730016],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997987,40.729969],[-73.999682,40.73146],[-73.999917,40.730016],[-73.997987,40.729969]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.999682,40.73146],[-73.997987,40.729969],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999682,40.73146],[-73.997822,40.731318],[-73.998676,40.732548],[-73.999682,40.73146]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997822,40.731318],[-73.99701,40.73241],[-73.998676,40.732548],[-73.997822,40.731318]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.99701,40.73241],[-73.997234,40.733579],[-73.998676,40.732548],[-73.99701,40.73241]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.997234,40.733579],[-73.999177,40.733797],[-73.998676,40.732548],[-73.997234,40.733579]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-73.999177,40.733797],[-74.000762,40.732961],[-73.998676,40.732548],[-73.999177,40.733797]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000762,40.732961],[-73.999177,40.733797],[-74.000548,40.734881],[-74.000762,40.732961]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.002465,40.735473],[-74.000548,40.734881],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.002465,40.735473],[-74.000224,40.735864],[-74.002077,40.737309],[-74.002465,40.735473]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}},{"geometry":{"type":"Polygon","coordinates":[[[-74.000224,40.735864],[-74.000626,40.737742],[-74.002077,40.737309],[-74.000224,40.735864]]]},"type":"Feature","properties":{}}]

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function FeaturesTwo(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'featuresTwo',className:'FeaturesTwo'},content.main.map(function(content,_idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeaturesTwoItem,{key:'FeaturesTwoItem-'+_idx,content:content});}));}function FeaturesTwoItem(_ref2){var content=_ref2.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeaturesTwo-item'},content.img,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'inter'},content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p));}/* harmony default export */ __webpack_exports__["a"] = (FeaturesTwo);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function FeaturesBordered(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'featuresBordered',className:'FeaturesBordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'FeaturesBordered-header'},content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeaturesBordered-items'},content.main.map(function(item,_idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeaturesBorderedItem,{key:'FeaturesBorderedItem-'+_idx,content:item});})));}function FeaturesBorderedItem(_ref2){var content=_ref2.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeaturesBordered-item',style:{borderColor:content.color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,content.h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,content.p),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:content.cta.href,style:{backgroundColor:content.color}},content.cta.text));}/* harmony default export */ __webpack_exports__["a"] = (FeaturesBordered);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return steps; });
var steps=[{key:'ONE_BEACON',viewport:{longitude:-73.98,latitude:40.741,zoom:12,bearing:0,pitch:0},h:'How Location Verification works:\nZone Anchors.',h2:'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',p:'FOAM incentivizes the creation of a distributed network of radio beacons, called Zone Anchors. After joining the network, Zone Anchors send signals to discover and connect with others nearby.',img:{src:'/publicAssets/mapStory/Beacons.svg',alt:''// icon: { src: '/publicAssets/mapStory/mapstep1.png', alt: '' }
}},{key:'MANY_BEACONS',viewport:{longitude:-73.994894,latitude:40.730608,zoom:14,bearing:15,pitch:0},h:'Clock Synchronization.',h2:'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',p:'Location verification depends on accurate and synchronized clocks. Using a Byzantine Fault Tolerant clock synchronization protocol, Zone Anchors send messages until a consensus can be reached on the time. The timed difference of messages sent and received allows for location to be calculated and the geometry of the network to be determined.',img:{src:'/publicAssets/mapStory/Clocks.svg',alt:''// icon: { src: '/publicAssets/mapStory/mapstep2.png', alt: '' }
}},{key:'TRIANGULATIOM',viewport:{longitude:-73.99734,latitude:40.730828,zoom:15,bearing:20,pitch:0},h:'Zone Formation.',h2:'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',p:'Once synchronized, groups of Zone Anchors can establish a Zone. They pledge to offer location services that are enforced by smart contract safety deposits, which provide accountability for faulty behavior. A Zone maintains a quorum on time and space.',img:{src:'/publicAssets/mapStory/Zones.svg',alt:''// icon: { src: '/publicAssets/mapStory/mapstep3.png', alt: '' }
}},{key:'FOAMY',viewport:{longitude:-73.997341,latitude:40.729,zoom:16,bearing:25,pitch:40},h:'Triangulation.',h2:'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',p:'Zones can include time-stamped messages from customers in a competitive market for a transaction fee. This is done while Zones are resynchronizing clocks and publishing their time logs to a data store. Validators provide fraud proofs and calculate triangulations for precise location data to verify final Presence Claims.',img:{src:'/publicAssets/mapStory/Triangulation.svg',alt:''// icon: { src: '/publicAssets/mapStory/mapstep4.png', alt: '' }
}}];

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return company; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Views_Company_FullTeam__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Views_Company_TeamHero__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Views_Home_Partners__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamMembers__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partnerTiles__ = __webpack_require__(74);
var company=[{key:'teamHero',component:__WEBPACK_IMPORTED_MODULE_1__Views_Company_TeamHero__["a" /* default */],color:'LIGHT',shadow:true,main:{h:'Our Company',p:['Our team is made up of developers, designers, and geospatial experts. We are based out of the New Lab at the Brooklyn Navy Yard, an interdisciplinary workspace designed to support urban entrepreneurs leveraging advanced technologies.'],// cta: {
//   path: 'https://jobs.lever.co/foam',
//   text: 'We are currently hiring',
//   type: 'EXTERNAL'
// },
justification:'LEFT',width:'NARROW'},img:{src:'/publicAssets/newlab.jpg',alt:''}},{key:'company',component:__WEBPACK_IMPORTED_MODULE_0__Views_Company_FullTeam__["a" /* default */],color:'LIGHT',main:null,// {
//   h: 'Our Full Team',
//   p:
//     'We are designing a shared spatial language for open decentralized systems and smart contracts. FOAM is working on geospatial protocol and the resulting market implications on global infrastructures.',
//   icn: { src: '/publicAssets/icons/team.png', alt: '' },
//   justification: 'CENTER',
//   width: 'WIDE'
// },
teamMembers:__WEBPACK_IMPORTED_MODULE_3__teamMembers__["a" /* teamMembers */]},{key:'partners',component:__WEBPACK_IMPORTED_MODULE_2__Views_Home_Partners__["a" /* default */],color:'DARK',partnerTiles:__WEBPACK_IMPORTED_MODULE_4__partnerTiles__["a" /* partnerTiles */]}];

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Aside__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(12);
function FullTeam(_ref){var content=_ref.content;var coreMembers=content.teamMembers.filter(function(member){return member.role==='CORE'||member.role==='TEAM';});var advisors=content.teamMembers.filter(function(member){return member.role==='ADVISOR';});var collaborators=content.teamMembers.filter(function(member){return member.role==='COLLABORATOR';});var coreMembersAndAdvisors=coreMembers.concat(advisors);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'company'},content.main&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_Aside__["b" /* MainAside */],{content:content.main}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'midHeading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Core Team')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileGrid,{members:coreMembersAndAdvisors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'midHeading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Collaborators')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TileGrid,{members:collaborators}));}function TileGrid(_ref2){var members=_ref2.members;var tiles=members.map(function(member){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tile,{key:member.h,member:member});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-list'},tiles);}function Tile(_ref3){var member=_ref3.member;var h=member.h,s=member.s,p=member.p,img=member.img;var emojifiedTitle=Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* emojifyTitle */])(s);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teamMember-tile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:img.src,alt:h}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,h),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,emojifiedTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,p),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialList,{social:member.social})));}function SocialList(_ref4){var social=_ref4.social;var list=Object.keys(social).filter(function(key){return social[key]!=='';}).map(function(key){return(// eslint-disable-next-line
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:key,className:'social-button-'+key,href:social[key]}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialContainer'},list);}/* harmony default export */ __webpack_exports__["a"] = (FullTeam);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Aside__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_HeroMask__ = __webpack_require__(72);
function TeamHero(_ref){var content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'teamHero'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeroImage,{src:content.img.src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_Aside__["a" /* HeroAside */],{content:content.main}));}function HeroImage(_ref2){var src=_ref2.src;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hero-video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'newlab',src:src,alt:'New Lab'}),'\\',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_HeroMask__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (TeamHero);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return teamMembers; });
// NOTE: showOnFrontPage only allows role 'CORE' team members to be turn on /off on the front page.
var teamMembers=[{h:'Ryan John King',s:'Co-founder, CEO',p:'Entrepreneur with a background in urban economic development, architecture and blockchain technology.',role:'CORE',img:{src:'/publicAssets/team/Ryan.jpg',alt:''},social:{twitter:'https://twitter.com/frothcity',github:''},showOnFrontPage:true},{h:'Kristoffer Josefsson',s:'Co-founder, CTO',p:'Senior full-stack blockchain and smart contract developer. Early member of Consensys. Founding Member of BlockApps.',role:'CORE',img:{src:'/publicAssets/team/Kristoffer.jpg',alt:''},social:{twitter:'https://twitter.com/kejace',github:'https://github.com/kejace'},showOnFrontPage:true},{h:'Katya Zavyalova',s:'Co-founder, Creative Director',p:'Award winning architect and a leading industry voice recognized by the American Institute of Architects.',role:'CORE',img:{src:'/publicAssets/team/Ekaterina-Zavyalova.jpg',alt:''},social:{twitter:'https://twitter.com/katya_zavyalova',github:''},showOnFrontPage:true},//  {
//    h: 'Arthur Röing Baer',
//    s: 'Head of Growth',
//    p:
//      'Designer and researcher. Previously worked on blockchain-enabled infrastructure decentralization in logistics and mobility.',
//    role: 'CORE',
//    img: { src: '/publicAssets/team/Arthur.jpg', alt: '' },
//    social: {
//      twitter: 'https://twitter.com/ArthurRoingBaer',
//      github: ''
//    },
//    showOnFrontPage: true
//  },
{h:'Ilya Ostrovskiy',s:'​​​<wizard/> / Hacker-in-Charge',p:'Polyglot programmer and DevOps plumber. Former VM lead at BlockApps. Co-author of the PureScript Ethereum development tool Chanterelle.',role:'CORE',img:{src:'/publicAssets/team/Ilya.png',alt:''},social:{twitter:'',github:'https://github.com/iostat'},showOnFrontPage:true},// {
//   h: 'Irakli Safareli',
//   s: 'Senior Software Engineer',
//   p:
//     'Front-end developer and functional programming specialist. Author and contributor of many open source PureScript libraries, including the functional Ethereum stack developed at FOAM. Co-author of the Haskell cosmos/tendermint SDK.',
//   role: 'TEAM',
//   img: { src: '/publicAssets/team/irakli.png', alt: '' },
//   social: {
//     twitter: 'https://twitter.com/safareli',
//     github: 'https://github.com/safareli'
//   }
// },
{h:'Anjali Vijay Kumar',s:'Senior Electrical Engineer',p:'Computer Hardware Engineer specializing in electronic product design and firmware development. Specifically interested in IoT based technologies.',role:'TEAM',img:{src:'/publicAssets/team/Anjali.jpg',alt:''},social:{linkedIn:'https://www.linkedin.com/in/anjalivijaykumar'}},{h:'Michael Goldenberg',s:'Software Engineer',p:'Michael has a background at the intersections of philosophy, education, and computer science. He’s interested in networks and decentralization.',role:'TEAM',img:{src:'/publicAssets/team/Michael.png',alt:''},social:{twitter:'',github:'https://github.com/mgoldenberg'}},{h:'Carl Factora',s:'Software Engineer',p:'Functional programmer with a background in programming language theory. Former lead architect at Droit Financial Technologies.',role:'TEAM',img:{src:'/publicAssets/team/Carl.png',alt:''},social:{github:'https://github.com/IvantheTricourne'}},{h:'Coleman Moore',s:'Technical Project Manager',p:'Technical Project Manager with experience implementing difficult technology solutions. Former Big 4 management consultant focused on Supply Chain technology.',role:'TEAM',img:{src:'/publicAssets/team/Coleman.png',alt:''},social:{twitter:'https://twitter.com/nameloceroom'}},{h:'Matt Earl',s:'Senior Rust Engineer',p:'Programmer with a background in robotic fleet coordination and control.',role:'TEAM',img:{src:'/publicAssets/team/Matt-Earl.png',alt:''},social:{github:'https://github.com/mattearl'}},{h:'Aadil Hashmi',s:'Electrical Engineer',p:'Aadil has an educational background in Biomedical and Electrical Engineering. He’s interested in network design and communication systems.',role:'TEAM',img:{src:'/publicAssets/team/Aadil.png',alt:''},social:{linkedIn:'https://www.linkedin.com/in/aadil-h-5733b0139/'}},// {
//   h: 'Jessica Salomon',
//   s: 'Community and Growth',
//   p:
//     'Community, Marketing and Business Strategist. Former Community and Business at MakerDAO.',
//   role: 'TEAM',
//   img: { src: '/publicAssets/team/Jessica.png', alt: '' },
//   social: {
//     linkedIn: 'https://www.linkedin.com/in/jessica-salomon-772a94a9/'
//   }
// },
// {
//   h: 'Andrej Dukalev',
//   s: 'Strategic Business and Operations Manager',
//   p:
//     'Andrej is a business developer with a background in engineering, passionate about finding product market fit in order to grow value for everyone involved.',
//   role: 'TEAM',
//   img: { src: '/publicAssets/team/Andrej.png', alt: '' },
//   social: {
//     linkedIn: 'https://www.linkedin.com/in/dukalev/'
//   }
// },
// {
//   h: 'Daryl Lau Toh Kin',
//   s: 'Community Administrator',
//   p:
//     'Community administrator, passionate about growing communities centered around decentralization.',
//   role: 'TEAM',
//   img: { src: '/publicAssets/team/daryl.jpg', alt: '' },
//   social: {
//     twitter: 'https://twitter.com/Daryllautk',
//     github: ''
//   }
// },
{h:'Martin Allen',s:'Senior Blockchain Engineer',p:'Functional programming specialist, author of purescript-web3. Formerly a senior engineer at BlockApps. Background in algebraic geometry.',role:'COLLABORATOR',img:{src:'/publicAssets/team/Martin.jpg',alt:''},social:{twitter:'',github:'https://github.com/martyall'},showOnFrontPage:true},{h:'Édouard Urcades',s:'Product Designer',p:'Édouard is a designer interested in infrastructure.',role:'COLLABORATOR',img:{src:'/publicAssets/team/ed.jpg',alt:''},social:{twitter:'https://twitter.com/edouerd',github:''}},{h:'General Trademark',s:'Product R&D',p:'General Trademark is product R&D studio run by Callil Capuozzo and Gavin Atkinson.',role:'COLLABORATOR',img:{src:'/publicAssets/team/GT.jpg',alt:''},social:{twitter:'',github:''}},{h:'Anna Kopp',s:'Full Stack Engineer',p:'Anna is a software developer. She likes using Haskell to make compile time guarantees about data and functions.',role:'COLLABORATOR',img:{src:'/publicAssets/team/Anna.jpg',alt:''},social:{twitter:'',github:''},showOnFrontPage:true},{h:'Ben Weitzman',s:'Full Stack Engineer',p:'Ben is a software engineer with a deep interest in implementation and application of lazy functional languages.',role:'COLLABORATOR',img:{src:'/publicAssets/team/Ben.png',alt:''},social:{twitter:'',github:''},showOnFrontPage:true},{h:'Sam Hart',s:'Scientist',p:'Researcher specializing in quantitative analysis and systems design. Background in computational genomics, biophysics, and publishing.',role:'COLLABORATOR',img:{src:'/publicAssets/team/Sam_Hart.jpg',alt:''},social:{twitter:'',github:''}},// {
//   h: 'Matt Vernon',
//   s: 'Product Designer',
//   p:
//     'Sydney-based Product Designer currently focusing on bringing great design and user experiences to decentralized applications.',
//   role: 'COLLABORATOR',
//   img: { src: '/publicAssets/team/matt-vernon.jpg', alt: '' },
//   social: {
//     twitter: 'https://twitter.com/dApp_boi',
//     github: ''
//   },
//   showOnFrontPage: true
// },
// {
//   h: 'Enrico Zago',
//   s: '3D Artist',
//   p:
//     'Vienna-based artist and designer. His work involves 3D objects in order to investigate the perception of the physical environment into its digital representations and deformations.',
//   role: 'COLLABORATOR',
//   img: { src: '/publicAssets/team/Enrico-Zago.jpg', alt: '' },
//   social: {
//     twitter: '',
//     github: ''
//   },
//   showOnFrontPage: true
// },
{h:'Rick Dudley',s:'Blockchain Technical Consultant and Advisor ',p:'President of Vulcanize, a firm providing decentralized applications with blockchain technical guidance, project management, and code & security audits; & Blockchain Architect for Omega One.',role:'ADVISOR',img:{src:'/publicAssets/team/Rick-Dudley.png',alt:''},social:{twitter:'https://twitter.com/AFDudley0',github:''},showOnFrontPage:true},// {
//   h: 'Alyssa Wright',
//   s: 'OpenStreetMap Consultant and Advisor',
//   p:
//     'Geospatial technologist, strategist & entrepreneur focused on the intersection of open innovation, community, and collaboration. Started at beginning of OpenStreetMap, OpenGeo, Open Transport Partnership and Mapzen. She’s let you know when she’s arrived at the destination.',
//   role: 'COLLABORATOR',
//   img: { src: '/publicAssets/team/alyssa.jpg', alt: '' },
//   social: {
//     twitter: 'https://twitter.com/alyssapwright',
//     github: ''
//   },
//   showOnFrontPage: true
// },
{h:'Matt Liston',s:'Special Advisor',p:'Founding member and ambassador of Gnosis, Augur cofounder.',role:'ADVISOR',img:{src:'/publicAssets/team/Matt-Liston.jpg',alt:''},social:{twitter:'https://twitter.com/malloc8',github:''},showOnFrontPage:true// {
//   h: 'Rivers Plasketes',
//   s: 'Administrative Specialist',
//   p: 'Rivers is an artist and writer based in Brooklyn.',
//   role: 'TEAM',
//   img: { src: '/publicAssets/team/rivers.jpg', alt: '' },
//   social: {
//     twitter: '',
//     github: ''
//   }
// }
}];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Web3 = __webpack_require__(193);

// dont override global variable
if (typeof window !== 'undefined' && typeof window.Web3 === 'undefined') {
    window.Web3 = Web3;
}

module.exports = Web3;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file web3.js
 * @authors:
 *   Jeffrey Wilcke <jeff@ethdev.com>
 *   Marek Kotewicz <marek@ethdev.com>
 *   Marian Oancea <marian@ethdev.com>
 *   Fabian Vogelsteller <fabian@ethdev.com>
 *   Gav Wood <g@ethdev.com>
 * @date 2014
 */

var RequestManager = __webpack_require__(194);
var Iban = __webpack_require__(33);
var Eth = __webpack_require__(219);
var DB = __webpack_require__(238);
var Shh = __webpack_require__(239);
var Net = __webpack_require__(240);
var Personal = __webpack_require__(241);
var Swarm = __webpack_require__(242);
var Settings = __webpack_require__(243);
var version = __webpack_require__(244);
var utils = __webpack_require__(2);
var sha3 = __webpack_require__(27);
var extend = __webpack_require__(245);
var Batch = __webpack_require__(246);
var Property = __webpack_require__(23);
var HttpProvider = __webpack_require__(247);
var IpcProvider = __webpack_require__(254);
var BigNumber = __webpack_require__(26);



function Web3 (provider) {
    this._requestManager = new RequestManager(provider);
    this.currentProvider = provider;
    this.eth = new Eth(this);
    this.db = new DB(this);
    this.shh = new Shh(this);
    this.net = new Net(this);
    this.personal = new Personal(this);
    this.bzz = new Swarm(this);
    this.settings = new Settings();
    this.version = {
        api: version.version
    };
    this.providers = {
        HttpProvider: HttpProvider,
        IpcProvider: IpcProvider
    };
    this._extend = extend(this);
    this._extend({
        properties: properties()
    });
}

// expose providers on the class
Web3.providers = {
    HttpProvider: HttpProvider,
    IpcProvider: IpcProvider
};

Web3.prototype.setProvider = function (provider) {
    this._requestManager.setProvider(provider);
    this.currentProvider = provider;
};

Web3.prototype.reset = function (keepIsSyncing) {
    this._requestManager.reset(keepIsSyncing);
    this.settings = new Settings();
};

Web3.prototype.BigNumber = BigNumber;
Web3.prototype.toHex = utils.toHex;
Web3.prototype.toAscii = utils.toAscii;
Web3.prototype.toUtf8 = utils.toUtf8;
Web3.prototype.fromAscii = utils.fromAscii;
Web3.prototype.fromUtf8 = utils.fromUtf8;
Web3.prototype.toDecimal = utils.toDecimal;
Web3.prototype.fromDecimal = utils.fromDecimal;
Web3.prototype.toBigNumber = utils.toBigNumber;
Web3.prototype.toWei = utils.toWei;
Web3.prototype.fromWei = utils.fromWei;
Web3.prototype.isAddress = utils.isAddress;
Web3.prototype.isChecksumAddress = utils.isChecksumAddress;
Web3.prototype.toChecksumAddress = utils.toChecksumAddress;
Web3.prototype.isIBAN = utils.isIBAN;
Web3.prototype.padLeft = utils.padLeft;
Web3.prototype.padRight = utils.padRight;


Web3.prototype.sha3 = function(string, options) {
    return '0x' + sha3(string, options);
};

/**
 * Transforms direct icap to address
 */
Web3.prototype.fromICAP = function (icap) {
    var iban = new Iban(icap);
    return iban.address();
};

var properties = function () {
    return [
        new Property({
            name: 'version.node',
            getter: 'web3_clientVersion'
        }),
        new Property({
            name: 'version.network',
            getter: 'net_version',
            inputFormatter: utils.toDecimal
        }),
        new Property({
            name: 'version.ethereum',
            getter: 'eth_protocolVersion',
            inputFormatter: utils.toDecimal
        }),
        new Property({
            name: 'version.whisper',
            getter: 'shh_version',
            inputFormatter: utils.toDecimal
        })
    ];
};

Web3.prototype.isConnected = function(){
    return (this.currentProvider && this.currentProvider.isConnected());
};

Web3.prototype.createBatch = function () {
    return new Batch(this);
};

module.exports = Web3;



/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file requestmanager.js
 * @author Jeffrey Wilcke <jeff@ethdev.com>
 * @author Marek Kotewicz <marek@ethdev.com>
 * @author Marian Oancea <marian@ethdev.com>
 * @author Fabian Vogelsteller <fabian@ethdev.com>
 * @author Gav Wood <g@ethdev.com>
 * @date 2014
 */

var Jsonrpc = __webpack_require__(77);
var utils = __webpack_require__(2);
var c = __webpack_require__(32);
var errors = __webpack_require__(22);

/**
 * It's responsible for passing messages to providers
 * It's also responsible for polling the ethereum node for incoming messages
 * Default poll timeout is 1 second
 * Singleton
 */
var RequestManager = function (provider) {
    this.provider = provider;
    this.polls = {};
    this.timeout = null;
};

/**
 * Should be used to synchronously send request
 *
 * @method send
 * @param {Object} data
 * @return {Object}
 */
RequestManager.prototype.send = function (data) {
    if (!this.provider) {
        console.error(errors.InvalidProvider());
        return null;
    }

    var payload = Jsonrpc.toPayload(data.method, data.params);
    var result = this.provider.send(payload);

    if (!Jsonrpc.isValidResponse(result)) {
        throw errors.InvalidResponse(result);
    }

    return result.result;
};

/**
 * Should be used to asynchronously send request
 *
 * @method sendAsync
 * @param {Object} data
 * @param {Function} callback
 */
RequestManager.prototype.sendAsync = function (data, callback) {
    if (!this.provider) {
        return callback(errors.InvalidProvider());
    }

    var payload = Jsonrpc.toPayload(data.method, data.params);
    this.provider.sendAsync(payload, function (err, result) {
        if (err) {
            return callback(err);
        }
        
        if (!Jsonrpc.isValidResponse(result)) {
            return callback(errors.InvalidResponse(result));
        }

        callback(null, result.result);
    });
};

/**
 * Should be called to asynchronously send batch request
 *
 * @method sendBatch
 * @param {Array} batch data
 * @param {Function} callback
 */
RequestManager.prototype.sendBatch = function (data, callback) {
    if (!this.provider) {
        return callback(errors.InvalidProvider());
    }

    var payload = Jsonrpc.toBatchPayload(data);

    this.provider.sendAsync(payload, function (err, results) {
        if (err) {
            return callback(err);
        }

        if (!utils.isArray(results)) {
            return callback(errors.InvalidResponse(results));
        }

        callback(err, results);
    }); 
};

/**
 * Should be used to set provider of request manager
 *
 * @method setProvider
 * @param {Object}
 */
RequestManager.prototype.setProvider = function (p) {
    this.provider = p;
};

/**
 * Should be used to start polling
 *
 * @method startPolling
 * @param {Object} data
 * @param {Number} pollId
 * @param {Function} callback
 * @param {Function} uninstall
 *
 * @todo cleanup number of params
 */
RequestManager.prototype.startPolling = function (data, pollId, callback, uninstall) {
    this.polls[pollId] = {data: data, id: pollId, callback: callback, uninstall: uninstall};


    // start polling
    if (!this.timeout) {
        this.poll();
    }
};

/**
 * Should be used to stop polling for filter with given id
 *
 * @method stopPolling
 * @param {Number} pollId
 */
RequestManager.prototype.stopPolling = function (pollId) {
    delete this.polls[pollId];

    // stop polling
    if(Object.keys(this.polls).length === 0 && this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
    }
};

/**
 * Should be called to reset the polling mechanism of the request manager
 *
 * @method reset
 */
RequestManager.prototype.reset = function (keepIsSyncing) {
    /*jshint maxcomplexity:5 */

    for (var key in this.polls) {
        // remove all polls, except sync polls,
        // they need to be removed manually by calling syncing.stopWatching()
        if(!keepIsSyncing || key.indexOf('syncPoll_') === -1) {
            this.polls[key].uninstall();
            delete this.polls[key];
        }
    }

    // stop polling
    if(Object.keys(this.polls).length === 0 && this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
    }
};

/**
 * Should be called to poll for changes on filter with given id
 *
 * @method poll
 */
RequestManager.prototype.poll = function () {
    /*jshint maxcomplexity: 6 */
    this.timeout = setTimeout(this.poll.bind(this), c.ETH_POLLING_TIMEOUT);

    if (Object.keys(this.polls).length === 0) {
        return;
    }

    if (!this.provider) {
        console.error(errors.InvalidProvider());
        return;
    }

    var pollsData = [];
    var pollsIds = [];
    for (var key in this.polls) {
        pollsData.push(this.polls[key].data);
        pollsIds.push(key);
    }

    if (pollsData.length === 0) {
        return;
    }

    var payload = Jsonrpc.toBatchPayload(pollsData);
    
    // map the request id to they poll id
    var pollsIdMap = {};
    payload.forEach(function(load, index){
        pollsIdMap[load.id] = pollsIds[index];
    });


    var self = this;
    this.provider.sendAsync(payload, function (error, results) {


        // TODO: console log?
        if (error) {
            return;
        }

        if (!utils.isArray(results)) {
            throw errors.InvalidResponse(results);
        }
        results.map(function (result) {
            var id = pollsIdMap[result.id];

            // make sure the filter is still installed after arrival of the request
            if (self.polls[id]) {
                result.callback = self.polls[id].callback;
                return result;
            } else
                return false;
        }).filter(function (result) {
            return !!result; 
        }).filter(function (result) {
            var valid = Jsonrpc.isValidResponse(result);
            if (!valid) {
                result.callback(errors.InvalidResponse(result));
            }
            return valid;
        }).forEach(function (result) {
            result.callback(null, result.result);
        });
    });
};

module.exports = RequestManager;



/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(31), __webpack_require__(196), __webpack_require__(197), __webpack_require__(20), __webpack_require__(21), __webpack_require__(47), __webpack_require__(78), __webpack_require__(198), __webpack_require__(79), __webpack_require__(199), __webpack_require__(80), __webpack_require__(200), __webpack_require__(48), __webpack_require__(201), __webpack_require__(17), __webpack_require__(3), __webpack_require__(202), __webpack_require__(203), __webpack_require__(204), __webpack_require__(205), __webpack_require__(206), __webpack_require__(207), __webpack_require__(208), __webpack_require__(209), __webpack_require__(210), __webpack_require__(211), __webpack_require__(212), __webpack_require__(213), __webpack_require__(214), __webpack_require__(215), __webpack_require__(216), __webpack_require__(217));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(78));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(31), __webpack_require__(79));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(47), __webpack_require__(48));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(20), __webpack_require__(21), __webpack_require__(17), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(20), __webpack_require__(21), __webpack_require__(17), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(20), __webpack_require__(21), __webpack_require__(17), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(20), __webpack_require__(21), __webpack_require__(17), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(1), __webpack_require__(20), __webpack_require__(21), __webpack_require__(17), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/utf8js v2.1.2 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var utf8 = {
		'version': '2.1.2',
		'encode': utf8encode,
		'decode': utf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return utf8;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = utf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in utf8) {
				hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.utf8 = utf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module), __webpack_require__(8)))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file eth.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @author Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */



var formatters = __webpack_require__(14);
var utils = __webpack_require__(2);
var Method = __webpack_require__(18);
var Property = __webpack_require__(23);
var c = __webpack_require__(32);
var Contract = __webpack_require__(220);
var watches = __webpack_require__(35);
var Filter = __webpack_require__(34);
var IsSyncing = __webpack_require__(232);
var namereg = __webpack_require__(233);
var Iban = __webpack_require__(33);
var transfer = __webpack_require__(236);

var blockCall = function (args) {
    return (utils.isString(args[0]) && args[0].indexOf('0x') === 0) ? "eth_getBlockByHash" : "eth_getBlockByNumber";
};

var transactionFromBlockCall = function (args) {
    return (utils.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getTransactionByBlockHashAndIndex' : 'eth_getTransactionByBlockNumberAndIndex';
};

var uncleCall = function (args) {
    return (utils.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getUncleByBlockHashAndIndex' : 'eth_getUncleByBlockNumberAndIndex';
};

var getBlockTransactionCountCall = function (args) {
    return (utils.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getBlockTransactionCountByHash' : 'eth_getBlockTransactionCountByNumber';
};

var uncleCountCall = function (args) {
    return (utils.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getUncleCountByBlockHash' : 'eth_getUncleCountByBlockNumber';
};

function Eth(web3) {
    this._requestManager = web3._requestManager;

    var self = this;

    methods().forEach(function(method) {
        method.attachToObject(self);
        method.setRequestManager(self._requestManager);
    });

    properties().forEach(function(p) {
        p.attachToObject(self);
        p.setRequestManager(self._requestManager);
    });


    this.iban = Iban;
    this.sendIBANTransaction = transfer.bind(null, this);
}

Object.defineProperty(Eth.prototype, 'defaultBlock', {
    get: function () {
        return c.defaultBlock;
    },
    set: function (val) {
        c.defaultBlock = val;
        return val;
    }
});

Object.defineProperty(Eth.prototype, 'defaultAccount', {
    get: function () {
        return c.defaultAccount;
    },
    set: function (val) {
        c.defaultAccount = val;
        return val;
    }
});

var methods = function () {
    var getBalance = new Method({
        name: 'getBalance',
        call: 'eth_getBalance',
        params: 2,
        inputFormatter: [formatters.inputAddressFormatter, formatters.inputDefaultBlockNumberFormatter],
        outputFormatter: formatters.outputBigNumberFormatter
    });

    var getStorageAt = new Method({
        name: 'getStorageAt',
        call: 'eth_getStorageAt',
        params: 3,
        inputFormatter: [null, utils.toHex, formatters.inputDefaultBlockNumberFormatter]
    });

    var getCode = new Method({
        name: 'getCode',
        call: 'eth_getCode',
        params: 2,
        inputFormatter: [formatters.inputAddressFormatter, formatters.inputDefaultBlockNumberFormatter]
    });

    var getBlock = new Method({
        name: 'getBlock',
        call: blockCall,
        params: 2,
        inputFormatter: [formatters.inputBlockNumberFormatter, function (val) { return !!val; }],
        outputFormatter: formatters.outputBlockFormatter
    });

    var getUncle = new Method({
        name: 'getUncle',
        call: uncleCall,
        params: 2,
        inputFormatter: [formatters.inputBlockNumberFormatter, utils.toHex],
        outputFormatter: formatters.outputBlockFormatter,

    });

    var getCompilers = new Method({
        name: 'getCompilers',
        call: 'eth_getCompilers',
        params: 0
    });

    var getBlockTransactionCount = new Method({
        name: 'getBlockTransactionCount',
        call: getBlockTransactionCountCall,
        params: 1,
        inputFormatter: [formatters.inputBlockNumberFormatter],
        outputFormatter: utils.toDecimal
    });

    var getBlockUncleCount = new Method({
        name: 'getBlockUncleCount',
        call: uncleCountCall,
        params: 1,
        inputFormatter: [formatters.inputBlockNumberFormatter],
        outputFormatter: utils.toDecimal
    });

    var getTransaction = new Method({
        name: 'getTransaction',
        call: 'eth_getTransactionByHash',
        params: 1,
        outputFormatter: formatters.outputTransactionFormatter
    });

    var getTransactionFromBlock = new Method({
        name: 'getTransactionFromBlock',
        call: transactionFromBlockCall,
        params: 2,
        inputFormatter: [formatters.inputBlockNumberFormatter, utils.toHex],
        outputFormatter: formatters.outputTransactionFormatter
    });

    var getTransactionReceipt = new Method({
        name: 'getTransactionReceipt',
        call: 'eth_getTransactionReceipt',
        params: 1,
        outputFormatter: formatters.outputTransactionReceiptFormatter
    });

    var getTransactionCount = new Method({
        name: 'getTransactionCount',
        call: 'eth_getTransactionCount',
        params: 2,
        inputFormatter: [null, formatters.inputDefaultBlockNumberFormatter],
        outputFormatter: utils.toDecimal
    });

    var sendRawTransaction = new Method({
        name: 'sendRawTransaction',
        call: 'eth_sendRawTransaction',
        params: 1,
        inputFormatter: [null]
    });

    var sendTransaction = new Method({
        name: 'sendTransaction',
        call: 'eth_sendTransaction',
        params: 1,
        inputFormatter: [formatters.inputTransactionFormatter]
    });

    var signTransaction = new Method({
        name: 'signTransaction',
        call: 'eth_signTransaction',
        params: 1,
        inputFormatter: [formatters.inputTransactionFormatter]
    });

    var sign = new Method({
        name: 'sign',
        call: 'eth_sign',
        params: 2,
        inputFormatter: [formatters.inputAddressFormatter, null]
    });

    var call = new Method({
        name: 'call',
        call: 'eth_call',
        params: 2,
        inputFormatter: [formatters.inputCallFormatter, formatters.inputDefaultBlockNumberFormatter]
    });

    var estimateGas = new Method({
        name: 'estimateGas',
        call: 'eth_estimateGas',
        params: 1,
        inputFormatter: [formatters.inputCallFormatter],
        outputFormatter: utils.toDecimal
    });

    var compileSolidity = new Method({
        name: 'compile.solidity',
        call: 'eth_compileSolidity',
        params: 1
    });

    var compileLLL = new Method({
        name: 'compile.lll',
        call: 'eth_compileLLL',
        params: 1
    });

    var compileSerpent = new Method({
        name: 'compile.serpent',
        call: 'eth_compileSerpent',
        params: 1
    });

    var submitWork = new Method({
        name: 'submitWork',
        call: 'eth_submitWork',
        params: 3
    });

    var getWork = new Method({
        name: 'getWork',
        call: 'eth_getWork',
        params: 0
    });

    return [
        getBalance,
        getStorageAt,
        getCode,
        getBlock,
        getUncle,
        getCompilers,
        getBlockTransactionCount,
        getBlockUncleCount,
        getTransaction,
        getTransactionFromBlock,
        getTransactionReceipt,
        getTransactionCount,
        call,
        estimateGas,
        sendRawTransaction,
        signTransaction,
        sendTransaction,
        sign,
        compileSolidity,
        compileLLL,
        compileSerpent,
        submitWork,
        getWork
    ];
};


var properties = function () {
    return [
        new Property({
            name: 'coinbase',
            getter: 'eth_coinbase'
        }),
        new Property({
            name: 'mining',
            getter: 'eth_mining'
        }),
        new Property({
            name: 'hashrate',
            getter: 'eth_hashrate',
            outputFormatter: utils.toDecimal
        }),
        new Property({
            name: 'syncing',
            getter: 'eth_syncing',
            outputFormatter: formatters.outputSyncingFormatter
        }),
        new Property({
            name: 'gasPrice',
            getter: 'eth_gasPrice',
            outputFormatter: formatters.outputBigNumberFormatter
        }),
        new Property({
            name: 'accounts',
            getter: 'eth_accounts'
        }),
        new Property({
            name: 'blockNumber',
            getter: 'eth_blockNumber',
            outputFormatter: utils.toDecimal
        }),
        new Property({
            name: 'protocolVersion',
            getter: 'eth_protocolVersion'
        })
    ];
};

Eth.prototype.contract = function (abi) {
    var factory = new Contract(this, abi);
    return factory;
};

Eth.prototype.filter = function (options, callback, filterCreationErrorCallback) {
    return new Filter(options, 'eth', this._requestManager, watches.eth(), formatters.outputLogFormatter, callback, filterCreationErrorCallback);
};

Eth.prototype.namereg = function () {
    return this.contract(namereg.global.abi).at(namereg.global.address);
};

Eth.prototype.icapNamereg = function () {
    return this.contract(namereg.icap.abi).at(namereg.icap.address);
};

Eth.prototype.isSyncing = function (callback) {
    return new IsSyncing(this._requestManager, callback);
};

module.exports = Eth;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file contract.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2014
 */

var utils = __webpack_require__(2);
var coder = __webpack_require__(49);
var SolidityEvent = __webpack_require__(82);
var SolidityFunction = __webpack_require__(230);
var AllEvents = __webpack_require__(231);

/**
 * Should be called to encode constructor params
 *
 * @method encodeConstructorParams
 * @param {Array} abi
 * @param {Array} constructor params
 */
var encodeConstructorParams = function (abi, params) {
    return abi.filter(function (json) {
        return json.type === 'constructor' && json.inputs.length === params.length;
    }).map(function (json) {
        return json.inputs.map(function (input) {
            return input.type;
        });
    }).map(function (types) {
        return coder.encodeParams(types, params);
    })[0] || '';
};

/**
 * Should be called to add functions to contract object
 *
 * @method addFunctionsToContract
 * @param {Contract} contract
 * @param {Array} abi
 */
var addFunctionsToContract = function (contract) {
    contract.abi.filter(function (json) {
        return json.type === 'function';
    }).map(function (json) {
        return new SolidityFunction(contract._eth, json, contract.address);
    }).forEach(function (f) {
        f.attachToContract(contract);
    });
};

/**
 * Should be called to add events to contract object
 *
 * @method addEventsToContract
 * @param {Contract} contract
 * @param {Array} abi
 */
var addEventsToContract = function (contract) {
    var events = contract.abi.filter(function (json) {
        return json.type === 'event';
    });

    var All = new AllEvents(contract._eth._requestManager, events, contract.address);
    All.attachToContract(contract);

    events.map(function (json) {
        return new SolidityEvent(contract._eth._requestManager, json, contract.address);
    }).forEach(function (e) {
        e.attachToContract(contract);
    });
};


/**
 * Should be called to check if the contract gets properly deployed on the blockchain.
 *
 * @method checkForContractAddress
 * @param {Object} contract
 * @param {Function} callback
 * @returns {Undefined}
 */
var checkForContractAddress = function(contract, callback){
    var count = 0,
        callbackFired = false;

    // wait for receipt
    var filter = contract._eth.filter('latest', function(e){
        if (!e && !callbackFired) {
            count++;

            // stop watching after 50 blocks (timeout)
            if (count > 50) {

                filter.stopWatching(function() {});
                callbackFired = true;

                if (callback)
                    callback(new Error('Contract transaction couldn\'t be found after 50 blocks'));
                else
                    throw new Error('Contract transaction couldn\'t be found after 50 blocks');


            } else {

                contract._eth.getTransactionReceipt(contract.transactionHash, function(e, receipt){
                    if(receipt && receipt.blockHash && !callbackFired) {

                        contract._eth.getCode(receipt.contractAddress, function(e, code){
                            /*jshint maxcomplexity: 6 */

                            if(callbackFired || !code)
                                return;

                            filter.stopWatching(function() {});
                            callbackFired = true;

                            if(code.length > 3) {

                                // console.log('Contract code deployed!');

                                contract.address = receipt.contractAddress;

                                // attach events and methods again after we have
                                addFunctionsToContract(contract);
                                addEventsToContract(contract);

                                // call callback for the second time
                                if(callback)
                                    callback(null, contract);

                            } else {
                                if(callback)
                                    callback(new Error('The contract code couldn\'t be stored, please check your gas amount.'));
                                else
                                    throw new Error('The contract code couldn\'t be stored, please check your gas amount.');
                            }
                        });
                    }
                });
            }
        }
    });
};

/**
 * Should be called to create new ContractFactory instance
 *
 * @method ContractFactory
 * @param {Array} abi
 */
var ContractFactory = function (eth, abi) {
    this.eth = eth;
    this.abi = abi;

    /**
     * Should be called to create new contract on a blockchain
     *
     * @method new
     * @param {Any} contract constructor param1 (optional)
     * @param {Any} contract constructor param2 (optional)
     * @param {Object} contract transaction object (required)
     * @param {Function} callback
     * @returns {Contract} returns contract instance
     */
    this.new = function () {
        /*jshint maxcomplexity: 7 */

        var contract = new Contract(this.eth, this.abi);

        // parse arguments
        var options = {}; // required!
        var callback;

        var args = Array.prototype.slice.call(arguments);
        if (utils.isFunction(args[args.length - 1])) {
            callback = args.pop();
        }

        var last = args[args.length - 1];
        if (utils.isObject(last) && !utils.isArray(last)) {
            options = args.pop();
        }

        if (options.value > 0) {
            var constructorAbi = abi.filter(function (json) {
                return json.type === 'constructor' && json.inputs.length === args.length;
            })[0] || {};

            if (!constructorAbi.payable) {
                throw new Error('Cannot send value to non-payable constructor');
            }
        }

        var bytes = encodeConstructorParams(this.abi, args);
        options.data += bytes;

        if (callback) {

            // wait for the contract address and check if the code was deployed
            this.eth.sendTransaction(options, function (err, hash) {
                if (err) {
                    callback(err);
                } else {
                    // add the transaction hash
                    contract.transactionHash = hash;

                    // call callback for the first time
                    callback(null, contract);

                    checkForContractAddress(contract, callback);
                }
            });
        } else {
            var hash = this.eth.sendTransaction(options);
            // add the transaction hash
            contract.transactionHash = hash;
            checkForContractAddress(contract);
        }

        return contract;
    };

    this.new.getData = this.getData.bind(this);
};

/**
 * Should be called to create new ContractFactory
 *
 * @method contract
 * @param {Array} abi
 * @returns {ContractFactory} new contract factory
 */
//var contract = function (abi) {
    //return new ContractFactory(abi);
//};



/**
 * Should be called to get access to existing contract on a blockchain
 *
 * @method at
 * @param {Address} contract address (required)
 * @param {Function} callback {optional)
 * @returns {Contract} returns contract if no callback was passed,
 * otherwise calls callback function (err, contract)
 */
ContractFactory.prototype.at = function (address, callback) {
    var contract = new Contract(this.eth, this.abi, address);

    // this functions are not part of prototype,
    // because we dont want to spoil the interface
    addFunctionsToContract(contract);
    addEventsToContract(contract);

    if (callback) {
        callback(null, contract);
    }
    return contract;
};

/**
 * Gets the data, which is data to deploy plus constructor params
 *
 * @method getData
 */
ContractFactory.prototype.getData = function () {
    var options = {}; // required!
    var args = Array.prototype.slice.call(arguments);

    var last = args[args.length - 1];
    if (utils.isObject(last) && !utils.isArray(last)) {
        options = args.pop();
    }

    var bytes = encodeConstructorParams(this.abi, args);
    options.data += bytes;

    return options.data;
};

/**
 * Should be called to create new contract instance
 *
 * @method Contract
 * @param {Array} abi
 * @param {Address} contract address
 */
var Contract = function (eth, abi, address) {
    this._eth = eth;
    this.transactionHash = null;
    this.address = address;
    this.abi = abi;
};

module.exports = ContractFactory;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeAddress is a prootype that represents address type
 * It matches:
 * address
 * address[]
 * address[4]
 * address[][]
 * address[3][]
 * address[][6][], ...
 */
var SolidityTypeAddress = function () {
    this._inputFormatter = f.formatInputInt;
    this._outputFormatter = f.formatOutputAddress;
};

SolidityTypeAddress.prototype = new SolidityType({});
SolidityTypeAddress.prototype.constructor = SolidityTypeAddress;

SolidityTypeAddress.prototype.isType = function (name) {
    return !!name.match(/address(\[([0-9]*)\])?/);
};

module.exports = SolidityTypeAddress;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeBool is a prootype that represents bool type
 * It matches:
 * bool
 * bool[]
 * bool[4]
 * bool[][]
 * bool[3][]
 * bool[][6][], ...
 */
var SolidityTypeBool = function () {
    this._inputFormatter = f.formatInputBool;
    this._outputFormatter = f.formatOutputBool;
};

SolidityTypeBool.prototype = new SolidityType({});
SolidityTypeBool.prototype.constructor = SolidityTypeBool;

SolidityTypeBool.prototype.isType = function (name) {
    return !!name.match(/^bool(\[([0-9]*)\])*$/);
};

module.exports = SolidityTypeBool;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeInt is a prootype that represents int type
 * It matches:
 * int
 * int[]
 * int[4]
 * int[][]
 * int[3][]
 * int[][6][], ...
 * int32
 * int64[]
 * int8[4]
 * int256[][]
 * int[3][]
 * int64[][6][], ...
 */
var SolidityTypeInt = function () {
    this._inputFormatter = f.formatInputInt;
    this._outputFormatter = f.formatOutputInt;
};

SolidityTypeInt.prototype = new SolidityType({});
SolidityTypeInt.prototype.constructor = SolidityTypeInt;

SolidityTypeInt.prototype.isType = function (name) {
    return !!name.match(/^int([0-9]*)?(\[([0-9]*)\])*$/);
};

module.exports = SolidityTypeInt;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeUInt is a prootype that represents uint type
 * It matches:
 * uint
 * uint[]
 * uint[4]
 * uint[][]
 * uint[3][]
 * uint[][6][], ...
 * uint32
 * uint64[]
 * uint8[4]
 * uint256[][]
 * uint[3][]
 * uint64[][6][], ...
 */
var SolidityTypeUInt = function () {
    this._inputFormatter = f.formatInputInt;
    this._outputFormatter = f.formatOutputUInt;
};

SolidityTypeUInt.prototype = new SolidityType({});
SolidityTypeUInt.prototype.constructor = SolidityTypeUInt;

SolidityTypeUInt.prototype.isType = function (name) {
    return !!name.match(/^uint([0-9]*)?(\[([0-9]*)\])*$/);
};

module.exports = SolidityTypeUInt;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

var SolidityTypeDynamicBytes = function () {
    this._inputFormatter = f.formatInputDynamicBytes;
    this._outputFormatter = f.formatOutputDynamicBytes;
};

SolidityTypeDynamicBytes.prototype = new SolidityType({});
SolidityTypeDynamicBytes.prototype.constructor = SolidityTypeDynamicBytes;

SolidityTypeDynamicBytes.prototype.isType = function (name) {
    return !!name.match(/^bytes(\[([0-9]*)\])*$/);
};

SolidityTypeDynamicBytes.prototype.isDynamicType = function () {
    return true;
};

module.exports = SolidityTypeDynamicBytes;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

var SolidityTypeString = function () {
    this._inputFormatter = f.formatInputString;
    this._outputFormatter = f.formatOutputString;
};

SolidityTypeString.prototype = new SolidityType({});
SolidityTypeString.prototype.constructor = SolidityTypeString;

SolidityTypeString.prototype.isType = function (name) {
    return !!name.match(/^string(\[([0-9]*)\])*$/);
};

SolidityTypeString.prototype.isDynamicType = function () {
    return true;
};

module.exports = SolidityTypeString;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeReal is a prootype that represents real type
 * It matches:
 * real
 * real[]
 * real[4]
 * real[][]
 * real[3][]
 * real[][6][], ...
 * real32
 * real64[]
 * real8[4]
 * real256[][]
 * real[3][]
 * real64[][6][], ...
 */
var SolidityTypeReal = function () {
    this._inputFormatter = f.formatInputReal;
    this._outputFormatter = f.formatOutputReal;
};

SolidityTypeReal.prototype = new SolidityType({});
SolidityTypeReal.prototype.constructor = SolidityTypeReal;

SolidityTypeReal.prototype.isType = function (name) {
    return !!name.match(/real([0-9]*)?(\[([0-9]*)\])?/);
};

module.exports = SolidityTypeReal;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeUReal is a prootype that represents ureal type
 * It matches:
 * ureal
 * ureal[]
 * ureal[4]
 * ureal[][]
 * ureal[3][]
 * ureal[][6][], ...
 * ureal32
 * ureal64[]
 * ureal8[4]
 * ureal256[][]
 * ureal[3][]
 * ureal64[][6][], ...
 */
var SolidityTypeUReal = function () {
    this._inputFormatter = f.formatInputReal;
    this._outputFormatter = f.formatOutputUReal;
};

SolidityTypeUReal.prototype = new SolidityType({});
SolidityTypeUReal.prototype.constructor = SolidityTypeUReal;

SolidityTypeUReal.prototype.isType = function (name) {
    return !!name.match(/^ureal([0-9]*)?(\[([0-9]*)\])*$/);
};

module.exports = SolidityTypeUReal;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var f = __webpack_require__(6);
var SolidityType = __webpack_require__(9);

/**
 * SolidityTypeBytes is a prototype that represents the bytes type.
 * It matches:
 * bytes
 * bytes[]
 * bytes[4]
 * bytes[][]
 * bytes[3][]
 * bytes[][6][], ...
 * bytes32
 * bytes8[4]
 * bytes[3][]
 */
var SolidityTypeBytes = function () {
    this._inputFormatter = f.formatInputBytes;
    this._outputFormatter = f.formatOutputBytes;
};

SolidityTypeBytes.prototype = new SolidityType({});
SolidityTypeBytes.prototype.constructor = SolidityTypeBytes;

SolidityTypeBytes.prototype.isType = function (name) {
    return !!name.match(/^bytes([0-9]{1,})(\[([0-9]*)\])*$/);
};

module.exports = SolidityTypeBytes;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file function.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var coder = __webpack_require__(49);
var utils = __webpack_require__(2);
var errors = __webpack_require__(22);
var formatters = __webpack_require__(14);
var sha3 = __webpack_require__(27);

/**
 * This prototype should be used to call/sendTransaction to solidity functions
 */
var SolidityFunction = function (eth, json, address) {
    this._eth = eth;
    this._inputTypes = json.inputs.map(function (i) {
        return i.type;
    });
    this._outputTypes = json.outputs.map(function (i) {
        return i.type;
    });
    this._constant = json.constant;
    this._payable = json.payable;
    this._name = utils.transformToFullName(json);
    this._address = address;
};

SolidityFunction.prototype.extractCallback = function (args) {
    if (utils.isFunction(args[args.length - 1])) {
        return args.pop(); // modify the args array!
    }
};

SolidityFunction.prototype.extractDefaultBlock = function (args) {
    if (args.length > this._inputTypes.length && !utils.isObject(args[args.length -1])) {
        return formatters.inputDefaultBlockNumberFormatter(args.pop()); // modify the args array!
    }
};

/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */
SolidityFunction.prototype.validateArgs = function (args) {
    var inputArgs = args.filter(function (a) {
      // filter the options object but not arguments that are arrays
      return !( (utils.isObject(a) === true) &&
                (utils.isArray(a) === false) &&
                (utils.isBigNumber(a) === false)
              );
    });
    if (inputArgs.length !== this._inputTypes.length) {
        throw errors.InvalidNumberOfSolidityArgs();
    }
};

/**
 * Should be used to create payload from arguments
 *
 * @method toPayload
 * @param {Array} solidity function params
 * @param {Object} optional payload options
 */
SolidityFunction.prototype.toPayload = function (args) {
    var options = {};
    if (args.length > this._inputTypes.length && utils.isObject(args[args.length -1])) {
        options = args[args.length - 1];
    }
    this.validateArgs(args);
    options.to = this._address;
    options.data = '0x' + this.signature() + coder.encodeParams(this._inputTypes, args);
    return options;
};

/**
 * Should be used to get function signature
 *
 * @method signature
 * @return {String} function signature
 */
SolidityFunction.prototype.signature = function () {
    return sha3(this._name).slice(0, 8);
};


SolidityFunction.prototype.unpackOutput = function (output) {
    if (!output) {
        return;
    }

    output = output.length >= 2 ? output.slice(2) : output;
    var result = coder.decodeParams(this._outputTypes, output);
    return result.length === 1 ? result[0] : result;
};

/**
 * Calls a contract function.
 *
 * @method call
 * @param {...Object} Contract function arguments
 * @param {function} If the last argument is a function, the contract function
 *   call will be asynchronous, and the callback will be passed the
 *   error and result.
 * @return {String} output bytes
 */
SolidityFunction.prototype.call = function () {
    var args = Array.prototype.slice.call(arguments).filter(function (a) {return a !== undefined; });
    var callback = this.extractCallback(args);
    var defaultBlock = this.extractDefaultBlock(args);
    var payload = this.toPayload(args);


    if (!callback) {
        var output = this._eth.call(payload, defaultBlock);
        return this.unpackOutput(output);
    }

    var self = this;
    this._eth.call(payload, defaultBlock, function (error, output) {
        if (error) return callback(error, null);

        var unpacked = null;
        try {
            unpacked = self.unpackOutput(output);
        }
        catch (e) {
            error = e;
        }

        callback(error, unpacked);
    });
};

/**
 * Should be used to sendTransaction to solidity function
 *
 * @method sendTransaction
 */
SolidityFunction.prototype.sendTransaction = function () {
    var args = Array.prototype.slice.call(arguments).filter(function (a) {return a !== undefined; });
    var callback = this.extractCallback(args);
    var payload = this.toPayload(args);

    if (payload.value > 0 && !this._payable) {
        throw new Error('Cannot send value to non-payable function');
    }

    if (!callback) {
        return this._eth.sendTransaction(payload);
    }

    this._eth.sendTransaction(payload, callback);
};

/**
 * Should be used to estimateGas of solidity function
 *
 * @method estimateGas
 */
SolidityFunction.prototype.estimateGas = function () {
    var args = Array.prototype.slice.call(arguments);
    var callback = this.extractCallback(args);
    var payload = this.toPayload(args);

    if (!callback) {
        return this._eth.estimateGas(payload);
    }

    this._eth.estimateGas(payload, callback);
};

/**
 * Return the encoded data of the call
 *
 * @method getData
 * @return {String} the encoded data
 */
SolidityFunction.prototype.getData = function () {
    var args = Array.prototype.slice.call(arguments);
    var payload = this.toPayload(args);

    return payload.data;
};

/**
 * Should be used to get function display name
 *
 * @method displayName
 * @return {String} display name of the function
 */
SolidityFunction.prototype.displayName = function () {
    return utils.extractDisplayName(this._name);
};

/**
 * Should be used to get function type name
 *
 * @method typeName
 * @return {String} type name of the function
 */
SolidityFunction.prototype.typeName = function () {
    return utils.extractTypeName(this._name);
};

/**
 * Should be called to get rpc requests from solidity function
 *
 * @method request
 * @returns {Object}
 */
SolidityFunction.prototype.request = function () {
    var args = Array.prototype.slice.call(arguments);
    var callback = this.extractCallback(args);
    var payload = this.toPayload(args);
    var format = this.unpackOutput.bind(this);

    return {
        method: this._constant ? 'eth_call' : 'eth_sendTransaction',
        callback: callback,
        params: [payload],
        format: format
    };
};

/**
 * Should be called to execute function
 *
 * @method execute
 */
SolidityFunction.prototype.execute = function () {
    var transaction = !this._constant;

    // send transaction
    if (transaction) {
        return this.sendTransaction.apply(this, Array.prototype.slice.call(arguments));
    }

    // call
    return this.call.apply(this, Array.prototype.slice.call(arguments));
};

/**
 * Should be called to attach function to contract
 *
 * @method attachToContract
 * @param {Contract}
 */
SolidityFunction.prototype.attachToContract = function (contract) {
    var execute = this.execute.bind(this);
    execute.request = this.request.bind(this);
    execute.call = this.call.bind(this);
    execute.sendTransaction = this.sendTransaction.bind(this);
    execute.estimateGas = this.estimateGas.bind(this);
    execute.getData = this.getData.bind(this);
    var displayName = this.displayName();
    if (!contract[displayName]) {
        contract[displayName] = execute;
    }
    contract[displayName][this.typeName()] = execute; // circular!!!!
};

module.exports = SolidityFunction;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file allevents.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2014
 */

var sha3 = __webpack_require__(27);
var SolidityEvent = __webpack_require__(82);
var formatters = __webpack_require__(14);
var utils = __webpack_require__(2);
var Filter = __webpack_require__(34);
var watches = __webpack_require__(35);

var AllSolidityEvents = function (requestManager, json, address) {
    this._requestManager = requestManager;
    this._json = json;
    this._address = address;
};

AllSolidityEvents.prototype.encode = function (options) {
    options = options || {};
    var result = {};

    ['fromBlock', 'toBlock'].filter(function (f) {
        return options[f] !== undefined;
    }).forEach(function (f) {
        result[f] = formatters.inputBlockNumberFormatter(options[f]);
    });

    result.address = this._address;

    return result;
};

AllSolidityEvents.prototype.decode = function (data) {
    data.data = data.data || '';


    var eventTopic = (utils.isArray(data.topics) && utils.isString(data.topics[0])) ? data.topics[0].slice(2) : '';
    var match = this._json.filter(function (j) {
        return eventTopic === sha3(utils.transformToFullName(j));
    })[0];

    if (!match) { // cannot find matching event?
        return formatters.outputLogFormatter(data);
    }

    var event = new SolidityEvent(this._requestManager, match, this._address);
    return event.decode(data);
};

AllSolidityEvents.prototype.execute = function (options, callback) {

    if (utils.isFunction(arguments[arguments.length - 1])) {
        callback = arguments[arguments.length - 1];
        if(arguments.length === 1)
            options = null;
    }

    var o = this.encode(options);
    var formatter = this.decode.bind(this);
    return new Filter(o, 'eth', this._requestManager, watches.eth(), formatter, callback);
};

AllSolidityEvents.prototype.attachToContract = function (contract) {
    var execute = this.execute.bind(this);
    contract.allEvents = execute;
};

module.exports = AllSolidityEvents;



/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file syncing.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */

var formatters = __webpack_require__(14);
var utils = __webpack_require__(2);

var count = 1;

/**
Adds the callback and sets up the methods, to iterate over the results.

@method pollSyncing
@param {Object} self
*/
var pollSyncing = function(self) {

    var onMessage = function (error, sync) {
        if (error) {
            return self.callbacks.forEach(function (callback) {
                callback(error);
            });
        }

        if(utils.isObject(sync) && sync.startingBlock)
            sync = formatters.outputSyncingFormatter(sync);

        self.callbacks.forEach(function (callback) {
            if (self.lastSyncState !== sync) {
                
                // call the callback with true first so the app can stop anything, before receiving the sync data
                if(!self.lastSyncState && utils.isObject(sync))
                    callback(null, true);
                
                // call on the next CPU cycle, so the actions of the sync stop can be processes first
                setTimeout(function() {
                    callback(null, sync);
                }, 0);
                
                self.lastSyncState = sync;
            }
        });
    };

    self.requestManager.startPolling({
        method: 'eth_syncing',
        params: [],
    }, self.pollId, onMessage, self.stopWatching.bind(self));

};

var IsSyncing = function (requestManager, callback) {
    this.requestManager = requestManager;
    this.pollId = 'syncPoll_'+ count++;
    this.callbacks = [];
    this.addCallback(callback);
    this.lastSyncState = false;
    pollSyncing(this);

    return this;
};

IsSyncing.prototype.addCallback = function (callback) {
    if(callback)
        this.callbacks.push(callback);
    return this;
};

IsSyncing.prototype.stopWatching = function () {
    this.requestManager.stopPolling(this.pollId);
    this.callbacks = [];
};

module.exports = IsSyncing;



/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file namereg.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var globalRegistrarAbi = __webpack_require__(234);
var icapRegistrarAbi= __webpack_require__(235);

var globalNameregAddress = '0xc6d9d2cd449a754c494264e1809c50e34d64562b';
var icapNameregAddress = '0xa1a111bc074c9cfa781f0c38e63bd51c91b8af00';

module.exports = {
    global: {
        abi: globalRegistrarAbi,
        address: globalNameregAddress
    },
    icap: {
        abi: icapRegistrarAbi,
        address: icapNameregAddress
    }
};



/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = [{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"name","outputs":[{"name":"o_name","type":"bytes32"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"owner","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"content","outputs":[{"name":"","type":"bytes32"}],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"addr","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"reserve","outputs":[],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"subRegistrar","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_newOwner","type":"address"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_registrar","type":"address"}],"name":"setSubRegistrar","outputs":[],"type":"function"},{"constant":false,"inputs":[],"name":"Registrar","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_a","type":"address"},{"name":"_primary","type":"bool"}],"name":"setAddress","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_content","type":"bytes32"}],"name":"setContent","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"disown","outputs":[],"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_name","type":"bytes32"},{"indexed":false,"name":"_winner","type":"address"}],"name":"AuctionEnded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_name","type":"bytes32"},{"indexed":false,"name":"_bidder","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"NewBid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"}],"name":"Changed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"},{"indexed":true,"name":"addr","type":"address"}],"name":"PrimaryChanged","type":"event"}]

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = [{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"owner","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_refund","type":"address"}],"name":"disown","outputs":[],"type":"function"},{"constant":true,"inputs":[{"name":"_name","type":"bytes32"}],"name":"addr","outputs":[{"name":"","type":"address"}],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"}],"name":"reserve","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_newOwner","type":"address"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"_name","type":"bytes32"},{"name":"_a","type":"address"}],"name":"setAddr","outputs":[],"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"name","type":"bytes32"}],"name":"Changed","type":"event"}]

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file transfer.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var Iban = __webpack_require__(33);
var exchangeAbi = __webpack_require__(237);

/**
 * Should be used to make Iban transfer
 *
 * @method transfer
 * @param {String} from
 * @param {String} to iban
 * @param {Value} value to be tranfered
 * @param {Function} callback, callback
 */
var transfer = function (eth, from, to, value, callback) {
    var iban = new Iban(to); 
    if (!iban.isValid()) {
        throw new Error('invalid iban address');
    }

    if (iban.isDirect()) {
        return transferToAddress(eth, from, iban.address(), value, callback);
    }
    
    if (!callback) {
        var address = eth.icapNamereg().addr(iban.institution());
        return deposit(eth, from, address, value, iban.client());
    }

    eth.icapNamereg().addr(iban.institution(), function (err, address) {
        return deposit(eth, from, address, value, iban.client(), callback);
    });
    
};

/**
 * Should be used to transfer funds to certain address
 *
 * @method transferToAddress
 * @param {String} from
 * @param {String} to
 * @param {Value} value to be tranfered
 * @param {Function} callback, callback
 */
var transferToAddress = function (eth, from, to, value, callback) {
    return eth.sendTransaction({
        address: to,
        from: from,
        value: value
    }, callback);
};

/**
 * Should be used to deposit funds to generic Exchange contract (must implement deposit(bytes32) method!)
 *
 * @method deposit
 * @param {String} from
 * @param {String} to
 * @param {Value} value to be transfered
 * @param {String} client unique identifier
 * @param {Function} callback, callback
 */
var deposit = function (eth, from, to, value, client, callback) {
    var abi = exchangeAbi;
    return eth.contract(abi).at(to).deposit(client, {
        from: from,
        value: value
    }, callback);
};

module.exports = transfer;



/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = [{"constant":false,"inputs":[{"name":"from","type":"bytes32"},{"name":"to","type":"address"},{"name":"value","type":"uint256"}],"name":"transfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"from","type":"bytes32"},{"name":"to","type":"address"},{"name":"indirectId","type":"bytes32"},{"name":"value","type":"uint256"}],"name":"icapTransfer","outputs":[],"type":"function"},{"constant":false,"inputs":[{"name":"to","type":"bytes32"}],"name":"deposit","outputs":[],"payable":true,"type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"AnonymousDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"bytes32"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"bytes32"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"bytes32"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"indirectId","type":"bytes32"},{"indexed":false,"name":"value","type":"uint256"}],"name":"IcapTransfer","type":"event"}]

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file db.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var Method = __webpack_require__(18);

var DB = function (web3) {
    this._requestManager = web3._requestManager;

    var self = this;
    
    methods().forEach(function(method) { 
        method.attachToObject(self);
        method.setRequestManager(web3._requestManager);
    });
};

var methods = function () {
    var putString = new Method({
        name: 'putString',
        call: 'db_putString',
        params: 3
    });

    var getString = new Method({
        name: 'getString',
        call: 'db_getString',
        params: 2
    });

    var putHex = new Method({
        name: 'putHex',
        call: 'db_putHex',
        params: 3
    });

    var getHex = new Method({
        name: 'getHex',
        call: 'db_getHex',
        params: 2
    });

    return [
        putString, getString, putHex, getHex
    ];
};

module.exports = DB;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file shh.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 *   Marek Kotewicz <marek@ethcore.io>
 * @date 2017
 */

var Method = __webpack_require__(18);
var Filter = __webpack_require__(34);
var watches = __webpack_require__(35);

var Shh = function (web3) {
    this._requestManager = web3._requestManager;

    var self = this;

    methods().forEach(function(method) {
        method.attachToObject(self);
        method.setRequestManager(self._requestManager);
    });
};

Shh.prototype.newMessageFilter = function (options, callback, filterCreationErrorCallback) {
    return new Filter(options, 'shh', this._requestManager, watches.shh(), null, callback, filterCreationErrorCallback);
};

var methods = function () {

    return [
        new Method({
            name: 'version',
            call: 'shh_version',
            params: 0
        }),
        new Method({
            name: 'info',
            call: 'shh_info',
            params: 0
        }),
        new Method({
            name: 'setMaxMessageSize',
            call: 'shh_setMaxMessageSize',
            params: 1
        }),
        new Method({
            name: 'setMinPoW',
            call: 'shh_setMinPoW',
            params: 1
        }),
        new Method({
            name: 'markTrustedPeer',
            call: 'shh_markTrustedPeer',
            params: 1
        }),
        new Method({
            name: 'newKeyPair',
            call: 'shh_newKeyPair',
            params: 0
        }),
        new Method({
            name: 'addPrivateKey',
            call: 'shh_addPrivateKey',
            params: 1
        }),
        new Method({
            name: 'deleteKeyPair',
            call: 'shh_deleteKeyPair',
            params: 1
        }),
        new Method({
            name: 'hasKeyPair',
            call: 'shh_hasKeyPair',
            params: 1
        }),
        new Method({
            name: 'getPublicKey',
            call: 'shh_getPublicKey',
            params: 1
        }),
        new Method({
            name: 'getPrivateKey',
            call: 'shh_getPrivateKey',
            params: 1
        }),
        new Method({
            name: 'newSymKey',
            call: 'shh_newSymKey',
            params: 0
        }),
        new Method({
            name: 'addSymKey',
            call: 'shh_addSymKey',
            params: 1
        }),
        new Method({
            name: 'generateSymKeyFromPassword',
            call: 'shh_generateSymKeyFromPassword',
            params: 1
        }),
        new Method({
            name: 'hasSymKey',
            call: 'shh_hasSymKey',
            params: 1
        }),
        new Method({
            name: 'getSymKey',
            call: 'shh_getSymKey',
            params: 1
        }),
        new Method({
            name: 'deleteSymKey',
            call: 'shh_deleteSymKey',
            params: 1
        }),

        // subscribe and unsubscribe missing

        new Method({
            name: 'post',
            call: 'shh_post',
            params: 1,
            inputFormatter: [null]
        })
    ];
};

module.exports = Shh;



/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file eth.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var utils = __webpack_require__(2);
var Property = __webpack_require__(23);

var Net = function (web3) {
    this._requestManager = web3._requestManager;

    var self = this;

    properties().forEach(function(p) { 
        p.attachToObject(self);
        p.setRequestManager(web3._requestManager);
    });
};

/// @returns an array of objects describing web3.eth api properties
var properties = function () {
    return [
        new Property({
            name: 'listening',
            getter: 'net_listening'
        }),
        new Property({
            name: 'peerCount',
            getter: 'net_peerCount',
            outputFormatter: utils.toDecimal
        })
    ];
};

module.exports = Net;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file eth.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @author Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */



var Method = __webpack_require__(18);
var Property = __webpack_require__(23);
var formatters = __webpack_require__(14);

function Personal(web3) {
    this._requestManager = web3._requestManager;

    var self = this;

    methods().forEach(function(method) {
        method.attachToObject(self);
        method.setRequestManager(self._requestManager);
    });

    properties().forEach(function(p) {
        p.attachToObject(self);
        p.setRequestManager(self._requestManager);
    });
}

var methods = function () {
    var newAccount = new Method({
        name: 'newAccount',
        call: 'personal_newAccount',
        params: 1,
        inputFormatter: [null]
    });

    var importRawKey = new Method({
        name: 'importRawKey',
		call: 'personal_importRawKey',
		params: 2
    });

    var sign = new Method({
        name: 'sign',
		call: 'personal_sign',
		params: 3,
		inputFormatter: [null, formatters.inputAddressFormatter, null]
    });

    var ecRecover = new Method({
        name: 'ecRecover',
		call: 'personal_ecRecover',
		params: 2
    });

    var unlockAccount = new Method({
        name: 'unlockAccount',
        call: 'personal_unlockAccount',
        params: 3,
        inputFormatter: [formatters.inputAddressFormatter, null, null]
    });

    var sendTransaction = new Method({
        name: 'sendTransaction',
        call: 'personal_sendTransaction',
        params: 2,
        inputFormatter: [formatters.inputTransactionFormatter, null]
    });

    var lockAccount = new Method({
        name: 'lockAccount',
        call: 'personal_lockAccount',
        params: 1,
        inputFormatter: [formatters.inputAddressFormatter]
    });

    return [
        newAccount,
        importRawKey,
        unlockAccount,
        ecRecover,
        sign,
        sendTransaction,
        lockAccount
    ];
};

var properties = function () {
    return [
        new Property({
            name: 'listAccounts',
            getter: 'personal_listAccounts'
        })
    ];
};


module.exports = Personal;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * @file bzz.js
 * @author Alex Beregszaszi <alex@rtfs.hu>
 * @date 2016
 *
 * Reference: https://github.com/ethereum/go-ethereum/blob/swarm/internal/web3ext/web3ext.go#L33
 */



var Method = __webpack_require__(18);
var Property = __webpack_require__(23);

function Swarm(web3) {
    this._requestManager = web3._requestManager;

    var self = this;

    methods().forEach(function(method) {
        method.attachToObject(self);
        method.setRequestManager(self._requestManager);
    });

    properties().forEach(function(p) {
        p.attachToObject(self);
        p.setRequestManager(self._requestManager);
    });
}

var methods = function () {
    var blockNetworkRead = new Method({
        name: 'blockNetworkRead',
        call: 'bzz_blockNetworkRead',
        params: 1,
        inputFormatter: [null]
    });

    var syncEnabled = new Method({
        name: 'syncEnabled',
        call: 'bzz_syncEnabled',
        params: 1,
        inputFormatter: [null]
    });

    var swapEnabled = new Method({
        name: 'swapEnabled',
        call: 'bzz_swapEnabled',
        params: 1,
        inputFormatter: [null]
    });

    var download = new Method({
        name: 'download',
        call: 'bzz_download',
        params: 2,
        inputFormatter: [null, null]
    });

    var upload = new Method({
        name: 'upload',
        call: 'bzz_upload',
        params: 2,
        inputFormatter: [null, null]
    });

    var retrieve = new Method({
        name: 'retrieve',
        call: 'bzz_retrieve',
        params: 1,
        inputFormatter: [null]
    });

    var store = new Method({
        name: 'store',
        call: 'bzz_store',
        params: 2,
        inputFormatter: [null, null]
    });

    var get = new Method({
        name: 'get',
        call: 'bzz_get',
        params: 1,
        inputFormatter: [null]
    });

    var put = new Method({
        name: 'put',
        call: 'bzz_put',
        params: 2,
        inputFormatter: [null, null]
    });

    var modify = new Method({
        name: 'modify',
        call: 'bzz_modify',
        params: 4,
        inputFormatter: [null, null, null, null]
    });

    return [
        blockNetworkRead,
        syncEnabled,
        swapEnabled,
        download,
        upload,
        retrieve,
        store,
        get,
        put,
        modify
    ];
};

var properties = function () {
    return [
        new Property({
            name: 'hive',
            getter: 'bzz_hive'
        }),
        new Property({
            name: 'info',
            getter: 'bzz_info'
        })
    ];
};


module.exports = Swarm;


/***/ }),
/* 243 */
/***/ (function(module, exports) {



var Settings = function () {
    this.defaultBlock = 'latest';
    this.defaultAccount = undefined;
};

module.exports = Settings;



/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = {"version":"0.20.6"}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var formatters = __webpack_require__(14);
var utils = __webpack_require__(2);
var Method = __webpack_require__(18);
var Property = __webpack_require__(23);

// TODO: refactor, so the input params are not altered.
// it's necessary to make same 'extension' work with multiple providers
var extend = function (web3) {
    /* jshint maxcomplexity:5 */
    var ex = function (extension) {

        var extendedObject;
        if (extension.property) {
            if (!web3[extension.property]) {
                web3[extension.property] = {};
            }
            extendedObject = web3[extension.property];
        } else {
            extendedObject = web3;
        }

        if (extension.methods) {
            extension.methods.forEach(function (method) {
                method.attachToObject(extendedObject);
                method.setRequestManager(web3._requestManager);
            });
        }

        if (extension.properties) {
            extension.properties.forEach(function (property) {
                property.attachToObject(extendedObject);
                property.setRequestManager(web3._requestManager);
            });
        }
    };

    ex.formatters = formatters; 
    ex.utils = utils;
    ex.Method = Method;
    ex.Property = Property;

    return ex;
};



module.exports = extend;



/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** 
 * @file batch.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */

var Jsonrpc = __webpack_require__(77);
var errors = __webpack_require__(22);

var Batch = function (web3) {
    this.requestManager = web3._requestManager;
    this.requests = [];
};

/**
 * Should be called to add create new request to batch request
 *
 * @method add
 * @param {Object} jsonrpc requet object
 */
Batch.prototype.add = function (request) {
    this.requests.push(request);
};

/**
 * Should be called to execute batch request
 *
 * @method execute
 */
Batch.prototype.execute = function () {
    var requests = this.requests;
    this.requestManager.sendBatch(requests, function (err, results) {
        results = results || [];
        requests.map(function (request, index) {
            return results[index] || {};
        }).forEach(function (result, index) {
            if (requests[index].callback) {

                if (!Jsonrpc.isValidResponse(result)) {
                    return requests[index].callback(errors.InvalidResponse(result));
                }

                requests[index].callback(null, (requests[index].format ? requests[index].format(result.result) : result.result));
            }
        });
    }); 
};

module.exports = Batch;



/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file httpprovider.js
 * @authors:
 *   Marek Kotewicz <marek@ethdev.com>
 *   Marian Oancea <marian@ethdev.com>
 *   Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */

var errors = __webpack_require__(22);

// workaround to use httpprovider in different envs

// browser
if (typeof window !== 'undefined' && window.XMLHttpRequest) {
  XMLHttpRequest = window.XMLHttpRequest; // jshint ignore: line
// node
} else {
  XMLHttpRequest = __webpack_require__(252).XMLHttpRequest; // jshint ignore: line
}

var XHR2 = __webpack_require__(253); // jshint ignore: line

/**
 * HttpProvider should be used to send rpc calls over http
 */
var HttpProvider = function (host, timeout, user, password, headers) {
  this.host = host || 'http://localhost:8545';
  this.timeout = timeout || 0;
  this.user = user;
  this.password = password;
  this.headers = headers;
};

/**
 * Should be called to prepare new XMLHttpRequest
 *
 * @method prepareRequest
 * @param {Boolean} true if request should be async
 * @return {XMLHttpRequest} object
 */
HttpProvider.prototype.prepareRequest = function (async) {
  var request;

  if (async) {
    request = new XHR2();
    request.timeout = this.timeout;
  } else {
    request = new XMLHttpRequest();
  }

  request.open('POST', this.host, async);
  if (this.user && this.password) {
    var auth = 'Basic ' + new Buffer(this.user + ':' + this.password).toString('base64');
    request.setRequestHeader('Authorization', auth);
  } request.setRequestHeader('Content-Type', 'application/json');
  if(this.headers) {
      this.headers.forEach(function(header) {
          request.setRequestHeader(header.name, header.value);
      });
  }
  return request;
};

/**
 * Should be called to make sync request
 *
 * @method send
 * @param {Object} payload
 * @return {Object} result
 */
HttpProvider.prototype.send = function (payload) {
  var request = this.prepareRequest(false);

  try {
    request.send(JSON.stringify(payload));
  } catch (error) {
    throw errors.InvalidConnection(this.host);
  }

  var result = request.responseText;

  try {
    result = JSON.parse(result);
  } catch (e) {
    throw errors.InvalidResponse(request.responseText);
  }

  return result;
};

/**
 * Should be used to make async request
 *
 * @method sendAsync
 * @param {Object} payload
 * @param {Function} callback triggered on end with (err, result)
 */
HttpProvider.prototype.sendAsync = function (payload, callback) {
  var request = this.prepareRequest(true);

  request.onreadystatechange = function () {
    if (request.readyState === 4 && request.timeout !== 1) {
      var result = request.responseText;
      var error = null;

      try {
        result = JSON.parse(result);
      } catch (e) {
        error = errors.InvalidResponse(request.responseText);
      }

      callback(error, result);
    }
  };

  request.ontimeout = function () {
    callback(errors.ConnectionTimeout(this.timeout));
  };

  try {
    request.send(JSON.stringify(payload));
  } catch (error) {
    callback(errors.InvalidConnection(this.host));
  }
};

/**
 * Synchronously tries to make Http request
 *
 * @method isConnected
 * @return {Boolean} returns true if request haven't failed. Otherwise false
 */
HttpProvider.prototype.isConnected = function () {
  try {
    this.send({
      id: 9999999999,
      jsonrpc: '2.0',
      method: 'net_listening',
      params: []
    });
    return true;
  } catch (e) {
    return false;
  }
};

module.exports = HttpProvider;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248).Buffer))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(249)
var ieee754 = __webpack_require__(250)
var isArray = __webpack_require__(251)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 251 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// go env doesn't have and need XMLHttpRequest
if (typeof XMLHttpRequest === 'undefined') {
    exports.XMLHttpRequest = {};
} else {
    exports.XMLHttpRequest = XMLHttpRequest; // jshint ignore:line
}



/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = XMLHttpRequest;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/** @file ipcprovider.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethdev.com>
 * @date 2015
 */



var utils = __webpack_require__(2);
var errors = __webpack_require__(22);


var IpcProvider = function (path, net) {
    var _this = this;
    this.responseCallbacks = {};
    this.path = path;
    
    this.connection = net.connect({path: this.path});

    this.connection.on('error', function(e){
        console.error('IPC Connection Error', e);
        _this._timeout();
    });

    this.connection.on('end', function(){
        _this._timeout();
    }); 


    // LISTEN FOR CONNECTION RESPONSES
    this.connection.on('data', function(data) {
        /*jshint maxcomplexity: 6 */

        _this._parseResponse(data.toString()).forEach(function(result){

            var id = null;

            // get the id which matches the returned id
            if(utils.isArray(result)) {
                result.forEach(function(load){
                    if(_this.responseCallbacks[load.id])
                        id = load.id;
                });
            } else {
                id = result.id;
            }

            // fire the callback
            if(_this.responseCallbacks[id]) {
                _this.responseCallbacks[id](null, result);
                delete _this.responseCallbacks[id];
            }
        });
    });
};

/**
Will parse the response and make an array out of it.

@method _parseResponse
@param {String} data
*/
IpcProvider.prototype._parseResponse = function(data) {
    var _this = this,
        returnValues = [];
    
    // DE-CHUNKER
    var dechunkedData = data
        .replace(/\}[\n\r]?\{/g,'}|--|{') // }{
        .replace(/\}\][\n\r]?\[\{/g,'}]|--|[{') // }][{
        .replace(/\}[\n\r]?\[\{/g,'}|--|[{') // }[{
        .replace(/\}\][\n\r]?\{/g,'}]|--|{') // }]{
        .split('|--|');

    dechunkedData.forEach(function(data){

        // prepend the last chunk
        if(_this.lastChunk)
            data = _this.lastChunk + data;

        var result = null;

        try {
            result = JSON.parse(data);

        } catch(e) {

            _this.lastChunk = data;

            // start timeout to cancel all requests
            clearTimeout(_this.lastChunkTimeout);
            _this.lastChunkTimeout = setTimeout(function(){
                _this._timeout();
                throw errors.InvalidResponse(data);
            }, 1000 * 15);

            return;
        }

        // cancel timeout and set chunk to null
        clearTimeout(_this.lastChunkTimeout);
        _this.lastChunk = null;

        if(result)
            returnValues.push(result);
    });

    return returnValues;
};


/**
Get the adds a callback to the responseCallbacks object,
which will be called if a response matching the response Id will arrive.

@method _addResponseCallback
*/
IpcProvider.prototype._addResponseCallback = function(payload, callback) {
    var id = payload.id || payload[0].id;
    var method = payload.method || payload[0].method;

    this.responseCallbacks[id] = callback;
    this.responseCallbacks[id].method = method;
};

/**
Timeout all requests when the end/error event is fired

@method _timeout
*/
IpcProvider.prototype._timeout = function() {
    for(var key in this.responseCallbacks) {
        if(this.responseCallbacks.hasOwnProperty(key)){
            this.responseCallbacks[key](errors.InvalidConnection('on IPC'));
            delete this.responseCallbacks[key];
        }
    }
};


/**
Check if the current connection is still valid.

@method isConnected
*/
IpcProvider.prototype.isConnected = function() {
    var _this = this;

    // try reconnect, when connection is gone
    if(!_this.connection.writable)
        _this.connection.connect({path: _this.path});

    return !!this.connection.writable;
};

IpcProvider.prototype.send = function (payload) {

    if(this.connection.writeSync) {
        var result;

        // try reconnect, when connection is gone
        if(!this.connection.writable)
            this.connection.connect({path: this.path});

        var data = this.connection.writeSync(JSON.stringify(payload));

        try {
            result = JSON.parse(data);
        } catch(e) {
            throw errors.InvalidResponse(data);                
        }

        return result;

    } else {
        throw new Error('You tried to send "'+ payload.method +'" synchronously. Synchronous requests are not supported by the IPC provider.');
    }
};

IpcProvider.prototype.sendAsync = function (payload, callback) {
    // try reconnect, when connection is gone
    if(!this.connection.writable)
        this.connection.connect({path: this.path});


    this.connection.write(JSON.stringify(payload));
    this._addResponseCallback(payload, callback);
};

module.exports = IpcProvider;



/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

Async.prototype.invokeLater = AsyncInvokeLater;
Async.prototype.invoke = AsyncInvoke;
Async.prototype.settlePromises = AsyncSettlePromises;


function _drainQueue(queue) {
    while (queue.length() > 0) {
        _drainQueueStep(queue);
    }
}

function _drainQueueStep(queue) {
    var fn = queue.shift();
    if (typeof fn !== "function") {
        fn._settlePromises();
    } else {
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
}

Async.prototype._drainQueues = function () {
    _drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    _drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context,
    enableAsyncHooks, disableAsyncHooks) {
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var es5 = _dereq_("./es5");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

var deferUnhandledRejectionCheck;
(function() {
    var promises = [];

    function unhandledRejectionCheck() {
        for (var i = 0; i < promises.length; ++i) {
            promises[i]._notifyUnhandledRejection();
        }
        unhandledRejectionClear();
    }

    function unhandledRejectionClear() {
        promises.length = 0;
    }

    deferUnhandledRejectionCheck = function(promise) {
        promises.push(promise);
        setTimeout(unhandledRejectionCheck, 1);
    };

    es5.defineProperty(Promise, "_unhandledRejectionCheck", {
        value: unhandledRejectionCheck
    });
    es5.defineProperty(Promise, "_unhandledRejectionClear", {
        value: unhandledRejectionClear
    });
})();

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    deferUnhandledRejectionCheck(this);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var context = Promise._getContext();
    possiblyUnhandledRejection = util.contextBind(context, fn);
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var context = Promise._getContext();
    unhandledRejectionHandled = util.contextBind(context, fn);
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
            Context.deactivateLongStackTraces();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
        Context.activateLongStackTraces();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};


var legacyHandlers = {
    unhandledrejection: {
        before: function() {
            var ret = util.global.onunhandledrejection;
            util.global.onunhandledrejection = null;
            return ret;
        },
        after: function(fn) {
            util.global.onunhandledrejection = fn;
        }
    },
    rejectionhandled: {
        before: function() {
            var ret = util.global.onrejectionhandled;
            util.global.onrejectionhandled = null;
            return ret;
        },
        after: function(fn) {
            util.global.onrejectionhandled = fn;
        }
    }
};

var fireDomEvent = (function() {
    var dispatch = function(legacy, e) {
        if (legacy) {
            var fn;
            try {
                fn = legacy.before();
                return !util.global.dispatchEvent(e);
            } finally {
                legacy.after(fn);
            }
        } else {
            return !util.global.dispatchEvent(e);
        }
    };
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var eventData = {
                    detail: event,
                    cancelable: true
                };
                var domEvent = new CustomEvent(name, eventData);
                es5.defineProperty(
                    domEvent, "promise", {value: event.promise});
                es5.defineProperty(
                    domEvent, "reason", {value: event.reason});

                return dispatch(legacyHandlers[name], domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = new Event(name, {
                    cancelable: true
                });
                domEvent.detail = event;
                es5.defineProperty(domEvent, "promise", {value: event.promise});
                es5.defineProperty(domEvent, "reason", {value: event.reason});
                return dispatch(legacyHandlers[name], domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                name = name.toLowerCase();
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name, false, true,
                    event);
                return dispatch(legacyHandlers[name], domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
        var prev = config.asyncHooks;
        var cur = !!opts.asyncHooks;
        if (prev !== cur) {
            config.asyncHooks = cur;
            if (cur) {
                enableAsyncHooks();
            } else {
                disableAsyncHooks();
            }
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._dereferenceTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function longStackTracesDereferenceTrace() {
    this._trace = undefined;
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = (firstLineError.stack || "").split("\n");
    var lastStackLines = (lastLineError.stack || "").split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false,
    asyncHooks: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    asyncHooks: function() {
        return config.asyncHooks;
    },
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./es5":13,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var context = Promise._getContext();
                        holder.fn = util.contextBind(context, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var context = Promise._getContext();
    this._callback = util.contextBind(context, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
    if (util.isArray(promises)) {
        for (var i = 0; i < promises.length; ++i) {
            var maybePromise = promises[i];
            if (maybePromise instanceof Promise) {
                maybePromise.suppressUnhandledRejections();
            }
        }
    }
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");
util.setReflectHandler(reflectHandler);

var getDomain = function() {
    var domain = process.domain;
    if (domain === undefined) {
        return null;
    }
    return domain;
};
var getContextDefault = function() {
    return null;
};
var getContextDomain = function() {
    return {
        domain: getDomain(),
        async: null
    };
};
var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ?
    _dereq_("async_hooks").AsyncResource : null;
var getContextAsyncHooks = function() {
    return {
        domain: getDomain(),
        async: new AsyncResource("Bluebird::Promise")
    };
};
var getContext = util.isNode ? getContextDomain : getContextDefault;
util.notEnumerableProp(Promise, "_getContext", getContext);
var enableAsyncHooks = function() {
    getContext = getContextAsyncHooks;
    util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
};
var disableAsyncHooks = function() {
    getContext = getContextDomain;
    util.notEnumerableProp(Promise, "_getContext", getContextDomain);
};

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;

var debug = _dereq_("./debuggability")(Promise, Context,
    enableAsyncHooks, disableAsyncHooks);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];

        if (typeof fn !== "function") {
            throw new TypeError("The last argument to .catch() " +
                "must be a function, got " + util.toString(fn));
        }
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var context = getContext();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: util.contextBind(context, handler),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise,
                receiver, context);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    var bitField = this._bitField;
    this._bitField = bitField |
        (((bitField & 536870912) >> 2) ^
        134217728);
};

Promise.prototype._setNoAsyncGuarantee = function() {
    this._bitField = (this._bitField | 536870912) &
        (~134217728);
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    context
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 = util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 = util.contextBind(context, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                util.contextBind(context, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                util.contextBind(context, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);


    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(maybePromise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
        this._dereferenceTrace();
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
        get: function () {
            return "Object";
        }
    });
}

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
Promise.Promise = Promise;
Promise.version = "3.7.2";
_dereq_('./call_get.js')(Promise);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,"async_hooks":undefined}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
        values.suppressUnhandledRejections();
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var context = Promise._getContext();
    this._fn = util.contextBind(context, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined &&
        this._eachValues !== null &&
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    for (var j = i; j < length; ++j) {
        var maybePromise = values[j];
        if (maybePromise instanceof Promise) {
            maybePromise.suppressUnhandledRejections();
        }
    }

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };

            value = value._then(gotAccum, undefined, undefined, ctx, undefined);

            if ((i & 127) === 0) {
                value._setNoAsyncGuarantee();
            }
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova)) &&
          ("classList" in document.documentElement)) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.allSettled = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var receiver = new FakeConstructor();
    function ic() {
        return typeof receiver.foo;
    }
    ic();
    ic();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    "object" !== "undefined";

function env(key) {
    return hasEnvVariables ? Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_GA_ANALYTICS_KEY":"UA-111781922-1","REACT_APP_MAPBOX_TOKEN":"pk.eyJ1Ijoia2VqYWNlIiwiYSI6ImNqZ2NlZ3ZrdzNmMGIzMnFkdXh2dGIzY3QifQ.1Ytkor_lU5hORL0jK9KpOw"})[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if (classString(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

var reflectHandler;
function contextBind(ctx, cb) {
    if (ctx === null ||
        typeof cb !== "function" ||
        cb === reflectHandler) {
        return cb;
    }

    if (ctx.domain !== null) {
        cb = ctx.domain.bind(cb);
    }

    var async = ctx.async;
    if (async !== null) {
        var old = cb;
        cb = function() {
            var args = (new Array(2)).concat([].slice.call(arguments));;
            args[0] = old;
            args[1] = this;
            return async.runInAsyncScope.apply(async, args);
        };
    }
    return cb;
}

var ret = {
    setReflectHandler: function(fn) {
        reflectHandler = fn;
    },
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    contextBind: contextBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version;
    if (process.versions && process.versions.node) {
        version = process.versions.node.split(".").map(Number);
    } else if (process.version) {
        version = process.version.split(".").map(Number);
    }
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();
ret.nodeSupportsAsyncResource = ret.isNode && (function() {
    var supportsAsync = false;
    try {
        var res = _dereq_("async_hooks").AsyncResource;
        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
    } catch (e) {
        supportsAsync = false;
    }
    return supportsAsync;
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13,"async_hooks":undefined}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83), __webpack_require__(8), __webpack_require__(256).setImmediate))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(257);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(83)))

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d8b8e960.js